
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5E5D3", function(module, exports) {

$parcel$export(module.exports, "register", () => $41c50df5c805813e$export$6503ec6e8aabbaf, (v) => $41c50df5c805813e$export$6503ec6e8aabbaf = v);
var $41c50df5c805813e$export$6503ec6e8aabbaf;
var $41c50df5c805813e$export$f7ad0328861e2f03;
"use strict";
var $41c50df5c805813e$var$mapping = new Map();
function $41c50df5c805813e$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$41c50df5c805813e$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $41c50df5c805813e$var$resolve(id) {
    var resolved = $41c50df5c805813e$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$41c50df5c805813e$export$6503ec6e8aabbaf = $41c50df5c805813e$var$register;
$41c50df5c805813e$export$f7ad0328861e2f03 = $41c50df5c805813e$var$resolve;

});

parcelRegister("2SJ43", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $219394c9006f5b7e$export$bdfd709ae4826697, (v) => $219394c9006f5b7e$export$bdfd709ae4826697 = v);
var $219394c9006f5b7e$export$bdfd709ae4826697;
var $219394c9006f5b7e$export$c9e73fbda7da57b6;
var $219394c9006f5b7e$export$5a759dc7a1cfb72a;
"use strict";
var $219394c9006f5b7e$var$bundleURL = {};
function $219394c9006f5b7e$var$getBundleURLCached(id) {
    var value = $219394c9006f5b7e$var$bundleURL[id];
    if (!value) {
        value = $219394c9006f5b7e$var$getBundleURL();
        $219394c9006f5b7e$var$bundleURL[id] = value;
    }
    return value;
}
function $219394c9006f5b7e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $219394c9006f5b7e$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $219394c9006f5b7e$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $219394c9006f5b7e$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$219394c9006f5b7e$export$bdfd709ae4826697 = $219394c9006f5b7e$var$getBundleURLCached;
$219394c9006f5b7e$export$c9e73fbda7da57b6 = $219394c9006f5b7e$var$getBaseURL;
$219394c9006f5b7e$export$5a759dc7a1cfb72a = $219394c9006f5b7e$var$getOrigin;

});

parcelRegister("fRpWP", function(module, exports) {

$parcel$export(module.exports, "UrlManager", () => $b8bfeef0e3ed5c87$export$fb10f6d9eb34a490);
const $b8bfeef0e3ed5c87$export$4ba5dcadf4bea9ed = function() {
    var modules = {};
    var listeners = {};
    var lastUrl = "";
    var getUrlParams = function(path) {
        var split = path.split("/");
        var params = {};
        params.section = split[1];
        for(var i = 2; i < split.length; i += 2)params[split[i]] = split[i + 1];
        return params;
    };
    var init = function() {
        //console.log("init")
        addEventListener("popstate", (event)=>{
            var urlPath = event.target.document.location.pathname;
            var currentUrlParams = getUrlParams(urlPath);
            for(var key in modules){
                if (!currentUrlParams[key]) {
                    ///removed
                    //if (key == "section") {
                    delete modules[key];
                    //}
                    if (listeners[key]) for(var i = 0; i < listeners[key].length; i++){
                        listeners[key][i](event, currentUrlParams[key], currentUrlParams[key]);
                        if (!listeners[key]) break;
                    }
                } else if (modules[key] != currentUrlParams[key]) {
                    if (listeners[key]) for(var i = 0; i < listeners[key].length; i++){
                        modules[key] = currentUrlParams[key];
                        listeners[key][i](event, currentUrlParams[key], currentUrlParams[key]);
                    }
                }
            }
            //auto add new modules
            for(var key in currentUrlParams)if (!modules[key]) modules[key] = currentUrlParams[key];
        });
    };
    init();
    return {
        updateUrl: function(replace) {
            var url = "";
            if (modules["section"]) url += "/" + modules["section"];
            for(var key in modules){
                if (key == "section") continue;
                url += "/" + key + "/" + modules[key];
            }
            if (window.location.pathname == url) //console.log("url not changed #2 ",url);
            return;
            lastUrl = url;
            if (replace) history.replaceState(null, null, url);
            else history.pushState(null, null, url);
        },
        setModule: function(module, value, dontUpdateUrl, dontAffectHistory) {
            modules[module] = value;
            if (!dontUpdateUrl) this.updateUrl(dontAffectHistory);
        },
        getModule: function(module) {
            return modules[module];
        },
        registerModule: function(module) {
            if (!listeners[module]) listeners[module] = [];
        },
        removeModule: function(module) {
            delete modules[module];
        },
        listenModule: function(module, handler) {
            if (!listeners[module]) listeners[module] = [];
            listeners[module].push(handler);
        },
        unlistenModule: function(module, handler) {
            delete listeners[module];
        },
        stopChecking: function() {
        //console.log("stop checking");
        },
        startChecking: function() {
        //console.log("start checking");
        },
        saveModuleHistory: function(module) {},
        getModuleHistory: function(module) {},
        clearUrl: function() {
            modules = {};
        },
        autoRegisterModules: function() {
            var urlPath = document.location.pathname;
            var currentUrlParams = getUrlParams(urlPath);
            for(var key in currentUrlParams){
                if (modules[key]) continue;
                modules[key] = currentUrlParams[key];
            }
        }
    };
}();
const $b8bfeef0e3ed5c87$export$fb10f6d9eb34a490 = $b8bfeef0e3ed5c87$export$4ba5dcadf4bea9ed;

});

parcelRegister("dNeVp", function(module, exports) {

$parcel$export(module.exports, "ManiaCache", () => $a0ab6dbc763b56ef$export$c22384742ad19d8d);
const $a0ab6dbc763b56ef$export$c22384742ad19d8d = {
    maxSize: 100,
    storeName: "cachedItems",
    dbName: "footballmaniadb",
    version: 2,
    shortCacheStateKey: "shortCache",
    memoryCacheObj: new Map(),
    // Initialize IndexedDB promisified
    async openDB () {
        if (!window.indexedDB) throw new Error("IndexedDB not supported");
        return new Promise((resolve, reject)=>{
            const request = window.indexedDB.open(this.dbName, this.version);
            request.onerror = ()=>reject(new Error("Failed to open IndexedDB"));
            request.onblocked = ()=>reject(new Error("Database operation blocked"));
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                if (!db.objectStoreNames.contains(this.storeName)) db.createObjectStore(this.storeName);
            };
            request.onsuccess = (event)=>{
                const db = event.target.result;
                db.onversionchange = ()=>{
                    db.close();
                    console.warn("Database version changed, connection closed");
                };
                resolve(db);
            };
        });
    },
    // Prune old entries (async/await)
    async prune () {
        try {
            const db = await this.openDB();
            const tx = db.transaction(this.storeName, "readwrite");
            const store = tx.objectStore(this.storeName);
            const weekInMs = 604800000;
            let deletions = 0;
            return new Promise((resolve)=>{
                const request = store.openCursor();
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (!cursor) {
                        db.close();
                        resolve(deletions);
                        return;
                    }
                    const { timestamp: timestamp } = cursor.value || {};
                    if (timestamp && Date.now() - timestamp > weekInMs) {
                        cursor.delete();
                        deletions++;
                    }
                    cursor.continue();
                };
                request.onerror = ()=>{
                    db.close();
                    resolve(deletions);
                };
            });
        } catch (error) {
            console.error("Error pruning cache:", error);
            return 0;
        }
    },
    // Set value with memory and IndexedDB
    async set (key, value) {
        this.setMemoryCache(key, value);
        try {
            const db = await this.openDB();
            const tx = db.transaction(this.storeName, "readwrite");
            const store = tx.objectStore(this.storeName);
            await new Promise((resolve, reject)=>{
                const request = store.put({
                    timestamp: Date.now(),
                    value: value
                }, key);
                request.onsuccess = resolve;
                request.onerror = reject;
            });
            tx.oncomplete = ()=>db.close();
        } catch (error) {
            console.error("Error setting cache:", error);
        }
    },
    // Get value with expiration check
    async get (key, expire, cb) {
        const memoryValue = this.getMemoryCache(key);
        if (memoryValue !== undefined) {
            const expireTime = this.memoryCacheObj.get(`${key}_expire`);
            if (expireTime && Date.now() - expireTime <= expire) return cb(memoryValue);
            this.deleteMemoryCache(key);
        }
        try {
            const db = await this.openDB();
            const tx = db.transaction(this.storeName, "readonly");
            const store = tx.objectStore(this.storeName);
            const result = await new Promise((resolve, reject)=>{
                const request = store.get(key);
                request.onsuccess = ()=>resolve(request.result);
                request.onerror = reject;
            });
            tx.oncomplete = ()=>db.close();
            if (!result || !result.value) return cb(null);
            if (Date.now() - result.timestamp > expire) return cb(null);
            this.setMemoryCache(key, result.value); // Update memory cache
            return cb(result.value);
        } catch (error) {
            console.error("Error getting cache:", error);
            return cb(null);
        }
    },
    // LocalStorage short cache methods
    setShortCache (key, data) {
        try {
            localStorage.setItem(`${this.shortCacheStateKey}${key}`, JSON.stringify(data));
        } catch (error) {
            console.warn("Failed to set short cache:", error);
        }
    },
    getShortCache (key) {
        try {
            const data = localStorage.getItem(`${this.shortCacheStateKey}${key}`);
            return data ? JSON.parse(data) : null;
        } catch (error) {
            console.warn("Failed to get short cache:", error);
            return null;
        }
    },
    flushShortCache (key) {
        localStorage.removeItem(`${this.shortCacheStateKey}${key}`);
    },
    // Memory cache methods using Map
    setMemoryCache (key, value) {
        if (this.memoryCacheObj.size >= this.maxSize) {
            const firstKey = this.memoryCacheObj.keys().next().value;
            this.deleteMemoryCache(firstKey);
        }
        this.memoryCacheObj.set(key, value);
        this.memoryCacheObj.set(`${key}_expire`, Date.now());
    },
    getMemoryCache (key) {
        return this.memoryCacheObj.get(key);
    },
    deleteMemoryCache (key) {
        this.memoryCacheObj.delete(key);
        this.memoryCacheObj.delete(`${key}_expire`);
    }
};

});

parcelRegister("3SrKy", function(module, exports) {

$parcel$export(module.exports, "PushMessaging", () => $2d2bf0d01adcb4d9$export$a38344f073f13a07);

var $kc8Kt = parcelRequire("kc8Kt");
const $2d2bf0d01adcb4d9$export$a38344f073f13a07 = {
    init: function() {
        if (window.JSAndroidBridge) console.log("init firebase from android");
        else if (window.iOSConfig) {
            console.log("init firebase from ios");
            $2d2bf0d01adcb4d9$var$PushMessagingIOS.init();
        } else {
            console.log("init firebase from web");
            $2d2bf0d01adcb4d9$var$PushMessagingWeb.init();
        }
    },
    getToken: async function(cb) {
        if (window.JSAndroidBridge) {
            var token = window.JSAndroidBridge.getFCMToken();
            cb(token);
        } else if (AppInstance.getConfig().appmode == "ios") $2d2bf0d01adcb4d9$var$PushMessagingIOS.getToken();
        else $2d2bf0d01adcb4d9$var$PushMessagingWeb.getFirebaseToken(cb);
    },
    subscribeMatch: function(matchId, cb) {
        $2d2bf0d01adcb4d9$export$a38344f073f13a07.getMessager().subscribeMatch(matchId, cb);
    },
    unSubscribeMatch: function(matchid, cb) {
        $2d2bf0d01adcb4d9$export$a38344f073f13a07.getMessager().unSubscribeMatch(matchid, cb);
    },
    subscribeTeam: function(teamid, cb) {
        $2d2bf0d01adcb4d9$export$a38344f073f13a07.getMessager().subscribeTeam(teamid, cb);
    },
    unSubscribeTeam: function(teamid, cb) {
        $2d2bf0d01adcb4d9$export$a38344f073f13a07.getMessager().unSubscribeTeam(teamid, cb);
    },
    subscribeLeague: function(key, cb) {
        $2d2bf0d01adcb4d9$export$a38344f073f13a07.getMessager().subscribeLeague(key, cb);
    },
    unSubscribeLeague: function(key, cb) {
        $2d2bf0d01adcb4d9$export$a38344f073f13a07.getMessager().unSubscribeLeague(key, cb);
    },
    getMessager: function() {
        if (window.JSAndroidBridge) return $2d2bf0d01adcb4d9$var$PushMessagingAndroid;
        else if (window.iOSConfig) return $2d2bf0d01adcb4d9$var$PushMessagingIOS;
        else return $2d2bf0d01adcb4d9$var$PushMessagingWeb;
    }
};
var $2d2bf0d01adcb4d9$var$PushMessagingAndroid = {
    init: function() {
        console.warn("no need to initialize firebase from android from web");
    },
    getToken: function() {
        return window.JSAndroidBridge.getFCMToken();
    },
    subscribeMatch: function(matchid, cb) {
        if (!this.getToken()) {
            console.warn("no token yet");
            if (cb) cb(false);
            return;
        }
        window.JSAndroidBridge.subscribeMatch(matchid);
        if (cb) cb(true);
    },
    unSubscribeMatch: function(matchid, cb) {
        if (!this.getToken()) {
            console.warn("no token yet");
            if (cb) cb(false);
            return;
        }
        window.JSAndroidBridge.unSubscribeMatch(matchid);
        if (cb) cb(true);
    },
    subscribeTeam: function(teamid, cb) {
        if (!this.getToken()) {
            console.warn("no token yet");
            if (cb) cb(false);
            return;
        }
        window.JSAndroidBridge.subscribeTeam(teamid);
        if (cb) cb(true);
    },
    unSubscribeTeam: function(teamid, cb) {
        if (!this.getToken()) {
            console.warn("no token yet");
            if (cb) cb(false);
            return;
        }
        window.JSAndroidBridge.unSubscribeTeam(teamid);
        if (cb) cb(true);
    },
    subscribeLeague: function(key, cb) {
        if (!this.getToken()) {
            console.warn("no token yet");
            if (cb) cb(false);
            return;
        }
        window.JSAndroidBridge.subscribeLeague(key);
        if (cb) cb(true);
    },
    unSubscribeLeague: function(key, cb) {
        if (!this.getToken()) {
            console.warn("no token yet");
            if (cb) cb(false);
            return;
        }
        window.JSAndroidBridge.unSubscribeLeague(key);
        if (cb) cb(true);
    }
};
var $2d2bf0d01adcb4d9$var$PushMessagingIOS = {
    init: function() {
        console.warn("no need to initialize firebase from ios from web");
        //check if we have a token stored in localstorage. it might be different than the one now
        //if so, we need to update the server
        //TODO
        var oldToken = localStorage.getItem("ios_token");
        this.oldToken = oldToken;
        localStorage.setItem("ios_token", iOSConfig.token);
    },
    getToken: function() {
        return iOSConfig.token;
    },
    hasToken: function() {
        return iOSConfig.token != null && iOSConfig.token != undefined && iOSConfig.token != "";
    },
    getPushPayload: function(extra, cb) {
        Object.assign(extra, {
            regid: this.getToken(),
            oldregid: this.oldToken,
            lang: AppInstance.getConfig().userLocale
        });
        return extra;
    },
    subscribeMatch: function(matchid, cb) {
        if (!this.hasToken()) {
            if (cb) cb(false);
            return;
        }
        var url = "/footapi/registration_ios/subscribematch?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
        (0, $kc8Kt.DataProvider).postGeneric(url, this.getPushPayload({
            "matchid": matchid
        }), function(response) {
            console.log("subscribed to match");
            if (cb) cb(response.isOk());
        }, "subscribeMatch");
    },
    unSubscribeMatch: function(matchid, cb) {
        if (!this.hasToken()) {
            if (cb) cb(false);
            return;
        }
        var url = "/footapi/registration_ios/unsubscribematch?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
        (0, $kc8Kt.DataProvider).postGeneric(url, this.getPushPayload({
            "matchid": matchid
        }), function(response) {
            console.log("unsubscribed to match");
            if (cb) cb(response.isOk());
        }, "unsubscribeMatch");
    },
    subscribeTeam: function(teamid, cb) {
        if (!this.hasToken()) {
            if (cb) cb(false);
            return;
        }
        var url = "/footapi/registration_ios/subscribeteam?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
        (0, $kc8Kt.DataProvider).postGeneric(url, this.getPushPayload({
            "teamid": teamid
        }), function(response) {
            console.log("subscribed to team");
            if (cb) cb(response.isOk());
        }, "subscribeteam");
    },
    unSubscribeTeam: function(teamid, cb) {
        if (!this.hasToken()) {
            if (cb) cb(false);
            return;
        }
        var url = "/footapi/registration_ios/unsubscribeteam?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
        (0, $kc8Kt.DataProvider).postGeneric(url, this.getPushPayload({
            "teamid": teamid
        }), function(response) {
            console.log("unsubscribed to team");
            if (cb) cb(response.isOk());
        }, "unsubscribeteam");
    },
    subscribeLeague: function(leaguekey1, cb) {
        if (!this.hasToken()) {
            if (cb) cb(false);
            return;
        }
        var url = "/footapi/registration_ios/subscribeleague?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
        (0, $kc8Kt.DataProvider).postGeneric(url, this.getPushPayload({
            "leaguekey": leaguekey1
        }), function(response) {
            console.log("subscribed to league");
            if (cb) cb(response.isOk());
        }, "subscribeLeague");
    },
    unSubscribeLeague: function(key, cb) {
        if (!this.hasToken()) {
            if (cb) cb(false);
            return;
        }
        var url = "/footapi/registration_ios/unsubscribeleague?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
        (0, $kc8Kt.DataProvider).postGeneric(url, this.getPushPayload({
            "leaguekey": leaguekey
        }), function(response) {
            console.log("unsubscribed to league");
            if (cb) cb(response.isOk());
        }, "unsubscribeleague");
    }
};
var $2d2bf0d01adcb4d9$var$PushMessagingWeb = {
    init: async function() {
        var srcInit = 'https://www.gstatic.com/firebasejs/9.21.0/firebase-app.js';
        var srcMessaging = 'https://www.gstatic.com/firebasejs/9.21.0/firebase-messaging.js';
        let { initializeApp: initializeApp } = await import(srcInit);
        let { getMessaging: getMessaging, onMessage: onMessage } = await import(srcMessaging);
        const firebaseConfig = {
            apiKey: "AIzaSyDCwWarGEjxiJGB1jT9tluIKocpfIYhLrw",
            authDomain: "admob-app-id-3193292840.firebaseapp.com",
            databaseURL: "https://admob-app-id-3193292840.firebaseio.com",
            projectId: "admob-app-id-3193292840",
            storageBucket: "admob-app-id-3193292840.appspot.com",
            messagingSenderId: "1041266175732",
            appId: "1:1041266175732:web:61ba5007d3e420a651b8a1",
            measurementId: "G-89667RKR4X"
        };
        // Initialize Firebase
        const FirebaseApp = initializeApp(firebaseConfig);
        // this.getFirebaseToken((token)=>{
        //     console.log("firebase token is ",token);
        // })
        const messaging = getMessaging();
        // messaging.onMessageHandler =  (payload)=> {
        //     console.log('---------------------------------------------------------------------> Message received. ', payload);
        //     // ...
        // };
        // messaging.onBackgroundMessageHandler =  (payload)=> {
        //     console.log('---------------------------------------------------------------------> background Message received. ', payload);
        //     // ...
        // }
        onMessage(messaging, (payload)=>{
            console.log('Message received. ', payload);
        // ...
        });
    },
    getPushPayload: async function(extra, cb) {
        console.log("get push payload ", extra, cb);
        this.getFirebaseToken((token)=>{
            if (!token) return cb(null);
            Object.assign(extra, {
                regid: token,
                oldregid: this.oldToken,
                lang: AppInstance.getConfig().userLocale
            });
            this.oldToken = token;
            return cb(extra);
        });
    },
    subscribeMatch: function(matchid, cb) {
        this.getPushPayload({
            "matchid": matchid
        }, (payload)=>{
            if (!payload) {
                console.log("no payload");
                if (cb) cb(false);
                return;
            }
            var url = "/footapi/registration_web/subscribematch?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
            (0, $kc8Kt.DataProvider).postGeneric(url, payload, (response)=>{
                console.log("subscribed to match");
                if (cb) cb(response.isOk());
            }, "subscribeMatch");
        });
    },
    unSubscribeMatch: function(matchid, cb) {
        this.getPushPayload({
            "matchid": matchid
        }, (payload)=>{
            if (!payload) {
                console.log("no payload");
                if (cb) cb(false);
                return;
            }
            var url = "/footapi/registration_web/unsubscribematch?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
            (0, $kc8Kt.DataProvider).postGeneric(url, payload, (response)=>{
                console.log("unsubscribed to match");
                if (cb) cb(response.isOk());
            }, "unsubscribeMatch");
        });
    },
    subscribeTeam: function(teamid, cb) {
        this.getPushPayload({
            "teamid": teamid
        }, (payload)=>{
            if (!payload) {
                console.log("no payload");
                if (cb) cb(false);
                return;
            }
            var url = "/footapi/registration_web/subscribeteam?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
            (0, $kc8Kt.DataProvider).postGeneric(url, payload, (response)=>{
                console.log("subscribed to team");
                if (cb) cb(response.isOk());
            }, "subscribeTeam");
        });
    },
    unSubscribeTeam: function(teamid, cb) {
        this.getPushPayload({
            "teamid": teamid
        }, (payload)=>{
            if (!payload) {
                console.log("no payload");
                if (cb) cb(false);
                return;
            }
            var url = "/footapi/registration_web/unsubscribeteam?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
            (0, $kc8Kt.DataProvider).postGeneric(url, payload, (response)=>{
                console.log("unsubscribed to team");
                if (cb) cb(response.isOk());
            }, "unsubscribeTeam");
        });
    },
    subscribeLeague: function(leaguekey1, cb) {
        this.getPushPayload({
            "leaguekey": leaguekey1
        }, (payload)=>{
            if (!payload) {
                console.log("no payload");
                if (cb) cb(false);
                return;
            }
            var url = "/footapi/registration_web/subscribeleague?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
            (0, $kc8Kt.DataProvider).postGeneric(url, payload, (response)=>{
                console.log("subscribed to league");
                if (cb) cb(response.isOk());
            }, "subscribeleague");
        });
    },
    unSubscribeLeague: function(leaguekey1, cb) {
        this.getPushPayload({
            "leaguekey": leaguekey1
        }, (payload)=>{
            if (!payload) {
                console.log("no payload");
                if (cb) cb(false);
                return;
            }
            var url = "/footapi/registration_web/unsubscribeleague?" + (0, $kc8Kt.DataProvider).getExtraUrlParts();
            (0, $kc8Kt.DataProvider).postGeneric(url, payload, (response)=>{
                console.log("unsubscribed to league");
                if (cb) cb(response.isOk());
            }, "unsubscribeleague");
        });
    },
    getFirebaseToken: async function(cb) {
        var srcInit = 'https://www.gstatic.com/firebasejs/9.21.0/firebase-app.js';
        var srcMessaging = 'https://www.gstatic.com/firebasejs/9.21.0/firebase-messaging.js';
        let { initializeApp: initializeApp } = await import(srcInit);
        let { getMessaging: getMessaging, getToken: getToken } = await import(srcMessaging);
        const firebaseConfig = {
            apiKey: "AIzaSyDCwWarGEjxiJGB1jT9tluIKocpfIYhLrw",
            authDomain: "admob-app-id-3193292840.firebaseapp.com",
            databaseURL: "https://admob-app-id-3193292840.firebaseio.com",
            projectId: "admob-app-id-3193292840",
            storageBucket: "admob-app-id-3193292840.appspot.com",
            messagingSenderId: "1041266175732",
            appId: "1:1041266175732:web:61ba5007d3e420a651b8a1",
            measurementId: "G-89667RKR4X"
        };
        // Initialize Firebase
        const FirebaseApp = initializeApp(firebaseConfig);
        const messaging = getMessaging();
        // Add the public key generated from the console here.
        getToken(messaging, {
            serviceWorkerRegistration: window.firebaseServiceWorker,
            vapidKey: "BLyCrmUFizRZO8W_szBQWo5N5N-A5GwNo5CqS1LR19n4Kl9OnLArxSwlCxC622drMSlPXme49Y4sQhoznXbiAMk"
        }).then((currentToken)=>{
            if (currentToken) {
                console.log('currentToken', currentToken);
                cb(currentToken);
            } else {
                console.log('No registration token available. Request permission to generate one.');
                Notification.requestPermission().then((permission)=>{
                    if (permission === 'granted') {
                        console.log('Notification permission granted.');
                        $2d2bf0d01adcb4d9$var$PushMessagingWeb.getFirebaseToken(cb);
                    } else {
                        console.log('Unable to get permission to notify.');
                        cb(null);
                    }
                });
            }
        }).catch((err)=>{
            console.log('An error occurred while retrieving token. ', err);
            cb(null);
        });
    }
};
if (typeof window !== 'undefined') window.PushMessaging = $2d2bf0d01adcb4d9$var$PushMessagingWeb;

});
parcelRegister("kc8Kt", function(module, exports) {

$parcel$export(module.exports, "DataProvider", () => $eb3bb6f0397ce84a$export$43c6ed89e8a21a35);

var $dNeVp = parcelRequire("dNeVp");

var $5er4g = parcelRequire("5er4g");

var $3SrKy = parcelRequire("3SrKy");

var $fRpWP = parcelRequire("fRpWP");
var $eb3bb6f0397ce84a$var$DataProviderConfig = {
    baseUrl: "/footapi/",
    baseImageUrl: ""
};
var $eb3bb6f0397ce84a$var$Response = function() {
    var isError = false;
    var errorMessage;
    var errorCode;
    var data;
    var status;
    var authorized;
    this.error = function(e) {
        status = e.status;
        console.log(e);
        authorized = e.statusText != "Unauthorized";
        console.log("authorized ", authorized);
        if (!authorized) isError = true;
        if (status == 404 || status == 400 || status == 500 || status == 0) isError = true;
        if (e.responseText) try {
            var error = JSON.parse(e.responseText);
            this.errorMessage = error.message;
            this.errorCode = error.code;
        } catch (ex) {
            //console.log("error parsing error message",ex);
            this.errorMessage = "Error fetching data. An unusual error ocured";
            this.errorCode = 500;
            isError = true;
        }
        return this;
    };
    this.getStatus = function() {
        return status;
    };
    this.getErrorMessage = function() {
        return this.errorMessage || "";
    };
    this.getErrorCode = function() {
        return this.errorCode || "";
    };
    this.success = function(d) {
        data = d;
        status = 200;
        authorized = true;
        return this;
    };
    this.getData = function() {
        return data;
    };
    this.isOk = function() {
        return !isError;
    };
    this.isNoInternet = function() {};
    this.isTimeout = function() {};
    this.isAuthorized = function() {
        return authorized;
    };
};
const $eb3bb6f0397ce84a$export$43c6ed89e8a21a35 = {
    getExtraUrlParts: function() {
        return "lang=" + AppInstance.getConfig().userLocale + "&version=" + AppInstance.getConfig().apiVersion;
    // var fullLocale = AppInstance.getConfig().userIntlLocale;
    // if (fullLocale && fullLocale.baseName){
    //     part += "&locale="+fullLocale.baseName;
    // }
    // return part;
    },
    iamhere: function() {
        return;
    },
    getGeneralCall: function(url, cacheExpireTime, ignoreCache, cb, label, forceJson) {
        var expireTime = cacheExpireTime;
        //console.log("get general call",url,cacheExpireTime,ignoreCache,cb,label,forceJson,AppInstance.isOnline());
        if (!AppInstance.isOnline()) {
            //console.log("thzee app is not online. put a long expire time");
            ignoreCache = false;
            expireTime = 999999999;
        }
        var xhr = function() {
            $.ajax({
                timeout: FootballManiaConfig.ajaxTimeout,
                xhrFields: {},
                url: url,
                data: {},
                crossDomain: true,
                type: "GET",
                success: function(data) {
                    (0, $dNeVp.ManiaCache).set(url, data);
                    //console.log("retreived "+label+" from xhr");
                    if (!cb) {
                        console.error("no callback for " + label);
                        return;
                    }
                    if (forceJson) return cb(new $eb3bb6f0397ce84a$var$Response().success(JSON.parse(data)));
                    return cb(new $eb3bb6f0397ce84a$var$Response().success(data));
                },
                error: function(e) {
                    console.error(e);
                    if (!cb) {
                        console.error("no callback for " + label);
                        return;
                    }
                    return cb(new $eb3bb6f0397ce84a$var$Response().error(e));
                }
            });
        };
        if (ignoreCache) xhr();
        else //console.log("get",url,expireTime);
        (0, $dNeVp.ManiaCache).get(url, expireTime, function(result) {
            if (result) {
                //console.log("retreived "+label+" from cache");
                if (!cb) {
                    console.error("no callback for " + label);
                    return;
                }
                if (forceJson) return cb(new $eb3bb6f0397ce84a$var$Response().success(JSON.parse(result)));
                return cb(new $eb3bb6f0397ce84a$var$Response().success(result));
            }
            xhr();
        });
    },
    postGeneric: function(url, data, cb, label) {
        var xhr = function() {
            $.ajax({
                timeout: FootballManiaConfig.ajaxTimeout,
                xhrFields: {},
                url: url,
                data: data,
                crossDomain: true,
                type: "POST",
                success: function(data) {
                    console.log("post " + label);
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().success(data));
                },
                error: function(e) {
                    console.error(e);
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().error(e));
                }
            });
        };
        xhr();
    },
    getAppStart: function(cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.home;
        var url = AppInstance.getConfig().url.dataBaseUrl + "fixtures/feed_appstart.json?" + $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        if (FootballManiaConfig.detectedUserCountryCode) //url += "&usercountrycode="+FootballManiaConfig.detectedUserCountryCode;
        url += "&usercountrycode=ES";
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getAppStart");
    },
    getConfig: function(cb, ignoreCache) {
        var cacheExpireTime = 600000;
        if (!AppInstance.isOnline()) {
            ignoreCache = false;
            cacheExpireTime = 999999999;
        }
        var url = AppInstance.getConfig().url.dataBaseUrl + "config.json?" + $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var xhr = function() {
            $.ajax({
                timeout: FootballManiaConfig.ajaxTimeout,
                xhrFields: {},
                url: url,
                data: {},
                crossDomain: true,
                type: "GET",
                success: function(data) {
                    //ManiaCache.set(url, data);
                    localStorage.setItem("mania_config", JSON.stringify({
                        data: data,
                        timestamp: new Date().getTime()
                    }));
                    console.log("retreived config from xhr");
                    return cb(new $eb3bb6f0397ce84a$var$Response().success(data));
                },
                error: function(e) {
                    return cb(new $eb3bb6f0397ce84a$var$Response().error(e));
                }
            });
        };
        if (ignoreCache) xhr();
        else {
            var cachedResult = localStorage.getItem("mania_config");
            var hardcodedConfigCacheTime = cacheExpireTime;
            if (cachedResult) {
                cachedResult = JSON.parse(cachedResult);
                ///console.log("we have cached result",cachedResult.timestamp)
                if (new Date().getTime() - cachedResult.timestamp < hardcodedConfigCacheTime) return cb(new $eb3bb6f0397ce84a$var$Response().success(cachedResult));
                else xhr();
            } else xhr();
        }
    },
    getTranslations: function(locale, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.translations;
        var url = "/js/translations/" + locale + ".json?" + $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getTranslations");
    },
    getLiveNow: function(cb, ignoreCache, cacheExpireTime) {
        var cacheExpireTime = cacheExpireTime || FootballManiaConfig.cacheTimes.live;
        var url = AppInstance.getConfig().url.dataBaseUrl + "fixtures/feed_livenow.json?" + $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getLive");
    },
    getToday: function(cb, ignoreCache, cacheExpireTime) {
        var cacheExpireTime = cacheExpireTime || FootballManiaConfig.cacheTimes.today;
        var date = new (0, $5er4g.DateTimecode)();
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts() + "&date=" + date.getLocalDateTime("%d/%m/%Y") + "&tzoffset=" + new Date().getTimezoneOffset() * -1;
        var url = AppInstance.getConfig().url.dataBaseUrl + "fixtures/feed_matches_aggregated_short.json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getToday");
    },
    getFixturesForDate: function(date, long, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.datefixtures;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts() + "&date=" + (date + "") + "&tzoffset=" + new Date().getTimezoneOffset() * -1;
        if (long) var url = AppInstance.getConfig().url.dataBaseUrl + "fixtures/feed_matches_aggregated_long.json?" + urlPart;
        else var url = AppInstance.getConfig().url.dataBaseUrl + "fixtures/feed_matches_aggregated.json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "GETFIXTURESFORDATE");
    },
    getMatch: function(id, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.match;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts() + "&h2h=1";
        if (FootballManiaConfig.disallowedHighlightRegions.indexOf(FootballManiaConfig.userRegionLocale) == -1) urlPart += '&vid=1';
        var url = AppInstance.getConfig().url.dataBaseUrl + "matches/" + id + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "GETMATCH");
    },
    getMatchVotes: function(id, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.match;
        var url = AppInstance.getConfig().url.voteBaseUrl + "getVotes.php?matchid=" + id;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "GETVOTES");
    },
    getLeagueMatches: function(key, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.league;
        // return cb(new Response().success(JSON.parse(JSON.stringify(data))));
        //var url = AppInstance.getConfig().url.dataBaseUrl + "fixtures/feed_matches_aggregated_short.json?"+urlPart;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + "fixtures_v2/" + key.replaceAll(" ", "") + "_small.json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "LEAGUEMATCHES");
    },
    getTeam: function(id, cb, ignoreCache, cacheExpireTime, simple) {
        var cacheExpireTime = cacheExpireTime != null ? cacheExpireTime : FootballManiaConfig.cacheTimes.team;
        if (simple) var urlTarget = "team_gs_simple";
        else var urlTarget = "team_gs";
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + urlTarget + "/" + id + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "TEAM");
    },
    getPlayer: function(id, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.player;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + "players/" + id + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "player");
    },
    getCoach: function(id, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.player;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + "coaches/" + id + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "coach");
    },
    getCountryLeagues: function(country, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.countryLeagues;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        country = country.replaceAll(" ", "");
        var url = AppInstance.getConfig().url.dataBaseUrl + "fixtures/feed_leagues_country_" + country + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "countryLeagues");
    },
    getHistoryTable: function(key, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.league;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + "tableshistory/" + key + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "countryLeagues");
    },
    getInfo: function(cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.userinfo;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = "https://boogiewoogiedoo.com/getInfo?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "userinfo");
    },
    getCommentaries: function(matchid, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.commentaries;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + "commentaries/" + matchid + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getcommentaries");
    },
    getNews: function(locale, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.news;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        if (AppInstance.getConfig().newsLocaleRemap[locale]) locale = AppInstance.getConfig().newsLocaleRemap[locale];
        // //overwrite
        // var fullLocale = AppInstance.getConfig().userIntlLocale;
        // if (fullLocale && fullLocale.baseName){
        //     locale = fullLocale.baseName.toUpperCase();
        // }
        var url = AppInstance.getConfig().url.dataBaseUrl + "news/" + locale.toUpperCase() + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getnews");
    },
    getSuggestions: function(cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.suggestions;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var locale = FootballManiaConfig.userLocaleFull;
        if (!locale.baseName || locale.baseName.length < 4) locale = FootballManiaConfig.userLocale + "-" + FootballManiaConfig.userLocale.toUpperCase();
        else locale = locale.baseName;
        if (FootballManiaConfig.detectedUserCountryCode) urlPart += "&usercountrycode=" + FootballManiaConfig.detectedUserCountryCode;
        var url = AppInstance.getConfig().url.dataBaseUrl + "suggestions/" + locale.replace("-", "_") + ".json?" + urlPart;
        console.log("----------------->", url);
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getsuggestions");
    },
    getRanking: function(year, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.ranking;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts() + "&tzoffset=" + new Date().getTimezoneOffset() * -1;
        var url = AppInstance.getConfig().url.dataBaseUrl + "rankings/ranking_fifa_" + year + ".json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getranking");
    },
    getPlayerMarketValueRanking: function(cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.ranking;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts() + "&tzoffset=" + new Date().getTimezoneOffset() * -1;
        var url = AppInstance.getConfig().url.dataBaseUrl + "otherdata/topMarketValuedPlayers.json?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getplayermarketvalues");
    },
    getOtherData: function(otherdata, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.ranking;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts() + "&tzoffset=" + new Date().getTimezoneOffset() * -1;
        var url = AppInstance.getConfig().url.dataBaseUrl + "otherdata/" + otherdata + "?" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getOtherData");
    },
    getTopVoters: function(cb, ignoreCache, period) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.ranking;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        (0, $3SrKy.PushMessaging).getToken((token)=>{
            if (FootballManiaConfig.isAndroid) urlPart += "&gcmid=" + token;
            else if (FootballManiaConfig.isIOS) ;
            else urlPart += "&webtoken=" + token;
            if (period == "alltime") var topVoterUrlPart = "topVoters.json";
            else var topVoterUrlPart = "topVotersLastMonth.json";
            var url = AppInstance.getConfig().url.dataBaseUrl + topVoterUrlPart + "?" + urlPart;
            this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getTopVoters", "json");
        });
    },
    getTopTeams: function(cb, ignoreCache, period) {
        var data = [];
        for(var i = 0; i < 40; i++)data.push({
            "index": i
        });
        return cb(new $eb3bb6f0397ce84a$var$Response().success(data));
    },
    getTopVoterUser: function(id, cb, ignoreCache, period) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.ranking;
        var urlPart = "userVotes/" + id + ".json?" + $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getTopVoterUser");
    },
    getAdtekMatchOdds: function(matchid, cb, ignoreCache) {
        ignoreCache = true; //ads should never cache
        //var urlPart = DataProvider.getExtraUrlParts()+"&tzoffset="+(new Date().getTimezoneOffset()*-1);
        var urlPart = "?type=odds&appid=1&mid=" + matchid + "&random=" + Math.round(Math.random() * 1000);
        const forcedAdsLocale = localStorage.getItem("forceAdsLocale");
        if (forcedAdsLocale && forcedAdsLocale != "auto") {
            urlPart += "&country=" + forcedAdsLocale + "&force=1";
            console.warn("using forced ads locale", forcedAdsLocale);
        }
        //urlPart += "&country=BR";
        var url = "https://boogiewoogiedoo.com/request_creative" + urlPart;
        console.log("get adtek match odds: " + url);
        this.getGeneralCall(url, 0, ignoreCache, cb, "getAdtekMatchOdds");
    },
    getAdtekAd: function(type, cb, ignoreCache) {
        ignoreCache = true; //ads should never cache
        //var urlPart = DataProvider.getExtraUrlParts()+"&tzoffset="+(new Date().getTimezoneOffset()*-1);
        //var urlPart = "?type="+type+"&force=1&appid=1"+"&random="+Math.round(Math.random()*1000);
        var urlPart = "?type=" + type + "&appid=1" + "&random=" + Math.round(Math.random() * 1000);
        const forcedAdsLocale = localStorage.getItem("forceAdsLocale");
        if (forcedAdsLocale && forcedAdsLocale != "auto") {
            urlPart += "&country=" + forcedAdsLocale + "&force=1";
            console.warn("using forced ads locale", forcedAdsLocale);
        }
        //urlPart += "&country=BR";
        var url = "https://boogiewoogiedoo.com/request_creative" + urlPart;
        console.log("get adtek ad: " + url);
        this.getGeneralCall(url, 0, ignoreCache, cb, "getAdtekAd");
    },
    getForumIndex: function(cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.forum;
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + "forum/index.json?lang=" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "getForumIndex", true);
    },
    search: function(q, cb, ignoreCache) {
        var cacheExpireTime = FootballManiaConfig.cacheTimes.search;
        if (!AppInstance.isOnline()) {
            ignoreCache = false;
            cacheExpireTime = 999999999;
        }
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        if (FootballManiaConfig.detectedUserCountry) urlPart += "&country=" + FootballManiaConfig.detectedUserCountry;
        var url = AppInstance.getConfig().url.dataBaseUrl + "search_v3?q=" + encodeURIComponent(q) + "&" + urlPart;
        this.getGeneralCall(url, cacheExpireTime, ignoreCache, cb, "search");
    },
    searchtrack: function(data, cb) {
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var url = AppInstance.getConfig().url.dataBaseUrl + "track?" + urlPart;
        console.log(url);
        var xhr = function() {
            $.ajax({
                timeout: FootballManiaConfig.ajaxTimeout,
                xhrFields: {},
                url: url,
                data: data,
                crossDomain: true,
                type: "POST",
                success: function(data) {
                    console.log("post track");
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().success(data));
                },
                error: function(e) {
                    console.error(e);
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().error(e));
                }
            });
        };
        xhr();
    },
    sayHello: function(data, cb) {
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        var matchid = (0, $fRpWP.UrlManager).getModule("mid");
        var url = "https://boogiewoogiedoo.com/visitors/hello?appid=1&page=1&matchid=" + matchid;
        var xhr = function() {
            $.ajax({
                timeout: FootballManiaConfig.ajaxTimeout,
                xhrFields: {},
                url: url,
                data: data,
                crossDomain: true,
                type: "GET",
                success: function(data) {
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().success(data));
                },
                error: function(e) {
                    console.error(e);
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().error(e));
                }
            });
        };
        xhr();
    },
    getLike: function(type, team, cb) {
        var urlPart = team;
        if (type == "team") var url = AppInstance.getConfig().url.dataBaseUrl + "likes/team.json?id=" + urlPart;
        else if (type == "player") var url = AppInstance.getConfig().url.dataBaseUrl + "likes/player.json?id=" + urlPart;
        var xhr = function() {
            $.ajax({
                timeout: FootballManiaConfig.ajaxTimeout,
                xhrFields: {},
                url: url,
                crossDomain: true,
                type: "GET",
                success: function(data) {
                    console.log("get team like");
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().success(data));
                },
                error: function(e) {
                    console.error(e);
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().error(e));
                }
            });
        };
        xhr();
    },
    like: function(type, id, cb) {
        var urlPart = $eb3bb6f0397ce84a$export$43c6ed89e8a21a35.getExtraUrlParts();
        if (type == "team") var url = AppInstance.getConfig().url.dataBaseUrl + "footapi/likes/team";
        else if (type == "player") var url = AppInstance.getConfig().url.dataBaseUrl + "footapi/likes/player";
        var data = {
            id: id
        };
        var xhr = function() {
            $.ajax({
                timeout: FootballManiaConfig.ajaxTimeout,
                xhrFields: {},
                url: url,
                data: data,
                crossDomain: true,
                type: "POST",
                success: function(data) {
                    console.log("post team like");
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().success(data));
                },
                error: function(e) {
                    console.error(e);
                    if (cb) return cb(new $eb3bb6f0397ce84a$var$Response().error(e));
                }
            });
        };
        xhr();
    }
};

});
parcelRegister("5er4g", function(module, exports) {

$parcel$export(module.exports, "DateTimecode", () => $3cf341a8ac278deb$export$ec7f24eb46b69be9);
const $3cf341a8ac278deb$export$ec7f24eb46b69be9 = function(data, local) {
    var time = new Date;
    var FPS = 25;
    /**
     * @ignore
     * @param {Object} obj
     * @returns {Object}
     */ var _init = function(obj) {
        if (!data) return;
        if (!isNaN(data)) obj.setTimecode(data);
        else if (local) obj.setLocalTime(data);
        else obj.setTime(data);
        return obj;
    };
    /**
     * @return {int} timecode
     */ this.getTimecode = function() {
        return time.getTime();
    };
    /**
     * @param {int} timecode
     */ this.setTimecode = function(timecode) {
        time.setTime(timecode);
        return this;
    };
    /**
     * Ensures pair integer
     * @ignore
     */ var dd = function(value) {
        return (value < 10 ? '0' : '') + value;
    };
    this.getDateObject = function() {
        return time;
    };
    /**
     * gets local date time by given format.
     * By default '%d-%m-%Y %H:%M:%S:%F'
     * @param {String}  format
     * @return {String}
     */ this.getLocalDateTime = function(format) {
        format = format || '%d-%m-%Y %H:%M:%S:%F';
        var items = {
            'H': dd(time.getHours()),
            'M': dd(time.getMinutes()),
            'S': dd(time.getSeconds()),
            'F': dd(Math.round(time.getMilliseconds() / 1000 * FPS)),
            'd': dd(time.getDate()),
            'm': dd(time.getMonth() + 1),
            'Y': time.getFullYear(),
            'w': time.getWeek()
        };
        var item;
        for(item in items)format = format.replace('%' + item, items[item]);
        return format;
    };
    this.toLocaleTimeString = function() {
        return Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            hour: "numeric",
            minute: "numeric"
        }).format(time);
    //time.toLocaleTimeString('en-IT', { hour12: false })
    };
    this.toLocaleDateString = function() {
        return Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }).format(time);
    //time.toLocaleTimeString('en-IT', { hour12: false })
    };
    this.toLocaleDateStringLong = function() {
        return Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }).format(time);
    //time.toLocaleTimeString('en-IT', { hour12: false })
    };
    this.toLocaleDateStringAlt = function() {
        return Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(time);
    //time.toLocaleTimeString('en-IT', { hour12: false })
    };
    this.toLocaleDateStringAlt2 = function() {
        return Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
        }).format(time);
    //time.toLocaleTimeString('en-IT', { hour12: false })
    };
    /**
     * gets local time
     * by default '%H:%M:%S:%F'
     * @param {String} format
     * @return {String}
     */ this.getLocalTime = function(format) {
        format = format || '%H:%M:%S:%F';
        return this.getLocalDateTime(format);
    };
    /**
     * gets local date
     * by default '%d-%m-%Y'
     * @param {String} format
     * @return {String}
     */ this.getLocalDate = function(format) {
        format = format || '%d-%m-%Y';
        return this.getLocalDateTime(format);
    };
    /**
     * gets date time by given format.
     * By default '%d-%m-%Y %H:%M:%S:%F'
     * @param {String}  format
     * @return {String}
     */ this.getDateTime = function(format) {
        format = format || '%d-%m-%Y %H:%M:%S:%F';
        var items = {
            'H': dd(time.getUTCHours()),
            'M': dd(time.getUTCMinutes()),
            'S': dd(time.getUTCSeconds()),
            'F': dd(Math.round(time.getUTCMilliseconds() / 1000 * FPS)),
            'd': dd(time.getUTCDate()),
            'm': dd(time.getUTCMonth() + 1),
            'Y': time.getUTCFullYear()
        };
        var item;
        for(item in items)format = format.replace('%' + item, items[item]);
        return format;
    };
    /**
     * gets time
     * by default '%H:%M:%S:%F'
     * @param {String} format
     * @return {String}
     */ this.getTime = function(format) {
        format = format || '%H:%M:%S:%F';
        return this.getDateTime(format);
    };
    /**
     * gets date
     * by default '%d-%m-%Y'
     * @param {String} format
     * @return {String}
     */ this.getDate = function(format) {
        format = format || '%d-%m-%Y';
        return this.getDateTime(format);
    };
    /**
     * @ignore
     * @param {String} string
     * @returns {Array}
     */ var stringToParts = function(string) {
        var e = string.split(/[\\/\-|:]/);
        // Check for missing time; only date was given
        if (e.length == 3) {
            e.push('0');
            e.push('0');
            e.push('0');
            e.push('0');
        }
        // Check for missing date; only time was given
        if (e.length == 4) {
            e.unshift('1970');
            e.unshift('1');
            e.unshift('1');
        }
        return e;
    };
    /**
     * sets year
     * @param {int} y
     * @return {this}
     */ this.setYear = function(y) {
        time.setFullYear(y);
        return this;
    };
    /**
     * sets utc year
     * @param {int} y
     * @return {this}
     */ this.setUTCYear = function(y) {
        time.setUTCFullYear(y);
        return this;
    };
    /**
     * get year
     * @return {int}
     */ this.getYear = function() {
        return time.getFullYear();
    };
    /**
     * get utc year
     * @return {int}
     */ this.getUTCYear = function() {
        return time.getUTCFullYear();
    };
    /**
     * sets time
     * @param {String} string
     * @return {this}
     */ this.setTime = function(string) {
        var e = stringToParts(string);
        time.setUTCDate(1); // we need this to prevent invalidation of date object when day is changed on 31st
        time.setUTCFullYear(e[2]);
        time.setUTCMonth(e[1] - 1);
        time.setUTCDate(e[0]);
        time.setUTCHours(e[3]);
        time.setUTCMinutes(e[4]);
        time.setUTCSeconds(e[5]);
        time.setUTCMilliseconds(e[6] / FPS * 1000);
        return this;
    };
    /**
     * sets local time
     * @param {String} string
     * @return {this}
     */ this.setLocalTime = function(string) {
        var e = stringToParts(string);
        time.setDate(1); // we need this to prevent invalidation of date object when day is changed on 31st
        time.setFullYear(e[2]);
        time.setMonth(e[1] - 1);
        time.setDate(e[0]);
        time.setHours(e[3]);
        time.setMinutes(e[4]);
        time.setSeconds(e[5]);
        time.setMilliseconds(e[6] / FPS * 1000);
        return this;
    };
    /**
     * @function
     * Sets local date time
     * @param {String} string
     * @return {this}
     */ this.setLocalDateTime = this.setLocalTime;
    /**
     * @function
     * Sets local date
     * @param {String} string
     * @return {this}
     */ this.setLocalDate = this.setLocalTime;
    this.setMonth = function(month) {
        time.setMonth(month);
    };
    this.setDate = function(day) {
        time.setDate(day);
    };
    /**
     * Adds date time
     * @param {Banana.Util.DateTimecode} other
     * @return {this}
     */ this.add = function(other) {
        this.setTimecode(this.getTimecode() + other.getTimecode());
        return this;
    };
    /**
     * Subtracts date time
     * @param {Banana.Util.DateTimecode} other
     * @return {this}
     */ this.sub = function(other) {
        this.setTimecode(this.getTimecode() - other.getTimecode());
        return this;
    };
    /**
     * Compares date time.
     * @param {Banana.Util.DateTimecode} other
     * @return {int} diff between given datetime and this datetime
     */ this.compareTo = function(other) {
        return this.getTimecode() - other.getTimecode();
    };
    /**
     * gets week number
     * @return {int}
     */ this.getWeek = function() {
        return time.getWeek();
    };
    /**
     * gets day number
     * @return {int}
     */ this.getDay = function() {
        return time.getDay();
    };
    /**
     * gets month number
     * @return {int}
     */ this.getMonth = function() {
        return time.getUTCMonth() + 1;
    };
    /**
     * gets local month number
     * @return {int}
     */ this.getLocalMonth = function() {
        return time.getMonth() + 1;
    };
    /**
     * gets local month number
     * @return {int}
     */ this.getMonthDay = function() {
        return time.getUTCDate();
    };
    /**
     * gets local month day number
     * @return {int}
     */ this.getLocalMonthDay = function() {
        return time.getDate();
    };
    /**
     * @return Banana.Util.DateTimecode
     *
     * @param {int} local
     * @param {int} monthDay of the month. When given this day is forced
     */ this.addMonth = function(local, monthDay) {
        var month = this.getMonth() + 1;
        var year = this.getYear();
        if (!monthDay) {
            if (local) monthDay = this.getLocalMonthDay();
            else monthDay = this.getMonthDay();
        }
        if (month == 13) {
            month = 1;
            year++;
        }
        if (local) this.setLocalTime(monthDay + '-' + month + '-' + year + ' ' + this.getLocalTime());
        else this.setTime(monthDay + '-' + month + '-' + year + ' ' + this.getTime());
    };
    this.getAgeInYearsTillNow = function() {
        const ageDiffMs = Date.now() - this.getTimecode();
        const ageDateObj = new Date(ageDiffMs);
        return Math.abs(ageDateObj.getUTCFullYear() - 1970);
    };
    _init(this);
};
/**
 * Returns the week number for this date. dowOffset is the day of week the week
 * "starts" on for your locale - it can be from 0 to 6. If dowOffset is 1 (Monday),
 * the week returned is the ISO 8601 week number.
 * @ignore
 * @param int dowOffset
 * @return int
 */ Date.prototype.getWeek = function(dowOffset) {
    /*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com */ dowOffset = typeof dowOffset == 'int' ? dowOffset : 0; //default dowOffset to zero
    var newYear = new Date(this.getFullYear(), 0, 1);
    var day = newYear.getDay() - dowOffset; //the day of week the year begins on
    day = day >= 0 ? day : day + 7;
    var daynum = Math.floor((this.getTime() - newYear.getTime() - (this.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) / 86400000) + 1;
    var weeknum;
    //if the year starts before the middle of a week
    if (day < 4) {
        weeknum = Math.floor((daynum + day - 1) / 7) + 1;
        if (weeknum > 52) {
            var nYear = new Date(this.getFullYear() + 1, 0, 1);
            var nday = nYear.getDay() - dowOffset;
            nday = nday >= 0 ? nday : nday + 7;
            /*if the next year starts before the middle of
            the week, it is week #1 of that year*/ weeknum = nday < 4 ? 1 : 53;
        }
    } else weeknum = Math.floor((daynum + day - 1) / 7);
    return weeknum;
};

});



parcelRegister("02mnx", function(module, exports) {

$parcel$export(module.exports, "Localizer", () => $00718bfab72bcb0c$export$36821066db45cf20);

var $kc8Kt = parcelRequire("kc8Kt");

var $aEHEB = parcelRequire("aEHEB");
const $00718bfab72bcb0c$export$36821066db45cf20 = {
    DefaultTranslations: $aEHEB.DefaultTranslations,
    LocalizedTranslations: null,
    loadedLocale: null,
    /**
     * Retrieves the localized string for the given key.
     * Falls back to default translations or the original string if not found.
     * @param {string} str - The key for the string to localize.
     * @returns {string} The localized string.
     */ getString (str) {
        const key = str.replace(/\s|'/g, "_");
        if (!this.LocalizedTranslations) {
            console.warn("No localized translations loaded. Using default or original string.");
            return this.DefaultTranslations[key] || str;
        }
        return this.LocalizedTranslations[key] || this.DefaultTranslations[key] || str;
    },
    /**
     * Safely replaces placeholders in the localized string.
     * @param {string} str - The key for the string to localize.
     * @param {Object} replacements - Key-value pairs for replacements (e.g., { name: "John" }).
     * @returns {string} The localized string with replacements.
     */ getStringSafeReplace (str, replacements) {
        let localized = this.getString(str);
        if (replacements && typeof replacements === "object") for (const [key, value] of Object.entries(replacements))localized = localized.replace(new RegExp(`{${key}}`, "g"), value);
        return localized;
    },
    /**
     * Checks if a localized string exists for the given key.
     * @param {string} key - The key to check.
     * @returns {boolean} True if the key exists in localized translations.
     */ hasString (key) {
        return !!(this.LocalizedTranslations && this.LocalizedTranslations[key]);
    },
    /**
     * Loads translations for the specified locale.
     * @param {string} locale - The locale to load (e.g., "en_US").
     * @param {Function} cb - Callback function receiving a boolean success status.
     */ loadLocale (locale, cb) {
        if (this.loadedLocale === locale) {
            console.log(`Locale ${locale} already loaded.`);
            return cb(true);
        }
        if (!AppInstance.getConfig().allowableLocales.includes(locale)) {
            console.warn(`Locale ${locale} not supported. Falling back to default.`);
            locale = AppInstance.getConfig().defaultLocale;
        }
        (0, $kc8Kt.DataProvider).getTranslations(locale, (response)=>{
            if (response.isOk()) {
                console.log(`Locale ${locale} loaded successfully.`);
                this.LocalizedTranslations = response.getData();
                this.loadedLocale = locale;
                cb(true);
            } else cb(false);
        });
    },
    /**
     * Retrieves the currently loaded locale's translations.
     * @returns {Object|null} The loaded translations or null if none are loaded.
     */ getLoadedLocale () {
        return this.LocalizedTranslations;
    }
};

});
parcelRegister("aEHEB", function(module, exports) {

$parcel$export(module.exports, "DefaultTranslations", () => $7c1f80929beed5c9$export$134822ea7cfe5ca3);
const $7c1f80929beed5c9$export$134822ea7cfe5ca3 = {
    "facebook_app_id": "222169131296470",
    "com.crashlytics.android.build_id": "RANDOM_UUID",
    "com.crashlytics.android.build_id__#": "<string name=\"google_app_id\">177818426888</string>",
    "app_name": "Football Mania",
    "app_logo_name": "Football Live Scores",
    "standen": "Standings",
    "reload": "Reload",
    "loading": "Loading..",
    "nointernet": "No internet connection",
    "noconnnection": "Can't Connect",
    "noserverconnection": "Connection to server could not be established",
    "tryagain": "try again",
    "settings": "Settings",
    "no_data": "No data found",
    "selectcompetition": "Competitions",
    "morecompetition": "More Competitions",
    "matchinfo": "Match info",
    "lineups": "Lineups",
    "teaminfo": "Team info",
    "squad": "Squad",
    "venue": "Venue",
    "capacity": "Capacity",
    "surface": "Surface",
    "transfers": "Transfers",
    "founded": "Founded",
    "coach": "Coach",
    "country": "Country",
    "attacker": "Attacker",
    "midfielder": "Midfielder",
    "defender": "Defender",
    "goalkeeper": "Goalkeeper",
    "loan": "Loan",
    "from": "From",
    "to": "To",
    "free": "Free",
    "unknown": "Unknown",
    "schedule": "Schedule",
    "live": "Live",
    "nowlive": "Now live",
    "live_matches": "Live matches",
    "todays_matches": "Todays Matches",
    "tomorrow": "Tomorrow",
    "currently_no_matches": "Currently no matches",
    "todaysmatches": "Today",
    "thisweekmatches": "This week",
    "nextweekmatches": "Next week",
    "round": "Round",
    "topscoreplayers": "Top Scorers",
    "career": "Career",
    "passport": "Personal Details",
    "season": "Season",
    "team": "Team",
    "age": "Age",
    "nationality": "Nationality",
    "birthplace": "Birthplace",
    "position": "Position",
    "weight": "Weight",
    "height": "Height",
    "competition": "Competition",
    "Europe": "Europe",
    "Asia": "Asia",
    "South_America": "South America",
    "Africa": "Africa",
    "Oceania": "Oceania",
    "North_Central_America": "North Central America",
    "World_Cup": "World Cup",
    "World_Cup_Qualifications": "World Cup Qualifications",
    "International_Cups": "International Cups",
    "Eurocups": "European Cups",
    "votes": "Votes",
    "voteMatch": "Vote",
    "already_voted": "You voted",
    "shotstotals": "Total shots",
    "shotsgoal": "Shots on goal",
    "goal": "Goal",
    "goals": "Goals",
    "fouls": "Fouls",
    "possessiontime": "Possession time",
    "corners": "Corners",
    "offsides": "Offsides",
    "yellowcard": "Yellow card",
    "yellowcards": "Yellow cards",
    "redcard": "Red card",
    "redcards": "Red cards",
    "saves": "Saves",
    "odds": "odds",
    "threewayhandicap": "3 Way Handicap",
    "stats": "stats",
    "rank": "rank",
    "cleansheet": "Clean sheet",
    "avggoalspergamescored": "Average goals per game scored",
    "avggoalspergameconceded": "Average goals per game conceded",
    "avgfirstgoalscored": "Average first goal scored",
    "avgfirstgoalconceded": "Average first goal conceded",
    "failedtoscore": "Failed to score",
    "scoringminutes": "Scoring minutes",
    "sidelined": "Sidelined",
    "home": "home",
    "away": "Away",
    "total": "Total",
    "table_gamesplayed_full": "Games played",
    "table_gamesplayed": "GP",
    "table_points_full": "Points",
    "table_points": "Pts",
    "table_wins_full": "Win",
    "table_wins": "W",
    "table_draw_full": "Draw",
    "table_draw": "D",
    "table_lost_full": "Lost",
    "table_lost": "L",
    "table_goalsagainst_full": "Goals against",
    "table_goalsfor_full": "Goals for",
    "table_goalsforagainst": "GF-GA",
    "table_goalsforagainst_full": "Goal difference",
    "table_goaldiff": "GD",
    "favorites": "Favourites",
    "favoriteteams": "Favourite Teams",
    "favoriteleagues": "Favourite Competitions",
    "substitutions": "Substitutions",
    "videos": "Videos",
    "searchresults": "Search results",
    "teams": "Teams",
    "league": "league",
    "leagues": "Leagues",
    "sounds": "Sounds",
    "entertainment": "Entertainment",
    "interrupted": "Interrupted",
    "city": "City",
    "world_ranking_list": "FIFA World Ranking List",
    "menu_favorite_team": "Favourite Team",
    "menu_favorite_league": "Favourite Competition",
    "menu_refresh": "Refresh",
    "menu_search": "Search",
    "menu_sharematch": "Share",
    "menu_unsubscribe": "Unsubscribe",
    "menu_subscribe": "Subscribe",
    "comments": "Chat",
    "previous_matches": "Previous matches",
    "versus": "Versus",
    "interrupted_short": "Intr.",
    "finaltime": "Full time",
    "finaltime_short": "FT",
    "halftime": "Half time",
    "halftime_short": "HT",
    "after_extra_time": "After extra time",
    "after_extra_time_short": "AET",
    "to_be_announced": "To be announced",
    "to_be_announced_short": "TBA",
    "penalty": "Penalty",
    "penalty_short": "Pen.",
    "postponed": "Postponed",
    "postponed_short": "Postp.",
    "abandoned": "Abandoned",
    "cancelled": "Cancelled",
    "cancelled_short": "Can.",
    "abandoned_short": "Aban.",
    "more_team_battle_info": "More team statistics",
    "news": "News",
    "source": "Source",
    "please_login": "Please login",
    "back": "Back",
    "close": "Close",
    "advertisement": "Advertisement",
    "we_are_sorry": "We're sorry!",
    "no_player_info": "We have no further information for this player yet..",
    "ok": "OK",
    "push_notification_warning": "You just enabled push notifications for a game and will receive them once a goal is made or the game has ended.",
    "ok_got_it": "OK, got it!",
    "no_match_info": "No match facts available",
    "no_team_info": "Sorry, we don't have any info on this team",
    "no_squad_info": "No squad found..",
    "no_transfer_info": "No transfers found..",
    "no_topscorers_info": "No top scorers yet..",
    "none": "None",
    "relegation": "Regelation",
    "promotion": "Promotion",
    "promotion_playoff": "Promotion Play-off",
    "show_only_top_leagues": "show only top leagues",
    "show_all": "show all",
    "no_live_matches": "There are currently no live matches",
    "notification_sound": "notification sound",
    "notification_vibration_enabled": "Notification Vibrate On",
    "voting_statistics": "voting statistics",
    "apply_filter": "apply filter",
    "all_time": "all time",
    "extra_time_short": "ET",
    "tap_again_to_exit": "Tap again to exit",
    "match_started": "Match started",
    "website": "website",
    "Northern_Ireland": "Northern Ireland",
    "assist": "assist",
    "h2h": "Head 2 Head",
    "liveticker": "Live Ticker",
    "agenda": "Calendar",
    "vkontakte": "\u0412\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0435",
    "aggregate": "On aggregate",
    "winner": "winner:",
    "selectitemtoswap": "Select highlighted item to swap",
    "chattypehint": "Type here your message",
    "silent": "Silent",
    "ringtoneTitle": "Ringtone",
    "ringtoneSummary": "Ringtone: %s",
    "language": "Language",
    "contact": "Contact",
    "feedback_and_support": "Feedback & Support",
    "summary": "Your feedback is appreciated and will help us to improve our ability to serve you and other users the best experience. Please let us know your questions, issues and suggestions by clicking here or sending a mail to: World.Sport.Apps@Gmail.com",
    "starts_in": "Starts in %{param1} minutes",
    "announcement": "Announcement",
    "notification_enabled_types": "Enabled notifications",
    "reset_application": "Application reset",
    "reset_application_summary": "Reset this application to default installation",
    "reset_application_summary_extended": "This action will reset all favourites, push notifications and other custom settings. Are you sure you want to continue?",
    "resumed": "Resumed",
    "enabled": "Enabled",
    "vibration_enabled": "Vibrate on alert",
    "wake_when_push_notification_arrives": "Wake when push notification arrives",
    "notification_high_prio_enabled": "High priority for notifications",
    "England": "England",
    "Scotland": "Scotland",
    "Wales": "Wales",
    "Moldovia": "Moldovia",
    "Azerbaijan": "Azerbaijan",
    "Cambodia": "Cambodia",
    "Congo_Kinshasa": "Congo Kinshasa",
    "Guadeloupe": "Guadeloupe",
    "Ivory_Coast": "Ivory Coast",
    "remove_ads": "Remove Advertising",
    "remove_ads_summary": "Please choose one of the following options:",
    "remove_ads_summary_offer_short": "Select this to remove advertising",
    "remove_ads_summary_offer": "Remove advertising by subscribing to one of the following options below. The subscription will automatically renew by the end of the subscription period. You can stop the subscription from here",
    "premium_subscription_info_title": "You have an active premium subscription",
    "premium_subscription_info_expiration_status": "",
    "remove_premium_subscription_info_guide": "Click here to manage your Google app subscriptions",
    "remove_premium_autorenew_on": "Your subscription is automatically renewed",
    "remove_premium_autorenew_off": "Your subscription is cancelled and will not automatically be renewed",
    "remove_advertising_one_month": "1 month subscription",
    "remove_advertising_six_months": "6 months subscription",
    "remove_advertising": "1 year subscription",
    "remove_advertising_oneweek": "1 week subscription",
    "extraRingtones": [
        "whistle1",
        "whistle2",
        "whistle3",
        "whistle4",
        "whistle5",
        "whistle6",
        "whistle7",
        "whistle8",
        "whistle9",
        "whistle10",
        "whistle11",
        "whistle12",
        "crowd1",
        "crowd2",
        "crowd3"
    ],
    "extraRingtoneTitles": [
        "whistle1",
        "whistle2",
        "whistle3",
        "whistle4",
        "whistle5",
        "whistle6",
        "whistle7",
        "whistle8",
        "whistle9",
        "whistle10",
        "whistle11",
        "whistle12",
        "crowd1",
        "crowd2",
        "crowd3"
    ],
    "extra_time": "Extra time",
    "offline_mode": "Offline",
    "beta_test": "Beta testing",
    "beta_test_summary": "Interested in trying out the newest features? click here to join the beta test program",
    "reset_cache": "Reset cache",
    "reset_application_cache": "Removes all stored images and offline data",
    "permission_disabled_warning": "\"You have denied the permission to write and read data from your phone.\nWhile the app still works there will be a decrease in performance, more data usage and offline support is disabled.\nYou can enable this permission in your app settings.\"",
    "about_title": "About",
    "about_text": "Special thanks to Arjan Meijer for his high quality football data. And thanks to the Football Mania community for its valueable input and support. Football Mania is a product created by and for football fans from all over the world.\nThanks to Anthony Buttaci for his awesome work on updating many team logos.",
    "no_thanks": "No Thanks",
    "team_form": "Form",
    "error_no_gcm": "Cannot retreive Google Cloud messaging registration id. Please update Google playservices",
    "default_home_screen": "Default home/start screen",
    "watchlist": "My Watchlist",
    "fixtures": "Fixtures",
    "push_notification_title": "Push notification registration number. Click to test and copy to clipboard",
    "enable_community_logo_pack": "Logo pack",
    "enable_community_logo_pack_summary": "Click here to install Fan Logo Pack",
    "disclaimer": "Disclaimer",
    "installed": "Installed. Click to uninstall",
    "uninstall": "Uninstall",
    "uninstall_logo_pack": "Are you sure you want to uninstall the Logo pack",
    "enable_community_logo_pack_disclaimer": "The logo pack contains images from clubs and players.\nFootball Mania does not represent the owner of the images. The images are not authorized by, sponsored by, or associated with the trademark owner(s).\nAll logos are collected by football fans and for personal use only. Click OK to install.",
    "pause": "Break",
    "start": "Home",
    "cancel": "Cancel",
    "updated_at": "Last updated",
    "widget_no_data": "There are currently no items on your watchlist, nor are any of your favorite teams playing.",
    "suspended_short": "Susp",
    "suspended": "Suspended",
    "favorite_order": "Favorites order",
    "manual": "Manual",
    "alfabetical": "Alfabetical",
    "select_date": "Select different date from calendar",
    "top_voters": "Top User Predictions",
    "username": "Username",
    "hits": "Right",
    "misses": "Wrong",
    "info": "Info",
    "last_week": "Last week",
    "last_month": "Last month",
    "login": "Sign in",
    "logout": "Sign out",
    "not_logged_in": "Not signed in",
    "logged_in_as": "Signed in as: %s",
    "substitutes": "Substitutes",
    "odd_title": "Odds",
    "bookmaker": "Bookmaker",
    "bookmaker_value_format": "Bookmaker format",
    "odds_preference": "Preferred Bookmaker",
    "bookmakers_enabled": "Show Bookmakers in match screen",
    "user_fixture_ordering": "Favourite order (live,today,calendar)",
    "Kyrgyzstan": "Kyrgyzstan",
    "preferred_foot": "Preferred foot",
    "privacy": "Privacy policy",
    "profile": "Profile",
    "attendance": "Attendance",
    "predictions": "Predictions",
    "missed_penalty": "Penalty missed",
    "theme": "Theme",
    "theme_black": "Black",
    "theme_white": "White",
    "theme_green": "Green",
    "theme_green2": "Dark Green",
    "theme_dblue": "Dark Blue",
    "theme_red": "Red",
    "theme_orange": "Desert",
    "theme_blue": "Blue",
    "theme_purple": "Purple",
    "theme_pink": "Pink",
    "font_size": "Font size",
    "font_small": "Small",
    "font_medium": "Medium",
    "font_large": "Large",
    "font_xlarge": "XLarge",
    "graphics": "Graphics",
    "advanced_animations": "Advanced Animations",
    "clock_mode": "Clock Format",
    "clock_mode_24": "24 hours",
    "clock_mode_12": "12 hours",
    "Tajikistan": "Tajikistan",
    "gibraltar": "Gibraltar",
    "back_button_label": "Back",
    "next_button_label": "Next",
    "skip_button_label": "Skip",
    "skip_button_label__#": "Optional button to Skip a PreferenceActivity [CHAR LIMIT=20]",
    "download": "Download",
    "please_wait": "Please Wait",
    "next_match": "Next match on %{param1}",
    "terms_of_service": "Privacy Policy",
    "terms_of_service_popup_title": "",
    "terms_of_service_popup_explained": "We keep this app free by showing ads. We use an unique identifier on your device to serve ads. If you want to avoid any tracking, you can buy ad-free version of this app.",
    "terms_of_service_popup_introduction": "Scroll down and click \"I agree\" when you are ready to continue with Football Mania Live Scores.",
    "terms_of_service_popup_introduction2": "To be consistent with data protection laws, we're asking you to take a moment to review key points of Football Mania's Privacy Policy.",
    "terms_of_service_popup_data_title": "Data we progress:",
    "terms_of_service_data_usage_list": "When you use Football Mania Live Scores, we progress information about that activity. Including information like device ID and Cookie Data.\n  \nWe progress that information for services like Ads, Analytics and Crashalytics.",
    "terms_of_service_popup_why_usuing_data": "Why we progress it:",
    "terms_of_service_popup_why_usuing_data_explained": "We progress this data described in our policy, including to:\n\n  \n<li>Help our services deliver more useful, customized content such as favorites and relevant search results</li>.\n  \n<li>Improve the quality of our services and develop new ones.</li>\n  \n<li>Deliver ads based on your interest.</li>\n  \n<li>Conduct analytics and measurements to understand how our services are used. We use Google Analytics and Crashalytics\n   to understand user behavior and app crashes.\\n\\nThank you for your attention, \\nThe Football Mania Live Score team. \\n\\n If you have any questions or feedback, feel free to contact world.sport.apps@gmail.com\\n</li>",
    "terms_of_service_description": "Touch to view Privacy Policy",
    "terms_of_service_cancel_button": "Later",
    "terms_of_service_ok_button": "I agree",
    "overwrite_default_push_notification_behavior": "Enable custom sounds",
    "change_log": "Changelog",
    "change_log_description": "Click to view changelog and developer notes",
    "notice": "Notice",
    "forum": "Chat",
    "banned": "banned",
    "chat_vote_disabled": "We have disabled your voting functionality. Please contact the app admin for more information",
    "chat_disabled": "This chat room is archived and all activity is disabled.",
    "banned_cannot_post_reason": "Your account is currently banned. Please contact the app admin for more information.",
    "unknown_error": "An unknown error has happened. Please contact the app admin for more information.",
    "chat_auth_failure": "Authorization failed. Please try logging in again or contact the app admin for more information.",
    "removed": "Removed",
    "fastscroll_enabled": "Fast scrolling in lists",
    "experimental_mode": "Fancy mode (Android 9+)",
    "International_North_Central_America": "North Central America",
    "International_Africa": "International Africa",
    "International_Asia": "International Asia",
    "International_Oceania": "International Oceania",
    "International_South_America": "International South America",
    "International": "International",
    "Regions": "Regions",
    "Faroe_islands": "Faroe islands",
    "venue2": "venue",
    "possestiontime": "Ball possession",
    "shotsgoalmissed": "Missed shots on goal",
    "shotsgoalblocked": "Blocked shots on goal",
    "passestotal": "Total ball passes",
    "passesaccurate": "Total accurate ball passes",
    "shotstotal": "Total shots",
    "taptotryagain": "Tap to try again",
    "referee": "referee",
    "no_schedule_available": "no schedule available",
    "taptoreturn": "Tap to return to previous screen",
    "no_matches_found": "No football matches found",
    "you_have_enabled_favorite_filter": "You have enabled filter to show only favorite matches and leagues",
    "tap_to_return": "Tap to go back",
    "upcoming_matches": "Upcoming matches",
    "attackers": "attackers",
    "defenders": "defenders",
    "midfielders": "midfielders",
    "goalkeepers": "goalkeepers",
    "kneeinjury": "knee injury",
    "minorinjury": "minor injury",
    "anklefootinjury": "ankle/footinjury",
    "hamstring": "hamstring",
    "last_played_match": "last played match",
    "todays_played_match": "Today's played match",
    "today": "today",
    "thighmusclestrain": "thigh muscle injury",
    "brokenwrist": "broken wrist",
    "footinjury": "foot injury",
    "calfmusclestrain": "calf muscle strain",
    "knock": "minor injury",
    "trophies": "trophies",
    "Kosovo": "Kosovo",
    "incoming_transfers": "incoming transfers",
    "outgoing_transfers": "outgoing transfers",
    "free_exchange": "free exchange",
    "secondplace": "trophysecond",
    "firstplace": "trophyfirst",
    "dominican_republic": "Dominican Republic",
    "search_your_favorite_teams": "Search your favorite teams",
    "goal_disallowed": "Goal disallowed",
    "added": "added",
    "offside": "offside",
    "address": "Address",
    "penalties": "penalties",
    "match_events": "Match events",
    "match": "Match",
    "select_news_from_country": "Select news from another country",
    "description_add_news_source": "Do you miss news from a specific country or language?. Let us know by sending a good news source with RSS feed support.",
    "firstname": "firstname",
    "lastname": "lastname",
    "injury_still_there": "The injury is still present",
    "date": "date",
    "injury_type": "injury type",
    "injury_period": "injury period",
    "injury_suspended": "Player is suspended",
    "knee_injury": "Knee injury",
    "groin_pelvis_injury": "Groin/Pelvis injury",
    "pcl_knee_ligament_injury": "Knee ligament injury",
    "mcl_knee_ligament_injury": "Knee Ligament injury",
    "ankle_foot_injury": "Ankle foot injury",
    "virus": "virus",
    "illness": "illness",
    "thigh_muscle_rupture": "Thigh muscle rupture",
    "shoulder_injury": "Shoulder injury",
    "concussion": "concussion",
    "lcl_knee_ligament_injury": "Knee Ligament injury",
    "ankle_ligaments": "Ankle ligaments injury",
    "thigh_muscle_strain": "Thigh muscle strain",
    "back_injury": "Back injury",
    "broken_shinbone": "Broken shinbone",
    "period_from": "period from",
    "period_to": "period to",
    "days": "days",
    "groin_strain": "Groin strain",
    "calf_shin_injury": "calf shin injury",
    "hip_thigh_injury": "hip thigh injury",
    "achilles_tendonitis": "achilles tendonitis",
    "metatarsal_fracture": "metatarsal fracture",
    "ankle_fracture": "Ankle fracture",
    "injuries": "injuries",
    "market_value": "Market value",
    "right_foot": "right foot",
    "left_foot": "left foot",
    "search_your_favorite_league": "Search your favorite league/cup",
    "league_add_information": "Below you can see some suggestions. Use the search function above to find more Leagues or Cups",
    "tap_to_add": "Tap to add",
    "player_market_values": "Player Market Values",
    "name": "name",
    "birthdate": "birthdate",
    "predicted_lineups": "Predicted Team Lineups",
    "no_chat_messages": "No messages yet",
    "type_below_to_be_first": "Type below to be the first with a new message",
    "shortsclip": "shorts",
    "highlights": "highlights",
    "bookmakers_enabled_when_premium": "Bookmaker ads enabled when premium",
    "filter_by_country": "Filter by country",
    "selected": "selected:",
    "Democratic_Republic_of_Congo": "Democratic Republic of Congo",
    "Czechia": "Czechia",
    "Congo_DR": "Congo DR",
    "Cura\xe7ao": "Cura\xe7ao",
    "Korea_Republic": "Korea Republic",
    "North_Macedonia": "North Macedonia",
    "Republic_of_Ireland": "Republic of Ireland",
    "Syria": "Syria",
    "T\xfcrkiye": "T\xfcrkiye",
    "USA": "USA",
    "C\xf4te_d_Ivoire": "C\xf4te d'Ivoire",
    "playerstats": "Player stats",
    "update_version": "updating to version {}",
    "sidelined_match": "Sidelined",
    "injury": "Injury",
    "calf_injury": "Calf Injury",
    "achilles_tendon_injury": "Achilles Tendon Injury",
    "muscle_injury": "Muscle injury",
    "health_problems": "Health problems",
    "arm_injury": "Arm injury",
    "groin_injury": "Groin Injury",
    "toe_injury": "Toe injury",
    "yellow_cards": "Yellow cards",
    "red_card": "Red card",
    "ankle_injury": "Ankle injury",
    "abdominal_strain": "Abdominal Strain",
    "thigh_injury": "Thigh Injury",
    "tendon_injury": "Tendon injury",
    "suspended_player": "Suspended",
    "convalescence": "Convalescence",
    "hip_injury": "Hip injury",
    "loan_agreement": "Loan agreement",
    "Curacao": "Curacao",
    "Tripping": "Tripping",
    "Roughing": "Roughing",
    "Foul": "Foul",
    "heart_problems": "Heart problems",
    "doping": "doping",
    "Unsportsmanlike_conduct": "Unsportsmanlike conduct",
    "Holding": "Holding",
    "user_consent_sumary": "User consent information",
    "data_privacy": "Data privacy",
    "Eswatini": "Eswatini",
    "Laos": "Laos",
    "select_leaguecup": "Select other league/cup",
    "select_season": "Select season",
    "trophy_first": "winner",
    "trophy_second": "runner-up",
    "trophyfirst": "1st",
    "trophysecond": "2nd",
    "title_home_screen": "Home screen - Football Mania Livescores",
    "title_home_today": "Today's matches",
    "title_home_live": "Live matches",
    "euro2024": "Euro Championship 2024"
};

});


parcelRegister("6K7Df", function(module, exports) {

$parcel$export(module.exports, "CountryUtil", () => $4e8cf5811b4c6397$export$9225d78b5f2f8e31);

var $02mnx = parcelRequire("02mnx");

var $lU8CH = parcelRequire("lU8CH");
const $4e8cf5811b4c6397$export$9225d78b5f2f8e31 = {
    cache: new Map(),
    /**
     * Retrieves the localized name of a country by its English name.
     * @param {string} name - The English name of the country.
     * @param {string} [forceLocale] - Optional locale to force; defaults to user locale.
     * @returns {string} The localized country name.
     */ getLocalizedCountryByName (name, forceLocale) {
        var _nameCountries_name;
        const localeCode = (_nameCountries_name = $4e8cf5811b4c6397$export$dae06f7b53496f9e[name]) === null || _nameCountries_name === void 0 ? void 0 : _nameCountries_name.toUpperCase();
        if (!localeCode) {
            console.warn(`Country code not found for ${name}`);
            return (0, $02mnx.Localizer).getString(name);
        }
        const locale = forceLocale || FootballManiaConfig.userLocale;
        const cacheKey = `${localeCode}-${name}-${locale}`;
        if (this.cache.has(cacheKey)) return this.cache.get(cacheKey);
        if (!Intl.DisplayNames) {
            console.warn("Intl.DisplayNames not supported. Using default name.");
            return name;
        }
        const regionNames = new Intl.DisplayNames([
            locale
        ], {
            type: 'region'
        });
        const localizedName = regionNames.of(localeCode) || name;
        this.cache.set(cacheKey, localizedName);
        return localizedName;
    },
    /**
     * Retrieves the country name by its locale code.
     * @param {string} locale - The locale code (e.g., 'us', 'gb').
     * @param {string} displayLocale - The locale to display the name in.
     * @returns {string} The country name in the specified display locale.
     */ getCountryByLocale (locale, displayLocale) {
        const cacheKey = `${locale}-${displayLocale}`;
        if (this.cache.has(cacheKey)) return this.cache.get(cacheKey);
        const regionNames = new Intl.DisplayNames([
            displayLocale
        ], {
            type: 'region'
        });
        const countryName = regionNames.of(locale.toUpperCase()) || locale;
        this.cache.set(cacheKey, countryName);
        return countryName;
    },
    /**
     * Retrieves the localized language name by its locale code.
     * @param {string} locale - The locale code (e.g., 'en', 'fr').
     * @param {string} [forceLocale] - Optional locale to force; defaults to the locale itself.
     * @returns {string} The localized language name.
     */ getLocalizedLanguageNameByLocale (locale, forceLocale) {
        const displayLocale = forceLocale || locale.toUpperCase();
        const cacheKey = `${locale}-${displayLocale}`;
        if (this.cache.has(cacheKey)) return this.cache.get(cacheKey);
        const languageNames = new Intl.DisplayNames([
            displayLocale
        ], {
            type: 'language'
        });
        const languageName = languageNames.of(locale.toUpperCase()) || locale;
        this.cache.set(cacheKey, languageName);
        return languageName;
    },
    /**
     * Determines the user's region based on their locale.
     * @param {string} [forceLocale] - Optional locale to force; defaults to user locale.
     * @returns {string} The region name (e.g., 'Europe', 'Asia').
     */ getRegionByLocale (forceLocale) {
        var _FootballManiaConfig_userIntlLocale;
        const locale = forceLocale || ((_FootballManiaConfig_userIntlLocale = FootballManiaConfig.userIntlLocale) === null || _FootballManiaConfig_userIntlLocale === void 0 ? void 0 : _FootballManiaConfig_userIntlLocale.region) || FootballManiaConfig.userLocale;
        const countryName = this.getCountryByLocale(locale, "en");
        return $4e8cf5811b4c6397$var$countryToRegion[countryName] || "Unknown";
    },
    /**
     * Checks if a country is recognized.
     * @param {string} country - The country name.
     * @returns {boolean} True if the country is recognized, false otherwise.
     */ isRealCountry (country) {
        return !!$4e8cf5811b4c6397$var$countryToRegion[country];
    },
    /**
     * Localizes and sorts a list of countries.
     * @param {string[]} countries - Array of country names in English.
     * @param {string} locale - The locale to localize the names in.
     * @returns {Object[]} Array of objects with 'name' and 'localized' properties.
     */ localizeCountries (countries, locale) {
        return countries.map((country)=>{
            const localized = this.getLocalizedCountryByName(country, locale);
            return {
                name: country.toLowerCase(),
                localized: localized || country
            };
        }).sort((a, b)=>a.localized.localeCompare(b.localized));
    },
    /**
     * Finds countries matching a search term.
     * @param {Object[]} countrystack - Array of country objects with 'localized' property.
     * @param {string} search - The search term.
     * @param {string} locale - The locale for searching.
     * @returns {Object[]} Array of matching country objects.
     */ findCountries (countrystack, search, locale) {
        const searchLower = search.toLowerCase();
        return countrystack.filter((country)=>{
            const localizedLower = country.localized.toLowerCase();
            const distance = (0, $lU8CH.LevensteinDistance)(localizedLower, searchLower);
            return distance < 2 || localizedLower.includes(searchLower);
        });
    }
};
// Export to window if in browser environment
if (typeof window !== 'undefined') window.CountryUtil = $4e8cf5811b4c6397$export$9225d78b5f2f8e31;
const $4e8cf5811b4c6397$export$fb0d84d40d87f647 = {
    "AD": "Southern Europe",
    "AE": "Western Asia, Middle East",
    "AF": "Central Asia",
    "AG": "Caribbean",
    "AI": "Caribbean",
    "AL": "Balkans",
    "AM": "Western Asia",
    "AO": "Central Africa",
    "AQ": "Antarctica",
    "AR": "South America",
    "AS": "American Samoa",
    "AT": "Western Europe",
    "AU": "Oceania",
    "AW": "Caribbean",
    "AX": "Scandinavia",
    "AZ": "Western Asia",
    "BA": "Balkans",
    "BB": "Caribbean",
    "BD": "Southern Asia",
    "BE": "Western Europe",
    "BF": "Western Africa",
    "BG": "Central Europe",
    "BH": "Western Asia, Middle East",
    "BI": "East Africa, Central Africa",
    "BJ": "Western Africa",
    "BL": "Caribbean",
    "BM": "Caribbean, North America",
    "BN": "South-East Asia",
    "BO": "South America",
    "BQ": "Caribbean",
    "BR": "South America",
    "BS": "Caribbean",
    "BT": "Southern Asia",
    "BV": "Scandinavia, Nordic Countries",
    "BW": "Southern Africa",
    "BY": "Central Europe",
    "BZ": "Caribbean",
    "CA": "North America",
    "CC": "Central America",
    "CD": "Central Africa",
    "CF": "Central Africa",
    "CG": "Central Africa",
    "CH": "Western Europe",
    "CI": "Western Africa",
    "CK": "Oceania",
    "CL": "South America",
    "CM": "Central Africa",
    "CN": "East Asia",
    "CO": "South America",
    "CR": "Central America",
    "CU": "Caribbean",
    "CV": "Western Africa",
    "CW": "Caribbean",
    "CX": "Oceania",
    "CY": "Western Asia",
    "CZ": "Central Europe",
    "DE": "Western Europe",
    "DJ": "East Africa",
    "DK": "Scandinavia, Nordic Countries",
    "DA": "Scandinavia, Nordic Countries",
    "DM": "Caribbean",
    "DO": "Caribbean",
    "DZ": "Northern Africa",
    "EC": "South America",
    "EE": "Baltic Countries",
    "EG": "Northern Africa",
    "EH": "Western Sahara",
    "ER": "East Africa",
    "ES": "Southern Europe",
    "ET": "East Africa",
    "FI": "Nordic Countries",
    "FJ": "Oceania",
    "FK": "South America",
    "FM": "Oceania",
    "FO": "Scandinavia, Nordic Countries",
    "FR": "Western Europe",
    "GA": "Central Africa",
    "GB": "Western Europe",
    "GD": "Caribbean",
    "GE": "Western Asia",
    "GF": "South America",
    "GG": "Western Europe",
    "GH": "Western African",
    "GI": "Southern Europe",
    "GL": "North America",
    "GM": "Western Africa",
    "GN": "Western Africa",
    "GP": "Caribbean",
    "GQ": "Central Africa",
    "GR": "Southern Europe",
    "GS": "South America",
    "GT": "Central America",
    "GU": "Oceania",
    "GW": "Western Africa",
    "GY": "Caribbean",
    "HK": "East Asia",
    "HM": "Oceania",
    "HN": "Central America",
    "HR": "Balkans",
    "HT": "Caribbean",
    "HU": "Central Europe",
    "ID": "South-East Asia, Oceania",
    "IE": "Western Europe",
    "IL": "Western Asia, Middle East",
    "IM": "Western Europe",
    "IN": "Southern Asia",
    "IO": "Southern Asia",
    "IQ": "Western Asia, Middle East",
    "IR": "Western Asia, Middle East",
    "IS": "Scandinavia, Nordic Countries",
    "IT": "Southern Europe",
    "JE": "Western Europe",
    "JM": "Caribbean",
    "JO": "Western Asia, Middle East",
    "JP": "East Asia",
    "KE": "East Africa",
    "KG": "Central Asia",
    "KH": "South-East Asia",
    "KI": "Oceania",
    "KM": "East Africa",
    "KN": "Caribbean",
    "KP": "East Asia",
    "KR": "East Asia",
    "KW": "Western Asia, Middle East",
    "KY": "Caribbean",
    "KZ": "Central Asia",
    "LA": "South-East Asia",
    "LB": "Western Asia, Middle East",
    "LC": "Caribbean",
    "LI": "Western Europe",
    "LK": "Southern Asia",
    "LR": "Western Africa",
    "LS": "Southern Africa",
    "LT": "Baltic Countries",
    "LU": "Western Europe",
    "LV": "Baltic Countries",
    "LY": "Northern Africa",
    "MA": "Northern Africa",
    "MC": "Western Europe",
    "MD": "Central Europe",
    "ME": "Balkans",
    "MF": "Caribbean",
    "MG": "East Africa, Southern Africa",
    "MH": "Oceania",
    "MK": "Balkans",
    "ML": "Western Africa",
    "MM": "South-East Asia",
    "MN": "East Asia",
    "MO": "East Asia",
    "MP": "South-East Asia",
    "MQ": "Caribbean",
    "MR": "Western Africa",
    "MS": "Caribbean",
    "MT": "Southern Europe",
    "MU": "East Africa",
    "MV": "Southern Asia",
    "MW": "East Africa, Southern Africa",
    "MX": "North America",
    "MY": "South-East Asia",
    "MZ": "East Africa, Southern Africa",
    "NA": "Southern Africa",
    "NC": "Oceania",
    "NE": "Western Africa",
    "NF": "Oceania",
    "NG": "Western Africa",
    "NI": "Central America",
    "NL": "Western Europe, Nordic Countries",
    "NO": "Scandinavia, Nordic Countries",
    "NP": "Southern Asia",
    "NR": "Oceania",
    "NU": "Oceania",
    "NZ": "Oceania",
    "OM": "Western Asia, Middle East",
    "PA": "Central America",
    "PE": "South America",
    "PF": "Oceania",
    "PG": "Oceania",
    "PH": "South-East Asia",
    "PK": "Southern Asia",
    "PL": "Central Europe",
    "PM": "North America",
    "PN": "Oceania",
    "PR": "Caribbean",
    "PS": "Western Asia, Middle East",
    "PT": "Southern Europe",
    "PW": "Oceania",
    "PY": "South America",
    "QA": "Western Asia, Middle East",
    "RE": "East Africa",
    "RO": "Central Europe",
    "RS": "Balkans",
    "RU": "Eastern Europe",
    "RW": "East Africa, Central Africa",
    "SA": "Western Asia, Middle East",
    "SB": "Oceania",
    "SC": "East Africa",
    "SD": "Northern Africa, East Africa",
    "SE": "Scandinavia, Nordic Countries",
    "SG": "South-East Asia",
    "SH": "Western Africa",
    "SI": "Balkans",
    "SJ": "Scandinavia",
    "SK": "Central Europe",
    "SL": "Western Africa",
    "SM": "Southern Europe",
    "SN": "Western Africa",
    "SO": "East Africa",
    "SR": "South America",
    "SS": "East Africa, Northern Africa",
    "ST": "Central Africa",
    "SV": "Central America",
    "SX": "Caribbean",
    "SY": "Western Asia, Middle East",
    "SZ": "Southern Africa",
    "TC": "Caribbean",
    "TD": "Central Africa",
    "TF": "Oceania",
    "TG": "Western Africa",
    "TH": "South-East Asia",
    "TJ": "Central Asia",
    "TK": "Oceania",
    "TL": "South-East Asia",
    "TM": "Central Asia",
    "TN": "Northern Africa",
    "TO": "Oceania",
    "TR": "Western Asia, Middle East",
    "TT": "Caribbean",
    "TV": "Oceania",
    "TW": "East Asia",
    "TZ": "East Africa",
    "UA": "Central Europe",
    "UG": "East Africa",
    "UM": "Oceania",
    "US": "North America",
    "UY": "South America",
    "UZ": "Central Asia",
    "VA": "Southern Europe",
    "VC": "Caribbean",
    "VE": "South America",
    "VG": "Caribbean",
    "VI": "Caribbean",
    "VN": "South-East Asia",
    "VU": "Oceania",
    "WF": "Oceania",
    "WS": "Oceania",
    "XK": "Balkans",
    "YE": "Western Asia, Middle East",
    "YT": "East Africa",
    "ZA": "Southern Africa",
    "ZM": "East Africa, Southern Africa",
    "ZW": "East Africa, Southern Africa"
};
var $4e8cf5811b4c6397$var$countryToRegion = {
    "Afghanistan": "Southern and Central Asia",
    "Albania": "Southern Europe",
    "Algeria": "Northern Africa",
    "American Samoa": "Polynesia",
    "Andorra": "Southern Europe",
    "Angola": "Central Africa",
    "Anguilla": "Caribbean",
    "Antarctica": "Antarctica",
    "Antigua and Barbuda": "Caribbean",
    "Argentina": "South America",
    "Armenia": "Middle East",
    "Aruba": "Caribbean",
    "Australia": "Australia and New Zealand",
    "Austria": "Western Europe",
    "Azerbaijan": "Middle East",
    "Bahamas": "Caribbean",
    "Bahrain": "Middle East",
    "Bangladesh": "Southern and Central Asia",
    "Barbados": "Caribbean",
    "Belarus": "Eastern Europe",
    "Belgium": "Western Europe",
    "Belize": "Central America",
    "Benin": "Western Africa",
    "Bermuda": "North America",
    "Bhutan": "Southern and Central Asia",
    "Bolivia": "South America",
    "Bosnia and Herzegovina": "Southern Europe",
    "Botswana": "Southern Africa",
    "Bouvet Island": "Antarctica",
    "Brazil": "South America",
    "British Indian Ocean Territory": "Eastern Africa",
    "Brunei": "Southeast Asia",
    "Bulgaria": "Eastern Europe",
    "Burkina Faso": "Western Africa",
    "Burundi": "Eastern Africa",
    "Cambodia": "Southeast Asia",
    "Cameroon": "Central Africa",
    "Canada": "North America",
    "Cape Verde": "Western Africa",
    "Cayman Islands": "Caribbean",
    "Central African Republic": "Central Africa",
    "Chad": "Central Africa",
    "Chile": "South America",
    "China": "Eastern Asia",
    "Christmas Island": "Australia and New Zealand",
    "Cocos (Keeling) Islands": "Australia and New Zealand",
    "Colombia": "South America",
    "Comoros": "Eastern Africa",
    "Congo": "Central Africa",
    "Cook Islands": "Polynesia",
    "Costa Rica": "Central America",
    "Croatia": "Southern Europe",
    "Cuba": "Caribbean",
    "Cyprus": "Middle East",
    "Czech Republic": "Eastern Europe",
    "Denmark": "Nordic Countries",
    "Djibouti": "Eastern Africa",
    "Dominica": "Caribbean",
    "Dominican Republic": "Caribbean",
    "East Timor": "Southeast Asia",
    "Ecuador": "South America",
    "Egypt": "Northern Africa",
    "El Salvador": "Central America",
    "England": "Western Europe",
    "Equatorial Guinea": "Central Africa",
    "Eritrea": "Eastern Africa",
    "Estonia": "Baltic Countries",
    "Ethiopia": "Eastern Africa",
    "Falkland Islands": "South America",
    "Faroe Islands": "Nordic Countries",
    "Fiji Islands": "Melanesia",
    "Finland": "Nordic Countries",
    "France": "Western Europe",
    "French Guiana": "South America",
    "French Polynesia": "Polynesia",
    "French Southern territories": "Antarctica",
    "Gabon": "Central Africa",
    "Gambia": "Western Africa",
    "Georgia": "Middle East",
    "Germany": "Western Europe",
    "Ghana": "Western Africa",
    "Gibraltar": "Southern Europe",
    "Greece": "Southern Europe",
    "Greenland": "North America",
    "Grenada": "Caribbean",
    "Guadeloupe": "Caribbean",
    "Guam": "Micronesia",
    "Guatemala": "Central America",
    "Guinea": "Western Africa",
    "Guinea-Bissau": "Western Africa",
    "Guyana": "South America",
    "Haiti": "Caribbean",
    "Heard Island and McDonald Islands": "Antarctica",
    "Holy See (Vatican City State)": "Southern Europe",
    "Honduras": "Central America",
    "Hong Kong": "Eastern Asia",
    "Hungary": "Eastern Europe",
    "Iceland": "Nordic Countries",
    "India": "Southern and Central Asia",
    "Indonesia": "Southeast Asia",
    "Iran": "Southern and Central Asia",
    "Iraq": "Middle East",
    "Ireland": "British Isles",
    "Israel": "Middle East",
    "Italy": "Southern Europe",
    "Ivory Coast": "Western Africa",
    "Jamaica": "Caribbean",
    "Japan": "Eastern Asia",
    "Jordan": "Middle East",
    "Kazakhstan": "Southern and Central Asia",
    "Kenya": "Eastern Africa",
    "Kiribati": "Micronesia",
    "Kuwait": "Middle East",
    "Kyrgyzstan": "Southern and Central Asia",
    "Laos": "Southeast Asia",
    "Latvia": "Baltic Countries",
    "Lebanon": "Middle East",
    "Lesotho": "Southern Africa",
    "Liberia": "Western Africa",
    "Libyan Arab Jamahiriya": "Northern Africa",
    "Liechtenstein": "Western Europe",
    "Lithuania": "Baltic Countries",
    "Luxembourg": "Western Europe",
    "Macao": "Eastern Asia",
    "North Macedonia": "Southern Europe",
    "Madagascar": "Eastern Africa",
    "Malawi": "Eastern Africa",
    "Malaysia": "Southeast Asia",
    "Maldives": "Southern and Central Asia",
    "Mali": "Western Africa",
    "Malta": "Southern Europe",
    "Marshall Islands": "Micronesia",
    "Martinique": "Caribbean",
    "Mauritania": "Western Africa",
    "Mauritius": "Eastern Africa",
    "Mayotte": "Eastern Africa",
    "Mexico": "Central America",
    "Micronesia, Federated States of": "Micronesia",
    "Moldova": "Eastern Europe",
    "Monaco": "Western Europe",
    "Mongolia": "Eastern Asia",
    "Montserrat": "Caribbean",
    "Morocco": "Northern Africa",
    "Mozambique": "Eastern Africa",
    "Myanmar": "Southeast Asia",
    "Namibia": "Southern Africa",
    "Nauru": "Micronesia",
    "Nepal": "Southern and Central Asia",
    "Netherlands": "Western Europe",
    "Netherlands Antilles": "Caribbean",
    "New Caledonia": "Melanesia",
    "New Zealand": "Australia and New Zealand",
    "Nicaragua": "Central America",
    "Niger": "Western Africa",
    "Nigeria": "Western Africa",
    "Niue": "Polynesia",
    "Norfolk Island": "Australia and New Zealand",
    "North Korea": "Eastern Asia",
    "Northern Ireland": "Western Europe",
    "Northern Mariana Islands": "Micronesia",
    "Norway": "Nordic Countries",
    "Oman": "Middle East",
    "Pakistan": "Southern and Central Asia",
    "Palau": "Micronesia",
    "Palestine": "Middle East",
    "Panama": "Central America",
    "Papua New Guinea": "Melanesia",
    "Paraguay": "South America",
    "Peru": "South America",
    "Philippines": "Southeast Asia",
    "Pitcairn": "Polynesia",
    "Poland": "Eastern Europe",
    "Portugal": "Southern Europe",
    "Puerto Rico": "Caribbean",
    "Qatar": "Middle East",
    "Reunion": "Eastern Africa",
    "Romania": "Eastern Europe",
    "Russian Federation": "Eastern Europe",
    "Rwanda": "Eastern Africa",
    "Saint Helena": "Western Africa",
    "Saint Kitts and Nevis": "Caribbean",
    "Saint Lucia": "Caribbean",
    "Saint Pierre and Miquelon": "North America",
    "Saint Vincent and the Grenadines": "Caribbean",
    "Samoa": "Polynesia",
    "San Marino": "Southern Europe",
    "Sao Tome and Principe": "Central Africa",
    "Saudi Arabia": "Middle East",
    "Scotland": "Western Europe",
    "Senegal": "Western Africa",
    "Serbia": "Central and Southeast Europe",
    "Seychelles": "Eastern Africa",
    "Sierra Leone": "Western Africa",
    "Singapore": "Southeast Asia",
    "Slovakia": "Eastern Europe",
    "Slovenia": "Southern Europe",
    "Solomon Islands": "Melanesia",
    "Somalia": "Eastern Africa",
    "South Africa": "Southern Africa",
    "South Georgia and the South Sandwich Islands": "Antarctica",
    "South Korea": "Eastern Asia",
    "South Sudan": "Eastern Africa",
    "Spain": "Southern Europe",
    "Sri Lanka": "Southern Asia",
    "Sudan": "Northern Africa",
    "Suriname": "South America",
    "Svalbard and Jan Mayen": "Nordic Countries",
    "Swaziland": "Southern Africa",
    "Sweden": "Nordic Countries",
    "Switzerland": "Western Europe",
    "Syria": "Middle East",
    "Tajikistan": "Southern and Central Asia",
    "Tanzania": "Eastern Africa",
    "Thailand": "Southeast Asia",
    "The Democratic Republic of Congo": "Central Africa",
    "Togo": "Western Africa",
    "Tokelau": "Polynesia",
    "Tonga": "Polynesia",
    "Trinidad and Tobago": "Caribbean",
    "Tunisia": "Northern Africa",
    "Turkey": "Middle East",
    "Turkmenistan": "Southern and Central Asia",
    "Turks and Caicos Islands": "Caribbean",
    "Tuvalu": "Polynesia",
    "Uganda": "Eastern Africa",
    "Ukraine": "Eastern Europe",
    "United Arab Emirates": "Middle East",
    //"United Kingdom": "British Isles",
    "United Kingdom": "Western Europe",
    "United States": "North America",
    "United States Minor Outlying Islands": "Micronesia/Caribbean",
    "Uruguay": "South America",
    "Uzbekistan": "Southern and Central Asia",
    "Vanuatu": "Melanesia",
    "Venezuela": "South America",
    "Vietnam": "Southeast Asia",
    "Virgin Islands, British": null,
    "Virgin Islands, U.S.": null,
    "Wales": "Western Europe",
    "Wallis and Futuna": "Polynesia",
    "Western Sahara": "Northern Africa",
    "Yemen": "Middle East",
    "Zambia": "Eastern Africa",
    "Zimbabwe": "Eastern Africa"
};
const $4e8cf5811b4c6397$export$dae06f7b53496f9e = {
    'Afghanistan': 'AF',
    'Aland Islands': 'AX',
    'Albania': 'AL',
    'Algeria': 'DZ',
    'American Samoa': 'AS',
    'Andorra': 'AD',
    'Angola': 'AO',
    'Anguilla': 'AI',
    'Antarctica': 'AQ',
    'Antigua And Barbuda': 'AG',
    'Argentina': 'AR',
    'Armenia': 'AM',
    'Aruba': 'AW',
    'Australia': 'AU',
    'Austria': 'AT',
    'Azerbaijan': 'AZ',
    'Bahamas': 'BS',
    'Bahrain': 'BH',
    'Bangladesh': 'BD',
    'Barbados': 'BB',
    'Belarus': 'BY',
    'Belgium': 'BE',
    'Belize': 'BZ',
    'Benin': 'BJ',
    'Bermuda': 'BM',
    'Bhutan': 'BT',
    'Bolivia': 'BO',
    'Bosnia And Herzegovina': 'BA',
    'Bosnia and Herzegovina': 'BA',
    'Botswana': 'BW',
    'Bouvet Island': 'BV',
    'Brazil': 'BR',
    'British Indian Ocean Territory': 'IO',
    'Brunei Darussalam': 'BN',
    'Bulgaria': 'BG',
    'Burkina Faso': 'BF',
    'Burundi': 'BI',
    'Cambodia': 'KH',
    'Cameroon': 'CM',
    'Canada': 'CA',
    'Cape Verde': 'CV',
    'Cayman Islands': 'KY',
    'Central African Republic': 'CF',
    'Chad': 'TD',
    'Chile': 'CL',
    'China': 'CN',
    'Christmas Island': 'CX',
    'Cocos (Keeling) Islands': 'CC',
    'Colombia': 'CO',
    'Comoros': 'KM',
    'Congo': 'CG',
    'Congo Kinshasa': 'CD',
    'Cook Islands': 'CK',
    'Costa Rica': 'CR',
    'Cote D\'Ivoire': 'CI',
    'Ivory Coast': 'CI',
    'Croatia': 'HR',
    'Cuba': 'CU',
    'Cyprus': 'CY',
    'Czech Republic': 'CZ',
    'Denmark': 'DK',
    'Djibouti': 'DJ',
    'Dominica': 'DM',
    'Dominican Republic': 'DO',
    'Ecuador': 'EC',
    'Egypt': 'EG',
    'El Salvador': 'SV',
    'El salvador': 'SV',
    'Equatorial Guinea': 'GQ',
    'Eritrea': 'ER',
    'Estonia': 'EE',
    'Ethiopia': 'ET',
    'Falkland Islands (Malvinas)': 'FK',
    'Faroe Islands': 'FO',
    'Fiji': 'FJ',
    'Finland': 'FI',
    'France': 'FR',
    'French Guiana': 'GF',
    'French Polynesia': 'PF',
    'French Southern Territories': 'TF',
    'Gabon': 'GA',
    'Gambia': 'GM',
    'Georgia': 'GE',
    'Germany': 'DE',
    'Ghana': 'GH',
    'Gibraltar': 'GI',
    'Greece': 'GR',
    'Greenland': 'GL',
    'Grenada': 'GD',
    'Guadeloupe': 'GP',
    'Guam': 'GU',
    'Guatemala': 'GT',
    'Guernsey': 'GG',
    'Guinea': 'GN',
    'Guinea-Bissau': 'GW',
    'Guyana': 'GY',
    'Haiti': 'HT',
    'Heard Island & Mcdonald Islands': 'HM',
    'Holy See (Vatican City State)': 'VA',
    'Honduras': 'HN',
    'Hong Kong': 'HK',
    'Hungary': 'HU',
    'Iceland': 'IS',
    'India': 'IN',
    'Indonesia': 'ID',
    'Iran, Islamic Republic Of': 'IR',
    'Iran': 'IR',
    'Iraq': 'IQ',
    'Ireland': 'IE',
    'Isle Of Man': 'IM',
    'Israel': 'IL',
    'Italy': 'IT',
    'Jamaica': 'JM',
    'Japan': 'JP',
    'Jersey': 'JE',
    'Jordan': 'JO',
    'Kazakhstan': 'KZ',
    'Kenya': 'KE',
    'Kiribati': 'KI',
    'South Korea': 'KR',
    'Kuwait': 'KW',
    'Kyrgyzstan': 'KG',
    'Lao People\'s Democratic Republic': 'LA',
    'Latvia': 'LV',
    'Lebanon': 'LB',
    'Lesotho': 'LS',
    'Liberia': 'LR',
    'Libyan Arab Jamahiriya': 'LY',
    'Libya': 'LY',
    'Liechtenstein': 'LI',
    'Lithuania': 'LT',
    'Luxembourg': 'LU',
    'Macao': 'MO',
    'Macedonia': 'MK',
    'Madagascar': 'MG',
    'Malawi': 'MW',
    'Malaysia': 'MY',
    'Maldives': 'MV',
    'Mali': 'ML',
    'Malta': 'MT',
    'Marshall Islands': 'MH',
    'Martinique': 'MQ',
    'Mauritania': 'MR',
    'Mauritius': 'MU',
    'Mayotte': 'YT',
    'Mexico': 'MX',
    'Micronesia, Federated States Of': 'FM',
    'Moldova': 'MD',
    'Moldovia': 'MD',
    'Monaco': 'MC',
    'Mongolia': 'MN',
    'Montenegro': 'ME',
    'Montserrat': 'MS',
    'Morocco': 'MA',
    'Mozambique': 'MZ',
    'Myanmar': 'MM',
    'Namibia': 'NA',
    'Nauru': 'NR',
    'Nepal': 'NP',
    'Netherlands': 'NL',
    'Netherlands Antilles': 'AN',
    'New Caledonia': 'NC',
    'New Zealand': 'NZ',
    'Nicaragua': 'NI',
    'Niger': 'NE',
    'Nigeria': 'NG',
    'Niue': 'NU',
    'Norfolk Island': 'NF',
    'Northern Mariana Islands': 'MP',
    'Norway': 'NO',
    'Oman': 'OM',
    'Pakistan': 'PK',
    'Palau': 'PW',
    'Palestinian Territory, Occupied': 'PS',
    'Palestine': 'PS',
    'Panama': 'PA',
    'Papua New Guinea': 'PG',
    'Paraguay': 'PY',
    'Peru': 'PE',
    'Philippines': 'PH',
    'Pitcairn': 'PN',
    'Poland': 'PL',
    'Portugal': 'PT',
    'Puerto Rico': 'PR',
    'Qatar': 'QA',
    'Reunion': 'RE',
    'Romania': 'RO',
    'Russian Federation': 'RU',
    'Russia': 'RU',
    'Rwanda': 'RW',
    'Saint Barthelemy': 'BL',
    'Saint Helena': 'SH',
    'Saint Kitts And Nevis': 'KN',
    'Saint Lucia': 'LC',
    'Saint Martin': 'MF',
    'Saint Pierre And Miquelon': 'PM',
    'Saint Vincent And Grenadines': 'VC',
    'Samoa': 'WS',
    'San Marino': 'SM',
    'Sao Tome And Principe': 'ST',
    'Saudi Arabia': 'SA',
    'Senegal': 'SN',
    'Serbia': 'RS',
    'Seychelles': 'SC',
    'Sierra Leone': 'SL',
    'Singapore': 'SG',
    'Slovakia': 'SK',
    'Slovenia': 'SI',
    'Solomon Islands': 'SB',
    'Somalia': 'SO',
    'South Africa': 'ZA',
    'South Georgia And Sandwich Isl.': 'GS',
    'Spain': 'ES',
    'Sri Lanka': 'LK',
    'Sudan': 'SD',
    'Suriname': 'SR',
    'Svalbard And Jan Mayen': 'SJ',
    'Swaziland': 'SZ',
    'Sweden': 'SE',
    'Switzerland': 'CH',
    'Syrian Arab Republic': 'SY',
    'syria': 'SY',
    'Taiwan': 'TW',
    'Tajikistan': 'TJ',
    'Tanzania': 'TZ',
    'Thailand': 'TH',
    'Timor-Leste': 'TL',
    'Togo': 'TG',
    'Tokelau': 'TK',
    'Tonga': 'TO',
    'Trinidad and Tobago': 'TT',
    'Tunisia': 'TN',
    'Turkey': 'TR',
    'Turkmenistan': 'TM',
    'Turks And Caicos Islands': 'TC',
    'Tuvalu': 'TV',
    'Uganda': 'UG',
    'Ukraine': 'UA',
    'United Arab Emirates': 'AE',
    'United Kingdom': 'GB',
    'United States': 'US',
    'United States Outlying Islands': 'UM',
    'Uruguay': 'UY',
    'Uzbekistan': 'UZ',
    'Vanuatu': 'VU',
    'Venezuela': 'VE',
    'Viet Nam': 'VN',
    'Vietnam': 'VN',
    'Virgin Islands, British': 'VG',
    'Virgin Islands, U.S.': 'VI',
    'Wallis And Futuna': 'WF',
    'Western Sahara': 'EH',
    'Yemen': 'YE',
    'Zambia': 'ZM',
    'Zimbabwe': 'ZW'
};

});
parcelRegister("lU8CH", function(module, exports) {

$parcel$export(module.exports, "LevensteinDistance", () => $ff25845496767323$export$9cd5f0339d52787a);
$parcel$export(module.exports, "svgRepo", () => $ff25845496767323$export$5d6e8c5ccae163d6);
$parcel$export(module.exports, "isNumeric", () => $ff25845496767323$export$e90fb89750dba83f);
$parcel$export(module.exports, "RemoveReservedIfNeeded", () => $ff25845496767323$export$9854dd1046e1f895);
$parcel$export(module.exports, "WordShorthand", () => $ff25845496767323$export$c6fd0dd17afdf812);
const $ff25845496767323$export$9cd5f0339d52787a = function(a, b) {
    if (a.length == 0) return b.length;
    if (b.length == 0) return a.length;
    var matrix = [];
    // increment along the first column of each row
    var i;
    for(i = 0; i <= b.length; i++)matrix[i] = [
        i
    ];
    // increment each column in the first row
    var j;
    for(j = 0; j <= a.length; j++)matrix[0][j] = j;
    // Fill in the rest of the matrix
    for(i = 1; i <= b.length; i++){
        for(j = 1; j <= a.length; j++)if (b.charAt(i - 1) == a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
        else matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1)); // deletion
    }
    return matrix[b.length][a.length];
};
var $ff25845496767323$var$filecolor = "#1be5c7";
const $ff25845496767323$export$5d6e8c5ccae163d6 = {
    "ball": `<div class=loader2><svg viewBox="0 0 866 866"xmlns=http://www.w3.org/2000/svg><svg viewBox="0 0 164.83 151.5"xmlns=http://www.w3.org/2000/svg data-name="Layer 1"id=Layer_1><path class=path-0 d=M117.24,69.24A8,8,0,0,0,115.67,67c-4.88-4-9.8-7.89-14.86-11.62A4.93,4.93,0,0,0,96.93,55c-5.76,1.89-11.4,4.17-17.18,6a4.36,4.36,0,0,0-3.42,4.12c-1,6.89-2.1,13.76-3,20.66a4,4,0,0,0,1,3.07c5.12,4.36,10.39,8.61,15.68,12.76a3.62,3.62,0,0,0,2.92.75c6.29-2.66,12.52-5.47,18.71-8.36a3.49,3.49,0,0,0,1.68-2.19c1.34-7.25,2.54-14.55,3.9-22.58Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=path-1 d=M97.55,38.68A43.76,43.76,0,0,1,98,33.44c.41-2.36-.5-3.57-2.57-4.64C91.1,26.59,87,24,82.66,21.82a6.18,6.18,0,0,0-4-.71C73.45,22.55,68.32,24.25,63.22,26c-3.63,1.21-6.08,3.35-5.76,7.69a26.67,26.67,0,0,1-.6,4.92c-1.08,8.06-1.08,8.08,5.86,11.92,3.95,2.19,7.82,5.75,11.94,6.08s8.76-2.41,13.12-3.93c9.33-3.29,9.33-3.3,9.78-14Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=path-2 d=M66.11,126.56c5.91-.91,11.37-1.7,16.81-2.71a3.3,3.3,0,0,0,1.87-2.17c1-4.06,1.73-8.19,2.84-12.24.54-2-.11-3-1.55-4.15-5-4-9.9-8.12-15-12a6.19,6.19,0,0,0-4.15-1.1c-5.35.66-10.7,1.54-16,2.54A4,4,0,0,0,48.34,97a109.13,109.13,0,0,0-3,12.19,4.47,4.47,0,0,0,1.34,3.6c5.54,4.36,11.23,8.53,16.91,12.69a10.84,10.84,0,0,0,2.57,1.11Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=path-3 d=M127.42,104.12c4.1-2.1,8-3.93,11.72-6a6,6,0,0,0,2.27-3,58.22,58.22,0,0,0,3.18-29.92c-.26-1.7-8-7.28-9.71-6.85A5,5,0,0,0,133,59.65c-2.81,2.49-5.71,4.88-8.33,7.56a9.46,9.46,0,0,0-2.47,4.4c-1.29,6.49-2.38,13-3.35,19.55a5.73,5.73,0,0,0,.83,3.91c2.31,3.08,5,5.88,7.7,9Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=path-4 d=M52.58,29.89c-2.15-.36-3.78-.54-5.39-.9-2.83-.64-4.92.1-7,2.32A64.1,64.1,0,0,0,26.09,54.64c-2.64,7.92-2.62,7.84,5.15,10.87,1.76.69,2.73.45,3.93-1C39.79,59,44.54,53.65,49.22,48.2a4.2,4.2,0,0,0,1.13-2c.8-5.32,1.49-10.68,2.24-16.34Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=path-5 d=M23,68.13c0,2.51,0,4.7,0,6.87a60.49,60.49,0,0,0,9.75,32.15c1.37,2.13,6.4,3,7,1.2,1.55-5,2.68-10.2,3.82-15.34.13-.58-.58-1.38-.94-2.06-2.51-4.77-5.47-9.38-7.45-14.37C32.94,71,28.22,69.84,23,68.13Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=path-6 d=M83.91,12.86c-.32.36-.66.71-1,1.07.9,1.13,1.57,2.62,2.73,3.33,4.71,2.84,9.56,5.48,14.39,8.1a9.29,9.29,0,0,0,3.13.83c5.45.69,10.89,1.38,16.35,1.94a10.41,10.41,0,0,0,3.07-.71c-11.48-9.9-24.26-14.61-38.71-14.56Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=path-7 d=M66.28,132.51c13.36,3.78,25.62,3.5,38-.9C91.68,129.59,79.36,128,66.28,132.51Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=path-8 d=M127.2,30.66l-1.27.37a18.58,18.58,0,0,0,1,3.08c3,5.52,6.21,10.89,8.89,16.54,1.34,2.83,3.41,3.82,6.49,4.9a60.38,60.38,0,0,0-15.12-24.9Z fill=` + $ff25845496767323$var$filecolor + ` /><path class=bb-9 d=M117.35,125c5.58-2.32,16.9-13.84,18.1-19.2-2.41,1.46-5.18,2.36-6.78,4.23-4.21,5-7.89,10.37-11.32,15Z fill=` + $ff25845496767323$var$filecolor + ` /></svg></svg></div>`
};
const $ff25845496767323$export$e90fb89750dba83f = (str)=>{
    if (typeof str != "string") return false // we only process strings!
    ;
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    ;
};
const $ff25845496767323$export$9854dd1046e1f895 = (string)=>{
    if (string && !AppInstance.getConfig().enabledFeatures.showCompleteLeagueNames) {
        var regex = new RegExp(AppInstance.getConfig().reservedWords.join("|"), "g");
        string = string.replace(regex, "");
    }
    return string;
};
const $ff25845496767323$export$c6fd0dd17afdf812 = (string)=>{
    if (!string) return string;
    string = string.replace(/ +(?= )/g, '');
    //if word is longer than 15 characters and containing more than 3 words split it and return first 3 words
    var split = string.split(" ");
    var newword = "";
    if (split.length > 2) {
        for(var i = 0; i < split.length; i++){
            if (i == 0) newword += split[i] + " ";
            else if (split[i].length == 1) {
                if (split[i + 1]) newword += "-" + split[i] + "-";
                else newword += "-" + split[i];
            } else {
                console.log(split, i);
                newword += split[i][0].toUpperCase();
            }
        }
        return newword;
    } else return string;
};

});


parcelRegister("9yWe2", function(module, exports) {

$parcel$export(module.exports, "MatchUtil", () => $6f647469270c68ea$export$f6ea5520092f1c56);

var $5er4g = parcelRequire("5er4g");

var $02mnx = parcelRequire("02mnx");
const $6f647469270c68ea$export$f6ea5520092f1c56 = {
    //TODO: optimize code below. its used frequently in scrolling lists.
    getLocalizedScoreTime: function(mi) {
        var s;
        var foundProperTime = false;
        // console.log(mi,mi.scoretime)
        if (!$6f647469270c68ea$export$f6ea5520092f1c56.isValidScore(mi)) {
            //console.log("no valid")
            s = $6f647469270c68ea$export$f6ea5520092f1c56.getLocalizedTime(mi.time, mi.date);
            foundProperTime = true;
        } else if (AppInstance.getConfig().isRTL) {
            var Sparts = mi.scoretime.split("-");
            s = "\u200E" + parts[1] + " - " + parts[0]; //tag needed to prevent reversing string to RTL @see http://stackoverflow.com/questions/27910465/how-to-prevent-automatic-right-to-left-text-direction-for-hebrew-and-arabic
        } else s = mi.scoretime;
        return s;
    },
    getLocalScore: function(mi, complyRTL) {
        // console.log(mi,mi.scoretime)
        if (!$6f647469270c68ea$export$f6ea5520092f1c56.isValidScore(mi)) return null;
        else {
            var parts1 = mi.scoretime.split("-");
            if (complyRTL && AppInstance.getConfig().isRTL) return parts1[1];
            else return parts1[0];
        }
    },
    getAwayScore: function(mi, complyRTL) {
        // console.log(mi,mi.scoretime)
        if (!$6f647469270c68ea$export$f6ea5520092f1c56.isValidScore(mi)) return null;
        else {
            var parts1 = mi.scoretime.split("-");
            if (complyRTL && AppInstance.getConfig().isRTL) return parts1[0];
            else return parts1[1];
        }
    },
    getLocalAggregateScore: function(mi, complyRTL) {
        if (!$6f647469270c68ea$export$f6ea5520092f1c56.hasAggregatedScore(mi)) return null;
        else {
            var parts1 = mi.aggregateScore.split("-");
            if (complyRTL && AppInstance.getConfig().isRTL) return parts1[1].trim();
            else return parts1[0].trim();
        }
    },
    getAwayAggregateScore: function(mi, complyRTL) {
        if (!$6f647469270c68ea$export$f6ea5520092f1c56.hasAggregatedScore(mi)) return null;
        else {
            var parts1 = mi.aggregateScore.split("-");
            if (complyRTL && AppInstance.getConfig().isRTL) return parts1[0].trim();
            else return parts1[1].trim();
        }
    },
    /**
     * get the day
     * @param mi
     */ getLocalizedDayTimecode (mi) {
        return new Date(Date.UTC(mi.date[6] + "" + mi.date[7] + "" + mi.date[8] + "" + mi.date[9], parseInt(mi.date[3] + "" + mi.date[4]) - 1, mi.date[0] + "" + mi.date[1], 0, 0, 0, 0)).getTime();
    },
    getLocalizedDayNoUTCTimecode (mi) {
        return new Date(mi.date[6] + "" + mi.date[7] + "" + mi.date[8] + "" + mi.date[9], parseInt(mi.date[3] + "" + mi.date[4]) - 1, mi.date[0] + "" + mi.date[1], 0, 0, 0, 0).getTime();
    },
    getLocalizedTimecode (mi) {
        if (!mi.time) return new Date(Date.UTC(mi.date[6] + "" + mi.date[7] + "" + mi.date[8] + "" + mi.date[9], parseInt(mi.date[3] + "" + mi.date[4]) - 1, mi.date[0] + "" + mi.date[1], 0, 0, 0, 0)).getTime();
        else return new Date(Date.UTC(mi.date[6] + "" + mi.date[7] + "" + mi.date[8] + "" + mi.date[9], parseInt(mi.date[3] + "" + mi.date[4]) - 1, mi.date[0] + "" + mi.date[1], mi.time[0] + "" + mi.time[1], mi.time[3] + "" + mi.time[4], 0, 0)).getTime();
    },
    getTimecode: function(mi) {
        if (!mi.time) {
            if (!this.tempDateTime2) this.tempDateTime2 = new (0, $5er4g.DateTimecode)();
            var split = mi.date.split("/");
            //this.tempDateTime.clear()
            this.tempDateTime2.setYear(split[2]);
            this.tempDateTime2.setMonth(split[1] - 1);
            this.tempDateTime2.setDate(split[0]);
            //this.tempDateTime.setTime(mi.date+":00:00:00:00");
            return this.tempDateTime2.getTimecode();
        } else {
            if (!this.tempDateTime) this.tempDateTime = new (0, $5er4g.DateTimecode)();
            this.tempDateTime.setTime(mi.date.replaceAll(".", "/") + ":" + mi.time + ":00:00");
            return this.tempDateTime.getTimecode();
        }
    },
    getLocalizedDate: function(mi, long, alternateFormat) {
        if (!/^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(mi.time)) mi.time = "00:00"; //hack for IOS
        if (!mi.time) {
            if (!this.tempDateTime2) this.tempDateTime2 = new (0, $5er4g.DateTimecode)();
            var split = mi.date.split("/");
            //this.tempDateTime.clear()
            this.tempDateTime2.setYear(split[2]);
            this.tempDateTime2.setMonth(split[1]);
            this.tempDateTime2.setDate(split[0]);
            //this.tempDateTime.setTime(mi.date+":00:00:00:00");
            if (!long) {
                if (alternateFormat) return this.tempDateTime2.toLocaleDateStringAlt2();
                return this.tempDateTime2.toLocaleDateString();
            }
            return this.tempDateTime2.toLocaleDateStringLong();
        } else {
            if (!this.tempDateTime) this.tempDateTime = new (0, $5er4g.DateTimecode)();
            this.tempDateTime.setTime(mi.date.replaceAll(".", "/") + ":" + mi.time + ":00:00");
            if (!long) {
                if (alternateFormat) return this.tempDateTime.toLocaleDateStringAlt2();
                return this.tempDateTime.toLocaleDateString();
            }
            return this.tempDateTime.toLocaleDateStringLong();
        }
    },
    localizedTimeDateFormat: null,
    tempDateTime: null,
    getLocalizedTime: function(time, date) {
        if (!this.tempDateTime) this.tempDateTime = new (0, $5er4g.DateTimecode)();
        if (!time) return "-";
        this.tempDateTime.setTime(date + ":" + time + ":00:00");
        return this.tempDateTime.toLocaleTimeString();
    },
    getLocalizedAggregateScore: function(mi, clean) {
        if (mi.aggregateWinner == 1) {
            var split = mi.aggregateScore.replaceAll(" ", "").split("-");
            if (FootballManiaConfig.isRtl) return "(" + split[1] + "-<p style='display:inline' class='greentext'>" + split[0] + "</p>)";
            return "(<p style='display:inline' class='greentext'>" + split[0] + "</p>-" + split[1] + ")";
        } else if (mi.aggregateWinner == 2) {
            var split = mi.aggregateScore.replaceAll(" ", "").split("-");
            if (FootballManiaConfig.isRtl) return "(<p style='display:inline' class='greentext'>" + split[1] + "</p>-" + split[0] + ")";
            return "(" + split[0] + "-<p style='display:inline' class='greentext'>" + split[1] + "</p>)";
        } else {
            if (FootballManiaConfig.isRtl) mi.aggregateScore.split("").reverse().join("");
            return "(" + mi.aggregateScore.replaceAll(" ", "") + ")";
        }
    },
    getFullStatus: function(mi) {
        // mi.inj_minute = "5";
        // mi.status = "90";
        //console.log("get full status",mi.status);
        if (mi.status == null || mi.status == "") return "";
        else if (mi.status == "FT") return (0, $02mnx.Localizer).getString("finaltime");
        else if (!isNaN(mi.status)) {
            if ((mi.status == "45" || mi.status == "90") && mi.injuryminute) return mi.status + "' <z style=''>+" + mi.injuryminute + "</z>";
            else if (mi.status == "45" && mi.addedTime_period1) return mi.status + "' <z style=''>+" + mi.addedTime_period1 + "</z>";
            else if (mi.status == "90" && mi.addedTime_period2) return mi.status + "' +" + mi.addedTime_period2 + "";
            else return mi.status + "'";
        } else if (mi.status == "HT") return (0, $02mnx.Localizer).getString("halftime");
        else if (mi.status == "P") {
            //console.log("----------> status mi",mi.status)
            if (mi.penaltyLocalTeam != null && mi.penaltyVisitorTeam != null) return "pen " + mi.penaltyLocalTeam + " - " + mi.penaltyVisitorTeam;
            return "p.";
        } else if (mi.status == "Pen.") {
            //console.log("----------2> status mi",mi.status,mi)
            if (mi.penaltyLocalTeam != null && mi.penaltyVisitorTeam != null) return "pen " + mi.penaltyLocalTeam + " - " + mi.penaltyVisitorTeam;
            return "p.";
        } else if (mi.status == "Postp.") return (0, $02mnx.Localizer).getString("postponed");
        else if (mi.status == "Aban.") return (0, $02mnx.Localizer).getString("abandoned");
        else if (mi.status == "Int.") return (0, $02mnx.Localizer).getString("interrupted");
        else if (mi.status == "AET") return (0, $02mnx.Localizer).getString("after_extra_time");
        else if (mi.status == "Cancl.") return (0, $02mnx.Localizer).getString("cancelled");
        else if (mi.status == "TBA") return (0, $02mnx.Localizer).getString("to_be_announced");
        else if (mi.status == "Break") return (0, $02mnx.Localizer).getString("pause");
        else if (mi.status == "Susp.") return (0, $02mnx.Localizer).getString("suspended");
        return "";
    },
    getShortStatus: function(mi) {
        // mi.inj_minute = "15";
        // mi.status = "90";
        // console.log("get short status ",mi.status);
        if (mi.status == null || mi.status == "") return "X";
        if (!isNaN(mi.status)) {
            if ((mi.status == "45" || mi.status == "90") && mi.injuryminute) return mi.status + "' <z style='font-size:9px;'>+" + mi.injuryminute + "</z>";
            else if (mi.status == "45" && mi.addedTime_period1) return mi.status + "' <z style='font-size:9px;'>+" + mi.addedTime_period1 + "</z>";
            else if (mi.status == "90" && mi.addedTime_period2) return mi.status + "' <z style='font-size:9px;'>+" + mi.addedTime_period2 + "</z>";
            else return mi.status + "'";
        } else if (mi.status == "FT") return (0, $02mnx.Localizer).getString("finaltime_short");
        else if (mi.status == "HT") return (0, $02mnx.Localizer).getString("halftime_short");
        else if (mi.status == "Pen.") return (0, $02mnx.Localizer).getString("penalty_short");
        else if (mi.status == "P") return (0, $02mnx.Localizer).getString("penalty_short");
        else if (mi.status == "Postp.") return (0, $02mnx.Localizer).getString("postponed_short");
        else if (mi.status == "Aban.") return (0, $02mnx.Localizer).getString("abandoned_short");
        else if (mi.status == "Int.") return (0, $02mnx.Localizer).getString("interrupted_short");
        else if (mi.status == "AET") return (0, $02mnx.Localizer).getString("after_extra_time_short");
        else if (mi.status == "Cancl.") return (0, $02mnx.Localizer).getString("cancelled_short");
        else if (mi.status == "TBA") return (0, $02mnx.Localizer).getString("to_be_announced_short");
        else if (mi.status == "Break") return (0, $02mnx.Localizer).getString("pause");
        else if (mi.status == "Susp.") return (0, $02mnx.Localizer).getString("suspended_short");
        return "";
    },
    isFinished: function(mi) {
        return mi.status != null && mi.status == "FT" || mi.status == "AET" || mi.status == "Pen." || mi.status == "Aban.";
    },
    isValidScore: function(mi) {
        return null != mi.scoretime.replaceAll(" ", "").match("([0-9]+)-([0-9]+)");
    },
    isPlaying: function(mi) {
        return mi.status != null && (!isNaN(mi.status) || mi.status == "HT" || mi.status == "P") || mi.status == "Break";
    },
    isHalftime: function(mi) {
        return mi.status != null && mi.status == "HT";
    },
    isLivePenalty: function(mi) {
        return mi.status != null && mi.status == "P";
    },
    getLocalizedPenalty: function(mi) {
        if (mi.penaltyLocalTeam != null && mi.penaltyVisitorTeam != null) {
            if (FootballManiaConfig.isRtl) return mi.penaltyVisitorTeam + " - " + mi.penaltyLocalTeam;
            return mi.penaltyLocalTeam + " - " + mi.penaltyVisitorTeam;
        } else return " - ";
    },
    isPenalty: function(mi) {
        return mi.status != null && mi.status == "Pen.";
    },
    isPostponed: function(mi) {
        return mi.status != null && mi.status == "Postp.";
    },
    isAbandoned: function(mi) {
        return mi.status != null && mi.status == "Aban.";
    },
    isCancelled: function(mi) {
        return mi.status != null && mi.status == "Cancl.";
    },
    isInterrupted: function(mi) {
        return mi.status != null && mi.status == "Int.";
    },
    isSuspended: function(mi) {
        return mi.status != null && mi.status == "Susp.";
    },
    isToBeAnnounced: function(mi) {
        return Boolean.valueOf(mi.status != null && mi.status == "TBA");
    },
    hasAggregatedScore: function(mi) {
        if (mi.aggregateScore) return true;
        return false;
    },
    hasPenaltyScore: function(mi) {
        return mi.penaltyLocalTeam != null && mi.penaltyVisitorTeam != null;
    },
    isInteger: function(s) {
        try {
            Integer.parseInt(s);
            return true;
        } catch (e) {
            return false;
        }
    }
};

});

parcelRegister("gQQqD", function(module, exports) {

$parcel$export(module.exports, "Processors", () => $c44a2be76dfc6905$export$4e867c0b523724b8);

var $6K7Df = parcelRequire("6K7Df");

var $02mnx = parcelRequire("02mnx");

var $9yWe2 = parcelRequire("9yWe2");
const $c44a2be76dfc6905$export$4e867c0b523724b8 = {
    prepareTodayFeedData: function(options) {
        // Destructure options once at the top
        const { translations: translations, defaultTranslations: defaultTranslations, responseData: countries, fixedRegions: fixedRegions, fixedLeagueOrder: fixedLeagueOrder, favoriteTeams: favoriteTeams, favoriteLeagues: favoriteLeagues, hiddenTitles: hiddenTitles, locale: locale, enabledFeatures: enabledFeatures, userRegionLocale: userRegionLocale, showOnlyFavorites: showOnlyFavorites, subscribedTeams: subscribedTeams, subscribedLeagues: subscribedLeagues, subscribedMatches: subscribedMatches, fontSize: fontSize, userCountry: userCountry, listType: listType } = options;
        // Set up localization
        (0, $02mnx.Localizer).LocalizedTranslations = translations;
        (0, $02mnx.Localizer).DefaultTranslations = defaultTranslations;
        // Constants
        const MATCH_HEIGHT_LARGE = 60;
        const MATCH_HEIGHT_TYPE3 = 70;
        const MATCH_HEIGHT_DEFAULT = 55;
        const HEADER_HEIGHT = 45;
        const MATCH_TYPE = 1;
        const HEADER_TYPE = 2;
        // Determine item height in one expression
        const itemHeight = listType === "3" ? MATCH_HEIGHT_TYPE3 : fontSize === "xlarge" || fontSize === "large" ? MATCH_HEIGHT_LARGE : MATCH_HEIGHT_DEFAULT;
        // Pre-process fixed regions
        const foundFixedRegions = fixedLeagueOrder[userRegionLocale] || {};
        const foundFixedLeagues = foundFixedRegions.leagues || [];
        const foundFixedCountries = foundFixedRegions.countries || [];
        // Use Map for O(1) lookups instead of arrays with indexOf
        const favoriteTeamsMap = new Map(Object.entries(favoriteTeams));
        const favoriteLeaguesMap = new Map(Object.entries(favoriteLeagues));
        const subscribedTeamsSet = new Set(subscribedTeams);
        const subscribedLeaguesSet = new Set(subscribedLeagues);
        const subscribedMatchesSet = new Set(subscribedMatches);
        const hiddenTitlesSet = new Set(hiddenTitles);
        // Process data in a single pass
        const listData = [];
        let headerId = 0;
        for (const country of countries){
            const localizedCountry = (0, $6K7Df.CountryUtil).getLocalizedCountryByName(country.country, locale);
            const fixedCountryIndex = foundFixedCountries.indexOf(country.country);
            let foundFixedIndex = 1;
            for (const league of country.leagues){
                headerId++;
                const leagueKey = league.key;
                const isLeagueSubscribed = subscribedLeaguesSet.has(leagueKey);
                const fixedLeagueIndex = foundFixedLeagues.indexOf(leagueKey);
                const isFixedToTop = fixedLeagueIndex !== -1 || fixedCountryIndex !== -1;
                const fixedIndex = fixedLeagueIndex !== -1 ? fixedLeagueIndex : fixedCountryIndex !== -1 ? foundFixedIndex + 200 : null;
                if (isFixedToTop) foundFixedIndex++;
                for (const match of league.matches){
                    const localTeamId = match.gs_localteamid;
                    const visitorTeamId = match.gs_visitorteamid;
                    const matchId = String(match.id);
                    // Build match object
                    const matchData = {
                        ...match,
                        title: `${match.localteam} - ${match.visitorteam}`,
                        type: MATCH_TYPE,
                        country: country.country,
                        localizedCountry: localizedCountry,
                        league: league.league,
                        headerId: headerId,
                        style: {
                            height: itemHeight
                        },
                        leagueKey: leagueKey
                    };
                    // Fixed index handling
                    if (isFixedToTop) {
                        matchData.foundFixedIndex = fixedIndex;
                        matchData.fixedIndex = true;
                    }
                    // Favorite and subscription flags
                    const favLocal = favoriteTeamsMap.get(localTeamId);
                    const favVisitor = favoriteTeamsMap.get(visitorTeamId);
                    const favLeague = favoriteLeaguesMap.get(leagueKey);
                    matchData.isFavouritedByTeam = !!(favLocal || favVisitor);
                    matchData.favoriteTeamIndex = (favLocal === null || favLocal === void 0 ? void 0 : favLocal.index) || (favVisitor === null || favVisitor === void 0 ? void 0 : favVisitor.index) || null;
                    matchData.isFavouritedByLeague = !!favLeague;
                    matchData.favoriteLeagueIndex = (favLeague === null || favLeague === void 0 ? void 0 : favLeague.index) || null;
                    matchData.isMatchSubscribed = subscribedMatchesSet.has(matchId);
                    matchData.isLocalTeamSubscribed = subscribedTeamsSet.has(localTeamId);
                    matchData.isVisitorTeamSubscribed = subscribedTeamsSet.has(visitorTeamId);
                    matchData.isLeagueSubscribed = isLeagueSubscribed;
                    // Add match if it meets criteria
                    const shouldAdd = !showOnlyFavorites || matchData.isFavouritedByTeam || matchData.isFavouritedByLeague || matchData.isMatchSubscribed || matchData.isLocalTeamSubscribed || matchData.isVisitorTeamSubscribed || matchData.isLeagueSubscribed;
                    if (shouldAdd) listData.push(matchData);
                }
            }
        }
        // Sort with optimized comparison
        listData.sort((a, b)=>{
            // Favorite teams
            if (a.isFavouritedByTeam !== b.isFavouritedByTeam) return a.isFavouritedByTeam ? -1 : 1;
            if (a.isFavouritedByTeam && b.isFavouritedByTeam) return a.favoriteTeamIndex - b.favoriteTeamIndex;
            // Favorite leagues
            if (a.isFavouritedByLeague !== b.isFavouritedByLeague) return a.isFavouritedByLeague ? -1 : 1;
            if (a.isFavouritedByLeague && b.isFavouritedByLeague) return a.favoriteLeagueIndex - b.favoriteLeagueIndex;
            // Fixed index
            if (a.fixedIndex !== b.fixedIndex) return a.fixedIndex ? -1 : 1;
            if (a.fixedIndex && b.fixedIndex) return a.foundFixedIndex - b.foundFixedIndex;
            // User country priority
            if (userCountry && a.country !== b.country) return a.country === userCountry ? -1 : 1;
            return a.localizedCountry !== b.localizedCountry ? String(a.localizedCountry || '').localeCompare(String(b.localizedCountry || '')) : a.league !== b.league ? String(a.league || '').localeCompare(String(b.league || '')) : a.time !== b.time ? String(a.time || '').localeCompare(String(b.time || '')) : String(a.localteam || '').localeCompare(String(b.localteam || ''));
        });
        // Add headers in a single pass using reduce
        const finalList = listData.reduce((acc, match, index)=>{
            if (index === 0 || match.headerId !== listData[index - 1].headerId) {
                const header = {
                    country: match.country,
                    localizedCountry: match.localizedCountry,
                    league: match.league,
                    title: hiddenTitlesSet.has(match.country) ? match.league : `${match.localizedCountry} - ${match.league}`,
                    type: HEADER_TYPE,
                    style: {
                        height: HEADER_HEIGHT
                    },
                    isFavorite: match.isFavouritedByTeam || match.isFavouritedByLeague,
                    isFavoriteTeam: match.isFavouritedByTeam,
                    isFavoriteLeague: match.isFavouritedByLeague,
                    key: match.leagueKey
                };
                acc.push(header);
            }
            acc.push(match);
            return acc;
        }, []);
        return {
            listData: finalList,
            foundUnfiltered: listData.length > 0
        };
    },
    prepareLiveFeedData: function(options) {
        // Destructure options
        const { translations: translations, defaultTranslations: defaultTranslations, responseData: countries, fixedRegions: fixedRegions, fixedLeagueOrder: fixedLeagueOrder, favoriteTeams: favoriteTeams, favoriteLeagues: favoriteLeagues, hiddenTitles: hiddenTitles, locale: locale, enabledFeatures: enabledFeatures, userRegionLocale: userRegionLocale, showOnlyFavorites: showOnlyFavorites, subscribedTeams: subscribedTeams, subscribedLeagues: subscribedLeagues, subscribedMatches: subscribedMatches, fontSize: fontSize, userCountry: userCountry, listType: listType } = options;
        // Set up localization
        (0, $02mnx.Localizer).LocalizedTranslations = translations;
        (0, $02mnx.Localizer).DefaultTranslations = defaultTranslations;
        // Constants
        const MATCH_HEIGHT_LARGE = 60;
        const MATCH_HEIGHT_TYPE3 = 70;
        const MATCH_HEIGHT_DEFAULT = 55;
        const HEADER_HEIGHT = 45;
        const MATCH_TYPE = 1;
        const HEADER_TYPE = 2;
        // Determine item height
        const itemHeight = listType === "3" ? MATCH_HEIGHT_TYPE3 : fontSize === "xlarge" || fontSize === "large" ? MATCH_HEIGHT_LARGE : MATCH_HEIGHT_DEFAULT;
        // Pre-process favorite indices
        const favoriteLeaguesMap = new Map(Object.entries(favoriteLeagues).map(([key], index)=>[
                key,
                {
                    index: index + 1
                }
            ]));
        const favoriteTeamsMap = new Map(Object.entries(favoriteTeams));
        // Use Sets for O(1) lookups
        const subscribedTeamsSet = new Set(subscribedTeams);
        const subscribedLeaguesSet = new Set(subscribedLeagues);
        const subscribedMatchesSet = new Set(subscribedMatches);
        const hiddenTitlesSet = new Set(hiddenTitles);
        // Pre-process fixed regions
        const foundFixedRegions = fixedLeagueOrder[userRegionLocale] || {};
        const foundFixedLeagues = foundFixedRegions.leagues || [];
        const foundFixedCountries = foundFixedRegions.countries || [];
        // Process data
        const listData = [];
        let headerId = 0;
        for (const country of countries){
            const localizedCountry = (0, $6K7Df.CountryUtil).getLocalizedCountryByName(country.country, locale);
            const fixedCountryIndex = foundFixedCountries.indexOf(country.country);
            let foundFixedIndex = 1;
            for (const league of country.leagues){
                headerId++;
                const leagueKey = league.key;
                const isLeagueSubscribed = subscribedLeaguesSet.has(leagueKey);
                const fixedLeagueIndex = foundFixedLeagues.indexOf(leagueKey);
                const isFixedToTop = fixedLeagueIndex !== -1 || fixedCountryIndex !== -1;
                const fixedIndex = fixedLeagueIndex !== -1 ? fixedLeagueIndex : fixedCountryIndex !== -1 ? foundFixedIndex + 200 : null;
                if (isFixedToTop) foundFixedIndex++;
                for (const match of league.matches){
                    const localTeamId = match.gs_localteamid;
                    const visitorTeamId = match.gs_visitorteamid;
                    const matchId = String(match.id);
                    // Build match object
                    const matchData = {
                        ...match,
                        title: `${match.localteam} - ${match.visitorteam}`,
                        type: MATCH_TYPE,
                        country: country.country,
                        localizedCountry: localizedCountry,
                        league: league.league,
                        headerId: headerId,
                        style: {
                            height: itemHeight
                        },
                        accessibility: {
                            focusable: true,
                            allowTabFocus: true
                        },
                        leagueKey: leagueKey
                    };
                    // Fixed index handling
                    if (isFixedToTop) {
                        matchData.foundFixedIndex = fixedIndex;
                        matchData.fixedIndex = true;
                    }
                    // Favorite and subscription flags
                    const favLocal = favoriteTeamsMap.get(localTeamId);
                    const favVisitor = favoriteTeamsMap.get(visitorTeamId);
                    const favLeague = favoriteLeaguesMap.get(leagueKey);
                    matchData.isFavouritedByTeam = !!(favLocal || favVisitor);
                    matchData.favoriteTeamIndex = (favLocal === null || favLocal === void 0 ? void 0 : favLocal.index) || (favVisitor === null || favVisitor === void 0 ? void 0 : favVisitor.index) || null;
                    matchData.isFavouritedByLeague = !!favLeague;
                    matchData.favoriteLeagueIndex = (favLeague === null || favLeague === void 0 ? void 0 : favLeague.index) || null;
                    matchData.isMatchSubscribed = subscribedMatchesSet.has(matchId);
                    matchData.isLocalTeamSubscribed = subscribedTeamsSet.has(localTeamId);
                    matchData.isVisitorTeamSubscribed = subscribedTeamsSet.has(visitorTeamId);
                    matchData.isLeagueSubscribed = isLeagueSubscribed;
                    // Add match if it meets criteria
                    const shouldAdd = !showOnlyFavorites || matchData.isFavouritedByTeam || matchData.isFavouritedByLeague || matchData.isMatchSubscribed || matchData.isLocalTeamSubscribed || matchData.isVisitorTeamSubscribed || matchData.isLeagueSubscribed;
                    if (shouldAdd) listData.push(matchData);
                }
            }
        }
        // Optimized sort
        listData.sort((a, b)=>{
            if (a.isFavouritedByTeam !== b.isFavouritedByTeam) return a.isFavouritedByTeam ? -1 : 1;
            if (a.isFavouritedByTeam) return a.favoriteTeamIndex - b.favoriteTeamIndex;
            if (a.isFavouritedByLeague !== b.isFavouritedByLeague) return a.isFavouritedByLeague ? -1 : 1;
            if (a.isFavouritedByLeague) return a.favoriteLeagueIndex - b.favoriteLeagueIndex;
            if (userCountry && a.country !== b.country) return a.country === userCountry ? -1 : 1;
            if (a.fixedIndex !== b.fixedIndex) return a.fixedIndex ? -1 : 1;
            if (a.fixedIndex) return a.foundFixedIndex - b.foundFixedIndex;
            return a.localizedCountry.localeCompare(b.localizedCountry);
        });
        // Add headers using reduce
        const finalList = listData.reduce((acc, match, index)=>{
            if (index === 0 || match.headerId !== listData[index - 1].headerId) {
                const header = {
                    country: match.country,
                    localizedCountry: match.localizedCountry,
                    league: match.league,
                    title: hiddenTitlesSet.has(match.country) ? match.league : `${match.localizedCountry} - ${match.league}`,
                    type: HEADER_TYPE,
                    style: {
                        height: HEADER_HEIGHT
                    },
                    isFavorite: match.isFavouritedByTeam || match.isFavouritedByLeague,
                    isFavoriteTeam: match.isFavouritedByTeam,
                    isFavoriteLeague: match.isFavouritedByLeague,
                    key: match.leagueKey,
                    accessibility: {
                        focusable: true,
                        allowTabFocus: true
                    }
                };
                acc.push(header);
            }
            acc.push(match);
            return acc;
        }, []);
        return {
            listData: finalList,
            foundUnfiltered: listData.length > 0
        };
    },
    prepareHomeFeedData: function(options) {
        // Destructure options
        const { enabledFeatures: enabledFeatures, responseData: responseData, fixedRegions: fixedRegions, translations: translations, favoriteTeams: favoriteTeams, favoriteLeagues: favoriteLeagues, locale: locale, localeFull: localeFull, userRegionLocale: userRegionLocale, defaultTranslations: defaultTranslations, availableNewsLocales: availableNewsLocales, newsLocaleRemap: newsLocaleRemap } = options;
        // Set up localization
        (0, $02mnx.Localizer).LocalizedTranslations = translations;
        (0, $02mnx.Localizer).DefaultTranslations = defaultTranslations;
        // Constants
        const ITEM_HEIGHT = 50;
        const FEATURED_ITEM_HEIGHT = 70;
        const HEADER_HEIGHT = 40;
        const COUNTRY_TYPE = 1;
        const HEADER_TYPE = 2;
        const FEATURE_TYPE = 3;
        const TEAM_TYPE = 4;
        const LEAGUE_TYPE = 5;
        const AGENDA_TYPE = 6;
        const NO_TEAMS_TYPE = 7;
        const TEAMS_HEADER_TYPE = 8;
        const LEAGUES_HEADER_TYPE = 9;
        const NO_LEAGUES_TYPE = 10;
        const FEATURED_MATCHES_TYPE = 11;
        // Common accessibility object
        const ACCESSIBLE = {
            focusable: true,
            allowTabFocus: true
        };
        const listData = [];
        // Agenda item
        listData.push({
            title: (0, $02mnx.Localizer).getString("agenda"),
            image: "agendaitem.png",
            type: AGENDA_TYPE,
            accessibility: ACCESSIBLE,
            style: {
                height: ITEM_HEIGHT
            }
        });
        if (responseData && responseData.match_suggestions) {
            var header = {
                "title": (0, $02mnx.Localizer).getString("popular_matches"),
                "type": 2,
                "style": {
                    "height": 0
                }
            };
            listData.push(header);
            var item = {
                type: FEATURED_MATCHES_TYPE,
                matchSuggestions: responseData.match_suggestions,
                item: "suggestions",
                style: {
                    height: 80
                }
            };
            listData.push(item);
        }
        // News section
        if (enabledFeatures.news) {
            const tempLocale = newsLocaleRemap[locale] || locale;
            if (availableNewsLocales.includes(tempLocale) || localeFull && availableNewsLocales.includes(localeFull)) listData.push({
                title: (0, $02mnx.Localizer).getString("news"),
                image: "newsitem.png",
                type: FEATURE_TYPE,
                style: {
                    height: ITEM_HEIGHT
                },
                accessibility: ACCESSIBLE,
                item: "news"
            });
        }
        // Remove ads section
        if (responseData === null || responseData === void 0 ? void 0 : responseData.showRemoveAds) listData.push({
            title: (0, $02mnx.Localizer).getString("remove_ads"),
            image: "noadsitem.png",
            type: FEATURE_TYPE,
            accessibility: ACCESSIBLE,
            style: {
                height: ITEM_HEIGHT
            },
            item: "news"
        });
        // Favorite teams section
        listData.push({
            title: (0, $02mnx.Localizer).getString("favoriteteams"),
            type: TEAMS_HEADER_TYPE,
            accessibility: ACCESSIBLE,
            style: {
                height: HEADER_HEIGHT
            }
        });
        const favoriteTeamKeys = Object.keys(favoriteTeams);
        if (favoriteTeamKeys.length) {
            const tempTeams = favoriteTeamKeys.map((key)=>({
                    ...favoriteTeams[key],
                    key: key
                })).sort((a, b)=>{
                var _a_index, _b_index;
                return ((_a_index = a.index) !== null && _a_index !== void 0 ? _a_index : Infinity) - ((_b_index = b.index) !== null && _b_index !== void 0 ? _b_index : Infinity);
            });
            tempTeams.forEach((team)=>{
                var _responseData_livestats;
                var _responseData_livestats_teams_includes;
                listData.push({
                    name: team.name,
                    id: team.key,
                    accessibility: ACCESSIBLE,
                    is_live: (_responseData_livestats_teams_includes = responseData === null || responseData === void 0 ? void 0 : (_responseData_livestats = responseData.livestats) === null || _responseData_livestats === void 0 ? void 0 : _responseData_livestats.teams.includes(team.key)) !== null && _responseData_livestats_teams_includes !== void 0 ? _responseData_livestats_teams_includes : false,
                    type: TEAM_TYPE,
                    style: {
                        height: ITEM_HEIGHT
                    }
                });
            });
        } else listData.push({
            type: NO_TEAMS_TYPE,
            style: {
                height: ITEM_HEIGHT
            }
        });
        // Favorite leagues section
        listData.push({
            title: (0, $02mnx.Localizer).getString("favoriteleagues"),
            type: LEAGUES_HEADER_TYPE,
            accessibility: ACCESSIBLE,
            style: {
                height: HEADER_HEIGHT
            }
        });
        const favoriteLeagueKeys = Object.keys(favoriteLeagues);
        if (favoriteLeagueKeys.length) {
            const tempLeagues = favoriteLeagueKeys.map((key)=>({
                    ...favoriteLeagues[key],
                    key: key
                })).sort((a, b)=>{
                var _a_index, _b_index;
                return ((_a_index = a.index) !== null && _a_index !== void 0 ? _a_index : Infinity) - ((_b_index = b.index) !== null && _b_index !== void 0 ? _b_index : Infinity);
            });
            tempLeagues.forEach((league)=>{
                var _responseData_livestats;
                var _ref;
                listData.push({
                    name: league.name,
                    country: league.country,
                    key: league.key,
                    accessibility: ACCESSIBLE,
                    is_live: (_ref = (responseData === null || responseData === void 0 ? void 0 : (_responseData_livestats = responseData.livestats) === null || _responseData_livestats === void 0 ? void 0 : _responseData_livestats.leagues[league.key]) != null) !== null && _ref !== void 0 ? _ref : false,
                    type: LEAGUE_TYPE,
                    style: {
                        height: ITEM_HEIGHT
                    }
                });
            });
        } else listData.push({
            type: NO_LEAGUES_TYPE,
            style: {
                height: ITEM_HEIGHT
            }
        });
        // Entertainment section
        if (enabledFeatures.entertainment) {
            listData.push({
                title: (0, $02mnx.Localizer).getString("entertainment"),
                type: HEADER_TYPE,
                style: {
                    height: HEADER_HEIGHT
                }
            });
            const entertainmentItems = [
                {
                    item: "fifaranking",
                    title: (0, $02mnx.Localizer).getString("world_ranking_list"),
                    image: "ranking.png"
                },
                {
                    item: "playervalues",
                    title: (0, $02mnx.Localizer).getString("player_market_values"),
                    image: "playermarketvalue.png"
                }
            ];
            if (enabledFeatures.forum) entertainmentItems.push({
                item: "forumindex",
                title: (0, $02mnx.Localizer).getString("forum"),
                image: "praten.png"
            });
            if (enabledFeatures.userPredictions) entertainmentItems.push({
                item: "topvoters",
                title: (0, $02mnx.Localizer).getString("top_voters"),
                image: "topvoters.png"
            });
            entertainmentItems.forEach((item)=>{
                listData.push({
                    ...item,
                    type: FEATURE_TYPE,
                    accessibility: ACCESSIBLE,
                    style: {
                        height: ITEM_HEIGHT
                    }
                });
            });
        }
        // Countries/Regions section
        listData.push({
            title: (0, $02mnx.Localizer).getString("International"),
            type: HEADER_TYPE,
            style: {
                height: HEADER_HEIGHT
            }
        });
        const hiddenCountries = new Set([
            "World Cup",
            "World Cup Qualifications",
            "Eurocups",
            "England",
            "Spain",
            "France"
        ]);
        const regions = responseData.countries.filter((country)=>enabledFeatures.showHiddenLeagues || !hiddenCountries.has(country.country)).map((country)=>({
                ...country,
                type: COUNTRY_TYPE,
                isFixed: fixedRegions.includes(country.country),
                foundFixedIndex: fixedRegions.indexOf(country.country),
                countryLocalized: (0, $6K7Df.CountryUtil).getLocalizedCountryByName(country.country, locale),
                accessibility: ACCESSIBLE,
                style: {
                    height: ITEM_HEIGHT
                }
            })).sort((a, b)=>a.isFixed !== b.isFixed ? a.isFixed ? -1 : 1 : a.isFixed ? a.foundFixedIndex - b.foundFixedIndex : a.countryLocalized.localeCompare(b.countryLocalized));
        listData.push(...regions);
        // Add Regions header before first non-fixed country
        const firstNonFixedIndex = listData.findIndex((item)=>item.type === COUNTRY_TYPE && !item.isFixed);
        if (firstNonFixedIndex !== -1) listData.splice(firstNonFixedIndex, 0, {
            title: (0, $02mnx.Localizer).getString("Regions"),
            type: HEADER_TYPE,
            accessibility: ACCESSIBLE,
            style: {
                height: HEADER_HEIGHT
            }
        });
        return listData;
    },
    prepareFixtureData: function(options) {
        var _options_responseData;
        console.log("prepare fixture data mrec", options);
        // Constants for clarity and maintainability
        const MATCH_HEIGHT_LARGE = 60;
        const MATCH_HEIGHT_TYPE3 = 70;
        const MATCH_HEIGHT_DEFAULT = 55;
        const HEADER_HEIGHT = 40;
        const MATCH_TYPE = 1;
        const HEADER_TYPE = 2;
        const AD_TYPE = 3;
        // Input validation
        if (!options || !Array.isArray((_options_responseData = options.responseData) === null || _options_responseData === void 0 ? void 0 : _options_responseData.fixtures)) throw new Error("Invalid or missing fixture data");
        // Destructure options for cleaner access
        const { translations: translations, defaultTranslations: defaultTranslations, responseData: { fixtures: fixtures }, dontSelectByCurrentDate: dontSelectByCurrentDate = false, fontSize: fontSize, listType: listType } = options;
        // Set up localization
        (0, $02mnx.Localizer).LocalizedTranslations = translations;
        (0, $02mnx.Localizer).DefaultTranslations = defaultTranslations;
        // Determine match height
        const isLargeFont = fontSize === "xlarge" || fontSize === "large";
        const matchHeight = listType === "3" ? MATCH_HEIGHT_TYPE3 : isLargeFont ? MATCH_HEIGHT_LARGE : MATCH_HEIGHT_DEFAULT;
        // Current time at midnight
        const currentTc = (()=>{
            const now = new Date();
            now.setHours(0, 0, 0, 0);
            return now.getTime();
        })();
        // Process and sort fixtures in one go
        const sortedMatches = fixtures.map((match)=>({
                ...match,
                type: MATCH_TYPE,
                dayTimecodeLocalized: (0, $9yWe2.MatchUtil).getLocalizedDayNoUTCTimecode(match),
                timecode: (0, $9yWe2.MatchUtil).getLocalizedTimecode(match),
                country: match.filegroup,
                league: match.leaguename,
                headerId: HEADER_TYPE,
                style: {
                    height: matchHeight
                }
            })).sort((a, b)=>{
            if (a.dayTimecodeLocalized === b.dayTimecodeLocalized) {
                if (a.stageName && b.stageName && a.stageName !== b.stageName) return a.stageName.localeCompare(b.stageName);
                return a.timecode - b.timecode || a.localteam.localeCompare(b.localteam);
            }
            return a.timecode - b.timecode || a.localteam.localeCompare(b.localteam);
        });
        // Build final list with headers in a single pass
        const finalList = [];
        let prevDay = null;
        let prevStageName = null;
        let selectedIndex = -1;
        let foundSelected = false;
        let hasDifferentStages = sortedMatches.some((m, i)=>i > 0 && m.dayTimecodeLocalized === sortedMatches[i - 1].dayTimecodeLocalized && m.stageName && sortedMatches[i - 1].stageName && m.stageName !== sortedMatches[i - 1].stageName);
        for (const match of sortedMatches){
            const needsHeader = prevDay !== match.dayTimecodeLocalized || hasDifferentStages && match.stageName && prevStageName !== match.stageName;
            if (needsHeader) {
                const header = {
                    week: match.week,
                    date: match.date,
                    time: match.time,
                    stage: match.stageName,
                    round: match.stageRound,
                    dayTimecodeLocalized: match.dayTimecodeLocalized,
                    style: {
                        height: HEADER_HEIGHT
                    },
                    type: HEADER_TYPE
                };
                // Selection logic
                if (!dontSelectByCurrentDate && !foundSelected) {
                    if ((0, $9yWe2.MatchUtil).isPlaying(match)) {
                        header.style.selected = true;
                        foundSelected = true;
                        selectedIndex = finalList.length;
                    } else if (currentTc <= match.dayTimecodeLocalized) {
                        header.style.selected = true;
                        foundSelected = true;
                        selectedIndex = finalList.length;
                    }
                }
                finalList.push(header);
                prevStageName = match.stageName;
            }
            finalList.push(match);
            prevDay = match.dayTimecodeLocalized;
        }
        // Default selection if none found
        if (!foundSelected && finalList.length > 0) {
            finalList[finalList.length - 1].style.selected = true;
            selectedIndex = finalList.length - 1;
        }
        if (options.mrecAdData) {
            console.log("add mrec to list");
            if (selectedIndex >= 0 && finalList.length > selectedIndex + 7) {
                const adItem = {
                    type: AD_TYPE,
                    style: {
                        height: 250
                    },
                    content: 'mediumRectangle',
                    html: options.mrecAdData
                };
                finalList.splice(selectedIndex + 7, 0, adItem);
            }
        }
        return finalList;
    },
    prepareTeamFixtureData: function(options) {
        console.log("prepare team fixture data", options);
        (0, $02mnx.Localizer).LocalizedTranslations = options.translations;
        (0, $02mnx.Localizer).DefaultTranslations = options.defaultTranslations;
        var data = options.responseData;
        var fontSize = options.fontSize;
        var listType = options.listType;
        if (fontSize == "xlarge" || fontSize == "large") var itemHeight = 60;
        if (options.listType == "3") itemHeight = 70;
        else itemHeight = 55;
        if (data.isProcessedByProcessor) return data;
        data.isProcessedByProcessor = true;
        var listData = [];
        var match;
        var headerId = 2;
        var currentTc = new Date();
        currentTc.setHours(0, 0, 0, 0, 0);
        currentTc = currentTc.getTime();
        var inTheFuture = [];
        var inThePast = [];
        var nowPlaying = null;
        var todayPlaying = null;
        var tomorrowPlaying = null;
        var usedIds = [];
        if (data.fixtures) for(var i = 0; i < data.fixtures.length; i++){
            if (usedIds.indexOf(data.fixtures[i].id) != -1) continue;
            usedIds.push(data.fixtures[i].id);
            match = data.fixtures[i];
            match.type = 1;
            match.dayTimecodeLocalized = (0, $9yWe2.MatchUtil).getLocalizedDayNoUTCTimecode(match);
            match.dayTimecodeLocalized = Math.floor(match.dayTimecodeLocalized / 1000) * 1000;
            match.timecode = (0, $9yWe2.MatchUtil).getLocalizedTimecode(match);
            match.country = match.filegroup;
            match.league = match.leaguename;
            match.headerId = headerId;
            match.style = {
                "height": itemHeight
            };
            // console.log(new Date(match.dayTimecodeLocalized),new Date(currentTc))
            // console.log(match.dayTimecodeLocalized,currentTc)
            if (match.status != null && (!isNaN(match.status) || match.status == "HT" || match.status == "P") || match.status == "Break") nowPlaying = match;
            else if (match.dayTimecodeLocalized == currentTc) {
                if (match.status != null && match.status == "FT" || match.status == "AET" || match.status == "Pen." || match.status == "Aban.") match.isfinished = true;
                todayPlaying = match;
            } else if (match.dayTimecodeLocalized < currentTc) inThePast.push(match);
            else inTheFuture.push(match);
            listData.push(match);
        }
        inTheFuture.sort(function(a, b) {
            if (a.timecode > b.timecode) return 1;
            else if (a.timecode < b.timecode) return -1;
            else return a.localteam.localeCompare(b.localteam);
        });
        inThePast.sort(function(a, b) {
            if (a.timecode > b.timecode) return 1;
            else if (a.timecode < b.timecode) return -1;
            else return a.localteam.localeCompare(b.localteam);
        });
        inThePast.reverse();
        data.futureMatches = inTheFuture;
        data.pastMatches = inThePast;
        data.nowPlaying = nowPlaying;
        data.todayPlaying = todayPlaying;
        !data.nowPlaying && !data.todayPlaying && data.futureMatches[0];
        if (todayPlaying && !todayPlaying.isfinished && inThePast.length > 0) data.lastPlayedMatch = inThePast[0];
        if (!todayPlaying && inThePast.length > 0) data.lastPlayedMatch = inThePast[0];
        var countryTableFound = false;
        if (data.leagues && data.leagues.length > 0) {
            for(var k = 0; k < data.leagues.length; k++)if (data.country != data.leagues[k].country) countryTableFound = true;
        }
        //some table stuff
        var newLeagues = [];
        if (data.leagues && data.leagues.length > 0) for(var k = 0; k < data.leagues.length; k++){
            // if (data.country != data.leagues[k].country){
            //     continue;
            // }
            if (data.leagues[k].table && data.leagues[k].table.filegroup == "empty") continue;
            var newGroups = [];
            var useLeague = false;
            if (!data.leagues[k].table) continue;
            data.leagues[k].isRealCountry = (0, $6K7Df.CountryUtil).isRealCountry(data.leagues[k].country) ? 1 : 0;
            console.log("LLLLLL", data.leagues[k]);
            for(var i = 0; i < data.leagues[k].table.groups.length; i++){
                var group = data.leagues[k].table.groups[i];
                if (data.leagues[k].table.groups[i].is_current != 1) continue;
                var newTeams = [];
                for(var j = 0; j < group.teams.length; j++)if (group.teams[j].id_gs == data.id_gs) {
                    console.log("found team", group.teams[j]);
                    newTeams.push(group.teams[j]);
                }
                data.leagues[k].table.groups[i].teams = newTeams;
                if (newTeams.length) {
                    console.log("yes we have teams in this group");
                    newGroups.push(data.leagues[k].table.groups[i]);
                    useLeague = true;
                }
            }
            if (useLeague) newLeagues.push(data.leagues[k]);
            data.leagues[k].table.groups = newGroups;
        }
        data.leagues = newLeagues;
        data.leagues.sort((a, b)=>{
            return b.isRealCountry - a.isRealCountry;
        });
        if (data.squad) {
            for(var i = 0; i < data.squad.length; i++){
                data.squad[i].type = 1;
                data.squad[i].style = {
                    "height": 50
                };
            }
            data.squad = data.squad.sort(function(a, b) {
                if (a.position == "A" && b.position != "A") return -1;
                else if (a.position == "M" && b.position != "M") return -1;
                else if (a.position == "D" && b.position != "D") return -1;
                else if (a.position == "G" && b.position != "G") return -1;
                else return parseInt(b.goals) - parseInt(a.goals);
            });
            var prevPosition = -1;
            for(var i = 0; i < data.squad.length; i++){
                if (data.squad.injured != "True" && data.sidelined) {
                    for(var j = 0; j < data.sidelined.length; j++)if (data.sidelined[j].id == data.squad[i].id) {
                        data.squad[i].injuryDescription = data.sidelined[j].description;
                        data.squad[i].injuryFrom = data.sidelined[j].startdate;
                        break;
                    }
                }
                if (prevPosition != data.squad[i].position) {
                    var header = {
                        "type": 2,
                        "style": {
                            "height": 40
                        }
                    };
                    if (data.squad[i].position == "A") header.title = (0, $02mnx.Localizer).getString("attackers");
                    else if (data.squad[i].position == "M") header.title = (0, $02mnx.Localizer).getString("midfielders");
                    else if (data.squad[i].position == "G") header.title = (0, $02mnx.Localizer).getString("goalkeepers");
                    else if (data.squad[i].position == "D") header.title = (0, $02mnx.Localizer).getString("defenders");
                    data.squad.splice(i, 0, header);
                    i++;
                    prevPosition = data.squad[i].position;
                }
            }
        }
        if (data.coach) {
            var header = {
                "type": 2,
                "style": {
                    "height": 40
                }
            };
            header.title = (0, $02mnx.Localizer).getString("coach");
            var item = {};
            item.type = 3;
            item.style = {
                "height": 50
            };
            item.data = {
                coach: data.coach,
                coachid: data.coachid,
                coachbirthcountry: data.coachbirthcountry
            };
            if (!data.squad) data.squad = [];
            data.squad.splice(0, 0, item);
            data.squad.splice(0, 0, header);
        }
        if (data.transfers) {
            var transferData = [];
            if (data.transfers.in && data.transfers.in.length) {
                var header = {
                    "type": 2,
                    "style": {
                        "height": 40
                    }
                };
                header.title = (0, $02mnx.Localizer).getString("incoming_transfers");
                transferData.push(header);
                for(var i = 0; i < data.transfers.in.length; i++){
                    var item = {};
                    item.type = 1;
                    item.style = {
                        "height": 55
                    };
                    data.transfers.in[i].team = data.transfers.in[i].from;
                    item.data = data.transfers.in[i];
                    transferData.push(item);
                }
            }
            if (data.transfers.out && data.transfers.out.length) {
                var header = {
                    "type": 2,
                    "style": {
                        "height": 40
                    }
                };
                header.title = (0, $02mnx.Localizer).getString("outgoing_transfers");
                transferData.push(header);
                for(var i = 0; i < data.transfers.out.length; i++){
                    var item = {};
                    item.type = 1;
                    item.style = {
                        "height": 55
                    };
                    data.transfers.out[i].team = data.transfers.out[i].to;
                    item.data = data.transfers.out[i];
                    transferData.push(item);
                }
            }
            data.transfers = transferData;
        }
        if (data.trophies) {
            var previousLeague = null;
            for(var i = 0; i < data.trophies.length; i++){
                if (previousLeague != data.trophies[i].league) {
                    var header = {
                        "type": 2,
                        "style": {
                            "height": 40
                        }
                    };
                    header.title = data.trophies[i].league;
                    header.country = data.trophies[i].country;
                    data.trophies.splice(i, 0, header);
                    i++;
                    previousLeague = data.trophies[i].league;
                }
                var seasons = data.trophies[i].seasons;
                var splitted = seasons.replaceAll(" ", "").split(",");
                data.trophies[i].seasons = splitted;
                data.trophies[i].type = 1;
                data.trophies[i].style = {
                    "height": 60
                };
            }
        }
        return data;
    },
    preparePlayerData: function(data, translations, defaultTranslations, userLocale) {
        // Localizer.LocalizedTranslations = translations;
        // DefaultTranslations = defaultTranslations;
        if (data.isProcessedByProcessor) return data;
        data.isProcessedByProcessor = true;
        data.type = 1;
        data.style = {
            "height": 55
        };
        var allStatistics = [];
        if (data.statistics && data.statistics.length) allStatistics = allStatistics.concat(data.statistics);
        if (data.statisticscups && data.statisticscups.length) allStatistics = allStatistics.concat(data.statisticscups);
        if (data.statisticscupsintl && data.statisticscupsintl.length) allStatistics = allStatistics.concat(data.statisticscupsintl);
        if (data.statisticsintl && data.statisticsintl.length) allStatistics = allStatistics.concat(data.statisticsintl);
        allStatistics.sort(function(a, b) {
            return b.season.localeCompare(a.season);
        });
        if (data.sidelined && data.sidelined.length) for(var i = 0; i < data.sidelined.length; i++){
            var item = data.sidelined[i];
            item.injurytype = item.type;
            item.type = 1;
            item.style = {
                "height": 50
            };
        }
        if (data.trophies) {
            var previousLeague = null;
            for(var i = 0; i < data.trophies.length; i++){
                if (previousLeague != data.trophies[i].league) {
                    var header = {
                        "type": 2,
                        "style": {
                            "height": 40
                        }
                    };
                    header.title = data.trophies[i].league;
                    header.country = data.trophies[i].country;
                    data.trophies.splice(i, 0, header);
                    i++;
                    previousLeague = data.trophies[i].league;
                }
                var seasons = data.trophies[i].seasons;
                var splitted = seasons.replaceAll(" ", "").split(",");
                data.trophies[i].seasons = splitted;
                data.trophies[i].type = 1;
                data.trophies[i].style = {
                    "height": 60
                };
            }
        }
        if (data.transfers && data.transfers.length) // var header = {"type":2,"style":{"height":40}};
        // header.title = Localizer.getString("incoming_transfers");
        // transferData.push(header);
        for(var i = 0; i < data.transfers.length; i++){
            data.transfers[i].transferType = data.transfers[i].type;
            data.transfers[i].type = 1;
            data.transfers[i].style = {
                "height": 55
            };
            data.transfers[i].team = data.transfers[i].from;
        ////transferData.push(item);
        }
        if (data.careerclubs && data.careerclubs.length) for(var i = 0; i < data.careerclubs.length; i++){
            data.careerclubs[i].type = 1;
            data.careerclubs[i].style = {
                "height": 55
            };
        }
        data.allStatistics = allStatistics;
        return data;
    },
    prepareRankingData: function(data, translations, defaultTranslations, userLocale) {
        for(var i = 0; i < data.length; i++){
            var item = data[i];
            item.type = 1;
            item.style = {
                "height": 50
            };
        }
        return data;
    },
    preparePlayerMarketValuesData: function(data, filterData, selectedPlayerId) {
        var filteredData = [];
        for(var i = 0; i < data.length; i++){
            if (filterData && filterData.length) {
                if (filterData.indexOf(data[i].nationality.toLowerCase()) == -1) continue;
            }
            var item = data[i];
            item.type = 1;
            item.style = {
                "height": 50
            };
            filteredData.push(item);
            if (data[i].id == selectedPlayerId) item.style.selected = true;
        }
        return filteredData;
    },
    prepareTopVotersData: function(data) {
        var result = [];
        if (!data || !data.responseData) return result;
        if (data.responseData.userVotes) {
            //add to beginning of array
            data.responseData.userVotes.isMine = true;
            data.responseData.topVoters.unshift(data.responseData.userVotes);
        }
        for(var i = 0; i < data.responseData.topVoters.length; i++){
            var item = data.responseData.topVoters[i];
            item.type = 1;
            item.style = {
                "height": 50
            };
            if (item.isMine) item.style = {
                "height": 55
            };
            result.push(item);
        }
        return result;
    },
    prepareUserVotesData: function(data) {
        var result = {};
        if (!data) return result;
        var futurelistData = [];
        var pastlistData = [];
        var pastVotes = data.voteResults;
        for(var i = 0; i < pastVotes.length; i++){
            var match = pastVotes[i];
            match.type = 1;
            match.style = {
                "height": 50
            };
            match.isPast = true;
            match.dayTimecodeLocalized = (0, $9yWe2.MatchUtil).getLocalizedDayTimecode(match);
            match.timecode = (0, $9yWe2.MatchUtil).getLocalizedTimecode(match);
            match.country = match.filegroup;
            match.league = match.leaguename;
            //match.headerId = headerId;
            pastlistData.push(match);
        }
        pastlistData.sort(function(a, b) {
            if (a.timecode < b.timecode) return 1;
            else if (a.timecode > b.timecode) return -1;
            else return a.localteam.localeCompare(b.localteam);
        });
        var newListData = [];
        var header, prevWeek;
        var prevHeader = null;
        for(var i = 0; i < pastlistData.length; i++){
            if (prevWeek != pastlistData[i].dayTimecodeLocalized) {
                header = {
                    "week": pastlistData[i].week,
                    "date": pastlistData[i].date,
                    "time": pastlistData[i].time,
                    "stage": pastlistData[i].stageName,
                    "stageName": pastlistData[i].stageName,
                    "round": pastlistData[i].stageRound,
                    "dayTimecodeLocalized": pastlistData[i].dayTimecodeLocalized,
                    "style": {
                        "height": 30
                    },
                    "type": 2
                };
                prevHeader = header;
                newListData.push(header);
            }
            newListData.push(pastlistData[i]);
            prevWeek = pastlistData[i].dayTimecodeLocalized;
        }
        pastlistData = newListData;
        var futureVotes = data.voteFuture;
        for(var i = 0; i < futureVotes.length; i++){
            var match = futureVotes[i];
            match.type = 1;
            match.style = {
                "height": 50
            };
            match.dayTimecodeLocalized = (0, $9yWe2.MatchUtil).getLocalizedDayTimecode(match);
            match.timecode = (0, $9yWe2.MatchUtil).getLocalizedTimecode(match);
            match.country = match.filegroup;
            match.league = match.leaguename;
            //match.headerId = headerId;
            futurelistData.push(match);
        }
        futurelistData.sort(function(a, b) {
            if (a.timecode > b.timecode) return 1;
            else if (a.timecode < b.timecode) return -1;
            else return a.localteam.localeCompare(b.localteam);
        });
        var newListData = [];
        var header, prevWeek;
        var prevHeader = null;
        for(var i = 0; i < futurelistData.length; i++){
            if (prevWeek != futurelistData[i].dayTimecodeLocalized) {
                header = {
                    "week": futurelistData[i].week,
                    "date": futurelistData[i].date,
                    "time": futurelistData[i].time,
                    "stage": futurelistData[i].stageName,
                    "stageName": futurelistData[i].stageName,
                    "round": futurelistData[i].stageRound,
                    "dayTimecodeLocalized": futurelistData[i].dayTimecodeLocalized,
                    "style": {
                        "height": 30
                    },
                    "type": 2
                };
                prevHeader = header;
                newListData.push(header);
            }
            newListData.push(futurelistData[i]);
            prevWeek = futurelistData[i].dayTimecodeLocalized;
        }
        futurelistData = newListData;
        data.listData = futurelistData;
        data.listData = data.listData.concat(pastlistData);
        ////data.listData.push(pastlistData);
        return data;
    },
    prepareTopTeams: function(data) {
        var teams = data.responseData;
        for(var i = 0; i < teams.length; i++){
            teams[i].type = 1;
            teams[i].style = {
                "height": 50
            };
        }
        //console.log(teams);
        return teams;
    },
    prepareForumIndexData: function(data) {
        var prevGroup = null;
        for(var i = 0; i < data.length; i++){
            if (data[i].group != prevGroup) {
                var header = {
                    "type": 2,
                    "style": {
                        "height": 40
                    }
                };
                header.title = data[i].group;
                data.splice(i, 0, header);
                i++;
                prevGroup = data[i].group;
            }
            var item = data[i];
            item.type = 1;
            item.style = {
                "height": 55
            };
        }
        return data;
    },
    //binary search for finding nearest top offset element.
    //thanks to chatgtp. it gave this answer right away
    findNearestItem: function(array, target) {
        let left = 0;
        let right = array.length - 1;
        var current;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            current = array[mid];
            if (current.style.offset > target) right = mid - 1;
            else if (current.style.offset < target) left = mid + 1;
            else return mid;
        }
        // If we didn't find an exact match, return the nearest element
        if (left > 0) {
            const prev = array[left - 1];
            if (target - prev.style.offset < current.style.offset - target) return left - 1;
        }
        return left;
    }
};

});

var $495dacf9dec72733$exports = {};


(parcelRequire("5E5D3")).register((parcelRequire("2SJ43")).getBundleURL('kuLgW'), JSON.parse("[\"kuLgW\",\"index.ee7c73eb.js\",\"5p2LO\",\"service-worker.js\",\"fwd0D\",\"firebase-messaging-service-worker.js\",\"2vlxr\",\"loader1235.25bed157.svg\",\"ji5a1\",\"football.906e411e.png\",\"kacoe\",\"yellowcard.c501e054.png\",\"72fhS\",\"subinout.f62c91f1.png\",\"3KlLR\",\"redcard.dc6a6e43.png\",\"bOABQ\",\"yellowredcard.072c2218.png\",\"eV5Pj\",\"football_pen_miss.c1eb9941.png\",\"7SPT9\",\"subin.60d515bf.png\",\"1YsVH\",\"subout.b7c56990.png\",\"7ImM0\",\"lineups.05e927ca.png\",\"iGNNu\",\"bench.4a6cfd1f.png\",\"3uFxJ\",\"time_clock.b0cbfc87.png\",\"iSxzm\",\"workers.411b1a1d.js\"]"));

/**
 * @author Gillis Haasnoot <gillis.haasnoot@gmail.com>
 * @package Banana
 * @summary Base Control component
 */ /**
 * @author Gillis Haasnoot <gillis.haasnoot@gmail.com>
 * @package Banana.Util
 * @summary Various utils
 */ /**
 @class Banana.Util
 @name Banana.Util
 */ /**
 * Natural sort function for comparing strings with numbers, dates, or hex values
 * @param {string} a - First value to compare
 * @param {string} b - Second value to compare
 * @returns {number} - -1 if a < b, 1 if a > b, 0 if equal
 */ const $73ef6be17e83afdd$export$a57e3d1504ae3816 = (a, b)=>{
    const re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi;
    const sre = /(^[ ]*|[ ]*$)/g;
    const dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/;
    const hre = /^0x[0-9a-f]+$/i;
    const ore = /^0/;
    const normalize = (s)=>$73ef6be17e83afdd$export$a57e3d1504ae3816.insensitive ? String(s).toLowerCase() : String(s);
    const x = normalize(a).replace(sre, '') || '';
    const y = normalize(b).replace(sre, '') || '';
    const xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');
    const yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');
    const xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x) || null;
    const yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null;
    if (yD) return xD < yD ? -1 : xD > yD ? 1 : 0;
    const maxLen = Math.max(xN.length, yN.length);
    for(let cLoc = 0; cLoc < maxLen; cLoc++){
        var _xN_cLoc, _yN_cLoc;
        const xVal = !((_xN_cLoc = xN[cLoc]) === null || _xN_cLoc === void 0 ? void 0 : _xN_cLoc.match(ore)) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
        const yVal = !((_yN_cLoc = yN[cLoc]) === null || _yN_cLoc === void 0 ? void 0 : _yN_cLoc.match(ore)) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
        if (isNaN(xVal) !== isNaN(yVal)) return isNaN(xVal) ? 1 : -1;
        if (typeof xVal !== typeof yVal) return String(xVal) < String(yVal) ? -1 : 1;
        if (xVal < yVal) return -1;
        if (xVal > yVal) return 1;
    }
    return 0;
};
/**
 * Cache for namespace lookups
 * @type {Object}
 */ const $73ef6be17e83afdd$var$nameSpaceCache = {};
const $73ef6be17e83afdd$export$efb38226d8a3ed79 = (ns)=>{
    if ($73ef6be17e83afdd$var$nameSpaceCache[ns]) return $73ef6be17e83afdd$var$nameSpaceCache[ns];
    const parts = ns.split('.');
    let fn = window;
    for (const part of parts){
        fn = fn[part];
        if (!fn) return null;
    }
    $73ef6be17e83afdd$var$nameSpaceCache[ns] = fn;
    return fn;
};
const $73ef6be17e83afdd$export$a324f95e9827bc34 = (data, path)=>{
    return path.split('.').reduce((acc, part)=>{
        var _acc_part;
        return (_acc_part = acc === null || acc === void 0 ? void 0 : acc[part]) !== null && _acc_part !== void 0 ? _acc_part : null;
    }, data);
};
const $73ef6be17e83afdd$export$b5d07669a5562b23 = (data, deep)=>deep ? owl.deepCopy(data) : owl.clone(data);
const $73ef6be17e83afdd$export$49840e61b5793ba1 = (data, field, value)=>data.find((item)=>item[field] === value) || null;
const $73ef6be17e83afdd$export$1f3edade1fd98095 = (arr, field)=>{
    if (!(arr instanceof Array)) {
        log.error('CombineArrayByField - List should be of type Array');
        return arr;
    }
    if (!field) {
        log.error('CombineArrayByField - No field given');
        return arr;
    }
    const grouped = new Map();
    arr.forEach((item)=>{
        const key = item[field];
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(item);
    });
    return Array.from(grouped.values());
};
const $73ef6be17e83afdd$export$a3eb66067ebeef12 = (newdata, olddata, identifier, refObj)=>{
    if (newdata instanceof Array && olddata instanceof Array) {
        const backup = [
            ...olddata
        ];
        olddata.length = 0;
        newdata.forEach((valueA, i)=>{
            if (typeof valueA === 'object' && valueA) {
                const idA = valueA[identifier];
                if (idA) {
                    const match = backup.find((valueB)=>valueB[identifier] === idA);
                    if (match) {
                        olddata.push(match);
                        $73ef6be17e83afdd$export$a3eb66067ebeef12(valueA, match, identifier, {
                            ref: olddata,
                            prop: i
                        });
                    } else olddata.push(valueA);
                } else olddata.push(valueA);
            } else olddata[i] = valueA;
        });
    } else if (newdata instanceof Array) {
        if (!refObj) throw "Unable to assign property to object (missing reference)";
        refObj.ref[refObj.prop] = newdata;
    } else if (typeof newdata === 'object' && newdata !== null) {
        const oldKeys = Object.keys(olddata).filter((key)=>typeof olddata[key] !== 'function');
        for(const prop in newdata){
            if (typeof newdata[prop] === 'function') continue;
            const index = oldKeys.indexOf(prop);
            if (index >= 0) oldKeys.splice(index, 1);
            if (typeof newdata[prop] === 'object' && olddata[prop] && newdata[prop] !== null) $73ef6be17e83afdd$export$a3eb66067ebeef12(newdata[prop], olddata[prop], identifier, {
                ref: olddata,
                prop: prop
            });
            else olddata[prop] = newdata[prop];
        }
        oldKeys.forEach((key)=>delete olddata[key]);
    }
    return olddata;
};
const $73ef6be17e83afdd$export$dc32dd0e76123b43 = (a, b, ignores)=>$73ef6be17e83afdd$export$9d718bc2c25b8220(a, b, ignores) && $73ef6be17e83afdd$export$9d718bc2c25b8220(b, a, ignores);
const $73ef6be17e83afdd$export$9d718bc2c25b8220 = (a, b, ignores = [])=>{
    if (!a || !b) return false;
    const ignoreSet = new Set(ignores);
    for(const prop in a){
        if (typeof a[prop] === 'function') continue;
        if (typeof a[prop] === 'object' && a[prop] !== null && b[prop] !== null) {
            if (typeof b[prop] !== 'object' || !$73ef6be17e83afdd$export$dc32dd0e76123b43(a[prop], b[prop], ignores)) return false;
        } else if ([
            'string',
            'number',
            'boolean'
        ].includes(typeof a[prop])) {
            if (!ignoreSet.has(prop) && b[prop] !== a[prop]) return false;
        }
    }
    return true;
};
const $73ef6be17e83afdd$export$ab61efdd12ed4121 = (obj, sortFunc)=>{
    const keys = Object.keys(obj).sort(sortFunc || undefined);
    return Object.fromEntries(keys.map((key)=>[
            key,
            obj[key]
        ]));
};
const $73ef6be17e83afdd$export$48da330df5248c4c = ()=>((1 + Math.random()) * 0x1000000000 | 0).toString(16).substring(1);
const $73ef6be17e83afdd$export$ec4de0bdc266f27 = (object, childKey, reversed = [])=>{
    if (!object) return reversed;
    if (object[childKey]) object[childKey].forEach((child)=>$73ef6be17e83afdd$export$ec4de0bdc266f27(child, childKey, reversed));
    reversed.push(object);
    return reversed;
};
const $73ef6be17e83afdd$export$1d97eda983b1d04 = (array, cb, timeout = 0, completeCb, completeChunkCb)=>{
    if (typeof cb !== 'function') {
        log.error("No callback specified for async iterator");
        return;
    }
    const chunkSize = Math.max(Math.floor(array.length / 10), 1);
    let i = -1;
    const loop = ()=>{
        i++;
        if (i >= array.length) {
            completeCb === null || completeCb === void 0 ? void 0 : completeCb();
            return;
        }
        const end = Math.min(i + chunkSize, array.length);
        for(; i < end; i++)cb(array[i], i);
        completeChunkCb === null || completeChunkCb === void 0 ? void 0 : completeChunkCb();
        setTimeout(loop, timeout);
    };
    loop();
};


const $bf7f47488c894fdf$export$86d9a347f2bf71d6 = {
    'DOM_EVENT': 1,
    'CUSTOM_EVENT': 2
};
class $bf7f47488c894fdf$export$7a7fa4424cb20976 {
    init() {
        this.generateUniqueId();
        this.customId = false; // flag if page sets id
        this.binds = [];
        this.controls = [];
    }
    createComponents() {}
    updateDisplay() {}
    onPreInvalidateContents() {}
    unload() {}
    onWindowResize() {}
    onVisibilityChange() {}
    onOffline() {}
    onOnline() {}
    applyToChildren(fn) {
        const args = Array.from(arguments).slice(1);
        this.controls.forEach((child)=>fn.apply(this, args));
    }
    setId(id) {
        this.id = id;
        this.customId = true;
        return this;
    }
    getId() {
        return this.id;
    }
    setClientId(cid) {
        this.clientId = cid;
    }
    getClientId() {
        return this.clientId;
    }
    generateUniqueId() {
        this.id = (0, $73ef6be17e83afdd$export$48da330df5248c4c)();
    }
    render(control, index) {
        this.getPage().initRender(control, this, null, null, false, index);
    }
    setPage(page) {
        this.page = page;
    }
    getPage() {
        return this.page;
    }
    getProxy(fn) {
        return jQuery.proxy(fn, this);
    }
    setParent(parent) {
        this.parent = parent;
    }
    getParent() {
        return this.parent;
    }
    getEnabled() {}
    addControl(c) {
        this.controls.push(c);
        return this;
    }
    addControlAt(c, at) {
        this.controls.splice(at, 0, c);
        return this;
    }
    getControls() {
        return this.controls;
    }
    findControl(id) {
        if (this.id === id) return this;
        for (const child of this.controls)if (child instanceof $bf7f47488c894fdf$export$7a7fa4424cb20976) {
            const found = child.findControl(id);
            if (found) return found;
        }
        return null;
    }
    remove() {
        console.error("Remove method is not fully implemented");
        this.unregisterEvents();
    }
    clear() {
        this.controls = [];
    }
    invalidateDisplay() {
        var page = this.getPage();
        if (page && page.isRendered) page.rerender(this.getFirstUiControl());
    }
    triggerEvent(name, params) {
        jQuery(this).trigger(name, params);
    }
    getDomEventTypes() {
        return [
            'mousedown',
            'mousemove',
            'touchstart',
            'touchend',
            'touchmove',
            'drag',
            'dragstart',
            'dragenter',
            'dragover',
            'dragleave',
            'dragend',
            'drop',
            'resize',
            'mouseup',
            'ready',
            'click',
            'dblclick',
            'error',
            'ready',
            'select',
            'submit',
            'focusin',
            'focusout',
            'blur',
            'focus',
            'change',
            'mouseover',
            'mouseleave',
            'mouseenter',
            'mouseout',
            'keypress',
            'keyup',
            'keydown'
        ];
    }
    bind(name, func, data) {
        if (this.hasBind(name, func)) return false;
        const type = this.getDomEventTypes().includes(name) ? $bf7f47488c894fdf$export$86d9a347f2bf71d6.DOM_EVENT : $bf7f47488c894fdf$export$86d9a347f2bf71d6.CUSTOM_EVENT;
        this.binds.push({
            name: name,
            func: func,
            data: data,
            type: type
        });
        if (type === $bf7f47488c894fdf$export$86d9a347f2bf71d6.CUSTOM_EVENT || this.isRendered) jQuery(this.isRendered && type === $bf7f47488c894fdf$export$86d9a347f2bf71d6.DOM_EVENT ? `#${this.getClientId()}` : this).bind(name, data, func);
        return this;
    }
    hasBind(name, func) {
        this.binds = this.binds || [];
        return this.binds.some((b)=>b.name === name && (!func || func.guid === b.func.guid || b.func === func));
    }
    unbind(name, func) {
        this.binds = this.binds.filter((b)=>{
            if (b.name === name && (!func || b.func === func)) {
                const $target = b.type === $bf7f47488c894fdf$export$86d9a347f2bf71d6.DOM_EVENT ? jQuery(`#${this.getClientId()}`) : jQuery(this);
                $target.unbind(name, func);
                return false;
            }
            return true;
        });
    }
    registerEvents() {
        if (!this.binds) return;
        var i, len;
        for(i = 0, len = this.binds.length; i < len; i++){
            var name = this.binds[i].name;
            var func = this.binds[i].func;
            var data = this.binds[i].data;
            var type = this.binds[i].type;
            //there is a difference between dom and data events. dom events can be registered only
            //when the dom elements are rendered. data events can be registered right when object are instantiated
            //if we bind an custom event during construction (before dom render, no rerender has occured) we want it instant to be registered
            //because this function is called after rendering and rerendering we only need to bind the custom events
            //after a RE-rerender, cause rerendering always starts with unbinding ALL events.
            if (type === $bf7f47488c894fdf$export$86d9a347f2bf71d6.CUSTOM_EVENT && this.getPage().isRerendering) {
                if (data) jQuery(this).bind(name, data, func);
                else jQuery(this).bind(name, func);
            } else ;
        }
    }
    unregisterEvents() {
        if (!this.binds) return;
        jQuery(this).unbind(); //and all custom events
    }
    getHtml(markAsRendered) {
        return this.controls.map((child)=>child instanceof $bf7f47488c894fdf$export$7a7fa4424cb20976 ? child.getHtml(markAsRendered) : child).join('');
    }
    getFirstUiControl() {
        if (this.parent) return this.parent.getFirstUiControl();
        return null;
    }
    constructor(...args){
        this.init.apply(this, args);
    }
}



class $5983bd27facb3353$export$ff49c445471d74bb extends (0, $bf7f47488c894fdf$export$7a7fa4424cb20976) {
    init(...args) {
        super.init(...args);
        this.css = {};
        this.style = '';
        this.isRendered = false;
        this.visible = true; //default is visible
        this.enabled = true;
    }
    addControl(c, autoRender) {
        if (this.isInitialized) {
            const page = this.getPage();
            page.initializeControl(c, this, false, this.controls.length);
            if (autoRender) this.render(c);
        }
        return super.addControl(c);
    }
    addControlAt(c, index, autoRender) {
        if (!this.controls[index]) return this.addControl(c, autoRender);
        if (this.isInitialized) {
            const page = this.getPage();
            page.initializeControl(c, this, false, index);
            if (autoRender) this.render(c, index);
        }
        return super.addControlAt(c, index);
    }
    unload() {
        this.cachedElement = undefined;
    }
    remove() {
        this.getPage().removeControl(this);
    }
    clear() {
        const page = this.getPage();
        if (page) {
            page.clearControl(this);
            this.controls = [];
        }
    }
    getFirstUiControl() {
        var _this_parent;
        if (!this.markAsNonRender) return this;
        return ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.getFirstUiControl()) || null;
    }
}
/*
 * @return object jquery dom writer
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getDomWriter = function() {
    if (!this.cachedElement) this.cachedElement = jQuery(`#${this.getClientId()}`);
    return this.cachedElement;
};
/**
 * @return string tag name of control
 * overwrite this function to use your own tags. ie <div> <a> <p> <input> <label>
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getTagName = function() {
    return '';
};
/**
 * Computes widht,height and left right offsets
 *
 * @return {Object} of dimensions
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getDimensions = function() {
    const $el = this.getDomWriter();
    return {
        height: $el.height(),
        width: $el.width(),
        offset: $el.offset(),
        position: $el.position()
    };
};
/**
 * sets client id used to reference dom node. This method is auto called by the page
 * @param {String} cid
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.setClientId = function(cid) {
    this.clientId = cid;
};
/**
 * @return {String} reference to the dom node id
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getClientId = function() {
    return this.clientId;
};
/**
 * Triggers an event which will notify all listeners
 * Optionally data can be send along.
 *
 * @param {String} name of the event to be triggered
 * @param {mixed} data
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.triggerEvent = function(name, data) {
    if (this.getDomEventTypes().indexOf(name) !== -1) {
        if (this.isRendered) this.getDomWriter().trigger(name, data);
    } else jQuery(this).trigger(name, data);
};
/**
 * Composes attributes for usuage in html tags.
 * @return {Object} of attributes
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getAttributes = function() {
    var attributes = this.attributes || {};
    attributes['id'] = this.getClientId();
    attributes['style'] = this.getStyle() || '';
    if (this.getCss()) {
        var css = "";
        for(var prop in this.getCss())css += prop + ':' + this.getCss()[prop] + ';';
        attributes['style'] += css;
    }
    if (this.cssClass && this.cssClass.length > 0) attributes['class'] = this.getCssClass().join(' ');
    return attributes;
};
/**
 * sets attribute
 * depending on the type of key we set prop or attr
 *
 * see http://blog.jquery.com/ for more information
 * @param {String} key
 * @param {String} value
 * @return {this}
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.setAttribute = function(key, value) {
    if (this.isRendered) this.getDomWriter().prop(key, value);
    this.attributes = this.attributes || {};
    this.attributes[key] = value;
    return this;
};
/**
 * @String key of the attribute which should be removed
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.removeAttribute = function(key) {
    var _this_attributes;
    if (this.isRendered) this.getDomWriter().removeProp(key);
    if ((_this_attributes = this.attributes) === null || _this_attributes === void 0 ? void 0 : _this_attributes[key]) delete this.attributes[key];
    return this;
};
/**
 * @param {String} key of the attribute
 * @return {String} attribute by key
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getAttribute = function(key) {
    if (!this.attributes) return null;
    return this.attributes[key];
};
/**
 * NOTE: use setCss() instead to directly apply it to dom
 * @param {String} style of this control. by css definitions
 * @return {this}
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.setStyle = function(style) {
    if (this.isRendered) console.warn("setting style on rendered control wont immediately apply. Use setCss() instead or invalidate control");
    this.style = style;
    return this;
};
/**
 * @return {String}
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getStyle = function() {
    return this.style;
};
/**
 * adds css style in object key value style.
 * @param {Object} css example {width:'100px',left:0};
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.addCss = function(css) {
    this.css = {
        ...this.css,
        ...css
    };
};
/**
 * adds css style and instantly apply it to dom if rendered
 *
 * @param {Object} css
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.setCss = function(css) {
    this.addCss(css);
    if (this.isRendered) this.getDomWriter().css(this.css);
    return this;
};
/**
 * @return {Object} of css properties in key value format
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getCss = function() {
    return this.css;
};
/**
 * @return {String} value of css property
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getStyleProperty = function(prop) {
    return this.css[prop] || this.getDomWriter().css(prop);
};
/**
 * @return {Array} of currently added css classes
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getCssClass = function() {
    if (!this.cssClass) this.cssClass = [];
    return this.cssClass;
};
/**
 * Adds css class. this will be instantly applied to dom if rendered
 *
 * @param {String} css name of css class
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.addCssClass = function(css) {
    if (!this.cssClass) this.cssClass = [];
    if (!this.hasCssClass(css)) {
        this.cssClass.push(css);
        if (this.isRendered) this.getDomWriter().addClass(css);
    }
    return this;
};
/**
 * removes css class. this will be instantly applied to dom
 *
 * @param {String} css name of css class
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.removeCssClass = function(css) {
    if (!this.cssClass) return this;
    var indexOf = this.cssClass.indexOf(css);
    if (indexOf != -1) {
        this.cssClass.splice(indexOf, 1);
        if (this.isRendered) this.getDomWriter().removeClass(css);
    }
    return this;
};
/**
 * Switch the old Css class with a new one
 *
 * @param {String} oldClass Old CSS class to replace
 * @param {String} newClass New CSS class to add
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.switchCssClass = function(oldClass, newClass) {
    this.removeCssClass(oldClass);
    this.addCssClass(newClass);
    return this;
};
/**
 * @return {boolean}
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.hasCssClass = function(search) {
    return this.isRendered ? this.getDomWriter().hasClass(search) : this.getCssClass().includes(search);
};
/**
 * return string representation of html attributes. used by renderer
 *
 * @return {String}
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getHtmlAttributes = function() {
    const attributes = this.getAttributes();
    return Object.entries(attributes).filter(([_, value])=>value !== undefined && value !== 'undefined').map(([key, value])=>`${key}="${value}"`).join(' ');
};
/**
 * makes control visible or invisible.
 *
 * @param {boolean} v true when visible
 * @param {String} speed animation speed of hiding/ showing
 * @param {String} type of animation
 * @param {Function} callback when finished
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.setVisible = function(v, speed, type, callback) {
    this.triggerEvent('onSetVisible', v); //trigger this first to prevent flickering
    this.visible = v;
    var ignoreDirectAction = false;
    if (v) {
        if (this.isRendered) {
            if (type === 'fadeIn') {
                this.getDomWriter().fadeIn(speed, ()=>{
                    this.setCss({
                        'display': ''
                    });
                    if (callback) callback();
                });
                ignoreDirectAction = true;
            } else this.getDomWriter().show(speed, ()=>{
                this.setCss({
                    'display': ''
                });
                if (callback) callback();
            });
        }
        if (!ignoreDirectAction) this.setCss({
            'display': ''
        });
    } else {
        if (this.isRendered) {
            if (type === 'fadeOut') {
                ignoreDirectAction = true;
                this.getDomWriter().fadeOut(speed, ()=>{
                    this.setCss({
                        'display': 'none'
                    });
                    if (callback) callback();
                });
            } else this.getDomWriter().hide(speed, ()=>{
                this.setCss({
                    'display': 'none'
                });
                if (callback) callback();
            });
        }
        if (!ignoreDirectAction) this.setCss({
            'display': 'none'
        });
    }
    return this;
};
/*
 * @return bool true when visible
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getVisible = function() {
    if (this.isRendered) return this.getDomWriter().is(":visible");
    else return this.visible; //note this only works on controls which are directly made invisble not for their childs
};
/**
 * register all binded events
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.registerEvents = function() {
    var _this_binds;
    if (!((_this_binds = this.binds) === null || _this_binds === void 0 ? void 0 : _this_binds.length)) return;
    this.binds.forEach(({ name: name, func: func, data: data, type: type })=>{
        if (type === (0, $bf7f47488c894fdf$export$86d9a347f2bf71d6).DOM_EVENT) this.getDomWriter().bind(name, data, func);
        else if (type === (0, $bf7f47488c894fdf$export$86d9a347f2bf71d6).CUSTOM_EVENT && this.getPage().isRerendering) jQuery(this).bind(name, data, func);
    });
};
/**
 * unregister all binded events.
 * note we dont touch the bind array, cause we might rebind it at a later moment. ie rerender
 * used by framework
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.unregisterEvents = function() {
    var _this_binds;
    if (!((_this_binds = this.binds) === null || _this_binds === void 0 ? void 0 : _this_binds.length)) return;
    this.getDomWriter().unbind();
    jQuery(this).unbind();
};
/**
 * sets control enabled /disabled
 * we basicly add a css class. so, make sure your css file contains this css classes
 * TODO this is not nice, can it be done otherwise?
 *
 * @param {boolean} e         True when enabled
 * @param {boolean} recursive Also enable/disable child controls
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.setEnabled = function(e, recursive) {
    this.triggerEvent('onSetEnabled', e);
    this.enabled = e;
    if (this.isRendered) this.getDomWriter().prop('disabled', !e);
    if (recursive) this.controls.forEach((child)=>{
        var _child_setEnabled;
        return (_child_setEnabled = child.setEnabled) === null || _child_setEnabled === void 0 ? void 0 : _child_setEnabled.call(child, e, true);
    });
    return this;
};
$5983bd27facb3353$export$ff49c445471d74bb.prototype.getEnabled = function() {
    return this.enabled;
};
/**
 * returns html markup string of control + all child controls
 *
 * @return {String}
 */ $5983bd27facb3353$export$ff49c445471d74bb.prototype.getHtml = function(markAsRendered, nocache) {
    //if (nocache) {
    this.cachedElement = undefined;
    //}
    const tag = this.getTagName();
    const attrs = this.getHtmlAttributes();
    const controlsHtml = this.controls.map((child)=>child instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976) ? child.getHtml(markAsRendered, true) : child).join('');
    const html = `<${tag} ${attrs}>${controlsHtml}</${tag}>`;
    if (markAsRendered) this.isRendered = true;
    return html;
};



class $53fe8439ad8103ec$export$2ddb90ad54e5f587 extends (0, $5983bd27facb3353$export$ff49c445471d74bb) {
    init() {
        super.init();
        this.tagName = 'div';
    }
}
$53fe8439ad8103ec$export$2ddb90ad54e5f587.prototype.getTagName = function() {
    return this.tagName;
};


/**
 * @author Gillis Haasnoot <gillis.haasnoot@gmail.com>
 * @package Banana
 * @summary Page
 */ 

/**
 * @author Gillis Haasnoot <gillis.haasnoot@gmail.com>
 * @package Banana.Util
 * @summary Dom Helper. dom writer for various banana actions
 */ /**
 * responsible for writing dom elements
 */ /**
 * @class
 * @name Banana.Util.DomHelper
 * @constructor
 */ const $16a8694255569d68$export$1fdf8a6251f5e19a = /** @lends Banana.Util.DomHelper.prototype */ {
    /**
	 * renders control to target
	 *
	 * @param {String} data
	 * @param {mixed} target Banana.Control or dom id
	 *
	 */ render: function(data, target1) {
        if (typeof target1 === 'string') jQuery('#' + target1).append(data);
        else jQuery('#' + target1.getClientId()).append(data);
    },
    /**
	 * renders control to target
	 *
	 * @param {String} data
	 * @param {mixed} target Banana.Control or dom id
	 *
	 */ renderBefore: function(data, before) {
        if (typeof target === 'string') jQuery('#' + before).before(data);
        else jQuery('#' + before.getClientId()).before(data);
    },
    /**
	 * replaces content with another
	 *
	 * @param {String} data
	 * @param {mixed} target Banana.Control or dom id
	 */ replace: function(data, target1) {
        if (typeof target1 === 'string') jQuery(target1).replaceWith(data);
        else jQuery('#' + target1.getClientId()).replaceWith(data);
    },
    /**
	 * renders plain html to target
	 *
	 * @param {String} data
	 * @param {mixed} target Banana.Control or dom id
	 * @param {boolean} dontAppend If true we replace existing data. Otherwise append
	 */ renderHtml: function(html, target1, dontAppend) {
        if (target1.getClientId() === 'body') {
            if (dontAppend) jQuery('body').html(html);
            else jQuery('body').append(html);
        } else if (dontAppend) jQuery('#' + target1.getClientId()).html(html);
        else jQuery('#' + target1.getClientId()).append(html);
    },
    /**
	 * removes all child elements from control
	 *
	 * @param {Banana.Control} control
	 */ clear: function(control) {
        jQuery('#' + control.getClientId()).empty();
    },
    /**
	 * removes control from dom. removing also removes all child dom elements
	 *
	 * @param {Banana.Control} control
	 */ remove: function(control) {
        if (typeof control === 'string') jQuery('#' + control).remove();
        else //seems that first clearing it and then removing it is a lot faster see http://api.jquery.com/remove/#expr but doesnt work somehow find out why
        //jQuery('#'+control.getClientId()).clear().remove();
        jQuery('#' + control.getClientId()).remove();
    },
    /**
	 * sets data on dom element.
	 *
	 * @param {String} value
	 * @param {Banana.Control} control
	 */ setData: function(value, control) {
        jQuery('#' + control.getClientId()).val(value);
    },
    /**
	 * Dedicated function to set text data on labels
	 *
	 * @param {String} value
	 * @param {Banana.Controls.Label} control
	 */ setTextData: function(value, control) {
        jQuery('#' + control.getClientId()).text(value);
    },
    /**
	 * Dedictated function to set data on checkboxes
	 *
	 * @param {String} value
	 * @param {Banana.Controls.Checkbox} control
	 */ setCheckBoxData: function(value, control) {
        if (value) jQuery('#' + control.getClientId()).prop({
            'checked': true
        });
        else jQuery('#' + control.getClientId()).prop('checked', false);
    },
    /**
	 * gets data from dom data control
	 * @param {Banana.Control} control
	 * @return {String}
	 */ getData: function(control) {
        return jQuery('#' + control.getClientId()).val();
    },
    /**
	 * dedicated function to retreive data from checkboxes
	 * @param {Banana.Controls.Checkbox} control
	 * @return {String}
	 */ getCheckBoxData: function(control) {
        return jQuery('#' + control.getClientId()).prop("checked");
    },
    /**
	 * Mark all controls as cleared.
	 * Method is used during page transitions where new pages are rendered first, before the old one
	 * is removed.
	 * TODO: potentialy dangerous if user already used 'cleared' id somewhere. I suggest different id
	 * @param {String} id used to mark dom elements
	 */ clearIdsFrom: function(id) {
        jQuery('#' + id + ' *').attr({
            'id': 'cleared'
        });
        jQuery('#' + id).attr({
            'id': 'cleared'
        });
    }
};



class $f92ae9cc12ea9b4f$export$6955bcca4cd3539f extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
        this.addCssClass('BPage');
        this.uniqueId = 0;
        this.validators = [];
        this.dataSets = [];
        if (!this.resizefunc) this.resizefunc = ()=>{
            this.onWindowResize(this);
        };
        window.addEventListener("resize", this.resizefunc);
        if (!this.visibilityChangeFunc) this.visibilityChangeFunc = ()=>{
            this.onVisibilityChange(this);
        };
        document.addEventListener("visibilitychange", this.visibilityChangeFunc);
        if (!this.offlineFunc) this.offlineFunc = ()=>{
            this.onOffline(this);
        };
        addEventListener("offline", this.offlineFunc);
        if (!this.onlineFunc) this.onlineFunc = ()=>{
            this.onOnline(this);
        };
        addEventListener("online", this.onlineFunc);
    }
}
/**
 * reference to application Default = Banana.Application
 * @param {Banana.Application} app
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.setApplication = function(app) {
    this.application = app;
};
/**
 * @return {Banana.Application}
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.getApplication = function() {
    return this.application;
};
/**
 * Starting point to initialize new page render.
 * The application is responsible for calling this method
 *
 * @param {mixed} target could be a string or object. in case of string we assume we have a dom id.
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.run = function(target) {
    this.validationControls = {};
    this.initRender(this, target || this.getApplication().settings.renderTarget);
};
/**
 * initialize rendering process
 *
 * @param {Banana.Control} control
 * @param {Banana.UiControl} target
 * @param {Banana.UiControl} place optional replace control
 * @param {boolean} wasRendering true if this control is already in a rerender phase
 * @param {boolean} parentRerendering true when parent control is currently rerendering
 * @param {int} parentRerendering index of control
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.initRender = function(control, target, place, wasRerendering, parentRendering, index) {
    this.rendering = true;
    if (wasRerendering) {
        //if the page was already rerendering we dont need to render this action again
        //we still need to rerender and register events on the control.
        this.renderControl(control, target, place, index);
        this.rendering = false;
        this.recursiveRegisterEvents(control);
        return;
    }
    this.isRendered = false;
    this.initializeControl(control, target);
    this.renderControl(control, target, place, index);
    this.isRendered = true;
    this.setVisible(true);
    //some controls are not Banana.Controls but plain text
    if (control && control.triggerEvent) control.triggerEvent('renderComplete', this);
    //if parent is already rendering we dont have to register events
    //parent control will do that for us
    if (!parentRendering) {
        this.recursiveRegisterEvents(control);
        //only set this boolean to false when parent is not rerendering. then the parent will eventualy make sure that
        //this bool will be false
        this.rendering = false;
        this.parentFirstTimeRendering = false;
    }
    //	console.log("------> page run -> rupdatedisplay");
    this.recursiveUpdateDisplay(control);
//	console.log("------> page run -> rupdatedisplay complte");
};
/**
 * rerenders control
 *
 * @param {Banana.Control} control
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.rerender = function(control) {
    ///this bool is needed in the following situation:
    // call method updatedisplay on child controls from current method updatedisplay
    // creates a situation that the the isRerendering bool is set to false in the first updatedisplay
    // updatedisplay A -> isRerendering = true
    // updateDisplay B -> isRerendering = true
    // updateDisplay B is finished we set isRerendering to false
    // updateDisplay A is not finished yet and still needs to register events. but isRerendering is false
    // to prevent this situation we added this bool
    var parentRerendering = this.isRerendering;
    var parentRendering = this.rendering;
    //exception case
    if (parentRendering && !parentRerendering) this.parentFirstTimeRendering = true;
    this.isRerendering = true;
    if (!parentRendering) this.recursiveUnRegisterEvents(control);
    var orig = control.getFirstUiControl();
    var parentControl = orig.getParent();
    this.initRender(control, parentControl, orig, parentRerendering, parentRendering);
    // Restore this.isRerendering
    this.isRerendering = parentRerendering;
};
/**
 * sets content placeholder page
 *
 * @param {PageTemplate} ph
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.setContentPlaceHolder = function(ph) {
    this.contentPlaceHolder = ph;
};
/**
 * gets content placeholder
 *
 * @return  {PageTemplate}
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.getContentPlaceHolder = function() {
    return this.contentPlaceHolder;
};
/**
 * sets content placeholder page
 *
 * @param {PageTemplate} ph
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.setPageTemplate = function(ph) {
    this.contentPlaceHolder = ph;
};
/**
 * gets content placeholder
 *
 * @return  {PageTemplate}
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.getPageTemplate = function() {
    return this.contentPlaceHolder;
};
/**
 * Hides loader
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.hideLoader = function() {
    if (!this.loader) return;
    this.loader.hide();
};
/**
 * Datasets are to centralize data storage of your controls
 * You can either use stand alone datasets and manually assign them to your controls or
 * add datasets to the page and let the page automatically handle the data.
 *
 * @param {String} id for the dataset
 * @param {Banana.Data.DataSet} the dataset
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.addDataSet = function(id, d) {
    if (this.dataSets[id]) return;
    d.id = id;
    this.dataSets[id] = d;
};
/**
 * @return Banana.Data.DataSet
 *
 * @param string id of the dataset
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.getDataSet = function(id) {
    return this.dataSets[id];
};
/**
 *    removes all datasets from page
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.removeDataSets = function() {
    var index;
    for(index in this.dataSets){
        if (typeof this.dataSets[index] === 'function') continue;
        this.dataSets[index].clear();
    }
    this.dataSets = [];
};
/**
 * validates all controls
 *
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.isValid = function() {
    return Banana.Util.ValidationManager.validateAll();
};
/**
 * initialize controls
 * this method walks through all controls and sets the following things
 *
 * clientId -> for all Banana.Controls
 * parent -> parent control holding this control
 * page -> reference to the page
 *
 * Page also automatically binds controls to their datasets
 *
 * @param {Banana.Control} control
 * @param {Banana.Control} target control used to determine parent
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.initializeControl = function(control, target) {
    //only handle banana controls
    if (!(control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976))) return;
    //if the target is not a ui control we fetch the first anchester which is a ui control
    if (target instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        if (!control.clientId) //control.setClientId(target.getClientId()+"-"+this.uniqueId++);
        control.setClientId("b" + ++window.domuuid);
    // if (window.domuuid > 100000){
    // 	window.domuuid = 0;
    // }
    } else {
        var sn = this.getApplication().settings.applicationName;
        if (sn) control.setClientId(sn + this.uniqueId++);
        else control.setClientId(this.uniqueId++);
    }
    control.setParent(target);
    control.setPage(this);
    if (!control.isInitialized) {
        /*
        @createComponents Method is applied on all controls during creation of the page.
        In this state thi
        */ control.createComponents();
        control.isInitialized = true;
        //bs/bd[0] = dataset name
        //bs/bd[1] = dataset property name
        var bs = control.bindedDataSource;
        if (bs) {
            if (this.getDataSet(bs[0])) this.getDataSet(bs[0]).bindControlToDataSource(control);
        }
        var bd = control.bindedData;
        if (bd) {
            if (this.getDataSet(bd[0])) this.getDataSet(bd[0]).bindControlToData(control);
        }
    }
    // Because in the create components other controls can be added, we
    // call this function after the createComponents
    var childs = control.getControls();
    var i, len;
    for(i = 0, len = childs.length; i < len; i++)this.initializeControl(childs[i], control);
};
/**
 * We render the control by fetching all html data from the control.
 *
 * @param {Banana.Control|String} control Control which should be rendered.
 * @param {Banana.Control} target The target where the control should be rendered in.
 * @param {Banana.Control} place (optional) If given we replace the old control html data with new data
 * @param {int} place (optional) If given we insert data at given index.
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.renderControl = function(control, target, place, index) {
    if (target instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) target.cachedElement = undefined;
    if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        control.cachedElement = undefined;
        var data = control.getHtml(true);
    } else data = control;
    if (index != undefined) {
        if (target.controls[index]) (0, $16a8694255569d68$export$1fdf8a6251f5e19a).renderBefore(data, target.controls[index]);
        else {
            console.error("cannot add control at this index ", index);
            (0, $16a8694255569d68$export$1fdf8a6251f5e19a).render(data, target);
        }
    } else if (place) (0, $16a8694255569d68$export$1fdf8a6251f5e19a).replace(data, place);
    else (0, $16a8694255569d68$export$1fdf8a6251f5e19a).render(data, target);
};
/**
 * Call updateDisplay on all controls in the hierarchy
 *
 * Controls can perform post-render actions in this function. These
 * will also be called on rerender.
 *
 * As a side-effect, the isRendered-property of all controls will be set.
 * This should happen in the {@link #renderControl}-function, but we don't
 * have a recursive pass there.
 *
 * Events are not registered yet in updateDisplay!
 *
 * @param {Banana.Control|string} control Control which is rendered
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.recursiveUpdateDisplay = function(control) {
    if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        // TODO: a parent control asking a child control to be rendered returns false.
        // but in reality it is rendered. This flag should be moved to earlier phase
        control.isRendered = true;
        control.updateDisplay();
        var childs = control.getControls();
        var i, len;
        for(i = 0, len = childs.length; i < len; i++)this.recursiveUpdateDisplay(childs[i]);
    }
};
/**
 * Register all binded events to control
 *
 * @param {Banana.Control|string} control
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.recursiveRegisterEvents = function(control) {
    if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        control.registerEvents();
        var childs = control.getControls();
        var i, len;
        for(i = 0, len = childs.length; i < len; i++)this.recursiveRegisterEvents(childs[i]);
    }
};
/**
 * unregister events from control
 *
 * @param {Banana.Control} control
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.recursiveUnRegisterEvents = function(control) {
    if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        control.onPreInvalidateContents();
        control.unregisterEvents();
        if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
            var childs = control.getControls();
            var i, len;
            for(i = 0, len = childs.length; i < len; i++)this.recursiveUnRegisterEvents(childs[i]);
        }
    }
};
/**
 * completely removes a control from dom and data model
 *
 * @param Banana.Control
 * @param bool dont remove dom when true. this is an optimalisation.
 * from the controls which are getting removed, the root items (the one user want to remove) should
 * be treated differently.
 *
 * <Root item>                               -  <ChildItems>
 * parent control collection altered            parent control collection stays
 * call dom remove                              dont call dom remove (done in root)
 *
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.removeControl = function(control, dontRemoveDom) {
    if (!(control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976))) return;
    var childs = control.controls.slice(); //slice to clone
    var i;
    for(i = childs.length - 1; i >= 0; i--){
        this.removeControl(childs[i], true);
        childs.pop();
    }
    control.unregisterEvents();
    control.unload();
    if (!dontRemoveDom) (0, $16a8694255569d68$export$1fdf8a6251f5e19a).remove(control);
    //if our control got a parent, then we also need to remove it from the parent array controls
    //we only do this is we directly call remove on this control, otherwise we remove the controls array anywayy
    var parent = control.parent;
    if (parent) {
        var indexInParent = parent.controls.indexOf(control);
        parent.controls.splice(indexInParent, 1);
    }
    control = undefined;
};
/**
 * clears a control by removing all children
 *
 * @param {Banana.Control} control
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.clearControl = function(control) {
    var childs = control.getControls().slice();
    var totalCleared = 0;
    var i, len;
    for(i = 0, len = childs.length; i < len; i++){
        totalCleared++;
        this.removeControl(childs[i], true);
    }
    control.controls = null;
    childs = null;
    //TODO added this to also remove non object controls ie strings.
    //move this to domhelper.js
    if (control.cachedElement) control.cachedElement.empty();
    else jQuery('#' + control.getClientId()).empty();
};
/**
 * removes complete page plus all its controls/events/binds and dom data
 * We traverse through child controls in a async operation. This is needed
 * to prevent slow script running detects by various browsers
 *
 * @param {boolean} keepDom when true we dont remove the dom
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.remove = function(keepPageDom, cb) {
    //get flatten depth first collection of control hierargie
    var flat = (0, $73ef6be17e83afdd$export$ec4de0bdc266f27)(this, 'controls');
    flat.pop(); //remove the last page which is {this} we handle {this} is the complete event
    (0, $73ef6be17e83afdd$export$1d97eda983b1d04)(flat, (control, i)=>{
        if (!(control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976))) return;
        control.unregisterEvents();
        control.unload();
        var parent = control.parent;
        if (parent && parent.controls) parent.controls.splice(parent.controls.indexOf(control), 1);
        control = undefined;
    }, 0, ()=>{
        this.unload();
        this.clearIds();
        //if we clear the page we also need to unregister the resize event. otherwise the callback will always
        //be called after screensize changes.
        window.removeEventListener("resize", this.resizefunc);
        document.removeEventListener("visibilitychange", this.visibilityChangeFunc);
        removeEventListener("online", this.onlineFunc);
        removeEventListener("offline", this.offlineFunc);
        //jQuery(window).unbind();
        this.unbind();
        this.removeDataSets();
        clearTimeout(this.timer);
        if (!keepPageDom) (0, $16a8694255569d68$export$1fdf8a6251f5e19a).remove(this);
        if (cb) cb();
    }, ()=>{
    //not implemented here
    });
};
/**
 * used internally -> should move to another location
 * @ignore
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.removeDom = function() {
    jQuery('#cleared').remove();
};
/**
 * @ignore
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.clearProps = function() {
//	var prop;
//	for (prop in this)
//	{
//		//this[prop] = undefined;
//	}
};
/**
 *
 * @param Banana.UiControl
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.onWindowResize = function(control) {
    if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        control.onWindowResize();
        var childs = control.getControls();
        var i, len;
        for(i = 0, len = childs.length; i < len; i++)this.onWindowResize(childs[i]);
    }
};
/**
 *
 * @param Banana.UiControl
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.onVisibilityChange = function(control) {
    if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        control.onVisibilityChange();
        var childs = control.getControls();
        var i, len;
        for(i = 0, len = childs.length; i < len; i++)this.onVisibilityChange(childs[i]);
    }
};
/**
 *
 * @param Banana.UiControl
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.onOffline = function(control) {
    if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        control.onOffline();
        var childs = control.getControls();
        var i, len;
        for(i = 0, len = childs.length; i < len; i++)this.onOffline(childs[i]);
    }
};
/**
 *
 * @param Banana.UiControl
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.onOnline = function(control) {
    if (control instanceof (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)) {
        control.onOnline();
        var childs = control.getControls();
        var i, len;
        for(i = 0, len = childs.length; i < len; i++)this.onOnline(childs[i]);
    }
};
/**
 * Clears all ids in the page.
 * Used by application during page transition.
 */ $f92ae9cc12ea9b4f$export$6955bcca4cd3539f.prototype.clearIds = function(control) {
    if (!control) control = this;
    (0, $16a8694255569d68$export$1fdf8a6251f5e19a).clearIdsFrom(control.getClientId());
};




class $3be81c086bc509fb$export$1773bf8c632ebee7 extends (0, $f92ae9cc12ea9b4f$export$6955bcca4cd3539f) {
    /**
	 * Creates a page template.
	 * A page template is no different from a page. 
	 * By default banana pages are loaded inside a page template.
	 * You might create your own page template with navigation buttons on top and a center
	 * where your pages are getting inserted and maybe a footer with some info. 
	 * @constructs
	 * @extends Banana.Page
	 */ init() {
        super.init();
        this.addCssClass("BPageTemplate");
        this.content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.content.addCssClass("BPageTemplateContent");
    }
    /**
	 * @override
	 */ createComponents() {
        this.addControl(this.content);
    }
    /**
	 * Initiates the render process
	 * Automatically called by the application
	 */ run() {
        if (!this.isRendered) super.run();
        else this.triggerEvent('renderComplete', this);
        this.pageControl.setApplication(this.getApplication());
        this.pageControl.run(this.content);
    }
    /**
	 * Automatically called by the application
	 * @param {Banana.Page} page
	 */ addPageControl(page) {
        page.setContentPlaceHolder(this);
        this.pageControl = page;
    }
}





var $fRpWP = parcelRequire("fRpWP");
window.domuuid = 0;
class $38ca654a9d34084c$export$16975c34e60e1e61 extends (0, $bf7f47488c894fdf$export$7a7fa4424cb20976) {
    initApplication(settings) {
        console.log("STARTING APPLICATION", settings);
        if (!jQuery) {
            console.error("JQuery is not found. JQuery required.");
            return;
        }
        this.settings = settings || {};
        this.id = 0; // Increments on each page load
        this.isLoadingPage = false;
        this.delayedSheduledPageLoad = [];
    }
    /**
     * Prepares the application for unload by removing event listeners and cleaning up resources.
     */ prepareUnload() {
        jQuery(window).on("beforeunload", ()=>{
            jQuery("*").unbind();
            if (this.activePage) this.activePage.remove();
            if (this.pageTemplate) this.pageTemplate.remove();
            Banana = null; // Assuming Banana is a global; otherwise, this could be removed
        });
    }
    /**
     * Loads the page template specified in the settings.
     */ loadPageTemplate() {
        const pageTemplateClass = this.settings.pageTemplate;
        if (!pageTemplateClass) {
            console.error("No page template defined. Please define one.");
            return;
        }
        this.pageTemplate = new pageTemplateClass();
    }
    /**
     * Returns the application settings.
     * @returns {Object} The settings object.
     */ getSettings() {
        return this.settings;
    }
    /**
     * Processes any delayed page load requests.
     */ processDelayedSheduledPageLoad() {
        if (this.delayedSheduledPageLoad.length > 0) {
            const { page: page, urlParams: urlParams, ignoreHistoryParams: ignoreHistoryParams, cb: cb } = this.delayedSheduledPageLoad.shift();
            this.loadPage(page, urlParams, ignoreHistoryParams, cb);
        }
    }
    /**
     * Loads a page by name, handling URL parameters and history.
     * @param {string} page - The page to load.
     * @param {Object} urlParams - URL parameters to set.
     * @param {boolean} ignoreHistoryParams - Whether to ignore history parameters.
     * @param {Function} cb - Callback after page load.
     * @param {Object} pageParams - Additional parameters for the page.
     */ loadPage(page, urlParams, ignoreHistoryParams, cb, pageParams) {
        if (this.isLoadingPage) {
            this.delayedSheduledPageLoad.push({
                page: page,
                urlParams: urlParams,
                ignoreHistoryParams: ignoreHistoryParams,
                cb: cb
            });
            console.warn("Cannot load page while loading another page. Delaying.");
            return;
        }
        this.isLoadingPage = true;
        (0, $fRpWP.UrlManager).saveModuleHistory("section");
        (0, $fRpWP.UrlManager).clearUrl();
        this.loadingWithHistory = !ignoreHistoryParams;
        if (this.loadingWithHistory) {
            const history = (0, $fRpWP.UrlManager).getModuleHistory(page);
            for(const key in history)if (history.hasOwnProperty(key)) {
                (0, $fRpWP.UrlManager).registerModule(key);
                (0, $fRpWP.UrlManager).setModule(key, history[key], true);
            }
        }
        if (urlParams) {
            for(const key in urlParams)if (urlParams.hasOwnProperty(key)) {
                (0, $fRpWP.UrlManager).registerModule(key);
                (0, $fRpWP.UrlManager).setModule(key, urlParams[key], true);
            }
        }
        this.run(page, cb, pageParams);
    }
    /**
     * Instantiates a single page instance.
     */ instantiateSinglePage() {
        if (!this.pageTemplate) this.loadPageTemplate();
        this.page.bind("renderComplete", ()=>{
            if (this.activePage) {
                this.activePage.removeDom();
                this.activePage.clearProps();
                this.activePage = undefined;
            }
            this.activePage = this.page;
            this.activePage.setVisible(true);
            this.isLoadingPage = false;
            this.processDelayedSheduledPageLoad();
        });
        this.page.setVisible(false);
        this.pageTemplate.addPageControl(this.page);
        this.pageTemplate.setApplication(this);
        this.pageTemplate.run(this);
    }
    /**
     * Runs the specified page.
     * @param {string|Page} page - The page to run (string name or Page instance).
     * @param {Function} cb - Callback after running the page.
     * @param {Object} params - Parameters for the page.
     */ run(page, cb, params) {
        if (page instanceof (0, $f92ae9cc12ea9b4f$export$6955bcca4cd3539f)) {
            this.page = page;
            return this.instantiateSinglePage();
        }
        this.triggerEvent("onPreLoadPage");
        if (!this.activePage) (0, $fRpWP.UrlManager).autoRegisterModules();
        if (!this.pageTemplate) this.loadPageTemplate();
        const section = page || (0, $fRpWP.UrlManager).getModule("section") || this.settings.defaultPage;
        this.section = section;
        this.pageTemplate.triggerEvent("preLoadPage", section);
        this.registerUrlSection(section);
        if (!this.loadingWithHistory) (0, $fRpWP.UrlManager).updateUrl(true);
        const loadPage = ()=>{
            if (!this.settings.pages[section]) {
                console.error(`Page ${section} not found. Loading default page.`);
                this.isLoadingPage = false;
                return this.loadPage(this.settings.defaultPage);
            }
            const pageClass = new this.settings.pages[section](params);
            this.id++;
            const newPage = pageClass;
            newPage.bind("renderComplete", ()=>{
                if (this.activePage) {
                    this.activePage.removeDom();
                    this.activePage.clearProps();
                    this.activePage = undefined;
                }
                this.activePage = newPage;
                this.activePage.setVisible(true);
                this.isLoadingPage = false;
                this.processDelayedSheduledPageLoad();
            });
            newPage.setVisible(false);
            this.pageTemplate.addPageControl(newPage);
            this.pageTemplate.setApplication(this);
            if (this.activePage) (0, $fRpWP.UrlManager).updateUrl(false);
            else (0, $fRpWP.UrlManager).updateUrl(true);
            this.pageTemplate.run();
            (0, $fRpWP.UrlManager).unlistenModule("section");
            (0, $fRpWP.UrlManager).listenModule("section", ()=>{
                this.loadPage((0, $fRpWP.UrlManager).getModule("section"));
            });
            if (cb) cb();
        };
        if (this.activePage) {
            (0, $fRpWP.UrlManager).stopChecking();
            this.activePage.remove(true, ()=>{
                (0, $fRpWP.UrlManager).startChecking();
                loadPage();
            });
        } else loadPage();
    }
    /**
     * Registers the section URL and binds a change event to it.
     * @param {string} section - The section to register.
     */ registerUrlSection(section) {
        (0, $fRpWP.UrlManager).registerModule("section", section);
        (0, $fRpWP.UrlManager).setModule("section", section, true);
    }
    constructor(settings){
        super();
        this.initApplication(settings);
    }
}




/**
 * @author Gillis Haasnoot <gillis.haasnoot@gmail.com>
 * @package Banana.Controls
 * @summary Base data control. Provides functionality to act as a data control 
 */ 

/**
 * @author Gillis Haasnoot <gillis.haasnoot@gmail.com>
 * @package Banana.Controls
 * @summary Dataset
 */ 
class $0d02f8fa33e24d2e$export$486059efd2d2dabe extends (0, $bf7f47488c894fdf$export$7a7fa4424cb20976) {
    /**
	 * Datasets are local storages to maintain data in one central place and provide all or parts of the data to controls.
	 * All DataControls within banana have bindDataSet and bindDataSourceSet methods available to bind on a specific dataset.
	 * 
	 * it looks like this
	 * 
	 * Control.bindDataSet("datasetName","optionalProperty");  
	 * 
	 * the optionalProperty is used when you supply a complex object as data in your dataset.
	 * For example
	 * 
	 * var data = {"value1":"foo","value2":"foo2"}
	 * Control.bindDataSet("datasetName",value1);
	 * 
	 * Data can be of any type. Strings, Arrays or Deep nested arrays/objects.
	 * 
	 * Changing data in controls propagates back to the dataset to maintain consistent data.
	 * There are 3 ways of getting data from the dataset
	 * 1. getData() retreives the original data. changes in controls will not affect this data, unless commitControlData is used
	 * 2. getControlData() retreives only data which have registered controls on it
	 * 3. getChangedDataSet() retreives all data with the latest by controls modified data
	 * 
	 * When new data is inserted in the dataset all controls are getting updated with new data.
	 * Sometimes you are using complex data like 
	 * var data = {"value1":{'id':12,'name':'foo'}}
	 * When you update the dataset with new data like
	 * var data = {"value1":{'id':12,'name':'foo foo foo foo foo foo'}}
	 * You want to keep the references pointing to the same origin. Dataset handles this for you by suppling a key with setDataKey() on the dataset
	 * 
	 * If new data is inserted only data which is changed will affect controls. This increases performance.
	 * 
	 * use dataset.clientUpdate to make data visible into the controls
	 * @constructs
	 * @extends Banana.Control
	 */ init() {
        this.dataKey = 'id';
        this.isChanged = false;
        this.controlRegisterModified = false;
    }
    /**
	 * @param {String} id sets the datakey which is used to maintain key value pointer references
	 */ setDataKey(id1) {
        this.dataKey = id1;
    }
    /**
	 * Clears the dataset by removing internal data and unregisters all controls
	 */ clear() {
        this.unregisterEvents();
        this.registeredDataSourceControls = undefined;
        this.registeredDataControls = undefined;
        this.data = undefined;
        this.oldData = undefined;
    }
    /**
	 * we overwrite the bind function to detect if a user listens to controldatachaged events
	 * if so, we register on every control attached to this dataset a listener.
	 */ bind(name, func) {
        if (name == 'controlDataChanged') this.enableControlChangeEvent = true;
        return super.bind(name, func);
    }
    /**
	 * clears the data in all controls
	 */ clearControlData() {
        for(id in this.registeredDataSourceControls){
            var c = this.registeredDataSourceControls[id];
            if (c.bindedDataSource) {
                if (c.bindedDataSource[1]) c.setDataSource(null, true);
            }
        }
        for(id in this.registeredDataControls){
            var c = this.registeredDataControls[id];
            if (c.bindedData) {
                if (c.bindedData[1]) c.setData(null, true);
            }
        }
        this.oldData = undefined;
        jQuery(this).trigger('dataChanged', this.data); //is this a good place????
    }
    /**
	 * sets data in dataset
	 * We check if previous data is changed compared to new data.
	 * if so we copy all new properties to the old data, to make sure our object references stay intact.
	 * this is specialy usefull to prevent changes between items
	 *
	 * so that only changed controls are getting updated
	 * @param {mixed} d data
	 * @param {boolean} ignoreEqualCheck when true we dont check if new data is equal to old.
	 * @return {this} 
	 */ setData(d, ignoreEqualCheck) {
        this.allowControlUpdate = true;
        //when new controls are added to this dataset we always update
        //if this.data and new data are the same, we just trigger change event
        if (this.data != d && this.data && !this.controlRegisterModified) {
            //if the datas are not the same we copy references, otherwise we do nothing
            if (ignoreEqualCheck || !Banana.Util.ObjectsAreEqual(d, this.data)) {
                Banana.Util.CopyTo(d, this.data, this.dataKey);
                this.triggerEvent('dataChanged');
            } else {
                this.allowControlUpdate = false;
                this.triggerEvent('dataUnchanged');
            }
        } else {
            this.data = d;
            this.triggerEvent('dataChanged');
        }
        return this;
    }
    /**
	 * resets control to original data
	 */ resetControls() {
        if (!this.getData()) return;
        this.allowControlUpdate = true;
        this.clientUpdate();
    }
    /**
	 * returns data in dataset
	 * always returns most up to date data
	 * 
	 * @return {mixed} data
	 */ getData() {
        return this.data;
    }
    /**
	 * @return {boolean} true when data is changed. 
	 */ getIsChanged() {
        return this.isChanged;
    }
    /**
	 * updates all registered controls with the current dataset data
	 */ clientUpdate() {
        if (!this.allowControlUpdate) return false;
        for(id in this.registeredDataSourceControls){
            var c = this.registeredDataSourceControls[id];
            if (c.bindedDataSource) this.setControlDataSource(c);
        }
        for(id in this.registeredDataControls){
            var c = this.registeredDataControls[id];
            if (c.bindedData) {
                if (c.bindedData[1]) this.setControlData(c);
            }
        }
        this.controlRegisterModified = false;
        this.isChanged = false;
    }
    /**
	 * Retreives the data from all registered data controls.
	 * Besides the data we also have the original data and isDataChanged boolean
	 * @param {flattened} when true we just return a key value object 
	 * @return {object} 
	 */ getControlData(flattened) {
        var d = {};
        for(var id1 in this.registeredDataControls){
            var c = this.registeredDataControls[id1];
            var data = c.getData();
            if (!c.id) {
                if (!(c instanceof Banana.Controls.DataControl)) continue;
            }
            if (flattened) {
                if (data === undefined) cd = null;
                else cd = data;
            } else {
                var cd = {};
                cd['originalData'] = null;
                cd['isDataChanged'] = true;
                if (this.getData()) {
                    cd['originalData'] = this.getDataByPath(c.bindedData[1]) || null;
                    cd['isDataChanged'] = this.getDataByPath(c.bindedData[1]) != data;
                }
                if (data === undefined) cd['data'] = null;
                else cd['data'] = data;
            }
            //we want to ensure datastructures
            this.ensureObjectFromPath(d, c.bindedData[1], cd);
        }
        return d;
    }
    /**
	 * Get the dataset with changed values from input fields
	 *
	 * @return {mixed} The dataset
	 */ getChangedDataSet() {
        var d = this.getData() || {};
        for(var id1 in this.registeredDataControls){
            var c = this.registeredDataControls[id1];
            if (!(c instanceof Banana.Controls.DataControl)) continue;
            //if bindedfield is like xxx.yyy.zzz we make sure that the data is in same path
            var field = c.bindedData[1];
            var sfield = field.split('.');
            this.ensureObjectFromPath(d, field);
            this.setDataByPath(c.getData(), field);
        }
        return d;
    }
    /**
	 * Persist the data from the controls to the dataset.
	 * This function should be used after a successful save to
	 * reset the dataChanged flags.
	 */ commitControlData() {
        var d = {};
        for(var id1 in this.registeredDataControls){
            var c = this.registeredDataControls[id1];
            if (!(c instanceof Banana.Controls.DataControl)) continue;
            d = this.ensureObjectFromPath(d, c.bindedData[1], c.getData());
        }
        this.setData(d);
        return this;
    }
    /**
	 * ensures an object contains properties acording to dot limited path
	 * additionaly possible to insert data at last property
	 *
	 * @param {object} obj
	 * @param {string} path i.e test.sub.subsu
	 * @param {object} props to insert at last property
	 * @param {string} refpath used by function
	 * @param {object} refObj used by function
	 *
	 */ ensureObjectFromPath(obj, path, props, refpath, refObj) {
        if (!path) {
            refObj[refpath] = props;
            return;
        }
        var split = path.split('.');
        refObj = obj;
        if (!obj[split[0]]) obj[split[0]] = {};
        var s = split[0];
        split.splice(0, 1);
        refpath = path;
        var path = split.join('.');
        this.ensureObjectFromPath(obj[s], path, props, refpath, refObj);
        return obj;
    }
    /**
	 * sets data on control from dataset data
	 *
	 * @param {Banana.Controls.DataControl} c
	 * @param {mixed} d
	 */ setControlData(c, d) {
        var data = this.getData() === null ? null : this.getDataByPath(c.bindedData[1]);
        c.setData(data);
        c.triggerEvent('controlDataBinded', data);
    }
    /**
	 * sets datasource data on control from dataset data
	 *
	 * @param {Banana.Controls.DataControl} c
	 */ setControlDataSource(c) {
        if (c.bindedDataSource[1]) {
            var d = this.getDataByPath(c.bindedDataSource[1]);
            c.setDataSource(d);
        } else c.setDataSource(this.getData());
        c.triggerEvent('controlDataSourceBinded');
    }
    /**
	 * @param {String} path
	 * @returns {mixed} 
	 */ getDataByPath(path) {
        path = path.split('.');
        var d = this.getData();
        if (!d) return d;
        for(var i = 0, len = path.length; i < len; i++){
            d = d[path[i]];
            if (d == undefined) return null;
        }
        return d;
    }
    /**
	 * sets data by path
	 * 
	 * @param {mixed} data
	 * @param {String} path
	 */ setDataByPath(data, path) {
        path = path.split('.');
        var d = this.getData();
        var refPath = null;
        if (path.length == 1) refPath = path;
        else {
            var d = this.getData();
            var refPath = null;
            for(var i = 0, len = path.length; i < len - 1; i++)d = d[path[i]];
            //our reference path is the last one in given path
            refPath = path[path.length - 1];
        }
        d[refPath] = data;
        return d;
    }
    /**
	 * binds data from dataset to datasource in control
	 *
	 * @param {Banana.Controls.DataControl} c
	 */ bindControlToDataSource(c) {
        this.controlRegisterModified = true;
        if (!this.registeredDataSourceControls) this.registeredDataSourceControls = {};
        if (!this.registeredDataSourceControls[c.getId()]) {
            if (this.getData()) this.setControlDataSource(c);
            this.registeredDataSourceControls[c.getId()] = c;
        }
    }
    /**
	 * binds data from dataset to data in control
	 *
	 * @param {Banana.Controls.DataControl} c
	 */ bindControlToData(c) {
        this.controlRegisterModified = true;
        if (!this.registeredDataControls) this.registeredDataControls = {};
        if (!this.registeredDataControls[c.getId()]) {
            if (this.getData()) this.setControlData(c);
            if (this.enableControlChangeEvent) c.bind('dataChanged', this.getProxy(this.controlChangedHandler));
            this.registeredDataControls[c.getId()] = c;
        }
    }
    /**
	 * handler for change events.
	 * checks current changed control and store changed status in an array
	 * this is needed to track changes of controls.
	 * only when all checked controls are equal to original data we fire a restoreevent. unaffected controls are playing no
	 * role in the descision of firing the change or restore event
	 *
	 * TODO needs to be improved. Could slow down things a bit
	 *
	 * @param Event e
	 */ controlChangedHandler(e) {
        if (!this.controlChecks) this.controlChecks = {};
        var c = e.currentTarget;
        var orgData = this.getData() === null ? '' : this.getDataByPath(c.bindedData[1]);
        orgData = orgData || '';
        if (orgData != e.currentTarget.data) this.controlChecks[e.currentTarget.id] = false;
        else this.controlChecks[e.currentTarget.id] = true;
        for(index in this.controlChecks)if (this.controlChecks[index] == false) {
            this.triggerEvent('controlDataChanged');
            return;
        }
        this.triggerEvent('controlDataRestored');
        return;
    }
    /**
	 * unbinds controls from this dataset
	 *
	 * @param {Banana.Controls.DataControl} c
	 */ unBindControl(c) {
        this.controlRegisterModified = true;
        delete this.registeredDataControls[c.getId()];
    }
    /**
	 * unbinds control from this dataset
	 *
	 * @param {Banana.Controls.DataControl} c
	 */ unBindDataSourceControl(c) {
        if (!this.registeredDataSourceControls) return;
        this.controlRegisterModified = true;
        delete this.registeredDataSourceControls[c.getId()];
    }
}


class $44ba6ae0e222a615$export$c3b2237bc022073a extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    /**
	 * Creates a base data control. Most Data controls in Banana are derived from this base data control.
	 * It adds set/get data support. And as well support to bind to datasets. @see Banana.Data.DataSet
	 * Changes made in controls are automatically redirected to the data property to ensure always up to date data.
	 * Still you can as a user bind on the 'dataChanged' event to listen to data changes.
	 * Depending on the type of the control you can also use dom events to detect changes.  
	 * 
	 * @constructs
	 * @extends Banana.Controls.Panel
	 */ init() {
        super.init();
        this.addCssClass('BDataControl');
        this.isChanged = false;
    }
    /**
	 * @override
	 */ updateDisplay() {
        super.updateDisplay();
        this.setDomData(this.data);
    }
}
/**
 *	Sets data on control.
 *	when this function is called we also trigger a datachanged event and update the dom.
 *
 *	@param {mixed} data for control
 *	@param {boolean} ignoreEvent when true no datachanged is triggered. This is useful when you are running in a circle or performance issues.
 *	@param {boolean} ignoreDom when true setDomData function is not called. Useful in cases of optimizing performance.
 *  @return {this}
 *
 */ $44ba6ae0e222a615$export$c3b2237bc022073a.prototype.setData = function(data, ignoreEvent, ignoreDom) {
    this.data = data;
    if (!ignoreEvent) this.triggerEvent('dataChanged', data);
    if (!ignoreDom) this.setDomData(data);
    return this;
};
/**
 * returns the most up to date data from the control
 *
 * @return {mixed} data
 */ $44ba6ae0e222a615$export$c3b2237bc022073a.prototype.getData = function() {
    return this.data;
};
/**
 * binds data to the Dom element
 * 
 * @ignore
 * @param {mixed} data
 *
 */ $44ba6ae0e222a615$export$c3b2237bc022073a.prototype.setDomData = function(data) {
    if (this.isRendered && this.data !== undefined) (0, $16a8694255569d68$export$1fdf8a6251f5e19a).setData(data, this);
};
/**
 * @ignore
 * @return data from dom element
 */ $44ba6ae0e222a615$export$c3b2237bc022073a.prototype.getDomData = function() {
    if (this.isRendered) return (0, $16a8694255569d68$export$1fdf8a6251f5e19a).getData(this);
};
/**
 * binds a value from data from dataset to data in this control
 *
 * @param {mixed} Banana.Data.DataSet || name of the dataset
 * @param {string} bind property of the data. can be like value.subvalue.subsubvalue
 * @return {this}
 */ $44ba6ae0e222a615$export$c3b2237bc022073a.prototype.dataSetBind = function(set, bind) {
    this.bindedData = [
        set,
        bind
    ];
    if (set instanceof (0, $0d02f8fa33e24d2e$export$486059efd2d2dabe)) set.bindControlToData(this);
    else if (this.isRendered) {
        if (this.getPage().getDataSet(bd[0])) this.getPage().getDataSet(bd[0]).bindControlToData(this);
    }
    return this;
};
/**
 * Unbinds this control from dataset
 * @param {mixed} Banana.Data.DataSet || name of the dataset
 *
 */ $44ba6ae0e222a615$export$c3b2237bc022073a.prototype.unDataSetBind = function(set) {
    this.bindedData = null;
    if (set instanceof (0, $0d02f8fa33e24d2e$export$486059efd2d2dabe)) {
        set.bindControlToData(this);
        set.unBindControl(this);
    } else {
        set = this.getPage().getDataSet(set);
        set.unBindControl(this);
    }
    return this;
};



class $37cbb85645b0d818$export$b04be29aa201d4f5 extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    init() {
        super.init();
        this.addCssClass('BLabel');
        this.tagName = 'label';
    }
    setData(data, ignoreEvent, ignoreDom) {
        super.setData(data, true, ignoreDom);
        this.addControl(data);
        return this;
    }
    setTagName(tag) {
        this.tagName = tag;
        return this;
    }
    getTagName() {
        return this.tagName;
    }
}
$37cbb85645b0d818$export$b04be29aa201d4f5.prototype.setForControl = function(control) {
    this.setAttribute('for', control.clientId);
};
$37cbb85645b0d818$export$b04be29aa201d4f5.prototype.setDomData = function(data) {
    if (this.isRendered) {
        if (data == undefined) data = '';
        (0, $16a8694255569d68$export$1fdf8a6251f5e19a).setTextData(data, this);
    }
};



class $df64cf20c6ea21bc$export$3e431a229df88919 extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    init() {
        super.init();
    }
}
$df64cf20c6ea21bc$export$3e431a229df88919.prototype.setImage = function(image) {
    this.setAttribute('src', image);
    return this;
};
$df64cf20c6ea21bc$export$3e431a229df88919.prototype.setTitle = function(title) {
    this.setAttribute('title', title);
    return this;
};
$df64cf20c6ea21bc$export$3e431a229df88919.prototype.getTagName = function() {
    return 'img';
};
$df64cf20c6ea21bc$export$3e431a229df88919.prototype.setDomData = function(data) {
    jQuery('#' + this.getClientId()).attr({
        'src': data
    });
};



var $fRpWP = parcelRequire("fRpWP");

var $fRpWP = parcelRequire("fRpWP");

var $dNeVp = parcelRequire("dNeVp");
localStorage.states = {};
const $f8e803ab7d0be49a$export$4d5c8163a511d38a = {
    stateKey: "statemanager12632",
    savePageState: function(pageName, data) {
        var states = localStorage.getItem(this.stateKey + pageName);
        if (!states) states = {};
        else states = JSON.parse(states);
        states[location.href] = data;
        localStorage.setItem(this.stateKey + pageName, JSON.stringify(states));
    },
    purgeNonImportant: function() {
        console.log("purge non important localstorage items");
        var i, key;
        return;
    },
    getCurrentPageState: function(pageName) {
        var states = localStorage.getItem(this.stateKey + pageName);
        if (!states) return null;
        var parsed = JSON.parse(states);
        return parsed[location.href];
    },
    flushPageState: function(pageName) {
        localStorage.removeItem(this.stateKey + pageName);
    },
    getNavigationState: function() {
        return history.state;
    },
    storeNavigationState: function(data) {
        history.replaceState(data, "match", location.href);
    }
} ///window.StateManager = StateManager;
;


parcelRequire("3SrKy");
const $2ee970b2529997d7$export$55185c17a0fcbe46 = {
    bannerManuallyHidden: false,
    init: function() {
        window.addEventListener('popstate', function(event) {
        /// alert("location: " + document.location + ", state: " + JSON.stringify(event.state));
        });
        $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
    },
    showMatchScreen: function(page, data) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        (0, $dNeVp.ManiaCache).setMemoryCache("match", data);
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("Match", {
            "mid": data.id,
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 300);
    //
    },
    showHome: function(page, ignoreStateSaveOnUnload) {
        window.lastBannerLoad = null;
        var referalData = {
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        };
        if (window.firstIsPageLoaded) $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        //mark home page to not store state. so we enter a fresh new home page
        //only applicable when we are in home page
        page.pageControl.ignoreStateSaveOnUnload = ignoreStateSaveOnUnload;
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState("Home");
        AppInstance.loadPage("Home", referalData);
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
        }, 1000);
        if ($2ee970b2529997d7$export$55185c17a0fcbe46.bannerManuallyHidden) {
            $2ee970b2529997d7$export$55185c17a0fcbe46.bannerManuallyHidden = false;
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 400);
    },
    showAgendaScreen: function(date) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("Agenda", {
            "date": date,
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 400);
    },
    showCountryLeaguesScreen: function(data) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("CountryLeagues", {
            "cid": encodeURI(data.country),
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 400);
    },
    showLeagueScreen: function(data, extradata) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        if (extradata) AppInstance.loadPage("League", {
            "extradata": btoa(encodeURI(JSON.stringify(extradata))),
            "lid": data.key || data.leagueKey || data.keygs,
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        else AppInstance.loadPage("League", {
            "lid": data.key || data.leagueKey || data.keygs,
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 300);
    },
    showTeamScreen: function(id) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("Team", {
            "tid": id,
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 1000);
    },
    showPlayerScreen: function(id) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("Player", {
            "pid": id,
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 400);
    },
    showCoachScreen: function(id) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("Coach", {
            "cid": id,
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 300);
    },
    showPlayerMarketValues: function(selectedPlayerId) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        var params = {};
        if (selectedPlayerId) {
            params.selectedPlayerId = selectedPlayerId;
            AppInstance.loadPage("PlayerValuesRanking", {
                "spid": selectedPlayerId,
                "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
            }, false, function() {}, params);
        } else AppInstance.loadPage("PlayerValuesRanking", {
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {}, params);
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 200);
    },
    showTopVoters: function() {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("TopVoters", {
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 200);
    },
    showNews: function(id) {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("News", {
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
        }, 1000);
        if (AppInstance.getConfig().appmode == "ios") $2ee970b2529997d7$export$55185c17a0fcbe46.hideBanner();
    },
    showFifaRanking: function() {
        window.lastBannerLoad = null;
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("Fifaranking", {
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 200);
    },
    showForumIndex: function() {
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("ForumIndex", {
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
            $2ee970b2529997d7$export$55185c17a0fcbe46.showBanner();
        }, 300);
    },
    showForumChat: function(index, name) {
        $2ee970b2529997d7$export$55185c17a0fcbe46.showInterstitial();
        $2ee970b2529997d7$export$55185c17a0fcbe46.hideBanner();
        AppInstance.activePage.onPageDetached();
        AppInstance.loadPage("ForumChat", {
            "index": index,
            "title": encodeURI(name),
            "referalData": $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData()
        }, false, function() {});
        setTimeout(function() {
            $2ee970b2529997d7$export$55185c17a0fcbe46.updateSessionTime();
        }, 1000);
    },
    showSettings: function() {
        if (window.JSAndroidBridge) window.JSAndroidBridge.showSettings();
        else AppInstance.loadPage("Settings");
    },
    voteMatch: function(matchid, side) {
        window.lastBannerLoad = null;
        if (window.JSAndroidBridge) window.JSAndroidBridge.voteMatch(matchid, side);
    },
    updateSessionTime: function() {
        if (window.JSAndroidBridge && window.JSAndroidBridge.updateSessionLength) window.JSAndroidBridge.updateSessionLength();
    },
    loadInterstitial: function() {
        if (window.JSAndroidBridge) window.JSAndroidBridge.loadInterstitialAd();
    },
    showInterstitial: function() {
        if (window.JSAndroidBridge) window.JSAndroidBridge.showInterstitialAd();
    },
    showAdmobInterstitial: function() {
        if (window.JSAndroidBridge) window.JSAndroidBridge.showAdmobInterstitial();
    },
    showCustomInterstitial: function(forceShow, country, campaignId) {
        if (window.JSAndroidBridge) window.JSAndroidBridge.showCustomInterstitialAd(forceShow, country, campaignId);
    },
    showBanner: function() {
        if (window.lastBannerLoad && new Date().getTime() - window.lastBannerLoad < 5000) {
            console.warn("Banner already loaded recently");
            return;
        }
        window.lastBannerLoad = new Date().getTime();
        if (window.JSAndroidBridge) window.JSAndroidBridge.showBannerAd();
        else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosBridge) window.webkit.messageHandlers.iosBridge.postMessage({
            "method": "loadBanner"
        });
    },
    hideBanner: function() {
        if (window.JSAndroidBridge) {
            window.JSAndroidBridge.hideBannerAd();
            $2ee970b2529997d7$export$55185c17a0fcbe46.bannerManuallyHidden = true;
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosBridge) window.webkit.messageHandlers.iosBridge.postMessage({
            "method": "hideBanner"
        });
    },
    openUrl: function(url, newPage) {
        if (window.JSAndroidBridge && window.JSAndroidBridge.openWebPage) window.JSAndroidBridge.openWebPage(url, newPage ? true : false);
        else window.open(url, '_blank');
    },
    allowBackButtonQuitApp: function() {
        if (window.JSAndroidBridge) {
            console.log("allow back button quit");
            window.JSAndroidBridge.enableBackImmediateQuite();
        }
    },
    disallowBackButtonQuitApp: function() {
        if (window.JSAndroidBridge) {
            console.log("disallow back button quit");
            window.JSAndroidBridge.disableBackImmediateQuite();
        }
    },
    isNavigatedFromPush: function() {
        return (0, $fRpWP.UrlManager).getModule("fromPush") == 1;
    },
    getFutureReferalData: function() {
        var referalData = {
            "origin_section": (0, $fRpWP.UrlManager).getModule("section")
        };
        return btoa(JSON.stringify(referalData));
    },
    getCurrentReferalData: function() {
        var referalData = (0, $fRpWP.UrlManager).getModule("referalData");
        if (!referalData) return null;
        referalData = decodeURIComponent(referalData);
        //referalData = btoa(referalData);
        try {
            return JSON.parse(atob(referalData));
        } catch (e) {
            console.error("Invalid referal data", referalData);
            return null;
        }
    },
    updateCurrentReferalData: function() {
        var referalData = $2ee970b2529997d7$export$55185c17a0fcbe46.getFutureReferalData();
        //history.replaceState(referalData, undefined, "#referalData")
        (0, $fRpWP.UrlManager).registerModule("referalData");
        (0, $fRpWP.UrlManager).setModule("referalData", encodeURIComponent(referalData), true, true);
    },
    navigationIsFromOutside: function() {
        if (!$2ee970b2529997d7$export$55185c17a0fcbe46.getCurrentReferalData()) return false;
        return $2ee970b2529997d7$export$55185c17a0fcbe46.getCurrentReferalData().origin_section != (0, $fRpWP.UrlManager).getModule("section");
    }
};
$2ee970b2529997d7$export$55185c17a0fcbe46.init();



var $02mnx = parcelRequire("02mnx");

var $kc8Kt = parcelRequire("kc8Kt");
const $9f67281357957bbc$export$89d41d4ee5fc0b81 = {
    loadStickyBanner: function(target, cb) {
        if (!AppInstance.getConfig().enabledFeatures.stickyad) {
            console.warn("sticky ad disabled");
            return cb(true);
        }
        (0, $kc8Kt.DataProvider).getAdtekAd("sticky", (data)=>{
            if (!data.isOk()) {
                console.log("no sticky ad available");
                cb(true);
                return;
            }
            try {
                var html_string = data.getData();
                var iFrame = $("#" + target.getClientId());
                var iFrameParent = iFrame.parent();
                iFrame.remove();
                iFrame.attr('src', "data:text/html;charset=utf-8," + escape(html_string));
                iFrameParent.append(iFrame);
                cb();
            } catch (e) {
                console.error("failed to load house ad " + e);
                cb(true);
            }
        });
    },
    loadMediumRectangle: function(cb) {
        if (!AppInstance.getConfig().enabledFeatures.mrecad) {
            console.warn("mrec ad disabled");
            return cb(true);
        }
        (0, $kc8Kt.DataProvider).getAdtekAd("mrec", (data)=>{
            if (!data.isOk()) {
                console.log("no mrec ad available");
                cb(true);
                return;
            }
            try {
                cb(false, data.getData());
            } catch (e) {
                console.error("failed to load mrec ad " + e);
                cb(true);
            }
        });
    },
    loadHouseAd: function(target, cb) {
        if (!AppInstance.getConfig().enabledFeatures.housead) {
            console.warn("house ad disabled");
            return cb(true);
        }
        if (/Android/i.test(navigator.userAgent)) var type = "housead_android";
        else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) var type = "housead_ios";
        else {
            console.warn("no house ad for this device");
            return cb(true);
        }
        console.log("loading house ad " + type);
        (0, $kc8Kt.DataProvider).getAdtekAd(type, (data)=>{
            if (!data.isOk()) {
                console.log("no sticky ad available");
                cb(true);
                return;
            }
            try {
                var html_string = data.getData();
                var iFrame = $("#" + target.getClientId());
                var iFrameParent = iFrame.parent();
                iFrame.remove();
                iFrame.attr('src', "data:text/html;charset=utf-8," + escape(html_string));
                iFrameParent.append(iFrame);
                cb();
            } catch (e) {
                console.error("failed to load house ad " + e);
                cb(true);
            }
        });
    }
};


var $05ab3a9c7dc443e9$exports = {};

$05ab3a9c7dc443e9$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "loader1235.25bed157.svg";


class $0e26d0b3b103d6c2$export$db22d6a18a24ebf7 extends (0, $f92ae9cc12ea9b4f$export$6955bcca4cd3539f) {
    init() {
        super.init();
    }
    onVisibilityChange() {
        if (document.hidden) (0, $2ee970b2529997d7$export$55185c17a0fcbe46).hideBanner();
        else (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
    }
    //called when page controller wants to load a new page.
    onPageDetached() {
        this.isDetached = true;
    }
    isReferalOtherPage() {
        var referalData = (0, $fRpWP.UrlManager).getModule("referalData");
        if (referalData) {
            console.log("ref data", referalData);
            referalData = decodeURIComponent(JSON.stringify(referalData));
            console.log("ref data", referalData);
            if (referalData.origin_section == (0, $fRpWP.UrlManager).getModule("section")) return false;
            return true;
        }
        return true;
    }
    showLoader(text, bgOpacity) {
        if (this.wrapper) {
            if (text) this.loaderText.setData(text);
            this.wrapper.setVisible(true);
            return;
        }
        this.loaderContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.loaderContainer.addCssClass("loader_container");
        this.wrapper = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.wrapper.addCssClass("loader_wrapper");
        this.wrapper.addControl(this.loaderContainer);
        this.loaderSpinner = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.loaderSpinner.addCssClass("loader_spinner");
        this.loaderSpinner.setImage(new URL($05ab3a9c7dc443e9$exports));
        this.loaderContainer.addControl(`
        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
   <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>
        `);
        this.loaderText = new (0, $37cbb85645b0d818$export$b04be29aa201d4f5)();
        this.loaderText.setData();
        if (text) this.loaderText.setData(text);
        this.loaderText.addCssClass("loader_text");
        this.loaderContainer.addControl(this.loaderText);
        var fade = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        fade.addCssClass("loader_fade");
        this.wrapper.addControl(fade);
        var background = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        background.addCssClass("loader_background");
        this.loaderContainer.addControl(background);
        this.loaderfade = fade;
        this.getPage().addControl(this.wrapper, true);
    }
    showSucces(message, timeout) {
        console.log("show succes");
        if (this.feedbackPanel) this.feedbackPanel.remove();
        var feedbackPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        feedbackPanel.addControl(message);
        feedbackPanel.addCssClass("alert alert-success");
        feedbackPanel.addCssClass("feedbackPanel");
        feedbackPanel.setStyle("margin-top:-16px;");
        this.feedbackPanel = feedbackPanel;
        setTimeout(()=>{
            feedbackPanel.addCssClass("feedbackPanelFadeOut");
            setTimeout(this.getProxy(function() {
                feedbackPanel.remove();
            }), 1000);
        }, timeout);
        this.feedback.addControl(feedbackPanel, true);
    }
    showError(message, cb) {
        if (this.errorWrapper) this.errorWrapper.remove();
        var errorWrapper = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        errorWrapper.addCssClass("error");
        var errorImage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        errorImage.addCssClass("no-internet");
        errorWrapper.addControl(errorImage);
        errorWrapper.addControl((0, $02mnx.Localizer).getString("nointernet") + "<br>");
        errorWrapper.addControl((0, $02mnx.Localizer).getString("taptotryagain"));
        this.errorWrapper = errorWrapper;
        this.errorWrapper.unbind("click");
        this.errorWrapper.bind("click", ()=>{
            this.errorWrapper.remove();
            this.errorWrapper = null;
            cb();
        });
        this.getPage().addControl(this.errorWrapper, true);
    }
    showPageDataDoesNotExist(message, cb) {
        if (this.errorWrapper) this.errorWrapper.remove();
        var errorWrapper = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        errorWrapper.addCssClass("error");
        var errorImage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        errorImage.addCssClass("no-internet");
        errorWrapper.addControl(errorImage);
        errorWrapper.addControl((0, $02mnx.Localizer).getString("no_data") + "<br>");
        errorWrapper.addControl((0, $02mnx.Localizer).getString("tap_to_return"));
        this.errorWrapper = errorWrapper;
        this.errorWrapper.unbind("click");
        this.errorWrapper.bind("click", ()=>{
            this.errorWrapper.remove();
            this.errorWrapper = null;
            history.back();
        });
        this.getPage().addControl(this.errorWrapper, true);
    }
    showCriticalError(message, timeout) {
        if (this.feedbackPanel) this.feedbackPanel.remove();
        if (this.errorImage) this.errorImage.remove();
        var feedbackPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        feedbackPanel.addControl(message);
        feedbackPanel.addCssClass("alert alert-danger");
        feedbackPanel.addCssClass("feedbackPanel");
        feedbackPanel.setStyle("margin-top:-16px;");
        this.feedbackPanel = feedbackPanel;
        setTimeout(()=>{
            feedbackPanel.addCssClass("feedbackPanelFadeOut");
            setTimeout(()=>{
                feedbackPanel.remove();
            }, 1000);
        }, timeout);
        this.feedback.addControl(feedbackPanel, true);
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.addCssClass("error_image");
        //image.setImage(new URL("/images/oeps.svg", import.meta.url));
        this.errorImage = image;
        this.addControl(image, true);
    }
    setLoaderText(text, color) {
        if (this.loaderText) this.loaderText.setData(text);
        if (color) this.loaderText.setCss({
            'color': color
        });
    }
    hideLoader() {
        setTimeout(()=>{
            if (this.wrapper) {
                this.wrapper.remove();
                this.wrapper = null;
            }
        }, 1);
    }
}






/**
 * @author Gillis Haasnoot <gillis.haasnoot@gmail.com>
 * @package Banana.Controls
 * @summary Base input data control. Provides functionality to act as a input data control 
 */ 
class $2cf92be5dbbab152$export$574966fbea4a65e5 extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    /**
 	 * Abstract basic input control. will be rendered as <input></input>
 	 * Checkbox/radiobutton/text etc extends from this control
 	 *
	 * @constructs
	 * @extends Banana.Controls.DataControl
	 */ init() {
        super.init();
        this.bind('change', this.getProxy(this.onChange));
    }
}
/**
 * focus the input control
 * @return {this}
 */ $2cf92be5dbbab152$export$574966fbea4a65e5.prototype.focus = function() {
    jQuery('#' + this.clientId).focus();
    return this;
};
/**
 * this function is called after user changes something in the dom
 */ $2cf92be5dbbab152$export$574966fbea4a65e5.prototype.onChange = function() {
    this.setData(this.getDomData(), false, true);
    this.isChanged = true;
};
/**
 * @return {String}
 */ $2cf92be5dbbab152$export$574966fbea4a65e5.prototype.getTagName = function() {
    return 'input';
};
/**
 * @param {String} v value of the control
 * @return {this}
 */ $2cf92be5dbbab152$export$574966fbea4a65e5.prototype.setValue = function(v) {
    this.value = v;
    return this;
};
/**
 * @return {String} value of the control
 */ $2cf92be5dbbab152$export$574966fbea4a65e5.prototype.getValue = function() {
    return this.value;
};
/**
 * sets name of the input control. Not required!
 * @param {String} n
 * @return {this}
 */ $2cf92be5dbbab152$export$574966fbea4a65e5.prototype.setName = function(n) {
    this.name = n;
    return this;
};
/**
 * gets name of the input control
 * @return {String} 
 */ $2cf92be5dbbab152$export$574966fbea4a65e5.prototype.getName = function() {
    return this.name;
};



var $fRpWP = parcelRequire("fRpWP");


var $02mnx = parcelRequire("02mnx");
function $09f8d0da92f63b44$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}




var $fRpWP = parcelRequire("fRpWP");
class $b27fd2646652aa84$export$2b77a92f1a5ad772 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init(urlIdentifier, disableUrlHistory) {
        super.init();
        this.addCssClass("homodal");
        var bg = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        bg.addCssClass("homodal-bg");
        this.addControl(bg);
        this.bg = bg;
        var scrollPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        scrollPanel.addCssClass("homodal-scrollpanel");
        this.addControl(scrollPanel);
        this.scrollPanel = scrollPanel;
        var mainPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        mainPanel.addCssClass("homodal-mainpanel");
        this.scrollPanel.addControl(mainPanel);
        this.mainPanel = mainPanel;
        var mainPanelWrapper = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        mainPanelWrapper.addCssClass("homodal-mainpanel-wrapper");
        this.mainPanel.addControl(mainPanelWrapper);
        this.mainPanelWrapper = mainPanelWrapper;
        var marginPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        marginPanel.addCssClass("homodal-margin");
        mainPanelWrapper.addControl(marginPanel);
        var contentPanelBg = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        contentPanelBg.addCssClass("homodal-contentsbg");
        mainPanelWrapper.addControl(contentPanelBg);
        var contentPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        contentPanel.addCssClass("homodal-contents");
        marginPanel.addControl(contentPanel);
        this.contentPanel = contentPanel;
        var close = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        close.addCssClass("icon-close homodal-closeButton");
        contentPanel.addControl(close);
        this.addControl = function(control) {
            this.contentPanel.addControl(control, true);
        };
        if (!disableUrlHistory) {
            if (!urlIdentifier) urlIdentifier = "m_" + this.getId();
            this.urlIdentifier = urlIdentifier;
            if (!(0, $fRpWP.UrlManager).getModule(urlIdentifier)) {
                (0, $fRpWP.UrlManager).registerModule(urlIdentifier);
                (0, $fRpWP.UrlManager).setModule(urlIdentifier, "open");
            }
            (0, $fRpWP.UrlManager).listenModule(urlIdentifier, ()=>{
                console.log("received url event", urlIdentifier);
                if (!(0, $fRpWP.UrlManager).getModule(urlIdentifier)) {
                    console.log("received url event @3", urlIdentifier);
                    (0, $fRpWP.UrlManager).unlistenModule(urlIdentifier);
                    (0, $fRpWP.UrlManager).removeModule(urlIdentifier);
                    this.destroy();
                }
            });
        }
        close.bind("click", ()=>{
            if (!disableUrlHistory) history.back();
            this.destroy();
        });
    }
    updateDisplay() {
        this.bg.addCssClass("homodal-bg-ani");
        this.mainPanel.addCssClass("homodal-mainpanel-ani");
        this.reValidateSize();
        if (!this.disableHiding) {
            this.bg.bind("touchend", ()=>{
                this.destroy();
            });
            this.mainPanel.bind("click", (e)=>{
                e.stopPropagation(); //otherwise window click closes the modal
            });
            this.scrollPanel.bind("click", ()=>{
                this.destroy();
            });
            ///todo what about other onkeyup listeners?
            jQuery(window).unbind('keyup');
            jQuery(window).on('keyup', (e)=>{
                if (e.key == "Escape") this.destroy();
            });
        }
        this.getPage().triggerEvent("onModalOpen", this);
    }
    destroy() {
        jQuery(window).unbind('keyup');
        (0, $fRpWP.UrlManager).unlistenModule(this.urlIdentifier);
        //UrlManager.removeModule(this.urlIdentifier);
        this.bg.addCssClass("homodal-bg-closing");
        this.mainPanel.addCssClass("homodal-mainpanel-ani-close");
        var that = this;
        setTimeout(function() {
            that.remove();
        }, 200);
        this.getPage().triggerEvent("onModalClose", this);
    }
    reValidateSize() {
        var windowHeight = $(window).height();
        //this.mainPanel.setCss({"margin-top":Math.max(0,(((windowHeight-height)/2)))})
        this.mainPanel.setCss({
            "margin-top": "50px"
        });
        this.scrollPanel.setCss({
            "height": windowHeight + "px"
        });
        this.mainPanelWrapper.setCss({
            "height": windowHeight - 100 + "px"
        });
    }
    constructor(...args){
        super(...args), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "title", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "classname", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "disableHiding", false);
    }
}


class $b327ff81cc3a41d8$export$5137ec99f248330b extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    getTagName() {
        return 'iframe';
    }
}
class $b327ff81cc3a41d8$export$1457961a45169cfb extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
        this.isSlidedOut = true;
        this.voteEnabled = true;
    }
    createComponents() {
        this.addCssClass("ChatMenuPopup");
        if (this.isAdmin) this.setCss({
            "margin-bottom": "400px"
        });
        else this.setCss({
            "margin-bottom": "200px"
        });
        this.thumbup = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.thumbup.addCssClass("icon-thumbup menuchaticon");
        this.addControl(this.thumbup);
        this.thumbdown = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.thumbdown.addCssClass("icon-thumbdown menuchaticon");
        this.addControl(this.thumbdown);
        this.thumbup.bind("click", ()=>{
            if (!this.voteEnabled) {
                this.getPage().getPageTemplate().showToast((0, $02mnx.Localizer).getString("already_voted"));
                return;
            }
            this.triggerEvent("thumbup");
        });
        this.thumbdown.bind("click", ()=>{
            if (!this.voteEnabled) {
                this.getPage().getPageTemplate().showToast((0, $02mnx.Localizer).getString("already_voted"));
                return;
            }
            this.triggerEvent("thumbdown");
        });
        if (!this.isAdmin) return;
        this.adminMenu = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.adminMenu.addCssClass("icon-admin menuchaticon");
        this.addControl(this.adminMenu);
        this.adminMenu.bind("click", ()=>{
            this.triggerEvent("requestAdminMenu");
        });
    }
    enableVote(toggle) {
        this.voteEnabled = toggle;
        if (!toggle) {
            this.thumbdown.addCssClass("icon-thumb-disabled");
            this.thumbup.addCssClass("icon-thumb-disabled");
        } else {
            this.thumbdown.removeCssClass("icon-thumb-disabled");
            this.thumbup.removeCssClass("icon-thumb-disabled");
        }
    }
    slideIn() {
        this.isSlidedOut = false;
        this.addCssClass("chatmenuanimatein");
        this.removeCssClass("chatmenuanimateout");
    }
    slideOut() {
        //return;
        if (this.isSlidedOut) return;
        this.isSlidedOut = true;
        this.addCssClass("chatmenuanimateout");
        this.removeCssClass("chatmenuanimatein");
    }
}
class $b327ff81cc3a41d8$export$1b1752f8539f7991 extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier) {
        super.init(urlIdentifier);
    }
    unload() {
        clearTimeout(this.commentaryRefreshHandler);
    }
    setData(data) {
        this.data = data;
    }
    createComponents() {
        var username = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        username.addControl(this.data.un);
        username.addCssClass("adminmenuusername");
        this.addControl(username);
        var removeMessage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        removeMessage.addCssClass("adminmenuitem");
        removeMessage.setCss({
            "margin-top": "27px"
        });
        removeMessage.addControl((0, $02mnx.Localizer).getString("Remove message"));
        removeMessage.bind("click", ()=>{
            this.triggerEvent("removeMessage");
        });
        this.addControl(removeMessage);
        // var editMessage = new Panel();
        // editMessage.addCssClass("adminmenuitem");
        // editMessage.addControl(Localizer.getString("Edit message"));
        // editMessage.bind("click",()=>{ this.triggerEvent("editMessage"); });
        // this.addControl(editMessage);
        var banUser1day = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        banUser1day.addCssClass("adminmenuitem");
        banUser1day.addControl((0, $02mnx.Localizer).getString("Ban user 1 day"));
        banUser1day.bind("click", ()=>{
            this.triggerEvent("banUser1day");
        });
        this.addControl(banUser1day);
        var banUser7day = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        banUser7day.addCssClass("adminmenuitem");
        banUser7day.addControl((0, $02mnx.Localizer).getString("Ban user 7 days"));
        banUser7day.bind("click", ()=>{
            this.triggerEvent("banUser7days");
        });
        this.addControl(banUser7day);
        var banUser356day = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        banUser356day.addCssClass("adminmenuitem");
        banUser356day.addControl((0, $02mnx.Localizer).getString("Ban user 365 days"));
        banUser356day.bind("click", ()=>{
            this.triggerEvent("banUser365days");
        });
        this.addControl(banUser356day);
        var unbanUser = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        unbanUser.addCssClass("adminmenuitem");
        unbanUser.addControl((0, $02mnx.Localizer).getString("Unban user"));
        unbanUser.bind("click", ()=>{
            this.triggerEvent("unbanuser");
        });
        this.addControl(unbanUser);
        var userMessage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        userMessage.addControl(this.data.m);
        userMessage.addCssClass("adminmenumessage");
        this.addControl(userMessage);
    }
}


const $893ad9ebb6e0883d$export$61165f5ad0de9ff6 = {
    defaultListType: '1',
    getShowOnlyFavoritesAgenda: function() {
        var set = localStorage.getItem("showOnlyFavoritesAgenda");
        if (set == 1) return true;
        return false;
    },
    setShowOnlyFavoritesAgenda: function(value) {
        localStorage.setItem("showOnlyFavoritesAgenda", value ? 1 : 0);
        jQuery(this).trigger("showOnlyFavoritesAgendaChanged", value ? 1 : 0);
    },
    getUserNewsLocale: function() {
        localStorage.getItem("userpref_newslocale");
    },
    setUserNewsLocale: function(value) {
        localStorage.setItem("userpref_newslocale", value);
        jQuery(this).trigger("userpref_newslocaleChanged", value);
    },
    setMatchListType: function(value) {
        localStorage.setItem("userpref_matchlisttype", value);
        jQuery(this).trigger("userpref_matchlistTypeChanged", value);
    },
    getMatchListType: function() {
        return localStorage.getItem("userpref_matchlisttype") || AppInstance.getConfig().graphics.defaultMatchListType;
    },
    bind: function(name, func, data) {
        jQuery(this).bind(name, data, func);
    },
    unbind: function(name, func) {
        jQuery(this).unbind(name, func);
    }
};


const $40e70090f1e1ff2d$export$5510f7c459d7063c = {
    applyTheme: function(theme) {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem("mtheme", theme);
    },
    autoApplyTheme: function() {
        console.log("auto apply theme");
        if (FootballManiaConfig.useAndroidThemeAndSizes && window.JSAndroidBridge) {
            let androidTheme = window.JSAndroidBridge.getTheme();
            var theme;
            if (androidTheme == 3) theme = "light";
            else if (androidTheme == 2) theme = "dark";
            else if (androidTheme == 3) theme = "blue";
            else theme = "blue";
            document.documentElement.setAttribute('data-theme', theme);
        } else {
            let theme = localStorage.getItem("mtheme");
            //let theme = false;
            if (!theme) {
                console.log("no user defined theme found");
                if (window.matchMedia) {
                    console.log("use system prefers-color-scheme");
                    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                        theme = "dark";
                        console.log("found system prefers-color-scheme: dark -> set to ", theme);
                    } else if (window.matchMedia('(prefers-color-scheme: light)').matches) {
                        theme = "dark";
                        console.log("found NO system prefers-color-scheme: -> set to ", theme);
                    } else {
                        console.log("no system prefers-color-scheme found -> set to default", FootballManiaConfig.defaultTheme);
                        theme = FootballManiaConfig.defaultTheme;
                        this.applyTheme(FootballManiaConfig.defaultTheme);
                    }
                    //add a listener to change the theme if the system changes the theme
                    if (!this.mediaChangeListener) {
                        this.mediaChangeListener = (event)=>{
                            console.log("changed event", event);
                            this.autoApplyTheme();
                        };
                        window.matchMedia('(prefers-color-scheme:dark)').addEventListener('change', this.mediaChangeListener);
                    }
                } else {
                    console.log("no system prefers-color-scheme supported -> set to default", FootballManiaConfig.defaultTheme);
                    theme = FootballManiaConfig.defaultTheme;
                    this.applyTheme(FootballManiaConfig.defaultTheme);
                }
                document.documentElement.setAttribute('data-theme', theme);
            } else //console.log("auto apply theme", theme);
            document.documentElement.setAttribute('data-theme', theme);
        }
    },
    getCurrentTheme: function() {
        return document.documentElement.getAttribute('data-theme');
    },
    getCurrentSize: function() {
        return document.documentElement.getAttribute('data-sizes') || "medium";
    },
    applySizes: function(size) {
        document.documentElement.setAttribute('data-sizes', size);
        localStorage.setItem("msizes", size);
    },
    autoApplySize: function() {
        if (FootballManiaConfig.useAndroidThemeAndSizes && window.JSAndroidBridge) {
            let androidFontSize = window.JSAndroidBridge.getFontSizes();
            //console.log("use android sizes",androidFontSize);
            var size;
            if (androidFontSize == 1) size = "small";
            else if (androidFontSize == 2) size = "medium";
            else if (androidFontSize == 3) size = "large";
            else if (androidFontSize == 4) size = "xlarge";
            else size = "medium";
            document.documentElement.setAttribute('data-sizes', size);
        } else {
            let size = localStorage.getItem("msizes");
            if (!size) this.applySizes(FootballManiaConfig.defaultSize);
            else document.documentElement.setAttribute('data-sizes', size);
        }
    }
};
if (window != undefined) window.ThemeManager = $40e70090f1e1ff2d$export$5510f7c459d7063c;




var $3SrKy = parcelRequire("3SrKy");
const $542851713e8a5d10$export$60959659b2c22881 = {
    storageKeyMatch: "matchSubscriptions",
    storageKeyTeam: "teamSubscriptions",
    storageKeyLeague: "leagueSubscriptions",
    getSubscribedMatches: function() {
        if (this.cachedSubscribedMatches) return this.cachedSubscribedMatches;
        var data = [];
        try {
            var raw = localStorage.getItem(this.storageKeyMatch);
            data = JSON.parse(raw);
            if (!data) data = [];
        } catch (e) {
            console.warn("error getting subscribed matches ", e);
        }
        this.cachedSubscribedMatches = data;
        return data;
    },
    getSubscribedTeams: function() {
        if (this.cachedSubscribedTeams) return this.cachedSubscribedTeams;
        var data = [];
        try {
            var raw = localStorage.getItem(this.storageKeyTeam);
            data = JSON.parse(raw);
            if (!data) data = [];
        } catch (e) {
            console.warn("error getting subscribed teams ", e);
        }
        this.cachedSubscribedTeams = data;
        return data;
    },
    getSubscribedLeagues: function() {
        if (this.cachedSubscribedLeagues) return this.cachedSubscribedLeagues;
        var data = [];
        try {
            var raw = localStorage.getItem(this.storageKeyLeague);
            data = JSON.parse(raw);
            if (!data) data = [];
        } catch (e) {
            console.warn("error getting subscribed leagues ", e);
        }
        this.cachedSubscribedLeagues = data;
        return data;
    },
    hasMatchSubscription: function(matchid) {
        return this.getSubscribedMatches().indexOf(matchid) != -1;
    },
    hasTeamSubscription: function(teamid) {
        return this.getSubscribedTeams().indexOf(teamid) != -1;
    },
    hasLeagueSubscription: function(key) {
        return this.getSubscribedLeagues().indexOf(key) != -1;
    },
    unsubscribeMatch: function(matchid, cb) {
        (0, $3SrKy.PushMessaging).unSubscribeMatch(matchid, (result)=>{
            if (!result) {
                console.warn("error usubscribing match ", matchid);
                if (cb) cb(false);
                return;
            }
            this.cachedSubscribedMatches = null;
            var data = this.getSubscribedMatches();
            data.splice(data.indexOf(matchid), 1);
            localStorage.setItem(this.storageKeyMatch, JSON.stringify(data));
            if (cb) cb(true);
        });
    },
    unsubscribeTeam: function(teamid, cb) {
        (0, $3SrKy.PushMessaging).unSubscribeTeam(teamid, (result)=>{
            if (!result) {
                console.warn("error unsubscribing team ", teamid);
                if (cb) cb(false);
                return;
            }
            this.cachedSubscribedTeams = null;
            var data = this.getSubscribedTeams();
            data.splice(data.indexOf(teamid), 1);
            localStorage.setItem(this.storageKeyTeam, JSON.stringify(data));
            if (cb) cb(true);
        });
    },
    unsubscribeLeague: function(key, cb) {
        (0, $3SrKy.PushMessaging).unSubscribeLeague(key, (result)=>{
            if (!result) {
                console.warn("error unsubscribing league ", key);
                if (cb) cb(false);
                return;
            }
            this.cachedSubscribedLeagues = null;
            var data = this.getSubscribedLeagues();
            data.splice(data.indexOf(key), 1);
            localStorage.setItem(this.storageKeyLeague, JSON.stringify(data));
            if (cb) cb(true);
        });
    },
    subscribeMatch: function(matchid, cb) {
        (0, $3SrKy.PushMessaging).subscribeMatch(matchid, (result)=>{
            if (!result) {
                console.warn("error subscribe match ", matchid);
                if (cb) cb(false);
                return;
            }
            this.cachedSubscribedMatches = null;
            var data = this.getSubscribedMatches();
            data.push(matchid);
            localStorage.setItem(this.storageKeyMatch, JSON.stringify(data));
            if (cb) cb(true);
        });
    },
    subscribeTeam: function(teamid, cb) {
        (0, $3SrKy.PushMessaging).subscribeTeam(teamid, (result)=>{
            if (!result) {
                console.warn("error subscribe team ", teamid);
                if (cb) cb(false);
                return;
            }
            this.cachedSubscribedTeams = null;
            var data = this.getSubscribedTeams();
            data.push(teamid);
            localStorage.setItem(this.storageKeyTeam, JSON.stringify(data));
            if (cb) cb(true);
        });
    },
    subscribeLeague: function(key, cb) {
        (0, $3SrKy.PushMessaging).subscribeLeague(key, (result)=>{
            if (!result) {
                console.warn("error subscribe league ", key);
                if (cb) cb(false);
                return;
            }
            this.cachedSubscribedLeagues = null;
            var data = this.getSubscribedLeagues();
            data.push(key);
            localStorage.setItem(this.storageKeyLeague, JSON.stringify(data));
            if (cb) cb(true);
        });
    },
    migrateAndroidMatchSubscriptions: function(newData) {
        localStorage.setItem(this.storageKeyMatch, newData);
    },
    migrateAndroidTeamSubscriptions: function(newData) {
        localStorage.setItem(this.storageKeyTeam, newData);
    },
    migrateAndroidLeagueSubscriptions: function(newData) {
        localStorage.setItem(this.storageKeyLeague, newData);
    }
};



var $kc8Kt = parcelRequire("kc8Kt");
const $aabc673d1ba8b527$export$db78e401119da622 = {
    storageLeagueKey: "leagueFavorites",
    storageTeamKey: "teamFavorites",
    cachedLeagueFavorites: null,
    cachedTeamFavorites: null,
    getFavoriteTeams: function() {
        // return {
        //     "6999" : "Club Universado",
        //     "6559" : "Club Energetik",
        //     "22853" : "Araz"
        // }
        if (this.cachedTeamFavorites) return this.cachedTeamFavorites;
        var data = {};
        try {
            var raw = localStorage.getItem(this.storageTeamKey);
            data = JSON.parse(raw);
            if (!data) data = {};
        } catch (e) {
            console.warn("error getting teams ", e);
        }
        for(var key in data)if (data[key].index == undefined) {
            console.log("incorrect team favorite indexing, fixing");
            var index = 0;
            for(var key in data){
                data[key].index = index;
                index++;
            }
            localStorage.setItem(this.storageTeamKey, JSON.stringify(data));
            break;
        }
        this.cachedTeamFavorites = data;
        return data;
    },
    hasFavoriteTeams: function() {
        var data = this.getFavoriteTeams();
        return Object.keys(data).length > 0;
    },
    isFavoriteTeam: function(key) {
        var data = this.getFavoriteTeams();
        return data[key] != undefined;
    },
    hasFavoriteLeagues: function() {
        var data = this.getFavoriteLeagues();
        return Object.keys(data).length > 0;
    },
    addFavoriteTeam: function(key, name) {
        this.cachedTeamFavorites = null;
        var data = this.getFavoriteTeams();
        var index = Object.keys(data).length;
        if (index > 20) return false;
        data[key] = {
            "name": name,
            "index": index
        };
        localStorage.setItem(this.storageTeamKey, JSON.stringify(data));
        return true;
    },
    removeFavoriteTeam: function(key) {
        this.cachedTeamFavorites = null;
        var data = this.getFavoriteTeams();
        var oldIndex = data[key].index;
        delete data[key];
        if (oldIndex != undefined) {
            for(var key in data)if (data[key].index > oldIndex) data[key].index = data[key].index - 1;
        }
        localStorage.setItem(this.storageTeamKey, JSON.stringify(data));
    },
    swapFavoriteTeams: function(key1, key2) {
        this.cachedTeamFavorites = null;
        var data = this.getFavoriteTeams();
        var index1 = data[key1].index;
        var index2 = data[key2].index;
        data[key1].index = index2;
        data[key2].index = index1;
        localStorage.setItem(this.storageTeamKey, JSON.stringify(data));
    },
    //[{key : "EnglandPremierLeague" , country: "england", name : "Premier League"}],
    getFavoriteLeagues: function() {
        if (this.cachedLeagueFavorites) return this.cachedLeagueFavorites;
        var data = {};
        try {
            var raw = localStorage.getItem(this.storageLeagueKey);
            data = JSON.parse(raw);
            if (!data) data = {};
            var keysToDelete = [];
            for(var key in data){
                if (!data[key].country || !data[key].name) {
                    console.warn("broken favorite league data, removing");
                    keysToDelete.push(key);
                }
                if (data[key].index == undefined) {
                    console.log("incorrect league favorite indexing, fixing");
                    var index = 0;
                    for(var key in data){
                        data[key].index = index;
                        index++;
                    }
                    localStorage.setItem(this.storageLeagueKey, JSON.stringify(data));
                    break;
                }
            }
            var deletedItems = false;
            for(var i = 0; i < keysToDelete.length; i++){
                delete data[keysToDelete[i]];
                deletedItems = true;
            }
            if (deletedItems) localStorage.setItem(this.storageLeagueKey, JSON.stringify(data));
        } catch (e) {
            console.warn("error getting leagues ", e);
        }
        this.cachedLeagueFavorites = data;
        return data;
    },
    addFavoriteLeague: function(key, country, name) {
        console.log("adding favorite league", key, country, name);
        this.cachedLeagueFavorites = null;
        var data = this.getFavoriteLeagues();
        var index = Object.keys(data).length;
        if (index > 25) return false;
        data[key] = {
            "country": country,
            "name": name,
            "index": index
        };
        localStorage.setItem(this.storageLeagueKey, JSON.stringify(data));
        this.cachedLeagueFavorites = null;
        return true;
    },
    removeFavoriteLeague: function(key) {
        console.log("removing favorite league", key);
        this.cachedLeagueFavorites = null;
        var data = this.getFavoriteLeagues();
        var oldIndex = data[key].index;
        delete data[key];
        if (oldIndex != undefined) {
            for(var key in data)if (data[key].index > oldIndex) data[key].index = data[key].index - 1;
        }
        localStorage.setItem(this.storageLeagueKey, JSON.stringify(data));
        this.cachedLeagueFavorites = null;
    },
    swapFavoriteLeagues: function(key1, key2) {
        this.cachedLeagueFavorites = null;
        var data = this.getFavoriteLeagues();
        var index1 = data[key1].index;
        var index2 = data[key2].index;
        data[key1].index = index2;
        data[key2].index = index1;
        localStorage.setItem(this.storageLeagueKey, JSON.stringify(data));
    },
    migrateAndroidFavoriteTeams: function(androidData) {
        var dict_reverse = function(obj) {
            var new_obj = {};
            var rev_obj = Object.keys(obj).reverse();
            rev_obj.forEach(function(i) {
                new_obj[i] = obj[i];
            });
            return new_obj;
        };
        //{"9446|1":"Wolves|9446|1","9002|1":"Arsenal|9002|1"}
        androidData = JSON.parse(androidData);
        var newData = {};
        for(var key in androidData){
            var split = androidData[key].split("|");
            newData[split[1]] = {
                name: split[0]
            };
        }
        newData = dict_reverse(newData);
        var index = 0;
        for(var key in newData){
            newData[key].index = index;
            index++;
        }
        localStorage.setItem(this.storageTeamKey, JSON.stringify(newData));
    },
    migrateAndroidFavoriteLeagues: function(androidData) {
        var dict_reverse = function(obj) {
            var new_obj = {};
            var rev_obj = Object.keys(obj).reverse();
            rev_obj.forEach(function(i) {
                new_obj[i] = obj[i];
            });
            return new_obj;
        };
        ///"{"EurocupsUEFAChampionsLeague":"UEFA Champions League|Eurocups","EnglandPremierLeague":"Premier League|England","WorldCupBrazil2014":"World Cup|World Cup"}
        androidData = JSON.parse(androidData);
        var newData = {};
        for(var key in androidData){
            var split = androidData[key].split("|");
            newData[key] = {
                "country": split[1],
                "name": split[0]
            };
        }
        newData = dict_reverse(newData);
        var index = 0;
        for(var key in newData){
            newData[key].index = index;
            index++;
        }
        localStorage.setItem(this.storageLeagueKey, JSON.stringify(newData));
    },
    saveLeagueFavorite: function() {}
};



var $dNeVp = parcelRequire("dNeVp");
const $0dbc6ded793568e1$export$1a7533566a41982d = {
    //there is a problem with the initSocialNetworks android native method
    //it is not sync and directly calling isloggedin after will return false
    init: function() {
        if (window.JSAndroidBridge) window.JSAndroidBridge.initSocialNetworks();
    },
    setManiaToken: function(token) {
        console.log("set mania token");
        localStorage.setItem("mania_token", token);
    },
    getManiaToken: function() {
        return localStorage.getItem("mania_token");
    },
    resetManiaToken: function() {
        localStorage.removeItem("mania_token");
    },
    requestManiaToken: function() {
        console.warn("not implemented");
    },
    isLoggedIn: function(str) {
        if (window.JSAndroidBridge) ///window.JSAndroidBridge.initSocialNetworks()
        return window.JSAndroidBridge.isLoggedIn();
        else return localStorage.getItem("socialloginweb");
    },
    requestLogin: function(cb1) {
        if (window.JSAndroidBridge) $0dbc6ded793568e1$var$AndroidSocializer.requestLogin(cb1);
        else $0dbc6ded793568e1$var$WebSocializer.requestLogin(cb1);
    },
    requestLogout: function(cb1) {
        localStorage.removeItem("mania_token");
        if (window.JSAndroidBridge) $0dbc6ded793568e1$var$AndroidSocializer.requestLogout(cb1);
        else {
            localStorage.removeItem("socialloginweb");
            if (cb1) cb1();
        }
    },
    decodeJwt: function(token) {
        var base64Payload = token.split(".")[1];
        var payload = decodeURIComponent(atob(base64Payload).split("").map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(payload);
    },
    getSocialUser: function() {
        if ($0dbc6ded793568e1$export$1a7533566a41982d.isLoggedIn()) {
            if (window.JSAndroidBridge) {
                let user = localStorage.getItem("socialloginandroid");
                if (user) {
                    var u = JSON.parse(user);
                    u.nw = 3;
                    u.maniatoken = $0dbc6ded793568e1$export$1a7533566a41982d.getManiaToken();
                    return u;
                }
            } else {
                let token = localStorage.getItem("socialloginweb");
                let u = $0dbc6ded793568e1$export$1a7533566a41982d.decodeJwt(token);
                return {
                    un: u.given_name,
                    image: u.picture,
                    pid: u.sub,
                    token: token,
                    nw: 10,
                    maniatoken: $0dbc6ded793568e1$export$1a7533566a41982d.getManiaToken()
                };
            }
        }
        return null;
    }
};
var $0dbc6ded793568e1$var$AndroidSocializer = {
    requestLogin: function(cb1) {
        window.removeEventListener("message", this.onWebviewMessagePosted);
        this.onWebviewMessagePosted = (response)=>{
            console.log("onWebviewMessagePosted login", response);
            window.removeEventListener("message", this.onWebviewMessagePosted);
            try {
                var responseData = JSON.parse(response.data);
                if (responseData.type == 0 && responseData.logged_in == 1) {
                    console.log("succesfully login in", responseData.user);
                    localStorage.setItem("socialloginandroid", JSON.stringify(responseData.user));
                    if (cb1) cb1(responseData);
                } else {
                    console.log("login failed");
                    //still try to login
                    if (window.JSAndroidBridge.isLoggedIn()) console.log("already logged in still", $0dbc6ded793568e1$var$AndroidSocializer.getSocialUser());
                    //AndroidSocializer.getSocialUser();
                    if (cb1) cb1(null);
                }
                console.log("reponseData", responseData);
            } catch (e) {
                console.log("error", e);
                if (cb1) cb1(null);
            }
        };
        window.addEventListener("message", this.onWebviewMessagePosted);
        window.JSAndroidBridge.initSocialNetworks();
        setTimeout(function() {
            window.JSAndroidBridge.requestLogin(3);
        }, 400);
    },
    getSocialUser: function() {
        window.removeEventListener("message", this.onWebviewMessagePosted);
        this.onWebviewMessagePosted = (response)=>{
            console.log("onWebviewMessagePosted get social user", response);
            window.removeEventListener("message", this.onWebviewMessagePosted);
            try {
                var responseData = JSON.parse(response.data);
                console.log(responseData);
            } catch (e) {
                console.log("error", e);
                if (cb) cb(null);
            }
        };
        window.addEventListener("message", this.onWebviewMessagePosted);
        window.JSAndroidBridge.initSocialNetworks();
        setTimeout(function() {
            window.JSAndroidBridge.getSocialUser();
        }, 500);
    },
    requestLogout: function(cb1) {
        window.addEventListener("message", this.onWebviewMessagePosted);
        this.onWebviewMessagePosted = function(response) {
            console.log("onWebviewMessagePosted logout", response);
            window.removeEventListener("message", this.onWebviewMessagePosted);
            if (cb1) cb1();
        };
        window.addEventListener("message", this.onWebviewMessagePosted);
        window.JSAndroidBridge.requestLogout(3);
    }
};
var $0dbc6ded793568e1$var$WebSocializer = {
    requestLogin: function(cb1) {
        console.log("========> requestLogin");
        AppInstance.loadJsScript("https://accounts.google.com/gsi/client", function() {
            console.log("google.accounts.id.initialize");
            google.accounts.id.initialize({
                client_id: '1041266175732-q9244ltvieieqlshg7o13j6l07llio4u.apps.googleusercontent.com',
                auto_select: true,
                callback: function(response) {
                    console.log("response", response);
                    if (response.credential) {
                        var jwt = response.credential;
                        var decoded = $0dbc6ded793568e1$export$1a7533566a41982d.decodeJwt(jwt);
                        localStorage.setItem("socialloginweb", jwt);
                        console.log("decoded", decoded);
                        if (cb1) cb1(decoded);
                    } else if (cb1) cb1(null);
                }
            });
            google.accounts.id.prompt((notification)=>{
                console.log(notification);
                if (notification.isNotDisplayed()) {
                    console.log('Login prompt was not displayed');
                    if (cb1) cb1(null);
                } else if (notification.isSkippedMoment()) {
                    console.log('Login prompt was skipped');
                    if (cb1) cb1(null);
                } else console.log('Login prompt was displayed');
            });
        }, function() {
            console.log("google.accounts.id.initialize error. script not loaded");
            if (cb1) cb1(null);
        });
    }
};
//if window
if (typeof window !== 'undefined') window.Socializer = $0dbc6ded793568e1$export$1a7533566a41982d;



var $02mnx = parcelRequire("02mnx");




var $02mnx = parcelRequire("02mnx");

var $6K7Df = parcelRequire("6K7Df");

class $1e85e6e9406b695f$export$199856d717696aba extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier, data) {
        super.init(urlIdentifier);
        this.data = data;
    }
    reValidateSize() {
        var windowHeight = $(window).height();
        //this.mainPanel.setCss({"margin-top":Math.max(0,(((windowHeight-height)/2)))})
        this.mainPanel.setCss({
            "margin-top": "50px"
        });
        this.scrollPanel.setCss({
            "height": windowHeight + "px"
        });
        this.mainPanelWrapper.setCss({
            "height": windowHeight - 150 + "px"
        });
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 200) + "px;justify-content: flex-start;align-items: flex-start;overflow-y:scroll;");
        // p.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("addFavoriteModalTitle");
        title.addControl((0, $02mnx.Localizer).getString("select_news_from_country"));
        this.addControl(title);
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
        //
        var selectedColor = "#285a99";
        for(var i = 0; i < AppInstance.getConfig().availableNewsLocales.length; i++){
            var lang = AppInstance.getConfig().availableNewsLocales[i];
            this.renderLanguageItem(lang, p);
        }
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.setStyle("font-size: 11px;margin-top: 10px;margin-bottom: 10px;");
        title.addControl((0, $02mnx.Localizer).getString("description_add_news_source"));
        this.addControl(title);
    }
    renderLanguageItem(lang, target) {
        var mainContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        mainContainer.addCssClass("flexHorizontalAlign");
        mainContainer.setStyle("width:100%;height:45px;border-bottom: 1px solid gray;cursor:pointer;");
        if (lang.includes("-")) lang = lang.split("-")[1];
        var languageName = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        languageName.addControl((0, $6K7Df.CountryUtil).getCountryByLocale(lang == "en" ? "uk" : lang, AppInstance.getConfig().userLocale));
        languageName.setStyle("margin-inline-start: 10px;align-self: center;");
        var flagsAndSelector = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        flagsAndSelector.addCssClass("flexHorizontalAlign");
        var flagContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        flagContainer.addCssClass("flexHorizontalAlign");
        var country = lang == "en" ? "united kingdom" : (0, $6K7Df.CountryUtil).getCountryByLocale(lang, "EN");
        var flag = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        flag.setStyle("width:40px;height:40px;margin-inline-end:4px;");
        flag.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + country.replaceAll(" ", "-").toLowerCase() + ".png", 30, 30);
        flagContainer.addControl(flag);
        var selector = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        selector.setStyle("background-color:red;width:40px;height:40px;margin-inline-start: 10px;align-self: center;");
        flagsAndSelector.addControl(flagContainer);
        //flagsAndSelector.addControl(selector);
        mainContainer.addControl(languageName);
        mainContainer.addControl(flagsAndSelector);
        target.addControl(mainContainer);
        mainContainer.bind("click", this.getProxy(function() {
            (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setUserNewsLocale(lang);
            navigation.back();
        }));
    }
}





class $dcf731dd052ddaa7$export$48513f6b9f8ce62d extends (0, $2cf92be5dbbab152$export$574966fbea4a65e5) {
    init() {
        super.init();
        this.bind('change', this.getProxy(this.onChange));
        this.setData(false);
        this.setAttribute('type', 'checkbox');
    }
}
/**
 * focus the input control
 * @return {this}
 */ $dcf731dd052ddaa7$export$48513f6b9f8ce62d.prototype.focus = function() {
    jQuery('#' + this.clientId).focus();
    return this;
};
/**
 * this function is called after user changes something in the dom
 */ $dcf731dd052ddaa7$export$48513f6b9f8ce62d.prototype.onChange = function() {
    this.setData(this.getDomData(), false, true);
    this.isChanged = true;
};
/**
 * @return {String}
 */ $dcf731dd052ddaa7$export$48513f6b9f8ce62d.prototype.getTagName = function() {
    return 'input';
};
/**
 * Used to apply the data to the dom
 * @ingore
 */ $dcf731dd052ddaa7$export$48513f6b9f8ce62d.prototype.setDomData = function(data) {
    if (this.isRendered) (0, $16a8694255569d68$export$1fdf8a6251f5e19a).setCheckBoxData(data, this);
};
/**
 * @ignore
 */ $dcf731dd052ddaa7$export$48513f6b9f8ce62d.prototype.getDomData = function() {
    if (this.isRendered) return (0, $16a8694255569d68$export$1fdf8a6251f5e19a).getCheckBoxData(this);
};





class $113d0a9711381252$export$353f5b6fc5456de1 extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    getTagName() {
        return 'button';
    }
}




var $02mnx = parcelRequire("02mnx");


parcelRequire("fRpWP");
/**
 * @author Gillis Haasnoot <gillis.haasnoot@gmail.com>
 * @package Banana.Controls
 * @summary Base list control for binding datasources to datasets
 */ 
class $cf8b45a51b0de626$export$18f8036a6dc5f3a5 extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    /**
	 * Sets the datasource for the control and triggers a rerender.
	 * Optionally suppresses the dataSourceChanged event.
	 *
	 * @param {any} datasource - The datasource to set.
	 * @param {boolean} [ignoreEvent=false] - If true, no event is triggered.
	 * @returns {this}
	 */ setDataSource(datasource, ignoreEvent = false) {
        this.datasource = datasource;
        this.invalidateDisplay();
        if (!ignoreEvent) this.triggerEvent("dataSourceChanged", datasource);
        return this;
    }
    /**
	 * Retrieves the current datasource.
	 *
	 * @returns {any} The current datasource.
	 */ getDataSource() {
        return this.datasource;
    }
    /**
	 * Binds the control's datasource to a dataset.
	 *
	 * @param {Banana.Data.DataSet|string} set - The dataset or its name.
	 * @param {string} bind - The property path to bind (e.g., "value.subvalue").
	 * @returns {this}
	 */ dataSetSourceBind(set, bind) {
        this.bindedDataSource = [
            set,
            bind
        ];
        if (set instanceof Banana.Data.DataSet) set.bindControlToDataSource(this);
        return this;
    }
    /**
	 * Sets the field name for the key in the datasource.
	 * Use this when the datasource contains complex objects.
	 *
	 * @param {string} key - The field name.
	 * @returns {this}
	 */ setDataKeyField(key) {
        this.dataKeyField = key;
        return this;
    }
    /**
	 * Sets the field name for the value in the datasource.
	 * Use this when the datasource contains complex objects.
	 *
	 * @param {string} value - The field name.
	 * @returns {this}
	 */ setDataValueField(value) {
        this.dataValueField = value;
        return this;
    }
    /**
	 * Sets the field name for the depth in the datasource.
	 *
	 * @param {string} value - The field name.
	 * @returns {this}
	 */ setDataDepthField(value) {
        this.dataDepthField = value;
        return this;
    }
    /**
	 * Creates a base list control for binding datasources to datasets.
	 * This control should be extended for specific list implementations.
	 *
	 * @constructs
	 * @extends {Banana.Controls.DataControl}
	 */ constructor(...args){
        super(...args);
        this.dataKeyField = "key";
        this.dataValueField = "value";
        this.dataDepthField = "depth";
        this.datasource = null;
        this.bindedDataSource = null;
    }
}



class $606b100eac0fdb00$export$931cbfb6bfb85fc extends (0, $cf8b45a51b0de626$export$18f8036a6dc5f3a5) {
    init() {
        super.init();
        this.bind("dataSourceChanged", ()=>{
            this.createOptions();
        });
        this.bind('change', ()=>{
            this.setData((0, $16a8694255569d68$export$1fdf8a6251f5e19a).getData(this), false, true);
        });
    }
    setData(data, ignoreEvent = false, triggerChange = true) {
        super.setData(data, ignoreEvent, triggerChange);
        this.createOptions();
    }
    createOptions() {
        //loop over datasource
        let options = "";
        if (!this.datasource) return;
        console.log("create opiotns", this.datasource, this.getData());
        this.clear();
        this.datasource.forEach((item)=>{
            //create option element
            if (item[this.dataKeyField] == null) //options += "<option disabled value='" + item[this.dataKeyField] + "'></option>";
            return;
            if (this.getData() != -1 && this.getData() == item[this.dataKeyField]) options += "<option selected value='" + item[this.dataKeyField] + "'>" + this.preOptionsText + " " + item[this.dataValueField] + " " + this.postOptionsText + "</option>";
            else options += "<option value='" + item[this.dataKeyField] + "'>" + item[this.dataValueField] + "</option>";
        });
        this.addControl(options);
        this.invalidateDisplay();
    }
    setDataSource(datasource, ignoreEvent = false) {
        return super.setDataSource(datasource, ignoreEvent);
    }
    getTagName() {
        return "select";
    }
    /**
     * Creates a dropdown list control for binding datasources to datasets.
     * This control is a specialized version of ListControl for dropdown functionality.
     *
     * @constructs
     * @extends {Banana.Controls.ListControl}
     */ constructor(...args){
        super(...args);
        console.log("Dropdown control created");
    }
}


class $2680d4151eb48962$export$8e94a76bd29c2eb5 extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier, disableUrlHistory, data) {
        super.init(urlIdentifier, disableUrlHistory);
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 50) + "px;justify-content: flex-start;");
        //p.setStyle("justify-content:space-between;");
        p.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("addFavoriteModalTitle");
        title.addControl((0, $02mnx.Localizer).getString("Debug Menu"));
        p.addControl(title);
        var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        resultP.addCssClass("suggestionsItemTitle");
        resultP.setStyle("justify-content: space-around");
        resultP.addControl("custom interstitials");
        p.addControl(resultP);
        var triggerInterstitial = new (0, $113d0a9711381252$export$353f5b6fc5456de1)();
        triggerInterstitial.addControl("show interstitial (android)");
        triggerInterstitial.addCssClass("button2");
        triggerInterstitial.setStyle("width:80%;");
        p.addControl(triggerInterstitial);
        triggerInterstitial.bind("click", ()=>{
            var country = null;
            if (localStorage.getItem("debug_interstitial_country")) country = localStorage.getItem("debug_interstitial_country");
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showCustomInterstitial(true, country, 0);
        });
        var label = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        label.addCssClass("");
        label.setStyle("justify-content: space-around");
        label.addControl("");
        p.addControl(label);
        var countrySelect = new (0, $606b100eac0fdb00$export$931cbfb6bfb85fc)();
        countrySelect.addCssClass("dropdown");
        countrySelect.preOptionsText = "Force country:";
        countrySelect.postOptionsText = "";
        countrySelect.setStyle("width:80%;");
        p.addControl(countrySelect);
        countrySelect.bind("dataChanged", (e)=>{
            console.log("data changed", countrySelect.getData());
            localStorage.setItem("debug_interstitial_country", countrySelect.getData());
        });
        var countries = this.getAdCountries();
        if (localStorage.getItem("debug_interstitial_country") !== null) countrySelect.setData(localStorage.getItem("debug_interstitial_country"));
        countrySelect.setDataSource(countries);
        var behaviorSelect = new (0, $606b100eac0fdb00$export$931cbfb6bfb85fc)();
        behaviorSelect.addCssClass("dropdown");
        behaviorSelect.preOptionsText = "";
        behaviorSelect.postOptionsText = "";
        behaviorSelect.setStyle("width:80%;");
        //p.addControl(behaviorSelect);
        behaviorSelect.bind("dataChanged", (e)=>{
            console.log("data changed", behaviorSelect.getData());
            localStorage.setItem("debug_interstitial_ratebehavior", behaviorSelect.getData());
        });
        var behaviors = this.getAdBehaviors();
        if (localStorage.getItem("debug_interstitial_ratebehavior") !== null) behaviorSelect.setData(localStorage.getItem("debug_interstitial_ratebehavior"));
        behaviorSelect.setDataSource(behaviors);
        var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        resultP.addCssClass("suggestionsItemTitle");
        resultP.setStyle("justify-content: space-around");
        resultP.addControl("admob interstitials");
        p.addControl(resultP);
        var triggerInterstitial = new (0, $113d0a9711381252$export$353f5b6fc5456de1)();
        triggerInterstitial.addControl("show admob interstitial (android)");
        triggerInterstitial.addCssClass("button2");
        triggerInterstitial.setStyle("width:80%;");
        p.addControl(triggerInterstitial);
        triggerInterstitial.bind("click", ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showAdmobInterstitial();
        });
        // var selectedContainer = new Panel();
        // selectedContainer.addCssClass("selectedCountriesContainer");
        // var title = new Panel();
        // title.setStyle("font-size: 12px;font-weight: bold;margin-bottom: 10px;");
        // this.selectedCount = title;
        //
        // selectedContainer.addControl(title);
        // p.addControl(selectedContainer);
        //
        // var searchResults = new Panel();
        // searchResults.addCssClass("addFavoriteModalSuggestList");
        // searchResults.setStyle("height:100%;overflow-y:scroll;width:85%;");
        // p.addControl(searchResults)
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
    }
    getAdCountries() {
        const data = [
            {
                "key": "-1",
                "value": "use device country (default)"
            },
            {
                "key": null,
                "value": null
            },
            {
                "key": "NL",
                "value": "Netherlands"
            },
            {
                "key": "DE",
                "value": "Germany"
            },
            {
                "key": "FR",
                "value": "France"
            },
            {
                "key": "GB",
                "value": "United Kingdom"
            },
            {
                "key": "US",
                "value": "United States"
            },
            {
                "key": "IT",
                "value": "Italy"
            },
            {
                "key": "ES",
                "value": "Spain"
            },
            {
                "key": "PL",
                "value": "Poland"
            },
            {
                "key": "PT",
                "value": "Portugal"
            },
            {
                "key": "RO",
                "value": "Romania"
            },
            {
                "key": "TR",
                "value": "Turkey"
            },
            {
                "key": "RU",
                "value": "Russia"
            },
            {
                "key": "VN",
                "value": "Vietnam"
            },
            {
                "key": "SM",
                "value": "San Marino"
            }
        ];
        return data;
    }
    getAdBehaviors() {
        const data = [
            {
                "key": "-1",
                "value": "use device rate limit (default)"
            },
            {
                "key": null,
                "value": null
            },
            {
                "key": "1",
                "value": "Disable rate limit (always show)"
            }
        ];
        return data;
    }
}






class $db68992ff30e24ab$export$c240d99d4d89b232 extends (0, $bf7f47488c894fdf$export$7a7fa4424cb20976) {
    /**
	 * Base class for itemrenders are used in various list renders of datagrids
	 * Itemrenders are the visible items in a datagrid.
	 * By extending from this base item render class you can build your own custom item render
	 * @constructs
	 * @extends Banana.Control
	 */ init() {
        super.init();
        this.listRender = null;
    }
    /**
	 * Sets reference to the list render
	 * @param {Banana.Controls.DataGridBaseListRender} lr
	 */ setListRender(lr) {
        this.listRender = lr;
    }
    /**
	 * @return {Banana.Controls.DataGridBaseListRender}
	 */ getListRender() {
        return this.listRender;
    }
    /**
	 * @param {int} i row index
	 */ setRowIndex(i) {
        this.rowIndex = i;
    }
    /**
	 * @return {int} index of the itemrender in the listrender
	 */ getRowIndex() {
        return this.listRender.getIndexByRow(this.parent);
    }
    /**
	 * @return {boolean} true when item can be selected
	 */ getIsSelectable() {
        return false;
    }
    /**
	 * @param {mixed} data
	 * @param {boolean} ignoreEvent
	 * @param {boolean} ignoreDom 
	 */ setData(data, ignoreEvent, ignoreDom) {
        this.data = data;
        if (!ignoreEvent) this.triggerEvent('dataChanged', data);
        return this;
    }
    /**
	 * @return {mixed} data
	 */ getData() {
        return this.data;
    }
}


class $2a9fdfb6f07b1997$export$b3f2024387ec8f9f extends (0, $db68992ff30e24ab$export$c240d99d4d89b232) {
    /**
	 * Base item render class for datagrid table tile renders.
	 * All item renders made for the tile item render should extend from this class
	 * 
	 * example:
	 
	  //define our custom datagrid table item render
        myCustomItemRender = Banana.Controls.DataGridTableContentItemRender.extend({

			createComponents ()
			{
				var label = new Banana.Controls.Panel();
				label.setData(this.getData().id);
				this.addControl(new Banana.Controls.Panel());
			}
		});
	 	
		grid = new Banana.Controls.DataGrid();
		
		var listRender = new Banana.Controls.DataGridTileListRender()
		
		//note that this method required you to pass a function providing the itemrender.
		listRender.setItemRender(function(){return new myCustomItemRender()});
		
		grid.setListRender(listRender);
		
		var content = [{id:1}{id:2}];
		
		grid.setDataSource(content);	

		this.addControl(grid);	 
		
	 * @constructs
	 * @extends Banana.Controls.DataGridItemRender
	 */ init(...args) {
        super.init(args);
    }
    /**
	 * Overwrite this method to implement your own item render
	 */ createComponents() {
        if (typeof this.data == "string") {
            var p = new Banana.Controls.Panel();
            p.addControl(this.data);
            this.addControl(p);
        }
    }
    /**
	 * Called when item is selected
	 */ select() {
        this.getListRender().getItemRenderPlaceHolderByItemRender(this).addCssClass("BDataGridTileTilePlaceHolderSelected");
    }
    /**
	 * Called when item is deselected
	 */ deselect() {
        this.getListRender().getItemRenderPlaceHolderByItemRender(this).removeCssClass("BDataGridTileTilePlaceHolderSelected");
    }
    /**
	 * Called when mouse moves over the item render.
	 */ mouseOver() {}
    /**
	 * Called when mouse moves out the item render
	 */ mouseOut() {}
}




class $5f67bb3af1a541ad$export$54ec01a60f47d33d extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    init() {
        super.init();
        this.addCssClass("table");
    }
}
$5f67bb3af1a541ad$export$54ec01a60f47d33d.prototype.getTagName = function() {
    return 'table';
};
class $5f67bb3af1a541ad$export$b05581f4e764e162 extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    init() {
        super.init();
    }
}
$5f67bb3af1a541ad$export$b05581f4e764e162.prototype.getTagName = function() {
    return 'tr';
};
class $5f67bb3af1a541ad$export$fa07a78f5c25d264 extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    init() {
        super.init();
    }
}
$5f67bb3af1a541ad$export$fa07a78f5c25d264.prototype.getTagName = function() {
    return 'td';
};
class $5f67bb3af1a541ad$export$331161bdaadcdb17 extends $5f67bb3af1a541ad$export$fa07a78f5c25d264 {
    init() {
        super.init();
    }
}
$5f67bb3af1a541ad$export$331161bdaadcdb17.prototype.getTagName = function() {
    return 'th';
};
class $5f67bb3af1a541ad$export$2f4a7be4f0dcc2 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
    }
}
$5f67bb3af1a541ad$export$2f4a7be4f0dcc2.prototype.getTagName = function() {
    return 'thead';
};
class $5f67bb3af1a541ad$export$76ccd210b9029917 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
    }
}
$5f67bb3af1a541ad$export$76ccd210b9029917.prototype.getTagName = function() {
    return 'tbody';
};







var $02mnx = parcelRequire("02mnx");


var $kc8Kt = parcelRequire("kc8Kt");
class $96212b9eb9cf2566$export$8ca15c0f5e461723 extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier) {
        super.init(urlIdentifier);
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 50) + "px;justify-content: flex-start;");
        p.addCssClass("flexVerticalAlign");
        var search = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        search.addCssClass("topBarSearchContainer");
        search.setStyle("margin-top:10px;position:relative;border: 1px solid #184548;width: 80%;border-radius: 13px;margin-bottom: 16px;");
        var searchInput = new (0, $2cf92be5dbbab152$export$574966fbea4a65e5)();
        search.addControl(searchInput);
        searchInput.setStyle("height:40px;text-align: center;");
        var searchPh = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchPh.addControl((0, $02mnx.Localizer).getString("search_your_favorite_teams"));
        searchPh.setStyle("font-style: italic;opacity:0.7;position:absolute;pointer-events:none;width: 100%;");
        search.addControl(searchPh);
        this.searchInput = searchInput;
        p.addControl(search);
        var searchResults = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchResults.addCssClass("addFavoriteModalSuggestList");
        searchResults.setStyle("overflow-y:scroll;width:85%;");
        p.addControl(searchResults);
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
        searchInput.bind("click", ()=>{
            searchPh.setVisible(false);
        });
        searchInput.bind("blur", ()=>{
            jQuery("#" + searchInput.clientId).val();
        });
        searchInput.bind("keydown", (e)=>{
            console.log("keydown");
            clearTimeout(this.inputter);
            this.inputter = setTimeout(()=>{
                if (!jQuery("#" + searchInput.clientId).val()) {
                    searchResults.clear();
                    //searchPh.setVisible(true);
                    return this.renderSuggestions(searchResults);
                }
                if (e.originalEvent.key == "Enter") {
                    jQuery("#" + searchInput.clientId).blur();
                    return;
                }
                (0, $kc8Kt.DataProvider).search(jQuery("#" + searchInput.clientId).val(), (response)=>{
                    searchResults.clear();
                    if (!response.isOk()) return this.renderSuggestions(searchResults);
                    var d = response.getData();
                    if (!d.result.length) {
                        console.log("render suggestions");
                        return this.renderSuggestions(searchResults);
                    }
                    var processedTeams = 0;
                    var max = 10;
                    for(var i = 0; i < d.result.length; i++){
                        var result = d.result[i];
                        if (result.type == "t") {
                            if (processedTeams >= max) continue;
                            processedTeams++;
                            this.renderSearchResult(result, searchResults);
                        }
                    }
                    searchResults.invalidateDisplay();
                });
            }, 200);
        });
        this.renderSuggestions(searchResults);
    }
    renderTeamItem(team, target, isFavorite, controlIndex) {
        var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        resultP.addCssClass("topBarSearchResultItem");
        resultP.setStyle("justify-content:space-between;");
        var subContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        subContainer.addCssClass("flexHorizontalAlign");
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.setStyle("width:40px;height:40px;");
        if (AppInstance.getConfig().enabledFeatures.teamImages) image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + team.id_gs + "_small_rnd.png");
        else image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/country/" + team.id_gs + "_small_rnd.png");
        subContainer.addControl(image);
        subContainer.addControl("<div style='text-align: start;'>");
        if (team.countrygs) subContainer.addControl(team.name || team.team + " - " + team.countrygs);
        else subContainer.addControl(team.name || team.team);
        var showRemove = false;
        if (isFavorite) {
            subContainer.setStyle("opacity:0.4;justify-content:space-between;");
            subContainer.addControl(" (" + (0, $02mnx.Localizer).getString("added") + ")");
            showRemove = true;
        }
        subContainer.addControl("</div>");
        resultP.addControl(subContainer);
        if (showRemove) {
            var removeButton = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            removeButton.addCssClass("icon-close");
            removeButton.setStyle("opacity:0.5;background-color: red;right:0;display:flex;width:40px;height:40px;margin-inline-start:4px;");
            resultP.addControl(removeButton);
            removeButton.bind("click", (e)=>{
                console.log('remove favorite', target.getControls().indexOf(resultP));
                (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteTeam(team.id_gs);
                subContainer.setCss({
                    "opacity": "1"
                });
                this.getPage().triggerEvent("onFavoriteChanged");
                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();
                var controlIndex = target.getControls().indexOf(resultP);
                this.renderTeamItem(team, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[team.id_gs], controlIndex);
                resultP.remove();
            });
        }
        if (controlIndex != null) target.addControlAt(resultP, controlIndex, true);
        else target.addControl(resultP);
        resultP.bind("click", ()=>{
            //console.log("add favorite",team.id_gs,team.name)
            if (!(0, $aabc673d1ba8b527$export$db78e401119da622).addFavoriteTeam(team.id_gs, team.team || team.name)) return this.getPage().getPageTemplate().showToast((0, $02mnx.Localizer).getString("max_favorite_teams_reached"));
            var controlIndex = target.getControls().indexOf(resultP);
            this.renderTeamItem(team, target, true, controlIndex);
            resultP.remove();
            subContainer.setCss({
                "opacity": "0.2"
            });
            this.getPage().triggerEvent("onFavoriteChanged");
        });
    }
    renderSuggestions(target) {
        (0, $kc8Kt.DataProvider).getSuggestions((response)=>{
            if (!response.isOk()) {
                console.error("cannot load suggestions");
                return;
            }
            var suggestions = response.getData();
            if (suggestions.suggestedLeagues && suggestions.suggestedLeagues.length) for(var i = 0; i < suggestions.suggestedLeagues.length; i++){
                var league = suggestions.suggestedLeagues[i];
                if (!league.suggestedTeams.length) continue;
                var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                resultP.addCssClass("suggestionsItemTitle");
                resultP.addControl(league.leagueName);
                target.addControl(resultP);
                for(var j = 0; j < league.suggestedTeams.length; j++){
                    if (i > 0 && j > 5) continue;
                    var team = league.suggestedTeams[j];
                    this.renderTeamItem(team, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[team.id_gs]);
                }
            }
            if (suggestions.suggestedOtherLeagues && suggestions.suggestedOtherLeagues.length) for(var i = 0; i < suggestions.suggestedOtherLeagues.length; i++){
                var league = suggestions.suggestedOtherLeagues[i];
                if (!league.suggestedTeams.length) continue;
                var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                resultP.addCssClass("suggestionsItemTitle");
                resultP.addControl(league.leagueName);
                target.addControl(resultP);
                for(var j = 0; j < league.suggestedTeams.length; j++){
                    var team = league.suggestedTeams[j];
                    this.renderTeamItem(team, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[team.id_gs]);
                }
            }
            target.invalidateDisplay();
        });
    }
    renderSearchResult(data, target) {
        this.renderTeamItem(data, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[data.id_gs]);
    }
}







var $02mnx = parcelRequire("02mnx");


var $6K7Df = parcelRequire("6K7Df");

var $kc8Kt = parcelRequire("kc8Kt");
class $d9cfbd126aa1f39b$export$eefd3e8e9bc8eae0 extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier) {
        super.init(urlIdentifier);
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 50) + "px;justify-content: flex-start;");
        p.addCssClass("flexVerticalAlign");
        var search = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        search.addCssClass("topBarSearchContainer");
        search.setStyle("margin-top:10px;position:relative;border: 1px solid #184548;width: 80%;border-radius: 13px;margin-bottom: 16px;");
        var searchInput = new (0, $2cf92be5dbbab152$export$574966fbea4a65e5)();
        search.addControl(searchInput);
        searchInput.setStyle("height:40px;text-align: center;");
        var searchPh = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchPh.addControl((0, $02mnx.Localizer).getString("search_your_favorite_league"));
        searchPh.setStyle("font-style: italic;opacity:0.7;position:absolute;pointer-events:none;width: 100%;");
        search.addControl(searchPh);
        this.searchInput = searchInput;
        p.addControl(search);
        var searchResults = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchResults.addCssClass("addFavoriteModalSuggestList");
        searchResults.setStyle("height:100%;overflow-y:scroll;width:85%;");
        p.addControl(searchResults);
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
        searchInput.bind("click", ()=>{
            searchPh.setVisible(false);
        });
        searchInput.bind("blur", ()=>{
            jQuery("#" + searchInput.clientId).val();
        });
        searchInput.bind("keydown", (e)=>{
            clearTimeout(this.inputter);
            this.inputter = setTimeout(this.getProxy(function() {
                if (!jQuery("#" + searchInput.clientId).val()) {
                    searchResults.clear();
                    //searchPh.setVisible(true);
                    return this.renderSuggestions(searchResults);
                }
                if (e.originalEvent.key == "Enter") {
                    jQuery("#" + searchInput.clientId).blur();
                    return;
                }
                (0, $kc8Kt.DataProvider).search(jQuery("#" + searchInput.clientId).val(), this.getProxy(function(response) {
                    searchResults.clear();
                    if (!response.isOk()) return this.renderSuggestions(searchResults);
                    var d = response.getData();
                    if (!d.result.length) {
                        console.log("render suggestions");
                        return this.renderSuggestions(searchResults);
                    }
                    var processedTeams = 0;
                    var max = 10;
                    for(var i = 0; i < d.result.length; i++){
                        var result = d.result[i];
                        console.log(result);
                        if (result.type == "l") {
                            if (processedTeams >= max) continue;
                            processedTeams++;
                            console.log(result);
                            if (!AppInstance.getConfig().enabledFeatures.showHiddenLeagues && AppInstance.getConfig().hiddenLeagues.indexOf(result.countrygs) != -1) continue;
                            this.renderSearchResult(result, searchResults);
                        }
                    }
                    searchResults.invalidateDisplay();
                }));
            }), 200);
        });
        this.renderSuggestions(searchResults);
    }
    renderLeagueItem(league, target, isFavorite, controlIndex) {
        var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        resultP.addCssClass("topBarSearchResultItem");
        resultP.setStyle("justify-content:space-between;");
        var subContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        subContainer.addCssClass("flexHorizontalAlign");
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.setStyle("width:40px;height:40px;");
        //image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/teams_gs/" + team.id_gs + "_rnd.png");
        if (league.leagueKey == "EurocupsEuropeanChampionship") image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/euro2024.png", 30, 30);
        else image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + (league.country || league.countrygs).replaceAll(" ", "-").toLowerCase() + ".png", 30, 30);
        //        console.log("==========>",league, league.country, league.countrygs, ((league.country || league.countrygs).replaceAll(" ", "-").toLowerCase()));
        subContainer.addControl(image);
        subContainer.addControl("<div style='text-align: start;width: 100%;'>");
        subContainer.addControl(league.leagueName);
        var showRemove = false;
        if (isFavorite) {
            subContainer.setStyle("width: calc(100% - 40px);opacity:0.2;justify-content:space-between;");
            subContainer.addControl(" (" + (0, $02mnx.Localizer).getString("added") + ")");
            showRemove = true;
        }
        subContainer.addControl("</div>");
        resultP.addControl(subContainer);
        if (showRemove) {
            var removeButton = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            removeButton.addCssClass("icon-close");
            removeButton.setStyle("z-index:999999;opacity:0.5;background-color: red;right:0;width:40px;height:40px;margin-inline-start:4px;");
            resultP.addControl(removeButton);
            removeButton.bind("click", (e)=>{
                console.log('remove favorite', target.getControls().indexOf(resultP));
                (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteLeague(league.leagueKey);
                subContainer.setCss({
                    "opacity": "1"
                });
                this.getPage().triggerEvent("onFavoriteChanged");
                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();
                var controlIndex = target.getControls().indexOf(resultP);
                this.renderLeagueItem(league, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues()[league.leagueKey], controlIndex);
                resultP.remove();
            });
        }
        if (controlIndex != null) target.addControlAt(resultP, controlIndex, true);
        else target.addControl(resultP);
        resultP.bind("click", ()=>{
            console.log("add favorite", league);
            if (!(0, $aabc673d1ba8b527$export$db78e401119da622).addFavoriteLeague(league.leagueKey, league.country || league.countrygs, league.leagueName)) return this.getPage().getPageTemplate().showToast((0, $02mnx.Localizer).getString("max_favorite_leagues_reached"));
            var controlIndex = target.getControls().indexOf(resultP);
            this.renderLeagueItem(league, target, true, controlIndex);
            resultP.remove();
            subContainer.setCss({
                "opacity": "0.4"
            });
            this.getPage().triggerEvent("onFavoriteChanged");
        });
    }
    renderSuggestions(target) {
        (0, $kc8Kt.DataProvider).getSuggestions((response)=>{
            if (!response.isOk()) {
                console.error("cannot load suggestions");
                return;
            }
            var suggestions = response.getData();
            console.log("suggestions", suggestions);
            if (suggestions.suggestedLeagues && suggestions.suggestedLeagues.length) for(var i = 0; i < suggestions.suggestedLeagues.length; i++){
                var league = suggestions.suggestedLeagues[i];
                league.countrygs = suggestions.countryKey;
                league.country = suggestions.country;
                if (!AppInstance.getConfig().enabledFeatures.showHiddenLeagues && AppInstance.getConfig().hiddenLeagues.indexOf(league.countrygs) != -1) continue;
                if (!league.suggestedTeams.length) continue;
                var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                // resultP.addCssClass("suggestionsItemTitle");
                // resultP.addControl(league.name);
                // target.addControl(resultP);
                this.renderLeagueItem(league, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues()[league.leagueKey]);
            // for (var j = 0; j < league.suggestedTeams.length; j++) {
            //     if (i > 0 && j > 5) continue;
            //     var team = league.suggestedTeams[j];
            //
            // }
            }
            if (suggestions.suggestedOtherLeagues && suggestions.suggestedOtherLeagues.length) {
                var prevUsedCountry = null;
                for(var i = 0; i < suggestions.suggestedOtherLeagues.length; i++){
                    var league = suggestions.suggestedOtherLeagues[i];
                    if (!league.suggestedTeams.length) continue;
                    league.countrygs = league.countryKey;
                    if (!AppInstance.getConfig().enabledFeatures.showHiddenLeagues && AppInstance.getConfig().hiddenLeagues.indexOf(league.countrygs) != -1) continue;
                    if (prevUsedCountry != league.countrygs) {
                        var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                        resultP.addCssClass("suggestionsItemTitle");
                        resultP.setStyle("text-align:start;");
                        resultP.addControl((0, $6K7Df.CountryUtil).getLocalizedCountryByName(league.country || league.countrygs));
                        target.addControl(resultP);
                    }
                    this.renderLeagueItem(league, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues()[league.leagueKey]);
                    prevUsedCountry = league.countrygs;
                // for (var j = 0; j < league.suggestedTeams.length; j++) {
                //     var team = league.suggestedTeams[j];
                //
                // }
                }
            }
            target.invalidateDisplay();
        });
    }
    renderSearchResult(data, target) {
        data.leagueName = data.name;
        data.leagueKey = data.keygs;
        this.renderLeagueItem(data, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues()[data.leagueKey]);
    }
}





const $61e67aa413d59276$export$d5cd1fb4cc71c74 = "data:image/png;base64,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";
const $61e67aa413d59276$export$a4f156a9bb250a8c = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAEOUExURUdwTKKiopiYmJaWlp2dnZOTk4mJiebm5uPj4+Hh4Y6OjqCgoJubm+jo6IyMjJGRkaenp9LS0t7e3tzc3JWVlaysrNfX18jIyLm5ucrKylVVVdnZ2dTU1M3Nzc/Pz6Wlpb6+vq+vr4eHh4mJiU5OTlZWVra2tsXFxVFRUYSEhI2Njbu7u1NTU1dXV5GRkcPDw1BQULGxsVhYWAAAAEhISKqqqnl5eXNzc0xMTEpKSqCgoDQ0NAAAAFhYWGpqalNTU1ZWVoSEhImJiYSEhH9/f+vr61FRUQAAAElJSaGhoZmZmZ6enpmZmbS0tE1NTQAAAEtLS3JycsDAwG9vb4KCgnl5eX9/f1BQUFJSUn9/f29sDogAAABadFJOUwBmZmZmZmZmZmZmZmZmZmZmZmZmOmZmZmZmNmZmZmZmZmZmNDQ4ZmY4MjZmNDo4ZjZmNAIuZiwqMjA+HQUuJDoyZjIwLmYyBjQ/PD06ZiQHIihmJ2YqZiMlMPskA6QAAALySURBVFjD7ZZZe5pAFIbDKgNTdSCyyOIWIWrUqrVNmqVJm+773v7/P9JzZtCadAHvfX0AmTnfOwtcsLe3Y8cOztnZ6WXz8NHhuD+fN/vj8QFy1BT0OfnNEe8aj/vN+bw/hkjz8vT9873F4twLplngcbIsAOI4TtgtEmjEviwThUE2DbzzxQLm8C4a+enoU1uQpqnvj0Zt/xbt0cj3oTMva49SfxT94Iv4MKVv00an0wA6nVlH/Fs2brAUvdjN7zuNdEan37mgOWu0WlK9LsFRjhYi1Zf+WAgadakFP8uSsL0QUdOy6q20zwVHdYgCqiqVxMIAVM8OhaAFUWhTVWy3CsGhoFSV1M6GQLVUSnl7IaIGBLSRCyRKLVlVZVktAQ6DhwqZZS6wIKpQKssyLUbmQyGqUr/LBc+oBjeyrChyKShVeDXVcsExFVFNEx1FiBoNrqpYwjGPKkqthletEBwKUZRccKKYPIqCMohBMKKKJZxoVRPDJpyLMU1RCYdGheBeTa/CrVmFcxkwbJpYLOcCs6tDuKrDuRhdN02s1OGkHQhB9eoKm7pdvRQ8DHT1lUD/9gXD5QTdbjW/dvXaCy7YZxGxDUKIgVRKAXUGcSovuWDCItsuHa3cAbgDBA+FIEFB3lWGp0KxFgxj5jjE2JAXTUFcQfCaC3oBc0JCyi5hvQ3EIa9yQeK69rYGQuyQvOGCgZe4kbOtwCaO6+yvBBHsgr2NwTBsey24DgIGuwD7aGwjcFxGelxwP/AYC0OcQunXCHZgQ+B5DLYxtPFlrBg5f4bW7ZgnThj9VVDIhiCxNwSR69ycQYHADl2W2I+54OtWAgR3AASxM+CCB5nHYuaGTqk1QA3EIR/9Fky9JOZTQEMx8AaEoetGyUrwGb5XYtcVa/gnYmyMi7wTR0HlJxd89AIWe5F4DP8RGOvxYfgogc+q9RKyOIlZiTXA6DamWQL1DDZOPIWLyZNBrzccDieT/UImUDfsAdcDSF3sPpN37FjxCwOGhA1lEwqnAAAAAElFTkSuQmCC";
const $61e67aa413d59276$export$fb9188ad99e3f6b = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADbUExURUdwTHl5eX5+fn5+flVVVWpqan5+fn5+fgAAAAAAAH5+fn5+fn19fX19fV9fX21tbXFxcT8/P35+fn19fX19fX5+fnh4eH5+fnt7e3p6en19fX19fX5+fn19fX5+fn5+fnl5eX5+fnFxcXx8fHR0dHZ2dn19fX5+fn19fXx8fHd3d35+fn19fX19fX5+fn19fXNzc3t7e319fX5+fnx8fH19fXt7e3x8fHt7e3p6en5+fnl5eXt7e35+fnx8fHh4eH5+fn19fX19fX19fX5+fn5+fn5+flVVVXl5efwNWMUAAABJdFJOUwAqX78DDKnEAQKLg25BCA4JBJtHZrkmh0IwlpTAmo+4F7MSThgcgJc3WB6uM0WvqBY6bHNMnh1cITirKEBVYBO6oop+e1ufBhXq8kDQAAAA8ElEQVQ4y43U6VbCMBAF4La0vallK4KIgsiOgooiiCwCIsv7PxG1gjSHpJP7t985k04yo2lBMJhqZAA07yOFEyA8z+SEHRFwoUuMZx7KBcmmhMjkEOxLeUmcshpKjBVCyH2I1SO4tD5lfeLyVlVAsJ8UkN+0KwWEsmHRCNi0FRDwU1dA6LwzGgF3ugIC1gpoeU2ihUGf6XtE/l3lge5TvkE2067Rd+f2yAseJ+in0p9HD4KflwQ1LUDcEkyex5UrvZ6TpLNlIRSLJwWVdqnwwTMF8WCa6f+FUfxKy1cP+0M33cgNNfk9jUFuOvdWl3/dA77DGdDKU1v2AAAAAElFTkSuQmCC";
class $61e67aa413d59276$export$ecf150517ad2aa0 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.setStyle("position:absolute;");
        this.addControl(image);
        this.placeHolder = image;
        var image = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //image.setStyle("position:absolute;"); //if this is enabled then somehow longtitles in listheaders of matches are overlapping this image.
        this.addControl(image);
        this.image = image;
    ///console.log("init image placeholder",this.image)
    }
    updateDisplay() {
        this.placeHolder.setImage(this.placeholderData);
    }
    unload() {}
    showPlaceHolder() {
        this.placeHolder.setVisible(true);
    }
    setImage(src, h, w) {
        this.isRendered;
        //if (src == this.loadedSrc) return;
        if (this.placeholderData) {
            this.placeHolder.setVisible(true);
            this.placeHolder.setCss({
                'height': h + "px",
                'width': w + "px"
            });
        }
        this.loadedSrc = src;
        if (!this.imageObj) this.imageObj = new Image(h, w);
        this.imageObj.src = "";
        if (!this.alt) this.alt = "";
        this.imageObj.setAttribute("alt", this.alt);
        if (w) this.imageObj.setAttribute("width", w);
        if (h) this.imageObj.setAttribute("height", h);
        if (this.imageObjectStyle) this.imageObj.style = this.imageObjectStyle;
        this.imageObj.onload = ()=>{
            this.placeHolder.setVisible(false);
            var temp = jQuery("#" + this.image.getClientId());
            temp.empty();
            temp.append(this.imageObj);
        };
        this.imageObj.onerror = ()=>{
            console.error("on error loading image");
            //this.setCss({'display':'hidden',"background-color":'red'});
            var temp = jQuery("#" + this.image.getClientId());
            temp.empty();
        };
        this.imageObj.src = src;
    }
    constructor(...args){
        super(...args), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "alt", "");
    }
}



var $9yWe2 = parcelRequire("9yWe2");


var $02mnx = parcelRequire("02mnx");
const $e8daee01203954a7$export$a3cf7111e6b6bc75 = {
    padZero: function(str, len) {
        len = len || 2;
        var zeros = new Array(len).join('0');
        return (zeros + str).slice(-len);
    },
    getCorrectTextColor: function(hex) {
        var threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */ 
        var hRed = hexToR(hex);
        var hGreen = hexToG(hex);
        var hBlue = hexToB(hex);
        function hexToR(h) {
            return parseInt(cutHex(h).substring(0, 2), 16);
        }
        function hexToG(h) {
            return parseInt(cutHex(h).substring(2, 4), 16);
        }
        function hexToB(h) {
            return parseInt(cutHex(h).substring(4, 6), 16);
        }
        function cutHex(h) {
            return h.charAt(0) == "#" ? h.substring(1, 7) : h;
        }
        var cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
        if (cBrightness > threshold) return "#000000";
        else return "#ffffff";
    },
    invertColor: function(hex, bw) {
        console.log("invert color ", hex);
        if (hex.indexOf('#') === 0) hex = hex.slice(1);
        // convert 3-digit hex to 6-digits.
        if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        if (hex.length !== 6) throw new Error('Invalid HEX color.');
        var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
        if (bw) return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
        // invert color components
        r = (255 - r).toString(16);
        g = (255 - g).toString(16);
        b = (255 - b).toString(16);
        // pad each with zeros and return
        return "#" + this.padZero(r) + this.padZero(g) + this.padZero(b);
    }
};



var $5er4g = parcelRequire("5er4g");



var $kc8Kt = parcelRequire("kc8Kt");

var $9yWe2 = parcelRequire("9yWe2");
const $33568486b3b6460c$export$f9a2ca4cdad371e = {
    teamStatCache: {},
    getTeamMatchInfo: function(teamid, cb) {
        if (this.teamStatCache[teamid]) {
            var teamStat = this.teamStatCache[teamid];
            if (teamStat.lastUpdate && teamStat.lastUpdate > new Date().getTime() - 60000) //console.log("returning cached team info",teamid," - ",teamStat.match.id," - ",teamStat.lastUpdate," - ",new Date().getTime()," - ",teamStat.lastUpdate > new Date().getTime() - 60000," - ",teamStat.lastUpdate - new Date().getTime() - 60000)
            return cb(teamStat.match);
        }
        setTimeout(()=>{
            this._getInfoFromLiveMatches(teamid, (match)=>{
                if (match) {
                    //console.log(teamid,"found match from live ",match);
                    this.teamStatCache[teamid] = {
                        match: match,
                        lastUpdate: new Date().getTime()
                    };
                    return cb(match);
                }
                this._getInfoFromTodaysMatches(teamid, (match)=>{
                    if (match) {
                        //console.log(teamid,"found match from today ",match);
                        this.teamStatCache[teamid] = {
                            match: match,
                            lastUpdate: new Date().getTime()
                        };
                        return cb(match);
                    }
                    return this._getTeamInfo(teamid, (match)=>{
                        if (match) {
                            //console.log(teamid,"found match from team ",match);
                            this.teamStatCache[teamid] = {
                                match: match,
                                lastUpdate: new Date().getTime()
                            };
                            return cb(match);
                        }
                        return cb(null);
                    });
                });
            });
        }, 20);
    },
    _getTeamInfo: function(teamid, cb) {
        (0, $kc8Kt.DataProvider).getTeam(teamid, (response)=>{
            try {
                if (!response.isOk()) return cb(null);
                var team = response.getData();
                if (!team.fixtures || !team.fixtures.length) return cb(null);
                var foundMatch = null;
                for(var i = 0; i < team.fixtures.length; i++){
                    if ((0, $9yWe2.MatchUtil).isFinished(team.fixtures[i]) || (0, $9yWe2.MatchUtil).isPostponed(team.fixtures[i])) continue;
                    foundMatch = team.fixtures[i];
                    break;
                }
                return cb(foundMatch);
            } catch (e) {
                console.warn("error getting team info ", e);
            }
            return cb(null);
        }, false, 120000, true);
    },
    _getInfoFromLiveMatchesBusy: false,
    _getInfoFromLiveMatchesQueue: [],
    _continueBusyLiveMatches: function() {
        if (this._getInfoFromLiveMatchesQueue.length) //reverse loop
        for(var i = this._getInfoFromLiveMatchesQueue.length - 1; i >= 0; i--){
            var teamid = this._getInfoFromLiveMatchesQueue[i].teamid;
            var cb = this._getInfoFromLiveMatchesQueue[i].cb;
            this._getInfoFromLiveMatches(teamid, cb, true);
        }
        this._getInfoFromLiveMatchesQueue = [];
    },
    _getInfoFromLiveMatches: function(teamid, cb, ignoreBusy) {
        if (!ignoreBusy && this._getInfoFromLiveMatchesBusy) //console.log("get live. queueing",teamid);
        return this._getInfoFromLiveMatchesQueue.push({
            teamid: teamid,
            cb: cb
        });
        //console.log("get today info. not live",teamid);
        if (!ignoreBusy) this._getInfoFromLiveMatchesBusy = true;
        (0, $kc8Kt.DataProvider).getLiveNow((response)=>{
            try {
                if (!response.isOk()) {
                    if (!ignoreBusy) {
                        this._getInfoFromLiveMatchesBusy = false;
                        this._continueBusyLiveMatches();
                    }
                    return cb(null);
                }
                var data = response.getData();
                for(var i = 0; i < data.length; i++){
                    for(var j = 0; j < data[i].leagues.length; j++)for(var k = 0; k < data[i].leagues[j].matches.length; k++){
                        var match = data[i].leagues[j].matches[k];
                        if (match.gs_localteamid == teamid || match.gs_visitorteamid == teamid) {
                            match.playedToday = true;
                            if (!ignoreBusy) {
                                this._getInfoFromLiveMatchesBusy = false;
                                this._continueBusyLiveMatches();
                            }
                            return cb(match);
                        }
                    }
                }
            } catch (e) {
                console.warn("error getting live matches ", e);
            }
            if (!ignoreBusy) {
                this._getInfoFromLiveMatchesBusy = false;
                this._continueBusyLiveMatches();
            }
            return cb(null);
        }, false, 60000);
    },
    _getInfoFromTodaysMatchesBusy: false,
    _getInfoFromTodaysMatchesQueue: [],
    _continueBusyTodaysMatches: function() {
        if (this._getInfoFromTodaysMatchesQueue.length) //reverse loop
        for(var i = this._getInfoFromTodaysMatchesQueue.length - 1; i >= 0; i--){
            var teamid = this._getInfoFromTodaysMatchesQueue[i].teamid;
            var cb = this._getInfoFromTodaysMatchesQueue[i].cb;
            this._getInfoFromTodaysMatches(teamid, cb, true);
        }
        this._getInfoFromTodaysMatchesQueue = [];
    },
    _getInfoFromTodaysMatches: function(teamid, cb, ignoreBusy) {
        if (!ignoreBusy && this._getInfoFromTodaysMatchesBusy) //console.log("get today. queueing",teamid);
        return this._getInfoFromTodaysMatchesQueue.push({
            teamid: teamid,
            cb: cb
        });
        //console.log("get today info. not busy",teamid);
        if (!ignoreBusy) this._getInfoFromTodaysMatchesBusy = true;
        (0, $kc8Kt.DataProvider).getToday((response)=>{
            try {
                if (!response.isOk()) {
                    if (!ignoreBusy) {
                        this._getInfoFromTodaysMatchesBusy = false;
                        this._continueBusyTodaysMatches();
                    }
                    return cb(null);
                }
                var data = response.getData();
                for(var i = 0; i < data.length; i++){
                    for(var j = 0; j < data[i].leagues.length; j++)for(var k = 0; k < data[i].leagues[j].matches.length; k++){
                        var match = data[i].leagues[j].matches[k];
                        if (match.gs_localteamid == teamid || match.gs_visitorteamid == teamid) {
                            match.playedToday = true;
                            if (!ignoreBusy) {
                                this._getInfoFromTodaysMatchesBusy = false;
                                this._continueBusyTodaysMatches();
                            }
                            return cb(match);
                        }
                    }
                }
            } catch (e) {
                console.warn("error getting today matches ", e);
            }
            if (!ignoreBusy) {
                this._getInfoFromTodaysMatchesBusy = false;
                this._continueBusyTodaysMatches();
            }
            return cb(null);
        }, false, 60000);
    }
};




var $lU8CH = parcelRequire("lU8CH");

class $d7e810688df07bfd$export$a6c7ac8248d6e38a extends (0, $44ba6ae0e222a615$export$c3b2237bc022073a) {
    init() {
        super.init();
        this.addCssClass('BLink');
    }
    updateDisplay() {
        if (!this.text) return;
        Banana.Util.DomHelper.renderHtml(this.text, this);
    }
    setTarget(target) {
        this.setAttribute('target', target);
    }
    setHref(href) {
        this.setAttribute('href', href);
        return this;
    }
    setText(text) {
        this.text = text;
        if (this.isRendered) Banana.Util.DomHelper.renderHtml(this.text, this, true);
        return this;
    }
    getTagName() {
        return 'a';
    }
}



class $f29955da1dcf3c72$export$9a51b5736e54ae3e extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
    }
    focus() {
        if (!this.getFocusable()) {
            console.warn("FocusableItemRender.focus: focusable is not set");
            return;
        }
        //this.getFocusable().setCss({"background-color":"red"});
        this.getFocusable().setAttribute("tabindex", "-1");
        $("#" + this.getFocusable().getClientId()).focus();
        console.log("focus", this.data);
    }
    defocus() {
    // if (!this.getFocusable()){
    //     console.warn("FocusableItemRender.defocus: focusable is not set");
    //     return;
    // }
    // //this.getFocusable().setAttribute("tabindex", "-1");
    // //this.getFocusable().setCss({"background-color":"green"});
    // console.log("defocus" ,this.data);
    }
    focusNext(isTabKey, isLeftRight, isUpDown) {
        if (!this.getNextFocusable()) return false;
        this.getNextFocusable().setAttribute("tabindex", "-1");
        $("#" + this.getNextFocusable().getClientId()).focus();
        return true;
    }
    focusPrevious(isTabKey, isLeftRight, isUpDown) {
        if (!this.getPreviousFocusable()) return false;
        this.getPreviousFocusable().setAttribute("tabindex", "-1");
        $("#" + this.getPreviousFocusable().getClientId()).focus();
        return true;
    }
    getNextFocusable() {
        return false;
    }
    getPreviousFocusable() {
        return false;
    }
    getFocusable() {
        return null;
    }
}


var $33b38b124674c7d3$var$leagueLogoRemaps = {
    "InternationalCupsOlympics": "olympicfootball2024",
    "InternationalCupsOlympicsWomen": "olympicfootball2024"
};
const $33b38b124674c7d3$export$6059b7f8008e8cd5 = {
    remapCountryLogo: (key, original)=>{
        if ($33b38b124674c7d3$var$leagueLogoRemaps[key]) return $33b38b124674c7d3$var$leagueLogoRemaps[key];
        return original;
    }
};



class $ae10f9e8e1dd758b$export$a3d5a919e7e64385 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("flexHorizontalAlign listViewItemFavorites");
        this.addControl(this.panel);
        var con = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        con.addCssClass("flexHorizontalAlign");
        this.imageBox = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.imageBox.addCssClass("icon-add-favorite");
        this.imageBox.setStyle("width:40px;height:40px;margin-inline-start:4px;");
        this.imageBox.placeholderData = (0, $61e67aa413d59276$export$a4f156a9bb250a8c);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewCountryTitle");
        this.contents.setStyle("margin-inline-start: 0px;");
        con.addControl(this.imageBox);
        con.addControl(this.contents);
        this.panel.addControl(con);
        this.panel.addControl(this.isLiveInfo);
        this.panel.bind('click', ()=>{
            this.openModal();
        });
    }
    getFocusable() {
        return this.panel;
    }
    setData(data) {
        this.data = data;
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.imageBox.alt = data.name;
        this.contents.addControl((0, $02mnx.Localizer).getString("tap_to_add"));
        this.invalidateDisplay();
    }
    openModal() {
        var urlIdentifier = "teamSelectModal";
        var pan = new (0, $96212b9eb9cf2566$export$8ca15c0f5e461723)(urlIdentifier);
        this.modal = pan;
        this.getPage().addControl(pan, true);
    }
}
class $ae10f9e8e1dd758b$export$fa8438dd333ee9d0 extends $ae10f9e8e1dd758b$export$a3d5a919e7e64385 {
    openModal() {
        var urlIdentifier = "leagueSelectModal";
        var pan = new (0, $d9cfbd126aa1f39b$export$eefd3e8e9bc8eae0)(urlIdentifier);
        this.modal = pan;
        this.getPage().addControl(pan, true);
    }
}
class $ae10f9e8e1dd758b$export$13ddad53616dbb8c extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("flexHorizontalAlign listViewItemFavorites");
        this.addControl(this.panel);
        var con = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        con.addCssClass("flexHorizontalAlign");
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.addCssClass("listViewCountryFlagItem");
        this.imageBox.placeholderData = (0, $61e67aa413d59276$export$a4f156a9bb250a8c);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewCountryTitle");
        this.isLiveInfo = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.isLiveInfo.addCssClass("listViewFavoriteIsLiveInfo listViewFavoriteIsLiveInfoStatus live");
        con.addControl(this.imageBox);
        con.addControl(this.contents);
        this.panel.addControl(con);
        this.panel.addControl(this.isLiveInfo);
        this.panel.bind('click', ()=>{
            if (this.stopClickPropogation) return;
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(this.data);
        });
        this.bindEvents();
    }
    getFocusable() {
        return this.panel;
    }
    bindEvents() {
        this.panel.bind('click', ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(this.data.id);
        });
        var startY = 0;
        var startX = 0;
        this.panel.bind("touchstart", (e)=>{
            startY = e.originalEvent.touches[0].clientY;
            startX = e.originalEvent.touches[0].clientX;
            this.longPressHandler = setTimeout(()=>{
                this.listRender.triggerEvent("requestActivateDrag", {
                    type: "league",
                    data: this.data
                });
            }, 500);
            this.panel.bind("touchmove", (e)=>{
                if (Math.abs(startY - e.originalEvent.touches[0].clientY) > 10) {
                    clearTimeout(this.longPressHandler);
                    this.panel.unbind("touchmove", e.handleObj.handler);
                }
                if (Math.abs(startX - e.originalEvent.touches[0].clientX) > 10) {
                    clearTimeout(this.longPressHandler);
                    this.panel.unbind("touchmove", e.handleObj.handler);
                }
            });
        });
        this.panel.bind("touchend", ()=>{
            clearTimeout(this.longPressHandler);
        });
    }
    setData(data) {
        console.log("setData", data);
        this.data = data;
        //this._super(data);
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.imageBox.alt = data.name;
        data.country = (0, $33b38b124674c7d3$export$6059b7f8008e8cd5).remapCountryLogo(data.key, data.country);
        console.log("favorite ", data.key);
        this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.country.replaceAll(" ", "-").toLowerCase() + ".png", 40, 40);
        //this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/leagueimages/" + data.key + ".png", 40, 40);
        this.contents.addControl(data.name);
        this.isLiveInfo.clear();
        if (data.is_live) this.isLiveInfo.addControl((0, $02mnx.Localizer).getString("live"));
        this.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$2b8a07e4e9fbcb88 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        //this.panel.setAttribute("tabindex", "0");
        this.panel.addCssClass("flexHorizontalAlign listViewItemFavorites");
        this.addControl(this.panel);
        var con = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        con.addCssClass("flexHorizontalAlign");
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.addCssClass("listViewCountryFlagItem");
        this.imageBox.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewCountryTitle");
        this.isLiveInfo = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.isLiveInfo.addCssClass("listViewFavoriteIsLiveInfo");
        con.addControl(this.imageBox);
        con.addControl(this.contents);
        this.panel.addControl(con);
        this.panel.addControl(this.isLiveInfo);
        this.bindEvents();
    }
    getFocusable() {
        return this.panel;
    }
    bindEvents() {
        this.panel.bind('click', ()=>{
            if (ignoreClickFix) return;
            if (this.stopClickPropogation) return;
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(this.data.id);
        });
        var startY = 0;
        var startX = 0;
        var ignoreClickFix = false;
        this.panel.bind("touchstart", (e)=>{
            startY = e.originalEvent.touches[0].clientY;
            startX = e.originalEvent.touches[0].clientX;
            this.longPressHandler = setTimeout(()=>{
                this.listRender.triggerEvent("requestActivateDrag", {
                    type: "team",
                    data: this.data
                });
            }, 500);
            this.panel.bind("touchmove", (e)=>{
                if (Math.abs(startY - e.originalEvent.touches[0].clientY) > 10) {
                    clearTimeout(this.longPressHandler);
                    this.panel.unbind("touchmove", e.handleObj.handler);
                    ignoreClickFix = true;
                }
                if (Math.abs(startX - e.originalEvent.touches[0].clientX) > 10) {
                    clearTimeout(this.longPressHandler);
                    this.panel.unbind("touchmove", e.handleObj.handler);
                    ignoreClickFix = true;
                }
            });
        });
        this.panel.bind("touchend", ()=>{
            clearTimeout(this.longPressHandler);
            ignoreClickFix = false;
        });
    }
    setData(data, ignoreImemediateRender, ignoreLiveStats) {
        super.setData(data);
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.isLiveInfo.clear();
        this.imageBox.alt = data.name;
        if (AppInstance.getConfig().enabledFeatures.teamImages) this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + this.data.id + "_small_rnd.png", 40, 40);
        else this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/country/" + this.data.id + "_small_rnd.png", 40, 40);
        this.contents.addControl(this.data.name);
        this.invalidateDisplay();
        if (ignoreLiveStats) return;
        (0, $33568486b3b6460c$export$f9a2ca4cdad371e).getTeamMatchInfo(this.data.id, (data)=>{
            this.renderLiveStats(data);
        });
    }
    renderLiveStats(data) {
        if (this.isunloaded || data == null) return;
        var windowWidth = $(window).width();
        var isLive = false;
        var liveClass = "";
        if ((0, $9yWe2.MatchUtil).isPlaying(data)) {
            //this.isLiveInfo.addCssClass("live");
            isLive = true;
            liveClass = "live";
        }
        var sparts = data.scoretime.split("-");
        var content = "<table class='" + liveClass + "' style=text-align:end;width:" + windowWidth * 0.45 + "px;>";
        content += "<tr>";
        content += "<td class='listViewFavoriteIsLiveInfoStatus " + liveClass + "' colspan='2' style=''>";
        if (isLive) {
            content += "<i>";
            content += (0, $02mnx.Localizer).getString("nowlive");
            content += " - " + (0, $9yWe2.MatchUtil).getShortStatus(data);
            content += "</i>";
        } else if (data.playedToday) {
            content += "<i>";
            content += (0, $02mnx.Localizer).getString("today");
            if ((0, $9yWe2.MatchUtil).isFinished(data)) content += " - " + (0, $9yWe2.MatchUtil).getFullStatus(data);
            else content += " - " + (0, $9yWe2.MatchUtil).getLocalizedScoreTime(data);
            content += "</i>";
        } else {
            content += "<i>";
            var dt = new (0, $5er4g.DateTimecode)();
            dt.setTimecode((0, $9yWe2.MatchUtil).getTimecode(data));
            content += dt.toLocaleDateString();
            content += "</i>";
        }
        content += "</td>";
        content += "</tr>";
        content += "<tr>";
        content += "<td class='isLiveTeamInfoTeamName' style=''>";
        content += data.localteam;
        content += "</td>";
        if ((0, $9yWe2.MatchUtil).isValidScore(data)) {
            content += "<td style='max-width:12px; width:12px;'>";
            content += sparts[0] + "";
            content += "</td>";
        }
        content += "</tr>";
        content += "<tr>";
        content += "<td class='isLiveTeamInfoTeamName' style=''>";
        content += data.visitorteam;
        content += "</td>";
        if ((0, $9yWe2.MatchUtil).isValidScore(data)) {
            content += "<td style='max-width:12px; width:12px;'>";
            content += sparts[1] + "";
            content += "</td>";
        }
        content += "</tr>";
        content += "</table>";
        this.isLiveInfo.clear();
        this.isLiveInfo.bind("click", (e)=>{
            e.stopPropagation();
            if (this.stopClickPropogation) return;
            console.log("show match screen");
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showMatchScreen(null, data);
        });
        this.isLiveInfo.addControl(content);
        this.isLiveInfo.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$d551b010dc729342 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("listView");
        this.panel.addCssClass("flexHorizontalAlign flexAlignStart listViewItemGeneral");
        this.panel.setStyle("cursor:pointer;");
        this.addControl(this.panel);
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.addCssClass("listViewCountryFlagItem");
        this.imageBox.placeholderData = (0, $61e67aa413d59276$export$a4f156a9bb250a8c);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewCountryTitle");
        this.panel.addControl(this.imageBox);
        this.panel.addControl(this.contents);
        this.panel.bind('click', ()=>{
            if (this.data.item == "news") (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showNews();
            else if (this.data.item == "fifaranking") (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showFifaRanking();
            else if (this.data.item == "playervalues") (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerMarketValues();
            else if (this.data.item == "forumindex") (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showForumIndex();
            else if (this.data.item == "topvoters") (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTopVoters();
            else if (this.data.item == "euro2024") //Router.showTopVoters();
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen({
                "key": "EurocupsEuropeanChampionship"
            });
            console.log(this.data);
        //console.log("click");
        //Router.showSettings();
        //this.getPage().getApplication().loadPage("PlayerDetail",{'id':this.data.id_gs});
        });
    }
    getFocusable() {
        return this.panel;
    }
    setData(data) {
        this.data = data;
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.imageBox.alt = data.title;
        this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.image.replaceAll(" ", "-").toLowerCase(), 40, 40);
        this.contents.addControl(data.title);
        this.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$9619424689cf3891 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listView");
        this.panel.addCssClass("flexHorizontalAlign flexAlignStart listViewItemGeneral");
        this.addControl(this.panel);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewAgenda");
        this.panel.addControl(this.contents);
    }
    updateDisplay() {
        $("#" + this.panel.getClientId()).on("touchstart", function(e) {
            e.stopPropagation();
        });
        this.createAgendaItems();
    }
    focus() {
        var r = super.focus();
        this.currentFocusableIndex = this.defaultFocusableIndex;
        return r;
    }
    focusNext(isTabKey, isLeftRight, isUpDown) {
        if (isTabKey || isUpDown) return false;
        var r = super.focusNext(isTabKey, isLeftRight, isUpDown);
        if (r) this.currentFocusableIndex++;
        return r;
    }
    focusPrevious(isTabKey, isLeftRight, isUpDown) {
        if (isTabKey || isUpDown) return false;
        var r = super.focusPrevious(isTabKey, isLeftRight, isUpDown);
        if (r) this.currentFocusableIndex--;
        return r;
    }
    getFocusable() {
        return this.todayElement;
    }
    getNextFocusable() {
        if (!this.contents.controls[this.currentFocusableIndex + 1]) return false;
        return this.contents.controls[this.currentFocusableIndex + 1];
    }
    getPreviousFocusable() {
        if (!this.contents.controls[this.currentFocusableIndex - 1]) return false;
        return this.contents.controls[this.currentFocusableIndex - 1];
    }
    unload() {
        $("#" + this.panel.getClientId()).off("touchstart");
    }
    setData(data) {
        this.data = data;
    }
    createAgendaItems() {
        //alert("create agenda items");
        var screenWidth = this.getPage().getDimensions().width;
        if (!screenWidth) return;
        this.contents.clear();
        const itemsPerSecreen = 7;
        var itemWidth = screenWidth / itemsPerSecreen;
        var daysToShow = 21;
        var daysBefore = Math.floor(daysToShow / 2);
        console.log("AG=> createAgendaItems", daysToShow, daysBefore, itemWidth, screenWidth);
        // Initialize today at midnight
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var todayTime = today.getTime();
        // Calculate start timecode (8 days before)
        var startTime = todayTime - 86400000 * daysBefore;
        // Formatters
        var formatter1 = new Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            weekday: 'short'
        });
        var formatter2 = new Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            month: 'short',
            day: 'numeric'
        });
        var todayStr = formatter2.format(today);
        this.currentFocusableIndex = daysBefore;
        this.defaultFocusableIndex = daysBefore;
        for(let i = 0; i <= daysToShow; i++){
            let currentTime = startTime + 86400000 * i;
            let currentDate = new Date(currentTime);
            let agendaItemContainer = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
            agendaItemContainer.setStyle(`width: ${itemWidth}px;`);
            agendaItemContainer.bind("click", ()=>{
                let date = `${String(currentDate.getDate()).padStart(2, '0')}/` + `${String(currentDate.getMonth() + 1).padStart(2, '0')}/` + `${currentDate.getFullYear()}`;
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showAgendaScreen(date.replaceAll("/", "-"));
            });
            let day = formatter1.format(currentDate);
            let dateStr = formatter2.format(currentDate);
            if (dateStr === todayStr) {
                this.todayElement = agendaItemContainer;
                day = (0, $02mnx.Localizer).getString("today");
            // //console.log("XX AG=> Today found at index", i, day);
            // if (i !== daysBefore) {
            //     console.warn("Warning: Today is at index", i, "instead of", daysBefore);
            // }
            }
            agendaItemContainer.addControl(`<div>${day}</div>`);
            agendaItemContainer.addControl(`<div>${dateStr}</div>`);
            this.contents.addControl(agendaItemContainer);
        }
        this.contents.invalidateDisplay();
        var scroll = jQuery("#" + this.contents.getClientId());
        //var scrollToToday = 1 * (scroll[0].scrollWidth - screenWidth + (screenWidth / itemsPerSecreen)) / 2;
        var scrollToToday = itemWidth * ((daysToShow - 1) / 2 - (itemsPerSecreen - 1) / 2);
        if (FootballManiaConfig.isRtl) scrollToToday *= -1;
        //console.log("AG=> ------------ ");
        jQuery("#" + this.contents.getClientId()).scrollLeft(scrollToToday);
    //i++;
    }
}
class $ae10f9e8e1dd758b$export$c2bd2f52e42e27e4 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listView");
        this.panel.addCssClass("flexHorizontalAlign flexAlignStart listViewItemGeneral");
        this.addControl(this.panel);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewMatchSuggestions");
        this.panel.addControl(this.contents);
    }
    updateDisplay() {
        $("#" + this.panel.getClientId()).on("touchstart", function(e) {
            e.stopPropagation();
        });
        this.createItems();
    }
    unload() {
        $("#" + this.panel.getClientId()).off("touchstart");
    }
    setData(data) {
        this.data = data;
        this.isDone = false;
        console.log("setData", data);
        this.createItems();
    }
    createItems() {
        if (!this.data) {
            console.warn("no data to create suggestions list");
            return;
        }
        if (this.isDone) {
            console.warn("already created suggestions list");
            return;
        }
        //alert("create agenda items");
        //if (this.isRendered) return;
        var screenWidth = this.getPage().getDimensions().width;
        if (!screenWidth) return;
        this.contents.clear();
        var itemCount = 2;
        var additionalItems = Math.round(screenWidth / itemCount / 80) - 1;
        console.log("additionalItems", additionalItems);
        itemCount += additionalItems;
        var itemWidth = screenWidth / itemCount;
        //console.log(itemWidth/80);
        console.log("createAgendaItems", this.data, this.isRendered);
        var totalItems = this.data.matchSuggestions.matches.length;
        //var totalItems = 7;
        console.log(this.data);
        var size = Math.min(42, itemWidth / 2 - itemWidth / 10);
        for(var i = 0; i < totalItems; i++){
            console.log("match item", this.data.matchSuggestions.matches[i]);
            var agendaItemContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            agendaItemContainer.setStyle("width:" + itemWidth + "px;");
            this.contents.addControl(agendaItemContainer);
            this.createMatchItem(agendaItemContainer, this.data.matchSuggestions.matches[i], size);
        }
        this.contents.invalidateDisplay();
        var scroll = jQuery("#" + this.contents.getClientId());
        var scrollToToday = 1 * (scroll[0].scrollWidth - screenWidth + screenWidth / 6) / 2;
        if (FootballManiaConfig.isRtl) scrollToToday *= -1;
        jQuery("#" + this.contents.getClientId()).scrollLeft(scrollToToday);
        this.isDone = true;
    }
    createMatchItem(container, match, size) {
        var panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        panel.addCssClass("listViewMatchSuggestionsMatchItem");
        container.addControl(panel);
        //match.id = match.matchid;
        panel.bind("click", ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showMatchScreen(null, match);
        });
        var topContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topContainer.addCssClass("listViewMatchSuggestionsMatchItemTop");
        var middleContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        middleContainer.addCssClass("listViewMatchSuggestionsMatchItemMiddle");
        var bottomContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        bottomContainer.addCssClass("listViewMatchSuggestionsMatchItemBottom");
        panel.addControl(topContainer);
        panel.addControl(middleContainer);
        panel.addControl(bottomContainer);
        var homeImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        homeImage.addCssClass("listViewMatchSuggestionsMatchItemHomeImage");
        homeImage.setStyle("width:" + size + "px;height:" + size + "px;");
        homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + match.gs_localteamid + "_small_rnd.png", size, size);
        topContainer.addControl(homeImage);
        var awayImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        awayImage.addCssClass("listViewMatchSuggestionsMatchItemAwayImage");
        awayImage.setStyle("width:" + size + "px;height:" + size + "px;");
        awayImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + match.gs_visitorteamid + "_small_rnd.png", size, size);
        topContainer.addControl(awayImage);
        if ((0, $9yWe2.MatchUtil).isPenalty(match)) //middleContainer.addControl(MatchUtil.getShortStatus(match));
        //bottomContainer.addControl(MatchUtil.getLocalizedPenalty(match,false,true));
        middleContainer.addControl((0, $9yWe2.MatchUtil).getLocalizedPenalty(match, false, true));
        else if ((0, $9yWe2.MatchUtil).isFinished(match) || (0, $9yWe2.MatchUtil).isPlaying(match)) //middleContainer.addControl(MatchUtil.getShortStatus(match));
        middleContainer.addControl((0, $9yWe2.MatchUtil).getLocalizedScoreTime(match));
        else middleContainer.addControl((0, $9yWe2.MatchUtil).getLocalizedDate(match, false, true));
        if ((0, $9yWe2.MatchUtil).isPlaying(match)) //add in green text
        bottomContainer.addControl("<p class='greentext'>" + (0, $02mnx.Localizer).getString("live") + "</p>");
        else if ((0, $9yWe2.MatchUtil).isFinished(match)) //add in red text
        bottomContainer.addControl((0, $02mnx.Localizer).getString("finaltime_short"));
    }
}
class $ae10f9e8e1dd758b$export$bd869f4126134c3f extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("listViewHeader");
        this.panel.setStyle("justify-content: space-between;padding-inline-end:0;");
        this.addControl(this.panel);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addButton = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addButton.setStyle("right:2px;height:28px;width:28px;");
        this.addButton.addCssClass("icon-add-favorite");
        //this.addButton.setVisible(window.showTeamAddFavoriteButton ? true : false);
        this.addButton.bind('click', ()=>{
            this.action();
        });
        this.panel.addControl(this.contents);
        if (this.addButtonEnabled()) this.panel.addControl(this.addButton);
    }
    getFocusable() {
        return this.panel;
    }
    setData(data) {
        super.setData(data);
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.contents.addControl(this.data.title);
        this.contents.invalidateDisplay();
    }
    addButtonEnabled(enabled) {
        return (0, $aabc673d1ba8b527$export$db78e401119da622).hasFavoriteTeams();
    }
    action() {
        var urlIdentifier = "teamSelectModal";
        var pan = new (0, $96212b9eb9cf2566$export$8ca15c0f5e461723)(urlIdentifier);
        this.modal = pan;
        this.getPage().addControl(pan, true);
    }
}
class $ae10f9e8e1dd758b$export$b6b4d9f3ed916d30 extends $ae10f9e8e1dd758b$export$bd869f4126134c3f {
    action() {
        var urlIdentifier = "leagueSelectModal";
        var pan = new (0, $d9cfbd126aa1f39b$export$eefd3e8e9bc8eae0)(urlIdentifier);
        this.modal = pan;
        this.getPage().addControl(pan, true);
    }
    addButtonEnabled(enabled) {
        return (0, $aabc673d1ba8b527$export$db78e401119da622).hasFavoriteLeagues();
    }
}
class $ae10f9e8e1dd758b$export$1b29664009aff387 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("listViewHeader");
        this.addControl(this.panel);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addControl(this.contents);
    }
    getFocusable() {
        return this.panel;
    }
    setData(data) {
        super.setData(data);
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.contents.addControl(this.data.title);
        this.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$c4e73d64e644a882 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("listViewItem");
        this.addControl(this.panel);
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.addCssClass("listViewCountryFlagItem");
        this.imageBox.placeholderData = (0, $61e67aa413d59276$export$a4f156a9bb250a8c);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewCountryTitle");
        this.panel.addControl(this.imageBox);
        this.panel.addControl(this.contents);
        this.panel.bind('click', ()=>{
            console.log("click", this.data);
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showCountryLeaguesScreen(this.data);
        });
    }
    getFocusable() {
        return this.panel;
    }
    setData(data, preventInstantRender) {
        this.data = data;
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.imageBox.alt = data.countryLocalized;
        this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.country.replaceAll(" ", "-").toLowerCase() + ".png", 40, 40);
        this.contents.addControl(data.countryLocalized);
        this.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$603c3d0f5550cd51 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    getFocusable() {
        return this.panel;
    }
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("flexHorizontalAlign listViewHeader listViewHeaderMatchDateHeader");
        this.panel.setStyle("height:40px;");
        this.addControl(this.panel);
    }
    setData(data, preventRender, preventInstantRender) {
        //this._super(data);
        this.panel.clear();
        var d = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }).format(data.dayTimecodeLocalized);
        //this.panel.addControl(MatchUtil.getLocalizedDate(data,true),true);
        this.panel.addControl("<div>" + d + " </div>");
        //console.log("MatchHeaderDateRender", data);
        if (data.week) {
            var stage = "";
            if (data.stageName != "Regular Season") stage = data.stageName ? " - " + data.stageName : "";
            this.panel.addControl("<div style='font-size:12px;margin-inline-end: 4px;'>" + (0, $02mnx.Localizer).getString("round") + " " + data.week + stage + "</div>");
        ///this.panel.addControl(data.stageName);
        } else if (data.stage) {
            var state = data.stage.split("-");
            if (state.length > 2) state = state[1];
            else state = data.stage;
            this.panel.addControl("<div style='font-size:12px;margin-inline-end: 4px;'>" + state + "</div>");
        } else if (data.stageRound) {
            var state = data.stage.split("-");
            if (state.length > 2) state = state[1];
            else state = data.stageRound;
            this.panel.addControl("<div style='font-size:12px;margin-inline-end: 4px;'>" + state + "</div>");
        }
        if (this.isRendered) this.panel.invalidateDisplay();
        else this.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$c4b9b4982bf4840d extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    getFocusable() {
        return this.panel;
    }
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("listViewMatchHeader");
        this.addControl(this.panel);
        this.imageBox = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.imageBox.addCssClass("listViewMatchHeaderCountryImage");
        this.imageBox.setStyle("width:40px;height:40px;");
        //this.imageBox.placeholderData = countryPlaceHolder;
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewMatchHeaderCountryTitle");
        this.favoriteContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.favoriteContainer.addCssClass("listViewMatchHeaderFavoriteContainer");
        if (FootballManiaConfig.isRtl) this.favoriteContainer.setStyle("margin-right:auto;");
        else this.favoriteContainer.setStyle("margin-left:auto;");
        this.favoriteLeague = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.favoriteLeague.addCssClass("icon-favorite-off");
        this.favoriteLeague.addCssClass("menu-icon");
        this.panel.bind('click', ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(this.data);
        });
        this.favoriteLeague.bind("click", (e)=>{
            e.stopImmediatePropagation();
            if (!this.data.isFavoriteLeague) {
                this.data.isFavoriteLeague = true;
                this.favoriteLeague.removeCssClass("icon-favorite-off");
                this.favoriteLeague.addCssClass("icon-favorite-on");
                (0, $aabc673d1ba8b527$export$db78e401119da622).addFavoriteLeague(this.data.key, this.data.country, this.data.league);
            } else {
                this.data.isFavoriteLeague = false;
                this.favoriteLeague.removeCssClass("icon-favorite-on");
                this.favoriteLeague.addCssClass("icon-favorite-off");
                (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteLeague(this.data.key, this.data.country, this.data.league);
            }
        });
        this.panel.addControl(this.imageBox);
        this.panel.addControl(this.contents);
        this.panel.addControl(this.favoriteContainer);
        this.favoriteContainer.addControl(this.favoriteLeague);
    }
    setData(data, preventRender, preventInstantRender) {
        //return;
        this.data = data;
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        data.title = (0, $lU8CH.RemoveReservedIfNeeded)(data.title);
        this.contents.addControl(data.title, true);
        this.imageBox.setAttribute("alt", data.title);
        console.log("------------", data);
        data.country = (0, $33b38b124674c7d3$export$6059b7f8008e8cd5).remapCountryLogo(data.key, data.country);
        this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.country.replaceAll(" ", "-").toLowerCase() + ".png", 30, 30);
        //this.favoriteLeague.unbind();
        if (data.isFavoriteLeague) {
            this.favoriteLeague.removeCssClass("icon-favorite-off");
            this.favoriteLeague.addCssClass("icon-favorite-on");
        } else {
            this.favoriteLeague.removeCssClass("icon-favorite-on");
            this.favoriteLeague.addCssClass("icon-favorite-off");
        }
        if (this.isRendered) ;
        else this.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$f5387a0c75ad4890 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    getFocusable() {
        return this.panel;
    }
    init(hideBell, renderVariant, showWhenFavorite) {
        super.init();
        this.renderVariant = renderVariant;
        this.hideBell = hideBell;
        this.lastImageLoad = -1;
        this.rendered = false;
        this.showWhenFavorite = showWhenFavorite;
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("listViewItem");
        this.addControl(this.panel);
        if (this.renderVariant == undefined) {
            if ((0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType() == "2") this.renderVariant = 2;
            else if ((0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType() == "3") this.renderVariant = 3;
            else this.renderVariant = 1;
        }
        if (this.renderVariant == 1) {
            this.notificationContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.notificationContainer.addCssClass("listViewMatchNotificationContainer");
            this.notificationBell = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.notificationBell.addCssClass("listViewMatchNotificationBell");
            this.notificationBell.addCssClass("icon-bell");
            this.contentPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.contentPanel.addCssClass("listViewMatchContentContainer");
            this.homePanelContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.homePanelContainer.addCssClass("listViewMatchHomeContainer");
            this.awayPanelContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.awayPanelContainer.addCssClass("listViewMatchAwayContainer");
            this.homeImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
            this.homeImage.addCssClass("listViewMatchHomeTeamLogoContainer");
            this.homeImage.image.addCssClass("listViewMatchTeamLogoImage");
            this.homeImage.placeHolder.addCssClass("listViewMatchTeamLogoPlaceHolder");
            this.homeImage.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
            this.awayImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
            this.awayImage.addCssClass("listViewMatchAwayTeamLogoContainer");
            this.awayImage.image.addCssClass("listViewMatchTeamLogoImage");
            this.awayImage.placeHolder.addCssClass("listViewMatchTeamLogoPlaceHolder");
            this.awayImage.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
            this.homeRedcard = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.homeRedcard.addCssClass("listViewMatchRedCardHome");
            this.homeImage.addControl(this.homeRedcard);
            this.awayRedcard = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.awayRedcard.addCssClass("listViewMatchRedCardAway");
            this.awayImage.addControl(this.awayRedcard);
            this.status = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.status.addCssClass("listViewMatchStatusContainer");
            this.statusAggr = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.statusAggr.addCssClass("listViewMatchStatusAggr");
            this.statusTime = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.statusTime.addCssClass("listViewMatchStatusScoreTime");
            this.statusMatch = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.statusMatch.addCssClass("listViewMatchStatusMatch");
            this.hometeam = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.hometeam.setStyle("");
            this.hometeam.addCssClass("listViewMatchHomeTitle");
            this.awayteam = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.awayteam.setStyle("");
            this.awayteam.addCssClass("listViewMatchAwayTitle");
            if (!this.hideBell) {
                this.notificationContainer.addControl(this.notificationBell);
                this.panel.addControl(this.notificationContainer);
            }
            //this.arrowContainer.addControl(this.arrow);
            this.panel.addControl(this.arrowContainer);
            this.panel.addControl(this.contentPanel);
            this.homePanelContainer.addControl(this.hometeam);
            this.homePanelContainer.addControl(this.homeImage);
            this.awayPanelContainer.addControl(this.awayImage);
            this.awayPanelContainer.addControl(this.awayteam);
            this.contentPanel.addControl(this.homePanelContainer);
            this.contentPanel.addControl(this.status);
            this.contentPanel.addControl(this.awayPanelContainer);
            this.status.addControl(this.statusAggr);
            this.status.addControl(this.statusTime);
            this.status.addControl(this.statusMatch);
        } else {
            this.notificationContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.notificationContainer.addCssClass("listViewMatchNotificationContainer");
            this.notificationContainer.addCssClass("listViewMatchNotificationContainerAlt");
            this.notificationBell = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.notificationBell.addCssClass("listViewMatchNotificationBell");
            this.notificationBell.addCssClass("icon-bell");
            this.left = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.left.addCssClass("listViewMatchLeft");
            this.right = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.right.addCssClass("listViewMatchRight");
            this.contentPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.contentPanel.addCssClass("listViewMatchContentContainerAlt");
            this.teamsContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.teamsContainer.addCssClass("listViewMatchTeamsContainer");
            this.scoreContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.scoreContainer.addCssClass("listViewMatchScoreContainer");
            this.cardContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.cardContainer.addCssClass("listViewMatchScoreContainer");
            this.homeRedcard = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.homeRedcard.addCssClass("listViewMatchRedCardAlt");
            this.awayRedcard = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.awayRedcard.addCssClass("listViewMatchRedCardAlt");
            this.scoreLocal = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.scoreAway = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.homePanelContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.homePanelContainer.addCssClass("listViewMatchHomeContainer");
            this.awayPanelContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.awayPanelContainer.addCssClass("listViewMatchAwayContainer");
            this.homeImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
            this.homeImage.addCssClass("listViewMatchTeamLogoContainerAlt");
            this.homeImage.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
            this.awayImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
            this.awayImage.addCssClass("listViewMatchTeamLogoContainerAlt");
            this.awayImage.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
            this.status = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.status.addCssClass("listViewMatchStatusContainerAlt");
            this.images = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.images.addCssClass("listViewMatchImageContainerAlt");
            this.statusAggr = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.statusAggr.addCssClass("listViewMatchStatusAggr");
            this.statusTime = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.statusTime.addCssClass("listViewMatchStatusScoreTime");
            this.statusMatch = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.statusMatch.addCssClass("listViewMatchStatusMatch listViewMatchStatusMatchAlt");
            this.hometeam = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.hometeam.setStyle("");
            this.hometeam.addCssClass("listViewMatchTeamTitleAlt");
            this.awayteam = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.awayteam.setStyle("");
            this.awayteam.addCssClass("listViewMatchTeamTitleAlt");
            //this.arrowContainer.addControl(this.arrow);
            //this.panel.addControl(this.arrowContainer);
            this.panel.addControl(this.contentPanel);
            this.contentPanel.addControl(this.left);
            this.contentPanel.addControl(this.right);
            this.left.addControl(this.status);
            if (this.renderVariant == 3) {
                this.left.addControl(this.images);
                this.images.addControl(this.homeImage);
                this.images.addControl(this.awayImage);
            }
            this.left.addControl(this.teamsContainer);
            this.teamsContainer.addControl(this.hometeam);
            this.teamsContainer.addControl(this.awayteam);
            this.cardContainer.addControl(this.homeRedcard);
            this.cardContainer.addControl(this.awayRedcard);
            this.scoreContainer.addControl(this.scoreLocal);
            this.scoreContainer.addControl(this.scoreAway);
            this.right.addControl(this.cardContainer);
            this.right.addControl(this.scoreContainer);
            if (!this.hideBell) {
                this.notificationContainer.addControl(this.notificationBell);
                this.right.addControl(this.notificationContainer);
            }
            this.status.addControl(this.statusAggr);
            this.status.addControl(this.statusMatch);
        }
        this.panel.bind('click', (e)=>{
            if (this.data.match_file_exist == 0) {
                console.warn("no match file exists for this match ", this.data.id);
                return;
            }
            e.stopPropagation();
            e.stopImmediatePropagation();
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showMatchScreen(this.getPage(), this.data);
        });
        if (!AppInstance.isOnline()) this.notificationBell.addCssClass("icon-bell-disabled");
        this.notificationContainer.bind("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            if (!AppInstance.isOnline()) return;
            if ((0, $9yWe2.MatchUtil).isFinished(this.data)) {
                console.log("match already finished. do nothing");
                return;
            }
            if ((0, $542851713e8a5d10$export$60959659b2c22881).hasMatchSubscription(this.data.id)) {
                this.notificationBell.removeCssClass("icon-bell-active");
                this.notificationBell.addCssClass("icon-bell-inactive");
                (0, $542851713e8a5d10$export$60959659b2c22881).unsubscribeMatch(this.data.id, (result)=>{
                    if (!result) {
                        this.notificationBell.removeCssClass("icon-bell-inactive");
                        this.notificationBell.addCssClass("icon-bell-error");
                        setTimeout(()=>{
                            this.notificationBell.removeCssClass("icon-bell-error");
                            this.notificationBell.addCssClass("icon-bell-active");
                        }, 800);
                    }
                });
            } else {
                this.notificationBell.removeCssClass("icon-bell-inactive");
                this.notificationBell.addCssClass("icon-bell-active");
                (0, $542851713e8a5d10$export$60959659b2c22881).subscribeMatch(this.data.id, (result)=>{
                    if (!result) {
                        this.notificationBell.removeCssClass("icon-bell-active");
                        this.notificationBell.addCssClass("icon-bell-error");
                        setTimeout(()=>{
                            this.notificationBell.removeCssClass("icon-bell-error");
                            this.notificationBell.addCssClass("icon-bell-inactive");
                        }, 800);
                    }
                });
            }
        });
    }
    setData(data, preventRender, preventInstantRender) {
        super.setData(data);
        if (preventRender) return;
        if (this.cachedHeight != data.style.height) this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.cachedHeight = data.style.height;
        if (AppInstance.isOnline()) {
            this.notificationBell.removeCssClass("icon-bell-active");
            this.notificationBell.removeCssClass("icon-bell-disabled");
            this.notificationBell.removeCssClass("icon-bell-inactive");
            if ((0, $9yWe2.MatchUtil).isFinished(this.data)) this.notificationBell.addCssClass("icon-bell-disabled");
            else if ((0, $542851713e8a5d10$export$60959659b2c22881).hasMatchSubscription(this.data.id)) this.notificationBell.addCssClass("icon-bell-active");
            else this.notificationBell.addCssClass("icon-bell-inactive");
        }
        if (this.renderVariant == 1) {
            this.hometeam.clear();
            this.statusTime.clear();
            this.awayteam.clear();
            this.statusAggr.clear();
            this.statusMatch.clear();
            this.hometeam.addControl(this.data.localteam);
            this.awayteam.addControl(this.data.visitorteam);
            if (this.showWhenFavorite) {
                if ((0, $aabc673d1ba8b527$export$db78e401119da622).isFavoriteTeam(this.data.gs_localteamid)) this.hometeam.addControl("<p class='icon-favorite-on listViewTeamFavoriteStar'></p>");
                if ((0, $aabc673d1ba8b527$export$db78e401119da622).isFavoriteTeam(this.data.gs_visitorteamid)) this.awayteam.addControl("<p class='icon-favorite-on listViewTeamFavoriteStar'></p>");
            }
            this.statusMatch.removeCssClass("green");
            this.statusMatch.removeCssClass("yellow");
            this.statusMatch.removeCssClass("red");
            //console.log(this.data.localteam,this.data);
            //we cache the status to avoid re-processing during scrolling
            if (!this.data.cachedStatus) {
                this.data.cachedStatus = {};
                var penaltyLive = false;
                if ((0, $9yWe2.MatchUtil).isLivePenalty(this.data)) {
                    penaltyLive = true;
                    this.data.cachedStatus.statusMatchCss = "green";
                    this.data.cachedStatus.statusAggr = (0, $9yWe2.MatchUtil).getLocalizedPenalty(this.data);
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getShortStatus(this.data);
                } else if ((0, $9yWe2.MatchUtil).isPenalty(this.data)) {
                    penaltyLive = true;
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getLocalizedPenalty(this.data);
                } else if ((0, $9yWe2.MatchUtil).isPlaying(this.data)) {
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getShortStatus(this.data);
                    this.data.cachedStatus.statusMatchCss = "green";
                } else if ((0, $9yWe2.MatchUtil).isHalftime(this.data)) {
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getShortStatus(this.data);
                    this.data.cachedStatus.statusMatchCss = "green";
                } else if ((0, $9yWe2.MatchUtil).isFinished(this.data)) ;
                else if ((0, $9yWe2.MatchUtil).isPostponed(this.data)) {
                    this.data.cachedStatus.statusMatchCss = "red";
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getShortStatus(this.data);
                // holder1.statusgreen.setVisibility(View.VISIBLE);
                // holder1.statusgreen.setTextColor(Color.parseColor("#F58282"));
                // holder1.statusgreen.setTextSize(TypedValue.COMPLEX_UNIT_SP, 12);
                // holder1.statusgreen.setText(mContext.getResources().getString(com.holoduke.football_live.base.R.string.postponed_short));
                } else if ((0, $9yWe2.MatchUtil).isInterrupted(this.data)) {
                    this.data.cachedStatus.statusMatchCss = "yellow";
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getShortStatus(this.data);
                } else if ((0, $9yWe2.MatchUtil).isAbandoned(this.data)) {
                    this.data.cachedStatus.statusMatchCss = "yellow";
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getShortStatus(this.data);
                } else if ((0, $9yWe2.MatchUtil).isCancelled(this.data)) {
                    this.data.cachedStatus.statusMatchCss = "yellow";
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getShortStatus(this.data);
                } else if ((0, $9yWe2.MatchUtil).isSuspended(this.data)) {
                    this.data.cachedStatus.statusMatchCss = "yellow";
                    this.data.cachedStatus.statusMatch = (0, $9yWe2.MatchUtil).getShortStatus(this.data);
                }
                if (!penaltyLive && this.data.aggregateScore != null) this.data.cachedStatus.statusAggr = (0, $9yWe2.MatchUtil).getLocalizedAggregateScore(this.data);
            }
            if (this.data.cachedStatus) {
                if (this.data.cachedStatus.statusMatchCss) this.statusMatch.addCssClass(this.data.cachedStatus.statusMatchCss);
                if (this.data.cachedStatus.statusAggr) this.statusAggr.addControl(this.data.cachedStatus.statusAggr);
                else this.statusAggr.addControl("");
                if (this.data.cachedStatus.statusMatch) this.statusMatch.addControl(this.data.cachedStatus.statusMatch);
                else this.statusMatch.addControl("");
            }
            //when user is fast scrolling we dont update all images classantly. too much of a performance hit
            if (this.listRender && this.listRender.isFastScrolling) {
                if (this.data.cachedLocalizedScoreTime) this.statusTime.addControl(this.data.cachedLocalizedScoreTime);
                clearTimeout(this.backoffMethod);
                this.backoffMethod = setTimeout(()=>{
                    if (this.unloaded) return console.warn("page is unloaded abort further actions");
                    this.usingPlaceholderTeamImage = false;
                    this.statusTime.clear();
                    this.data.cachedLocalizedScoreTime = (0, $9yWe2.MatchUtil).getLocalizedScoreTime(this.data);
                    this.statusTime.addControl(this.data.cachedLocalizedScoreTime, true);
                    this.homeImage.alt = this.data.localteam;
                    this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + this.data.gs_localteamid + "_small_rnd.png", AppInstance.getConfig().sizes.fixtureListImageSize, AppInstance.getConfig().sizes.fixtureListImageSize);
                    this.awayImage.alt = this.data.visitorteam;
                    this.awayImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + this.data.gs_visitorteamid + "_small_rnd.png", AppInstance.getConfig().sizes.fixtureListImageSize, AppInstance.getConfig().sizes.fixtureListImageSize);
                }, 300);
                if (!this.usingPlaceholderTeamImage) {
                    this.homeImage.showPlaceHolder();
                    this.awayImage.showPlaceHolder();
                }
            //this.usingPlaceholderTeamImage = true;
            } else {
                if (!this.data.cachedLocalizedScoreTime) this.data.cachedLocalizedScoreTime = (0, $9yWe2.MatchUtil).getLocalizedScoreTime(this.data);
                this.statusTime.addControl(this.data.cachedLocalizedScoreTime);
                this.homeImage.alt = this.data.localteam;
                this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + this.data.gs_localteamid + "_small_rnd.png", AppInstance.getConfig().sizes.fixtureListImageSize, AppInstance.getConfig().sizes.fixtureListImageSize);
                this.awayImage.alt = this.data.visitorteam;
                this.awayImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + this.data.gs_visitorteamid + "_small_rnd.png", AppInstance.getConfig().sizes.fixtureListImageSize, AppInstance.getConfig().sizes.fixtureListImageSize);
            }
        } else {
            this.hometeam.clear();
            this.awayteam.clear();
            this.scoreLocal.clear();
            this.scoreAway.clear();
            this.statusMatch.clear();
            this.scoreLocal.addControl((0, $9yWe2.MatchUtil).getLocalScore(this.data));
            this.scoreAway.addControl((0, $9yWe2.MatchUtil).getAwayScore(this.data));
            this.hometeam.addControl(this.data.localteam);
            this.awayteam.addControl(this.data.visitorteam);
            if (this.showWhenFavorite) {
                if ((0, $aabc673d1ba8b527$export$db78e401119da622).isFavoriteTeam(this.data.gs_localteamid)) this.hometeam.addControl("<p class='icon-favorite-on listViewTeamFavoriteStar'></p>");
                if ((0, $aabc673d1ba8b527$export$db78e401119da622).isFavoriteTeam(this.data.gs_visitorteamid)) this.awayteam.addControl("<p class='icon-favorite-on listViewTeamFavoriteStar'></p>");
            }
            this.statusMatch.removeCssClass("green");
            this.statusMatch.removeCssClass("yellow");
            this.statusMatch.removeCssClass("red");
            if (this.showAlwaysTime) this.statusMatch.addControl((0, $9yWe2.MatchUtil).getLocalizedDate(this.data, false, true).trim());
            else if ((0, $9yWe2.MatchUtil).isPlaying(this.data)) {
                this.statusMatch.addCssClass("green");
                this.statusMatch.addControl((0, $9yWe2.MatchUtil).getShortStatus(this.data));
            } else if ((0, $9yWe2.MatchUtil).isFinished(this.data)) this.statusMatch.addControl((0, $9yWe2.MatchUtil).getShortStatus(this.data));
            else if ((0, $9yWe2.MatchUtil).isLivePenalty(this.data)) this.statusMatch.addControl((0, $9yWe2.MatchUtil).getShortStatus(this.data));
            else if ((0, $9yWe2.MatchUtil).isPostponed(this.data)) {
                this.statusMatch.addCssClass("red");
                this.statusMatch.addControl((0, $9yWe2.MatchUtil).getShortStatus(this.data));
            } else this.statusMatch.addControl((0, $9yWe2.MatchUtil).getLocalizedScoreTime(this.data).trim());
            if ((0, $9yWe2.MatchUtil).hasAggregatedScore(this.data)) {
                if (this.data.aggregateWinner == 1) {
                    this.scoreLocal.addControl(" [<p class='listViewMatchScoreAggrPen greentext'>" + (0, $9yWe2.MatchUtil).getLocalAggregateScore(this.data) + "</p>]");
                    this.scoreAway.addControl(" [<p class='listViewMatchScoreAggrPen'>" + (0, $9yWe2.MatchUtil).getAwayAggregateScore(this.data) + "</p>]");
                } else if (this.data.aggregateWinner == 2) {
                    this.scoreLocal.addControl(" [<p class='listViewMatchScoreAggrPen'>" + (0, $9yWe2.MatchUtil).getLocalAggregateScore(this.data) + "</p>]");
                    this.scoreAway.addControl(" [<p class='listViewMatchScoreAggrPen greentext'>" + (0, $9yWe2.MatchUtil).getAwayAggregateScore(this.data) + "</p>]");
                } else {
                    this.scoreLocal.addControl(" [<p class='listViewMatchScoreAggrPen'>" + (0, $9yWe2.MatchUtil).getLocalAggregateScore(this.data) + "</p>]");
                    this.scoreAway.addControl(" [<p class='listViewMatchScoreAggrPen'>" + (0, $9yWe2.MatchUtil).getAwayAggregateScore(this.data) + "</p>]");
                }
            }
            if ((0, $9yWe2.MatchUtil).hasPenaltyScore(this.data)) {
                if (this.data.penaltyLocalTeam > this.data.penaltyVisitorTeam) {
                    this.scoreLocal.addControl(" [<p style='font-weight:normal;font-size:var(--text-size-xsmall);display:inline' class='greentext'>" + this.data.penaltyLocalTeam + "</p>]");
                    this.scoreAway.addControl(" [<p style='font-weight:normal;font-size:var(--text-size-xsmall);display:inline'>" + this.data.penaltyVisitorTeam + "</p>]");
                } else if (this.data.penaltyLocalTeam < this.data.penaltyVisitorTeam) {
                    this.scoreLocal.addControl(" [<p style='font-weight:normal;font-size:var(--text-size-xsmall);display:inline'>" + this.data.penaltyLocalTeam + "</p>]");
                    this.scoreAway.addControl(" [<p style='font-weight:normal;font-size:var(--text-size-xsmall);display:inline' class='greentext'>" + this.data.penaltyVisitorTeam + "</p>]");
                } else {
                    this.scoreLocal.addControl(" [<p style='font-weight:normal;font-size:var(--text-size-xsmall);display:inline' class='greentext'>" + this.data.penaltyLocalTeam + "</p>]");
                    this.scoreAway.addControl(" [<p style='font-weight:normal;font-size:var(--text-size-xsmall);display:inline'>" + this.data.penaltyVisitorTeam + "</p>]");
                }
            }
            if (this.renderVariant == 3) {
                var size = 28;
                this.homeImage.alt = this.data.localteam;
                this.awayImage.alt = this.data.visitorteam;
                if (AppInstance.getConfig().enabledFeatures.teamImages) {
                    this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + this.data.gs_localteamid + "_small_rnd.png", size, size);
                    this.awayImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + this.data.gs_visitorteamid + "_small_rnd.png", size, size);
                } else {
                    this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/country/" + this.data.gs_localteamid + "_small_rnd.png", size, size);
                    this.awayImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/country/" + this.data.gs_visitorteamid + "_small_rnd.png", size, size);
                }
            }
        }
        this.homeRedcard.setCss({
            "visibility": "hidden"
        });
        this.awayRedcard.setCss({
            "visibility": "hidden"
        });
        if (this.data.localteamrc) this.homeRedcard.setCss({
            "visibility": ""
        });
        if (this.data.visitorteamrc) this.awayRedcard.setCss({
            "visibility": ""
        });
        //TODO find out if below can be optimized
        if (!preventInstantRender) {
            if (this.isRendered) this.contentPanel.invalidateDisplay();
        //console.log("invalidate");
        //this.contentPanel.invalidateDisplay();
        }
    }
}
class $ae10f9e8e1dd758b$export$fca24ef23eb5ae98 extends $ae10f9e8e1dd758b$export$c4e73d64e644a882 {
    createComponents() {
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.setStyle("width:90%;margin-top:2px;padding-bottom:2px;border-bottom:1px solid #eeeeee;cursor:pointer;");
        this.addControl(this.panel);
        this.imageBox = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.imageBox.setStyle("float:left;width:100px;margin-right:8px;");
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.setStyle("float:left;");
        this.panel.addControl(this.imageBox);
        this.panel.addControl(this.contents);
        //this.imageBox.addControl("<img style='width:40px' src=https://holoduke.nl/footapi/images/flags/"+this.data.country.replace(" ","-").toLowerCase()+".png?" + new Date().getTime()+"></img>");
        this.contents.addControl("<h6>" + this.data.leagueName);
        this.contents.addControl(this.data.developer);
        this.panel.bind('click', ()=>{
            window.lastScrollPosition = $(document).scrollTop();
            UrlManager.registerModule("subsection");
            UrlManager.setModule("subsection", "competition", true);
            UrlManager.registerModule("league");
            UrlManager.setModule("league", this.data.key);
            // UrlManager.registerModule("country");
            // UrlManager.setModule("country",encodeURIComponent(this.data.country.replace(" ","")));
            this.getPage().autoLoadSubSection();
        // this.getPage().getApplication().loadPage("PlayerDetail",{'id':this.data.id_gs});
        });
    }
}
class $ae10f9e8e1dd758b$export$45388f8503fc1f41 extends $ae10f9e8e1dd758b$export$c4e73d64e644a882 {
    createComponents() {
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.setStyle("width:90%;margin-top:2px;padding-bottom:2px;border-bottom:1px solid #eeeeee;cursor:pointer;");
        this.addControl(this.panel);
        this.imageBox = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.imageBox.setStyle("float:left;width:70px;margin-right:8px;");
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.setStyle("float:left;");
        this.panel.addControl(this.imageBox);
        this.panel.addControl(this.contents);
        this.panel.addControl("<div style='clear:both'></div>");
        this.imageBox.addControl("<img style='width:60px' src=https://holoduke.nl/footapi/images/teams_gs/" + this.data.id + ".png?" + new Date().getTime() + "></img>");
        this.contents.addControl("<h6>" + this.data.name);
        this.contents.addControl(this.data.developer);
        this.panel.bind('click', ()=>{
            this.getPage().getApplication().loadPage("TeamDetail", {
                'id': this.data.id
            });
        });
    }
}
class $ae10f9e8e1dd758b$export$d120ce917f1dbbe9 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(alternativeRender) {
        super.init();
        this.alternativeRender = alternativeRender;
        var yearSelectContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        yearSelectContainer.setStyle("background-color:var(--listHeaderBackground);height:40px;width:100%;display:none;");
        this.addControl(yearSelectContainer);
        this.yearSelectContainer = yearSelectContainer;
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("flexHorizontalAlign");
        this.addControl(this.panel);
    }
    setData(data) {
        super.setData(data);
        console.log("--->", data, data);
        if (data.data.tableHistory && data.data.tableHistory.seasons.length) {
            this.yearSelectContainer.setCss({
                "display": "block"
            });
            var con = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            con.setStyle("width:100%;justify-content: center;font-size: 15px;font-variant: all-small-caps;cursor:pointer;");
            con.addCssClass("flexHorizontalAlign");
            var back = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            back.setStyle("display:inline;margin-right:auto;");
            back.addControl("2023");
            //con.addControl(back);
            var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            if (this.data.data.historyTable) title.addControl((0, $02mnx.Localizer).getString("season") + " " + data.data.historyTable.season);
            else title.addControl((0, $02mnx.Localizer).getString("season") + " " + data.data.table.season);
            con.addControl(title);
            con.addControl("<p class='arrow-down-choice' style='margin-top:3px; margin-inline-start:6px;'></p>");
            var forward = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            forward.setStyle("display:inline;margin-left:auto;");
            forward.addControl("2025");
            //con.addControl(forward);
            this.yearSelectContainer.clear();
            this.yearSelectContainer.addControl(con, true);
            this.yearSelectContainer.bind("click", ()=>{
                this.listRender.triggerEvent("onRequestSeasonSelector");
            });
        }
        if (this.data.data.historyTable) var groupsData = this.data.data.historyTable.groups;
        else groupsData = this.data.data.table.groups;
        console.log("create standings for group ", groups);
        this.panel.addControl("<table class='tableStandings'>");
        for(var i = 0; i < groupsData.length; i++){
            var groups = groupsData[i];
            var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
            row.setStyle("height:30px;");
            if (this.alternativeRender) row.setStyle("height:24px;");
            var th1 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            var th1Arrow = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            var th2 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th1Arrow.setAttribute("colspan", 3);
            if (this.alternativeRender) title1 = (0, $02mnx.Localizer).getString("round") + " " + groups.round;
            else {
                var title1 = groups.group.replace(data.data.info.title, "").replace(":", "").trim().trimStart();
                if (title1 && groups.round != 0) title1 += " - " + (0, $02mnx.Localizer).getString("round") + " " + groups.round;
                else {
                    if (groupsData.length > 1 && groups.round != 0) title1 = (0, $02mnx.Localizer).getString("round") + " " + groups.round;
                    else if (groups.group && groups.group != data.data.info.title) title1 = groups.group;
                    else if (data.data.info.stageName) title1 = (0, $02mnx.Localizer).getString(data.data.info.stageName);
                }
            }
            th1Arrow.addControl(title1);
            th1Arrow.setStyle("text-align:left;padding-left:4px;");
            var th3 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            var th4 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th4.addControl((0, $02mnx.Localizer).getString("table_gamesplayed"));
            var th5 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th5.addControl((0, $02mnx.Localizer).getString("table_wins"));
            var th6 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th6.addControl((0, $02mnx.Localizer).getString("table_draw"));
            var th7 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th7.addControl((0, $02mnx.Localizer).getString("table_lost"));
            var th8 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th8.addControl((0, $02mnx.Localizer).getString("table_goalsforagainst"));
            th8.setStyle("min-width:41px;");
            var th9 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th9.addControl((0, $02mnx.Localizer).getString("table_goaldiff"));
            var th10 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th10.addControl((0, $02mnx.Localizer).getString("table_points"));
            if (!this.alternativeRender) row.addControl(th1);
            row.addControl(th1Arrow);
            //row.addControl(th2);
            //row.addControl(th3);
            row.addControl(th4);
            row.addControl(th5);
            row.addControl(th6);
            row.addControl(th7);
            row.addControl(th8);
            row.addControl(th9);
            row.addControl(th10);
            this.panel.addControl(row);
            for(var j = 0; j < groups.teams.length; j++){
                var team = groups.teams[j];
                var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
                var pos = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                var imageCon = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                if (!this.alternativeRender) {
                    pos.addControl(j + 1 + "");
                    if (team.color) pos.setStyle("border-top-right-radius: 8px;border-bottom-right-radius: 8px;background-color:" + team.color + "; color:" + (0, $e8daee01203954a7$export$a3cf7111e6b6bc75).getCorrectTextColor(team.color));
                    if (AppInstance.getConfig().enabledFeatures.teamImages) {
                        var image = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
                        image.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
                        image.setCss({
                            'height': "36px",
                            'width': "36px"
                        });
                        image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + team.id_gs + "_small_rnd.png", 36, 36);
                        imageCon.addControl(image);
                    }
                } else row.setStyle("height:24px;");
                var colArrow = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                if (team.position_change > 0) colArrow.addControl("<div class='arrow-up'></div>");
                else if (team.position_change < 0) colArrow.addControl("<div class='arrow-down'></div>");
                var col1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                col1.addCssClass("standingsTeamName");
                if (this.alternativeRender) col1.addControl((0, $02mnx.Localizer).getString("position") + ": " + team.position);
                else col1.addControl(team.team);
                col1.setStyle("text-align: left;");
                if (team.isLive) col1.addCssClass("standingsLive");
                var gp = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                gp.addControl(team.matchPoints + "");
                var w = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                w.addControl(team.totalWon + "");
                var d = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                d.addControl(team.totalDraw + "");
                var l = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                l.addControl(team.totalLost + "");
                var gf = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                gf.setStyle("font-size:10px;");
                gf.addControl(team.totalGoalsFor + "-" + team.totalGoalsAgainst);
                var gd = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                gd.addControl(team.totalGoalsFor - team.totalGoalsAgainst + "");
                var points = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                points.addControl(team.points + "");
                if (!this.alternativeRender) row.addControl(pos);
                row.addControl(colArrow);
                row.addControl(imageCon);
                row.addControl(col1);
                row.addControl(gp);
                row.addControl(w);
                row.addControl(d);
                row.addControl(l);
                row.addControl(gf);
                row.addControl(gd);
                row.addControl(points);
                this.panel.addControl(row);
                (function(team, groups, alternativeRender) {
                    row.bind("click", function() {
                        if (alternativeRender) {
                            console.log(data);
                            var d = {
                                leagueKey: data.data.league.key
                            };
                            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(d, {
                                "action": "showStandings"
                            });
                        } else (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(team.id_gs);
                    });
                })(team, groups, this.alternativeRender);
            }
        }
        this.panel.addControl("</table>");
    }
}
class $ae10f9e8e1dd758b$export$ee3300d1140ed632 extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    getFocusable() {
        return this.panel;
    }
    init() {
        super.init();
        // Ad container
        this.adContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.adContainer.addCssClass("adContainer");
        this.adContainer.setCss({
            "display": "flex",
            "justify-content": "space-around"
        });
        this.addControl(this.adContainer);
    }
    setData(data) {
        this.adContainer.clear();
        // Create ad placeholder - you can replace this with actual ad integration
        const adContent = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        adContent.addCssClass("mediumRectangleContent");
        adContent.setCss({
            "width": "100%",
            "height": "240px",
            "backgroundColor": "#f0f0f0",
            "display": "flex",
            "justifyContent": "center",
            "alignItems": "center",
            "overflow": "hidden"
        });
        adContent.addControl(data.html);
        this.adContainer.addControl(adContent);
        console.log("render mrec ", data);
        this.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$5094fa700c8c41ca extends (0, $f29955da1dcf3c72$export$9a51b5736e54ae3e) {
    getFocusable() {
        return this.panel;
    }
    init() {
        super.init();
        this.panel = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
        this.panel.addCssClass("listView");
        this.panel.addCssClass("flexHorizontalAlign flexAlignStart");
        this.addControl(this.panel);
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.addCssClass("listViewCountryFlagItem");
        this.imageBox.placeholderData = (0, $61e67aa413d59276$export$a4f156a9bb250a8c);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewCountryTitle");
        this.panel.addControl(this.imageBox);
        this.panel.addControl(this.contents);
        this.panel.setCss({
            "height": "50px"
        });
    }
    setData(data) {
        this.contents.clear();
        this.imageBox.alt = data.leagueName;
        this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.country.replaceAll(" ", "-").toLowerCase() + ".png", 40, 40);
        this.contents.addControl(data.leagueName);
        this.panel.unbind("click");
        this.panel.bind("click", ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(data);
        });
        this.invalidateDisplay();
    }
}
class $ae10f9e8e1dd758b$export$62763c6558b56e7c extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    createComponents() {}
    setData(data) {
        this.card.clear();
        var formatted = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: "numeric",
            minute: "numeric"
        }).format(new Date(data.ts * 1000));
        var date = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        date.addControl("<i>" + formatted + "</i>");
        date.setStyle("font-size:11px;margin-inline-start: 8px;padding-top:8px;");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("MatchStatsTiteText MatchH2HTitle");
        title.setStyle("padding:8px;text-align:start;font-weight:bold;");
        title.addControl(data.title);
        this.card.addControl(title);
        this.card.addControl(date);
        if (AppInstance.getConfig().appmode == "ios") {
            var mainContainer = new (0, $d7e810688df07bfd$export$a6c7ac8248d6e38a)();
            mainContainer.setHref(data.link + "?externalLink=1");
        } else {
            var mainContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.card.bind("click", ()=>{
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).openUrl(data.link, true);
            });
        }
        //mainContainer.setHref(data.link+"?externalLink=1");
        //mainContainer.addCssClass("flexHorizontalAlign");
        mainContainer.setStyle("padding-bottom:4px;");
        //window.l = this;
        //var w = this.getPage().getDimensions().width / 3;
        var w = 175;
        var h = w * 0.65;
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.setStyle("float:right;width:" + w + "px;height:" + h + "px;border-radius:4px;margin:8px;margin-top:-22px;display: inline-block");
        image.setImage(data.image);
        var description = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        description.setStyle("margin-top:12px;margin:8px;text-align: start;line-height: 18px;");
        description.addControl(data.description);
        description.getTagName = function() {
            return 'p';
        };
        // var link = new Link();
        // link.setHref("http://www.google.com");
        // link.addControl("aaaaaaap");
        if (data.image != "http://holoduke.nl/footapi/news_visual_voetbalnieuws.jpg") mainContainer.addControl(image);
        mainContainer.addControl(description);
        //mainContainer.addControl(link);
        this.card.addControl(mainContainer);
        this.card.addControl("<div style='clear:both;width:96%;height:1px;background-color:var(--tab-border-color);margin:8px;'></div>");
    }
}
class $ae10f9e8e1dd758b$export$4a590bcb9bb280eb extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-bottom:40px;");
        //
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.panel.setStyle("margin-top:3px;margin-bottom:-3px;");
        this.card.setStyle("padding-bottom:4px;height:48px;cursor:pointer;");
        //
        this.content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //this.content.addCssClass("flexHorizontalAlign");
        this.content.setStyle("height: 100%;");
        this.card.addControl(this.content);
        this.left = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.left.addCssClass("flexHorizontalAlign flexAlignStart");
        this.right = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.right.addCssClass("flexHorizontalAlign flexAlignEnd");
        this.position = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.position.setStyle("min-width:20px;margin-inline-end: 4px;margin-inline-start: 4px;");
        this.image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.image.setStyle("width:40px;height:40px;");
        this.name = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.name.setStyle("font-weight:bold;margin-inline-end: 8px;margin-inline-start: 8px;");
        this.points = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        if (FootballManiaConfig.isRtl) this.points.setStyle("margin-inline-end: 8px;margin-inline-start: 8px;margin-right: auto;");
        else this.points.setStyle("margin-inline-end: 8px;margin-inline-start: 8px;margin-left: auto;");
        this.left.addControl(this.position);
        this.left.addControl(this.image);
        this.left.addControl(this.name);
        this.left.addControl(this.points);
        this.content.addControl(this.left);
        this.content.addControl(this.right);
        this.panel.bind('click', ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(this.data.id_gs);
        });
        this.addControl(this.panel);
    }
    setData(data) {
        this.data = data;
        this.panel.setCss({
            "height": data.style.height + 4 + "px"
        });
        this.position.clear();
        this.name.clear();
        this.points.clear();
        this.position.addControl(data.position, true);
        this.name.addControl(data.team, true);
        this.image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + data.id_gs + "_small_rnd.png", 40, 40);
        this.image.setAttribute("width", 40);
        this.image.setAttribute("height", 40);
        this.points.addControl(data.points, true);
    }
}



var $9yWe2 = parcelRequire("9yWe2");
class $aeb70e56f7d1eb62$export$58b0d2e434fc5ae2 extends (0, $3be81c086bc509fb$export$1773bf8c632ebee7) {
    init() {
        console.log("STARTING APPLICATION, Developed by Gillis Haasnoot (gillis.haasnoot@gmail.com)");
        super.init();
        var currentPageName;
        //this.setStyle("position:fixed;")
        var topBar = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topBar.tagName = "header";
        topBar.addCssClass("topBar");
        this.addControl(topBar);
        var topBarTopContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topBarTopContainer.addCssClass("topBarTopContainer");
        topBar.addControl(topBarTopContainer);
        var topTitleContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topTitleContainer.addCssClass("flexHorizontalAlign topBarTopTitleContainer");
        topBar.addControl(topTitleContainer);
        this.topTitleContainer = topTitleContainer;
        // var offlineIndicator = new Panel();
        // offlineIndicator.setStyle("height:20px; width:100%; background-color:red;")
        // topBar.addControl(offlineIndicator);
        var topLogoContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topLogoContainer.addCssClass("topLogoContainer");
        topBarTopContainer.addControl(topLogoContainer);
        topLogoContainer.bind("click", ()=>{
            this.getPage().ignoreResizeEvents = true; //ignore resize events to prevent flickering;
            let isFromHome = currentPageName == "Home";
            console.log("click home ", currentPageName);
            if (AppInstance.getConfig().appmode == "ios") {
                console.log("back", currentPageName);
                if (currentPageName != "Home" && !(0, $2ee970b2529997d7$export$55185c17a0fcbe46).isNavigatedFromPush() && history.length > 1) history.back();
                else (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showHome(this, isFromHome);
            } else (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showHome(this, isFromHome);
        });
        var topLogo = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.topLogo = topLogo;
        if (AppInstance.getConfig().appmode == "ios") topLogo.addCssClass("topLogoIOS");
        else topLogo.addCssClass("topLogo");
        topLogo.setAttribute("alt", "App logo");
        topLogoContainer.addControl(topLogo);
        var menuItems = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        menuItems.addCssClass("menuitemContainer");
        this.menuItems = menuItems;
        var search = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        search.addCssClass("topBarSearchContainer");
        search.setVisible(false);
        var searchBackArrow = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchBackArrow.addCssClass("menu-icon icon-back");
        searchBackArrow.setStyle("margin-inline-start:10px;margin-inline-end:30px;");
        var searchResultsCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchResultsCon.addCssClass("topBarSearchResultsContainer");
        var fade = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        fade.addCssClass("topBarSearchResultsFade");
        fade.setStyle("height:1000px;width:100%;background-color:#090c11db;position:fixed;left:0;");
        searchResultsCon.addControl(fade);
        fade.bind("click", (e)=>{
            this.deActivateSearch();
        });
        fade.bind("touchmove", (e)=>{
            e.preventDefault();
            e.stopPropagation();
        });
        var searchResult = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchResult.addCssClass("topBarSearchResults");
        this.searchResults = searchResult;
        searchResultsCon.addControl(searchResult);
        var searchInput = new (0, $2cf92be5dbbab152$export$574966fbea4a65e5)();
        search.addControl(searchBackArrow);
        search.addControl(searchInput);
        search.addControl(searchResultsCon);
        this.search = search;
        //menuItems.addControl("version "+FootballManiaConfig.clientVersion);
        var offlineIcon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.offlineIcon = offlineIcon;
        topBarTopContainer.addControl(offlineIcon);
        topBarTopContainer.addControl(menuItems);
        topBarTopContainer.addControl(search);
        if (!AppInstance.isOnline()) this.onOffline();
        this.topBar = topBar;
        this.topLogoContainer = topLogoContainer;
        AppInstance.getConfig().isWebStandalone;
        if (localStorage.getItem("clientVersion") != FootballManiaConfig.clientVersion) {
            this.showFakeLoader(FootballManiaConfig.clientVersion);
            localStorage.setItem("clientVersion", FootballManiaConfig.clientVersion);
        }
        this.hideTitle();
        this.bind("preLoadPage", (e, page)=>{
            currentPageName = page;
            if (AppInstance.getConfig().appmode == "ios") {
                if (page == "Home") topLogo.setVisible(false);
                else topLogo.setVisible(true);
            }
        });
        if (AppInstance.useWebAds()) {
            var bottom = new (0, $b327ff81cc3a41d8$export$5137ec99f248330b)();
            bottom.addCssClass("stickybanner");
            bottom.setAttribute("frameborder", "0");
            this.addControl(bottom, true);
            this.stickyBannerTargetContainer = bottom;
            this.stickyBannerTargetContainer.setVisible(false);
        }
    //bind key to window
    // window.addEventListener("keydown", (e) => {
    //     if (e.code == "Enter"){
    //         jQuery(document.activeElement).click();
    //     }
    //     //arrow down
    //     if (e.code == "ArrowDown") {
    //
    //     }
    //     //arrow up
    //     if (e.code == "ArrowUp") {
    //
    //     }
    //     //console.log(e);
    // });
    }
    hideStickBannerAd() {
        if (this.stickyBannerTargetContainer) {
            this.stickyBannerTargetContainer.setVisible(false);
            this.pageControl.triggerEvent("stickyBannerHide");
        }
    }
    loadStickyBannerAd() {
        if (!this.stickyBannerTargetContainer) {
            console.error("cannot load sticky banner ad without container");
            return;
        }
        (0, $9f67281357957bbc$export$89d41d4ee5fc0b81).loadStickyBanner(this.stickyBannerTargetContainer, (error)=>{
            if (error) {
                //this.stickyBannerTargetContainer.setVisible(false);
                console.warn("error loading sticky banner", error);
                (0, $9f67281357957bbc$export$89d41d4ee5fc0b81).loadHouseAd(this.stickyBannerTargetContainer, (error)=>{
                    if (error) {
                        this.stickyBannerTargetContainer.setVisible(false);
                        console.log("house ad failed");
                        this.pageControl.triggerEvent("stickyBannerLoadFail");
                    } else {
                        this.stickyBannerTargetContainer.setVisible(true);
                        console.log("house ad loaded");
                        this.pageControl.triggerEvent("stickyBannerLoadSuccess");
                    }
                });
            } else {
                this.stickyBannerTargetContainer.setVisible(true);
                console.log("custom ad loaded", this.pageControl);
                this.pageControl.triggerEvent("stickyBannerLoadSuccess");
            }
        });
    }
    showTitle() {
        this.topTitleContainer.clear();
        this.topTitleContainer.setVisible(true);
    }
    hideTitle() {
        this.topTitleContainer.clear();
        this.topTitleContainer.setVisible(false);
    }
    onOffline() {
        this.offlineIcon.addCssClass("icon icon-offline");
    }
    onOnline() {
        this.offlineIcon.removeCssClass("icon icon-offline");
    }
    // recreateLastMenu() {
    //     if (lastCreatedMenu == "Home") {
    //         this.createMenuHome(true);
    //     } else if (lastCreatedMenu == "Team") {
    //         this.createMenuTeam();
    //     } else if (lastCreatedMenu == "League") {
    //         this.createMenuLeague();
    //     } else if (lastCreatedMenu == "Match") {
    //         this.createMenuMatch();
    //     } else if (lastCreatedMenu == "Player") {
    //         this.createMenuPlayer();
    //     } else if (lastCreatedMenu == "News") {
    //         this.createMenuNews();
    //     } else if (lastCreatedMenu == "League") {
    //         this.createMenuLeague();
    //     } else if (lastCreatedMenu == "CountryLeagues") {
    //         this.createMenuCountryLeagues();
    //     } else if (lastCreatedMenu == "ForumChat") {
    //         this.createMenuForumChat();
    //     } else if (lastCreatedMenu == "TopVoters") {
    //         this.createMenuTopVoters();
    //     } else if (lastCreatedMenu == "ForumIndex") {
    //         this.createMenuForumIndex();
    //     } else if (lastCreatedMenu == "FifaRanking") {
    //         this.createMenuFifaRanking();
    //     }
    // }
    createMenuHome(showFilters, showIosBackButton) {
        this.lastCreatedMenu = "Home";
        this.deActivateSearch();
        this.menuItems.clear();
        if (localStorage.getItem("debug_mode") == 1) {
            var debug = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            debug.addCssClass("menu-icon icon-debug");
            debug.bind("click", ()=>{
                var modal = new (0, $2680d4151eb48962$export$8e94a76bd29c2eb5)("debugmenu");
                this.getPage().addControl(modal, true);
            });
            this.menuItems.addControl(debug, true);
        }
        var search = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        search.addCssClass("menu-icon icon-search");
        if (AppInstance.getConfig().enabledFeatures.search && AppInstance.isOnline()) this.menuItems.addControl(search, true);
        search.bind("click", ()=>{
            this.activateSearch();
        });
        if (showFilters) {
            if (AppInstance.getConfig().enabledFeatures.teamImages) {
                var listType = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                //filterFavorites.setStyle("width:32px;height:32px;")
                listType.addCssClass("menu-icon icon-listtype");
                this.menuItems.addControl(listType, true);
                listType.bind("click", ()=>{
                    listType.addCssClass("toggleRotate");
                    setTimeout(()=>{
                        listType.removeCssClass("toggleRotate");
                    }, 400);
                    var currentType = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType();
                    if (currentType == "1") (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setMatchListType("2");
                    else if (currentType == "2") (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setMatchListType("3");
                    else (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setMatchListType("1");
                });
            }
            var filterFavorites = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            //filterFavorites.setStyle("width:32px;height:32px;")
            filterFavorites.addCssClass("menu-icon icon-filter-favorites");
            this.menuItems.addControl(filterFavorites, true);
            filterFavorites.bind("click", ()=>{
                let set = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda();
                if (set) {
                    (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setShowOnlyFavoritesAgenda(false);
                    filterFavorites.removeCssClass("icon-filter-favorites-active");
                } else {
                    (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setShowOnlyFavoritesAgenda(true);
                    filterFavorites.addCssClass("icon-filter-favorites-active");
                }
            });
            let set = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda();
            if (set) filterFavorites.addCssClass("icon-filter-favorites-active");
            else filterFavorites.removeCssClass("icon-filter-favorites-active");
        }
        if (FootballManiaConfig.isAndroid) {
            var settings = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            settings.addCssClass("menu-icon icon-settings");
            settings.bind("click", function() {
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showSettings();
            });
            this.menuItems.addControl(settings, true);
        } else if (FootballManiaConfig.isIphone || FootballManiaConfig.isWebStandalone) {
            var darkmode = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            darkmode.addCssClass("menu-icon icon-darkmode");
            // const themes = ['light', 'dark', 'blue', 'darkpurple', 'darkred', 'cyberpunk','sunset',
            //     'soft-light', 'deep-dark', 'warm-light', 'cool-dark', 'peach-light',
            //     'slate-dark', 'mint-light', 'charcoal-dark', 'lavender-light', 'obsidian-dark',
            //     'sky-light', 'navy-dark', 'rose-light', 'graphite-dark', 'sand-light',
            //     'onyx-dark', 'ivory-light', 'jet-dark', 'coral-light', 'ebony-dark'
            // ];
            const themes = [
                'light',
                'dark',
                'blue',
                'darkpurple',
                'darkred',
                'cyberpunk'
            ];
            let currentIndex = themes.indexOf((0, $40e70090f1e1ff2d$export$5510f7c459d7063c).getCurrentTheme());
            this.menuItems.addControl(darkmode, true);
            darkmode.bind("click", function() {
                currentIndex = (currentIndex + 1) % themes.length;
                console.log("current index", currentIndex);
                (0, $40e70090f1e1ff2d$export$5510f7c459d7063c).applyTheme(themes[currentIndex]);
            });
            if (AppInstance.getConfig().appmode == "ios") {
                if (showIosBackButton) this.topLogo.setVisible(true);
                else this.topLogo.setVisible(false);
            }
        }
    // else if (FootballManiaConfig.isIphone){
    //     if (showIosBackButton){
    //         this.topLogo.setVisible(true);
    //     }
    //     else{
    //         this.topLogo.setVisible(false);
    //     }
    // }
    }
    createMenuAgenda() {
        this.lastCreatedMenu = "Agenda";
        this.menuItems.clear();
        //if (AppInstance.getConfig().enabledFeatures.teamImages) {
        var listType = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //filterFavorites.setStyle("width:32px;height:32px;")
        listType.addCssClass("menu-icon icon-listtype");
        this.menuItems.addControl(listType, true);
        listType.bind("click", ()=>{
            listType.addCssClass("toggleRotate");
            setTimeout(()=>{
                listType.removeCssClass("toggleRotate");
            }, 400);
            var currentType = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType();
            if (currentType == "1") (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setMatchListType("2");
            else if (currentType == "2") (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setMatchListType("3");
            else (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setMatchListType("1");
        });
        // }
        var filterFavorites = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        filterFavorites.addCssClass("menu-icon icon-filter-favorites");
        this.menuItems.addControl(filterFavorites, true);
        filterFavorites.bind("click", ()=>{
            let set = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda();
            if (set) {
                (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setShowOnlyFavoritesAgenda(false);
                filterFavorites.removeCssClass("icon-filter-favorites-active");
            } else {
                (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).setShowOnlyFavoritesAgenda(true);
                filterFavorites.addCssClass("icon-filter-favorites-active");
            }
        });
        let set = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda();
        if (set) filterFavorites.addCssClass("icon-filter-favorites-active");
        else filterFavorites.removeCssClass("icon-filter-favorites-active");
    }
    createMenuLeague(leagueData) {
        this.lastCreatedMenu = "League";
        this.deActivateSearch();
        this.menuItems.clear();
        if (!leagueData || !leagueData.info) {
            console.error("no league info");
            return;
        }
        var favorite = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        favorite.setStyle("margin-right:0;");
        if ((0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues()[leagueData.info.keygs]) {
            favorite.addCssClass("menu-icon");
            favorite.addCssClass("icon-favorite-on");
        } else {
            favorite.addCssClass("menu-icon");
            favorite.addCssClass("icon-favorite-off icon-favorite-off-topbar");
        }
        this.menuItems.addControl(favorite, true);
        favorite.bind("click", ()=>{
            if ((0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues()[leagueData.info.keygs]) {
                favorite.removeCssClass("icon-favorite-on");
                favorite.addCssClass("icon-favorite-off icon-favorite-off-topbar");
                (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteLeague(leagueData.info.keygs);
            } else if (!(0, $aabc673d1ba8b527$export$db78e401119da622).addFavoriteLeague(leagueData.info.keygs, leagueData.info.countrygs, leagueData.info.title)) {
                console.log("show toast");
                return this.showToast((0, $02mnx.Localizer).getString("max_favorite_leagues_reached"));
            } else {
                favorite.removeCssClass("icon-favorite-off icon-favorite-off-topbar");
                favorite.addCssClass("icon-favorite-on");
            }
            (0, $dNeVp.ManiaCache).deleteMemoryCache("homeData");
        });
        var subscribe = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        subscribe.setStyle("width:32px;height:32px;");
        subscribe.addCssClass("menu-icon icon-bell");
        if ((0, $542851713e8a5d10$export$60959659b2c22881).hasLeagueSubscription(leagueData.info.keygs)) subscribe.addCssClass("icon-bell-active");
        else subscribe.addCssClass("icon-bell-inactive");
        if (AppInstance.isOnline()) {
            subscribe.addCssClass("menu-icon icon-bell");
            subscribe.bind("click", (e)=>{
                if ((0, $542851713e8a5d10$export$60959659b2c22881).hasLeagueSubscription(leagueData.info.keygs)) {
                    subscribe.removeCssClass("icon-bell-active");
                    subscribe.addCssClass("icon-bell-inactive");
                    (0, $542851713e8a5d10$export$60959659b2c22881).unsubscribeLeague(leagueData.info.keygs, (result)=>{
                        if (!result) {
                            subscribe.removeCssClass("icon-bell-inactive");
                            subscribe.addCssClass("icon-bell-error");
                            setTimeout(()=>{
                                subscribe.removeCssClass("icon-bell-error");
                                subscribe.addCssClass("icon-bell-active");
                            }, 800);
                        }
                    });
                } else {
                    subscribe.removeCssClass("icon-bell-inactive");
                    subscribe.addCssClass("icon-bell-active");
                    (0, $542851713e8a5d10$export$60959659b2c22881).subscribeLeague(leagueData.info.keygs, (result)=>{
                        if (!result) {
                            subscribe.removeCssClass("icon-bell-active");
                            subscribe.addCssClass("icon-bell-error");
                            setTimeout(()=>{
                                subscribe.removeCssClass("icon-bell-error");
                                subscribe.addCssClass("icon-bell-inactive");
                            }, 800);
                        }
                    });
                }
            });
        } else subscribe.addCssClass("icon-bell-disabled");
        this.menuItems.addControl(subscribe, true);
    }
    createMenuPlayer(teamData) {
        this.lastCreatedMenu = "Player";
        this.deActivateSearch();
        this.menuItems.clear();
    }
    createMenuPlayerMarketValues(teamData) {
        this.lastCreatedMenu = "PlayerMarketValues";
        this.deActivateSearch();
        this.menuItems.clear();
        var filterFavorites = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //filterFavorites.setStyle("width:32px;height:32px;")
        filterFavorites.addCssClass("menu-icon icon-filter-favorites");
        this.menuItems.addControl(filterFavorites, true);
        filterFavorites.bind("click", ()=>{
            this.pageControl.triggerEvent("filterClicked");
        });
    }
    createMenuFifaRanking() {
        this.lastCreatedMenu = "FifaRanking";
        this.deActivateSearch();
        this.menuItems.clear();
    }
    createMenuForumIndex(teamData) {
        this.lastCreatedMenu = "ForumIndex";
        this.deActivateSearch();
        this.menuItems.clear();
        if ((0, $0dbc6ded793568e1$export$1a7533566a41982d).isLoggedIn()) {
            if ((0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser() == null) {
                (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogout(()=>{
                    console.log("logged out");
                    this.createMenuForumIndex();
                    this.showToast("logged_out");
                });
                return;
            }
            console.log("create menu forum chat -> login status true ");
            var logout = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            logout.addCssClass("menu-icon icon-logout");
            logout.bind("click", ()=>{
                (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogout(()=>{
                    console.log("logged out");
                    this.createMenuForumIndex();
                    this.showToast("logged_out");
                });
            });
            this.menuItems.addControl("<div style='font-size:16px;line-height:22px;font-variant: small-caps'>" + (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser().un + "</div>", true);
            this.menuItems.addControl(logout, true);
        } else {
            console.log("create menu forum chat -> login status false ");
            var login = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            login.addCssClass("menu-icon icon-login");
            login.bind("click", ()=>{
                this.hideStickBannerAd();
                (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogin((result)=>{
                    console.log("login result", result);
                    if (result) {
                        this.createMenuForumIndex();
                        this.showToast((0, $02mnx.Localizer).getString("logged_in_as").replace("%s", (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser().un));
                    }
                    this.loadStickyBannerAd();
                });
            });
            this.menuItems.addControl(login, true);
        }
    }
    createMenuTopVoters() {
        this.lastCreatedMenu = "TopVoters";
        this.createMenuForumChat();
    }
    createMenuForumChat() {
        this.lastCreatedMenu = "ForumChat";
        this.deActivateSearch();
        this.menuItems.clear();
        if ((0, $0dbc6ded793568e1$export$1a7533566a41982d).isLoggedIn()) {
            if ((0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser() == null) {
                (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogout(()=>{
                    console.log("logged out");
                    this.createMenuForumChat();
                    this.showToast("logged_out");
                });
                return;
            }
            console.log("create menu forum chat -> login status true ");
            var logout = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            logout.addCssClass("menu-icon icon-logout");
            logout.bind("click", ()=>{
                (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogout(()=>{
                    console.log("logged out");
                    this.createMenuForumChat();
                    this.showToast("logged_out");
                });
            });
            this.menuItems.addControl("<div style='font-size:16px;line-height:22px;font-variant: small-caps'>" + (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser().un + "</div>", true);
            this.menuItems.addControl(logout, true);
        } else {
            console.log("create menu forum chat -> login status false ");
            var login = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            login.addCssClass("menu-icon icon-login");
            login.bind("click", ()=>{
                (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogin((result)=>{
                    console.log("login result", result);
                    if (result) {
                        this.createMenuForumChat();
                        this.showToast((0, $02mnx.Localizer).getString("logged_in_as").replace("%s", (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser().un));
                    }
                });
            });
            this.menuItems.addControl(login, true);
        }
    }
    createMenuTeam(teamData) {
        this.lastCreatedMenu = "Team";
        this.deActivateSearch();
        this.menuItems.clear();
        if (!teamData) return;
        var favorite = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        favorite.setStyle("margin-right:0;");
        if ((0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[teamData.id_gs]) {
            favorite.addCssClass("menu-icon");
            favorite.addCssClass("icon-favorite-on");
        } else {
            favorite.addCssClass("menu-icon");
            favorite.addCssClass("icon-favorite-off icon-favorite-off-topbar");
        }
        this.menuItems.addControl(favorite, true);
        favorite.bind("click", ()=>{
            if ((0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[teamData.id_gs]) {
                favorite.removeCssClass("icon-favorite-on");
                favorite.addCssClass("icon-favorite-off icon-favorite-off-topbar");
                (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteTeam(teamData.id_gs);
            } else {
                if (!(0, $aabc673d1ba8b527$export$db78e401119da622).addFavoriteTeam(teamData.id_gs, teamData.teamname)) return this.showToast((0, $02mnx.Localizer).getString("max_favorite_teams_reached"));
                else {
                    favorite.removeCssClass("icon-favorite-off icon-favorite-off-topbar");
                    favorite.addCssClass("icon-favorite-on");
                }
            }
            (0, $dNeVp.ManiaCache).deleteMemoryCache("homeData");
        });
        var subscribe = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        subscribe.setStyle("width:32px;height:32px;");
        if ((0, $542851713e8a5d10$export$60959659b2c22881).hasTeamSubscription(teamData.id_gs)) subscribe.addCssClass("icon-bell-active");
        else subscribe.addCssClass("icon-bell-inactive");
        subscribe.addCssClass("menu-icon icon-bell");
        subscribe.bind("click", (e)=>{
            if ((0, $542851713e8a5d10$export$60959659b2c22881).hasTeamSubscription(teamData.id_gs)) {
                subscribe.removeCssClass("icon-bell-active");
                subscribe.addCssClass("icon-bell-inactive");
                (0, $542851713e8a5d10$export$60959659b2c22881).unsubscribeTeam(teamData.id_gs, (result)=>{
                    if (!result) {
                        subscribe.removeCssClass("icon-bell-inactive");
                        subscribe.addCssClass("icon-bell-error");
                        setTimeout(()=>{
                            subscribe.removeCssClass("icon-bell-error");
                            subscribe.addCssClass("icon-bell-active");
                        }, 800);
                    }
                });
            } else {
                subscribe.removeCssClass("icon-bell-inactive");
                subscribe.addCssClass("icon-bell-active");
                (0, $542851713e8a5d10$export$60959659b2c22881).subscribeTeam(teamData.id_gs, (result)=>{
                    if (!result) {
                        subscribe.removeCssClass("icon-bell-active");
                        subscribe.addCssClass("icon-bell-error");
                        setTimeout(()=>{
                            subscribe.removeCssClass("icon-bell-error");
                            subscribe.addCssClass("icon-bell-inactive");
                        }, 800);
                    }
                });
            }
        });
        this.menuItems.addControl(subscribe, true);
    }
    createMenuMatch(showBell, matchid) {
        this.lastCreatedMenu = "Match";
        this.deActivateSearch();
        this.menuItems.clear();
        if (!matchid) return;
        if (showBell) {
            var subscribe = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            subscribe.setStyle("width:32px;height:32px;");
            if ((0, $542851713e8a5d10$export$60959659b2c22881).hasMatchSubscription(matchid)) subscribe.addCssClass("icon-bell-active");
            else subscribe.addCssClass("icon-bell-inactive");
            subscribe.addCssClass("menu-icon icon-bell");
            subscribe.bind("click", (e)=>{
                if ((0, $542851713e8a5d10$export$60959659b2c22881).hasMatchSubscription(matchid)) {
                    subscribe.removeCssClass("icon-bell-active");
                    subscribe.addCssClass("icon-bell-inactive");
                    (0, $542851713e8a5d10$export$60959659b2c22881).unsubscribeMatch(matchid, (result)=>{
                        if (!result) {
                            subscribe.removeCssClass("icon-bell-inactive");
                            subscribe.addCssClass("icon-bell-error");
                            setTimeout(()=>{
                                subscribe.removeCssClass("icon-bell-error");
                                subscribe.addCssClass("icon-bell-active");
                            }, 800);
                        }
                    });
                } else {
                    subscribe.removeCssClass("icon-bell-inactive");
                    subscribe.addCssClass("icon-bell-active");
                    (0, $542851713e8a5d10$export$60959659b2c22881).subscribeMatch(matchid, (result)=>{
                        if (!result) {
                            subscribe.removeCssClass("icon-bell-active");
                            subscribe.addCssClass("icon-bell-error");
                            setTimeout(()=>{
                                subscribe.removeCssClass("icon-bell-error");
                                subscribe.addCssClass("icon-bell-inactive");
                            }, 800);
                        }
                    });
                }
            });
            this.menuItems.addControl(subscribe, true);
        }
        if (FootballManiaConfig.isAndroid) {
            var share = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            share.setStyle("width:32px;height:32px;");
            share.addCssClass("icon-share menu-icon");
            this.menuItems.addControl(share, true);
            share.bind("click", ()=>{
                this.pageControl.triggerEvent("requestShareAndroid");
            });
        }
    }
    createMenuCountryLeagues() {
        this.lastCreatedMenu = "CountryLeagues";
        this.menuItems.clear();
    }
    createMenuNews() {
        this.lastCreatedMenu = "News";
        this.menuItems.clear();
        var languageSelect = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        languageSelect.setStyle("width:32px;height:32px;");
        languageSelect.addCssClass("menu-icon icon-language");
        languageSelect.bind("click", (e)=>{
            var urlIdentifier = "languageselectmodal";
            var modal = new (0, $1e85e6e9406b695f$export$199856d717696aba)(urlIdentifier);
            this.getPage().addControl(modal, true);
        });
        this.menuItems.addControl(languageSelect, true);
    }
    activateSearch() {
        if (!AppInstance.isOnline()) {
            console.warn("Search is not available in offline mode");
            return;
        }
        this.searchActivated = true;
        this.pageControl.triggerEvent("searchActivated");
        var urlIdentifier = "search";
        if (!(0, $fRpWP.UrlManager).getModule(urlIdentifier)) {
            (0, $fRpWP.UrlManager).registerModule(urlIdentifier);
            (0, $fRpWP.UrlManager).setModule(urlIdentifier, "open");
        }
        (0, $fRpWP.UrlManager).listenModule(urlIdentifier, ()=>{
            if (!(0, $fRpWP.UrlManager).getModule(urlIdentifier)) {
                (0, $fRpWP.UrlManager).unlistenModule(urlIdentifier);
                (0, $fRpWP.UrlManager).removeModule(urlIdentifier);
                this.deActivateSearch();
            }
        });
        this.menuItems.setVisible(false);
        this.topLogoContainer.setVisible(false);
        this.search.setVisible(true);
        jQuery("#" + this.search.controls[1].clientId).focus();
        var that = this;
        var renderLeagueSearchResult = (data)=>{
            var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            resultP.addCssClass("topBarSearchResultItem");
            resultP.setStyle("justify-content: space-between;");
            var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            image.setStyle("width:40px;height:40px;");
            image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.countrygs.replaceAll(" ", "-").toLowerCase() + ".png");
            resultP.addControl(image);
            var name = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            if (FootballManiaConfig.isRtl) name.setStyle("margin-left:auto;");
            else name.setStyle("margin-right:auto;");
            if (data.subtype) name.addControl(data.name + " - " + data.subtype || "");
            else name.addControl(data.name);
            resultP.addControl(name);
            var favoriteToggle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            favoriteToggle.setStyle("width:35px;height:35px;margin-inline-end:28px;");
            if ((0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues()[data.keygs]) favoriteToggle.addCssClass("icon-favorite-on");
            else favoriteToggle.addCssClass("icon-favorite-off");
            resultP.addControl(favoriteToggle);
            favoriteToggle.bind("click", (e)=>{
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();
                if (!(0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues()[data.keygs]) {
                    console.log("add favorite league", data.name, data.keygs);
                    (0, $aabc673d1ba8b527$export$db78e401119da622).addFavoriteLeague(data.keygs, data.countrygs, data.name);
                    favoriteToggle.removeCssClass("icon-favorite-off");
                    favoriteToggle.addCssClass("icon-favorite-on");
                } else {
                    (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteLeague(data.keygs);
                    favoriteToggle.removeCssClass("icon-favorite-on");
                    favoriteToggle.addCssClass("icon-favorite-off");
                }
                console.log("onFavoriteChanged", this.getPage());
                this.getPage().pageControl.triggerEvent("onFavoriteChanged");
            });
            this.searchResults.addControl(resultP);
            resultP.bind("click", function() {
                var previousSearchClicks = localStorage.getItem("recentSearchClicks_v2");
                if (!previousSearchClicks) previousSearchClicks = [];
                else previousSearchClicks = JSON.parse(previousSearchClicks);
                var found = false;
                for(var i = 0; i < previousSearchClicks.length; i++)if (previousSearchClicks[i].type == "l" && previousSearchClicks[i].keygs == data.keygs) {
                    //remove
                    previousSearchClicks.splice(i, 1);
                    break;
                }
                previousSearchClicks.push(data);
                that.deActivateSearch();
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(data);
                setTimeout(()=>{
                    localStorage.setItem("recentSearchClicks_v2", JSON.stringify(previousSearchClicks));
                    (0, $kc8Kt.DataProvider).searchtrack({
                        id: data.id_gs,
                        leaguekey: data.keygs,
                        track_name: "league",
                        track_action: "search_action"
                    });
                }, 1000);
            });
        };
        var renderTeamResult = (data)=>{
            var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            resultP.addCssClass("topBarSearchResultItem");
            resultP.setStyle("justify-content: space-between;");
            var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            image.setStyle("width:40px;height:40px;");
            resultP.addControl(image);
            if (AppInstance.getConfig().enabledFeatures.teamImages) image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + data.id_gs + "_small_rnd.png");
            else image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/country/" + data.id_gs + "_small_rnd.png");
            var name = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            if (FootballManiaConfig.isRtl) name.setStyle("margin-left:auto;margin-inline-start:6px;");
            else name.setStyle("margin-right:auto;margin-inline-start:6px;");
            if (data.countrygs) name.addControl(data.name + " - " + data.countrygs);
            else name.addControl(data.name);
            resultP.addControl(name);
            var favoriteToggle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            favoriteToggle.setStyle("width:35px;height:35px;margin-inline-end:28px;");
            if ((0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[data.id_gs]) favoriteToggle.addCssClass("icon-favorite-on");
            else favoriteToggle.addCssClass("icon-favorite-off");
            resultP.addControl(favoriteToggle);
            favoriteToggle.bind("click", (e)=>{
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();
                if (!(0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[data.id_gs]) {
                    console.log("add favorite team", data.id_gs, data.name);
                    (0, $aabc673d1ba8b527$export$db78e401119da622).addFavoriteTeam(data.id_gs, data.name);
                    favoriteToggle.removeCssClass("icon-favorite-off");
                    favoriteToggle.addCssClass("icon-favorite-on");
                } else {
                    (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteTeam(data.id_gs);
                    favoriteToggle.removeCssClass("icon-favorite-on");
                    favoriteToggle.addCssClass("icon-favorite-off");
                }
                console.log("onFavoriteChanged", this.getPage());
                this.getPage().pageControl.triggerEvent("onFavoriteChanged");
            });
            this.searchResults.addControl(resultP);
            resultP.bind("click", function() {
                var previousSearchClicks = localStorage.getItem("recentSearchClicks_v2");
                if (!previousSearchClicks) previousSearchClicks = [];
                else previousSearchClicks = JSON.parse(previousSearchClicks);
                var found = false;
                for(var i = 0; i < previousSearchClicks.length; i++)if (previousSearchClicks[i].type == "t" && previousSearchClicks[i].id_gs == data.id_gs) {
                    previousSearchClicks.splice(i, 1);
                    break;
                }
                previousSearchClicks.push(data);
                that.deActivateSearch();
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(data.id_gs);
                setTimeout(function() {
                    localStorage.setItem("recentSearchClicks_v2", JSON.stringify(previousSearchClicks));
                    (0, $kc8Kt.DataProvider).searchtrack({
                        id: data.id_gs,
                        track_name: "team",
                        track_action: "search_action"
                    });
                }, 1000);
            });
        };
        var renderMatchResult = (data)=>{
            var itemRender = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)(null, 2);
            data.style = {
                "height": "40px"
            };
            itemRender.showAlwaysTime = true;
            itemRender.setData(data);
            var flag = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            flag.setStyle("margin-inline-start: 9px;margin-top: 14px;width:20px;height:20px;");
            flag.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.filegroup.toLowerCase().replaceAll(" ", "-") + ".png");
            itemRender.panel.addControlAt(flag, 0);
            this.searchResults.addControl(itemRender);
            itemRender.contentPanel.setStyle("margin-right:16px;");
            itemRender.bind("click", function() {
                that.deActivateSearch();
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showMatchScreen(null, data.data.id);
            });
        };
        var renderPlayerResult = (data)=>{
            var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            resultP.addCssClass("topBarSearchResultItem");
            if (AppInstance.getConfig().enabledFeatures.teamImages) {
                var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
                image.setStyle("width:40px;height:40px;");
                image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/playerimages/" + data.id_gs + "_small_rnd.png");
                resultP.addControl(image);
            }
            if (data.team_name) resultP.addControl(data.name + " - " + data.team_name);
            else resultP.addControl(data.name);
            this.searchResults.addControl(resultP);
            resultP.bind("click", function() {
                that.deActivateSearch();
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(data.id_gs);
                var previousSearchClicks = localStorage.getItem("recentSearchClicks_v2");
                if (!previousSearchClicks) previousSearchClicks = [];
                else previousSearchClicks = JSON.parse(previousSearchClicks);
                var found = false;
                for(var i = 0; i < previousSearchClicks.length; i++)if (previousSearchClicks[i].type == "p" && previousSearchClicks[i].id_gs == data.id_gs) {
                    found = true;
                    break;
                }
                if (!found) previousSearchClicks.push(data);
                setTimeout(function() {
                    localStorage.setItem("recentSearchClicks_v2", JSON.stringify(previousSearchClicks));
                    (0, $kc8Kt.DataProvider).searchtrack({
                        id: data.id_gs,
                        track_name: "player",
                        track_action: "search_action"
                    });
                }, 1000);
            });
        };
        var renderCoachResult = (data)=>{
            var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            resultP.addCssClass("topBarSearchResultItem");
            if (AppInstance.getConfig().enabledFeatures.teamImages) {
                var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
                image.setStyle("width:40px;height:40px;border: 1px solid #ffd7008f;border-radius: 24px;");
                image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/coachimages/" + data.id_gs + "_small_rnd.png");
                resultP.addControl(image);
            }
            if (data.team_name) resultP.addControl(data.name + " - " + data.team_name);
            else resultP.addControl(data.name);
            this.searchResults.addControl(resultP);
            resultP.bind("click", function() {
                that.deActivateSearch();
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showCoachScreen(data.id_gs);
                var previousSearchClicks = localStorage.getItem("recentSearchClicks_v2");
                if (!previousSearchClicks) previousSearchClicks = [];
                else previousSearchClicks = JSON.parse(previousSearchClicks);
                var found = false;
                for(var i = 0; i < previousSearchClicks.length; i++)if (previousSearchClicks[i].type == "p" && previousSearchClicks[i].id_gs == data.id_gs) {
                    found = true;
                    break;
                }
                if (!found) previousSearchClicks.push(data);
                setTimeout(function() {
                    localStorage.setItem("recentSearchClicks_v2", JSON.stringify(previousSearchClicks));
                    (0, $kc8Kt.DataProvider).searchtrack({
                        id: data.id_gs,
                        track_name: "coach",
                        track_action: "search_action"
                    });
                }, 1000);
            });
        };
        var handlePreviousResults = ()=>{
            //put previous search clicks in results when user clicks search
            localStorage.removeItem("recentSearchClicks");
            var previousSearchClicks = localStorage.getItem("recentSearchClicks_v2");
            if (previousSearchClicks) {
                previousSearchClicks = JSON.parse(previousSearchClicks);
                previousSearchClicks = previousSearchClicks.reverse();
                this.searchResults.clear();
                for(var i = 0; i < previousSearchClicks.length; i++){
                    if (i > 15) break;
                    var result = previousSearchClicks[i];
                    if (result.type == "t") renderTeamResult(result);
                    else if (result.type == "l") renderLeagueSearchResult(result);
                    else if (result.type == "p") renderPlayerResult(result);
                    else if (result.type == "c") renderCoachResult(result);
                }
                this.searchResults.invalidateDisplay();
            }
        };
        handlePreviousResults();
        this.search.controls[0].unbind("click");
        this.search.controls[0].bind("click", ()=>{
            history.back();
        //this.deActivateSearch();
        });
        this.search.controls[1].unbind("keydown");
        this.search.controls[1].bind("keydown", ()=>{
            clearTimeout(this.inputter);
            this.inputter = setTimeout(()=>{
                if (!jQuery("#" + this.search.controls[1].clientId).val()) {
                    this.searchResults.clear();
                    handlePreviousResults();
                    return;
                }
                (0, $kc8Kt.DataProvider).search(jQuery("#" + this.search.controls[1].clientId).val(), (response)=>{
                    this.searchResults.clear();
                    if (!response.isOk()) return;
                    var d = response.getData();
                    var processedTeams = 0;
                    var processedLeagues = 0;
                    var processedPlayers = 0;
                    var processedCoaches = 0;
                    var max = 40;
                    for(var i = 0; i < d.result.length; i++){
                        var result = d.result[i];
                        console.log("result", result);
                        if (result.type == "t") {
                            if (processedTeams >= max) continue;
                            processedTeams++;
                            renderTeamResult(result);
                            var past = [];
                            var future = [];
                            if (result.matches && result.matches.length) {
                                for(var j = result.matches.length - 1; j >= 0; j--)if ((0, $9yWe2.MatchUtil).isFinished(result.matches[j])) {
                                    if (past.length >= 2) continue;
                                    past.push(result.matches[j]);
                                }
                                for(var j = 0; j < result.matches.length; j++)if (!(0, $9yWe2.MatchUtil).isFinished(result.matches[j])) {
                                    if (future.length >= 3) continue;
                                    future.push(result.matches[j]);
                                }
                            }
                            if (future.length == 0) var matches = past;
                            else var matches = past.concat(future);
                            for(var k = 0; k < matches.length; k++)renderMatchResult(matches[k]);
                        } else if (result.type == "l") {
                            if (processedLeagues >= max) continue;
                            processedLeagues++;
                            renderLeagueSearchResult(result);
                            var past = [];
                            var future = [];
                            if (result.matches && result.matches.length) {
                                //reverse array
                                for(var j = result.matches.length - 1; j >= 0; j--)if ((0, $9yWe2.MatchUtil).isFinished(result.matches[j])) {
                                    if (past.length >= 0) continue;
                                    past.push(result.matches[j]);
                                }
                                for(var j = 0; j < result.matches.length; j++)if (!(0, $9yWe2.MatchUtil).isFinished(result.matches[j])) {
                                    if (future.length >= 8) continue;
                                    future.push(result.matches[j]);
                                }
                            }
                            if (future.length == 0) var matches = past;
                            else var matches = past.concat(future);
                            for(var k = 0; k < matches.length; k++)renderMatchResult(matches[k]);
                        } else if (result.type == "p") {
                            if (processedPlayers >= max) continue;
                            processedPlayers++;
                            console.log("render player");
                            renderPlayerResult(result);
                        } else if (result.type == "c") {
                            if (processedCoaches >= max) continue;
                            processedCoaches++;
                            console.log("render coach");
                            renderCoachResult(result);
                        }
                    }
                    this.searchResults.invalidateDisplay();
                });
            }, 200);
        });
    }
    deActivateSearch() {
        console.log("deactivate");
        if (this.searchActivated) this.pageControl.triggerEvent("searchDeactivated");
        var urlIdentifier = "search";
        (0, $fRpWP.UrlManager).unlistenModule(urlIdentifier);
        (0, $fRpWP.UrlManager).removeModule(urlIdentifier);
        (0, $fRpWP.UrlManager).updateUrl(true);
        this.menuItems.setVisible(true);
        this.topLogoContainer.setVisible(true);
        this.search.setVisible(false);
        jQuery("#" + this.search.controls[1].clientId).val("");
        this.search.controls[0].unbind("click");
        this.searchActivated = false;
    }
    showToast(message) {
        if (this.toast) this.toast.remove();
        clearTimeout(this.toasterTimeoutHandler);
        var toast = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        toast.addCssClass("snackbar");
        toast.addCssClass("snackbarshow");
        toast.addControl(message);
        this.addControl(toast, true);
        this.toast = toast;
        this.toasterTimeoutHandler = setTimeout(()=>{
            this.toast.remove();
        }, 4000);
    }
    showFakeLoader(version) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.addCssClass("loaderContainer");
        var loader = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        loader.addCssClass("loader");
        var text = new (0, $37cbb85645b0d818$export$b04be29aa201d4f5)();
        text.setData((0, $02mnx.Localizer).getString("update_version").replace("{}", version));
        //toast.addCssClass("snackbarshow");
        container.addControl(loader);
        container.addControl(text);
        this.addControl(container, true);
        clearTimeout(this.toasterTimeoutHandler);
        this.toasterTimeoutHandler = setTimeout(()=>{
            if (this.unloaded) return;
            container.remove();
        }, 1500);
    }
}










class $7c850b4330ee3fc0$export$c8dd51eb24f71762 extends (0, $cf8b45a51b0de626$export$18f8036a6dc5f3a5) {
    /**
	 * Creates a datagrid 
	 * A datagrid is a more advanced list control with functionality to have its own listrender. 
	 * A listrender is responsible for rendering the list and is completely independent from the datagrid itself.
	 * By default a datagrid is having a table list render .
	 * A different listrender can replace the current listrender if desired at anytime.
	 * Empty template can be assigned to a datagrid which is shown when there is no data inside the
	 * datagrid.
	 *  
	 Example:
	 
	var datagrid = new DataGrid();

	var columns = [
		          	new DataGridColumn().setHeaderText('name').setDataField('name'),
		          	new DataGridColumn().setHeaderText('description').setDataField('description')
		          ];
		          
	datagrid.getListRender().setColumns(colums);
	
	var datasource = [
	                 	{'name':'a name1','description':'a description1'},
	                 	{'name':'a name2','description':'a description2'},
	                 	{'name':'a name3','description':'a description3'}
	                 ];
	                 
	datagrid.setDataSource(datasource);   
	
	this.addControl(datagrid);
	 
	 * 
	 * @constructs
	 * @extends ListControl
	 */ init() {
        super.init();
        this.addCssClass('BDataGrid');
        this.datasource = [];
        this.listRender = null;
        this.listRenderCreated = false;
        this.createBasicControls();
    }
    /**
	 * Internaly used
	 * @ignore
	 */ createComponents() {
        this.triggerEvent('datagridReady');
    }
    /**
	 * @ignore
	 */ updateDisplay() {
        if (!this.listRenderCreated) this.createEmptyTemplate();
    }
    /**
	 * @param {mixed} datasource to fill the datagrid with
	 * @return {this}
	 */ setDataSource(datasource) {
        this.datasource = datasource;
        this.triggerEvent('onSetDataSource', datasource);
        return this;
    }
    /**
	 * setData method is equal to the setDataSource method. This method is used
	 * when datagrid is binded to data in a dataset.
	 * @param {mixed} data
	 * @return {this}
	 */ setData(data) {
        this.setDataSource(data);
        return this;
    }
    /**
	 * equal to getDataSource
	 * @return {mixed}
	 */ getData() {
        return this.datasource;
    }
    /**
	 * An empty template is shown when no datasource or empty datasource is inside the datagrid.
	 * @param {UiControl} c
	 * @return {this} 
	 */ setEmptyTemplate(c) {
        this.emptyTemplate = c;
        this.clearEmptyTemplate();
        this.createEmptyTemplate();
        return this;
    }
    /**
	 * Create building blocks which are needed to visualize our datagrid.
	 * From top to bottom we create a control panel holder, the list holder, info holder for the empty template
	 * and loader holder to show a loader.
	 * 
	 * @ignore
	 */ createBasicControls() {
        this.controlPanelHolder = new (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)();
        this.listHolder = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.infoHolder = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)().addCssClass('BDataGridInfoHolder');
        this.loaderHolder = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(this.loaderHolder);
        this.addControl(this.controlPanelHolder);
        this.addControl(this.listHolder);
        this.addControl(this.infoHolder);
    }
    /**
	 * Sets the list render responsible for rendering content.
	 * If changed during runtime we rerender the complete datagrid.
	 * 
	 * @param {DataGridBaseListRender} lr
	 * @return {this}
	 */ setListRender(lr) {
        this.clearListRender();
        this.listRender = lr;
        this.listRender.datagrid = this;
        //force rerender if datasource is available
        if (this.datasource && this.datasource.length) this.setDataSource(this.datasource);
        return this;
    }
    /**
	 * returns current active list render. If none is active we return a default table list render
	 * @return {DataGridBaseListRender} listRender
	 */ getListRender() {
        if (!this.listRender) this.listRender = new DataGridTableListRender();
        return this.listRender;
    }
    /**
	 * Clears the list render.
	 * @return {this} 
	 */ clearListRender() {
        this.listHolder.clear();
        return this;
    }
    /**
	 * Create the listRender
	 * @ignore
	 */ createListRender() {
        if (!this.listRender || !this.listRender.id) this.listRender = this.getListRender();
        //if list holder is not already added to its placeholder 
        if (this.listHolder.controls.indexOf(this.listRender) === -1) {
            this.listHolder.addControl(this.listRender);
            this.listRender.datagrid = this;
            this.listRenderCreated = true;
            //bind event. if source is 0 we create empty template, otherwise remove it
            this.listRender.bind('dataSourceChanged', this.getProxy(function(e, f) {
                this.datasource = this.listRender.datasource; //synchronize datasources
                ///if already cleared and datasource is bigger than zero
                if (this.emptyTemplateCleared && this.datasource.length) return;
                this.emptyTemplateCleared = false;
                if (this.datasource.length) {
                    this.clearEmptyTemplate();
                    this.emptyTemplateCleared = true;
                } else this.createEmptyTemplate();
            }));
        }
    }
    /**
	 * Invoked when datasource is set
	 * we start the creation of controls here
	 * @ignore
	 */ onSetDataSource() {
        if (!this.datasource) this.datasource = [];
        //datasource needs to be a indexed array
        if (!this.datasource.length) this.createEmptyTemplate();
        else this.infoHolder.setVisible(false);
        if (this.listRender) this.listRender.clear();
        this.createListRender();
        this.listRender.setDataSource(this.datasource);
        if (this.isRendered) this.listHolder.invalidateDisplay();
    }
    /**
	 * @abstract
	 * @ignore
	 */ showInitLoader() {}
    /**
	 * @abstract
	 * @ignore
	 */ renderList() {}
    /**
	 * @abstract
	 * @ignore
	 */ showLoader() {}
    /**
	 * creates an empty template. 
	 * 
	 * @ignore
	 */ createEmptyTemplate() {
        this.infoHolder.clear();
        if (this.emptyTemplate) this.infoHolder.addControl(this.emptyTemplate(), true).setVisible(true);
        else this.infoHolder.addControl('No data found', true).setVisible(true);
    }
    /**
	 * clears the empty template.
	 * @return {this}
	 */ clearEmptyTemplate() {
        this.infoHolder.clear();
        return this;
    }
}



var $fRpWP = parcelRequire("fRpWP");




var $02mnx = parcelRequire("02mnx");

var $dNeVp = parcelRequire("dNeVp");




var $gQQqD = parcelRequire("gQQqD");


const $f16aea2f3841680e$export$a9b191a1a9582fee = function() {
    this.activateForItem = (item)=>{
        item.stopClickPropogation = true;
        item.panel.addCssClass("dragHandlerContainer");
        var handle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        handle.addCssClass("dragHandlerHandleContainer");
        handle.setStyle("height:40px;width:100px;");
        var removeicon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        removeicon.setStyle("height:25px;width:25px;margin-inline-end:40px;");
        removeicon.addCssClass("icon-delete");
        handle.addControl(removeicon);
        var dragicon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        dragicon.setStyle("height:25px;width:25px;");
        dragicon.addCssClass("icon-draghandler");
        handle.addControl(dragicon);
        item.isLiveInfo.clear();
        item.isLiveInfo.addControl(removeicon, true);
        item.isLiveInfo.addControl(dragicon, true);
        var dropTargets = [];
        removeicon.bind("touchstart", (e)=>{
            console.log("touch start delete icon");
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            removeicon.bind("touchend", (e)=>{
                if (item.data.type == 5) {
                    item.panel.setCss({
                        "opacity": "0.5"
                    });
                    (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteLeague(item.data.key);
                    this.listrender.triggerEvent("requestDeActivateDrag");
                    this.listrender.triggerEvent("requestActivateDrag");
                    this.listrender.triggerEvent("requestReflowDrag");
                } else if (item.data.type == 4) {
                    item.panel.setCss({
                        "opacity": "0.5"
                    });
                    (0, $aabc673d1ba8b527$export$db78e401119da622).removeFavoriteTeam(item.data.id);
                    this.listrender.triggerEvent("requestDeActivateDrag");
                    this.listrender.triggerEvent("requestReflowDrag");
                } else console.error("deleting this item is not supported");
                item.stopClickPropogation = false;
            });
        });
        item.tempdh_touchStartMethod = (e)=>{
            this.wasDragging = false;
            clearTimeout(item.longPressHandler);
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            var targets = this.listrender.indexRenderedItemRenderMap[this.dragItem.data.type];
            dropTargets = [];
            for(var i = 0; i < targets.length; i++){
                if (targets[i].data == item.data) continue;
                dropTargets.push(targets[i].panel);
            }
            if (this.clonedDragged) {
                console.log("remove", this.clonedDragged);
                this.clonedDragged.remove();
            } else console.log("not remove");
            var dimensions = this.listrender.getDimensions();
            item.clonedDragged = $("#" + item.panel.getClientId()).clone();
            var y = e.originalEvent.touches[0].pageY;
            var x = e.originalEvent.touches[0].pageX;
            var startY = y;
            var startX = y;
            var windowHeight = $(window).height();
            var pos = y - dimensions.offset.top - 25;
            item.clonedDragged.css({
                "display": "none",
                "animation": "none",
                "position": "absolute",
                "z-index": 1000,
                "transform": "translateY(" + pos + "px)"
            });
            $("#" + item.parent.parent.getClientId()).append(item.clonedDragged);
            var startScroll = this.listrender.getScroll();
            var currentOffset = 0;
            var dragItemVisible = false;
            var foundDropTarget = null;
            item.tempdh_touchMoveMethod = (e)=>{
                var y = e.originalEvent.touches[0].pageY;
                if (!dragItemVisible && Math.abs(startY - y) > 8) {
                    dragItemVisible = true;
                    item.clonedDragged.css({
                        "display": "flex"
                    });
                    this.wasDragging = true;
                }
                // else if (!dragItemVisible && Math.abs(startX-x) > 8){
                //     console.log("dragging in x direction");
                //
                //
                //     return;
                // }
                this.listrender.triggerEvent("onDrag");
                var pos = y - dimensions.offset.top;
                const elements = document.elementsFromPoint(0, y);
                //droptargets are all possible items on which we can drop the dragged item
                //the elements are all elements at the current cursor position
                var stop = false;
                foundDropTarget = null;
                for(var j = 0; j < elements.length; j++){
                    if (stop) break;
                    if (elements[j].id == this.listrender.renderListContainers[0].getClientId()) continue;
                    for(var i = 0; i < dropTargets.length; i++)if (elements[j].id == dropTargets[i].getClientId()) {
                        foundDropTarget = dropTargets[i];
                        break;
                    }
                }
                for(var i = 0; i < dropTargets.length; i++)if (dropTargets[i] != foundDropTarget) dropTargets[i].removeCssClass("dropTarget");
                else foundDropTarget.addCssClass("dropTarget");
                item.clonedDragged.css({
                    "transform": "translateY(" + (pos - currentOffset - 25) + "px)"
                });
                if (y < 50) {
                    if (!this.scrollerRunning) this.scrollerRunning = setInterval(()=>{
                        if (this.listrender.getScroll() <= 0) return;
                        currentOffset += 20;
                        var scrollTarget = startScroll - currentOffset;
                        // currentOffset = Math.min(50,currentOffset);
                        //console.log("auto scrolling",currentOffset);
                        //currentScroll-=currentOffset;
                        this.listrender.scrollToSmooth(scrollTarget, 40);
                    }, 40);
                } else if (windowHeight - y < 50) {
                    if (!this.scrollerRunning) this.scrollerRunning = setInterval(()=>{
                        currentOffset -= 20;
                        var scrollTarget = startScroll - currentOffset;
                        // currentOffset = Math.min(50,currentOffset);
                        //console.log("auto scrolling",currentOffset);
                        //currentScroll-=currentOffset;
                        this.listrender.scrollToSmooth(scrollTarget, 40);
                    }, 40);
                } else if (this.scrollerRunning) {
                    clearInterval(this.scrollerRunning);
                    this.scrollerRunning = null;
                }
            };
            item.tempdh_touchEndMethod = (e)=>{
                clearInterval(this.scrollerRunning);
                item.panel.unbind("touchmove", item.tempdh_touchMoveMethod);
                item.panel.unbind("touchend", item.tempdh_touchEndMethod);
                if (foundDropTarget) {
                    console.log("swap item ", item, " with", foundDropTarget.parent.data);
                    this.listrender.triggerEvent("requestSwapItems", [
                        item.data,
                        foundDropTarget.parent.data
                    ]);
                    var tempData = foundDropTarget.parent.data;
                    foundDropTarget.parent.setData(item.data, false, true);
                    item.setData(tempData, false, true);
                    this.deactivateForItem(item);
                    this.deactivateForItem(foundDropTarget.parent);
                    this.activateForItem(item);
                    this.activateForItem(foundDropTarget.parent);
                    if (item.data.type == 5) {
                        console.log("swap league item", item, "foundDropTarget", foundDropTarget.parent);
                        (0, $aabc673d1ba8b527$export$db78e401119da622).swapFavoriteLeagues(item.data.key, foundDropTarget.parent.data.key);
                    } else if (item.data.type == 4) {
                        console.log("swap team item", item, "foundDropTarget", foundDropTarget.parent);
                        (0, $aabc673d1ba8b527$export$db78e401119da622).swapFavoriteTeams(item.data.id, foundDropTarget.parent.data.id);
                    } else console.error("swapping this item is not supported");
                //
                }
                for(var i = 0; i < dropTargets.length; i++)dropTargets[i].removeCssClass("dropTarget");
                if (item.clonedDragged) item.clonedDragged.remove();
                this.clonedDragged = null;
                if (!this.wasDragging) {
                    console.log("was not dragging. trigger event");
                    this.listrender.triggerEvent("requestDeActivateDrag");
                    return;
                }
                item.stopClickPropogation = false;
            };
            item.panel.bind("touchmove", item.tempdh_touchMoveMethod);
            item.panel.bind("touchend", item.tempdh_touchEndMethod);
        };
        item.panel.bind("touchstart", item.tempdh_touchStartMethod);
    };
    this.deactivateForItem = (item)=>{
        item.panel.unbind("touchstart", item.tempdh_touchStartMethod);
        item.panel.removeCssClass("dragHandlerContainer");
        item.isLiveInfo.clear();
    };
    this.setDragItem = (item)=>{
        console.log("set drag item", item);
        this.dragItem = item;
    };
    this.setListrender = (listrender)=>{
        console.log("set listrender", listrender);
        this.listrender = listrender;
    };
    this.activate = ()=>{
        console.log("activate");
        this.listrender.fastScrollContainerHandler.setVisible(false);
        var targets = this.listrender.indexRenderedItemRenderMap[this.dragItem.data.type];
        for(var i = 0; i < targets.length; i++)this.activateForItem(targets[i]);
        $('body').off({
            'touchstart': this.touchBodyStartMethod
        });
        //here we deactivate when the user touches outside the list
        this.touchBodyStartMethod = (e)=>{
            var y = e.originalEvent.touches[0].pageY;
            const elements = document.elementsFromPoint(0, y);
            var found = false;
            for(var j = 0; j < elements.length; j++){
                for(var i = 0; i < targets.length; i++)if (elements[j].id == targets[i].panel.getClientId()) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                this.listrender.triggerEvent("requestDeActivateDrag");
                return;
            }
        };
        $('body').on({
            'touchstart': this.touchBodyStartMethod
        });
    };
    this.deactivate = ()=>{
        this.listrender.fastScrollContainerHandler.setVisible(true);
        var targets = this.listrender.indexRenderedItemRenderMap[this.dragItem.data.type];
        for(var i = 0; i < targets.length; i++)this.deactivateForItem(targets[i]);
        $('body').off({
            'touchstart': this.touchBodyStartMethod
        });
    };
};


const $6d761ab6ba0922eb$export$e3622d1ca33003ac = function() {
    // Private state object
    const state = {
        version: "1.0",
        tabs: [],
        scrollerMethods: new Map(),
        touchStartMethod: null,
        touchEndMethod: null,
        collapser: null,
        tabview: null,
        ignoreEvents: false,
        ignoreEventForIndex: new Set(),
        lastListIndexScrolling: -1,
        unloaded: false,
        isTouching: false,
        reducerRatio: 0.3,
        transitionDuration: 100,
        alwaysCollapseOnBackScrolling: true,
        isCollapsed: false,
        lastRecalculateWasCollapsed: null,
        isVirtuallyCollapsed: false,
        lastScrollPositionAfterTouchStart: -1,
        lastYOffsetAfterTouchStart: 0,
        currentTranslateY: 0,
        currentActiveTab: -1,
        tempTimeout: null,
        collapserHeight: 0
    };
    // Public callback
    this.onCollapseChanged = null;
    // Add a scroller container (tab)
    this.addScrollerContainer = (tab)=>{
        if (tab) state.tabs.push(tab);
    };
    // Add collapser element
    this.addCollapser = (c)=>{
        state.collapser = c;
    };
    // Add tab view
    this.addTabView = (tab)=>{
        state.tabview = tab;
    };
    // Get cached collapser height
    this.getCollapserHeight = ()=>{
        if (!state.collapser) return 0;
        if (!state.collapserHeight) state.collapserHeight = state.collapser.getDimensions().height;
        return state.collapserHeight;
    };
    // Cleanup method
    this.unload = ()=>{
        if (state.unloaded) return;
        state.unloaded = true;
        if (state.collapser) state.collapser.setCss({
            transform: "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        state.tabs.forEach((tab)=>{
            const $scrollEl = jQuery(`#${tab.getClientId()}`);
            const handler = state.scrollerMethods.get(tab.getClientId());
            if (handler) $scrollEl.off("scroll", handler);
        });
        state.scrollerMethods.clear();
        jQuery("body").off({
            touchstart: state.touchStartMethod,
            touchend: state.touchEndMethod
        });
    };
    // Handle tab change
    this.tabChange = ()=>{
        var _FootballManiaConfig_graphics, _FootballManiaConfig;
        if (!((_FootballManiaConfig = FootballManiaConfig) === null || _FootballManiaConfig === void 0 ? void 0 : (_FootballManiaConfig_graphics = _FootballManiaConfig.graphics) === null || _FootballManiaConfig_graphics === void 0 ? void 0 : _FootballManiaConfig_graphics.animations) || !state.tabview) return;
        if (state.currentActiveTab === -1) state.currentActiveTab = state.tabview.currentActiveTab;
        const delay = 300;
        const collapserId = state.collapser.getClientId();
        const tabHolderId = state.tabview.tabHolder.getClientId();
        jQuery(`#${collapserId}, #${tabHolderId}`).css({
            transform: "translate(0px,0px)",
            "transition-duration": `${delay}ms`
        });
        state.currentTranslateY = 0;
        state.isVirtuallyCollapsed = false;
        state.isCollapsed = false;
        setTimeout(()=>this.recalculate(), delay);
        state.tabs.forEach((tab, i)=>{
            if (i === state.tabview.currentActiveTab) return;
            state.ignoreEvents = true;
            state.ignoreEventForIndex.add(i);
            setTimeout(()=>{
                var _tab_controls__controls, _tab_controls_, _tab_controls;
                const scrollElement = document.querySelector(`#${tab.getClientId()}`);
                const lazygrid = (_tab_controls = tab.controls) === null || _tab_controls === void 0 ? void 0 : (_tab_controls_ = _tab_controls[0]) === null || _tab_controls_ === void 0 ? void 0 : (_tab_controls__controls = _tab_controls_.controls) === null || _tab_controls__controls === void 0 ? void 0 : _tab_controls__controls[0];
                if (lazygrid === null || lazygrid === void 0 ? void 0 : lazygrid.scrollToLastSelectedOrTop) lazygrid.scrollToLastSelectedOrTop();
                else if (scrollElement) scrollElement.scrollTo({
                    top: 0,
                    left: 0
                });
                state.ignoreEvents = false;
                state.ignoreEventForIndex.delete(i);
            }, 0);
        });
        state.currentActiveTab = state.tabview.currentActiveTab;
    };
    // Recalculate a specific tab's layout
    this.recalculateTab = (index)=>{
        var _FootballManiaConfig_graphics, _FootballManiaConfig, _state_tabview_tabContents, _tab_controls__controls, _tab_controls_, _tab_controls;
        if (!((_FootballManiaConfig = FootballManiaConfig) === null || _FootballManiaConfig === void 0 ? void 0 : (_FootballManiaConfig_graphics = _FootballManiaConfig.graphics) === null || _FootballManiaConfig_graphics === void 0 ? void 0 : _FootballManiaConfig_graphics.animations) || !state.tabs[index] || !state.tabview) return;
        const tab = (_state_tabview_tabContents = state.tabview.tabContents) === null || _state_tabview_tabContents === void 0 ? void 0 : _state_tabview_tabContents.controls[index];
        if (!(tab === null || tab === void 0 ? void 0 : (_tab_controls = tab.controls) === null || _tab_controls === void 0 ? void 0 : (_tab_controls_ = _tab_controls[1]) === null || _tab_controls_ === void 0 ? void 0 : (_tab_controls__controls = _tab_controls_.controls) === null || _tab_controls__controls === void 0 ? void 0 : _tab_controls__controls[0])) return;
        const collapserHeight = this.getCollapserHeight();
        const $scrollEl = jQuery(`#${state.tabs[index].getClientId()}`);
        if (!$scrollEl.length) return;
        const extraMargin = this.scrollerBottomMargin || 0;
        const top = collapserHeight;
        jQuery(`#${tab.getClientId()}`).css({
            top: `-${top}px`,
            height: `calc(100% + ${top - extraMargin}px)`
        });
        jQuery(`#${tab.controls[1].controls[0].controls[0].getClientId()}`).css({
            position: "relative",
            top: `${top}px`,
            height: `calc(100% - ${top}px)`
        });
    };
    // Recalculate layout for all or specific tabs
    this.recalculate = (force = false, onlyTabIndex = null)=>{
        var _FootballManiaConfig_graphics, _FootballManiaConfig;
        if (!((_FootballManiaConfig = FootballManiaConfig) === null || _FootballManiaConfig === void 0 ? void 0 : (_FootballManiaConfig_graphics = _FootballManiaConfig.graphics) === null || _FootballManiaConfig_graphics === void 0 ? void 0 : _FootballManiaConfig_graphics.animations) || !state.tabview || !state.collapser) return;
        if (!force && state.lastRecalculateWasCollapsed !== null && state.isCollapsed === state.lastRecalculateWasCollapsed) return;
        const collapserHeight = this.getCollapserHeight();
        state.lastRecalculateWasCollapsed = state.isCollapsed;
        if (state.isCollapsed) {
            const transform = `translate(0px,${-collapserHeight}px)`;
            jQuery(`#${state.collapser.getClientId()}`).css({
                transform: transform,
                "transition-duration": "0ms"
            });
            jQuery(`#${state.tabview.tabHolder.getClientId()}`).css({
                transform: transform,
                "transition-duration": "0ms"
            });
        }
        const indices = onlyTabIndex !== null ? [
            onlyTabIndex
        ] : state.tabs.map((_, i)=>i);
        indices.forEach((i)=>this.recalculateTab(i));
    };
    // Auto-collapse or open based on scroll position
    this.autoCollapseOrOpen = (scrollPosition)=>{
        var _this_onCollapseChanged, _this;
        if (!state.collapser || !state.tabview) return;
        const collapserHeight = this.getCollapserHeight();
        const delay = 300;
        state.isCollapsed = state.currentTranslateY === -collapserHeight;
        state.isVirtuallyCollapsed = state.isCollapsed;
        if (state.currentTranslateY === 0 || state.currentTranslateY === -collapserHeight) {
            this.recalculate();
            return;
        }
        const threshold = collapserHeight * (1 / state.reducerRatio) / 2;
        const shouldCollapse = scrollPosition > threshold;
        const targetY = shouldCollapse ? -collapserHeight : 0;
        const transform = `translate(0px,${targetY}px)`;
        jQuery(`#${state.collapser.getClientId()}`).css({
            transform: transform,
            "transition-duration": `${delay}ms`
        });
        jQuery(`#${state.tabview.tabHolder.getClientId()}`).css({
            transform: transform,
            "transition-duration": `${delay}ms`
        });
        state.currentTranslateY = targetY;
        state.isCollapsed = shouldCollapse;
        state.isVirtuallyCollapsed = shouldCollapse;
        (_this_onCollapseChanged = (_this = this).onCollapseChanged) === null || _this_onCollapseChanged === void 0 ? void 0 : _this_onCollapseChanged.call(_this);
        clearTimeout(state.tempTimeout);
        state.tempTimeout = setTimeout(()=>this.recalculate(), delay);
    };
    // Prepare initial state
    this.prepare = ()=>{
        var _FootballManiaConfig_graphics, _FootballManiaConfig;
        if (!((_FootballManiaConfig = FootballManiaConfig) === null || _FootballManiaConfig === void 0 ? void 0 : (_FootballManiaConfig_graphics = _FootballManiaConfig.graphics) === null || _FootballManiaConfig_graphics === void 0 ? void 0 : _FootballManiaConfig_graphics.animations) || !state.collapser || !state.tabview) return;
        const collapserHeight = this.getCollapserHeight();
        if (state.isCollapsed) {
            state.isVirtuallyCollapsed = true;
            const transform = `translate(0px,${-collapserHeight}px)`;
            jQuery(`#${state.collapser.getClientId()}`).css({
                transform: transform,
                "transition-duration": "0ms"
            });
            jQuery(`#${state.tabview.tabHolder.getClientId()}`).css({
                transform: transform,
                "transition-duration": "0ms"
            });
        }
    };
    // Setup scroll and touch listeners
    this.run = ()=>{
        var _FootballManiaConfig_graphics, _FootballManiaConfig;
        if (!((_FootballManiaConfig = FootballManiaConfig) === null || _FootballManiaConfig === void 0 ? void 0 : (_FootballManiaConfig_graphics = _FootballManiaConfig.graphics) === null || _FootballManiaConfig_graphics === void 0 ? void 0 : _FootballManiaConfig_graphics.animations) || !state.tabview || !state.tabs.length) return;
        state.lastListIndexScrolling = state.tabview.currentActiveTab;
        this.recalculate();
        state.touchStartMethod = ()=>{
            var _state_tabs_state_tabview_currentActiveTab;
            state.isTouching = true;
            const tabId = (_state_tabs_state_tabview_currentActiveTab = state.tabs[state.tabview.currentActiveTab]) === null || _state_tabs_state_tabview_currentActiveTab === void 0 ? void 0 : _state_tabs_state_tabview_currentActiveTab.getClientId();
            const scrollElement = document.querySelector(`#${tabId}`);
            if (scrollElement) {
                state.lastScrollPositionAfterTouchStart = scrollElement.scrollTop;
                state.lastYOffsetAfterTouchStart = state.currentTranslateY;
            }
        };
        state.touchEndMethod = ()=>{
            state.isTouching = false;
        };
        jQuery("body").on({
            touchstart: state.touchStartMethod,
            touchend: state.touchEndMethod
        });
        state.tabs.forEach((tab, index)=>{
            const $scrollEl = jQuery(`#${tab.getClientId()}`);
            let prevScroll = null;
            let ticking = false;
            const scrollHandler = (e)=>{
                if (ticking || state.ignoreEvents || index !== state.tabview.currentActiveTab) return;
                if (state.ignoreEventForIndex.has(index)) {
                    state.ignoreEventForIndex.delete(index);
                    return;
                }
                window.requestAnimationFrame(()=>{
                    ticking = true;
                    const topOffset = e.originalEvent.target.scrollTop;
                    if (prevScroll === topOffset) {
                        ticking = false;
                        return;
                    }
                    state.lastListIndexScrolling = index;
                    clearTimeout(state.tempTimeout);
                    if (!state.isTouching) state.tempTimeout = setTimeout(()=>{
                        state.lastScrollPositionAfterTouchStart = -1;
                        this.autoCollapseOrOpen(topOffset);
                    }, 250);
                    const collapserHeight = this.getCollapserHeight();
                    let scrollDiff;
                    if (!state.alwaysCollapseOnBackScrolling || state.lastScrollPositionAfterTouchStart === -1) scrollDiff = Math.max(-topOffset, -collapserHeight);
                    else if (state.isCollapsed && state.isVirtuallyCollapsed) {
                        const t = (state.lastScrollPositionAfterTouchStart - topOffset) * state.reducerRatio - collapserHeight;
                        scrollDiff = Math.max(-collapserHeight, Math.min(0, t));
                    } else {
                        const t = (state.lastScrollPositionAfterTouchStart - topOffset) * state.reducerRatio + state.lastYOffsetAfterTouchStart;
                        scrollDiff = Math.min(0, Math.max(-collapserHeight, t));
                    }
                    state.currentTranslateY = scrollDiff;
                    state.isVirtuallyCollapsed = scrollDiff === -collapserHeight;
                    const transform = `translate(0px,${scrollDiff}px)`;
                    state.collapser.setCss({
                        transform: transform,
                        "transition-duration": `${state.transitionDuration}ms`
                    });
                    state.tabview.tabHolder.setCss({
                        transform: transform,
                        "transition-duration": `${state.transitionDuration}ms`
                    });
                    prevScroll = topOffset;
                    ticking = false;
                });
            };
            state.scrollerMethods.set(tab.getClientId(), scrollHandler);
            $scrollEl.off("scroll").on("scroll", scrollHandler);
        });
    };
    // Handle window resize
    this.onWindowResize = ()=>this.recalculate(true);
};



var $kc8Kt = parcelRequire("kc8Kt");


class $624900cc2abfdfb6$export$304e526a606cf55c extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
        this.addCssClass("bouncePanel");
        this.bounceEnabled = true;
        this.cachedElements = [];
        this.calculatedScrollbarItemHeight = 0;
        this.scrollbarHeightCalculated = false;
        this.cachedScreenHeight = 0;
        this.cachedScrollHeight = 0;
        this.cachedScrollContainerElement = null;
        this.scrollBarAnimationHandle = null;
        this.scrollBarSetToVisible = false;
        this.scrollerBarContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.scrollerBarContainer.addCssClass("listViewScrollerBarContainer");
        //this.scrollerBarContainer.setVisible(false);
        this.scrollerBarItem = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.scrollerBarItem.addCssClass("listViewScrollerBarItem");
        this.scrollerBarContainer.addControl(this.scrollerBarItem);
        this.indicatorContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.indicatorContainer.addCssClass("listViewScrollerIndicatorContainer");
        this.addControl(this.indicatorContainer);
        this.indicatorContainer.addControl(this.scrollerBarContainer);
        this.cachedElements = [];
    }
    enableBounce() {
        this.bounceEnabled = true;
    }
    disableBounce() {
        this.bounceEnabled = false;
    }
    unload() {
        var scrollEl = jQuery("#" + this.getClientId());
        scrollEl.off("scroll", this.scrollMethod); //what if others listen to this event
        this.cachedScrollContainerElement = null;
        this.cachedElements = null;
    }
    recalculate() {
        this.cachedScrollContainerElement = null;
        this.cachedScreenHeight = null;
        this.cachedScrollHeight = null;
        this.calculatedScrollbarItemHeight = false;
        this.cachedElements = [];
    }
    updateScrollbar(scrollTop, dontshowAnimation) {
        //console.log("update scrollbar", scrollTop, this.scrollbarHeightCalculated, this.cachedScreenHeight, this.cachedScrollHeight, this.calculatedScrollbarItemHeight, this.scrollBarSetToVisible,dontshowAnimation,this.scrollingTicks);
        if (!this.getContentScrollContainer()) {
            console.error("no scrollbar container");
            return;
        }
        //        console.log("update scrollbar");
        if (!this.cachedScrollContainerElement) this.cachedScrollContainerElement = document.querySelector("#" + this.getContentScrollContainer().getClientId());
        if (!this.cachedElements[this.getClientId()]) this.cachedElements[this.getClientId()] = document.querySelector("#" + this.getClientId());
        if (!this.cachedElements[this.scrollerBarItem.getClientId()]) this.cachedElements[this.scrollerBarItem.getClientId()] = document.querySelector("#" + this.scrollerBarItem.getClientId());
        this.cachedScreenHeight = this.cachedElements[this.getClientId()].offsetHeight;
        this.cachedScrollHeight = this.cachedScrollContainerElement.scrollHeight;
        this.calculatedScrollbarItemHeight = Math.max(0.05, Math.min(1, this.cachedScreenHeight / this.cachedScrollHeight));
        var scrollRatio = scrollTop / (this.cachedScrollHeight - this.cachedScreenHeight);
        var topOffset = this.cachedScreenHeight * (scrollTop / (this.cachedScrollHeight - this.cachedScreenHeight)) - scrollRatio * (this.calculatedScrollbarItemHeight * this.cachedScreenHeight);
        if (scrollRatio == 0) return;
        ///console.log("scroll ratio", scrollRatio, topOffset, this.calculatedScrollbarItemHeight, this.cachedScreenHeight, this.cachedScrollHeight, scrollTop, this.cachedScrollContainerElement.scrollHeight, this.cachedScreenHeight, this.cachedScrollHeight, this.calculatedScrollbarItemHeight, this.scrollBarSetToVisible, this.scrollbarHeightCalculated, this.cachedElements[this.scrollerBarItem.getClientId()]);
        this.cachedElements[this.scrollerBarItem.getClientId()].style.height = this.calculatedScrollbarItemHeight * 100 + "%";
        this.cachedElements[this.scrollerBarItem.getClientId()].style.transitionDuration = "20ms";
        this.cachedElements[this.scrollerBarItem.getClientId()].style.transform = "translate3d(0px, " + topOffset + "px, 0px)";
        this.scrollbarHeightCalculated = true;
        //jQuery("#"+this.scrollerBarItem.getClientId()).css({"transform": "translateY("+topOffset+"px)"});
        ////jQuery("#"+this.scrollerBarItem.getClientId()).css({"transition-duration":"130ms","transform": "translate3d(0px, "+topOffset+"px, 0px)"})
        //
        clearTimeout(this.scrollBarAnimationHandle);
        if (dontshowAnimation || this.scrollingTicks < 2) return;
        //this.scrollBarSetToVisible = false;
        if (!this.scrollBarSetToVisible) {
            this.scrollerBarContainer.setVisible(true);
            this.scrollerBarContainer.removeCssClass("scrollbaranimateout");
            this.scrollerBarContainer.addCssClass("scrollbaranimatein");
            this.scrollBarSetToVisible = true;
        }
        this.scrollBarAnimationHandle = setTimeout(()=>{
            this.scrollerBarContainer.removeCssClass("scrollbaranimatein");
            this.scrollerBarContainer.addCssClass("scrollbaranimateout");
            this.scrollBarSetToVisible = false;
        }, 100);
    }
    repositionScrollbar() {
        this.scrollingTicks = 0;
        console.log("reposition scrollbar");
        //this.scrollerBarContainer.setCss({"margin-left":this.getDimensions().width-(this.scrollerBarContainer.getDimensions().width)+"px"});
        this.scrollbarHeightCalculated = false;
        this.updateScrollbar(0, true);
    }
    getContentScrollContainer() {
        //console.log("get original content scroll container ",this.controls[1])
        return this.scrollElement || this.controls[1]; //hack assumption. for now ok
    }
    updateDisplay() {
        if (!this.getContentScrollContainer()) {
            console.error("no scroll container found for bouncepanel");
            return;
        }
        var scrollEl = jQuery("#" + this.getContentScrollContainer().getClientId());
        var lastPos, newPos, timer, timer2, delta, delay = 30;
        var that = this;
        var height = this.getDimensions().height;
        //console.log("xxxxxxxxx",document.getElementById(this.getContentScrollContainer().getClientId()).scrollHeight);
        this.repositionScrollbar();
        if (this.scrollMethod) scrollEl.off("scroll", this.scrollMethod);
        this.scrollerBarContainer.setVisible(false);
        this.scrollBarSetToVisible = false;
        this.scrollingTicks = 0;
        var ticking = false;
        var isBouncing = false;
        this.scrollMethod = ()=>{
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(()=>{
                    newPos = scrollEl.scrollTop();
                    that.updateScrollbar(newPos);
                    clearTimeout(timer2);
                    timer2 = setTimeout(()=>{
                        this.scrollingTicks = 0;
                    }, 1000);
                    this.scrollingTicks++;
                    if (!that.bounceEnabled) {
                        ticking = false;
                        console.log('disabled');
                        return;
                    }
                    if (lastPos != null) delta = newPos - lastPos;
                    //console.log(height,delta,newPos,document.getElementById(this.getContentScrollContainer().getClientId()).scrollHeight);
                    lastPos = newPos;
                    clearTimeout(timer);
                    //console.log("-->scroll->>",scrollEl.scrollTop(),delta)
                    if (!isBouncing) timer = setTimeout(function() {
                        if (newPos == 0 && Math.abs(delta) > 1) {
                            isBouncing = true;
                            $("#" + that.getClientId()).addClass("bouncePanelAnimation").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                                isBouncing = false;
                                $("#" + that.getClientId()).removeClass("bouncePanelAnimation");
                            });
                            lastPos = null;
                            delta = 0;
                        } else if (Math.abs(delta) > 1 && newPos + height >= document.getElementById(that.getContentScrollContainer().getClientId()).scrollHeight) console.log("the end of scrolling");
                    }, delay);
                    ticking = false;
                });
            }
        };
        scrollEl.scroll(this.scrollMethod);
    }
}








var $fRpWP = parcelRequire("fRpWP");
class $28c0cceb076dcf38$var$TabViewTitleHolder extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        this.tabTitles = [];
        this.currentActiveTab = -1;
        super.init();
        this.addCssClass("tabholder");
        this.tagName = "nav";
        var tabIndicator = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabIndicator.addCssClass("tabviewindicator");
        this.addControl(tabIndicator);
        this.tabIndicator = tabIndicator;
    }
    recalculateSizes(tabw) {
        for(var i = 0; i < this.controls.length; i++){
            if (this.controls[i] instanceof (0, $5983bd27facb3353$export$ff49c445471d74bb)) {
                if (this.controls[i].hasCssClass("tabholder-title-container")) this.controls[i].setCss({
                    'width': tabw + "px"
                });
            }
        }
    }
    renderTabs(tabs) {
        var w = this.getDimensions().width;
        var c = tabs.length;
        var tabw = Math.floor(w / c);
        if (c == 1) this.tabIndicator.setCss({
            'width': tabw / 2 - 20 + "px",
            "margin-left": tabw / 4 + 10 + "px"
        });
        else this.tabIndicator.setCss({
            'width': tabw - 20 + "px",
            "margin-left": "10px"
        });
        for(var i = 0; i < tabs.length; i++){
            var tabTitleContainer = new (0, $113d0a9711381252$export$353f5b6fc5456de1)();
            tabTitleContainer.setAttribute("tabindex", "-1");
            tabTitleContainer.addCssClass("tabholder-title-container");
            tabTitleContainer.setStyle("width:" + tabw + "px");
            this.addControl(tabTitleContainer);
            var tabTitleContainerBg = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            tabTitleContainerBg.addCssClass("tabholder-title-container-bg");
            tabTitleContainer.addControl(tabTitleContainerBg);
            var tabTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            //tabTitle.addControl(tabs[i].title);
            if (tabs[i].iconClass) {
                var tabLogo = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                tabLogo.setStyle("width: 28px;height:28px;");
                tabLogo.addCssClass(tabs[i].iconClass);
                tabTitle.addControl(tabLogo);
            } else tabTitle.addControl(tabs[i].title);
            tabTitle.addCssClass("tabholder-title");
            tabTitleContainer.addControl(tabTitle);
            this.tabTitles.push(tabTitle);
            var that = this;
            var startClickTime = 0;
            (function(index, tabTitleContainer, tabTitleContainerBg) {
                tabTitleContainer.bind("touchstart", function() {
                    tabTitleContainerBg.addCssClass("tabholder-title-container-bg-touch");
                    tabTitleContainerBg.addCssClass("tabholder-title-container-bg-touch2");
                    startClickTime = new Date().getTime();
                //console.log("tap")
                });
                tabTitleContainer.bind("touchend", function(e) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    if (new Date().getTime() - startClickTime > 300) tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch2");
                    else setTimeout(function() {
                        tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch2");
                    }, 300);
                    if (new Date().getTime() - startClickTime > 100) tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch");
                    else setTimeout(function() {
                        tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch");
                    }, 100);
                    console.log("tap end");
                    that.tabClicked(index, 150);
                });
                tabTitleContainer.bind("click", function() {
                    console.log('click');
                    that.tabClicked(index, 150);
                });
            })(i, tabTitleContainer, tabTitleContainerBg);
        }
    }
    tabClicked(index, speed) {
        this.triggerEvent("onTabClicked", {
            index: index,
            speed: speed
        });
    }
}
class $28c0cceb076dcf38$export$44c45b2b7f09d2a6 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
        this.currentActiveTab = 0;
        this.enableScrolling = true;
        this.cachedElements = [];
        this.cachedParllaxBgXOffset = 0;
        this.windowResizeHandler = null;
        this.scrollIndexes = {};
        this.tabsRendered = false;
        this.cachedParllaxBgXOffset = null;
        this.addCssClass("tabview");
        var tabHolder = new $28c0cceb076dcf38$var$TabViewTitleHolder();
        this.addControl(tabHolder);
        var tabHolderBg = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabHolder.addControl(tabHolderBg);
        tabHolderBg.addCssClass("tabholder-bg");
        var tabContents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabContents.tagName = "main";
        tabContents.addCssClass("tabContents");
        this.addControl(tabContents);
        this.tabHolder = tabHolder;
        this.tabContents = tabContents;
    }
    unload() {
        this.cachedElements = null;
        this.tabs = null;
        this.cachedParllaxBgXOffset = null;
    }
    onWindowResize() {
        var delay = 20;
        if (!this.windowResizeHandler) delay = 0;
        //clearTimeout(this.windowResizeHandler);
        //this.windowResizeHandler = setTimeout(this.getProxy(function(){
        this.recalculateSizes();
    //}),delay)
    }
    createComponents() {}
    getFocusControlType() {
        return 2; /// "left right type";
    }
    focusNext(forceReset, isTabKey, isLeftRight, isUpDown) {
        console.log("focusNext", isTabKey, isLeftRight, isUpDown, this.currentActiveTab);
        if (isUpDown) return false;
        if (this.selectedFocusIndex == undefined) this.selectedFocusIndex = this.currentActiveTab;
        else this.selectedFocusIndex++;
        console.log("focusDefault", this.currentActiveTab);
        console.log(this.tabHolder);
        if (!this.tabHolder.tabTitles[this.selectedFocusIndex]) {
            console.log("nothing to focus next");
            this.selectedFocusIndex--;
            return false;
        }
        var button = this.tabHolder.tabTitles[this.selectedFocusIndex].parent;
        button.setAttribute("tabindex", "0");
        $("#" + button.getClientId()).focus();
        return true;
    }
    focusPrevious(forceReset, isTabKey, isLeftRight, isUpDown) {
        console.log("focusprevious", isTabKey, isLeftRight, isUpDown, this.currentActiveTab, forceReset);
        if (!forceReset) {
            if (isUpDown) return false;
            if (this.selectedFocusIndex == undefined) this.selectedFocusIndex = this.currentActiveTab;
            else this.selectedFocusIndex--;
            console.log("focusDefault", this.currentActiveTab);
            console.log(this.tabHolder);
            if (!this.tabHolder.tabTitles[this.selectedFocusIndex]) {
                console.log("nothing to focus previous");
                this.selectedFocusIndex++;
                return false;
            }
        } else this.selectedFocusIndex = 0;
        var button = this.tabHolder.tabTitles[this.selectedFocusIndex].parent;
        button.setAttribute("tabindex", "0");
        $("#" + button.getClientId()).focus();
        return true;
    }
    defocus() {
        if (this.selectedFocusIndex == undefined) return;
        console.log("defocus", this.selectedFocusIndex);
        var button = this.tabHolder.tabTitles[this.selectedFocusIndex].parent;
        $("#" + button.getClientId()).blur();
        button.setAttribute("tabindex", "-1");
        this.selectedFocusIndex = undefined;
    }
    setTabs(tabs) {
        this.tabs = tabs;
        for(var i = 0; i < tabs.length; i++)tabs[i].tabIndex = i;
    }
    addTab(index, tab) {
        this.tabs.splice(index, 0, tab);
        var w = this.getDimensions().width;
        var c = this.tabs.length;
        tab.tabIndex = index;
        var tabw = Math.floor(w / c);
        var i = index;
        var previousSelected = this.currentActiveTab;
        var tabTitleContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabTitleContainer.addCssClass("tabholder-title-container");
        tabTitleContainer.setStyle("width:" + tabw + "px");
        var tabTitleContainerBg = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabTitleContainerBg.addCssClass("tabholder-title-container-bg");
        tabTitleContainer.addControl(tabTitleContainerBg);
        var tabTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabTitle.addControl(this.tabs[i].title);
        tabTitle.addCssClass("tabholder-title");
        tabTitleContainer.addControl(tabTitle);
        var that = this;
        var startClickTime = 0;
        tabTitleContainer.bind("touchstart", function() {
            tabTitleContainerBg.addCssClass("tabholder-title-container-bg-touch");
            tabTitleContainerBg.addCssClass("tabholder-title-container-bg-touch2");
            startClickTime = new Date().getTime();
        //console.log("tap")
        });
        tabTitleContainer.bind("touchend", function() {
            if (new Date().getTime() - startClickTime > 300) tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch2");
            else setTimeout(function() {
                tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch2");
            }, 300);
            if (new Date().getTime() - startClickTime > 100) tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch");
            else setTimeout(function() {
                tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch");
            }, 100);
            //console.log("tap end");
            that.moveToTab(index, 150);
        });
        tabTitleContainer.bind("click", function() {
            that.moveToTab(index, 150);
        });
        var tabw = Math.floor(w / this.tabs.length);
        //this.tabHolder.addControlAt(tabTitleContainer,index+1,true);//hack
        this.tabHolder.addControlAt(tabTitleContainer, index + 2, true); //hack
        this.tabTitles.splice(index, 0, tabTitle);
        for(var i = 0; i < this.tabHolder.controls.length; i++){
            if (this.tabHolder.controls[i] instanceof (0, $5983bd27facb3353$export$ff49c445471d74bb)) {
                if (this.tabHolder.controls[i].hasCssClass("tabholder-title-container")) this.tabHolder.controls[i].setCss({
                    'width': tabw + "px"
                });
            }
        }
        var p = new (0, $624900cc2abfdfb6$export$304e526a606cf55c)();
        p.enableFastScroll = this.enableFastScroll;
        p.addCssClass("tab-content-item");
        p.setStyle("width:0px;height:100%;left:0px;");
        p.addControl(this.tabs[index]);
        this.tabContents.addControlAt(p, index, true);
        this.recalculateSizes();
        if (previousSelected >= index) this.moveToTab(index + 1, 0);
        this.triggerEvent("tabAdded");
    }
    renderTabs() {
        if (this.parallaxBg) {
            if (this.tabs.length > 1) this.parallaxBg.setCss({
                'width': '120%'
            });
            else this.parallaxBg.setCss({
                'width': '100%'
            });
        }
        this.tabHolder.renderTabs(this.tabs);
        this.tabHolder.bind("onTabClicked", (e, data)=>{
            this.moveToTab(data.index, data.speed);
        });
        this.tabHolder.invalidateDisplay();
        //
        var windowHeight = jQuery(window).height();
        var top = $("#" + this.tabHolder.getClientId()).height();
        var height = windowHeight - top - $("#" + this.tabHolder.getClientId()).offset().top;
        this.tabContents.setCss({
            'height': height + "px"
        });
        //calculate width and create tabs
        var w = this.getDimensions().width;
        //add the conent items
        var left = 0;
        for(var i = 0; i < this.tabs.length; i++){
            var p = new (0, $624900cc2abfdfb6$export$304e526a606cf55c)();
            p.enableFastScroll = this.enableFastScroll;
            p.addCssClass("tab-content-item");
            p.setStyle("width:" + w + "px;height:100%;left:" + left + "px;");
            this.tabContents.addControl(p);
            p.addControl(this.tabs[i]);
            left += w;
        }
        this.tabContents.invalidateDisplay();
        this.registerSwipe();
        this.scrollIndexes = {};
        this.triggerEvent("onReady");
        if ((0, $fRpWP.UrlManager).getModule("tabindex")) this.moveToTab((0, $fRpWP.UrlManager).getModule("tabindex"), 0);
        else this.moveToTab(this.currentActiveTab, 0, true);
    }
    recalculateSizes() {
        var left = 0;
        var w = this.getDimensions().width;
        var tabw = Math.floor(w / this.tabs.length);
        var windowHeight = jQuery(window).height();
        var top = $("#" + this.tabHolder.getClientId()).height();
        //we set the hight of the content here. we take the tabholder top and offsettop (when in collapsed mode)
        var height = windowHeight - top - $("#" + this.tabHolder.getClientId())[0].offsetTop;
        //var height = windowHeight - top;// - $("#"+this.tabHolder.getClientId()).offset().top;
        //console.log("recalulalte tab size height",height," window height",windowHeight," tab holder top",$("#"+this.tabHolder.getClientId()).offset(),$("#"+this.tabHolder.getClientId())[0].offsetTop);
        for(var i = 0; i < this.tabContents.controls.length; i++){
            this.tabContents.controls[i].recalculate();
            this.tabContents.controls[i].setCss({
                "width": w + "px",
                "left": left + "px"
            });
            //this.tabContents.controls[i].setCss({"width":w+"px","height":"100%","left":left+"px"});
            //this.tabContents.controls[i].setCss({"width":w+"px","left":left+"px","height":height+"px"});
            this.tabContents.controls[i].repositionScrollbar();
            left += w;
        }
        this.tabHolder.recalculateSizes(tabw);
        var speed = 0;
        var index = this.currentActiveTab;
        var w = this.getDimensions().width;
        var offset = index * w;
        var bg = w * index / (w * this.tabs.length);
        var indicatorOffset = w / this.tabs.length * index;
        $("#" + this.tabContents.getClientId()).css({
            "transform": "translate(" + -offset + "px)",
            "transition-duration": speed + "ms"
        });
        $("#" + this.tabHolder.tabIndicator.getClientId()).css({
            "transform": "translate(" + indicatorOffset + "px)",
            "transition-duration": speed + "ms"
        });
        if (this.parallaxBg) {
            this.cachedParllaxBgXOffset = -bg * 10;
            if (this.tabs.length > 1) {
                if (FootballManiaConfig.isRtl) this.parallaxBg.setCss({
                    "margin-right": "-20%",
                    "transform": "translateY(-50px) translateX(" + this.cachedParllaxBgXOffset + "%)",
                    "transition-duration": speed + "ms"
                });
                else this.parallaxBg.setCss({
                    "transform": "translateY(-50px) translateX(" + this.cachedParllaxBgXOffset + "%)",
                    "transition-duration": speed + "ms"
                });
            }
        }
        if (this.tabs.length == 1) this.tabHolder.tabIndicator.setCss({
            'width': tabw / 2 - 20 + "px",
            "margin-left": tabw / 4 + 10 + "px"
        });
        else this.tabHolder.tabIndicator.setCss({
            'width': tabw - 20 + "px",
            "margin-left": "10px"
        });
        //this.tabHolder.tabIndicator.setCss({'width':tabw-20+"px","margin-left":"4px"});
        //calculate tab contents height
        this.tabContents.setCss({
            'height': height + "px"
        });
        console.log("set height tab content ", height);
    }
    updateDisplay() {
        if (!this.tabsRendered) {
            this.renderTabs();
            this.tabsRendered = true;
            this.triggerEvent("tabsReady");
        }
    }
    enableSwipe() {
        this.swipeDisabled = false;
    }
    disableSwipe() {
        this.swipeDisabled = true;
    }
    moveToTab(index, speed, force) {
        if (speed == null) speed = 240;
        console.log("move to tab ", index, speed, this.currentActiveTab);
        if (!force && this.currentActiveTab == index) {
            console.warn("cannot move to tab ", index, "already selected");
            return;
        }
        var trigger = false;
        if (this.currentActiveTab != index) trigger = true;
        if (!this.tabs[this.currentActiveTab]) {
            console.error("cannot move to tab ", this.currentActiveTab, "tab does not exist");
            return;
        }
        //console.log("move to tab ",index,speed,this.currentActiveTab);
        //if (this.currentActiveTab == index) return;
        this.tabs[this.currentActiveTab].removeCssClass("active");
        this.tabHolder.tabTitles[this.currentActiveTab].removeCssClass("active");
        this.currentActiveTab = index;
        this.tabs[this.currentActiveTab].addCssClass("active");
        this.tabHolder.tabTitles[this.currentActiveTab].addCssClass("active");
        var w = this.getDimensions().width;
        var offset = index * w;
        var bg = w * index / (w * this.tabs.length);
        var indicatorOffset = w / this.tabs.length * index;
        $("#" + this.tabContents.getClientId()).css({
            "transform": "translate(" + -offset + "px)",
            "transition-duration": speed + "ms"
        });
        $("#" + this.tabHolder.tabIndicator.getClientId()).css({
            "transform": "translate(" + indicatorOffset + "px)",
            "transition-duration": speed + "ms"
        });
        if (this.parallaxBg) {
            this.cachedParllaxBgXOffset = -bg * 10;
            if (this.tabs.length > 1) {
                if (FootballManiaConfig.isRtl) this.parallaxBg.setCss({
                    "margin-right": "-20%",
                    "transform": "translateY(-50px) translateX(" + this.cachedParllaxBgXOffset + "%)",
                    "transition-duration": speed + "ms"
                });
                else this.parallaxBg.setCss({
                    "transform": "translateY(-50px)  translateX(" + this.cachedParllaxBgXOffset + "%)",
                    "transition-duration": speed + "ms"
                });
            }
        }
        if (trigger) this.triggerEvent("tabChanged");
    }
    storeScrollPositions() {}
    restoreScrollPositions() {}
    registerSwipe() {
        var that = this;
        var w = this.getDimensions().width;
        var cancelSpeed = 350;
        var stopSwiping = false;
        var stopScrolling = false;
        var finchingY = false;
        var finchingX = false;
        var lastScrollPosition = 0;
        var disableLeftRightAction = false;
        var tabContentsElem = jQuery("#" + that.tabContents.getClientId());
        var tabIndicatorElem = jQuery("#" + that.tabHolder.tabIndicator.getClientId());
        this.cachedElements = [];
        $("#" + this.tabContents.getClientId()).swipe({
            allowPageScroll: "vertical",
            //Generic swipe handler for all directions
            swipe: function(event, direction, distance, duration, fingerCount, fingerData, currentDirection) {
                console.log("ending swipte");
                if (!that.tabs[that.currentActiveTab]) {
                    console.error("cannot swipe tab does not exist");
                    return;
                }
                //console
                if (fingerData[0].start.x < 35) {
                    that.isSwiping = false;
                    event.stopPropagation();
                    return;
                }
                if (that.isSwiping) {
                    that.isSwiping = false;
                    setTimeout(()=>{
                        that.triggerEvent("swipeEnd");
                    }, 200);
                }
                if (that.swipeDisabled) return;
                that.tabs[that.currentActiveTab].parent.enableBounce();
                disableLeftRightAction = false;
                //console.log("swiped ","dir",direction,"dis",distance,"dur",duration,"w",w,disableLeftRightAction,currentDirection);
                if (finchingY) {
                    // that.tabs[that.currentActiveTab].setCss({"transform":"scaleY(1)"});
                    $("#" + that.tabs[that.currentActiveTab].getClientId()).addClass("tabContentsScaleBack").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                        $(this).removeClass("tabContentsScaleBack");
                        $(this).css("transform", "none");
                    });
                    setTimeout(function() {
                        that.tabs[that.currentActiveTab].removeCssClass("tabContentsScaleBack");
                    }, 200);
                    finchingY = false;
                } else if (finchingX) {
                    $("#" + that.tabs[that.currentActiveTab].getClientId()).addClass("tabContentsScaleBackX").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                        $(this).removeClass("tabContentsScaleBackX");
                        $(this).css("transform", "none");
                    });
                    setTimeout(function() {
                        that.tabs[that.currentActiveTab].removeCssClass("tabContentsScaleBackX");
                    }, 200);
                    finchingX = false;
                }
                stopSwiping = false;
                stopScrolling = false;
                if (direction == "left") {
                    if (disableLeftRightAction) return;
                    var targetIndex = that.currentActiveTab + 1;
                    var speed = 200;
                    if (duration > 200) {
                        if (distance / w <= 0.50) {
                            console.log("cancel", distance / w);
                            //if (distance <= w - (w*0.2)){
                            targetIndex = that.currentActiveTab;
                            speed = cancelSpeed;
                        }
                    }
                    if (targetIndex > that.tabs.length - 1) {
                        targetIndex = that.tabs.length - 1;
                        speed = cancelSpeed;
                    }
                    that.moveToTab(targetIndex, speed, true);
                } else if (direction == "right") {
                    if (disableLeftRightAction) return;
                    var targetIndex = that.currentActiveTab - 1;
                    var speed = 200;
                    if (duration > 200) {
                        if (distance / w <= 0.50) {
                            console.log("cancel");
                            //if (distance <= w - (w*0.2)){
                            targetIndex = that.currentActiveTab;
                            speed = cancelSpeed;
                        }
                    }
                    if (targetIndex < 0) {
                        targetIndex = 0;
                        speed = cancelSpeed;
                    }
                    that.moveToTab(targetIndex, speed, true);
                } else {
                    speed = cancelSpeed;
                    that.moveToTab(that.currentActiveTab, speed, true);
                }
            },
            swipeStatus: function(event, phase, direction, distance, duration, fingers, fingerData, currentDirection) {
                if (Math.abs(fingerData[0].start.x < 35)) return;
                //that.tabs[that.currentActiveTab].parent.disableBounce();
                if (!that.tabs || !that.tabs[that.currentActiveTab]) {
                    console.error("swipe status failed. tabs not available");
                    return;
                }
                if (that.swipeDisabled) return;
                if (!that.cachedElements[that.tabs[that.currentActiveTab].getClientId()]) that.cachedElements[that.tabs[that.currentActiveTab].getClientId()] = document.querySelector("#" + that.tabs[that.currentActiveTab].getClientId());
                if (that.tabs[that.currentActiveTab].scrollerContainerReference) {
                    if (!that.cachedElements[that.tabs[that.currentActiveTab].scrollerContainerReference.getClientId()]) that.cachedElements[that.tabs[that.currentActiveTab].scrollerContainerReference.getClientId()] = document.querySelector("#" + that.tabs[that.currentActiveTab].scrollerContainerReference.getClientId());
                    var elem = that.cachedElements[that.tabs[that.currentActiveTab].scrollerContainerReference.getClientId()];
                } else elem = that.cachedElements[that.tabs[that.currentActiveTab].getClientId()];
                var translation = 0;
                //console.log(elem,elem.scrollHeight - elem.scrollTop, elem.offsetHeight)
                // console.log("set translation",duration,elem.scrollTop())
                if (!that.isSwiping && elem.scrollTop == 0 && direction == "down") {
                    var t = Math.min(1, distance / 100);
                    translation = 1 + 0.02 * t;
                    that.tabs[that.currentActiveTab].setCss({
                        "transform": "scaleY(" + translation + ")",
                        "transform-origin": "top right"
                    });
                    finchingY = true;
                    return;
                } else if (!that.isSwiping && direction == "up" && elem.scrollHeight - elem.scrollTop == elem.offsetHeight) {
                    var t = Math.min(1, distance / 100);
                    translation = 1 + 0.02 * t;
                    that.tabs[that.currentActiveTab].setCss({
                        "transform": "scaleY(" + translation + ")",
                        "transform-origin": "bottom right"
                    });
                    finchingY = true;
                }
                lastScrollPosition = elem.scrollTop;
                if (phase == "cancel") {
                    var speed = cancelSpeed;
                    that.moveToTab(that.currentActiveTab, speed, true);
                    //stopSwiping=  false;
                    stopScrolling = false;
                    //str +="<br/>Handler not triggered. <br/> One or both of the thresholds was not met "
                    return;
                } else if (phase == "end") {
                    //console.log("end");
                    speed = cancelSpeed;
                    //that.moveToTab(that.currentActiveTab,speed,true);
                    //stopSwiping=  false;
                    stopScrolling = false;
                    //str +="<br/>Handler was triggered."
                    return;
                }
                //var xDistance = Math.abs(fingerData[0].start.x - fingerData[0].last.x);
                var xDistance = Math.abs(distance);
                var startOffset = w * that.currentActiveTab;
                var indicatorOffset = w / that.tabs.length * that.currentActiveTab;
                //disable scrolling
                if (direction == "up" || direction == "down") {
                    disableLeftRightAction = true;
                    if (!stopScrolling) stopSwiping = true;
                }
                if (!disableLeftRightAction && !stopSwiping && direction == "right") {
                    stopScrolling = true;
                    var t = -startOffset + xDistance;
                    var tNonNormalised = t;
                    var t2 = indicatorOffset - xDistance / w * (w / that.tabs.length);
                    if (t > 0) {
                        t = 0;
                        t2 = 0;
                    }
                    var progression = t / (w * that.tabs.length);
                    if (!that.isSwiping) {
                        that.triggerEvent("swipeStart");
                        that.isSwiping = true;
                    }
                    tabContentsElem.css({
                        "transition-duration": "20ms",
                        "transform": "translate(" + t + "px)"
                    });
                    tabIndicatorElem.css({
                        "transition-duration": "20ms",
                        "transform": "translate(" + t2 + "px)"
                    });
                    if (progression == 0 && fingerData[0].start.x > 30) {
                        var translation = 1 + 0.0005 * Math.min(40, tNonNormalised);
                        that.tabs[that.currentActiveTab].setCss({
                            "transform": "scaleX(" + translation + ")",
                            "transform-origin": "bottom left"
                        });
                        finchingX = true;
                    }
                    if (that.parallaxBg) {
                        that.cachedParllaxBgXOffset = progression * 10;
                        if (FootballManiaConfig.isRtl) that.parallaxBg.setCss({
                            "margin-right": "-20%",
                            "transform": "translateY(-50px) translateX(" + this.cachedParllaxBgXOffset + "%)",
                            "transition-duration": "0ms"
                        });
                        else that.parallaxBg.setCss({
                            "transform": "translateY(-50px)  translateX(" + that.cachedParllaxBgXOffset + "%)",
                            "transition-duration": "0ms"
                        });
                    }
                //that.triggerEvent("onProgress",progression);
                } else if (!disableLeftRightAction && !stopSwiping && direction == "left") {
                    stopScrolling = true;
                    // if (finchingY){
                    //     return;
                    // }
                    //event.preventDefault();
                    //console.log("left",fingerData[0],xDistance)
                    var t = -startOffset - xDistance;
                    var t2 = indicatorOffset + xDistance / w * (w / that.tabs.length);
                    if (t < -((that.tabs.length - 1) * w)) {
                        t = -((that.tabs.length - 1) * w);
                        t2 = w - w / that.tabs.length;
                    }
                    var progression = t / (w * that.tabs.length);
                    if (-t == (that.tabs.length - 1) * w) {
                        var translation = 1 + 0.0005 * Math.min(20, xDistance);
                        that.tabs[that.currentActiveTab].setCss({
                            "transform": "scaleX(" + translation + ")",
                            "transform-origin": "bottom right"
                        });
                        finchingX = true;
                    }
                    if (!that.isSwiping) {
                        console.log("trigger swipe start");
                        that.triggerEvent("swipeStart");
                        that.isSwiping = true;
                    }
                    //console.log("progression","transition-duration","20ms","transform","translate("+t+"px)");
                    tabContentsElem.css({
                        "transition-duration": "20ms",
                        "transform": "translate(" + t + "px)"
                    });
                    tabIndicatorElem.css({
                        "transition-duration": "20ms",
                        "transform": "translate(" + t2 + "px)"
                    });
                    if (that.parallaxBg) {
                        that.cachedParllaxBgXOffset = progression * 10;
                        if (FootballManiaConfig.isRtl) that.parallaxBg.setCss({
                            "margin-right": "-20%",
                            "transform": "translateY(-50px) translateX(" + this.cachedParllaxBgXOffset + "%)",
                            "transition-duration": "0ms"
                        });
                        else that.parallaxBg.setCss({
                            "transform": "translateY(-50px)  translateX(" + that.cachedParllaxBgXOffset + "%)",
                            "transition-duration": "0ms"
                        });
                    }
                //jQuery("#"+that.parallaxBg).css({"transition-duration":"0ms","transform": "translate3d("+((progression)*10)+"%, 0px, 0px)"})
                //that.triggerEvent("onProgress",progression);
                }
            },
            //Default is 75px, set to 0 for demo so any distance triggers swipe
            threshold: 30
        });
    }
}
class $28c0cceb076dcf38$export$a6fec5efcdc65be2 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    hideLoader(text, tab) {
        if (!this.wrapper) //return console.error("cannot hide loader. never shown");
        return;
        this.wrapper.setVisible(false);
    }
    showLoader(text, tab) {
        if (this.wrapper) {
            if (text) this.loaderText.setData(text);
            this.wrapper.setVisible(true);
            return;
        }
        this.loaderContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.loaderContainer.addCssClass("loader_container");
        this.wrapper = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.wrapper.setStyle("margin-top:-50px;");
        this.wrapper.addCssClass("loader_wrapper");
        this.wrapper.addControl(this.loaderContainer);
        this.loaderSpinner = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.loaderSpinner.addCssClass("loader_spinner");
        this.loaderSpinner.setImage("images/loader1235.svg");
        this.loaderContainer.addControl(`
        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
   <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>  
        `);
        this.loaderText = new (0, $37cbb85645b0d818$export$b04be29aa201d4f5)();
        this.loaderText.setData();
        if (text) this.loaderText.setData(text);
        this.loaderText.addCssClass("loader_text");
        this.loaderContainer.addControl(this.loaderText);
        var fade = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        fade.addCssClass("loader_fade");
        this.wrapper.addControl(fade);
        var background = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //background.addCssClass("loader_background");
        //this.loaderContainer.addControl(background);
        this.loaderfade = fade;
        this.addControl(this.wrapper, true);
    }
}




var $02mnx = parcelRequire("02mnx");
class $90aac4880169307d$export$915e9e7bd4f0f96d extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init(options) {
        super.init();
        this.addCssClass("error");
        var errorImage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        errorImage.addCssClass("no-internet");
        this.addControl(errorImage);
        this.addControl(options.message);
        this.bind("click", ()=>{
            if (options.cb) return options.cb();
            console.error("no callback specified for error");
        });
    }
}
class $90aac4880169307d$export$4caa372402b56d41 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init(options) {
        super.init();
        this.addCssClass("error");
        var errorImage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        errorImage.addCssClass("no-internet");
        this.addControl(errorImage);
        this.addControl(options.message);
        this.addControl("<br><p class='noDataTapText'>" + (0, $02mnx.Localizer).getString("taptoreturn") + "</p>");
        this.bind("click", ()=>{
            if (options.cb) return options.cb();
            console.error("no callback specified for error");
        });
    }
}
class $90aac4880169307d$export$e5da9225dca7bbb3 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init(options) {
        super.init();
        this.addCssClass("error");
        var errorImage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        errorImage.addCssClass("no-internet");
        this.addControl(errorImage);
        this.addControl(options.message);
        this.bind("click", ()=>{
            if (options.cb) return options.cb();
            console.error("no callback specified for error");
        });
    }
}
class $90aac4880169307d$export$5006bd6e14e3bbef extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init(options) {
        super.init();
        this.addCssClass("error");
        var errorImage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        errorImage.addCssClass("icon-chat");
        errorImage.setStyle("height:100px;width:100px;");
        this.addControl(errorImage);
        this.addControl(options.message);
        this.addControl("<br><p class='noDataTapText'>" + (0, $02mnx.Localizer).getString("type_below_to_be_first") + "</p>");
        this.bind("click", ()=>{
            if (options.cb) return options.cb();
            console.error("no callback specified for error");
        });
    }
}




class $caa85a5b251985fa$export$19f5a358c10e8419 extends (0, $cf8b45a51b0de626$export$18f8036a6dc5f3a5) {
    /**
	 * Overridden to prevent default DOM data updates, as rendering is handled via `createControls`.
	 */ setDomData() {
    // Intentionally left empty
    }
    /**
	 * Abstract method to be overridden by subclasses.
	 * Defines the logic for creating controls based on `data` or `datasource`.
	 */ createControls() {
    // Subclasses should implement this method
    }
    /**
	 * Sets the data for the control.
	 * Clears the control, calls `createControls`, and invalidates the display for rerendering.
	 *
	 * @param {any} data - The data to set.
	 * @param {boolean} [ignoreEvent=false] - If true, no event is triggered.
	 * @param {boolean} [ignoreDom=false] - If true, DOM updates are skipped.
	 * @returns {this}
	 */ setData(data, ignoreEvent = false, ignoreDom = false) {
        try {
            // Use structuredClone if available, otherwise fall back to JSON method
            this.data = typeof structuredClone === "function" ? structuredClone(data) : JSON.parse(JSON.stringify(data));
        } catch (error) {
            console.error("Failed to clone data:", error);
            this.data = data; // Fallback to shallow assignment
        }
        if (!ignoreDom) {
            this.clear();
            this.createControls();
            this.invalidateDisplay();
        }
        if (!ignoreEvent) this.triggerEvent("onSetData", this.data);
        return this;
    }
    /**
	 * Sets the datasource for the control.
	 * Clears the control, calls `createControls`, and invalidates the display for rerendering.
	 *
	 * @param {any} ds - The datasource to set.
	 * @returns {this}
	 */ setDataSource(ds) {
        this.datasource = ds; // No cloning needed unless datasource is modified
        this.clear();
        this.createControls();
        this.invalidateDisplay();
        this.triggerEvent("onSetDataSource", this.datasource);
        return this;
    }
}





var $lU8CH = parcelRequire("lU8CH");


var $gQQqD = parcelRequire("gQQqD");
class $cc353791ae30d153$export$bc805d5457972dba extends (0, $caa85a5b251985fa$export$19f5a358c10e8419) {
    init() {
        super.init();
        this.addCssClass("LazyTileGrid");
        this.defaultContentItemRender = (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f);
    // this.lazyTileGridRendererWorker = new Worker('js/util/workers.js');
    }
    unload() {
        var scrollEl = jQuery("#" + this.containerTarget.getClientId());
        scrollEl.off("scroll", this.scrollMethod); //what if others listen to this event
        if (this.fastScrollContainerHandler) {
            var fastScrollEl = jQuery("#" + this.fastScrollContainerHandler.getClientId());
            fastScrollEl.off("touchmove", this.fastScrollTouchMoveMethod);
            fastScrollEl.off("touchend", this.fastScrollTouchEndMethod);
            fastScrollEl.on("click", this.fastScrollClickMethod);
        }
        if (this.tabview) {
            $(this.tabview).off('swipeStart', this.swipeStartMethod);
            $(this.tabview).off('swipeEnd ', this.swipeEndMethod);
        }
        if (this.enablePullToRefresh) {
            scrollEl.off("touchstart", this.pullToRefreshTouchStartMethod);
            scrollEl.off("touchend", this.pullToRefreshTouchEndMethod);
            scrollEl.off("touchmove", this.pullToRefreshTouchMoveMethod);
        }
        this.indexTilePlaceHolderMap = null;
        this.datasourceByType = null;
        this.datasourceIndexByTypeNormalized = null;
        this.itemRenderByIndexMap = null;
        this.datasource = null;
        clearTimeout(this.callLaterMethod);
        clearTimeout(this.indicerHandler);
    //this.lazyTileGridRendererWorker.terminate();
    }
    createComponents() {
        super.createComponents();
        //when we know the tabview we can know when user swipes and apply data when user is finished swiping
        if (this.tabview) {
            this.swipeStartMethod = (e)=>{
                this.isSwiping = true;
            };
            //
            this.swipeEndMethod = (e)=>{
                this.isSwiping = false;
                if (this.callSetDataSourceLater) {
                    var ds = this.callSetDataSourceLater;
                    this.callSetDataSourceLater = null;
                    this.setDataSource(ds);
                }
            };
            //prevent the data to load when touching. usually when scrolling.
            //it creates an annoying flicker. on touch up we apply the data
            $(this.tabview).on('swipeStart', this.swipeStartMethod);
            $(this.tabview).on('swipeEnd ', this.swipeEndMethod);
        } else console.warn("no tabview found, so no swipe events can be detected. please add it for better user experience");
    }
    setDataSource(ds) {
        if (this.isSwiping) {
            console.warn("user is swiping, so we dont apply the data now, but later when user is finished swiping");
            this.callSetDataSourceLater = ds;
            return;
        }
        if (this.stopOnDatasourceChangeUpdatesFlag) {
            console.warn("do not update list when stopOnDatasourceChangeUpdatesFlag is set");
            this.postponedDatasource = ds;
            return;
        }
        if (!this.datasource) {
            this.datasource = ds; //we dont need to clone this, cause do we change and save the datasource?
            this.clear();
            this.createControls();
            this.invalidateDisplay();
            //this.triggerEvent('onSetDataSource');
            return this;
        } else {
            this.datasource = ds;
            var scroll = this.getScroll();
            this.createItems();
            this.scrollTo(scroll);
        }
    }
    /**
     * @return {DataGridTileItemRender}
     */ getDefaultItemRender() {
        return this.defaultContentItemRender;
    }
    /**
     * Set the global item render for this list render.
     * @param {DataGridTileItemRender} itemRender
     */ setItemRender(render) {
        this.defaultContentItemRender = render;
        this.triggerEvent('itemRenderChanged');
    }
    stopOnDatasourceChangeUpdates() {
        //console.log("stopOnDatasourceChangeUpdates");
        this.stopOnDatasourceChangeUpdatesFlag = true;
    }
    continueOnDatasourceChangeUpdates() {
        this.stopOnDatasourceChangeUpdatesFlag = false;
        if (this.postponedDatasource) {
            //console.log("continueOnDatasourceChangeUpdates");
            this.setDataSource(this.postponedDatasource);
            this.postponedDatasource = null;
        }
    }
    showError(errorMessage, cb) {
        if (!this.errorTemplate) return console.error("cannot show error without template");
        this.createControls();
        this.mainContainer.clear();
        var control = this.errorTemplate({
            'message': errorMessage,
            "cb": cb
        });
        this.mainContainer.addControl(control, true);
        this.renderedErrorTemplate = control;
        this.invalidateDisplay();
    }
    hideError() {
        this.mainContainer.clear();
    }
    /**
     * Invoked after changing datasource or invalidating
     * @ignore
     */ createControls() {
        super.createControls();
        this.clear();
        this.mainContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.mainContainer.addCssClass("listViewMainContainer");
        this.addControl(this.mainContainer);
        if (this.enableFastScroll) {
            this.fastScrollContainerHandler = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.fastScrollContainerHandler.addCssClass("listViewFastScrollContainer");
            if (FootballManiaConfig.isRtl) this.fastScrollContainerHandler.setCss({
                "left": "0px"
            });
            else this.fastScrollContainerHandler.setCss({
                "right": "0px"
            });
            this.addControl(this.fastScrollContainerHandler);
        }
    }
    onWindowResize() {
        var delay = 20;
        if (!this.windowResizeHandler) delay = 0;
        var scrollEl = jQuery("#" + this.containerTarget.getClientId());
        this.contentHeight = scrollEl.height();
        clearTimeout(this.windowResizeHandler);
        this.windowResizeHandler = setTimeout(()=>{
            if (!this.mainContainer) return;
            console.log("on window resize proceed");
            var scroll = this.getScroll();
            this.createItems(false);
            this.scrollTo(scroll);
        }, delay);
    }
    /**
     * @ignore
     */ updateDisplay() {
        if (!this.datasource) return;
        this.createItems(true);
        if (this.enableFastScroll && this.fastScrollContainerHandler) {
            var scrollEl = jQuery("#" + this.fastScrollContainerHandler.getClientId());
            scrollEl.off("click");
            this.fastScrollClickMethod = (e)=>{
                console.log("fast click", e, e.target.className);
                //logic below is to make sure the click events are propagated to the correct element
                //the fast scrollbar container is a sibling of the content scroll container and therefor
                //no events are propogated to the content scroll container
                //we do it manually. Can we do it in a better way??
                if (!e.originalEvent) return;
                if (e.target.className != "listViewFastScrollContainer") // console.warn("do not propogate click when not originating from listViewFastScrollContainer");
                // var els = document.elementsFromPoint(e.originalEvent.clientX, e.originalEvent.clientY);
                // if (els.length < 1) return;
                // console.log(els[0])
                // $(els[0]).trigger("click");
                return;
                var els = document.elementsFromPoint(e.originalEvent.clientX, e.originalEvent.clientY);
                if (els.length < 1) return;
                $(els[1]).trigger("click");
            };
            scrollEl.on("click", this.fastScrollClickMethod);
        }
    }
    scrollTo(y, preventDefaultScrollEvent) {
        if (this.containerTarget.getParent()) {
            var el = jQuery("#" + this.containerTarget.getClientId());
            //set temporary scroll listener
            if (this.tempScrollMethod) el.off("scroll", this.tempScrollMethod);
            console.log("set scroll listener", y, preventDefaultScrollEvent);
            this.tempScrollMethod = ()=>{
                console.log("TRIGGERED SCROLL EVENT INCOMING", preventDefaultScrollEvent);
                el.off("scroll", this.tempScrollMethod);
                this.triggerEvent("onScrollToComplete");
            };
            if (preventDefaultScrollEvent) this.preventScrollEventOnce = true;
            el.on("scroll", this.tempScrollMethod);
            this.scrollLater = y;
            this.scrollLaterPreventDefault = preventDefaultScrollEvent;
            return jQuery("#" + this.containerTarget.getClientId()).scrollTop(y);
        }
        this.scrollLater = y;
        this.scrollLaterPreventDefault = preventDefaultScrollEvent;
    }
    scrollToSmooth(y, duration) {
        if (!this.containerTarget.getParent()) return;
        jQuery("#" + this.containerTarget.getClientId()).animate({
            scrollTop: y
        }, duration);
    }
    scrollRemaining() {
        var el = jQuery("#" + this.containerTarget.getClientId());
        return el[0].scrollHeight - (el[0].offsetHeight + el.scrollTop());
    }
    scrollToLastSelectedOrTop() {
        if (this.selectedItem != undefined) this.scrollTo(this.selectedItem);
        else this.scrollTo(0);
    }
    getScroll() {
        return jQuery("#" + this.containerTarget.getClientId()).scrollTop();
    }
    focusNext(forceReset, isTabKey, isLeftRight, isUpDown) {
        var oldIndex = this.selectedFocusIndex;
        if (this.selectedFocusIndex == undefined) this.selectedFocusIndex = -1;
        var currentSelected = this.datasource[this.selectedFocusIndex];
        if (currentSelected) {
            var ir = this.itemRenderByIndexMap[this.selectedFocusIndex];
            if (ir && ir.focusNext(isTabKey, isLeftRight, isUpDown)) {
                console.log("item render itself can focus next");
                return true;
            }
        }
        this.selectedFocusIndex++;
        console.log("focusNext", this.selectedFocusIndex);
        var foundNext = false;
        for(var i = this.selectedFocusIndex; i < this.datasource.length; i++){
            ///console.log("focusNext", i, this.datasource[i].accessibility.allowTabFocus, this.datasource[i].accessibility.focusable)
            if (!this.datasource[i].accessibility || !this.datasource[i].accessibility.focusable) continue;
            if (isTabKey) {
                if (this.datasource[i].accessibility.allowTabFocus) {
                    foundNext = true;
                    this.selectedFocusIndex = i;
                    break;
                }
            } else {
                foundNext = true;
                this.selectedFocusIndex = i;
                break;
            }
        }
        if (!foundNext || this.selectedFocusIndex == oldIndex) {
            console.warn("no focusable item render found");
            this.selectedFocusIndex--;
            return;
        }
        this.scrollTo(this.datasource[this.selectedFocusIndex].style.offset - 100);
        var ir = this.itemRenderByIndexMap[this.selectedFocusIndex];
        if (!ir) {
            console.warn("no item render found for data ", this.datasource[this.selectedFocusIndex]);
            return;
        }
        if (!ir.focus) {
            console.warn("no focus method on item render for data ", this.datasource[this.selectedFocusIndex]);
            return;
        }
        this.previousFocusItem = ir;
        setTimeout(()=>{
            ir.focus();
        }, 100);
        // if (this.previousFocusItem){
        //     this.previousFocusItem.defocus();
        // }
        return true;
    }
    focusPrevious(forceReset, isTabKey, isLeftRight, isUpDown) {
        var oldIndex = this.selectedFocusIndex;
        if (this.selectedFocusIndex == undefined) this.selectedFocusIndex = 0;
        var currentSelected = this.datasource[this.selectedFocusIndex];
        if (currentSelected) {
            var ir = this.itemRenderByIndexMap[this.selectedFocusIndex];
            if (ir && ir.focusPrevious && ir.focusPrevious(isTabKey, isLeftRight, isUpDown)) {
                console.log("item render itself can focus next");
                return true;
            }
        }
        this.selectedFocusIndex--;
        this.selectedFocusIndex = Math.max(0, this.selectedFocusIndex);
        var foundPrevious = false;
        console.log("focusPrevious", this.selectedFocusIndex);
        for(var i = this.selectedFocusIndex; i >= 0; i--){
            if (!this.datasource[i].accessibility || !this.datasource[i].accessibility.focusable) continue;
            if (isTabKey) {
                if (this.datasource[i].accessibility.allowTabFocus) {
                    foundPrevious = true;
                    this.selectedFocusIndex = i;
                    break;
                }
            } else {
                foundPrevious = true;
                this.selectedFocusIndex = i;
                break;
            }
        }
        if (!foundPrevious || this.selectedFocusIndex == oldIndex) {
            console.warn("no focusable item render found");
            return;
        }
        this.scrollTo(this.datasource[this.selectedFocusIndex].style.offset - 100);
        var ir = this.itemRenderByIndexMap[this.selectedFocusIndex];
        if (!ir) {
            console.warn("no item render found for data ", this.datasource[this.selectedFocusIndex]);
            return;
        }
        if (!ir.focus) {
            console.warn("no focus method on item render for data ", this.datasource[this.selectedFocusIndex]);
            return;
        }
        this.previousFocusItem = ir;
        setTimeout(()=>{
            ir.focus();
        }, 100);
        // if (this.previousFocusItem){
        //     this.previousFocusItem.defocus();
        // }
        return true;
    }
    defocus() {
        if (this.previousFocusItem) this.previousFocusItem.defocus();
        this.selectedFocusIndex = undefined;
    }
    autoMove() {
        if (!this.datasource.length) return;
        this.indexTilePlaceHolderMap = [];
        this.indexRenderedItemRenderMap = [];
        var scrollEl = jQuery("#" + this.containerTarget.getClientId());
        var previousTopVisibleItem = [];
        var topVisibleItem = [];
        var prevScrollTop = null;
        var scrollTop = -1;
        var lastFoundTopVisibleItem = [];
        var renderList = [];
        var relativeIndexItem;
        var targetPos;
        var run = (type, scrollTop)=>{
            if (!this.datasourceByType[type]) return;
            if (scrollTop == 0) {
                topVisibleItem[type] = 0;
                lastFoundTopVisibleItem[type] = 0;
            } else {
                if (this.datasourceIndexByTypeNormalized) topVisibleItem[type] = this.datasourceIndexByTypeNormalized[type][Math.trunc(scrollTop / 40) * 40];
                else topVisibleItem[type] = (0, $gQQqD.Processors).findNearestItem(this.datasourceByType[type], scrollTop);
                topVisibleItem[type] = topVisibleItem[type] >= 5 ? topVisibleItem[type] - 5 : 0;
            }
            if (previousTopVisibleItem[type] == topVisibleItem[type]) return;
            previousTopVisibleItem[type] = topVisibleItem[type];
            renderList[type] = [];
            relativeIndexItem = Math.floor(topVisibleItem[type] / this.maxItemsToRender);
            // console.log(type,"relative index item",relativeIndexItem,"maxrender",this.maxItemsToRender);
            for(var i = 0; i < this.maxItemsToRender; i++)if (i >= topVisibleItem[type] % this.maxItemsToRender) renderList[type][i] = i + relativeIndexItem * this.maxItemsToRender;
            else renderList[type][i] = i + this.maxItemsToRender + relativeIndexItem * this.maxItemsToRender;
            //console.log(type,renderList[type]);
            for(var i = 0; i < renderList[type].length; i++){
                //console.log("x",this.datasourceByType[type]);
                if (!this.datasourceByType[type][renderList[type][i]]) continue;
                //console.log("y");
                this.datasourceByType[type][renderList[type][i]].level = relativeIndexItem;
                //a new item needs to be rendered
                if (!this.indexTilePlaceHolderMap[type] || !this.indexTilePlaceHolderMap[type][i]) {
                    //console.log("==============> create placeholder",i,type);
                    this.createDivPlaceHolder(i, true, this.datasourceByType[type][renderList[type][i]].style.height, type);
                    this.indexTilePlaceHolderMap[type][i].renderType = this.datasourceByType[type][renderList[type][i]].type;
                    this.createItemRenderByIndex(i, this.datasourceByType[type][renderList[type][i]], true, type);
                ///console.log("create item render ",i,type)
                }
                var indexedPlaceHolder = this.indexTilePlaceHolderMap[type][i];
                var prevIndex = indexedPlaceHolder.currentDataIndex;
                indexedPlaceHolder.currentDataIndex = renderList[type][i];
                //and existing item needs to be updated
                if (prevIndex != indexedPlaceHolder.currentDataIndex) {
                    if (this.indexRenderedItemRenderMap[type][i] != this.datasourceByType[type][renderList[type][i]]) {
                        //console.log("==============> update placeholder",i,type);
                        this.itemRenderByIndexMap[this.datasourceByType[type][renderList[type][i]].style.index] = this.indexRenderedItemRenderMap[type][i];
                        this.indexRenderedItemRenderMap[type][i].setData(this.datasourceByType[type][renderList[type][i]]);
                        targetPos = this.datasourceByType[type][indexedPlaceHolder.currentDataIndex].style.offset;
                        indexedPlaceHolder.setCss({
                            "top": targetPos + "px"
                        });
                    ///console.log("set data ",i,type)
                    }
                }
            }
        };
        var length = Object.keys(this.datasourceByType).length + 4;
        this.scrollMethod = ()=>{
            scrollTop = scrollEl.scrollTop();
            if (!this.preventScrollEventOnce) this.triggerEvent("scroll", scrollTop);
            this.preventScrollEventOnce = false;
            for(var i = 0; i < length; i++)// if (i != 5) continue;
            run(i + 1, scrollTop, prevScrollTop);
            prevScrollTop = scrollTop;
        };
        if (this.scrollMethod) scrollEl.off("scroll", this.scrollMethod);
        scrollEl.scroll(this.scrollMethod);
        for(var i = 0; i < length; i++)run(i + 1, scrollEl.scrollTop(), -1);
    }
    createItems(allowFlickerBetweenRender) {
        if (!this.datasource || !this.datasource.length) {
            this.mainContainer.clear();
            if (this.emptyTemplate) {
                var control = this.emptyTemplate();
                // this.mainContainer.setCss({'height':"100%"})
                // t;
                //this.mainContainer.addControl("asdsdadsadsa")
                this.mainContainer.addControl(control);
                this.mainContainer.invalidateDisplay();
                // console.log("aap");
                this.previousWasEmptyDataSource = true;
                this.mainContainer.setCss({
                    'height': "100%"
                });
            }
            if (this.fastScrollContainerHandler && this.enableFastScroll) this.fastScrollContainerHandler.setCss({
                'height': "0px"
            });
            return;
        }
        this.calculatedScreenHeight = 0;
        this.calculatedItemsHeight = 0;
        if (this.renderedErrorTemplate) this.renderedErrorTemplate.remove();
        if (this.previousWasEmptyDataSource) {
            this.mainContainer.clear();
            this.previousWasEmptyDataSource = false;
        }
        if (!this.renderListContainers) this.renderListContainers = [];
        var renderListContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        renderListContainer.addCssClass("maincontainer2");
        ///we do some optimization here to prevent flickering whne new list items
        ///are created. we create a container which we render hidden, we wait
        //for x ms and then simultanously hide and show the old and new one.
        if (this.renderListContainers.length) //console.log("we have a previous render",this.renderListContainers.length);
        //renderListContainer.setVisible(false);
        renderListContainer.setCss({
            "visibility": "hidden"
        });
        this.renderListContainers.push(renderListContainer);
        // console.log("data length",this.datasource.length)
        //calculate scrolling area
        var height = 0;
        var id = 1;
        this.datasourceByType = [];
        this.itemRenderByIndexMap = [];
        this.datasourceTypeCount = 0;
        this.indexToOffsetMap = {};
        var selectedItem = -1;
        for(var i = 0; i < this.datasource.length; i++){
            this.datasource[i].style.offset = height;
            this.datasource[i].listId = id;
            if (this.datasource[i].style.selected) {
                selectedItem = this.datasource[i].style.offset;
                this.selectedItem = selectedItem;
            }
            if (!this.datasourceByType[this.datasource[i].type]) {
                this.datasourceTypeCount++;
                this.datasourceByType[this.datasource[i].type] = [];
            }
            this.datasourceByType[this.datasource[i].type].push(this.datasource[i]);
            this.indexToOffsetMap[i] = this.datasource[i].style.offset;
            this.datasource[i].style.index = i;
            id++;
            height += this.datasource[i].style.height;
        }
        this.positionIndexCalculated = false; //important to reset this flag
        this.datasourceIndexByTypeNormalized = {};
        //t = type
        //x = pixel height. if 40 items should not be smaller than 40px
        for(var t = 0; t < 15; t++){
            if (!this.datasourceByType[t]) continue;
            if (!this.datasourceIndexByTypeNormalized[t]) this.datasourceIndexByTypeNormalized[t] = {};
            var x = 0;
            for(var i = 0; i <= height; i += 40){
                if (!this.datasourceByType[t][x]) break;
                if (i <= this.datasourceByType[t][x].style.offset + this.datasourceByType[t][x].style.height) this.datasourceIndexByTypeNormalized[t][i] = x;
                else {
                    x++;
                    i -= 40;
                }
            }
        }
        this.calculatedItemsHeight = height;
        var dimensions = this.containerTarget.getDimensions();
        this.calculatedScreenHeight = dimensions.height;
        var avarageHeight = height / this.datasource.length;
        this.itemHeight = avarageHeight;
        if (!this.maxItemsToRender) {
            this.maxItemsToRender = Math.ceil(dimensions.height / avarageHeight);
            this.maxItemsToRender += 8;
        }
        this.maxItemsToRender = Math.max(FootballManiaConfig.graphics.listRenderMaxRenderCount, this.maxItemsToRender); ///hack
        //this.maxItemsToRender = 5;
        this.mainContainer.setCss({
            'height': height + "px"
        });
        if (this.fastScrollContainerHandler && this.enableFastScroll) this.fastScrollContainerHandler.setCss({
            'height': height + "px"
        });
        //console.log("set height ",height);
        this.mainContainer.addControl(renderListContainer, true);
        if (this.scrollLater != undefined) {
            this.scrollTo(this.scrollLater, this.scrollLaterPreventDefault);
            this.scrollLater = undefined;
            this.scrollLaterPreventDefault = undefined;
        } else if (selectedItem != undefined) {
            this.scrollTo(selectedItem, this.scrollLaterPreventDefault);
            this.scrollLaterPreventDefault = undefined;
        }
        this.autoMove();
        renderListContainer.invalidateDisplay();
        var delay = 80;
        if (allowFlickerBetweenRender) delay = 0;
        //console.log("renderlist container length",this.renderListContainers.length);
        clearTimeout(this.rerenderTimeoutHandler);
        if (this.renderListContainers.length > 1) this.rerenderTimeoutHandler = setTimeout(()=>{
            if (this.renderListContainers.length > 1) {
                this.renderListContainers[this.renderListContainers.length - 1].setCss({
                    "display": ""
                });
                for(var i = 0; i < this.renderListContainers.length - 1; i++)//console.log("remove list container ",i)
                this.getPage().removeControl(this.renderListContainers[i]);
                //this.renderListContainers[1].setCss({"display": ""});
                this.renderListContainers = [];
                this.renderListContainers.push(renderListContainer);
                renderListContainer.setCss({
                    "visibility": ""
                });
            }
            this.triggerEvent("createdList");
        }, delay);
        else this.triggerEvent("createdList");
        this.activateFastScroll();
        this.activatePullToRefresh();
        this.restoreFocus();
    }
    getItemByScrollPosition(scrollPosition) {
        if (!this.positionIndexCalculated) {
            this.positionIndex = {};
            var x = 0;
            for(var i = 0; i <= this.calculatedItemsHeight; i += 40){
                if (!this.datasource[x]) break;
                //if (x >= 10000) break;
                if (i <= this.datasource[x].style.offset + this.datasource[x].style.height) this.positionIndex[i] = x;
                else {
                    x++;
                    i -= 40;
                }
            }
            this.positionIndexCalculated = true;
        }
        var quantized = Math.floor(scrollPosition / 40) * 40;
        return this.datasource[this.positionIndex[quantized]];
    }
    activatePullToRefresh() {
        if (!this.enablePullToRefresh || !this.enablePullToRefresh) return;
        var scrollEl = jQuery("#" + this.containerTarget.getClientId());
        var topOffset;
        var startY = -1;
        var hold = false;
        var indicatorTriggered = false;
        var timeoutHandler;
        scrollEl.off("touchstart", this.pullToRefreshTouchStartMethod);
        this.pullToRefreshTouchStartMethod = ()=>{
            hold = false;
        };
        scrollEl.on("touchstart", this.pullToRefreshTouchStartMethod);
        scrollEl.off("touchend", this.pullToRefreshTouchEndMethod);
        this.pullToRefreshTouchEndMethod = ()=>{
            console.log("end");
            startY = -1;
            indicatorTriggered = false;
            clearTimeout(timeoutHandler);
            this.deactivatePullToRefresh();
            this.continueOnDatasourceChangeUpdates();
        };
        scrollEl.on("touchend", this.pullToRefreshTouchEndMethod);
        scrollEl.off("touchmove", this.pullToRefreshTouchMoveMethod);
        this.pullToRefreshTouchMoveMethod = (e)=>{
            if (hold || this.isSwiping) return;
            this.stopOnDatasourceChangeUpdates();
            topOffset = scrollEl.scrollTop();
            if (topOffset > 0) {
                hold = true;
                return;
            }
            if (startY == -1) {
                this.stopOnDatasourceChangeUpdates();
                startY = e.originalEvent.touches[0].clientY;
            //add html before
            }
            var diff = e.originalEvent.touches[0].clientY - startY;
            if (topOffset == 0 && diff > 0) {
                var pullTo = Math.min(70, Math.floor(diff));
                this.mainContainer.setCss({
                    "transform": "translateY(" + pullTo / 1.4 + "px)"
                });
                if (!indicatorTriggered && diff >= 70) {
                    indicatorTriggered = true;
                    var svgContent = (0, $lU8CH.svgRepo).ball;
                    jQuery("#" + this.mainContainer.getClientId()).prepend(`<div id="pullToRefreshContainer" class="pullToRefreshContainer">` + svgContent + `</div>`);
                    clearTimeout(timeoutHandler);
                    timeoutHandler = setTimeout(()=>{
                        hold = true;
                        startY = -1;
                        indicatorTriggered = false;
                        this.deactivatePullToRefresh();
                        this.continueOnDatasourceChangeUpdates();
                        this.triggerEvent("pullToRefreshAction");
                    }, 800);
                } else if (!indicatorTriggered) clearTimeout(timeoutHandler);
            }
        };
        scrollEl.on("touchmove", this.pullToRefreshTouchMoveMethod);
    }
    deactivatePullToRefresh() {
        jQuery("#pullToRefreshContainer").remove();
        this.mainContainer.setCss({
            "transform": "translateY(0px)",
            "transition-duration": "100ms"
        });
    }
    activateFastScroll() {
        if (!this.fastScrollContainerHandler || !this.enableFastScroll) return;
        if (this.fastScrollActivated) return;
        this.fastScrollActivated = true;
        var fastScrollEl = jQuery("#" + this.fastScrollContainerHandler.getClientId());
        var scrollEl = jQuery("#" + this.containerTarget.getClientId());
        var topOffset = scrollEl.offset().top;
        this.contentHeight = scrollEl.height();
        var scrollHeight = fastScrollEl[0].scrollHeight;
        if (!this.contentHeight || !scrollHeight || scrollHeight / this.contentHeight < 2) {
            console.log("do not activate fast scroll when scroll content is too smalll");
            return;
        }
        fastScrollEl.off("touchend", this.fastScrollTouchEndMethod);
        this.fastScrollTouchEndMethod = ()=>{
            this.isFastScrolling = false;
            previousClickedFastScrollItem = null;
            clearTimeout(this.fastScrollItemAnimationHandle);
            this.fastScrollItemAnimationHandle = setTimeout(()=>{
                if (this.unloaded || !this.fastScrollIndicatorControl) return;
                this.fastScrollIndicatorControl.addCssClass("fastscrollbaritemanimateout");
            }, 100);
        };
        fastScrollEl.on("touchend", this.fastScrollTouchEndMethod);
        this.indicatorpos = 0;
        var touchCurrentPos = 0;
        var scrollPercentage = 0;
        var previousClickedFastScrollItem = null;
        var currentFastScrollItem = null;
        fastScrollEl.off("touchmove", this.fastScrollTouchMoveMethod);
        this.fastScrollTouchMoveMethod = (e)=>{
            this.isFastScrolling = true;
            if (!this.fastScrollIndicatorControl) {
                this.fastScrollIndicatorControl = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                this.fastScrollIndicatorControl.addCssClass("FastScrollContentItem");
                if (FootballManiaConfig.isRtl) this.fastScrollIndicatorControl.addCssClass("FastScrollContentItemRTL");
                this.fastScrollContainerHandler.addControl(this.fastScrollIndicatorControl, true);
                // this.fastScrollIndicatorControl.bind("click",(e)=>{
                //     e.stopPropagation();
                //     console.log("trigger click for fastscrollindicator",this.indicatorpos);
                //     currentFastScrollItem = this.getItemByScrollPosition(this.indicatorpos);
                //     this.triggerEvent("fastScrollIndicatorClicked",currentFastScrollItem);
                // });
                if (!this.fastScrollElementTemplate) return console.warn("no fast scroll element defined");
                if (this.fastScrollElementTemplate) {
                    this.fastScrollElement = this.fastScrollElementTemplate();
                    this.fastScrollIndicatorControl.addControl(this.fastScrollElement, true);
                }
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            touchCurrentPos = e.originalEvent.touches[0].clientY;
            scrollPercentage = Math.min(1, Math.max(0, (touchCurrentPos - topOffset) / this.contentHeight));
            this.scrollTo(scrollPercentage * scrollHeight);
            //console.log(scrollPercentage,scrollEl.scrollTop());
            if (!this.fastScrollElementTemplate) return;
            this.indicatorpos = Math.max(topOffset, Math.min(this.calculatedItemsHeight, scrollPercentage * scrollHeight + scrollPercentage * this.contentHeight));
            this.fastScrollIndicatorControl.removeCssClass("fastscrollbaritemanimateout");
            currentFastScrollItem = this.getItemByScrollPosition(this.indicatorpos);
            if (currentFastScrollItem != previousClickedFastScrollItem) this.triggerEvent("requestFastScrollIndicatorItem", {
                "item": currentFastScrollItem,
                "element": this.fastScrollElement
            });
            previousClickedFastScrollItem = currentFastScrollItem;
            this.fastScrollIndicatorControl.setCss({
                "top": this.indicatorpos + "px"
            });
        };
        fastScrollEl.on("touchmove", this.fastScrollTouchMoveMethod);
    }
    createDivPlaceHolder(index, instantRender, height, type) {
        //console.log("create div placeholder ",index,this.renderListContainers[this.renderListContainers.length-1].getClientId());
        var tileplaceholder = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tileplaceholder.addCssClass("BDataGridTilePlaceHolder");
        tileplaceholder.setCss({
            "position": "absolute"
        });
        if (this.placeHolderWidth) tileplaceholder.setCss({
            width: this.placeHolderWidth
        });
        //tileplaceholder.bind('mouseenter',this.getProxy(function(e){this.onRowMouseOver(e); return true;}),tileplaceholder);
        //tileplaceholder.bind('mouseleave',this.getProxy(function(e){this.onRowMouseOut(e);return true;}),tileplaceholder);
        //tileplaceholder.bind('click',this.getProxy(function(e){this.onRowMouseClick(e);return true;}),tileplaceholder);
        this.renderListContainers[this.renderListContainers.length - 1].addControl(tileplaceholder, instantRender);
        if (!this.indexTilePlaceHolderMap) this.indexTilePlaceHolderMap = [];
        if (!this.indexTilePlaceHolderMap[type]) this.indexTilePlaceHolderMap[type] = [];
        this.indexTilePlaceHolderMap[type][index] = tileplaceholder;
    //  console.log(this.indexTilePlaceHolderMap)
    }
    setPlaceHolderWidth(width) {
        this.placeHolderWidth = width;
    }
    createItemRenderByIndex(index, data, instantRerender, type) {
        //console.log("create item render ",index)
        var itemRenderFactory = this.defaultContentItemRender;
        var itemRender = itemRenderFactory(data).render;
        if (!itemRender) return console.warn("no item render created");
        //console.log(itemRender);
        //data.index = index;
        if (!this.indexRenderedItemRenderMap[type]) this.indexRenderedItemRenderMap[type] = [];
        this.indexRenderedItemRenderMap[type][index] = itemRender;
        //itemRender.setData(data,true); //no instant render needed
        itemRender.setListRender(this);
        //data._itemRender = itemRender;
        this.itemRenderByIndexMap[data.style.index] = itemRender;
        this.indexTilePlaceHolderMap[type][index].clear();
        this.indexTilePlaceHolderMap[type][index].addControl(itemRender, instantRerender);
        instantRerender;
    }
    onRowMouseOver(e) {}
    onRowMouseOut(e) {}
    onRowMouseClick(e) {}
    selectIndex(index) {}
    deSelectIndex(index) {}
    constructor(...args){
        super(...args), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "restoreFocus", function() {
            if (this.selectedFocusIndex == undefined) return;
            console.log("restoreFocus", this.previousFocusItem, this.selectedFocusIndex);
            var ir = this.itemRenderByIndexMap[this.selectedFocusIndex];
            if (!ir) {
                console.warn("cannot restore focus for index " + this.selectedFocusIndex + ": no item render found for data ", this.datasource[this.selectedFocusIndex]);
                return;
            }
            if (!ir.focus) {
                console.warn("cannot restore focus for index " + this.selectedFocusIndex + ": no focus method found for data ", this.datasource[this.selectedFocusIndex]);
                return;
            }
            this.previousFocusItem = ir;
            setTimeout(()=>{
                ir.focus();
            }, 100);
        }), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "itemHeight", 60), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "overlapItems", 3), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "minItemsRenderAtOnce", 2), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "scrollMethod", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "lazyTileGridRendererWorker", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "heightIndex", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "datasourceByType", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "calculatedScreenHeight", 0), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "calculatedItemsHeight", 0), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "renderListContainers", null) //strange when defined as empty array, the variable is shared across multiple instances. why?
        , (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "datasourceTypeCount", 0), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "previousWasEmptyDataSource", false), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "datasourceIndexNormalized", null);
    }
}





const $5abb1aa7ecec12ae$export$ea0f6181e3388ffd = {
    setTitle: function(title) {
        document.title = title;
    },
    unload: function() {
        return;
    },
    init: function(page) {
        var activeElement, sectionIndex, sectionIndexCount, getFocusSection, goNext, e, isTabKey, isLeftRight, isUpDown, newActiveElement, succefullyFocused, goPrevious, e1, isTabKey1, isLeftRight1, isUpDown1, newActiveElement1, succefullyFocused1, e2;
        return;
    }
};


class $e402e2991179b868$export$b94310965bed44e6 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        super.init();
        this.pageName = "Home";
        this.version = "1.0.0";
        this.addCssClass("HomePage");
        //make sure that fresh new page always go to start screen
        //on android nly
        if (window.JSAndroidBridge && !window.firstIsPageLoaded) {
            (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
            window.firstIsPageLoaded = true;
            this.isFirstTimeBeforeLoading = true;
        } else if (!window.firstIsPageLoaded) {
            window.firstIsPageLoaded = true;
            this.isFirstTimeBeforeLoading = true;
        }
        this.enableFastScroll = true;
        //here we know if we come from the same page or another.
        //if we navigate from back history or refresh we are not from the outside.
        //if we navigate to this page from another and the referaldata is passed in the url params
        //then we are from the outside.
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.createPageLayout();
        this.coordinatoranimator = new (0, $6d761ab6ba0922eb$export$e3622d1ca33003ac)();
        this.bind("onFavoriteChanged", (e, ignoreHome)=>{
            console.log("Favorite changed => reload lists, including home=", ignoreHome);
            if (!ignoreHome) this.loadFeedAppStart(false, true, false, true);
            this.loadLive(false, true, false, true);
            this.loadToday(false, true, false, true);
        });
        this.bind("searchActivated", ()=>{});
        this.bind("searchDeactivated", ()=>{});
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
            this.wrapper2 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper2.addEventListener("message", this.wrapper2);
            this.wrapper3 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper3.addEventListener("message", this.wrapper3);
        }
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).bind("showOnlyFavoritesAgendaChanged", ()=>{
            this.reApplyDataSourceInListRenders();
        });
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).bind("userpref_matchlistTypeChanged", ()=>{
            this.reApplyDataSourceInListRenders();
        });
        setTimeout(()=>{
            (0, $dNeVp.ManiaCache).prune();
            (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).purgeNonImportant();
        }, 8000);
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).allowBackButtonQuitApp();
        if (AppInstance.isOnline()) (0, $kc8Kt.DataProvider).iamhere();
        (0, $5abb1aa7ecec12ae$export$ea0f6181e3388ffd).init(this);
    }
    onWorkerMessageReceived(e) {
        if (e.data[0] == 1) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.foundUnfilteredLiveData = e.data[2];
            (0, $dNeVp.ManiaCache).setMemoryCache("fixtureLive", e.data[1]);
            this.liveListrender.containerTarget.hideLoader();
            this.liveListrender.setDataSource(e.data[1]);
        } else if (e.data[0] == 0) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            (0, $dNeVp.ManiaCache).setMemoryCache("homeData", e.data[1]);
            this.homeListrender.containerTarget.hideLoader();
            this.homeListrender.setDataSource(e.data[1]);
        } else if (e.data[0] == 2) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            (0, $dNeVp.ManiaCache).setMemoryCache("fixtureToday", e.data[1]);
            this.todayListrender.containerTarget.hideLoader();
            this.todayListrender.setDataSource(e.data[1]);
        }
    }
    storeState() {
        if (this.unloaded || !this.tabview) return;
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "homeScrollPosition": this.homeListrender.getScroll(),
            "liveScrollPosition": this.liveListrender.getScroll(),
            "todayScrollPosition": this.todayListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isVirtuallyCollapsed
        };
        if (this.teamSelectModal) d.teamSelectModalOpen = 1;
        if (this.leagueSelectModal) d.leagueSelectModalOpen = 1;
        //console.log("store state ",d,this.coordinatoranimator.isCollapsed,this.coordinatoranimator.isVirtuallyCollapsed);
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        if (!this.ignoreStateSaveOnUnload) this.storeState();
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.liveLoadHandler);
        clearTimeout(this.todayLoadHandler);
        clearTimeout(this.homeLoadHandler);
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).unbind("showOnlyFavoritesAgendaChanged");
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).unbind("userpref_matchlistTypeChanged");
        if (AppInstance.workersInitialized) {
            AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
            AppInstance.workerHelper2.removeEventListener("message", this.wrapper2);
            AppInstance.workerHelper3.removeEventListener("message", this.wrapper3);
        }
        (0, $5abb1aa7ecec12ae$export$ea0f6181e3388ffd).unload();
    }
    getActiveListRender() {
        //console.log(this.tabview.tabs);
        //console.log(this.tabview.tabs[this.tabview.currentActiveTab].controls[0].controls[0]);
        return this.tabview.tabs[this.tabview.currentActiveTab].controls[0].controls[0];
    }
    createPageLayout() {
        var row1 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row1);
        this.contentContainer = row1;
    }
    createComponents() {
        // this.createMenuItems();
        this.getPageTemplate().hideTitle();
    }
    createMenuItems() {
        if (FootballManiaConfig.isRtl && (this.tabview.currentActiveTab == 1 || this.tabview.currentActiveTab == 0)) this.getPageTemplate().createMenuHome(true, true);
        else if (!FootballManiaConfig.isRtl && (this.tabview.currentActiveTab == 1 || this.tabview.currentActiveTab == 2)) this.getPageTemplate().createMenuHome(true, true);
        else this.getPageTemplate().createMenuHome();
        if ((0, $fRpWP.UrlManager).getModule("search") == "open") this.getPageTemplate().activateSearch();
    }
    onVisibilityChange() {
        super.onVisibilityChange();
        if (this.isDetached) {
            console.log("page is detached abort further actions");
            return;
        }
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) {
            this.autoRefreshHome(1200);
            this.autoRefreshLive(200);
            this.autoRefreshToday(500);
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
        }
        if (!document.hidden) (0, $2ee970b2529997d7$export$55185c17a0fcbe46).allowBackButtonQuitApp();
        if (document.hidden && this.homeListrender) {
            this.autoScrollToFromState(100);
            this.getPageTemplate().deActivateSearch();
            this.homeListrender.triggerEvent("requestDeActivateDrag", true);
        }
        this.previousDocumentHidden = document.hidden;
    }
    onWindowResize() {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        if (this.isDetached) {
            console.log("page is detached abort further actions");
            return;
        }
        if (this.ignoreResizeEvents) {
            console.log("page is ignoring resize events");
            return;
        }
        //this.getPageTemplate().topBar.addControl(this.i,true);
        console.log("onwindow resize");
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.homeListrender) {
            this.homeListrender.onWindowResize();
            this.liveListrender.onWindowResize();
            this.todayListrender.onWindowResize();
        }
    }
    onOffline() {
        console.log("on offline");
        this.autoRefreshHome(0);
        this.autoRefreshLive(22);
        this.autoRefreshToday(44);
        this.createMenuItems();
    }
    onOnline() {
        console.log("on online");
        this.autoRefreshHome(0);
        this.autoRefreshLive(22);
        this.autoRefreshToday(44);
        this.createMenuItems();
    }
    updateDisplay() {
        this.runApp();
    }
    autoScrollToFromState(thresshold) {
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            this.tabview.currentActiveTab = previousState.tabIndex;
            //this.tabview.moveToTab(previousState.tabIndex);
            if (previousState.homeScrollPosition < (thresshold || 50)) previousState.homeScrollPosition = 0;
            if (previousState.liveScrollPosition < (thresshold || 50)) previousState.liveScrollPosition = 0;
            if (previousState.todayScrollPosition < (thresshold || 50)) previousState.todayScrollPosition = 0;
            if (this.homeListrender) {
                this.homeListrender.scrollTo(previousState.homeScrollPosition || 0);
                this.liveListrender.scrollTo(previousState.liveScrollPosition || 0);
                this.todayListrender.scrollTo(previousState.todayScrollPosition || 0);
                this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
            }
        }
    }
    runApp() {
        this.showLoader();
        AppInstance.setup((result)=>{
            console.log("setup complete");
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", ()=>{
                    this.runApp();
                });
            }
            this.hideLoader();
            this.createTabs();
            this.tabview.bind("tabChanged", ()=>{
                this.storeState();
                this.coordinatoranimator.tabChange();
                setTimeout(()=>{
                    this.createMenuItems();
                }, 50);
                setTimeout(()=>{
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
                }, 1000);
                this.autoSetAccessiblity();
            });
            var storeHandler = null;
            this.homeListrender.bind("scroll", (e, scroll)=>{
                clearTimeout(storeHandler);
                storeHandler = setTimeout(()=>{
                    this.storeState();
                }, 200);
            });
            this.liveListrender.bind("scroll", (e, scroll)=>{
                clearTimeout(storeHandler);
                storeHandler = setTimeout(()=>{
                    this.storeState();
                }, 200);
            });
            this.todayListrender.bind("scroll", (e, scroll)=>{
                clearTimeout(storeHandler);
                storeHandler = setTimeout(()=>{
                    this.storeState();
                }, 200);
            });
            if (FootballManiaConfig.defaultHomeScreen == "comp") this.tabview.currentActiveTab = FootballManiaConfig.isRtl ? 2 : 0;
            else if (FootballManiaConfig.defaultHomeScreen == "live") this.tabview.currentActiveTab = 1;
            else if (FootballManiaConfig.defaultHomeScreen == "today") this.tabview.currentActiveTab = FootballManiaConfig.isRtl ? 0 : 2;
            this.autoScrollToFromState();
            this.contentContainer.invalidateDisplay();
            this.coordinatoranimator.prepare();
            this.coordinatoranimator.onCollapseChanged = ()=>{
                this.storeState();
            };
            this.loadFeedAppStart(false, false, false, false);
            this.loadLive(false, false, false, false);
            this.loadToday(false, false, false, false);
            this.isFirstTimeBeforeLoading = false;
            this.bind("onModalOpen", (e, modal)=>{
                console.log(modal.urlIdentifier);
                this.teamSelectModal = null;
                this.leagueSelectModal = null;
                if (modal.urlIdentifier == "teamSelectModal") this.teamSelectModal = modal;
                else if (modal.urlIdentifier == "leagueSelectModal") this.leagueSelectModal = modal;
                this.storeState();
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
            });
            this.bind("onModalClose", ()=>{
                this.teamSelectModal = null;
                this.leagueSelectModal = null;
                this.storeState();
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).allowBackButtonQuitApp();
            });
            var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
            if (previousState && previousState.teamSelectModalOpen) setTimeout(()=>{
                var urlIdentifier = "teamSelectModal";
                var modal = new (0, $96212b9eb9cf2566$export$8ca15c0f5e461723)(urlIdentifier);
                this.addControl(modal, true);
            });
            else if (previousState && previousState.leagueSelectModalOpen) setTimeout(()=>{
                var urlIdentifier = "leagueSelectModal";
                var modal = new (0, $d9cfbd126aa1f39b$export$eefd3e8e9bc8eae0)(urlIdentifier);
                this.addControl(modal, true);
            });
            this.autoSetAccessiblity();
        });
    }
    autoSetAccessiblity() {
    // if (this.tabview.currentActiveTab == 0 || (FootballManiaConfig.isRtl && this.tabview.currentActiveTab == 2)) {
    //     Accessibility.setTitle(Localizer.getString("title_home_start"));
    // } else if (this.tabview.currentActiveTab == 1) {
    //     Accessibility.setTitle(Localizer.getString("title_home_live"));
    // } else if (this.tabview.currentActiveTab == 2 || (FootballManiaConfig.isRtl && this.tabview.currentActiveTab == 0)) {
    //     Accessibility.setTitle(Localizer.getString("title_home_today"));
    // }
    }
    createTabs() {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        this.tabview = tabview;
        tabview.enableFastScroll = true;
        tabview.parallaxBg = this.bg_image;
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab1.addCssClass("listViewScrollableContainer");
        tab1.title = (0, $02mnx.Localizer).getString("start");
        var tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab2.addCssClass("listViewScrollableContainer");
        tab2.title = (0, $02mnx.Localizer).getString("live");
        var tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab3.addCssClass("listViewScrollableContainer");
        tab3.title = (0, $02mnx.Localizer).getString("todaysmatches");
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        if (FootballManiaConfig.isRtl) {
            tabs.push(tab3);
            tabs.push(tab2);
            tabs.push(tab1);
            this.coordinatoranimator.addScrollerContainer(tab3);
            this.coordinatoranimator.addScrollerContainer(tab2);
            this.coordinatoranimator.addScrollerContainer(tab1);
            this.createHome(tab1, 2);
            this.createLive(tab2, 1);
            this.createToday(tab3, 0);
            tabview.currentActiveTab = 2;
        } else {
            tabs.push(tab1);
            tabs.push(tab2);
            tabs.push(tab3);
            this.coordinatoranimator.addScrollerContainer(tab1);
            this.coordinatoranimator.addScrollerContainer(tab2);
            this.coordinatoranimator.addScrollerContainer(tab3);
            this.createHome(tab1, 0);
            this.createLive(tab2, 1);
            this.createToday(tab3, 2);
        }
        tabview.setTabs(tabs);
        tabview.bind("onReady", ()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.contentContainer.addCssClass("fadeIn").setStyle("margin-top:0;");
            this.coordinatoranimator.run();
            console.log("tab view ready", tabview.currentActiveTab);
            this.createMenuItems();
        });
        tabview.bind("swipeStart", ()=>{
            console.log("swipe start");
        });
        tabview.bind("swipeEnd", ()=>{
            console.log("swipe end");
            this.applyDelayedDataSource();
        });
        //triggered from page template
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            tab1.setCss({
                'height': '100%'
            });
            tab2.setCss({
                'height': '100%'
            });
            tab3.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
            tab2.setCss({
                'height': 'calc(100% - 50px)'
            });
            tab3.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createHome(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.enableFastScroll = true;
        listRender.containerTarget = tab;
        listRender.tabview = this.tabview;
        listRender.setItemRender(function(data) {
            if (data.type == 6) return {
                typeId: 6,
                render: new (0, $ae10f9e8e1dd758b$export$9619424689cf3891)()
            };
            if (data.type == 3) return {
                typeId: 3,
                render: new (0, $ae10f9e8e1dd758b$export$d551b010dc729342)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $ae10f9e8e1dd758b$export$1b29664009aff387)()
            };
            else if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$c4e73d64e644a882)()
            };
            else if (data.type == 4) return {
                typeId: 4,
                render: new (0, $ae10f9e8e1dd758b$export$2b8a07e4e9fbcb88)()
            };
            else if (data.type == 5) return {
                typeId: 5,
                render: new (0, $ae10f9e8e1dd758b$export$13ddad53616dbb8c)()
            };
            else if (data.type == 7) return {
                typeId: 7,
                render: new (0, $ae10f9e8e1dd758b$export$a3d5a919e7e64385)()
            };
            else if (data.type == 8) return {
                typeId: 8,
                render: new (0, $ae10f9e8e1dd758b$export$bd869f4126134c3f)()
            };
            else if (data.type == 9) return {
                typeId: 9,
                render: new (0, $ae10f9e8e1dd758b$export$b6b4d9f3ed916d30)()
            };
            else if (data.type == 10) return {
                typeId: 10,
                render: new (0, $ae10f9e8e1dd758b$export$fa8438dd333ee9d0)()
            };
            else if (data.type == 11) return {
                typeId: 11,
                render: new (0, $ae10f9e8e1dd758b$export$c2bd2f52e42e27e4)()
            };
        });
        listRender.emptyTemplate = function() {
            var empty = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            empty.addCssClass("listViewEmptyData");
            empty.addControl((0, $02mnx.Localizer).getString("no_data"));
            return empty;
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        listRender.bind("fastScrollIndicatorClicked", (e, item)=>{
        //console.log("not implemented. not needed now");
        });
        var dragHelper;
        listRender.bind("requestActivateDrag", (e, item)=>{
            console.log("long press item", item);
            dragHelper = new (0, $f16aea2f3841680e$export$a9b191a1a9582fee)();
            dragHelper.setDragItem(item);
            dragHelper.setListrender(listRender);
            dragHelper.activate();
            listRender.stopOnDatasourceChangeUpdates();
        });
        listRender.bind("requestReflowDrag", (e, item)=>{
            console.log("requestReflowDrag", item);
            var previousWasStopped = listRender.stopOnDatasourceChangeUpdatesFlag;
            listRender.continueOnDatasourceChangeUpdates();
            this.triggerEvent("onFavoriteChanged");
            setTimeout(()=>{
                if (dragHelper) dragHelper.activate();
                if (previousWasStopped) listRender.stopOnDatasourceChangeUpdates();
            }, 200);
        });
        listRender.bind("onDrag", (e, item)=>{
            this.tabview.disableSwipe();
        });
        listRender.bind("requestDeActivateDrag", (e, ignoreFavoriteChange)=>{
            this.tabview.enableSwipe();
            listRender.continueOnDatasourceChangeUpdates();
            if (dragHelper) {
                dragHelper.deactivate();
                dragHelper = null;
            }
            console.log("requestDeActivateDrag", ignoreFavoriteChange);
            if (!ignoreFavoriteChange) {
                (0, $aabc673d1ba8b527$export$db78e401119da622).cachedTeamFavorites = null;
                (0, $aabc673d1ba8b527$export$db78e401119da622).cachedLeagueFavorites = null;
                this.triggerEvent("onFavoriteChanged");
            }
        });
        listRender.bind("requestDeleteItem", (e, data)=>{
            console.log("request delete item", data);
        });
        listRender.fastScrollElementTemplate = ()=>{
            var panel = new (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)();
            var icon = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            var label = new (0, $37cbb85645b0d818$export$b04be29aa201d4f5)();
            panel.addControl(icon);
            panel.addControl(label);
            return panel;
        };
        listRender.bind('requestFastScrollIndicatorItem', (e, data)=>{
            if (!data.item) return;
            var icon = data.element.controls[0];
            var label = data.element.controls[1];
            if (data.item.type === 1) icon.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.item.country.replaceAll(" ", "-").toLowerCase() + ".png", 30, 30);
            else if (data.item.type === 4) icon.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + data.item.id + "_small_rnd.png", 30, 30);
            else icon.setImage("");
            label.setData(data.item.countryLocalized || data.item.name || data.item.title);
        });
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.homeScrollPosition || 0);
        container.addControl(listRender);
        this.homeListrender = listRender;
        tab.addControl(container);
    }
    createToday(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.enableFastScroll = true;
        //listRender.enablePullToRefresh = true;
        listRender.tabview = this.tabview;
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 2) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$c4b9b4982bf4840d)()
            };
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)(false, undefined, true)
            };
        });
        listRender.emptyTemplate = ()=>{
            var empty = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            empty.addCssClass("listViewEmptyData");
            var attention = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            attention.addCssClass("icon-attention");
            attention.setStyle("width:60px;height:60px;");
            empty.addControl(attention);
            empty.addControl("<p style='padding:5px;'>" + (0, $02mnx.Localizer).getString("currently_no_matches") + "</p>");
            let set = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda();
            if (set) empty.addControl("<div style='color:orange;margin-top:20px;margin-left:50px;margin-right:50px;' class='text-small'>" + (0, $02mnx.Localizer).getString("you_have_enabled_favorite_filter") + "</div>");
            this.coordinatoranimator.recalculateTab(index);
            //empty.addControl("<div style='margin-top:20px;' class='text-small'>"+Localizer.getString("you_have_enabled_favorite_filter")+"</div>");
            return empty;
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        listRender.bind("fastScrollIndicatorClicked", (e, item)=>{
        //console.log("not implemented. not needed now");
        });
        listRender.fastScrollElementTemplate = ()=>{
            var panel = new (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)();
            var icon = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            var label = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            panel.addControl(icon);
            panel.addControl(label);
            return panel;
        };
        listRender.bind('requestFastScrollIndicatorItem', (e, data)=>{
            if (!data.item) return;
            var icon = data.element.controls[0];
            var label = data.element.controls[1];
            icon.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.item.country.replaceAll(" ", "-").toLowerCase() + ".png", 30, 30);
            label.clear();
            label.addControl("<b>" + data.item.localizedCountry + "</b><br>" + "<p style='font-size:13px;'>" + data.item.league + "</p>", true);
        });
        listRender.bind('pullToRefreshAction', ()=>{
            this.loadToday(false, true, false, true);
        });
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.todayScrollPosition || 0);
        container.addControl(listRender);
        this.todayListrender = listRender;
        tab.addControl(container);
    }
    createLive(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var grid = new (0, $7c850b4330ee3fc0$export$c8dd51eb24f71762)();
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.enableFastScroll = true;
        listRender.tabview = this.tabview;
        //listRender.enablePullToRefresh = true;
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 2) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$c4b9b4982bf4840d)()
            };
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)(false, undefined, true)
            };
        });
        listRender.emptyTemplate = function() {
            var empty = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            empty.addCssClass("listViewEmptyData");
            var attention = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            attention.addCssClass("icon-attention");
            attention.setStyle("width:60px;height:60px;");
            empty.addControl(attention);
            empty.addControl("<p style='padding:5px;'>" + (0, $02mnx.Localizer).getString("no_live_matches") + "</p>");
            let set = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda();
            if (set) empty.addControl("<div style='color:orange;margin-top:20px;margin-left:50px;margin-right:50px;' class='text-small'>" + (0, $02mnx.Localizer).getString("you_have_enabled_favorite_filter") + "</div>");
            return empty;
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        listRender.bind("fastScrollIndicatorClicked", (e, item)=>{
        //console.log("not implemented. not needed now");
        });
        listRender.bind('pullToRefreshAction', ()=>{
            this.loadLive(false, true, false, true);
        });
        listRender.fastScrollElementTemplate = ()=>{
            var panel = new (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)();
            var icon = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            var label = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            panel.addControl(icon);
            panel.addControl(label);
            return panel;
        };
        listRender.bind('requestFastScrollIndicatorItem', (e, data)=>{
            if (!data.item) return;
            var icon = data.element.controls[0];
            var label = data.element.controls[1];
            icon.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.item.country.replaceAll(" ", "-").toLowerCase() + ".png", 30, 30);
            label.clear();
            label.addControl("<b>" + data.item.localizedCountry + "</b><br>" + "<p style='font-size:13px;'>" + data.item.league + "</p>", true);
        });
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.liveScrollPosition || 0);
        grid.setListRender(listRender);
        container.addControl(listRender);
        this.liveListrender = listRender;
        tab.addControl(container);
    }
    loadFeedAppStart(ignoreCache, dontShowLoader, isFromAutoRefresh, ignoreMemoryCache, forceWorkers) {
        if (!this.homeListrender) {
            console.error("homeListrender not set");
            return;
        }
        if (FootballManiaConfig.isRtl) var tabIndex = 2;
        else var tabIndex = 0;
        var timeout = 0;
        if (this.tabview.currentActiveTab != tabIndex) {
            forceWorkers = true;
            timeout = 700;
        }
        if (!AppInstance.workersInitialized) forceWorkers = false;
        var extraTimeout = 0;
        if (!ignoreMemoryCache && (0, $dNeVp.ManiaCache).getMemoryCache("homeData")) {
            if (this.tabview.currentActiveTab != tabIndex) {
                if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
            }
            setTimeout(()=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (this.tabview.currentActiveTab == tabIndex) {
                    console.log("use mem cache");
                    this.homeListrender.setDataSource((0, $dNeVp.ManiaCache).getMemoryCache("homeData"));
                    if (!dontShowLoader) this.tabview.tabs[tabIndex].hideLoader();
                    console.log("use mem cache complete");
                    extraTimeout = 800;
                }
                return this.autoRefreshHome(80 + extraTimeout, true);
            }, timeout);
            return;
        }
        if (document.hidden) return this.autoRefreshHome();
        //when page is already loaded then we dont load when page is hidden. but not first time, because it can happen that interstitial hides the screen first time
        if (this.firstTimeLoadingHome && document.hidden) return this.autoRefreshHome();
        this.firstTimeLoadingHome = true;
        if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
        setTimeout(()=>{
            (0, $kc8Kt.DataProvider).getAppStart((response)=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.tabview.tabs[tabIndex].hideLoader();
                    if (isFromAutoRefresh) {
                        //dont show error when i.e no internet
                        this.autoRefreshHome();
                        return;
                    }
                    var str = (0, $02mnx.Localizer).getString("nointernet") + "<br>" + (0, $02mnx.Localizer).getString("taptotryagain");
                    this.homeListrender.showError(str, ()=>{
                        this.homeListrender.hideError();
                        this.loadFeedAppStart(ignoreCache);
                    });
                    return;
                }
                var options = {
                    methodType: 4,
                    responseData: response.getData(),
                    enabledFeatures: AppInstance.getConfig().enabledFeatures,
                    fixedRegions: AppInstance.getConfig().fixedRegions,
                    favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
                    favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
                    translations: (0, $02mnx.Localizer).getLoadedLocale(),
                    locale: AppInstance.getLocale(),
                    localeFull: FootballManiaConfig.userLocaleFull,
                    userRegionLocale: FootballManiaConfig.userRegionLocale,
                    userCountry: FootballManiaConfig.detectedUserCountry,
                    defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
                    availableNewsLocales: AppInstance.getConfig().availableNewsLocales,
                    newsLocaleRemap: AppInstance.getConfig().newsLocaleRemap,
                    fontSize: FootballManiaConfig.size
                };
                console.log("options", options);
                if (!forceWorkers && !FootballManiaConfig.useWebWorkers) {
                    var list = (0, $gQQqD.Processors).prepareHomeFeedData(options);
                    var data = {
                        data: [
                            0,
                            list
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else AppInstance.workerHelper1.postMessage(options);
            }, ignoreCache);
        }, timeout);
        this.autoRefreshHome();
    }
    loadLive(ignoreCache, dontShowLoader, isFromAutoRefresh, ignoreMemoryCache, forceWorkers) {
        if (!this.liveListrender) {
            console.error("liveListrender not set");
            return;
        }
        var tabIndex = 1;
        var timeout = 0;
        if (this.tabview.currentActiveTab != tabIndex) {
            forceWorkers = true;
            timeout = 850;
        }
        if (!AppInstance.workersInitialized) forceWorkers = false;
        var extraTimeout = 0;
        if (!forceWorkers && !ignoreMemoryCache && (0, $dNeVp.ManiaCache).getMemoryCache("fixtureLive")) {
            if (this.tabview.currentActiveTab != tabIndex) {
                if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
            }
            setTimeout(()=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                //only set memory cache when we are on the live tab
                if (this.tabview.currentActiveTab == tabIndex) {
                    console.log("use mem cache");
                    this.liveListrender.setDataSource((0, $dNeVp.ManiaCache).getMemoryCache("fixtureLive"));
                    if (!dontShowLoader) this.tabview.tabs[tabIndex].hideLoader();
                    console.log("use mem cache complete");
                    extraTimeout = 100;
                }
                return this.autoRefreshLive(100 + extraTimeout, true);
            }, timeout);
            return;
        }
        //when page is already loaded then we dont load when page is hidden. but not first time, because it can happen that interstitial hides the screen first time
        if (this.firstTimeLoadingLive && document.hidden) return this.autoRefreshLive();
        this.firstTimeLoadingLive = true;
        if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
        setTimeout(()=>{
            (0, $kc8Kt.DataProvider).getLiveNow((response)=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.tabview.tabs[tabIndex].hideLoader();
                    if (isFromAutoRefresh) {
                        //dont show error when i.e no internet
                        this.autoRefreshLive();
                        return;
                    }
                    var str = (0, $02mnx.Localizer).getString("nointernet") + "<br>" + (0, $02mnx.Localizer).getString("taptotryagain");
                    this.liveListrender.showError(str, ()=>{
                        this.liveListrender.hideError();
                        this.loadLive(ignoreCache);
                    });
                    return;
                }
                this.liveListrender.loadedDatasource = response.getData();
                var options = {
                    methodType: 5,
                    responseData: response.getData(),
                    fixedRegions: AppInstance.getConfig().fixedRegions,
                    fixedLeagueOrder: AppInstance.getConfig().fixedLeaguesOrder,
                    favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
                    favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
                    translations: (0, $02mnx.Localizer).getLoadedLocale(),
                    locale: AppInstance.getLocale(),
                    enabledFeatures: AppInstance.getConfig().enabledFeatures,
                    userRegionLocale: FootballManiaConfig.userRegionLocale,
                    userCountry: FootballManiaConfig.detectedUserCountry,
                    defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
                    hiddenTitles: FootballManiaConfig.hideCountryTitleFor,
                    showOnlyFavorites: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(),
                    subscribedTeams: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(),
                    subscribedLeagues: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(),
                    subscribedMatches: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches(),
                    fontSize: FootballManiaConfig.size,
                    listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
                };
                if (!forceWorkers && !FootballManiaConfig.useWebWorkers) {
                    var list = (0, $gQQqD.Processors).prepareLiveFeedData(options);
                    var data = {
                        data: [
                            1,
                            list.listData,
                            list.foundUnfiltered
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else AppInstance.workerHelper2.postMessage(options);
            }, ignoreCache);
        }, timeout);
        this.autoRefreshLive();
    }
    loadToday(ignoreCache, dontShowLoader, isFromAutoRefresh, ignoreMemoryCache, forceWorkers) {
        if (!this.todayListrender) {
            console.error("todayListrender not set");
            return;
        }
        if (FootballManiaConfig.isRtl) var tabIndex = 0;
        else var tabIndex = 2;
        var timeout = 0;
        if (this.tabview.currentActiveTab != tabIndex) {
            forceWorkers = true;
            timeout = 1000;
        }
        if (!AppInstance.workersInitialized) forceWorkers = false;
        var extraTimeout = 0;
        if (!ignoreMemoryCache && (0, $dNeVp.ManiaCache).getMemoryCache("fixtureToday")) {
            if (this.tabview.currentActiveTab != tabIndex) {
                if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
            }
            setTimeout(()=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (this.tabview.currentActiveTab == tabIndex) {
                    this.todayListrender.setDataSource((0, $dNeVp.ManiaCache).getMemoryCache("fixtureToday"));
                    extraTimeout = 800;
                    if (!dontShowLoader) this.tabview.tabs[tabIndex].hideLoader();
                }
                return this.autoRefreshToday(80 + extraTimeout, true);
            }, timeout);
            return;
        }
        //when page is already loaded then we dont load when page is hidden. but not first time, because it can happen that interstitial hides the screen first time
        if (this.firstTimeLoadingToday && document.hidden) return this.autoRefreshToday();
        this.firstTimeLoadingToday = true;
        if (!dontShowLoader) {
            console.log("show loader");
            this.tabview.tabs[tabIndex].showLoader();
        }
        setTimeout(()=>{
            (0, $kc8Kt.DataProvider).getToday((response)=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.tabview.tabs[tabIndex].hideLoader();
                    if (isFromAutoRefresh) {
                        //dont show error when auto refreshing and i.e no internet
                        this.autoRefreshToday();
                        return;
                    }
                    var str = (0, $02mnx.Localizer).getString("nointernet") + "<br>" + (0, $02mnx.Localizer).getString("taptotryagain");
                    this.todayListrender.showError(str, ()=>{
                        this.todayListrender.hideError();
                        this.loadToday(ignoreCache);
                    });
                    return;
                }
                this.todayListrender.loadedDatasource = response.getData();
                var options = {
                    methodType: 6,
                    responseData: response.getData(),
                    fixedRegions: AppInstance.getConfig().fixedRegions,
                    fixedLeagueOrder: AppInstance.getConfig().fixedLeaguesOrder,
                    favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
                    favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
                    translations: (0, $02mnx.Localizer).getLoadedLocale(),
                    locale: AppInstance.getLocale(),
                    enabledFeatures: AppInstance.getConfig().enabledFeatures,
                    userRegionLocale: FootballManiaConfig.userRegionLocale,
                    userCountry: FootballManiaConfig.detectedUserCountry,
                    defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
                    hiddenTitles: FootballManiaConfig.hideCountryTitleFor,
                    showOnlyFavorites: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(),
                    subscribedTeams: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(),
                    subscribedLeagues: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(),
                    subscribedMatches: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches(),
                    fontSize: FootballManiaConfig.size,
                    listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
                };
                //if we dont want to use web workers
                if (!forceWorkers && !FootballManiaConfig.useWebWorkers) {
                    var list = (0, $gQQqD.Processors).prepareTodayFeedData(options);
                    var data = {
                        data: [
                            2,
                            list.listData,
                            list.foundUnfiltered
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else AppInstance.workerHelper3.postMessage(options);
            }, ignoreCache);
        }, timeout);
        this.autoRefreshToday();
    }
    applyDelayedDataSource() {
        console.log("apply delayed datasource");
        if (this.delayedHomeDataSource) {
            this.homeListrender.containerTarget.hideLoader();
            this.homeListrender.setDataSource(this.delayedHomeDataSource);
            this.delayedHomeDataSource = null;
        }
        if (this.delayedLiveDataSource) {
            this.liveListrender.containerTarget.hideLoader();
            this.liveListrender.setDataSource(this.delayedLiveDataSource);
            this.delayedLiveDataSource = null;
        }
        if (this.delayedTodayDataSource) {
            this.todayListrender.containerTarget.hideLoader();
            this.todayListrender.setDataSource(this.delayedTodayDataSource);
            this.delayedTodayDataSource = null;
        }
    }
    /**
     * call this when you want to set datasource in listrender again
     * for example after you enabled filter. worker is using filter data
     */ reApplyDataSourceInListRenders() {
        console.log("reapply datasource in listrender");
        var listRender = this.liveListrender;
        if (!listRender.loadedDatasource) {
            console.warn("no datasource in listrender");
            return;
        }
        listRender.scrollTo(0);
        var options = {
            methodType: 5,
            responseData: listRender.loadedDatasource,
            enabledFeatures: AppInstance.getConfig().enabledFeatures,
            fixedRegions: AppInstance.getConfig().fixedRegions,
            fixedLeagueOrder: AppInstance.getConfig().fixedLeaguesOrder,
            favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
            favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
            translations: (0, $02mnx.Localizer).getLoadedLocale(),
            locale: AppInstance.getLocale(),
            userRegionLocale: FootballManiaConfig.userRegionLocale,
            userCountry: FootballManiaConfig.detectedUserCountry,
            defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
            hiddenTitles: FootballManiaConfig.hideCountryTitleFor,
            showOnlyFavorites: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(),
            subscribedTeams: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(),
            subscribedLeagues: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(),
            subscribedMatches: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches(),
            fontSize: FootballManiaConfig.size,
            listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
        };
        AppInstance.workerHelper2.postMessage(options);
        var listRender = this.todayListrender;
        if (!listRender.loadedDatasource) {
            console.warn("no datasource in listrender");
            return;
        }
        listRender.scrollTo(0);
        options = {
            methodType: 6,
            responseData: listRender.loadedDatasource,
            fixedRegions: AppInstance.getConfig().fixedRegions,
            fixedLeagueOrder: AppInstance.getConfig().fixedLeaguesOrder,
            favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
            favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
            translations: (0, $02mnx.Localizer).getLoadedLocale(),
            locale: AppInstance.getLocale(),
            enabledFeatures: AppInstance.getConfig().enabledFeatures,
            userRegionLocale: FootballManiaConfig.userRegionLocale,
            userCountry: FootballManiaConfig.detectedUserCountry,
            defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
            hiddenTitles: FootballManiaConfig.hideCountryTitleFor,
            showOnlyFavorites: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(),
            subscribedTeams: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(),
            subscribedLeagues: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(),
            subscribedMatches: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches(),
            fontSize: FootballManiaConfig.size,
            listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
        };
        AppInstance.workerHelper3.postMessage(options);
    }
    autoRefreshHome(overrideInterval, forceWorkers) {
        clearTimeout(this.homeLoadHandler);
        this.homeLoadHandler = setTimeout(()=>{
            (0, $dNeVp.ManiaCache).deleteMemoryCache("homeData");
            this.loadFeedAppStart(true, true, true, true, forceWorkers);
        }, overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.home);
    }
    autoRefreshToday(overrideInterval, forceWorkers) {
        clearTimeout(this.todayLoadHandler);
        this.todayLoadHandler = setTimeout(()=>{
            (0, $dNeVp.ManiaCache).deleteMemoryCache("fixtureToday");
            this.loadToday(true, true, true, true, forceWorkers);
        }, overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.today);
    }
    autoRefreshLive(overrideInterval, forceWorkers) {
        clearTimeout(this.liveLoadHandler);
        this.liveLoadHandler = setTimeout(()=>{
            (0, $dNeVp.ManiaCache).deleteMemoryCache("fixtureLive");
            this.loadLive(true, true, true, true, forceWorkers);
        }, overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.live);
    }
    constructor(...args){
        super(...args), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "homeLoadHandler", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "liveLoadHandler", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "todayLoadHandler", null);
    }
}






var $fRpWP = parcelRequire("fRpWP");




var $02mnx = parcelRequire("02mnx");
//this control runs in combination with collapser (topbar) and tabiew
// when target scroller scrolls down it collapses the topbar and tabview scrollerContainers.
const $23ab1716e6aced69$export$bd2148639dcb5f7e = function() {
    var version = "1.0";
    var scrollerContainers = [];
    var scrollerMethods = [];
    var touchStartMethod = null;
    var touchEndMethod = null;
    var collapser = null;
    var tabview = null;
    var ignoreEvents = false;
    var ignoreEventForIndex = [];
    var lastListIndexScrolling = -1;
    var unloaded = false;
    this.isTouching = false;
    this.reducerRatio = 0.5;
    this.transitionDuration = 100;
    this.alwaysCollapseOnBackScrolling = true;
    this.isCollapsed = false;
    this.lastRecalculateWasCollapsed = null;
    this.isVirtuallyCollapsed = false;
    this.lastScrollPositionAfterTouchStart = -1;
    this.lastYOffsetAfterTouchStart = 0;
    this.currentTranslateY = 0;
    this.currentActiveTab = -1;
    this.addScrollerContainer = function(tab) {
        scrollerContainers.push(tab);
    };
    this.addCollapser = function(c) {
        collapser = c;
    };
    this.addTabView = function(tab) {
        tabview = tab;
    };
    this.unload = function() {
        unloaded = true;
        if (collapser) collapser.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        }) //reset
        ;
        if (scrollerContainers) for(var i = 0; i < scrollerContainers.length; i++){
            var scrollEl = jQuery("#" + scrollerContainers[i].getClientId());
            if (scrollerMethods[i]) scrollEl.off("scroll", scrollerMethods[i]);
        }
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        collapser = null;
        scrollerContainers = null;
    };
    this.onWindowResize = function() {
        this.recalculate(true);
    };
    this.tabChange = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        if (this.currentActiveTab == -1) this.currentActiveTab = tabview.currentActiveTab;
        var delay = 300;
        var that = this;
        $("#" + collapser.getClientId()).css({
            "transform": "translate(0px,0px)",
            "transition-duration": delay + "ms"
        });
        $("#" + tabview.tabHolder.getClientId()).css({
            "transform": "translate(0px,0px)",
            "transition-duration": delay + "ms"
        });
        this.currentTranslateY = 0;
        this.isVirtuallyCollapsed = false; //set this to false, because we set all scroll positions to 0 so everything becomes decollapsed
        this.isCollapsed = false;
        setTimeout(function() {
            //that.currentTranslateY = 0;
            that.recalculate();
        }, delay);
        for(var i = 0; i < scrollerContainers.length; i++){
            if (i == tabview.currentActiveTab) continue;
            ignoreEvents = true;
            if (ignoreEventForIndex.indexOf(i) == -1) ignoreEventForIndex.push(i);
            (function(i) {
                setTimeout(function() {
                    var scrollElement = scrollerContainers[i];
                    var lazygrid = scrollElement.controls[0].controls[0];
                    if (lazygrid && lazygrid.scrollToLastSelectedOrTop) lazygrid.scrollToLastSelectedOrTop();
                    else document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                        top: 0,
                        left: 0
                    });
                }, 180);
            })(i);
            ignoreEvents = false;
        }
        that.currentActiveTab = tabview.currentActiveTab;
    };
    this.recalculateTab = function(i) {
        if (!FootballManiaConfig.graphics.animations) return;
        if (!scrollerContainers || !scrollerContainers[i]) {
            console.warn("cannot recalcuate without tabs");
            return;
        }
        if (!tabview.tabContents || !tabview.tabContents.controls[i] || !tabview.tabContents.controls[i].controls[0]) {
            console.warn("cannot recalcuate without tabview elements");
            return;
        }
        var contentWindowHeight = tabview.tabContents.getDimensions().height;
        if (collapser) var collapserHeight = collapser.getDimensions().height;
        var scrollEl = jQuery("#" + scrollerContainers[i].getClientId());
        var top = collapserHeight;
        if (!scrollEl || !scrollEl[0]) {
            console.warn("no scroller");
            return;
        }
        console.log("RECALCULATE TAB ", i, scrollEl[0].scrollHeight, contentWindowHeight, collapserHeight);
        //when scrolllist is longer than the window (we can acualy scroll)
        if (scrollEl[0].scrollHeight > contentWindowHeight) {
            //$("#" + tabview.tabContents.controls[i].getClientId()).css({"top": "-" +top+"px"});
            $("#" + scrollerContainers[i].parent.getClientId()).css({
                "top": "-" + top + "px"
            });
            $("#" + scrollerContainers[i].parent.getClientId()).css({
                "height": contentWindowHeight + collapserHeight + "px"
            });
            ///$("#" + tabview.tabContents.controls[i].getClientId()).css({"height": contentWindowHeight + collapserHeight + "px"});
            $("#" + scrollerContainers[i].controls[0].getClientId()).css({
                "position": "relative",
                "top": top + "px",
                "height": contentWindowHeight + collapserHeight + "px"
            });
            //}
            $("#" + tabview.tabContents.controls[i].controls[0].getClientId()).css({
                "height": contentWindowHeight + collapserHeight + "px"
            });
        //enlarge the scrollbar
        } else {
            //console.log("no nonon ono no");
            //console.log("tab ",i,' content is not needed for scroll',contentWindowHeight)
            if (this.isCollapsed) ;
            else {
                //$("#" + tabview.tabContents.controls[i].getClientId()).css({"transform":"translate(0px,0px)","transition-duration": "100ms"})
                $("#" + scrollerContainers[i].parent.getClientId()).css({
                    "top": "0px"
                });
                $("#" + scrollerContainers[i].parent.getClientId()).css({
                    "height": contentWindowHeight + "px"
                });
                if (scrollEl.scrollTop() == 0) $("#" + scrollerContainers[i].controls[0].getClientId()).css({
                    "position": "absolute",
                    "top": "0px"
                });
            }
        }
    };
    this.recalculate = function(force, onlyTabIndex) {
        if (!FootballManiaConfig.graphics.animations) return;
        if (!tabview) {
            console.log("cannot recalculate without tabview");
            return;
        }
        console.log("RECALCULATE POSITIONS", tabview.currentActiveTab, "isCollapsed", this.isCollapsed);
        if (!force && this.lastRecalculateWasCollapsed != null && this.isCollapsed == this.lastRecalculateWasCollapsed) {
            console.log("dont repeat calculation");
            return;
        }
        this.lastRecalculateWasCollapsed = this.isCollapsed;
        var collapserHeight = collapser.getDimensions().height;
        if (this.isCollapsed) {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
        }
        for(var i = 0; i < scrollerContainers.length; i++)this.recalculateTab(i);
    };
    this.autoCollapseOrOpen = function(scrollPosition) {
        if (this.currentTranslateY == 0) {
            this.isCollapsed = false;
            this.isVirtuallyCollapsed = false;
        } else if (this.currentTranslateY == -collapser.getDimensions().height) {
            this.isCollapsed = true;
            this.isVirtuallyCollapsed = true;
        }
        if (this.currentTranslateY == 0 || this.currentTranslateY == -collapser.getDimensions().height) //console.log("no auto collapse when already open or closed",this.currentTranslateY);
        //this.recalculate();
        return;
        console.log("AUTO COLLAPSE", this.currentTranslateY);
        var collapserHeight = collapser.getDimensions().height;
        var that = this;
        var delay = 200;
        if (scrollPosition > collapserHeight * (1 / this.reducerRatio) / 2) {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": delay + "ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": delay + "ms"
            });
            console.log(this.isTouching, "auto collapser scroll position = ", scrollPosition, this.currentTranslateY);
            that.currentTranslateY = -collapserHeight;
            this.isCollapsed = true;
            clearTimeout(this.tempTimeout);
            this.tempTimeout = setTimeout(function() {
                that.currentTranslateY = -collapserHeight;
                that.recalculate();
            }, delay);
        } else {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px,0px)",
                "transition-duration": delay + "ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px,0px)",
                "transition-duration": delay + "ms"
            });
            console.log(this.isTouching, "auto collapser scroll position = ", scrollPosition);
            that.currentTranslateY = 0;
            this.isCollapsed = false;
            clearTimeout(this.tempTimeout);
            this.tempTimeout = setTimeout(function() {
                //that.currentTranslateY = 0;
                that.recalculate();
            }, delay);
        }
    };
    this.prepare = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        var collapserHeight = collapser.getDimensions().height;
        this.isVirtuallyCollapsed = false;
        console.log("prepare collapsed", this.isCollapsed);
        //make sure we start with a collapsed one before everything gets rendered. causes flickering
        if (this.isCollapsed) {
            this.isVirtuallyCollapsed = true;
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
        }
    };
    this.run = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        console.log("RUN ANIMATOR FOR LEAGUESCREEN " + version);
        lastListIndexScrolling = tabview.currentActiveTab;
        this.recalculate();
        var that = this;
        var timeoutHandler = null;
        var timeoutHandler2 = null;
        touchStartMethod = function(e) {
            clearTimeout(timeoutHandler2);
            clearTimeout(timeoutHandler);
            clearTimeout(that.tempTimeout);
            var scrollElement = scrollerContainers[tabview.currentActiveTab];
            that.isTouching = true;
            if (!scrollElement) {
                console.error("no scroll element found");
                return;
            }
            var topOffset = document.querySelector("#" + scrollElement.getClientId()).scrollTop;
            that.lastScrollPositionAfterTouchStart = topOffset;
            that.lastYOffsetAfterTouchStart = that.currentTranslateY;
        };
        touchEndMethod = function() {
            that.isTouching = false;
        };
        $('body').on({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        function runTabSCrollLogic(index) {
            var scrollEl = jQuery("#" + scrollerContainers[index].getClientId());
            var prevScroll = null;
            var ticking = false;
            var scrollDiff;
            scrollerMethods[index] = function(e) {
                clearTimeout(timeoutHandler2);
                clearTimeout(timeoutHandler);
                if (ticking) return;
                window.requestAnimationFrame(function() {
                    ticking = true;
                    if (ignoreEvents || index != tabview.currentActiveTab) {
                        console.log("ignore scroll event if not this active tab ", index);
                        ticking = false;
                        return;
                    }
                    if (ignoreEventForIndex.indexOf(index) != -1) {
                        console.log("ignore scroll event this time", index, ignoreEventForIndex);
                        //ignoreEventForIndex = -1;
                        ignoreEventForIndex.splice(ignoreEventForIndex.indexOf(index), 1);
                        ticking = false;
                        return;
                    }
                    var topOffset = e.originalEvent.target.scrollTop;
                    if (prevScroll == topOffset) {
                        ticking = false;
                        // console.log("do nothing no scroll change");
                        return;
                    }
                    lastListIndexScrolling = index;
                    clearTimeout(timeoutHandler2);
                    timeoutHandler2 = setTimeout(function() {
                        clearTimeout(timeoutHandler);
                        var topOffset = e.originalEvent.target.scrollTop;
                        if (!that.isTouching) {
                            that.lastScrollPositionAfterTouchStart = topOffset;
                            that.autoCollapseOrOpen(topOffset);
                        }
                    }, 50);
                    var topOffset = e.originalEvent.target.scrollTop;
                    var collapserHeight = collapser.getDimensions().height;
                    if (!that.alwaysCollapseOnBackScrolling) scrollDiff = Math.max(-topOffset, -collapserHeight);
                    else {
                        if (that.isCollapsed && that.isVirtuallyCollapsed) {
                            var t = (that.lastScrollPositionAfterTouchStart - topOffset) * that.reducerRatio - collapserHeight;
                            scrollDiff = Math.max(-collapserHeight, Math.min(0, t));
                        } else if (that.lastScrollPositionAfterTouchStart != -1) {
                            var t = (that.lastScrollPositionAfterTouchStart - topOffset) * that.reducerRatio + that.lastYOffsetAfterTouchStart;
                            scrollDiff = Math.min(0, Math.max(-collapserHeight, t));
                        } else //first time otherwise we always have collapsed after startng
                        scrollDiff = 0;
                    }
                    that.currentTranslateY = scrollDiff;
                    if (scrollDiff == -collapserHeight) that.isVirtuallyCollapsed = true;
                    else that.isVirtuallyCollapsed = false;
                    //collapser.setCss({"transform":"translate(0px,"+scrollDiff+"px)","transition-duration": this.transitionDuration+"ms"});
                    collapser.setCss({
                        "transform": "translate(0px," + scrollDiff + "px)",
                        "transition-duration": that.transitionDuration + "ms"
                    });
                    //tabview.tabHolder.setCss({"transform":"translate(0px,"+scrollDiff+"px)","transition-duration": this.transitionDuration+"100ms"});
                    tabview.tabHolder.setCss({
                        "transform": "translate(0px," + scrollDiff + "px)",
                        "transition-duration": that.transitionDuration + "ms"
                    });
                    prevScroll = e.originalEvent.target.scrollTop;
                    ticking = false;
                // });
                //
                });
            };
            if (scrollerMethods[index]) scrollEl.off("scroll", scrollerMethods[index]);
            scrollEl.scroll(scrollerMethods[index]);
        }
        for(var i = 0; i < scrollerContainers.length; i++)runTabSCrollLogic(i);
    };
};



var $kc8Kt = parcelRequire("kc8Kt");







class $761fc09f912370da$export$5f18642dbcedb9ce extends (0, $caa85a5b251985fa$export$19f5a358c10e8419) {
    init() {
        super.init();
        this.addCssClass("BDataGridTileListRender");
        this.defaultContentItemRender = (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f);
    }
    createComponents() {
        super.createComponents();
        //when we know the tabview we can know when user swipes and apply data when user is finished swiping
        if (this.tabview) {
            this.swipeStartMethod = (e)=>{
                this.isSwiping = true;
            };
            //
            this.swipeEndMethod = (e)=>{
                this.isSwiping = false;
                if (this.callSetDataSourceLater) {
                    var ds = this.callSetDataSourceLater;
                    this.callSetDataSourceLater = null;
                    this.setDataSource(ds);
                }
            };
            //prevent the data to load when touching. usually when scrolling.
            //it creates an annoying flicker. on touch up we apply the data
            $(this.tabview).on('swipeStart', this.swipeStartMethod);
            $(this.tabview).on('swipeEnd ', this.swipeEndMethod);
        } else console.warn("no tabview found, so no swipe events can be detected. please add it for better user experience");
    }
    unload() {
        var scrollEl = jQuery("#" + this.containerTarget.getClientId());
        if (this.tabview) {
            $(this.tabview).off('swipeStart', this.swipeStartMethod);
            $(this.tabview).off('swipeEnd ', this.swipeEndMethod);
        }
        scrollEl.off("scroll", this.scrollMethod); //what if others listen to this event
        this.indexTilePlaceHolderMap = null;
        this.datasourceByType = null;
    }
    setDataSource(ds, allowFlicker) {
        if (this.isSwiping) {
            console.warn("user is swiping, so we dont apply the data now, but later when user is finished swiping");
            this.callSetDataSourceLater = ds;
            return;
        }
        if (!this.datasource) {
            this.datasource = ds; //we dont need to clone this, cause do we change and save the datasource?
            this.clear();
            //this.createItems();
            this.createControls();
            this.invalidateDisplay();
            //this.triggerEvent('onSetDataSource');
            return this;
        } else {
            this.datasource = ds;
            var scroll = this.getScroll();
            this.createItems(allowFlicker);
            this.scrollTo(scroll);
        }
    }
    getDefaultItemRender() {
        return this.defaultContentItemRender;
    }
    setItemRender(render) {
        this.defaultContentItemRender = render;
        this.triggerEvent('itemRenderChanged');
    }
    createControls() {
        super.createControls();
        this.mainContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //this.mainContainer.addCssClass("listViewMainContainer");
        //this.mainContainer.addCssClass("listViewMainContainer")
        if (this.activateScrolling) {
            this.mainContainer.addCssClass("scrollerNoOverscroll");
            this.mainContainer.setStyle("overflow-y:scroll;position:absolute;top:0px;left:0px;right:0px;bottom:0px;");
        }
        this.addControl(this.mainContainer);
    }
    onWindowResize() {
        console.error("onWindowResize not implemented");
        var delay, scroll;
        // setTimeout(()=>{
        //     this.scrollTo(9999999);
        // },2000)
        return;
    }
    updateDisplay() {
        if (!this.datasource) return;
        this.createItems(true);
    }
    scrollTo(y) {
        if (this.containerTarget.getParent()) {
            //console.log("really scroll to man",y,this.containerTarget.getClientId());
            this.scrollLater = y;
            return this.getScrollElement().scrollTop(y);
        }
        this.scrollLater = y;
    }
    getScroll() {
        var scroll = this.getScrollElement();
        if (scroll) return scroll.scrollTop();
        else {
            console.error("no scroll element return 0");
            return 0;
        }
    }
    getScrollElement() {
        if (this.activateScrolling) {
            if (!this.mainContainer) return null;
            return jQuery("#" + this.mainContainer.getClientId());
        }
        return jQuery("#" + this.containerTarget.getClientId());
    }
    autoMove() {
        var requireRerender;
        if (!this.datasource.length) return;
        this.indexTilePlaceHolderMap = [];
        this.indexRenderedItemRenderMap = [];
        var scrollTop;
        for(var i = 0; i < this.datasource.length; i++)if (!this.indexTilePlaceHolderMap[i]) {
            this.createDivPlaceHolder(i, false);
            this.createItemRenderByIndex(i, this.datasource[i], false);
            requireRerender = true;
        }
        var scrollEl = this.getScrollElement();
        this.scrollMethod = ()=>{
            var ticking = false;
            if (!ticking) window.requestAnimationFrame(()=>{
                scrollTop = scrollEl.scrollTop();
                this.triggerEvent("scroll", scrollTop);
                ticking = false;
            });
            ticking = true;
        };
        if (this.scrollMethod) scrollEl.off("scroll", this.scrollMethod);
        //scrollEl.off("scroll");
        scrollEl.scroll(this.scrollMethod);
    }
    createItems(allowFlickerBetweenRender) {
        if (!this.datasource || !this.datasource.length) {
            this.mainContainer.clear();
            if (this.emptyTemplate) {
                var control = this.emptyTemplate();
                // this.mainContainer.setCss({'height':"100%"})
                this.mainContainer.addControl(control);
                this.mainContainer.invalidateDisplay();
                this.previousWasEmptyDataSource = true;
            }
            return;
        }
        this.calculatedScreenHeight = 0;
        this.calculatedItemsHeight = 0;
        if (this.previousWasEmptyDataSource) {
            this.mainContainer.clear();
            this.previousWasEmptyDataSource = false;
        }
        if (!this.renderListContainers) this.renderListContainers = [];
        var renderListContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        renderListContainer.addCssClass("maincontainer2");
        ///we do some optimization here to prevent flickering whne new list items
        ///are created. we create a container which we render hidden, we wait
        //for x ms and then simultanously hide and show the old and new one.
        if (this.renderListContainers.length) //console.log("we have a previous render",this.renderListContainers.length);
        //renderListContainer.setVisible(false);
        renderListContainer.setCss({
            "display": "none"
        });
        this.renderListContainers.push(renderListContainer);
        var dimensions = this.getDimensions();
        this.calculatedScreenHeight = dimensions.height;
        // console.log("set height of container ",this.calculatedScreenHeight)
        ///TODO: this might have performance issues. better to add dummy item at the end
        //this.mainContainer.setCss({'height':this.calculatedScreenHeight+"px"});
        this.mainContainer.addControl(renderListContainer, true);
        // console.log("max items to render ",this.maxItemsToRender)
        this.autoMove();
        renderListContainer.invalidateDisplay();
        //renderListContainer.setVisible("false");
        var delay = 300;
        if (allowFlickerBetweenRender) delay = 0;
        //console.log("renderlist container length",this.renderListContainers.length);
        clearTimeout(this.rerenderTimeoutHandler);
        if (this.renderListContainers.length > 1) this.rerenderTimeoutHandler = setTimeout(()=>{
            if (this.renderListContainers.length > 1) {
                this.renderListContainers[this.renderListContainers.length - 1].setCss({
                    "display": ""
                });
                for(var i = 0; i < this.renderListContainers.length - 1; i++)//console.log("remove list container ",i)
                this.getPage().removeControl(this.renderListContainers[i]);
                //this.renderListContainers[1].setCss({"display": ""});
                this.renderListContainers = [];
                this.renderListContainers.push(renderListContainer);
            }
            this.triggerEvent("createdList");
        //this.scrollTo(this.scrollLater);
        }, delay);
        else {
            this.triggerEvent("createdList");
            //console.log("Scrol later",this.scrollLater);
            this.scrollTo(this.scrollLater);
        }
    }
    createDivPlaceHolder(index, instantRender) {
        //console.log("create div placeholder ",index,this.renderListContainers[this.renderListContainers.length-1].getClientId());
        var tileplaceholder = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tileplaceholder.addCssClass("BDataGridTilePlaceHolder");
        if (this.placeHolderWidth) tileplaceholder.setCss({
            width: this.placeHolderWidth
        });
        this.renderListContainers[this.renderListContainers.length - 1].addControl(tileplaceholder, instantRender);
        if (!this.indexTilePlaceHolderMap) this.indexTilePlaceHolderMap = [];
        this.indexTilePlaceHolderMap[index] = tileplaceholder;
    }
    setPlaceHolderWidth(width) {
        this.placeHolderWidth = width;
    }
    createItemRenderByIndex(index, data, instantRerender) {
        //console.log("create item render ",index)
        var itemRenderFactory = this.defaultContentItemRender;
        var itemRender = itemRenderFactory(data).render;
        //console.log(itemRender);
        //data.index = index;
        this.indexRenderedItemRenderMap[index] = itemRender;
        //itemRender.setData(data,true); //no instant render needed
        itemRender.setData(data, false); //no instant render needed
        itemRender.setListRender(this);
        this.indexTilePlaceHolderMap[index].clear();
        this.indexTilePlaceHolderMap[index].addControl(itemRender, instantRerender);
    }
    onRowMouseOver(e) {}
    onRowMouseOut(e) {}
    onRowMouseClick(e) {}
    selectIndex(index) {}
    deSelectIndex(index) {}
    constructor(...args){
        super(...args), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "itemHeight", 60), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "overlapItems", 3), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "minItemsRenderAtOnce", 2), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "scrollMethod", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "datasourceByType", null), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "renderListContainers", null), //strange when defined as empty array, the variable is shared across multiple instances. why?
        (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "datasourceTypeCount", 0), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "previousWasEmptyDataSource", false);
    }
}



class $d1f65a756ab5ad7f$export$aec6fe3795564851 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        super.init();
        this.setStyle("height:100%");
        this.addCssClass("NewsPage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $23ab1716e6aced69$export$bd2148639dcb5f7e)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
        }
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).bind("userpref_newslocaleChanged", this.getProxy(function(e, locale) {
            this.reloadNews(locale);
        }));
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        this.tabview.tabs[0].hideLoader();
        this.newsListrender.setDataSource(e.data);
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "newsScrollPosition": this.newsListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        console.log("store state", d);
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.newsLoadHandler);
        (0, $fRpWP.UrlManager).unlistenModule('cid');
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).unbind("userpref_newslocaleChanged");
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        this.previousDocumentHidden = !document.hidden;
        this.previousDocumentHidden = document.hidden;
    //console.log("visibility change ",document.hidden,this);
    }
    createPageLayout() {
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().showTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.newsListrender) this.newsListrender.onWindowResize();
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        this.createTitle();
        this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", this.getProxy(function() {
                    this.runApp();
                }));
            }
            var locale = AppInstance.getConfig().userLocale;
            if (AppInstance.getConfig().userLocaleFull && AppInstance.getConfig().availableNewsLocales.indexOf(AppInstance.getConfig().userLocaleFull) != -1) locale = AppInstance.getConfig().userLocaleFull;
            //locale = "es";
            (0, $kc8Kt.DataProvider).getNews(locale, this.getProxy(function(response) {
                this.hideLoader();
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                        this.runApp();
                    }));
                    else return this.showError("", this.getProxy(function() {
                        this.runApp();
                    }));
                }
                var data = response.getData();
                this.createTabs(data);
                this.getPageTemplate().createMenuNews(response.getData());
                this.tabview.bind("tabChanged", this.getProxy(function() {
                    this.storeState();
                    this.coordinatoranimator.tabChange();
                }));
                var storeHandler = null;
                this.newsListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 100);
                }));
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                if (previousState) {
                    this.tabview.currentActiveTab = previousState.tabIndex;
                    this.newsListrender.scrollTo(previousState.newsScrollPosition || 0);
                    console.log("restored scroll ", previousState.newsScrollPosition);
                    this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                }
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.prepare();
                this.loadNews(data);
            }), true);
        }));
    }
    createTitle() {
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.setStyle("width:28px;");
        //image.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/flags/"+country.replaceAll(" ","-").toLowerCase()+".png");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("news"));
        //this.getPageTemplate().topTitleContainer.addControl(image);
        //this.getPageTemplate().topTitleContainer.addControl(title);
        this.getPageTemplate().topTitleContainer.invalidateDisplay();
        this.getPageTemplate().topTitleContainer.setVisible(false);
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab1.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab1.title = (0, $02mnx.Localizer).getString("news");
        tabs.push(tab1);
        this.createNewsControls(tab1, 0);
        this.coordinatoranimator.addScrollerContainer(tab1);
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", this.getProxy(function() {
            this.coordinatoranimator.run();
        }));
        this.tabview = tabview;
        tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createNewsControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$62763c6558b56e7c)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            console.log("restore scroll #2 : ", previousState.newsScrollPosition);
            listRender.scrollTo(previousState.newsScrollPosition || 0);
        }
        container.addControl(listRender);
        this.newsListrender = listRender;
        tab.addControl(container);
    }
    reloadNews(locale) {
        this.tabview.tabs[0].showLoader();
        (0, $kc8Kt.DataProvider).getNews(locale, this.getProxy(function(response) {
            this.hideLoader();
            console.log(response.getData());
            var data = response.getData();
            for(var i = 0; i < data.items.length; i++)data.items[i].type = 1;
            this.tabview.tabs[0].hideLoader();
            this.newsListrender.setDataSource(data.items);
        }));
    }
    loadNews(data, ignoreCache) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        for(var i = 0; i < data.items.length; i++)data.items[i].type = 1;
        this.tabview.tabs[0].hideLoader();
        this.newsListrender.setDataSource(data.items);
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
    }
    constructor(...args){
        super(...args), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "pageName", "News"), (0, $09f8d0da92f63b44$export$71511d61b312f219)(this, "version", 1);
    }
}




class $51908c82e41b0e01$export$10e6f4f66014ee2d extends (0, $2cf92be5dbbab152$export$574966fbea4a65e5) {
    /**
	 * Creates a textbox.
	 * 
	 * Example:
	 * 
	   var textbox = new Banana.Controls.TextBox()
	   this.addControl(textbox); //add to collection
	   
	   textbox.setData("some text");
	   
	   textbox.bind("dataChanged",function(){
	   		//do something here
	   });
	   
	   
	 * @constructs
	 * @extends Banana.Controls.InputControl
	 */ init() {
        this.data = "";
        super.init();
        this.setAttribute('type', 'text');
        this.addCssClass('BTextbox');
        this.bind('keyup', this.getProxy(this.onChange));
        this.bind('keypress', function(event) {
            return event.keyCode != 13;
        });
    }
}



var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $dNeVp = parcelRequire("dNeVp");

var $9yWe2 = parcelRequire("9yWe2");

//this control runs in combination with collapser (topbar) and tabiew
// when target scroller scrolls down it collapses the topbar and tabview scollers.
const $aeae458d1e4856c5$export$5be7f7356c27f222 = function() {
    var version = "1.0";
    var scollers = [];
    var scrollerMethods = [];
    var touchStartMethod = null;
    var touchEndMethod = null;
    var collapser = null;
    var tabview = null;
    var topbar = null;
    var ignoreEvents = false;
    var ignoreEventForIndex = [];
    var lastListIndexScrolling = -1;
    var unloaded = false;
    var touchEndTimeoutHandler = null;
    var scrollReleaseTimeoutHandler = null;
    this.matchStatus; //we use this for collapser differnt ways
    this.isTouching = false;
    this.reducerRatio = 0.3;
    this.transitionDuration = 100;
    this.alwaysCollapseOnBackScrolling = true;
    this.isCollapsed = false;
    this.lastRecalculateWasCollapsed = null;
    this.isVirtuallyCollapsed = false;
    this.lastScrollPositionAfterTouchStart = 0;
    this.lastYOffsetAfterTouchStart = 0;
    this.currentTranslateY = 0;
    this.currentActiveTab = -1;
    this.shrinkType = 1;
    this.scrollerBottomMargin = [];
    this.addScrollerContainer = function(tab) {
        if (scollers) scollers.push(tab);
        else console.warn("cannot add, no scroll container found");
    };
    this.getScrollerContainer = function(i) {
        return scollers[i];
    };
    this.setScrollerBottomMargin = function(i, margin) {
        this.scrollerBottomMargin[i] = margin;
    };
    this.addCollapser = function(c) {
        collapser = c;
    };
    this.addTopBar = function(tb) {
        topbar = tb;
    };
    this.addTabView = function(tab) {
        tabview = tab;
    };
    this.unload = function() {
        unloaded = true;
        if (topbar) topbar.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        if (collapser) collapser.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        if (scollers) for(var i = 0; i < scollers.length; i++){
            var scrollEl = jQuery("#" + scollers[i].getClientId());
            if (scrollerMethods[i]) scrollEl.off("scroll", scrollerMethods[i]);
        }
        scrollerMethods = null;
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        collapser = null;
        scollers = null;
        topbar = null;
    };
    this.onWindowResize = function() {
        this.recalculate(true);
    };
    this.allowEvent = function(i) {
        ignoreEvents = false;
        ignoreEventForIndex = [];
    };
    this.tabChange = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        if (this.currentActiveTab == -1) {
            console.log("nononono");
            this.currentActiveTab = tabview.currentActiveTab;
        //return;
        }
        var collaped = this.isCollapsed;
        var virtuallyCollapsed = this.isVirtuallyCollapsed;
        // if (this.isVirtuallyCollapsed){
        //     this.isCollapsed = true;
        // }
        ignoreEventForIndex.splice(ignoreEventForIndex.indexOf(tabview.currentActiveTab), 1);
        console.log(tabview.currentActiveTab, "TAB CHANGE ", collaped, virtuallyCollapsed);
        if (collapser) var collapserHeight = collapser.getDimensions().height;
        //console.log("RECALCULATE TAB ",i,scrollEl[0].scrollHeight,contentWindowHeight,collapserHeight)
        var height = collapserHeight;
        console.log("scroll top ", $("#" + scollers[tabview.currentActiveTab].getClientId()).scrollTop());
        if (!$("#" + scollers[tabview.currentActiveTab].getClientId()).isVScrollable()) {
            console.log("no scrollable content. so expand header");
            this.expandHeader();
            virtuallyCollapsed = false; //this is needed to make sure other tabs which are scrolled to zero have the also the scroll to zero
        }
        if (virtuallyCollapsed) this.colapseHeader();
        for(var i = 0; i < scollers.length; i++){
            if (i == tabview.currentActiveTab) continue;
            ignoreEvents = true;
            if (ignoreEventForIndex.indexOf(i) == -1) ignoreEventForIndex.push(i);
            this.recalculate();
            clearTimeout(scrollReleaseTimeoutHandler); //otherwise during scrolling other events will clash
            clearTimeout(touchEndTimeoutHandler);
            console.log("do something with ", i, collaped, virtuallyCollapsed, collaped || virtuallyCollapsed ? height : 0);
            (function(i) {
                var scrollElement = scollers[i];
                document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                    top: virtuallyCollapsed ? height : 0,
                    //top: 0,
                    left: 0
                });
            })(i);
            ignoreEvents = false;
        }
        this.currentActiveTab = tabview.currentActiveTab;
    };
    this.recalculateTab = function(i) {
        if (!FootballManiaConfig.graphics.animations) return;
        if (!scollers || !scollers[i]) {
            console.warn("cannot recalcuate without scollers ", i);
            return;
        }
        if (!tabview || !tabview.tabContents || !tabview.tabContents.controls[i] || !tabview.tabContents.controls[i].controls[1] || !tabview.tabContents.controls[i].controls[1].controls[0]) {
            console.warn("cannot recalcuate without tabview elements");
            return;
        }
        var contentWindowHeight = tabview.tabContents.getDimensions().height;
        var collapserHeight = 0;
        if (collapser) collapserHeight = collapser.getDimensions().height;
        var scrollEl = jQuery("#" + scollers[i].getClientId());
        var top = collapserHeight;
        if (!scrollEl || !scrollEl[0]) {
            console.warn("no scroller for tab ", i);
            return;
        }
        console.log(i, "RECALCULATE TAB ", "scrollHeight", scrollEl[0].scrollHeight, "content height", contentWindowHeight);
        if (!scollers[tabview.currentActiveTab]) {
            console.warn("no scroller for tab ", tabview.currentActiveTab);
            return;
        }
        if (!$("#" + scollers[tabview.currentActiveTab].getClientId()).isVScrollable()) {
            console.log(i, "content is not scrollable");
            $("#" + scollers[i].getClientId()).css({
                "box-sizing": "border-box"
            });
            $("#" + scollers[i].parent.getClientId()).css({
                "top": "-" + top + "px"
            });
            if (scollers[i].forceMarginTop) $("#" + scollers[i].controls[0].getClientId()).css({
                "margin-top": scollers[i].forceMarginTop,
                "height": ""
            });
            else $("#" + scollers[i].controls[0].getClientId()).css({
                "margin-top": "+" + top + "px",
                "height": ""
            });
            $("#" + scollers[i].parent.getClientId()).css({
                "height": "calc(100% + " + top + "px)"
            });
        } else {
            $("#" + scollers[i].getClientId()).css({
                "box-sizing": "border-box"
            });
            $("#" + scollers[i].parent.getClientId()).css({
                "top": "-" + top + "px"
            });
            $("#" + scollers[i].controls[0].getClientId()).css({
                "margin-top": "+" + top + "px",
                "height": ""
            });
            $("#" + scollers[i].parent.getClientId()).css({
                "height": "calc(100% + " + top + "px)"
            });
            console.log(i, "content is scrollable", this.isCollapsed);
        }
    };
    this.recalculate = function(force, onlyTabIndex) {
        if (!FootballManiaConfig.graphics.animations) return;
        //return;
        if (!force && this.lastRecalculateWasCollapsed != null && this.isCollapsed == this.lastRecalculateWasCollapsed) {
            console.log("NO NEED TO RECALCULATE POSITIONS");
            return;
        }
        console.log("RECALCULATE POSITIONS", "isCollapsed", this.isCollapsed);
        this.lastRecalculateWasCollapsed = this.isCollapsed;
        var collapserHeight = collapser.getDimensions().height;
        if (this.isCollapsed) this.colapseHeader();
        else this.expandHeader();
        if (scollers) {
            console.log("recalculate scollers length", scollers.length);
            for(var i = 0; i < scollers.length; i++){
                var scrollEl = jQuery("#" + scollers[i].getClientId());
                ///console.log("XXXXXXXX",scrollEl[0].scrollHeight,contentWindowHeight)
                this.recalculateTab(i);
                if (this.isCollapsed || this.isVirtuallyCollapsed) {
                    if (lastListIndexScrolling != i && scrollEl.scrollTop() <= collapserHeight) {
                        //console.log("scroll #1 manually tab", i, "to ", collapserHeight)
                        var scrollElement = scollers[i];
                        ignoreEvents = true;
                        if (ignoreEventForIndex.indexOf(i) == -1) ignoreEventForIndex.push(i);
                        document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                            top: collapserHeight,
                            left: 0
                        });
                        ignoreEvents = false;
                    }
                } else if (lastListIndexScrolling != i && scrollEl.scrollTop() <= collapserHeight) {
                    //console.log("scroll #2 manually tab", i, " to ", 0)
                    var scrollElement = scollers[i];
                    ignoreEvents = true;
                    if (ignoreEventForIndex.indexOf(i) == -1) ignoreEventForIndex.push(i);
                    document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                        top: 0,
                        left: 0
                    });
                    ignoreEvents = false;
                }
            }
        }
    };
    this.autoCollapseOrOpen = function(scrollPosition) {
        if (!FootballManiaConfig.graphics.animations) return;
        console.log("autoCollapseOrOpen", scrollPosition, this.currentTranslateY, this.isAutoCollapsing, this.isCollapsed);
        //return;
        if (this.isAutoCollapsing) {
            console.log("dont do twice ");
            return;
        }
        this.isAutoCollapsing = true;
        if (this.currentTranslateY == 0) this.isCollapsed = false;
        else if (this.currentTranslateY == -collapser.getDimensions().height) this.isCollapsed = true;
        if (this.currentTranslateY == 0 || this.currentTranslateY == -collapser.getDimensions().height) {
            //console.log("no auto collapse when already open or closed",this.currentTranslateY);
            this.isAutoCollapsing = false;
            this.recalculate();
            return;
        }
        console.log("AUTO COLLAPSE", this.currentTranslateY);
        var collapserHeight = collapser.getDimensions().height;
        var that = this;
        var delay = 300;
        if (scrollPosition > collapserHeight * (1 / this.reducerRatio) / 2) {
            var scrollElement = scollers[tabview.currentActiveTab];
            this.isCollapsed = true;
            document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                top: collapserHeight,
                left: 0,
                behavior: "smooth"
            });
        } else {
            var scrollElement = scollers[tabview.currentActiveTab];
            document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            that.currentTranslateY = 0;
            this.isCollapsed = false;
            setTimeout(function() {
                //that.currentTranslateY = 0;
                that.recalculate();
            }, delay);
        }
    };
    this.ensureStartPositions = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        if (this.isTouching) {
            console.log("NO PREPARE WHEN TOUCHING");
            return;
        }
        ///collapser.setVisible(false)
        console.log("PREPARE RUN ANIMATOR FOR MATCHSCREEN " + version);
        var collapserHeight = collapser.getDimensions().height;
        collapser.awayImage.setVisible(true);
        collapser.homeImage.setVisible(true);
        //make sure we start with a collapsed one before everything gets rendered. causes flickering
        if (this.isCollapsed) {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + topbar.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            var scrollElement = scollers[tabview.currentActiveTab];
            var el = document.querySelector("#" + scrollElement.getClientId());
            //console.log("scroll to 0 from start",el.scrollHeight,el.scrollTop);
            //only scroll to zero when user not scrolled
            if (el.scrollTop < collapserHeight) el.scrollTo({
                top: collapserHeight,
                left: 0
            });
        }
    };
    this.prerun = function(collapsed) {
        console.log("prerrunnn");
        if (!FootballManiaConfig.graphics.animations) return;
        console.log("PRE RUN ANIMATOR FOR MATCHSCREEN " + version);
        if (collapsed) {
            this.currentTranslateY = -collapser.getDimensions().height;
            this.autoCollapseOrOpen(-collapser.getDimensions().height);
        } else this.autoCollapseOrOpen(0);
        collapser.awayImage.setVisible(false);
        collapser.homeImage.setVisible(false);
    }, this.run = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        console.log("RUN ANIMATOR (scollers:" + scollers.length + ") FOR MATCHSCREEN " + version);
        lastListIndexScrolling = tabview.currentActiveTab;
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        for(var i = 0; i < scrollerMethods.length; i++){
            var scrollEl = jQuery("#" + scollers[i].getClientId());
            scrollEl.off("scroll", scrollerMethods[i]);
        }
        this.recalculate();
        var that = this;
        var homeImage = collapser.homeImage;
        var awayImage = collapser.awayImage;
        var statusContainer = collapser.statusContainer;
        var homeTitle = collapser.homeTitle;
        var awayTitle = collapser.awayTitle;
        var backgroundImage = collapser.backgroundImage;
        var startOpacityBackground = $("#" + backgroundImage.getClientId()).css("opacity");
        var isFirstTimeScroll = true;
        var currentActiveScrollElementHeight = 0;
        var windowHeight = $(window).height();
        touchStartMethod = function(e) {
            that.isTouching = true;
            var scrollElement = scollers[tabview.currentActiveTab];
            if (!scrollElement) {
                console.error("no scroll element in tab " + tabview.currentActiveTab + " found. do nothing?");
                return;
            }
            var topOffset = document.querySelector("#" + scrollElement.getClientId()).scrollTop;
            that.lastScrollPositionAfterTouchStart = topOffset;
            that.lastYOffsetAfterTouchStart = that.currentTranslateY;
        //alert(currentActiveScrollElementHeight)
        };
        touchEndMethod = function() {
            //console.log("touch end")
            that.isTouching = false;
            that.currentTranslateY, collapser.getDimensions().height;
            clearTimeout(touchEndTimeoutHandler);
            touchEndTimeoutHandler = setTimeout(function() {
                if (unloaded) return;
                if (!scollers) {
                    console.error("no scollers found why??");
                    return;
                }
                that.currentActiveTab = tabview.currentActiveTab;
                var scrollElement = scollers[tabview.currentActiveTab];
                if (!scrollElement) {
                    console.error("no scroll element in tab " + tabview.currentActiveTab + " found. do nothing?");
                    return;
                }
                var topOffset = document.querySelector("#" + scrollElement.getClientId()).scrollTop;
                that.autoCollapseOrOpen(topOffset);
            }, 100);
        };
        $('body').on({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        //what if dynamic height?
        var collapserHeight = collapser.getDimensions().height;
        function runTabSCrollLogic(index) {
            var scrollEl = jQuery("#" + scollers[index].getClientId());
            var prevScroll = null;
            var ticking = false;
            var topOffset = 0;
            var prevTopOffset = 0;
            scrollerMethods[index] = function(e) {
                //console.log("scroll event",index,that.isCollapsed,that.isVirtuallyCollapsed);
                if (ticking) return;
                //if (currentActiveScrollElementHeight == null){
                currentActiveScrollElementHeight = $("#" + scollers[tabview.currentActiveTab].getClientId())[0].scrollHeight;
                //}
                if (currentActiveScrollElementHeight < windowHeight) console.log("do nothing scroll element smaller than window height", currentActiveScrollElementHeight, windowHeight);
                //console.log(currentActiveScrollElementHeight,windowHeight);
                clearTimeout(touchEndTimeoutHandler);
                window.requestAnimationFrame(function() {
                    ticking = true;
                    if (ignoreEvents || index != tabview.currentActiveTab) {
                        console.log("ignore scroll event if not this active tab ", index);
                        ticking = false;
                        return;
                    }
                    if (ignoreEventForIndex.indexOf(index) != -1) {
                        console.log("ignore scroll event this time", index, ignoreEventForIndex);
                        //ignoreEventForIndex = -1;
                        ignoreEventForIndex.splice(ignoreEventForIndex.indexOf(index), 1);
                        ticking = false;
                        return;
                    }
                    var topOffset = e.originalEvent.target.scrollTop;
                    if (prevScroll == topOffset) {
                        ticking = false;
                        console.log("do nothing no scroll change");
                    //return;
                    }
                    // if (!that.isTouching && scollers[index].ignoreAnimationsOnProgrammaticScroll) {
                    //     ticking = false;
                    //     console.log("do nothing no animations on programmatic scroll");
                    //     return;
                    // }
                    lastListIndexScrolling = index;
                    clearTimeout(scrollReleaseTimeoutHandler);
                    scrollReleaseTimeoutHandler = setTimeout(function() {
                        that.isAutoCollapsing = false;
                        currentActiveScrollElementHeight = null;
                        var topOffset = e.originalEvent.target.scrollTop;
                        if (!that.isTouching) that.autoCollapseOrOpen(topOffset);
                        that.recalculate();
                        console.log("scroll done");
                    }, 150);
                    topOffset = e.originalEvent.target.scrollTop;
                    prevTopOffset = topOffset;
                    if (that.isCollapsed) {
                        if (topOffset <= collapserHeight) {
                            var t = -topOffset;
                            scrollDiff = Math.max(-collapserHeight, Math.min(0, t));
                        } else //console.log("do other")
                        scrollDiff = Math.max(-topOffset, -collapserHeight);
                    } else {
                        //console.log("is not collapsed scroll",topOffset,collapserHeight);
                        if (topOffset >= collapserHeight) scrollDiff = -collapserHeight;
                        else if (that.lastScrollPositionAfterTouchStart != -1) {
                            //var t = ((that.lastScrollPositionAfterTouchStart - topOffset) * that.reducerRatio) + that.lastYOffsetAfterTouchStart;
                            var t = (collapserHeight - topOffset - collapserHeight) * that.reducerRatio;
                            var scrollDiff = Math.min(0, Math.max(-collapserHeight, t));
                            var scrollDiff = t;
                        } else scrollDiff = 0;
                    }
                    that.currentTranslateY = scrollDiff;
                    //this virtualcollapsed value is a little different than iscollapsed
                    //when user is collapsing and no touchend event is fired then the state of
                    //iscollapsed remains the same. the virtualcollapsed one changes
                    //this is needed in the recalculation of positions
                    if (scrollDiff == -collapserHeight) that.isVirtuallyCollapsed = true;
                    else that.isVirtuallyCollapsed = false;
                    if (isFirstTimeScroll) {
                        var transformDuration = 0;
                        isFirstTimeScroll = false;
                    } else var transformDuration = 80;
                    that.shrinkOrExpand(scrollDiff, collapserHeight, homeImage, awayImage, backgroundImage, homeTitle, awayTitle, statusContainer, startOpacityBackground, transformDuration);
                    prevScroll = e.originalEvent.target.scrollTop;
                    ticking = false;
                });
            };
            if (scrollerMethods[index]) scrollEl.off("scroll", scrollerMethods[index]);
            scrollEl.scroll(scrollerMethods[index]);
        }
        for(var i = 0; i < scollers.length; i++)//if (i == this.disableAnimationsForIndex) continue;
        runTabSCrollLogic(i);
    }, this.colapseHeader = function() {
        console.log("collapse header");
        var collapserHeight = collapser.getDimensions().height;
        this.isCollapsed = true;
        this.isVirtuallyCollapsed = true;
        $("#" + collapser.getClientId()).css({
            "transform": "translate(0px," + -collapserHeight + "px)",
            "transition-duration": "0ms"
        });
        if (topbar) $("#" + topbar.getClientId()).css({
            "transform": "translate(0px," + -collapserHeight + "px)",
            "transition-duration": "0ms"
        });
        if (tabview) $("#" + tabview.tabHolder.getClientId()).css({
            "transform": "translate(0px," + -collapserHeight + "px)",
            "transition-duration": "0ms"
        });
        //this.recalculate();
        this.shrinkOrExpand(-collapser.getDimensions().height, collapser.getDimensions().height, collapser.homeImage, collapser.awayImage, collapser.backgroundImage, collapser.homeTitle, collapser.awayTitle, collapser.statusContainer, $("#" + collapser.backgroundImage.getClientId()).css("opacity"), 0);
    };
    this.expandHeader = function() {
        console.log("expand header");
        this.isCollapsed = false;
        this.isVirtuallyCollapsed = false;
        $("#" + collapser.getClientId()).css({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        if (topbar) $("#" + topbar.getClientId()).css({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        if (tabview) $("#" + tabview.tabHolder.getClientId()).css({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        //this.recalculate();
        this.shrinkOrExpand(0, collapser.getDimensions().height, collapser.homeImage, collapser.awayImage, collapser.backgroundImage, collapser.homeTitle, collapser.awayTitle, collapser.statusContainer, $("#" + collapser.backgroundImage.getClientId()).css("opacity"), 0);
    }, this.shrinkOrExpand = function(scrollDiff, collapserHeight, homeImage, awayImage, backgroundImage, homeTitle, awayTitle, statusContainer, startOpacityBackground, transformDuration) {
        if (!collapser || !tabview || !tabview.tabHolder) return;
        //collapser.setCss({"transform":"translate(0px,"+scrollDiff+"px)","transition-duration": this.transitionDuration+"ms"});
        collapser.setCss({
            "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
            "transition-duration": "80ms"
        });
        tabview.tabHolder.setCss({
            "transform": "translate(0px," + scrollDiff + "px)",
            "transition-duration": this.transitionDuration + "100ms"
        });
        tabview.tabHolder.setCss({
            "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
            "transition-duration": "80ms"
        });
        var progression = -scrollDiff / collapserHeight;
        var opacity = 1 - progression;
        //var opacity = 1;
        var scaleFontY = 1 - 0.40 * progression;
        var scaleFontX = 1 - 0.38 * progression;
        var scaleImage = 1 - 0.47 * progression;
        //1 == finished, 2 == live with aggregate score, 3 == live with individual score
        if (this.shrinkType == 1) {
            var statusContainerProgression = progression * 27;
            scaleFontY = 1 - 0.22 * progression;
            scaleFontX = 1 - 0.22 * progression;
        } else if (this.shrinkType == 2) {
            var statusContainerProgression = progression * 36;
            scaleFontY = 1 - 0.25 * progression;
            scaleFontX = 1 - 0.25 * progression;
        } else if (this.shrinkType == 3) {
            var statusContainerProgression = progression * 50;
            scaleFontY = 1 - 0.40 * progression;
            scaleFontX = 1 - 0.45 * progression;
        } else if (this.shrinkType == 4) {
            var statusContainerProgression = progression * 20;
            scaleFontY = 1 - 0.17 * progression;
            scaleFontX = 1 - 0.17 * progression;
        } else var statusContainerProgression = progression * 90;
        var imageVerticalMove = progression * 105;
        var imageHorizontalMove = progression * 40;
        homeImage.setCss({
            "transform": "scale(" + scaleImage + ") translate(" + imageHorizontalMove + "px," + imageVerticalMove + "px)",
            "transition-duration": transformDuration + "ms"
        });
        awayImage.setCss({
            "transform": "scale(" + scaleImage + ") translate(" + -imageHorizontalMove + "px," + imageVerticalMove + "px)",
            "transition-duration": transformDuration + "ms"
        });
        backgroundImage.setCss({
            "transform": "translateX(" + tabview.cachedParllaxBgXOffset + "%) translateY(" + (-50 + progression * 30) + "px)",
            "transition-duration": transformDuration + "ms",
            "opacity": startOpacityBackground - progression * startOpacityBackground
        });
        homeTitle.setCss({
            "opacity": opacity
        });
        awayTitle.setCss({
            "opacity": opacity
        });
        topbar.setCss({
            "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
            "transition-duration": transformDuration + "ms"
        });
        statusContainer.setCss({
            "transform": "scaley(" + scaleFontY + ") scalex(" + scaleFontX + ")   translate(0px," + statusContainerProgression + "px)",
            "transition-duration": transformDuration + "ms"
        });
    };
};



var $kc8Kt = parcelRequire("kc8Kt");






var $fRpWP = parcelRequire("fRpWP");


var $02mnx = parcelRequire("02mnx");

var $kc8Kt = parcelRequire("kc8Kt");
class $dae0bf243cd605f1$export$c5f42beb91c891a6 extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier) {
        super.init(urlIdentifier);
    }
    unload() {
        clearTimeout(this.commentaryRefreshHandler);
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 50) + "px;justify-content: flex-start;align-items: flex-start;overflow-y:scroll;");
        p.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("addFavoriteModalTitle");
        title.addControl((0, $02mnx.Localizer).getString("commentaries"));
        this.addControl(title);
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
        var matchid = (0, $fRpWP.UrlManager).getModule("mid");
        var loadCommentaries = ()=>{
            (0, $kc8Kt.DataProvider).getCommentaries(matchid, (data)=>{
                if (!data.isOk()) {
                    console.log("show error");
                    return;
                }
                var oldSCroll = jQuery("#" + p.getClientId()).scrollTop();
                p.clear();
                this.renderCommentaries(data.getData(), p);
                jQuery("#" + p.getClientId()).scrollTop(oldSCroll);
                clearTimeout(this.commentaryRefreshHandler);
                this.commentaryRefreshHandler = setTimeout(()=>{
                    loadCommentaries();
                }, AppInstance.getConfig().refreshIntervals.commentary);
            });
        };
        loadCommentaries();
    }
    renderCommentaries(commentaries, target) {
        var prevcomment = null;
        //reverse the commentaries
        for(var i = 0; i < commentaries.liveticker.length; i++){
            var commentary = commentaries.liveticker[i];
            if (commentary.comment == prevcomment) continue;
            var content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            content.addCssClass("flexHorizontalAlign");
            var minute = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            minute.setStyle("width:60px;text-align:center;margin-inline-end:8px;");
            minute.addControl(commentary.minute);
            if (commentary.minute) content.addControl(minute);
            content.addControl("<div style='width:100%;margin-inline-end:10px;'>" + commentary.comment + "</div>");
            content.setStyle("margin-top: 5px;text-align:left; margin-bottom: 5px;height:auto;");
            target.addControl(content);
            prevcomment = commentary.comment;
        }
        target.invalidateDisplay();
    }
}





var $02mnx = parcelRequire("02mnx");
class $8ab3f15a62b8f3ec$export$d57e9955a27a5081 extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier, data) {
        super.init(urlIdentifier);
        this.data = data;
    }
    unload() {
        clearTimeout(this.commentaryRefreshHandler);
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 50) + "px;justify-content: flex-start;align-items: flex-start;overflow-y:scroll;");
        p.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("addFavoriteModalTitle");
        title.addControl((0, $02mnx.Localizer).getString("odd_title"));
        this.addControl(title);
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
        for(var i = 0; i < this.data.odds.bookmakers.length; i++){
            var bookmaker = this.data.odds.bookmakers[i];
            this.renderOddItem(bookmaker, p);
        }
    }
    renderOddItem(bookmaker, target) {
        var mainContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        mainContainer.addCssClass("flexVerticalAlign");
        mainContainer.setStyle("width:100%;height:auto;");
        var topTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topTitle.addControl("<i>" + bookmaker.name + "</i>");
        topTitle.addCssClass("MatchStatsTitleText MatchH2HTitle");
        var topContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topContainer.addCssClass("flexHorizontalAlign");
        topContainer.setStyle("justify-content: space-around;margin-bottom:10px;width:100%;");
        var leftContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        var middleContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        var rightContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        leftContainer.addControl(bookmaker.homeValue);
        middleContainer.addControl(bookmaker.drawValue);
        rightContainer.addControl(bookmaker.awayValue);
        topContainer.addControl(leftContainer);
        topContainer.addControl(middleContainer);
        topContainer.addControl(rightContainer);
        mainContainer.addControl(topTitle);
        mainContainer.addControl(topContainer);
        target.addControl(mainContainer);
    }
}





var $02mnx = parcelRequire("02mnx");

var $9yWe2 = parcelRequire("9yWe2");


class $e5f9454769c5d1c5$export$807e1ffa413586ae extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
        this.addCssClass("MatchHeaderContainer");
        this.bounceEnabled = true;
        var homeContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        homeContainer.addCssClass("MatchHeaderHomeContainer");
        var statusContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        statusContainer.addCssClass("MatchHeaderStatusContainer");
        var awayContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        awayContainer.addCssClass("MatchHeaderAwayContainer");
        this.backgroundImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.backgroundImage.setVisible(false);
        this.backgroundImage.addCssClass("MatchHeaderBackgroundImage");
        //this.backgroundImage.addCssClass("fade-in-image2");
        this.homeImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.homeImage.addCssClass("MatchHeaderTeamLogoContainer");
        this.awayImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.awayImage.addCssClass("MatchHeaderTeamLogoContainer");
        this.homeTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.homeTitle.addCssClass("MatchHeaderTeamText");
        this.awayTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.awayTitle.addCssClass("MatchHeaderTeamText");
        this.statusDate = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.statusDate.addCssClass("MatchHeaderStatusDate");
        this.statusAggr = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.statusAggr.addCssClass("MatchHeaderStatusAggregate");
        this.scoreTime = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.scoreTime.addCssClass("MatchHeaderStatusScoreTime");
        this.statusMatch = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.statusMatch.addCssClass("MatchHeaderStatusMatch");
        this.addControl(this.backgroundImage);
        this.addControl(homeContainer);
        this.addControl(statusContainer);
        this.addControl(awayContainer);
        homeContainer.addControl(this.homeImage);
        homeContainer.addControl(this.homeTitle);
        awayContainer.addControl(this.awayImage);
        awayContainer.addControl(this.awayTitle);
        statusContainer.addControl(this.statusDate);
        statusContainer.addControl(this.statusAggr);
        statusContainer.addControl(this.scoreTime);
        statusContainer.addControl(this.statusMatch);
        this.statusContainer = statusContainer;
    }
    setPresetData(data, instantRender) {
        if (!data) {
            console.error("cannot set preset data without data");
            return;
        }
        if ((0, $40e70090f1e1ff2d$export$5510f7c459d7063c).getCurrentTheme() != "light" && instantRender) {
            //if (instantRender) {
            this.backgroundImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/venue/" + data.venueid + ".png");
            this.backgroundImage.setVisible(true);
        }
        //console.log("set preset daa",data,AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/teams_gs/"+data.gs_localteamid+"_rnd.png");
        this.statusDate.clear();
        this.scoreTime.clear();
        this.statusMatch.clear();
        this.awayTitle.clear();
        this.homeTitle.clear();
        this.statusDate.clear();
        this.statusAggr.clear();
        this.statusDate.addControl((0, $9yWe2.MatchUtil).getLocalizedDate(data), instantRender);
        this.scoreTime.addControl((0, $9yWe2.MatchUtil).getLocalizedScoreTime(data), instantRender);
        this.statusMatch.addControl((0, $9yWe2.MatchUtil).getFullStatus(data), instantRender);
        this.homeTitle.addControl(data.localteam, instantRender);
        this.awayTitle.addControl(data.visitorteam, instantRender);
        if (!this.oldData || this.oldData.gs_localteamid != data.gs_localteamid) {
            var teamImageSubFolder = "";
            if (!AppInstance.getConfig().enabledFeatures.teamImages) teamImageSubFolder = "country/";
            this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + teamImageSubFolder + data.gs_localteamid + "_rnd.png", AppInstance.getConfig().sizes.matchHeaderImageSize, AppInstance.getConfig().sizes.matchHeaderImageSize);
            this.homeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("home team image"));
            this.awayImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + teamImageSubFolder + data.gs_visitorteamid + "_rnd.png", AppInstance.getConfig().sizes.matchHeaderImageSize, AppInstance.getConfig().sizes.matchHeaderImageSize);
            this.awayImage.setAttribute("alt", (0, $02mnx.Localizer).getString("away team image"));
            this.homeImage.unbind("click");
            this.homeImage.bind("click", ()=>{
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(data.gs_localteamid);
            });
            this.awayImage.unbind("click");
            this.awayImage.bind("click", ()=>{
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(data.gs_visitorteamid);
            });
        }
        // if (MatchUtil.isPlaying(data) || MatchUtil.isHalftime(data)){
        //     //this.statusDate.setVisible(false);
        //     this.statusMatch.addCssClass('scoretimeBlinker ScoreTimeLarge');
        // }
        if ((0, $9yWe2.MatchUtil).isHalftime(data)) {
            this.statusDate.clear();
            this.statusMatch.addCssClass('scoretimeBlinker');
        } else if ((0, $9yWe2.MatchUtil).isPlaying(data)) {
            this.statusDate.clear();
            this.statusMatch.addCssClass('scoretimeBlinker ScoreTimeLarge');
        } else {
            this.scoreTime.addCssClass('scoretimeNormal');
            this.statusMatch.removeCssClass('scoretimeBlinker ScoreTimeLarge');
            this.statusMatch.removeCssClass('scoretimeBlinker');
        }
        if (data.aggregateScore) {
            var scoreParts = data.aggregateScore.split("-");
            if (data.aggregateWinner == 1) this.statusAggr.addControl("(<span class=MatchHeaderAggregateWinnerColor>" + scoreParts[0] + "</span> - " + scoreParts[1] + ")", instantRender);
            else if (data.aggregateWinner == 2) this.statusAggr.addControl("(" + scoreParts[0] + " - <span class=MatchHeaderAggregateWinnerColor>" + scoreParts[1] + "</span>)", instantRender);
            else this.statusAggr.addControl("(" + scoreParts[0] + " - " + scoreParts[1] + ")", instantRender);
        }
        this.oldData = data;
    }
    setData(data) {
    //this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/teams_gs/"+this.data.gs_localteamid+"_small_rnd.png",AppInstance.getConfig().sizes.fixtureListImageSize,AppInstance.getConfig().sizes.fixtureListImageSize);
    //this.awayImage.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/teams_gs/"+this.data.gs_visitorteamid+"_small_rnd.png",AppInstance.getConfig().sizes.fixtureListImageSize,AppInstance.getConfig().sizes.fixtureListImageSize);
    }
}





var $3SrKy = parcelRequire("3SrKy");


var $02mnx = parcelRequire("02mnx");
class $52274ddb13c5ef93$export$7d9d7c166fa1026a extends (0, $761fc09f912370da$export$5f18642dbcedb9ce) {
    init(noAutoInit) {
        console.log("init chat socket io", noAutoInit);
        super.init();
        if (!noAutoInit) this.initSocketIO();
    }
    createComponents() {
        super.createComponents();
        this.scrollTo(100000);
    }
    unload() {
        super.unload();
        if (this.socket) this.socket.disconnect();
    }
    rateMessage(message, rating, retry) {
        let socialUser = (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser();
        if (!socialUser) {
            console.error("no social user found -> cannot rate message without logging in");
            //login request
            if (retry) {
                AppInstance.activePage.getPageTemplate().showToast("error_login_failed_after_retry");
                return;
            }
            this.triggerEvent("authentication_start");
            (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogin((socialUser)=>{
                this.triggerEvent("authentication_end", socialUser);
                if (!socialUser) {
                    AppInstance.activePage.getPageTemplate().showToast("error_login_failed");
                    return;
                }
                this.rateMessage(message, rating, 1);
            });
            return;
        }
        console.log("rate message", message);
        var newMessage = {};
        newMessage.mid = message.id;
        newMessage.pid = socialUser.pid;
        newMessage.image = socialUser.image;
        newMessage.un = socialUser.un;
        newMessage.matchid = this.chatIndex;
        newMessage.type = 1;
        newMessage.rating = rating;
        newMessage.style = {
            height: 80
        };
        newMessage.time = Math.abs(new Date() / 1000);
        this.sendVote(newMessage);
    }
    addMessage(message, retry) {
        if (!message || message == (0, $02mnx.Localizer).getString("chattypehint")) {
            console.error("cannot add empty message");
            return;
        }
        let socialUser = (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser();
        if (!socialUser) {
            console.error("no social user found -> cannot add message without logging in");
            //login request
            if (retry) {
                console.error("retrying failed login");
                AppInstance.activePage.getPageTemplate().showToast("error_login_failed_after_retry");
                return;
            }
            this.triggerEvent("authentication_start");
            (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogin((socialUser)=>{
                this.triggerEvent("authentication_end", socialUser);
                if (!socialUser) {
                    console.log("login failed");
                    AppInstance.activePage.getPageTemplate().showToast("error_login_failed");
                    return;
                }
                this.addMessage(message, 1);
            });
            return;
        }
        var newMessage = {};
        newMessage.m = message;
        newMessage.temp = 1;
        newMessage.pid = socialUser.pid;
        newMessage.image = socialUser.image;
        newMessage.un = socialUser.un;
        newMessage.matchid = this.chatIndex;
        newMessage.type = 1;
        newMessage.style = {
            height: 80
        };
        newMessage.delivered = false;
        newMessage.time = Math.round(new Date() / 1000);
        console.log("add message", newMessage);
        var datasource = this.getDataSource();
        datasource.push(newMessage);
        console.log("Set new datasource ", datasource);
        this.setDataSource(datasource, true);
        setTimeout(()=>{
            this.scrollTo(99999999);
        }, 50);
        this.sendMessage(message);
    }
    sendMessage(message) {
        let socialUser = (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser();
        console.log("going to send message ", FootballManiaConfig.isAndroid);
        (0, $3SrKy.PushMessaging).getToken((token)=>{
            var data = {};
            data.m = message;
            data.nw = FootballManiaConfig.isAndroid ? 3 : 10;
            data.gcm = token;
            data.pid = socialUser.pid;
            data.token = socialUser.token;
            data.maniatoken = socialUser.maniatoken;
            data.image = socialUser.image;
            data.un = socialUser.un;
            data.matchid = this.chatIndex;
            this.socket.emit("post_message", JSON.stringify(data), (response)=>{
                console.log("message posted", response);
                if (response == -4) {
                    console.log("not logged in or expired token");
                    // AppInstance.activePage.getPageTemplate().showToast("not_logged_in");
                    // Socializer.resetManiaToken();
                    // Socializer.requestLogout(() => {});
                    (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogin((socialUser)=>{
                        if (!socialUser) {
                            AppInstance.activePage.getPageTemplate().showToast("error_login_failed");
                            this.triggerEvent("authentication_error");
                            return;
                        }
                        this.socket.emit("post_message", JSON.stringify(data), (response)=>{
                            console.log("message posted", response);
                        });
                    });
                }
            });
        });
    }
    sendVote(message) {
        let socialUser = (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser();
        (0, $3SrKy.PushMessaging).getToken((token)=>{
            var data = {};
            data.rating = message.rating;
            data.mid = message.mid;
            data.nw = FootballManiaConfig.isAndroid ? 3 : 10;
            data.gcm = token;
            data.pid = socialUser.pid;
            data.token = socialUser.token;
            data.maniatoken = socialUser.maniatoken;
            data.image = socialUser.image;
            data.un = socialUser.un;
            data.matchid = this.chatIndex;
            console.log("send ", data);
            this.socket.emit("post_vote", JSON.stringify(data), (response)=>{
                console.log("vote posted", response);
                if (response == -4) {
                    console.log("not logged in or expired token");
                    // AppInstance.activePage.getPageTemplate().showToast("not_logged_in");
                    // Socializer.resetManiaToken();
                    // Socializer.requestLogout(() => {});
                    (0, $0dbc6ded793568e1$export$1a7533566a41982d).requestLogin((socialUser)=>{
                        if (!socialUser) {
                            AppInstance.activePage.getPageTemplate().showToast("error_login_failed");
                            this.triggerEvent("voteFailed");
                            this.triggerEvent("authentication_error");
                            return;
                        }
                        this.socket.emit("post_vote", JSON.stringify(data), (response)=>{
                            console.log("message voted", response);
                        });
                    });
                } else if (response == -1) {
                    console.log("already voted");
                    this.triggerEvent("voteFailed");
                }
            });
        });
    }
    adminRemoveMessage(message) {
        console.log("remove message");
        let socialUser = (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser();
        (0, $3SrKy.PushMessaging).getToken((token)=>{
            var data = {};
            data.mid = message.id;
            data.nw = FootballManiaConfig.isAndroid ? 3 : 10;
            data.gcm = token;
            data.pid = socialUser.pid;
            data.token = socialUser.token;
            data.maniatoken = socialUser.maniatoken;
            data.image = socialUser.image;
            data.un = socialUser.un;
            data.matchid = this.chatIndex;
            console.log("send ", data);
            this.socket.emit("admin_remove_message", JSON.stringify(data), (response)=>{
                console.log("vote posted", response);
                if (response == -4) {
                    console.log("not logged in or expired token");
                    AppInstance.activePage.getPageTemplate().showToast("error: not logged in or expired token");
                    this.triggerEvent("authentication_error");
                } else if (response == -5) {
                    console.log("no admin rights");
                    AppInstance.activePage.getPageTemplate().showToast("error: not authorized for this action");
                } else if (response == -1) AppInstance.activePage.getPageTemplate().showToast("error: unexpected error. please contact support");
                else console.log("success");
                this.triggerEvent("adminActionFailed");
            });
        });
    }
    adminBanUser(message, duration) {
        console.log("ban user");
        let socialUser = (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser();
        console.log("ban user", message, duration);
        (0, $3SrKy.PushMessaging).getToken((token)=>{
            var data = {};
            data.mid = message.id;
            data.nw = FootballManiaConfig.isAndroid ? 3 : 10;
            data.gcm = token;
            data.pid = socialUser.pid;
            data.token = socialUser.token;
            data.maniatoken = socialUser.maniatoken;
            data.image = socialUser.image;
            data.un = socialUser.un;
            data.matchid = this.chatIndex;
            // data.userToBanUid =
            // data.userToBanId =
            // data.userToBanNw =
            // data.banDuration =
            console.log("send ", data);
            this.socket.emit("admin_remove_message", JSON.stringify(data), (response)=>{
                console.log("vote posted", response);
                if (response == -4) {
                    console.log("not logged in or expired token");
                    AppInstance.activePage.getPageTemplate().showToast("error: not logged in or expired token");
                    this.triggerEvent("authentication_error");
                } else if (response == -5) {
                    console.log("no admin rights");
                    AppInstance.activePage.getPageTemplate().showToast("error: not authorized for this action");
                } else if (response == -1) {
                    AppInstance.activePage.getPageTemplate().showToast("error: unexpected error. please contact support");
                    this.triggerEvent("authentication_error");
                } else console.log("success");
                this.triggerEvent("adminActionFailed");
            });
        });
    }
    initSocketIO() {
        console.log("init socket io");
        console.trace();
        if (this.initalized) return;
        this.initialized = true;
        const socket = io("/", {
            path: "/socketioweb",
            rejectUnauthorized: false,
            reconnectionDelayMax: 10000,
            forceNew: false,
            multiplex: true,
            autoConnect: false,
            transports: [
                "websocket"
            ]
        });
        this.socket = socket;
        socket.on("connect", ()=>{
            const engine = socket.io.engine;
            console.log(engine.transport.name); // in most cases, prints "polling"
            engine.once("upgrade", ()=>{
                // called when the transport is upgraded (i.e. from HTTP long-polling to WebSocket)
                console.log("engine upgrade => " + engine.transport.name); // in most cases, prints "websocket"
            });
            engine.on("packet", ({ type: type, data: data })=>{
            // called for each packet received
            //console.log("engine packet => "+type+" "+data);
            });
            engine.on("packetCreate", ({ type: type, data: data })=>{
            // called for each packet sent
            //console.log("engine packetCreate => "+type+" "+data);
            });
            engine.on("drain", ()=>{
            // called when the write buffer is drained
            //console.log("engine drain");
            });
            engine.on("close", (reason)=>{
            // called when the underlying connection is closed
            //console.log("engine close => "+reason);
            });
            let socialUser = (0, $0dbc6ded793568e1$export$1a7533566a41982d).getSocialUser();
            console.log("socket-io connected");
            socket.sendBuffer = [];
            var data = {
                matchid: this.chatIndex
            };
            if (socialUser) (0, $3SrKy.PushMessaging).getToken(function(token) {
                data.nw = socialUser.nw;
                data.maniatoken = socialUser.maniatoken;
                data.gcm = token;
                data.pid = socialUser.pid;
                data.token = socialUser.token;
                data.image = socialUser.image;
                data.un = socialUser.un;
                console.log("joinroom", data);
                socket.emit("joinroom", JSON.stringify(data), (arg)=>{
                    console.log("joinroom", data);
                });
            });
            else socket.emit("joinroom", JSON.stringify(data));
        });
        socket.on("incoming connection", (arg)=>{
            console.log("socket-io incoming connection", arg);
        });
        socket.on("accepted", (arg)=>{
            this.triggerEvent("accepted", arg);
        });
        socket.on("disconnect", (arg)=>{
            console.log("socket-io disconnect", arg);
        });
        socket.on("error", (arg)=>{
            console.log("socket-io error", arg);
        });
        socket.io.on("ping", ()=>{
            console.log("socet-io ping");
        });
        socket.io.on("reconnect", (attempt)=>{
            console.log("socket-io reconnect", attempt);
        });
        socket.io.on("reconnect_attempt", (attempt)=>{
            console.log("socket-io reconnect_attempt", attempt);
        });
        socket.io.on("reconnecting", (attempt)=>{
            console.log("socket-io reconnecting", attempt);
        });
        socket.io.on("reconnect_error", (arg)=>{
            console.log("socket-io reconnect_error", arg);
        });
        socket.on("connect_error", (arg, a)=>{
            console.log("socket-io connect_error", arg);
        });
        socket.on("connect_timeout", (arg)=>{
            console.log("socket-io connect_timeout", arg);
        });
        socket.on("event", (arg)=>{
            console.log("socket-io event", arg);
        });
        socket.on("incoming_message", (arg)=>{
            console.log("socket-io incoming_message", arg);
            var datasource = this.getDataSource();
            var newMessage = JSON.parse(arg);
            var foundExisting = null;
            for(var i = 0; i < datasource.length; i++){
                console.log("loop ", datasource[i].id, newMessage.id, datasource[i].id == newMessage.id, datasource[i].id != null);
                if (datasource[i].id != null && datasource[i].id == newMessage.id) {
                    foundExisting = datasource[i];
                    foundExisting.style = {
                        height: 80
                    };
                    foundExisting.rating = newMessage.rating;
                    foundExisting.userVote = newMessage.userVote;
                    newMessage = foundExisting;
                    newMessage.temp = null;
                    if (newMessage.delivered === false) newMessage.delivered = true;
                    console.log("found existing message", foundExisting);
                    break;
                ///return;
                }
            }
            if (!foundExisting) {
                newMessage.type = 1;
                newMessage.style = {
                    height: 80
                };
                if (!newMessage.time) newMessage.time = Math.abs(newMessage.t / 1000);
                datasource.push(newMessage);
                console.log("not found existing message", newMessage.t, newMessage);
            }
            console.log("new message ", newMessage);
            //return;
            for(var i = 0; i < datasource.length; i++)if (datasource[i].temp == 1 && datasource[i].m == newMessage.m) {
                console.log("replace temp (added) message with incoming message");
                datasource.splice(i, 1);
                break;
            }
            console.log("Set new datasource ", datasource);
            this.setDataSource(datasource);
            if (!foundExisting) setTimeout(()=>{
                this.scrollTo(99999999);
            }, 500);
            this.triggerEvent("incoming_message", newMessage);
        });
        socket.on("authentication_update", (data)=>{
            console.log("socket-io authentication_update", data);
            if (data.user && data.user.maniatoken) (0, $0dbc6ded793568e1$export$1a7533566a41982d).setManiaToken(data.user.maniatoken);
        });
        socket.on("refresh_chat", (data)=>{
            console.log("socket-io refresh_chat", data);
            if (data.messages) {
                for(var i = 0; i < data.messages.length; i++){
                    data.messages[i].type = 1;
                    data.messages[i].style = {
                        height: 80
                    };
                }
                console.log("set messages ", data.messages);
                this.setDataSource(data.messages);
                this.triggerEvent("refresh_chat");
            }
        });
        socket.open((err)=>{
            if (err) console.log("socket-io error", err);
            else console.log("socket-io open");
        });
    }
}







var $fRpWP = parcelRequire("fRpWP");


var $9yWe2 = parcelRequire("9yWe2");

var $02mnx = parcelRequire("02mnx");

const $ce9390ea20c7ac7b$export$bf48777cc692e18f = {
    storageKey: "votedMatches",
    getVotedMatches: function() {
        if (this.cachedVotedMatches) return this.cachedVotedMatches;
        var data = [];
        try {
            var raw = localStorage.getItem(this.storageKey);
            data = JSON.parse(raw);
            if (!data) data = {};
        } catch (e) {
            console.warn("error getting subscribed matches ", e);
        }
        this.cachedVotedMatches = data;
        return data;
    },
    getVote: function(matchid) {
        return this.getVotedMatches()[matchid];
    },
    voteMatch: function(matchid, side) {
        this.cachedVotedMatches = null;
        var data = this.getVotedMatches();
        if (!data[matchid]) {
            data[matchid] = side;
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).voteMatch(matchid, side);
        }
        localStorage.setItem(this.storageKey, JSON.stringify(data));
        this.cachedVotedMatches = null;
    },
    migrateAndroidMatchVotes: function(androidData) {
        console.log("migrate");
        //"{"3280364":1,"3283743":0,"3263563":2}"
        androidData = JSON.parse(androidData);
        var newData = {};
        for(var key in androidData)newData[key] = androidData[key];
        localStorage.setItem(this.storageKey, JSON.stringify(newData));
    }
};



var $6K7Df = parcelRequire("6K7Df");

var $kc8Kt = parcelRequire("kc8Kt");






var $lU8CH = parcelRequire("lU8CH");
class $c07b1d3ba027f23b$export$9927a8850dc24e2b extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        var card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        card.addCssClass("MatchTitleContainerCard");
        card.addCssClass("flexVerticalAlign");
        this.panel.addControl(card);
        this.addControl(this.panel);
        var topContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topContainer.addCssClass("flexVerticalAlign");
        this.imageBox = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.imageBox.addCssClass("MatchStatsTitleImage");
        //this.imageBox.placeholderData = countryPlaceHolder
        this.titleTop = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.titleTop.addCssClass("MatchStatsTitleTextTop");
        this.titleTop.setStyle("display: flex; align-items: center;");
        this.titleMiddle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.titleMiddle.addCssClass("MatchStatsTitleTextBottom");
        this.titleBottom = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.titleBottom.addCssClass("MatchStatsTitleTextBottom");
        this.titleTop.addControl(this.imageBox);
        topContainer.addControl(this.titleTop);
        card.addControl(topContainer);
        card.addControl(this.titleMiddle);
        card.addControl(this.titleBottom);
        this.panel.bind('click', ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(this.data.data);
        });
    }
    setData(data) {
        super.setData(data);
        //this.contents.clear();
        this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.data.filegroup.replaceAll(" ", "-").toLowerCase() + ".png", 30, 30);
        this.imageBox.setAttribute("alt", (0, $02mnx.Localizer).getString("flag"));
        //this.titleTop.clear();
        if (!AppInstance.getConfig().enabledFeatures.showCompleteLeagueNames) {
            var regex = new RegExp(AppInstance.getConfig().reservedWords.join("|"), "g");
            data.data.leaguename = data.data.leaguename.replace(regex, "");
        }
        if (FootballManiaConfig.hideCountryTitleFor.indexOf(data.data.filegroup) != -1) this.titleTop.addControl((0, $02mnx.Localizer).getString(data.data.leaguename));
        else {
            this.titleTop.addControl((0, $6K7Df.CountryUtil).getLocalizedCountryByName(data.data.filegroup));
            this.titleTop.addControl(" - " + (0, $02mnx.Localizer).getString(data.data.leaguename));
        }
        if (data.data.week != null) {
            if (data.data.stageName) this.titleMiddle.addControl(data.data.stageName + " - ");
            this.titleMiddle.addControl((0, $02mnx.Localizer).getString("round") + " " + data.data.week);
            if (data.data.time && data.data.date) this.titleMiddle.addControl(" - " + (0, $9yWe2.MatchUtil).getLocalizedTime(data.data.time, data.data.date));
        } else if (data.data.stageName) {
            //console.log("complare "+data.data.stageName+" with "+data.data.leaguename+" = "+(data.data.stageName.trim() == data.data.leaguename.trim()));
            if (data.data.stageRound && data.data.stageName.trim() == data.data.leaguename.trim()) this.titleMiddle.addControl(data.data.stageRound);
            else {
                var splitData = data.data.stageName.split("-");
                if (splitData[1]) this.titleMiddle.addControl(splitData[1]);
                else this.titleMiddle.addControl(splitData[0]);
                if (splitData[2]) this.titleMiddle.addControl(" - " + splitData[2]);
                if (data.data.stageRound) this.titleMiddle.addControl(" - " + data.data.stageRound);
            }
            if (data.data.time && data.data.date) this.titleMiddle.addControl(" - " + (0, $9yWe2.MatchUtil).getLocalizedTime(data.data.time, data.data.date));
        }
        if (data.data.venue) this.titleBottom.addControl(data.data.venue);
        if (data.data.referee) //this.titleBottom.addControl("<br>" + Localizer.getString("referee") + ": " + data.data.referee);
        this.titleBottom.addControl(" - " + (0, $02mnx.Localizer).getString("referee") + ": " + data.data.referee);
        this.invalidateDisplay();
    }
    getIsSelectable() {
        return false;
    }
}
var $b3feca7ce224195e$exports = {};

$b3feca7ce224195e$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "football.906e411e.png";


var $8a3745c536ca60af$exports = {};

$8a3745c536ca60af$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "yellowcard.c501e054.png";


var $8ccec231deee3dd2$exports = {};

$8ccec231deee3dd2$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "subinout.f62c91f1.png";


var $0008cb34d0412506$exports = {};

$0008cb34d0412506$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "redcard.dc6a6e43.png";


var $955991979d8a6b1d$exports = {};

$955991979d8a6b1d$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "yellowredcard.072c2218.png";


var $82e4862489582b64$exports = {};

$82e4862489582b64$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "football_pen_miss.c1eb9941.png";



class $c07b1d3ba027f23b$export$5ee8aff078d2cc0e extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.card.setStyle("padding-bottom:4px;padding-top:6px;");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    setData(data) {
        super.setData(data);
        this.card.clear();
        // var title = new Panel();
        // title.addControl(Localizer.getString("match"));
        // title.addCssClass("MatchStatsTitleText")
        //
        // this.card.addControl(title);
        if (data.data.events) for(var i = 0; i < data.data.events.length; i++){
            var event1 = data.data.events[i];
            if (FootballManiaConfig.isRtl) {
                if (event1.team == "localteam") event1.team = "awayteam";
                else if (event1.team == "visitorteam") event1.team = "localteam";
            }
            //if (event.type == "subst") continue;
            var eventContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            eventContainer.addCssClass("MatchEventContainer");
            this.card.addControl(eventContainer);
            var subC = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            eventContainer.addControl(subC);
            if (AppInstance.getConfig().enabledFeatures.playerImages) {
                var playerImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
                subC.addControl(playerImage);
                if (event1.team == "localteam") {
                    subC.addCssClass("MatchStatsEventLocalTitleContainer");
                    playerImage.addCssClass("MatchStatsEventLocalPlayer");
                } else {
                    subC.addCssClass("MatchStatsEventAwayTitleContainer");
                    playerImage.addCssClass("MatchStatsEventAwayPlayer");
                }
            } else {
                if (event1.team == "localteam") subC.addCssClass("MatchStatsEventLocalTitleContainer");
                else subC.addCssClass("MatchStatsEventAwayTitleContainer");
                subC.setStyle("justify-content: flex-end;");
            }
            // var imageCon = new Panel();
            // imageCon.addCssClass("tshirt-container");
            // var image = new Panel();
            // imageCon.setStyle("width:"+imageSize+"px;height:"+imageSize+"px");
            // image.setStyle("position:absolute;width:"+imageSize+"px;height:"+imageSize+"px");
            // image.addCssClass("tshirt tshirt-home");
            //
            // var image2 = new Panel();
            // image2.addCssClass("tshirt tshirt-home");
            var playerNameCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            playerNameCon.addCssClass("MatchStatsEventPlayerNameContainer");
            if (event1.team == "localteam") playerNameCon.setStyle("margin-left:auto;text-align:right;");
            else playerNameCon.setStyle("margin-right:auto;text-align:left;");
            //playerNameCon.setStyle("align-items: flex-start");
            event1.player = event1.player.replaceAll("(pen.)", (0, $02mnx.Localizer).getString("penalty"));
            if (event1.type == "pen miss") {
                playerNameCon.addControl("<p class='MatchStatsEventPlayerName'>" + event1.player + "</p>");
                playerNameCon.addControl("<p class='MatchStatsEventPlayerAssist'>" + (0, $02mnx.Localizer).getString("missed_penalty") + "</p>");
            } else if (event1.assist) {
                if (event1.type == "var") {
                    playerNameCon.addControl("<p class='MatchStatsEventPlayerName'>" + event1.player + "</p>");
                    if (event1.assist.search(/offside/)) playerNameCon.addControl("<p class='MatchStatsEventPlayerAssist'>(" + (0, $02mnx.Localizer).getString("offside") + ")</p>");
                    else playerNameCon.addControl("<p class='MatchStatsEventPlayerAssist'>(" + event1.assist + ")</p>");
                } else if (event1.type == "subst") {
                    playerNameCon.addControl("<p class='MatchStatsEventPlayerSubin'>" + event1.player + "</p>");
                    playerNameCon.addControl("<p class='MatchStatsEventPlayerSubout'>" + event1.assist + "</p>");
                } else {
                    playerNameCon.addControl("<p class='MatchStatsEventPlayerName'>" + event1.player + "</p>");
                    playerNameCon.addControl("<p class='MatchStatsEventPlayerAssist'>(" + (0, $02mnx.Localizer).getString(event1.assist) + ")</p>");
                }
            } else playerNameCon.addControl("<p class='MatchStatsEventPlayerName'>" + event1.player + "</p>");
            subC.addControl(playerNameCon);
            var typeImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            if (event1.type == "goal") {
                typeImage.setImage(new URL($b3feca7ce224195e$exports));
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("goal"));
            } else if (event1.type == "yellowcard") {
                typeImage.setImage(new URL($8a3745c536ca60af$exports));
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("yellowcard"));
            } else if (event1.type == "subst") {
                typeImage.setImage(new URL($8ccec231deee3dd2$exports));
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("yellowcard"));
            } else if (event1.type == "redcard") {
                typeImage.setImage(new URL($0008cb34d0412506$exports));
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("redcard"));
            } else if (event1.type == "yellowred") {
                typeImage.setImage(new URL($955991979d8a6b1d$exports));
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("yellowredcard"));
            } else if (event1.type == "pen miss") {
                typeImage.setImage(new URL($82e4862489582b64$exports));
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("missed_penalty"));
            } else if (event1.type == "var") {
                typeImage.setImage(new URL($82e4862489582b64$exports));
                typeImage.setStyle("margin-top: -12px;");
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("var"));
                if (event1.team == "localteam") {
                    var prop = "right";
                    if (FootballManiaConfig.isRtl) prop = "left";
                } else {
                    var prop = "left";
                    if (FootballManiaConfig.isRtl) prop = "right";
                }
                subC.addControl("<div class='MatchEventVarContainer' style='" + prop + ":4px;'>VAR</div>");
            }
            typeImage.addCssClass("MatchStatsEventTypeImageContainer");
            subC.addControl(typeImage);
            var mid = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            mid.addCssClass("MatchEventsMinute");
            if ((0, $lU8CH.isNumeric)(event1.extra_min) && (0, $lU8CH.isNumeric)(event1.minute)) event1.minute = parseInt(event1.extra_min, 10) + parseInt(event1.minute, 10) + "";
            mid.addControl(event1.minute + "'");
            if (event1.result) mid.addControl("<br><p class='MatchStatsEventMinuteREsult'>" + event1.result.replaceAll(/\[|\]/g, "") + "</p>");
            eventContainer.addControl(mid);
            if (event1.playerId != null && event1.playerId != "" && event1.playerId != undefined) (function(playerId) {
                eventContainer.bind('click', function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(playerId);
                });
            })(event1.playerId);
            if (AppInstance.getConfig().enabledFeatures.playerImages) playerImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + event1.playerId + "_small_rnd.png");
        }
        this.invalidateDisplay();
    }
    getIsSelectable() {
        return false;
    }
}
class $c07b1d3ba027f23b$export$3497bc161ffc5f8 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
        this.localContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.localContainer.setStyle("display:flex;flex-direction:column;width: 50%;");
        this.visitorContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.visitorContainer.setStyle("display:flex;flex-direction:column;width: 50%;");
    }
    setData(data) {
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("sidelined_match"));
        title.addCssClass("MatchStatsTitleText");
        this.card.addControl(title);
        var subContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        subContainer.addCssClass("MatchSubstitutesContainer");
        subContainer.addControl(this.localContainer);
        subContainer.addControl(this.visitorContainer);
        this.card.addControl(subContainer);
        var localSubs = data.data.injuries.ltsl;
        var awaySubs = data.data.injuries.vtsl;
        for(var i = 0; i < localSubs.length; i++)this.createSideLinedItem(this.localContainer, localSubs[i]);
        for(var i = 0; i < awaySubs.length; i++)this.createSideLinedItem(this.visitorContainer, awaySubs[i], true);
    }
    createSideLinedItem(target, sub, reverse) {
        var subC = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        subC.setStyle("height:50px;display:flex;flex-direction:" + (reverse ? "row-reverse" : "normal") + ";align-items:center;justify-content:" + (reverse ? "end" : "start"));
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        var name = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        name.setStyle("margin-inline-start:4px;");
        if (reverse) name.setStyle("text-align:end;margin-inline-end:4px;");
        subC.addControl(image);
        subC.addControl(name);
        target.addControl(subC);
        image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + sub.id + "_small_rnd.png", 40, 40);
        image.setAttribute("width", "40px");
        image.setAttribute("height", "40px");
        var icon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        icon.tagName = "P";
        icon.addCssClass("playersidelinedicon");
        if (sub.status == "Yellow Cards") icon.addCssClass("soccercard yellow");
        else if (sub.status == "Red Card") icon.addCssClass("soccercard red");
        else if (sub.status == "Red Suspended") icon.addCssClass("soccercard black");
        else if (sub.status == "Loan agreement") ;
        else if (sub.status == "Suspended") sub.status = "suspended player";
        else icon.addCssClass("cross");
        if (!reverse) {
            icon.setStyle("margin-left:-10px;margin-top:-8px;width:12px;height:12px;");
            name.addControl(icon);
        }
        name.addControl(sub.name);
        if (reverse) {
            icon.setStyle("margin-left:-2px;margin-top:-8px;width:12px;height:12px;");
            name.addControl(icon);
        }
        name.addControl("<br><i style='font-size: 11px;'>" + (0, $02mnx.Localizer).getString(sub.status.toLowerCase()) + "</i>");
        //name.addControl("<br><i>"+(Localizer.getString(sub.status.toLowerCase().replace("/", "").replaceAll(" ", "")))+"</i>");
        subC.bind("click", function() {
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(sub.id);
        });
    }
}


class $c07b1d3ba027f23b$export$8529c6e54ea923d2 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.card.setStyle("padding-bottom:10px;");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
        this.panel.bind('click', ()=>{});
    }
    setData(data) {
        super.setData(data);
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("penalties") + " <br> " + (0, $9yWe2.MatchUtil).getLocalizedPenalty(data.data));
        title.addCssClass("MatchStatsTitleText");
        this.card.addControl(title);
        if (data.data.penalties) for(var i = 0; i < data.data.penalties.length; i++){
            var event1 = data.data.penalties[i];
            if (FootballManiaConfig.isRtl) {
                if (event1.team == "localteam") event1.team = "awayteam";
                else if (event1.team == "visitorteam") event1.team = "localteam";
            }
            var eventContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            eventContainer.addCssClass("MatchEventContainer");
            eventContainer.setStyle("float:none;");
            this.card.addControl(eventContainer);
            var subC = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            eventContainer.addControl(subC);
            var playerImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            subC.addControl(playerImage);
            if (event1.team == "localteam") {
                subC.addCssClass("MatchStatsEventLocalTitleContainer");
                playerImage.addCssClass("MatchStatsEventLocalPlayer");
            } else {
                subC.addCssClass("MatchStatsEventAwayTitleContainer");
                playerImage.addCssClass("MatchStatsEventAwayPlayer");
            }
            var playerNameCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            playerNameCon.addCssClass("MatchStatsEventPlayerNameContainer");
            event1.player = event1.player.replaceAll("(pen.)", (0, $02mnx.Localizer).getString(""));
            playerNameCon.addControl("<p class='MatchStatsEventPlayerName'>" + event1.player + "</p>");
            subC.addControl(playerNameCon);
            var typeImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            if (event1.scored == 1) {
                typeImage.setImage(new URL($b3feca7ce224195e$exports));
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("goal"));
            } else {
                typeImage.setImage(new URL($82e4862489582b64$exports));
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("var"));
            }
            typeImage.addCssClass("MatchStatsEventTypeImageContainer");
            subC.addControl(typeImage);
            var mid = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            mid.addCssClass("MatchEventsMinute");
            mid.addControl(event1.minute + "'");
            if (event1.result) mid.addControl("<br><p class='MatchStatsEventMinuteREsult'>" + event1.result.replaceAll(/\[|\]/g, "") + "</p>");
            eventContainer.addControl(mid);
            (function(playerId) {
                eventContainer.bind('click', function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(playerId);
                });
            })(event1.playerId);
            playerImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + event1.playerId + "_small_rnd.png");
        }
        this.invalidateDisplay();
    }
    getIsSelectable() {
        return false;
    }
}
class $c07b1d3ba027f23b$export$30d475e9cd83759e extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
        this.panel.bind('click', ()=>{});
    }
    setData(data) {
        this.card.clear();
        if (data.data.commentaries && data.data.commentaries.stats) {
            var oldStatsLocal = data.data.commentaries.stats.localteam;
            var newStatsLocal = {
                possestiontime: oldStatsLocal.possestiontime,
                shotstotal: oldStatsLocal.shotstotal,
                shotsgoal: oldStatsLocal.shotsgoal,
                shotsgoalmissed: oldStatsLocal.shotsgoalmissed,
                shotsgoalblocked: oldStatsLocal.shotsgoalblocked,
                fouls: oldStatsLocal.fouls,
                corners: oldStatsLocal.corners,
                offsides: oldStatsLocal.offsides,
                yellowcards: oldStatsLocal.yellowcards,
                redcards: oldStatsLocal.redcards,
                saves: oldStatsLocal.saves,
                passestotal: oldStatsLocal.passestotal,
                passesaccurate: oldStatsLocal.passesaccurate
            };
            var oldStatsAway = data.data.commentaries.stats.visitorteam;
            var newStatsAway = {
                possestiontime: oldStatsAway.possestiontime,
                shotstotal: oldStatsAway.shotstotal,
                shotsgoal: oldStatsAway.shotsgoal,
                shotsgoalmissed: oldStatsAway.shotsgoalmissed,
                shotsgoalblocked: oldStatsAway.shotsgoalblocked,
                fouls: oldStatsAway.fouls,
                corners: oldStatsAway.corners,
                offsides: oldStatsAway.offsides,
                yellowcards: oldStatsAway.yellowcards,
                redcards: oldStatsAway.redcards,
                saves: oldStatsAway.saves,
                passestotal: oldStatsAway.passestotal,
                passesaccurate: oldStatsAway.passesaccurate
            };
            // if (FootballManiaConfig.isRtl){
            //     var temp = newStatsLocal;
            //     newStatsLocal = newStatsAway;
            //     newStatsAway = temp;
            // }
            //for (var statlt in data.data.commentaries.stats.localteam){
            for(var statlt in newStatsLocal){
                var localStat = newStatsLocal[statlt];
                var awayStat = newStatsAway[statlt];
                var statContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                statContainer.addCssClass("MatchComStatsContainer");
                var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                title.addCssClass("MatchComStatsTitle");
                title.addControl("<p style='padding-inline-start:20px'>" + localStat + "</p><p>" + (0, $02mnx.Localizer).getString(statlt) + "</p><p style='padding-inline:20px'>" + awayStat + "</p>");
                var barContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                barContainer.addCssClass("MatchComStatsBarContainer");
                var barLocal = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                barLocal.addCssClass("MatchComStatsBarLocal");
                var barAway = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                barAway.addCssClass("MatchComStatsBarAway");
                if (localStat == undefined || awayStat == undefined || localStat == "" || awayStat == "") {
                    console.error("unhandable sats ", statlt, localStat, awayStat);
                    continue;
                }
                localStat = localStat.replace("%", "");
                awayStat = awayStat.replace("%", "");
                //console.log(title,barLocal,barAway,localStat,awayStat);
                if (!isNaN(localStat) && !isNaN(awayStat)) {
                    this.card.addControl(statContainer);
                    statContainer.addControl(title);
                    statContainer.addControl(barContainer);
                    barContainer.addControl(barLocal);
                    barContainer.addControl(barAway);
                    localStat = parseInt(localStat);
                    awayStat = parseInt(awayStat);
                    var total = localStat + awayStat;
                    barLocal.setCss({
                        'width': localStat / total * 40 + "%",
                        "right": "50%"
                    });
                    barAway.setCss({
                        'width': awayStat / total * 40 + "%",
                        "left": "50%"
                    });
                } else console.error("unhandable #2 sats ", statlt, localStat, awayStat);
            }
        }
        this.invalidateDisplay();
    // console.log("set data",data);
    }
    getIsSelectable() {
        return false;
    }
}
class $c07b1d3ba027f23b$export$896fb244188045c5 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        if (AppInstance.getConfig().isAndroid || AppInstance.getConfig().isWebStandalone) this.fieldRatio = 1.5625;
        else this.fieldRatio = 125 / 93;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("");
        this.field = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.field.addCssClass("MatchField");
        this.field.addCssClass("footballField");
        this.playerContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerContainer.addCssClass("MatchLineupPlayerContainer");
        this.topNotice = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.topNotice.addCssClass("MatchLineupNotice MatchLineupPredictedTitle");
        this.topNotice.addControl((0, $02mnx.Localizer).getString("predicted_lineups"));
        this.addControl(this.topNotice);
        var topPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topPanel.addCssClass("matchLineupTitleBlockHome");
        this.topLeftTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.topLeftTitle.addCssClass("matchLineupTitleTeam");
        this.topRightTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.topRightTitle.addCssClass("matchLineupTitleFormation");
        topPanel.addControl(this.topLeftTitle);
        topPanel.addControl(this.topRightTitle);
        var bottomPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        bottomPanel.addCssClass("matchLineupTitleBlockAway");
        this.bottomLeftTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.bottomLeftTitle.addCssClass("matchLineupTitleTeam");
        this.bottomRightTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.bottomRightTitle.addCssClass("matchLineupTitleFormation");
        bottomPanel.addControl(this.bottomLeftTitle);
        bottomPanel.addControl(this.bottomRightTitle);
        this.addControl(topPanel);
        this.addControl(this.playerContainer);
        this.addControl(this.field);
        this.addControl(bottomPanel);
    }
    createComponents() {
        var w = this.getPage().getDimensions().width;
        this.field.setCss({
            "width": "100%",
            "height": w * this.fieldRatio + "px"
        });
        this.createPlayers();
    }
    setData(data) {
        if (!this.getPage()) {
            this.data = data;
            return;
        }
    }
    createPlayers() {
        if (!this.data) return console.error("no data set for lineups");
        this.panel.clear();
        if (!this.data.data.commentaries.isPredicted) this.topNotice.setVisible(false);
        var data = this.data;
        var substitutionOffIds = [];
        var playerStatsById = {};
        //determine substitutions
        if (data.data.commentaries.substitutions) {
            if (data.data.commentaries.substitutions.localteam) for(var i = 0; i < data.data.commentaries.substitutions.localteam.length; i++){
                var sub = data.data.commentaries.substitutions.localteam[i];
                substitutionOffIds.push(sub.off_id);
            }
            if (data.data.commentaries.substitutions.visitorteam) for(var i = 0; i < data.data.commentaries.substitutions.visitorteam.length; i++){
                var sub = data.data.commentaries.substitutions.visitorteam[i];
                substitutionOffIds.push(sub.off_id);
            }
        }
        if (data.data.commentaries.playerstats && data.data.commentaries.playerstats.localteam && data.data.commentaries.playerstats.localteam.length > 0 && data.data.commentaries.playerstats && data.data.commentaries.playerstats.visitorteam && data.data.commentaries.playerstats.visitorteam.length > 0) {
            for(var i = 0; i < data.data.commentaries.playerstats.localteam.length; i++){
                var player = data.data.commentaries.playerstats.localteam[i];
                playerStatsById[player.id] = player;
            }
            for(var i = 0; i < data.data.commentaries.playerstats.visitorteam.length; i++){
                var player = data.data.commentaries.playerstats.visitorteam[i];
                playerStatsById[player.id] = player;
            }
        }
        //do some manual lineup fixing for in case we dont have v3 lineups, but v2
        //todo: also fix when no v2, but v1 is available
        if (!this.data.data.commentaries.teams.visitorFormationTypeV3) {
            //if we have old known type
            if (!this.data.data.commentaries.teams.visitorFormationType2 && this.data.data.commentaries.teams.visitorFormationType) this.data.data.commentaries.teams.visitorFormationType2 = this.data.data.commentaries.teams.visitorFormationType;
            //if we have no type we try to guess it
            if (!this.data.data.commentaries.teams.visitorFormationType2) {
                var prevPos = "";
                var posIndex = -1;
                var posTypeCount = [];
                for(var i = 1; i < data.data.commentaries.teams.visitorteam.length; i++){
                    if (prevPos != data.data.commentaries.teams.visitorteam[i].pos) {
                        posIndex++;
                        posTypeCount[posIndex] = 1;
                    } else posTypeCount[posIndex]++;
                    prevPos = data.data.commentaries.teams.visitorteam[i].pos;
                }
                if (posTypeCount.length == 3) {
                    var formationType = posTypeCount[0] + "-" + posTypeCount[1] + "-" + posTypeCount[2];
                    this.data.data.commentaries.teams.visitorFormationType2 = formationType;
                } else {
                    console.warn("unable to determine linups localteam, use default");
                    this.data.data.commentaries.teams.visitorFormationType2 = "4-3-3";
                }
            }
            if (this.data.data.commentaries.teams.visitorFormationType2) {
                this.data.data.commentaries.teams.visitorFormationTypeV3 = this.data.data.commentaries.teams.visitorFormationType2;
                var split = this.data.data.commentaries.teams.visitorFormationType2.split("-");
                var hCount = split.length;
                this.data.data.commentaries.teams.visitorteam[0].x = 0.5;
                this.data.data.commentaries.teams.visitorteam[0].y = 0.05;
                var pCount = 1;
                var hHeight = 1 / split.length;
                var curHHeight = hHeight;
                for(var i = 0; i < split.length; i++){
                    //console.log(split[i]);
                    var wStart = 1;
                    var playerLineCount = parseInt(split[i]);
                    for(var j = 0; j < split[i]; j++){
                        wStart -= 1 / (playerLineCount + 1);
                        this.data.data.commentaries.teams.visitorteam[pCount].x = wStart;
                        this.data.data.commentaries.teams.visitorteam[pCount].y = curHHeight;
                        //console.log("->",playerLineCount,pCount,hHeight,1/(playerLineCount+1),wStart);
                        pCount++;
                    }
                    curHHeight += hHeight;
                }
            }
        }
        if (!this.data.data.commentaries.teams.localFormationTypeV3) {
            if (!this.data.data.commentaries.teams.localFormationTypeV2 && this.data.data.commentaries.teams.localFormationType) this.data.data.commentaries.teams.localFormationType2 = this.data.data.commentaries.teams.localFormationType;
            //if we have no type we try to guess it
            if (!this.data.data.commentaries.teams.localFormationType2) {
                console.log("do something");
                var prevPos = "";
                var posIndex = -1;
                var posTypeCount = [];
                for(var i = 1; i < data.data.commentaries.teams.localteam.length; i++){
                    if (prevPos != data.data.commentaries.teams.localteam[i].pos) {
                        posIndex++;
                        posTypeCount[posIndex] = 1;
                    } else posTypeCount[posIndex]++;
                    prevPos = data.data.commentaries.teams.localteam[i].pos;
                }
                if (posTypeCount.length == 3) {
                    var formationType = posTypeCount[0] + "-" + posTypeCount[1] + "-" + posTypeCount[2];
                    this.data.data.commentaries.teams.localFormationType2 = formationType;
                } else {
                    console.warn("unable to determine linups localteam, use default");
                    this.data.data.commentaries.teams.localFormationType2 = "4-3-3";
                }
            }
            //if we have old known type
            if (this.data.data.commentaries.teams.localFormationType2) {
                this.data.data.commentaries.teams.localFormationTypeV3 = this.data.data.commentaries.teams.localFormationType2;
                var split = this.data.data.commentaries.teams.localFormationType2.split("-");
                this.data.data.commentaries.teams.localteam[0].x = 0.5;
                this.data.data.commentaries.teams.localteam[0].y = 0.05;
                var pCount = 1;
                var hHeight = 1 / split.length;
                var curHHeight = hHeight;
                for(var i = 0; i < split.length; i++){
                    //console.log(split[i]);
                    var wStart = 1;
                    var playerLineCount = parseInt(split[i]);
                    for(var j = 0; j < split[i]; j++){
                        wStart -= 1 / (playerLineCount + 1);
                        this.data.data.commentaries.teams.localteam[pCount].x = wStart;
                        this.data.data.commentaries.teams.localteam[pCount].y = curHHeight;
                        //console.log("->",playerLineCount,pCount,hHeight,1/(playerLineCount+1),wStart);
                        pCount++;
                    }
                    curHHeight += hHeight;
                }
            }
        }
        var targettedHeight = this.getPage().getDimensions().width * this.fieldRatio;
        var blockSize = 70;
        var blockWidth = blockSize * 1.4;
        var imageSize = 40;
        this.topLeftTitle.addControl("<p>" + this.data.data.localteam);
        if (this.data.data.coachLocal) this.topLeftTitle.addControl("</p> &nbsp;<p> (" + this.data.data.coachLocal + "</p>)");
        this.topRightTitle.addControl("<p>" + this.data.data.commentaries.teams.localFormationTypeV3 + "</p>");
        this.bottomLeftTitle.addControl("<p>" + this.data.data.visitorteam);
        if (this.data.data.coachVisitor) this.bottomLeftTitle.addControl("</p> &nbsp;<p> (" + this.data.data.coachVisitor + "</p>)");
        this.bottomRightTitle.addControl("<p>" + this.data.data.commentaries.teams.visitorFormationTypeV3 + "</p>");
        for(var i = 0; i < data.data.commentaries.teams.localteam.length; i++){
            var player = data.data.commentaries.teams.localteam[i];
            //console.log(targettedHeight,player.y);
            var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            p.addCssClass("MatchLineupBlockContainer");
            var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            title.addCssClass("MatchLineupBlockTitle");
            title.addControl(player.name);
            var imageCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            imageCon.addCssClass("tshirt-container");
            var image = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            imageCon.setStyle("width:" + imageSize + "px;height:" + imageSize + "px");
            image.setStyle("position:absolute;width:" + imageSize + "px;height:" + imageSize + "px");
            image.addCssClass("tshirt tshirt-home");
            var image2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            image2.addCssClass("tshirt tshirt-home");
            if (playerStatsById[player.id]) {
                if (playerStatsById[player.id].rating) {
                    var ratingPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                    var rating = playerStatsById[player.id].rating;
                    ratingPanel.addCssClass("MatchLineupPlayerRating");
                    imageCon.addControl(ratingPanel);
                    ratingPanel.addControl(rating);
                    if (rating < 5.5) ratingPanel.addCssClass("MatchLineupPlayerRatingBad");
                    else if (rating < 6.5) ratingPanel.addCssClass("MatchLineupPlayerRatingOkaish");
                    else if (rating < 7) ratingPanel.addCssClass("MatchLineupPlayerRatingAvarage");
                    else if (rating < 8.5) ratingPanel.addCssClass("MatchLineupPlayerRatingGood");
                    else ratingPanel.addCssClass("MatchLineupPlayerRatingExcellent");
                }
                if (playerStatsById[player.id].goals) {
                    var goalPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                    goalPanel.addCssClass("MatchLineupPlayerGoal");
                    imageCon.addControl(goalPanel);
                }
            }
            if (substitutionOffIds.indexOf(player.id) != -1) {
                var offIcon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                offIcon.addCssClass("icon-arrow-out");
                offIcon.setStyle("width:25px; height:25px;position:absolute;top:-15px;right:-7px;z-index:1000;");
                imageCon.addControl(offIcon);
            // (function(imageCon,offIcon){
            //     var r = 180;
            //     setTimeout(function(){
            //         jQuery("#"+imageCon.getClientId()).bind("animationend transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(){
            //
            //             setTimeout(function(){
            //                 if (r == 180){
            //                     r = 0
            //                 }
            //                 else{
            //                     r = 180;
            //                 }
            //                 //jQuery("#"+imageCon.getClientId()).css({"transform":"rotateY("+r+"deg)","transition-duration": "1000ms"});
            //
            //                 if (r == 180) {
            //                     imageCon.removeCssClass("tshirt-container-flip-show-off")
            //                     imageCon.addCssClass("tshirt-container-flip-show-in")
            //                 }
            //                 else{
            //                     imageCon.removeCssClass("tshirt-container-flip-show-in")
            //                     imageCon.addCssClass("tshirt-container-flip-show-off")
            //                 }
            //
            //                 setTimeout(function(){
            //                     // // console.log("rrrr",r)
            //                     // if (r == 0){
            //                     //     offIcon.removeCssClass("icon-arrow-in");
            //                     // }
            //                     // else{
            //                     //     offIcon.addCssClass("icon-arrow-in");
            //                     // }
            //                 },500);
            //
            //             },1000)
            //         });
            //         imageCon.addCssClass("tshirt-container-flip-show-in")
            //     },1000);
            // })(imageCon,offIcon);
            }
            image.addControl(player.number);
            image.setAttribute("alt", (0, $02mnx.Localizer).getString("t-shirt"));
            //image.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/playerimages/"+player.id+"_small_rnd.png");
            p.addControl(imageCon);
            imageCon.addControl(image);
            p.addControl(title);
            if (data.data.commentaries.localteamcolor) {
                image.setStyle("color:#" + data.data.commentaries.localteamnumbercolor + ";background-color:#" + data.data.commentaries.localteamcolor);
                image2.setStyle("opacity:0.3;background-color:#" + data.data.commentaries.localteamnumbercolor + ";top:-1px;left:-1px;z-index:-1;position:absolute;width:" + (imageSize + 2) + "px;height:" + (imageSize + 2) + "px");
                imageCon.addControl(image2);
            }
            var top = player.y * (targettedHeight / 2 - blockSize);
            p.setCss({
                "top": top + "px",
                "left": "calc(" + (100 - player.x * 100) + "% - " + blockWidth / 2 + "px)",
                "width": blockWidth + "px",
                "height": blockSize + "px",
                "position": "absolute"
            });
            this.playerContainer.addControl(p);
            (function(playerId) {
                p.bind('click', function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(playerId);
                });
            })(player.id);
        }
        for(var i = 0; i < data.data.commentaries.teams.visitorteam.length; i++){
            var player = data.data.commentaries.teams.visitorteam[i];
            var top = targettedHeight / 2 + (1 - player.y) * (targettedHeight / 2 - blockSize);
            var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            p.addCssClass("MatchLineupBlockContainer");
            var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            title.addCssClass("MatchLineupBlockTitle");
            title.addControl(player.name);
            var imageCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            imageCon.addCssClass("tshirt-container");
            var image = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            image.setStyle("width:" + imageSize + "px;height:" + imageSize + "px");
            image.addCssClass("tshirt tshirt-away");
            var image2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            image2.addCssClass("tshirt tshirt-away");
            if (playerStatsById[player.id]) {
                if (playerStatsById[player.id].rating) {
                    var ratingPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                    var rating = playerStatsById[player.id].rating;
                    ratingPanel.addCssClass("MatchLineupPlayerRating");
                    imageCon.addControl(ratingPanel);
                    ratingPanel.addControl(rating);
                    if (rating < 5.5) ratingPanel.addCssClass("MatchLineupPlayerRatingBad");
                    else if (rating < 6.5) ratingPanel.addCssClass("MatchLineupPlayerRatingOkaish");
                    else if (rating < 7) ratingPanel.addCssClass("MatchLineupPlayerRatingAvarage");
                    else if (rating < 8.5) ratingPanel.addCssClass("MatchLineupPlayerRatingGood");
                    else ratingPanel.addCssClass("MatchLineupPlayerRatingExcellent");
                }
                if (playerStatsById[player.id].goals) {
                    var goalPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                    goalPanel.addCssClass("MatchLineupPlayerGoal");
                    imageCon.addControl(goalPanel);
                }
            }
            if (substitutionOffIds.indexOf(player.id) != -1) {
                var offIcon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                offIcon.addCssClass("icon-arrow-out");
                offIcon.setStyle("width:25px; height:25px;position:absolute;top:-15px;right:-7px;z-index:1000;");
                imageCon.addControl(offIcon);
            }
            image.addControl(player.number);
            //image.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/playerimages/"+player.id+"_small_rnd.png");
            p.addControl(imageCon);
            imageCon.addControl(image);
            p.addControl(title);
            if (data.data.commentaries.visitorteamcolor) {
                //image.setStyle("background-color:#"+data.data.commentaries.visitorteamcolor)
                image.setStyle("color:#" + data.data.commentaries.visitorteamnumbercolor + ";background-color:#" + data.data.commentaries.visitorteamcolor);
                image2.setStyle("opacity:0.3;background-color:#" + data.data.commentaries.visitorteamnumbercolor + ";top:-1px;left:-1px;z-index:-1;position:absolute;width:" + (imageSize + 2) + "px;height:" + (imageSize + 2) + "px");
                imageCon.addControl(image2);
            }
            p.setCss({
                "top": top + "px",
                "left": "calc(" + player.x * 100 + "% - " + blockWidth / 2 + "px)",
                "width": blockWidth + "px",
                "height": blockSize + "px",
                "position": "absolute"
            });
            this.playerContainer.addControl(p);
            (function(playerId) {
                p.bind('click', function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(playerId);
                });
            })(player.id);
        }
        this.invalidateDisplay();
    }
    updateDisplay() {
    //var w = this.panel.getDimensions().width;
    // console.log(this.panel.getDimensions());
    //this.field.setCss({"width":(w-200)+"px","height":w*this.fieldRatio+"px"});
    }
}
class $c07b1d3ba027f23b$export$4e99bc92372e6aba extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    setData(data) {
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("substitutions"));
        title.addCssClass("MatchStatsTitleText");
        this.card.addControl(title);
        this.localContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.visitorContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addControl(this.localContainer);
        this.card.addControl(this.visitorContainer);
        var localSubs = data.data.commentaries.substitutions.localteam;
        var awaySubs = data.data.commentaries.substitutions.visitorteam;
        var allSubs = [];
        for(var i = 0; i < localSubs.length; i++){
            localSubs[i].team = "localteam";
            allSubs.push(localSubs[i]);
        }
        for(var i = 0; i < awaySubs.length; i++){
            awaySubs[i].team = "awayteam";
            allSubs.push(awaySubs[i]);
        }
        allSubs.sort(function(a, b) {
            return b.minute - a.minute;
        });
        for(var i = 0; i < allSubs.length; i++){
            var event1 = allSubs[i];
            var float = "";
            //var float = "right"
            event1.team;
            var eventContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            eventContainer.addCssClass("MatchSubstitutionsContainer");
            eventContainer.setStyle("float:" + float + ";height:80px;");
            this.card.addControl(eventContainer);
            var subC = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            eventContainer.addControl(subC);
            var playerInContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            var playerOutContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            if (event1.team == "localteam") {
                playerInContainer.addCssClass("MatchSubstitutionsPlayerLocalContainer");
                playerOutContainer.addCssClass("MatchSubstitutionsPlayerLocalContainer");
            } else {
                playerInContainer.addCssClass("MatchSubstitutionsPlayerAwayContainer");
                playerOutContainer.addCssClass("MatchSubstitutionsPlayerAwayContainer");
            }
            for(var j = 0; j < 2; j++){
                if (j == 0) {
                    var targetCon = playerInContainer;
                    var d = {
                        minute: event1.minute,
                        player: event1.on,
                        id: event1.on_id,
                        injury: event1.injury == "True" ? true : false,
                        "css": "icon-subout-in"
                    };
                } else {
                    targetCon = playerOutContainer;
                    d = {
                        minute: event1.minute,
                        player: event1.off,
                        id: event1.off_id,
                        injury: event1.injury == "True" ? true : false,
                        "css": "icon-subout-out"
                    };
                }
                var playerImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
                targetCon.addControl(playerImage);
                var playerNameCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                playerNameCon.addCssClass("MatchStatsEventPlayerNameContainer");
                playerNameCon.addControl("<p class='MatchStatsEventPlayerName'>" + d.player + "</p>");
                targetCon.addControl(playerNameCon);
                var typeImage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                typeImage.addCssClass(d.css);
                typeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("Substitution"));
                typeImage.addCssClass("MatchStatsEventTypeImageContainer");
                targetCon.addControl(typeImage);
                playerImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + d.id + "_small_rnd.png");
                if (FootballManiaConfig.isRtl) {
                    if (event1.team == "localteam") {
                        subC.addCssClass("MatchSubstitutionsContainerAway");
                        playerImage.addCssClass("MatchStatsEventAwayPlayer");
                    } else {
                        subC.addCssClass("MatchSubstitutionsContainerLocal");
                        playerImage.addCssClass("MatchStatsEventLocalPlayer");
                    }
                } else if (event1.team == "localteam") {
                    subC.addCssClass("MatchSubstitutionsContainerLocal");
                    playerImage.addCssClass("MatchStatsEventLocalPlayer");
                } else {
                    subC.addCssClass("MatchSubstitutionsContainerAway");
                    playerImage.addCssClass("MatchStatsEventAwayPlayer");
                }
            }
            subC.addControl(playerInContainer);
            subC.addControl(playerOutContainer);
            var mid = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            //mid.setStyle("float:"+float);
            mid.addCssClass("MatchEventsMinute");
            mid.addControl(d.minute + "'");
            if (event1.result) mid.addControl("<br><p class='MatchStatsEventMinuteREsult'>" + event1.result.replaceAll(/\[|\]/g, "") + "</p>");
            eventContainer.addControl(mid);
            (function(playerOnId, playerOffId) {
                playerInContainer.bind('click', function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(playerOnId);
                });
                playerOutContainer.bind('click', function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(playerOffId);
                });
            })(event1.on_id, event1.off_id);
        }
    }
}
class $c07b1d3ba027f23b$export$fb81826a29f0b863 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
        this.localContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.localContainer.setStyle("display:flex;flex-direction:column;width: 50%;");
        this.visitorContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.visitorContainer.setStyle("display:flex;flex-direction:column;width: 50%;");
    }
    setData(data) {
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("substitutes"));
        title.addCssClass("MatchStatsTitleText");
        this.card.addControl(title);
        var subContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        subContainer.addCssClass("MatchSubstitutesContainer");
        subContainer.addControl(this.localContainer);
        subContainer.addControl(this.visitorContainer);
        this.card.addControl(subContainer);
        var localSubs = data.data.commentaries.substitutes.localteam;
        var awaySubs = data.data.commentaries.substitutes.visitorteam;
        for(var i = 0; i < localSubs.length; i++)this.createSubstituteItem(this.localContainer, localSubs[i]);
        for(var i = 0; i < awaySubs.length; i++)this.createSubstituteItem(this.visitorContainer, awaySubs[i], true);
    }
    createSubstituteItem(target, sub, reverse) {
        var subC = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        subC.setStyle("height:50px;display:flex;flex-direction:" + (reverse ? "row-reverse" : "normal") + ";align-items:center;justify-content:" + (reverse ? "end" : "start"));
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        var name = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        name.setStyle("margin-inline-start:4px;");
        if (reverse) name.setStyle("text-align:end;margin-inline-end:4px;");
        subC.addControl(image);
        subC.addControl(name);
        target.addControl(subC);
        image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + sub.id + "_small_rnd.png", 40, 40);
        image.setAttribute("width", "40px");
        image.setAttribute("height", "40px");
        name.addControl(sub.name + "<br>");
        if (sub.pos == "F") name.addControl("<i>" + (0, $02mnx.Localizer).getString("attacker") + "</i>");
        if (sub.pos == "D") name.addControl("<i>" + (0, $02mnx.Localizer).getString("defender") + "</i>");
        if (sub.pos == "M") name.addControl("<i>" + (0, $02mnx.Localizer).getString("midfielder") + "</i>");
        if (sub.pos == "G") name.addControl("<i>" + (0, $02mnx.Localizer).getString("goalkeeper") + "</i>");
        subC.bind("click", function() {
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(sub.id);
        });
    }
}
class $c07b1d3ba027f23b$export$d6dfff3781b604d3 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    setData(data) {
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("h2h"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var totalPlayed = data.data.stats.total_draws + data.data.stats.total_localteam_won + data.data.stats.total_visitorteam_won;
        var homePercentage = data.data.stats.total_localteam_won / totalPlayed * 100;
        var drawPercentage = data.data.stats.total_draws / totalPlayed * 100;
        var awayPercentage = data.data.stats.total_visitorteam_won / totalPlayed * 100;
        var statsPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        statsPanel.addCssClass("MatchH2HStatsContainer");
        var homeWins = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        homeWins.addCssClass("pie no-round");
        this.firstTime;
        homeWins.setStyle("--p:" + homePercentage + ";--c:lightgreen");
        homeWins.addControl(data.data.stats.total_localteam_won + "<br>" + (0, $02mnx.Localizer).getString("table_wins_full"));
        statsPanel.addControl(homeWins);
        var draws = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        draws.addCssClass("pie no-round");
        this.firstTime;
        draws.setStyle("--p:" + drawPercentage + ";--c:lightgreen");
        draws.addControl(data.data.stats.total_draws + "<br>" + (0, $02mnx.Localizer).getString("table_draw_full"));
        statsPanel.addControl(draws);
        var awayWins = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        awayWins.addCssClass("pie no-round");
        this.firstTime;
        awayWins.setStyle("--p:" + awayPercentage + ";--c:lightgreen");
        awayWins.addControl(data.data.stats.total_visitorteam_won + "<br>" + (0, $02mnx.Localizer).getString("table_wins_full"));
        statsPanel.addControl(awayWins);
        this.card.addControl(statsPanel);
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("previous_matches"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var listType = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType();
        for(var i = 0; i < data.data.h2hMatches.length; i++){
            var info = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            info.addCssClass("MatchH2HMatchTitleContainer");
            info.addControl("<p>" + (0, $9yWe2.MatchUtil).getLocalizedDate(data.data.h2hMatches[i]) + "</p>");
            data.data.h2hMatches[i].leaguename = (0, $lU8CH.RemoveReservedIfNeeded)(data.data.h2hMatches[i].leaguename);
            info.addControl("<p>" + data.data.h2hMatches[i].leaguename + "</p>");
            //console.log(data.data.h2hMatches[i]);
            var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            var render = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)();
            render.hideBell = true;
            var listRenderHeight = 70;
            if (listType == "3") {
                var itemHeight = 70;
                listRenderHeight += 20;
            } else itemHeight = 55;
            p.setStyle("width:100%;height:" + listRenderHeight + "px;position:relative;");
            data.data.h2hMatches[i].style = {
                height: itemHeight
            };
            render.setData(data.data.h2hMatches[i], false, true);
            p.addControl(info);
            p.addControl(render);
            this.card.addControl(p);
        }
        this.firstTime = false;
    }
}
class $c07b1d3ba027f23b$export$f55f717a57039365 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.card.setStyle("padding-top:4px;padding-bottom:10px;");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    setData(data) {
        this.data = data;
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.setStyle("line-height: 17px;");
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        title.addControl((0, $02mnx.Localizer).getString("aggregate") + "<br>" + (0, $9yWe2.MatchUtil).getLocalizedAggregateScore(data.data).replace(/[{()}]/g, ''));
        var previousScore = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //previousScore.addControl(MatchUtil.getLocalizedAggregateScore(data.data));
        this.card.addControl(previousScore);
        var aggregateMatches = [];
        for(var i = 0; i < data.data.aggregate.matches.length; i++)if (data.data.aggregate.matches[i] != data.data.id) aggregateMatches.push(data.data.aggregate.matches[i]);
        for(var i = 0; i < aggregateMatches.length; i++){
            var aggregateMatch = null;
            if (data.data.h2hMatches) {
                //look up match in h2h matches
                for(var j = 0; j < data.data.h2hMatches.length; j++)if (data.data.h2hMatches[j].id == aggregateMatches[i]) aggregateMatch = data.data.h2hMatches[j];
            }
            if (!aggregateMatch) continue;
            var info = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            info.addCssClass("MatchH2HMatchTitleContainer");
            info.setStyle("justify-content: center;");
            info.addControl("<p>" + (0, $9yWe2.MatchUtil).getLocalizedDate(aggregateMatch) + "</p>");
            var height = 70;
            if ((0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType() == "1") height = 50;
            var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            p.setStyle("width:100%;height:" + (height + 20) + "px;position:relative;");
            var render = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)(true);
            render.hideBell = true;
            aggregateMatch.style = {
                height: height
            };
            render.setData(aggregateMatch, false, true);
            p.addControl(info);
            p.addControl(render);
            this.card.addControl(p);
        }
    }
}
class $c07b1d3ba027f23b$export$6c66ad1fdb5757ea extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    createEmptyChart(userVote) {
        var homeResult = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        homeResult.addCssClass("MatchVoteChart");
        homeResult.setCss({
            "height": "1px"
        });
        if (userVote == 0) homeResult.addCssClass("MatchVoteChartIsVotedByUser");
        var drawResult = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        drawResult.addCssClass("MatchVoteChart");
        drawResult.setCss({
            "height": "1px"
        });
        if (userVote == 2) drawResult.addCssClass("MatchVoteChartIsVotedByUser");
        var awayResult = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        awayResult.addCssClass("MatchVoteChart");
        awayResult.setCss({
            "height": "1px"
        });
        if (userVote == 1) awayResult.addCssClass("MatchVoteChartIsVotedByUser");
        this.homeResult = homeResult;
        this.drawResult = drawResult;
        this.awayResult = awayResult;
        this.chartContainer.addCssClass("MatchVoteChartContainer");
        this.chartContainer.addControl(homeResult);
        this.chartContainer.addControl(drawResult);
        this.chartContainer.addControl(awayResult);
        this.chartContainer.invalidateDisplay();
    }
    createVoteButtons() {
        this.voteHome = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.voteHome.addCssClass("MatchVoteButton");
        this.voteHome.addControl(this.data.data.localteam);
        this.voteDraw = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.voteDraw.addCssClass("MatchVoteButton");
        this.voteDraw.addControl((0, $02mnx.Localizer).getString("draw"));
        this.voteAway = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.voteAway.addCssClass("MatchVoteButton");
        this.voteAway.addControl(this.data.data.visitorteam);
        this.voteHome.bind("click", ()=>{
            this.voteData.home += 1;
            (0, $ce9390ea20c7ac7b$export$bf48777cc692e18f).voteMatch(this.data.data.id, 0);
            this.chartContainer.setVisible(true);
            this.buttonContainer.setVisible(false);
            this.createEmptyChart();
            this.updateChart(true, 0);
        });
        this.voteDraw.bind("click", ()=>{
            this.voteData.draw += 1;
            (0, $ce9390ea20c7ac7b$export$bf48777cc692e18f).voteMatch(this.data.data.id, 2);
            this.chartContainer.setVisible(true);
            this.buttonContainer.setVisible(false);
            this.createEmptyChart();
            this.updateChart(true, 1);
        });
        this.voteAway.bind("click", ()=>{
            this.voteData.away += 1;
            (0, $ce9390ea20c7ac7b$export$bf48777cc692e18f).voteMatch(this.data.data.id, 1);
            this.chartContainer.setVisible(true);
            this.buttonContainer.setVisible(false);
            this.createEmptyChart();
            this.updateChart(true, 2);
        });
    }
    updateChart(forceShowResult, highLightSide) {
        var voteData = this.voteData;
        this.voteContainer.clear();
        if (forceShowResult || (0, $9yWe2.MatchUtil).isFinished(this.data.data)) {
            this.homeResult.addControl("<p style='margin-top:-20px;text-align: center'>" + voteData.home + " " + "</p>", true);
            this.homeResult.setCss({
                "height": +(voteData.home / (voteData.home + voteData.away + voteData.draw) * 100) + "%"
            });
            if (highLightSide == 0) this.homeResult.addCssClass("MatchVoteChartIsVotedByUser");
            this.drawResult.addControl("<p style='margin-top:-20px;text-align: center'>" + voteData.draw + " " + "</p>", true);
            this.drawResult.setCss({
                "height": +(voteData.draw / (voteData.home + voteData.away + voteData.draw) * 100) + "%"
            });
            if (highLightSide == 1) this.drawResult.addCssClass("MatchVoteChartIsVotedByUser");
            this.awayResult.addControl("<p style='margin-top:-20px;text-align: center'>" + voteData.away + " " + "</p>", true);
            this.awayResult.setCss({
                "height": +(voteData.away / (voteData.home + voteData.away + voteData.draw) * 100) + "%"
            });
            if (highLightSide == 2) this.awayResult.addCssClass("MatchVoteChartIsVotedByUser");
            this.voteContainer.addControl("<p class='matchVoteResult' style=width:28%;>" + this.data.data.localteam + "</p>");
            this.voteContainer.addControl("<p class='matchVoteResult' style=width:28%;>" + (0, $02mnx.Localizer).getString("draw") + "</p>");
            this.voteContainer.addControl("<p class='matchVoteResult' style=width:28%;>" + this.data.data.visitorteam + "</p>");
        //buttonContainer.invalidateDisplay();
        } else {
            this.voteContainer.addControl("<p class='matchVoteResult' style=width:28%;>" + voteData.home + " " + (0, $02mnx.Localizer).getString("votes") + "</p>");
            this.voteContainer.addControl("<p class='matchVoteResult' style=width:28%;>" + voteData.draw + " " + (0, $02mnx.Localizer).getString("votes") + "</p>");
            this.voteContainer.addControl("<p class='matchVoteResult' style=width:28%;>" + voteData.away + " " + (0, $02mnx.Localizer).getString("votes") + "</p>");
        }
        this.voteContainer.invalidateDisplay();
    }
    loadVoteResults(showChart) {
        (0, $kc8Kt.DataProvider).getMatchVotes(this.data.data.id, (response)=>{
            if (!response.isOk()) return;
            this.voteData = response.getData();
            this.updateChart(showChart);
        });
    }
    setData(data) {
        this.data = data;
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        this.buttonContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.buttonContainer.addCssClass("MatchVoteContainer");
        this.chartContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.chartContainer.addCssClass("MatchVoteContainer");
        this.voteContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.voteContainer.addCssClass("MatchVoteContainer");
        var userVote = (0, $ce9390ea20c7ac7b$export$bf48777cc692e18f).getVote(data.data.id);
        if (userVote != undefined) {
            title.addControl((0, $02mnx.Localizer).getString("already_voted"));
            this.createEmptyChart(userVote);
            this.loadVoteResults(true);
            this.buttonContainer.setVisible(false);
        } else if ((0, $9yWe2.MatchUtil).isFinished(data.data)) {
            title.addControl((0, $02mnx.Localizer).getString("votes"));
            this.buttonContainer.setVisible(false);
            this.createEmptyChart();
            this.loadVoteResults();
        } else {
            title.addControl((0, $02mnx.Localizer).getString("voteMatch"));
            this.createVoteButtons();
            this.loadVoteResults();
            this.chartContainer.setVisible(false);
        //this.chartContainer.setVisible(false)
        }
        this.buttonContainer.addControl(this.voteHome);
        this.buttonContainer.addControl(this.voteDraw);
        this.buttonContainer.addControl(this.voteAway);
        this.card.addControl(this.buttonContainer);
        this.card.addControl(this.chartContainer);
        this.card.addControl(this.voteContainer);
    }
    updateDisplay() {}
}
class $c07b1d3ba027f23b$export$a2b99b374b9e2dae extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    setData(data) {
        super.setData(data);
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("standen"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        this.card.addControl("<table class='tableStandings'>");
        var groups = [
            data.data.localteamStanding,
            data.data.visitorteamStanding
        ];
        var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
        row.setStyle("height:25px;");
        var th1 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        var th1Arrow = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        var th2 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        th1Arrow.setAttribute("colspan", 3);
        th1Arrow.setStyle("text-align:left;padding-inline-start:4px;");
        var th3 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        var th4 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        th4.addControl((0, $02mnx.Localizer).getString("table_gamesplayed"));
        var th5 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        th5.addControl((0, $02mnx.Localizer).getString("table_wins"));
        var th6 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        th6.addControl((0, $02mnx.Localizer).getString("table_draw"));
        var th7 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        th7.addControl((0, $02mnx.Localizer).getString("table_lost"));
        var th8 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        th8.addControl((0, $02mnx.Localizer).getString("table_goalsforagainst"));
        th8.setStyle("min-width:50px;");
        var th9 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        th9.addControl((0, $02mnx.Localizer).getString("table_goaldiff"));
        var th10 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        th10.addControl((0, $02mnx.Localizer).getString("table_points"));
        //row.addControl(th1);
        row.addControl(th1Arrow);
        //row.addControl(th2);
        //row.addControl(th3);
        row.addControl(th4);
        row.addControl(th5);
        row.addControl(th6);
        row.addControl(th7);
        row.addControl(th8);
        row.addControl(th9);
        row.addControl(th10);
        this.card.addControl(row);
        if (groups[0].position > groups[1].position) groups.reverse();
        for(var j = 0; j < groups.length; j++){
            var team = groups[j];
            var team2 = groups[j + 1];
            var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
            row.setStyle("height:24px;");
            var pos = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            pos.addControl("<b style='margin-inline-end: 5px;font-size:var(--text-size-small);'>" + team.position + "</b>");
            if (team.color) pos.setStyle("border-top-right-radius: 8px;border-bottom-right-radius: 8px;background-color:" + team.color + "; color:" + Colorizer.getCorrectTextColor(team.color));
            var image = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
            image.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
            image.addCssClass("tableImageSmall");
            image.setCss({
                'height': "28px",
                'width': "28px"
            });
            image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + team.id_gs + "_small_rnd.png", 28, 28);
            var imageCon = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            imageCon.addControl(image);
            var colArrow = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            if (team.position_change > 0) colArrow.addControl("<div class='arrow-up'></div>");
            else if (team.position_change < 0) colArrow.addControl("<div class='arrow-down'></div>");
            var col1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            if (team.id_gs == data.data.gs_localteamid) col1.addControl(data.data.localteam);
            else col1.addControl(data.data.visitorteam);
            col1.setStyle("text-align: left;");
            var gp = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            gp.addControl(team.matchPoints + "");
            var w = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            w.addControl(team.totalWon + "");
            var d = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            d.addControl(team.totalDraw + "");
            var l = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            l.addControl(team.totalLost + "");
            var gf = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            gf.addControl(team.totalGoalsFor + " - " + team.totalGoalsAgainst);
            var gd = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            gd.addControl(team.totalGoalsFor - team.totalGoalsAgainst + "");
            var points = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            points.addControl(team.points + "");
            row.addControl(pos);
            row.addControl(colArrow);
            //row.addControl(imageCon);
            row.addControl(col1);
            row.addControl(gp);
            row.addControl(w);
            row.addControl(d);
            row.addControl(l);
            row.addControl(gf);
            row.addControl(gd);
            row.addControl(points);
            this.card.addControl(row);
        }
        this.card.addControl("</table>");
        this.card.bind('click', ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(this.data.data, {
                "action": "showStandings"
            });
        });
    }
}
class $c07b1d3ba027f23b$export$d3cb1be954ef01d8 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    setData(data) {
        super.setData(data);
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("team_form"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.addCssClass("MatchStatsContainerForm flexHorizontalAlign");
        var startContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        startContainer.addCssClass("MatchStatsContainerFormStart flexHorizontalAlign");
        var endContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        endContainer.addCssClass("MatchStatsContainerFormEnd flexHorizontalAlign");
        for(var index in data.data.localteamshape){
            var letter = data.data.localteamshape[index];
            var item = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            if (letter == "W") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormWin");
            else if (letter == "D") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormDraw");
            else if (letter == "L") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormLost");
            item.addControl(letter);
            startContainer.addControl(item);
        }
        for(var index in data.data.visitorteamshape){
            var letter = data.data.visitorteamshape[index];
            var item = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            if (letter == "W") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormWin");
            else if (letter == "D") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormDraw");
            else if (letter == "L") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormLost");
            item.addControl(letter);
            endContainer.addControl(item);
        }
        container.addControl(startContainer);
        container.addControl(endContainer);
        this.card.addControl(container);
    }
}
class $c07b1d3ba027f23b$export$327097ff088d46f5 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    setData(data) {
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("liveticker"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var prevcomment = null;
        //reverse order
        for(var i = 0; i < data.data.commentaries.commentaries.length; i++){
            var commentary = data.data.commentaries.commentaries[i];
            if (commentary.comment == prevcomment) continue;
            var content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            content.addCssClass("flexHorizontalAlign MatchCommentary");
            var minute = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            minute.setStyle("width:40px;text-align:center;margin-inline-end:6px;");
            minute.addControl(commentary.minute);
            if (commentary.minute) content.addControl(minute);
            content.addControl("<div style='width:100%;margin-inline-end:10px;'>" + commentary.comment + "</div>");
            content.setStyle("margin-top: 3px; margin-bottom: 3px;");
            this.card.addControl(content);
            prevcomment = commentary.comment;
        }
        var showMore = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        showMore.addCssClass("icon-showmore");
        //showMore.addControl(Localizer.getString("show_more"));
        showMore.addCssClass("showMoreButton");
        this.card.addControl(showMore);
        this.card.bind("click", ()=>{
            var urlIdentifier = "matchmodal_" + (0, $fRpWP.UrlManager).getModule("mid");
            var modal = new (0, $dae0bf243cd605f1$export$c5f42beb91c891a6)(urlIdentifier);
            this.getPage().addControl(modal, true);
        });
    }
}
class $c07b1d3ba027f23b$export$77db5abd3bd473d4 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    setData(data) {
        this.card.clear();
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("odd_title"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var topTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topTitle.addCssClass("MatchStatsTitleText MatchH2HTitle");
        var topContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topContainer.addCssClass("flexHorizontalAlign");
        topContainer.setStyle("justify-content: space-around;");
        var leftContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        var middleContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        var rightContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        leftContainer.addControl("1");
        middleContainer.addControl("X");
        rightContainer.addControl("2");
        topContainer.addControl(leftContainer);
        topContainer.addControl(middleContainer);
        topContainer.addControl(rightContainer);
        //this.card.addControl(topTitle);
        this.card.addControl(topContainer);
        console.log("ddd", data.data.odds);
        for(var i = 0; i < data.data.odds.bookmakers.length; i++){
            var bookmaker = data.data.odds.bookmakers[i];
            this.renderOddItem(bookmaker);
            if (i == 0) break;
        }
        var showMore = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        showMore.addCssClass("icon-showmore");
        //showMore.addControl(Localizer.getString("show_more"));
        showMore.addCssClass("showMoreButton");
        this.card.addControl(showMore);
        this.card.bind("click", ()=>{
            var urlIdentifier = "oddsmodal_" + (0, $fRpWP.UrlManager).getModule("mid");
            var modal = new (0, $8ab3f15a62b8f3ec$export$d57e9955a27a5081)(urlIdentifier, data.data);
            this.getPage().addControl(modal, true);
        });
    }
    renderOddItem(bookmaker) {
        var topTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //topTitle.addControl("<i>"+bookmaker.name+"</i>");
        topTitle.addCssClass("MatchStatsTitleText MatchH2HTitle");
        var topContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topContainer.addCssClass("flexHorizontalAlign");
        topContainer.setStyle("justify-content: space-around;margin-top:10px;");
        var leftContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        var middleContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        var rightContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        leftContainer.addControl(bookmaker.homeValue);
        middleContainer.addControl(bookmaker.drawValue);
        rightContainer.addControl(bookmaker.awayValue);
        topContainer.addControl(leftContainer);
        topContainer.addControl(middleContainer);
        topContainer.addControl(rightContainer);
        this.card.addControl(topTitle);
        this.card.addControl(topContainer);
    }
}
class $c07b1d3ba027f23b$export$305644184261c649 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        //this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    createComponents() {
        this.tabChangeListener = ()=>{
            this.pauseVideos();
        };
        if (this.getPage().tabview) this.getPage().tabview.bind("tabChanged", this.tabChangeListener);
    }
    unload() {
        for(var i = 1; i < this.videoCount; i++){
            var videoEl = document.getElementById("video" + i);
            videoEl.removeEventListener('play', this.videoListeners[i]);
        }
        if (this.tabChangeListener && this.getPage().tabview) this.getPage().tabview.unbind("tabChanged", this.tabChangeListener);
        this.videoElements = null;
    }
    pauseVideos() {
        try {
            for(var i = 1; i < this.videoCount; i++){
                var videoEl = document.getElementById("video" + i);
                videoEl.pause();
            }
        } catch (e) {
            console.log(e);
        }
    }
    updateDisplay() {
        if (!this.videoListeners) this.videoListeners = [];
        if (!this.videoElements) this.videoElements = {};
        for(var i = 1; i < this.videoCount; i++){
            var videoEl = document.getElementById("video" + i);
            this.videoElements["video" + i] = videoEl;
            videoEl.removeEventListener('play', this.videoListeners[i]);
            this.videoListeners[i] = (e)=>{
                for(var key in this.videoElements)if (key != e.target.attributes.id.value) this.videoElements[key].pause();
            };
            videoEl.addEventListener('play', this.videoListeners[i]);
        }
    }
    setData(data) {
        this.panel.clear();
        var videoId = 1;
        var added = false;
        if (data.data.videoHighlights && data.data.videoHighlights.files.length) for(var i = 0; i < data.data.videoHighlights.files.length; i++){
            this.videoElementAdded = true;
            //base64encode
            var encoded = "/footapi/images/videoreference/" + data.data.id + "_" + btoa(data.data.videoHighlights.files[i].url) + ".jpg";
            var videoEl = `
            <video preload="none" poster=` + encoded + ` id=video` + videoId + ` width='100%' height='219' controls>
                 <source src='` + data.data.videoHighlights.files[i].url + `?rel=0#t=0.001' type='video/mp4'>
            </video>  
            `;
            this.panel.addControl(videoEl);
            //added = true;
            //break;
            videoId++;
        }
        if (!added && data.data.videoHighlights && data.data.videoHighlights.clips.length) for(var i = 0; i < data.data.videoHighlights.clips.length; i++){
            this.videoElementAdded = true;
            var encoded = "/footapi/images/videoreference/" + data.data.id + "_" + btoa(data.data.videoHighlights.clips[i].url) + ".jpg";
            var videoEl = `

            <div style="text-align: center;padding:5px; font-variant: small-caps;">
            ` + (0, $02mnx.Localizer).getString(data.data.videoHighlights.clips[i].type) + ` - ` + data.data.videoHighlights.clips[i].score.replace("[", "").replace("]", "") + `
            </div>

            <video preload="none" poster=` + encoded + ` id=video` + videoId + ` width='100%' height='219' controls>
                 <source src='` + data.data.videoHighlights.clips[i].url + `?rel=0#t=0.001' type='video/mp4'>
            </video>  
            `;
            this.panel.addControl(videoEl);
            videoId++;
        }
        this.videoCount = videoId;
        this.panel.invalidateDisplay();
    }
}
class $c07b1d3ba027f23b$export$6cf96a968a6d457c extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        var card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        card.addCssClass("MatchTitleContainerCard");
        card.addCssClass("flexVerticalAlign");
        this.panel.addControl(card);
        this.addControl(this.panel);
        var button = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        button.addCssClass("shareButton");
        button.addControl((0, $02mnx.Localizer).getString("menu_sharematch"));
        card.addControl(button);
        this.panel.bind('click', ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(this.data.data);
        });
    }
}
class $c07b1d3ba027f23b$export$5df24d9c35dca494 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        this.firstTime = true;
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-bottom:-5px;");
        this.panel.setVisible(false);
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsCotainerCard");
        //this.panel.addControl(this.card);
        this.addControl(this.panel);
    }
    listener() {}
    updateDisplay() {
        if (!this.videoElementAdded) return;
        if (this.fullscreenChangeListener) document.removeEventListener('fullscreenchange', this.fullscreenChangeListener);
        this.fullscreenchangeListener = ()=>{
            var isFullscreenNow = document.webkitFullscreenElement !== null;
            this.listRender.triggerEvent('onFullscreenEvent', isFullscreenNow);
        };
        document.getElementById("video").addEventListener('fullscreenchange', this.fullscreenchangeListener);
    }
    setData(data) {
        var matchid = (0, $fRpWP.UrlManager).getModule("mid");
        (0, $kc8Kt.DataProvider).getAdtekMatchOdds(matchid, (data)=>{
            if (!data.isOk()) {
                console.log("no ad avalable");
                return;
            }
            console.log("zzzee result ", data.getData());
            this.panel.setVisible(true);
            window.addEventListener('message', ()=>{
                if (typeof event.data === 'object' && event.data.type === 'resize') {
                    const items = document.querySelectorAll('[id^="bwss-iframe"]');
                    items.forEach((item)=>{
                        item.style.height = event.data.data + 'px';
                    });
                }
            });
            this.panel.clear();
            this.panel.addControl(data.getData(), true);
        });
    }
}






var $02mnx = parcelRequire("02mnx");

class $07ee7f8611ef3055$export$1ffd76da79c62f76 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(data) {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listViewHeader");
        this.panel.setStyle("justify-content: space-between;padding-inline-end:0;");
        this.addControl(this.panel);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addControl(this.contents);
    }
    setData(data) {
        this.data = data;
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.contents.addControl(data.title, true);
    }
}
class $07ee7f8611ef3055$export$9195dbe354ce2bc9 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(data) {
        super.init();
        this.data = data;
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listViewItem");
        this.addControl(this.panel);
        //
        this.content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.content.addCssClass("flexHorizontalAlign");
        this.content.setStyle("align-items: flex-start;width: 100%;");
        this.panel.addControl(this.content);
        this.itemImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.itemImage.setStyle("margin-inline-start:8px;width:40px; height;40px;align-self: center;");
        this.content.addControl(this.itemImage);
        this.forumIndexName = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.forumIndexName.setStyle("align-self: center;margin-inline-start: 8px;line-height: 21px;");
        this.content.addControl(this.forumIndexName);
        this.lastMessage = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        var margin = "margin-left:auto;text-align:right;";
        if (FootballManiaConfig.isRtl) margin = "margin-right:auto;";
        this.lastMessage.setStyle("font-size:10px;" + margin + "align-self: center;line-height: 22px;margin-inline-end:4px;");
        this.content.addControl(this.lastMessage);
        this.content.bind("click", ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showForumChat(this.data.link, this.data.name);
        });
    }
    setData(data) {
        this.data = data;
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.forumIndexName.clear();
        this.lastMessage.clear();
        //this.title.addControl(data.title+"",true);
        //this.playerImage.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/playerimages/"+data.id+"_small_rnd.png",40,40);
        console.log(data);
        if (data.image) this.itemImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.image.replace(/\s|\'/g, '-').toLowerCase() + ".png");
        this.forumIndexName.addControl(data.name, true);
        if (data.last_message_at) {
            //var date = new DateTimecode(data.last_message_at);/
            this.lastMessage.addControl(data.last_message_by);
            this.lastMessage.addControl("<br/>");
            var formatted = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
            }).format(new Date(data.last_message_at));
            this.lastMessage.addControl(formatted, true);
        }
    //this.lastMessage.addControl(this.valueFormatter.format(data.marketvalue),true);
    }
}
class $07ee7f8611ef3055$export$bce6b4f752d51f16 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(data) {
        super.init();
        this.mainContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.mainContainer.addCssClass("ChatMessageMainContainer");
        this.container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.container.addCssClass("ChatMessageContainer");
        this.image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.image.setAttribute("width", "40px");
        this.image.setAttribute("height", "40px");
        this.image.addCssClass("ChatMessageImage");
        this.contentContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contentContainer.addCssClass("ChatMessageContentContainer");
        this.topContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.topContainer.addCssClass("ChatMessageTopContainer");
        this.name = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.name.addCssClass("ChatMessageName");
        this.votes = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.votes.addCssClass("ChatMessageRating");
        this.text = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.bottomContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.bottomContainer.addCssClass("ChatMessageBottom");
        this.date = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.deliveryStatus = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.bottomContainer.addControl(this.date);
        this.bottomContainer.addControl(this.deliveryStatus);
        this.container.addControl(this.image);
        this.topContainer.addControl(this.name);
        this.topContainer.addControl(this.votes);
        this.contentContainer.addControl(this.topContainer);
        this.contentContainer.addControl(this.text);
        this.contentContainer.addControl(this.bottomContainer);
        this.container.addControl(this.contentContainer);
        this.mainContainer.addControl(this.container);
        this.addControl(this.mainContainer);
        this.container.bind("click", (e)=>{
            //prevent other click events. currently used to disable the side menu bar
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.listRender.triggerEvent("itemClick", this.data);
        });
    }
    blur() {
        this.container.addCssClass("ChatMessageContainerBlur");
    }
    unblur() {
        this.container.removeCssClass("ChatMessageContainerBlur");
    }
    setData(data) {
        this.data = data;
        if (data.removed == 1) {
            data.m = (0, $02mnx.Localizer).getString("removed");
            this.container.setStyle("opacity: 0.3;");
        }
        this.image.setImage(data.social_profile_image || data.image);
        this.name.addControl(data.un);
        if (data.rating > 0 || data.rating < 0) {
            this.votes.addControl((data.rating > 0 ? "+" : "") + data.rating + "");
            if (data.rating < -2) {
                this.votes.addCssClass("ChatRatingSuperBad");
                this.container.setCss({
                    "opacity": "0.1"
                });
            } else if (data.rating < 0) {
                this.votes.addCssClass("ChatRatingBad");
                this.container.setCss({
                    "opacity": "0.3"
                });
            } else if (data.rating > 0) this.votes.addCssClass("MChatRatingGood");
            else if (data.rating > 2) this.votes.addCssClass("ChatRatingBetter");
            else this.votes.addCssClass("ChatRatingExcellent");
        }
        this.text.addControl(data.m);
        var today12 = new Date();
        today12.setHours(0, 0, 0, 0);
        var messageDate = new Date(data.time * 1000);
        if (messageDate > today12) {
            var formatted = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
                weekday: 'short',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            }).format(data.time * 1000);
            this.date.addControl(formatted);
        } else {
            var formatted = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
            }).format(data.time * 1000);
            this.date.addControl(formatted);
        }
        if (data.delivered) {
            this.deliveryStatus.addCssClass("icon-verify_both");
            this.deliveryStatus.setStyle("width:20px;height:20px;margin-inline-start:20px;");
        } else if (data.delivered === false) {
            this.deliveryStatus.addCssClass("icon-verify_single");
            this.deliveryStatus.setStyle("width:20px;height:20px;margin-inline-start:20px;");
        }
    }
}


class $0a2141772032e98d$export$f421feb8fad20413 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        super.init();
        //this is a bit hacky.
        //the id change event is fired even when we set the id of this page before
        //this logic. The reason is because the onhashchange event is async
        //and altough we change the url before this logic, the onhashchange event fires
        //afte this logic
        this.bind("renderComplete", ()=>{
            var that = this;
            //alert("listen")
            //we do this to register back button scenario where page A is match and page B is also match
            setTimeout(function() {
                if (that.unloaded) {
                    console.log("ignore, page is unloaded");
                    return;
                }
                (0, $fRpWP.UrlManager).listenModule('mid', function() {
                    (0, $fRpWP.UrlManager).unlistenModule("mid");
                    var id = (0, $fRpWP.UrlManager).getModule('mid');
                    if (id == undefined || (0, $fRpWP.UrlManager).getModule('section') != "Match") return console.warn("ignore opening match , probably navigating to other screen");
                    AppInstance.loadPage("Match", {
                        "mid": id
                    }, false);
                });
            }, 100);
        });
        this.pageName = "Match_" + (0, $fRpWP.UrlManager).getModule("mid");
        this.addCssClass("MatchPage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $aeae458d1e4856c5$export$5be7f7356c27f222)();
        this.coordinatoranimator.reducerRatio = 1;
        this.coordinatoranimator.transitionDuration = 20;
        this.coordinatoranimator.alwaysCollapseOnBackScrolling = false;
        if ((0, $2ee970b2529997d7$export$55185c17a0fcbe46).isNavigatedFromPush()) {
            (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
            //remove push from history url. otherwise when navigating back button doesnt work
            (0, $fRpWP.UrlManager).removeModule("fromPush");
            (0, $fRpWP.UrlManager).updateUrl(true);
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).allowBackButtonQuitApp();
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
        } else (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        (0, $kc8Kt.DataProvider).sayHello();
    }
    storeState() {
        var d = {};
        if (this.tabview) d.tabIndex = this.tabview.currentActiveTab, d.matchstatsScrollPosition = this.matchstatsListrender.getScroll(), d.headerCollapsed = this.coordinatoranimator.isCollapsed;
        if (this.matchlineupsListrender) d.matchlineupScrollPosition = this.matchlineupsListrender.getScroll();
        if (this.matchHighlightListrender) d.matchhighlightScrollPosition = this.matchHighlightListrender.getScroll();
        if (this.commentariesModal) d.commentariesModalOpen = 1;
        if (this.oddsModal) d.oddsModalOpen = 1;
        console.log("store ", d);
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.matchLoadHandler);
        (0, $fRpWP.UrlManager).unlistenModule('mid');
    }
    onVisibilityChange() {
        console.log("visibility change ", document.hidden, this);
        if (this.previousDocumentHidden = !document.hidden) {
            this.autoInterval(0);
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
        }
        this.previousDocumentHidden = document.hidden;
    }
    onOffline() {
        this.getPageTemplate().createMenuMatch(false, false);
    }
    onOnline() {
        this.autoInterval(0);
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
    }
    createPageLayout() {
        this.matchHeader = new (0, $e5f9454769c5d1c5$export$807e1ffa413586ae)();
        this.matchHeader.setVisible(false);
        this.coordinatoranimator.addCollapser(this.matchHeader);
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(this.matchHeader);
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().hideTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (document.fullscreenElement) {
            console.warn("ignore resize event because fullscreen element is active");
            return;
        }
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.matchstatsListrender) this.matchstatsListrender.onWindowResize();
        if (this.matchlineupsListrender) this.matchlineupsListrender.onWindowResize();
        if (this.matchHighlightListrender) this.matchHighlightListrender.onWindowResize();
    }
    updateDisplay() {
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) this.coordinatoranimator.prerun(previousState.headerCollapsed);
        else this.coordinatoranimator.prerun(false);
        this.runApp();
    }
    runApp() {
        this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", ()=>{
                    this.runApp();
                });
            }
            var cachedHeaderData = (0, $dNeVp.ManiaCache).getMemoryCache("match");
            if (cachedHeaderData) this.matchHeader.setPresetData(cachedHeaderData);
            (0, $kc8Kt.DataProvider).getMatch((0, $fRpWP.UrlManager).getModule("mid"), this.getProxy(function(response) {
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                this.hideLoader();
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                        this.runApp();
                    }));
                    else return this.showError("", this.getProxy(function() {
                        this.runApp();
                    }));
                }
                var data = response.getData();
                this.matchData = data;
                console.log("loaded match data", data);
                if ((0, $9yWe2.MatchUtil).isFinished(data)) {
                    if (data.status == "Pen.") this.coordinatoranimator.shrinkType = 4;
                    else this.coordinatoranimator.shrinkType = 1;
                    this.getPageTemplate().createMenuMatch(false, response.getData().id);
                } else {
                    this.getPageTemplate().createMenuMatch(true, response.getData().id);
                    if (data.aggregateScore) this.coordinatoranimator.shrinkType = 2;
                    else this.coordinatoranimator.shrinkType = 3;
                }
                this.coordinatoranimator.matchStatus = data.status;
                this.matchHeader.setVisible(true);
                (0, $dNeVp.ManiaCache).setShortCache("match", data);
                this.matchHeader.setPresetData(data, true);
                this.createTabs(data);
                this.tabview.bind("tabChanged", ()=>{
                    this.coordinatoranimator.tabChange();
                    this.storeState();
                    setTimeout(()=>{
                        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
                    }, 1000);
                    console.log("tab changed", this.tabview.currentActiveTab);
                    //in case the match highlights tab is selected and the highlights are not loaded yet
                    if (this.matchHighlightListrender && this.matchHighlightListrender.containerTarget.tabIndex == this.tabview.currentActiveTab && this.waitingForActiveHighlightsTab) {
                        this.waitingForActiveHighlightsTab = false;
                        this.loadMatchHighlights(this.matchData);
                    }
                    if (this.bottomInput) jQuery("#" + this.bottomInput.getClientId()).blur();
                    if (this.chatListrender && this.chatListrender.containerTarget.parent.tabIndex == this.tabview.currentActiveTab) {
                        this.loadMatchChat();
                        if (this.chatListrender.indexRenderedItemRenderMap) {
                            if (this.chatMenuPopup) this.chatMenuPopup.slideOut();
                            for(var i = 0; i < this.chatListrender.indexRenderedItemRenderMap.length; i++)this.chatListrender.indexRenderedItemRenderMap[i].unblur();
                            this.inBlurMode = false;
                        }
                    }
                });
                var storeHandler = null;
                var storeHandler2 = null;
                var storeHandler3 = null;
                var tabCount = 1;
                this.matchstatsListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 200);
                }));
                if (this.matchlineupsListrender) {
                    this.matchlineupsListrender.bind("scroll", this.getProxy(function(e, scroll) {
                        clearTimeout(storeHandler2);
                        storeHandler2 = setTimeout(this.getProxy(function() {
                            this.storeState();
                        }), 200);
                    }));
                    ++tabCount;
                }
                if (this.matchHighlightListrender) {
                    this.matchHighlightListrender.bind("scroll", this.getProxy(function(e, scroll) {
                        clearTimeout(storeHandler2);
                        storeHandler3 = setTimeout(this.getProxy(function() {
                            this.storeState();
                        }), 200);
                    }));
                    ++tabCount;
                }
                if (this.chatListrender) ++tabCount;
                this.tabview.currentActiveTab = FootballManiaConfig.isRtl ? tabCount - 1 : 0;
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                if (previousState) {
                    if (previousState.tabIndex != null) this.tabview.currentActiveTab = previousState.tabIndex;
                    this.matchstatsListrender.scrollTo(previousState.matchstatsScrollPosition || 0);
                    console.log("restore scroll ", previousState.matchlineupScrollPosition);
                    if (this.matchlineupsListrender) this.matchlineupsListrender.scrollTo(previousState.matchlineupScrollPosition || 0);
                    if (this.matchHighlightListrender) this.matchHighlightListrender.scrollTo(previousState.matchhighlightScrollPosition || 0);
                }
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.ensureStartPositions(); //we call this to ensure tabview is collapsed without flicker
                this.coordinatoranimator.run();
                this.loadMatchStats(data);
                if (data.commentaries && data.commentaries.teams) this.loadMatchLineups(data);
                else if (data.commentaries_predicted && data.commentaries_predicted.teams) {
                    var oldCommentaries = data.commentaries;
                    data.commentaries = data.commentaries_predicted;
                    if (oldCommentaries) data.commentaries.commentaries = oldCommentaries.commentaries;
                    data.commentaries.isPredicted = true;
                    this.loadMatchLineups(data);
                }
                if (FootballManiaConfig.enableVideo && data.videoHighlights && (data.videoHighlights.files.length > 0 || data.videoHighlights.clips.length > 0) && FootballManiaConfig.disabledVideoCountries.indexOf(FootballManiaConfig.userLocale) == -1) this.loadMatchHighlights(data);
                if (FootballManiaConfig.enabledFeatures.matchChat && this.chatListrender.containerTarget.parent.tabIndex == this.tabview.currentActiveTab) this.loadMatchChat();
                ///some logic for reopening commentary modal after refresh
                this.bind("onModalOpen", this.getProxy(function(e, modal) {
                    this.commentariesModal = null;
                    this.oddsModal = null;
                    if (modal instanceof (0, $dae0bf243cd605f1$export$c5f42beb91c891a6)) this.commentariesModal = modal;
                    else if (modal instanceof (0, $8ab3f15a62b8f3ec$export$d57e9955a27a5081)) this.oddsModal = modal;
                    this.storeState();
                }));
                this.bind("onModalClose", ()=>{
                    this.commentariesModal = null;
                    this.oddsModal = null;
                    this.storeState();
                });
                if (previousState && previousState.commentariesModalOpen) setTimeout(()=>{
                    var urlIdentifier = "matchmodal_" + (0, $fRpWP.UrlManager).getModule("mid");
                    var modal = new (0, $dae0bf243cd605f1$export$c5f42beb91c891a6)(urlIdentifier);
                    this.addControl(modal, true);
                });
                else if (previousState && previousState.oddsModalOpen) setTimeout(()=>{
                    var urlIdentifier = "oddsmodal_" + (0, $fRpWP.UrlManager).getModule("mid");
                    var modal = new (0, $8ab3f15a62b8f3ec$export$d57e9955a27a5081)(urlIdentifier, data);
                    this.addControl(modal, true);
                });
                this.bind("requestShareAndroid", ()=>{
                    console.log("request share");
                    var subject = (0, $02mnx.Localizer).getString("app_name");
                    var link = "https://footballapp.live/Match/mid/" + data.id;
                    var message = data.localteam + " - " + data.visitorteam;
                    JSAndroidBridge.requestShareIntent(subject, link, message);
                });
            }), true);
        }));
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        //FootballManiaConfig.graphics.animations = false;
        if ((0, $40e70090f1e1ff2d$export$5510f7c459d7063c).getCurrentTheme() != "light") tabview.parallaxBg = this.matchHeader.backgroundImage;
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        var tab2;
        var tab3;
        var tab4;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab1.addCssClass("listViewScrollableContainer");
        tab1.title = (0, $02mnx.Localizer).getString("matchinfo");
        if (data.commentaries && data.commentaries.teams || data.commentaries_predicted && data.commentaries_predicted.teams) {
            tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab2.addCssClass("listViewScrollableContainer");
            tab2.title = (0, $02mnx.Localizer).getString("lineups");
        }
        if (FootballManiaConfig.enableVideo && data.videoHighlights && (data.videoHighlights.files.length > 0 || data.videoHighlights.clips.length > 0) && FootballManiaConfig.disabledVideoCountries.indexOf(FootballManiaConfig.userLocale) == -1) {
            tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab3.addCssClass("listViewScrollableContainer");
            tab3.title = (0, $02mnx.Localizer).getString("highlights");
            tab3.iconClass = "icon-video";
        }
        if (FootballManiaConfig.enabledFeatures.matchChat) {
            tab4 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab4.heightIsMaxContentHeight = true;
            //this tab is not the scrollable element, it
            tab4.setStyle("width:100%;height:100%;position:relative;");
            tab4.title = (0, $02mnx.Localizer).getString("chat");
            tab4.iconClass = "icon-chat";
            this.tab4 = tab4;
        }
        var usedTabIndices = 0;
        if (FootballManiaConfig.isRtl) {
            if (tab4) {
                tab4.addControl(this.createChatTabLayout(tab4, usedTabIndices));
                tabs.push(tab4);
                usedTabIndices++;
            }
            if (tab3) {
                this.createMatchHighlightControls(tab3, usedTabIndices);
                this.coordinatoranimator.addScrollerContainer(tab3);
                tabs.push(tab3);
                usedTabIndices++;
            }
            if (tab2) {
                this.createMatchLineupControls(tab2, usedTabIndices);
                this.coordinatoranimator.addScrollerContainer(tab2);
                tabs.push(tab2);
                usedTabIndices++;
            }
            this.createMatchStatsControls(tab1, usedTabIndices);
            this.coordinatoranimator.addScrollerContainer(tab1);
            tabs.push(tab1);
        } else {
            this.createMatchStatsControls(tab1, usedTabIndices);
            this.coordinatoranimator.addScrollerContainer(tab1);
            tabs.push(tab1);
            usedTabIndices++;
            if (tab2) {
                this.createMatchLineupControls(tab2, usedTabIndices);
                this.coordinatoranimator.addScrollerContainer(tab2);
                tabs.push(tab2);
                usedTabIndices++;
            }
            if (tab3) {
                this.createMatchHighlightControls(tab3, usedTabIndices);
                this.coordinatoranimator.addScrollerContainer(tab3);
                tabs.push(tab3);
                usedTabIndices++;
            }
            if (tab4) {
                tab4.addControl(this.createChatTabLayout(tab4, usedTabIndices));
                tabs.push(tab4);
            }
        }
        this.coordinatoranimator.addTopBar(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        this.tabview = tabview;
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) this.coordinatoranimator.setScrollerBottomMargin(tab1.tabIndex, 0);
            if (tab2) this.coordinatoranimator.setScrollerBottomMargin(tab2.tabIndex, 0);
            if (tab3) this.coordinatoranimator.setScrollerBottomMargin(tab3.tabIndex, 0);
            if (tab4) this.coordinatoranimator.setScrollerBottomMargin(tab4.tabIndex, 0);
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px", tab1);
            if (tab1) {
                this.coordinatoranimator.setScrollerBottomMargin(tab1.tabIndex, 50);
                this.coordinatoranimator.getScrollerContainer(tab1.tabIndex).setCss({
                    "height": "calc(100% - 50px)"
                });
                this.coordinatoranimator.recalculateTab(tab1.tabIndex);
            }
            if (tab2) {
                this.coordinatoranimator.setScrollerBottomMargin(tab2.tabIndex, 50);
                this.coordinatoranimator.getScrollerContainer(tab2.tabIndex).setCss({
                    "height": "calc(100% - 50px)"
                });
                this.coordinatoranimator.recalculateTab(tab2.tabIndex);
            }
            if (tab3) {
                this.coordinatoranimator.setScrollerBottomMargin(tab3.tabIndex, 50);
                this.coordinatoranimator.getScrollerContainer(tab3.tabIndex).setCss({
                    "height": "calc(100% - 50px)"
                });
                this.coordinatoranimator.recalculateTab(tab3.tabIndex);
            }
            if (tab4) {
                this.coordinatoranimator.setScrollerBottomMargin(tab4.tabIndex, 100);
                this.coordinatoranimator.getScrollerContainer(tab4.tabIndex).setCss({
                    "height": "calc(100% - 100px)"
                });
                this.coordinatoranimator.recalculateTab(tab4.tabIndex);
                if (this.chatBottomInputContainer) this.chatBottomInputContainer.setCss({
                    "bottom": "50px"
                });
            }
        });
        if (tab4) {
            this.coordinatoranimator.setScrollerBottomMargin(tab4.tabIndex, 50);
            this.coordinatoranimator.getScrollerContainer(tab4.tabIndex).setCss({
                "height": "calc(100% - 50px)"
            });
            this.coordinatoranimator.recalculateTab(tab4.tabIndex);
        }
        this.getPageTemplate().loadStickyBannerAd();
    }
    createChatTabLayout(tab, index) {
        var bottom = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        bottom.addCssClass("tableFooter");
        var input = new (0, $51908c82e41b0e01$export$10e6f4f66014ee2d)();
        input.addCssClass("ChatInput");
        input.setData((0, $02mnx.Localizer).getString("chattypehint"));
        this.chatMenuPopup = new (0, $b327ff81cc3a41d8$export$1457961a45169cfb)();
        this.chatMenuPopup.isAdmin = true;
        this.chatMenuPopup.bind("thumbup", ()=>{
            console.log(this.selectedChatData);
            if (!this.selectedChatData) {
                console.error("no selected chat data");
                return;
            }
            this.chatListrender.rateMessage(this.selectedChatData, 1);
        });
        this.chatMenuPopup.bind("thumbdown", ()=>{
            console.log(this.selectedChatData);
            if (!this.selectedChatData) {
                console.error("no selected chat data");
                return;
            }
            this.chatListrender.rateMessage(this.selectedChatData, -1);
        });
        this.chatMenuPopup.bind("requestAdminMenu", ()=>{
            console.log(this.selectedChatData);
            if (!this.selectedChatData) {
                console.error("no selected chat data");
                return;
            }
            var adminPanel = new (0, $b327ff81cc3a41d8$export$1b1752f8539f7991)();
            adminPanel.setData(this.selectedChatData);
            this.adminPanel = adminPanel;
            this.getPage().addControl(adminPanel, true);
            clearTimeout(this.menuSlideInTimeouthandler);
            this.getPage().bind("onModalClose", ()=>{
                this.chatMenuPopup.slideOut();
                for(var i = 0; i < this.chatListrender.indexRenderedItemRenderMap.length; i++)this.chatListrender.indexRenderedItemRenderMap[i].unblur();
                this.inBlurMode = false;
            });
            adminPanel.bind("removeMessage", ()=>{
                this.chatListrender.adminRemoveMessage(this.selectedChatData);
            });
            adminPanel.bind("banUser1day", ()=>{
                this.chatListrender.adminBanUser(this.selectedChatData, 1);
            });
            adminPanel.bind("banUser7days", ()=>{
                this.chatListrender.adminBanUser(this.selectedChatData, 7);
            });
            adminPanel.bind("banUser365days", ()=>{
                this.chatListrender.adminBanUser(this.selectedChatData, 365);
            });
            adminPanel.bind("unbanuser", ()=>{
                this.chatListrender.adminUnbanUser(this.selectedChatData, 365);
            });
        });
        bottom.addControl(this.chatMenuPopup);
        bottom.addControl(input);
        bottom.setVisible(false);
        var arrow = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        arrow.addCssClass("arrow-right");
        bottom.addControl(arrow);
        var scroller = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        scroller.addCssClass("listViewScrollableContainer");
        scroller.addCssClass("ChatScrollerContainer");
        scroller.setCss({
            "display": "flex",
            "flex-direction": "column"
        });
        scroller.forceMarginTop = "auto";
        this.coordinatoranimator.addScrollerContainer(scroller);
        ///set fixed height of scroller container table items.
        //this is needed because bottom description container is dynamic in height
        bottom.setStyle("display: flex;flex-direction: row;align-items: center;justify-content: flex-start;");
        scroller.setStyle("width:100%;height:calc(100% - 50px);position:relative;overflow-y: scroll;transform: translate(0,0);");
        this.bottomInputContainer = bottom;
        this.bottomInput = input;
        this.bottomArrow = arrow;
        this.createChatControls(scroller, index);
        var bottomContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        bottomContainer.setStyle("z-index:9999999;bottom:0px;position:fixed;width:100%;height:50px;");
        bottomContainer.addControl(bottom);
        this.chatBottomInputContainer = bottomContainer;
        this.tab4.addControl(bottomContainer);
        return scroller;
    }
    getMatchData() {
        return this.matchData;
    }
    createMatchStatsControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $c07b1d3ba027f23b$export$9927a8850dc24e2b)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $c07b1d3ba027f23b$export$5ee8aff078d2cc0e)()
            };
            else if (data.type == 3) return {
                typeId: 3,
                render: new (0, $c07b1d3ba027f23b$export$30d475e9cd83759e)()
            };
            else if (data.type == 4) return {
                typeId: 4,
                render: new (0, $c07b1d3ba027f23b$export$d6dfff3781b604d3)()
            };
            else if (data.type == 5) return {
                typeId: 5,
                render: new (0, $c07b1d3ba027f23b$export$6c66ad1fdb5757ea)()
            };
            else if (data.type == 6) return {
                typeId: 6,
                render: new (0, $c07b1d3ba027f23b$export$a2b99b374b9e2dae)()
            };
            else if (data.type == 7) return {
                typeId: 7,
                render: new (0, $c07b1d3ba027f23b$export$d3cb1be954ef01d8)()
            };
            else if (data.type == 8) return {
                typeId: 8,
                render: new (0, $c07b1d3ba027f23b$export$327097ff088d46f5)()
            };
            else if (data.type == 9) return {
                typeId: 9,
                render: new (0, $c07b1d3ba027f23b$export$77db5abd3bd473d4)()
            };
            else if (data.type == 10) return {
                typeId: 10,
                render: new (0, $c07b1d3ba027f23b$export$f55f717a57039365)()
            };
            else if (data.type == 11) return {
                typeId: 11,
                render: new (0, $c07b1d3ba027f23b$export$8529c6e54ea923d2)()
            };
            else if (data.type == 12) return {
                typeId: 12,
                render: new (0, $c07b1d3ba027f23b$export$5df24d9c35dca494)()
            };
            else if (data.type == 13) return {
                typeId: 13,
                render: new (0, $c07b1d3ba027f23b$export$6cf96a968a6d457c)()
            };
            else if (data.type == 14) return {
                typeId: 14,
                render: new (0, $c07b1d3ba027f23b$export$3497bc161ffc5f8)()
            };
        });
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
            this.coordinatoranimator.ensureStartPositions(); //needed for scrolllist to collapse mode
        });
        // listRender.bind('onFullscreenEvent',this.getProxy(function(e,fullscreen){
        //     console.log("onFullscreenEvent",fullscreen);
        //     //FootballManiaConfig.graphics.animations = !fullscreen;
        //     //this.getPage().hide();
        //     //jQuery(".BPage").hide();
        //     console.log("ignoreWindowResizeEvent",fullscreen);
        //     if (fullscreen) {
        //         this.ignoreWindowResizeEvent = fullscreen;
        //     }
        //     else{
        //         setTimeout(() => {
        //             this.ignoreWindowResizeEvent = false;
        //         }, 1000);
        //     }
        //     //listRender.setVisible(false);
        //     //asd();
        // }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.matchstatsScrollPosition || 0);
        container.addControl(listRender);
        this.matchstatsListrender = listRender;
        tab.addControl(container);
    }
    createMatchLineupControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $c07b1d3ba027f23b$export$896fb244188045c5)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $c07b1d3ba027f23b$export$4e99bc92372e6aba)()
            };
            else if (data.type == 3) return {
                typeId: 3,
                render: new (0, $c07b1d3ba027f23b$export$fb81826a29f0b863)()
            };
        });
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            console.log("restore scroll #2 : ", previousState.matchlineupScrollPosition);
            listRender.scrollTo(previousState.matchlineupScrollPosition || 0);
        }
        container.addControl(listRender);
        this.matchlineupsListrender = listRender;
        tab.addControl(container);
    }
    createMatchHighlightControls(tab, index) {
        console.log("create match highlight controls");
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 13) return {
                typeId: 13,
                render: new (0, $c07b1d3ba027f23b$export$305644184261c649)()
            };
        });
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
            this.coordinatoranimator.ensureStartPositions(); //needed for scrolllist to collapse mode
        });
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.matchhighlightScrollPosition || 0);
        container.addControl(listRender);
        this.matchHighlightListrender = listRender;
        tab.addControl(container);
    }
    createChatControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;display: flex;flex-direction: column;justify-content: flex-end;");
        console.log("create chat controls");
        var listRender = new (0, $52274ddb13c5ef93$export$7d9d7c166fa1026a)(true);
        var chatLocale = AppInstance.getConfig().userLocale;
        if (FootballManiaConfig.availableChatLocales.indexOf(chatLocale) == -1) chatLocale = FootballManiaConfig.default_chat_locale;
        listRender.chatIndex = (0, $fRpWP.UrlManager).getModule("mid") + "_" + chatLocale;
        //  listRender.chatIndex = UrlManager.getModule("mid")+"_it";
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $07ee7f8611ef3055$export$bce6b4f752d51f16)()
            };
        });
        listRender.emptyTemplate = (cb)=>{
            return new (0, $90aac4880169307d$export$5006bd6e14e3bbef)({
                cb () {},
                message: (0, $02mnx.Localizer).getString("no_chat_messages")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind("click", (data)=>{
            console.log("click");
            if (this.chatMenuPopup) this.chatMenuPopup.slideOut();
            if (listRender.indexRenderedItemRenderMap) for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
            this.inBlurMode = false;
        });
        listRender.bind('createdList', ()=>{
            this.tabview.tabs[this.chatListrender.containerTarget.parent.tabIndex].hideLoader();
            this.coordinatoranimator.recalculateTab(index);
        //NOT CALLED?????
        });
        listRender.bind('refresh_chat', ()=>{
            this.tabview.tabs[this.chatListrender.containerTarget.parent.tabIndex].hideLoader();
            this.coordinatoranimator.recalculateTab(index);
        //NOT CALLED?????
        });
        listRender.bind('refresh_chat', ()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.tabview.tabs[0].hideLoader();
            this.bottomInputContainer.setVisible(true);
        });
        listRender.bind("accepted", ()=>{
            console.log("accepted");
            this.coordinatoranimator.recalculateTab(index);
            this.acceptInteraction();
        });
        listRender.bind("incoming_message", (data)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            clearTimeout(this.menuSlideInTimeouthandler);
            this.chatMenuPopup.slideOut();
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
        });
        listRender.bind("voteFailed", (data)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            clearTimeout(this.menuSlideInTimeouthandler);
            this.chatMenuPopup.slideOut();
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
        });
        listRender.bind("authentication_start", (data)=>{
            this.getPageTemplate().hideStickBannerAd();
        });
        listRender.bind("authentication_end", (data)=>{
            this.getPageTemplate().loadStickyBannerAd();
        });
        listRender.bind("authentication_error", (data)=>{
        //this.getPageTemplate().createMenuForumChat(); //in case we auto logout
        });
        listRender.bind("adminActionFailed", (data)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            clearTimeout(this.menuSlideInTimeouthandler);
            this.chatMenuPopup.slideOut();
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
            if (this.adminPanel) this.adminPanel.destroy();
        });
        listRender.bind("itemClick", (e, data)=>{
            console.log("itemClick", data);
            if (!this.chatMenuPopup.isAdmin && data.removed == 1) {
                console.log("message removed");
                return;
            }
            if (this.inBlurMode) {
                clearTimeout(this.menuSlideInTimeouthandler);
                this.chatMenuPopup.slideOut();
                console.log("slideout");
                for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
                this.inBlurMode = false;
                return;
            } else this.chatMenuPopup.enableVote(data.userVote != 1 && data.userVote != -1);
            console.log("slidein");
            this.chatMenuPopup.slideIn();
            clearTimeout(this.menuSlideInTimeouthandler);
            this.menuSlideInTimeouthandler = setTimeout(()=>{
                console.log("timeout for slideout");
                this.chatMenuPopup.slideOut();
                this.inBlurMode = false;
                for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
                this.selectedChatData = null;
            }, 5000);
            console.log("go check ", listRender.indexRenderedItemRenderMap);
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++){
                console.log("go check ", listRender.indexRenderedItemRenderMap[i].data);
                if (!this.inBlurMode && listRender.indexRenderedItemRenderMap[i].data == data) {
                    listRender.indexRenderedItemRenderMap[i].unblur();
                    console.log("blur", listRender.indexRenderedItemRenderMap[i].data);
                    this.selectedChatData = data;
                } else listRender.indexRenderedItemRenderMap[i].blur();
            }
            this.inBlurMode = !this.inBlurMode;
        });
        listRender.setPlaceHolderWidth("100%;");
        container.addControl(listRender);
        this.chatListrender = listRender;
        tab.addControl(listRender);
    }
    loadMatchStats(data, ignoreCache) {
        if (!data) return this.autoInterval();
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var listData = [];
        //if (FootballManiaConfig.enabledOddsCountries.indexOf(FootballManiaConfig.userLocale) != -1) {
        //}
        var item = {
            "data": data,
            "type": 1
        };
        listData.push(item);
        var item = {
            "data": data,
            "type": 12
        };
        listData.push(item);
        if (data.penalties && data.penalties.length) {
            var item2 = {
                "data": data,
                "type": 11
            };
            listData.push(item2);
        }
        if (data.events && data.events.length) {
            if (data.commentaries && data.commentaries.events && data.commentaries.events.length) data.events = data.commentaries.events;
            var item2 = {
                "data": data,
                "type": 2
            };
            listData.push(item2);
        }
        if (data.aggregate) {
            var item2 = {
                "data": data,
                "type": 10
            };
            listData.push(item2);
        }
        if (data.localteamStanding && data.visitorteamStanding) {
            var item2 = {
                "data": data,
                "type": 6
            };
            listData.push(item2);
        }
        if (data.commentaries && data.commentaries.commentaries && data.commentaries.commentaries.length > 1) {
            var item2 = {
                "data": data,
                "type": 8
            };
            listData.push(item2);
        }
        if (data.commentaries && data.commentaries.stats) {
            var item2 = {
                "data": data,
                "type": 3
            };
            listData.push(item2);
        }
        item = {
            "data": data,
            "type": 5
        };
        listData.push(item);
        if (data.injuries) {
            var item2 = {
                "data": data,
                "type": 14
            };
            listData.push(item2);
        }
        if (data.odds && data.odds.bookmakers && data.odds.bookmakers.length) {
            var item2 = {
                "data": data,
                "type": 9
            };
            listData.push(item2);
        }
        if (data.localteamshape && data.visitorteamshape) {
            item = {
                "data": data,
                "type": 7
            };
            listData.push(item);
        }
        var item2 = {
            "data": data,
            "type": 13
        };
        //listData.push(item2);
        if (data.h2hMatches) {
            var item2 = {
                "data": data,
                "type": 4
            };
            listData.push(item2);
        }
        var timeout = 0;
        if (this.matchstatsListrender.containerTarget.tabIndex != this.tabview.currentActiveTab) {
            timeout = 500;
            this.tabview.tabs[this.matchstatsListrender.containerTarget.tabIndex].showLoader();
        }
        setTimeout(()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.tabview.tabs[this.matchstatsListrender.containerTarget.tabIndex].hideLoader();
            this.matchstatsListrender.setDataSource(listData);
        }, timeout);
        this.autoInterval();
    }
    loadMatchLineups(data, ignoreCache) {
        var listData = [];
        var item = {
            "data": data,
            "type": 1
        };
        listData.push(item);
        if (data.commentaries.substitutions && (data.commentaries.substitutions.localteam && data.commentaries.substitutions.localteam.length || data.commentaries.substitutions.visitorteam && data.commentaries.substitutions.visitorteam.length)) {
            var item = {
                "data": data,
                "type": 2
            };
            listData.push(item);
        }
        if (data.commentaries.substitutes && (data.commentaries.substitutes.localteam && data.commentaries.substitutes.localteam.length || data.commentaries.substitutes.visitorteam && data.commentaries.substitutes.visitorteam.length)) {
            var item = {
                "data": data,
                "type": 3
            };
            listData.push(item);
        }
        var timeout = 0;
        if (this.matchlineupsListrender.containerTarget.tabIndex != this.tabview.currentActiveTab) {
            this.tabview.tabs[this.matchlineupsListrender.containerTarget.tabIndex].showLoader();
            timeout = 500;
        }
        setTimeout(()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.tabview.tabs[this.matchlineupsListrender.containerTarget.tabIndex].hideLoader();
            this.matchlineupsListrender.setDataSource(listData);
        }, timeout);
    }
    loadMatchHighlights(data, ignoreCache) {
        console.log("load match highlights", this.matchHighlightListrender);
        var listData = [];
        var item = {
            "data": data,
            "type": 13
        };
        listData.push(item);
        var timeout = 0;
        if (this.matchHighlightListrender.containerTarget.tabIndex != this.tabview.currentActiveTab) {
            this.tabview.tabs[this.matchHighlightListrender.containerTarget.tabIndex].showLoader();
            this.waitingForActiveHighlightsTab = true;
            return;
        }
        setTimeout(()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.tabview.tabs[this.matchHighlightListrender.containerTarget.tabIndex].hideLoader();
            this.matchHighlightListrender.setDataSource([
                {
                    "type": 13,
                    "data": data
                }
            ]);
        }, timeout);
    }
    loadMatchChat() {
        console.log("load match cht");
        if (!this.chatListrender.initialized) {
            this.tabview.tabs[this.chatListrender.containerTarget.parent.tabIndex].showLoader();
            this.chatListrender.initSocketIO();
        } else this.chatListrender.scrollTo(9999999);
    }
    autoInterval(overrideInterval) {
        clearTimeout(this.matchLoadHandler);
        this.matchLoadHandler = setTimeout(()=>{
            if (document.hidden) {
                console.warn("no auto refresh because page is hidden");
                return;
            }
            ///if old data match is already finished do nothing.
            if (this.matchData && (0, $9yWe2.MatchUtil).isFinished(this.matchData)) {
                console.log("match is already finished, no auto refresh");
                return;
            }
            (0, $kc8Kt.DataProvider).getMatch((0, $fRpWP.UrlManager).getModule("mid"), this.getProxy(function(response) {
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.autoInterval();
                    return;
                }
                //todo error screen
                //the header of hte matchscreen uses cached data, which can be set from the outside.
                this.matchData = response.getData();
                (0, $dNeVp.ManiaCache).setShortCache("match", this.matchData);
                this.matchHeader.setPresetData(this.matchData, true);
                //coordinator needs this to properly collapse based on different status
                this.coordinatoranimator.matchStatus = this.matchData.status;
                if ((0, $9yWe2.MatchUtil).isFinished(this.matchData)) {
                    this.getPageTemplate().createMenuMatch(false, this.matchData.id);
                    console.log("stop auto refresh. match is finished");
                    return;
                } else this.getPageTemplate().createMenuMatch(true, this.matchData.id);
                this.loadMatchStats(this.matchData);
                if (this.matchlineupsListrender) {
                    if (this.matchData.commentaries && !this.matchData.commentaries.teams && this.matchData.commentaries_predicted && this.matchData.commentaries_predicted.teams) {
                        var oldCommentaries = this.matchData.commentaries;
                        this.matchData.commentaries = this.matchData.commentaries_predicted;
                        this.matchData.commentaries.isPredicted = true;
                        this.matchData.commentaries.commentaries = oldCommentaries.commentaries;
                    }
                    if (this.matchData.commentaries && this.matchData.commentaries.teams) this.loadMatchLineups(this.matchData);
                }
            }));
        }, overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.match);
    }
    acceptInteraction(data) {
        var message = "";
        // this.bottomArrow.unbind('click');
        // this.bottomInput.unbind('click');
        // this.bottomInput.unbind('keyup');
        this.bottomInput.bind('click', ()=>{
            this.bottomInput.setData("");
        });
        this.bottomArrow.bind('click', ()=>{
            this.chatListrender.addMessage(this.bottomInput.getData());
            this.bottomInput.setData("");
        });
        this.bottomInput.bind('keyup', (e)=>{
            if (e.keyCode == 13) {
                this.chatListrender.addMessage(this.bottomInput.getData());
                this.bottomInput.setData("");
            } else {
                message = this.bottomInput.getData();
                console.log("the current message = " + message);
            }
        });
    }
}






var $fRpWP = parcelRequire("fRpWP");




var $02mnx = parcelRequire("02mnx");

var $dNeVp = parcelRequire("dNeVp");



var $gQQqD = parcelRequire("gQQqD");
//this control runs in combination with collapser (topbar) and tabiew
// when target scroller scrolls down it collapses the topbar and tabview tabs.
const $3a49f5885469e8cf$export$af2d04701265f81a = function() {
    var version = "1.0";
    var tabs = [];
    var scrollerMethods = [];
    var touchStartMethod = null;
    var touchEndMethod = null;
    var collapser = null;
    var tabview = null;
    var ignoreEvents = false;
    var ignoreEventForIndex = [];
    var lastListIndexScrolling = -1;
    var unloaded = false;
    this.isTouching = false;
    this.reducerRatio = 0.3;
    this.transitionDuration = 100;
    this.alwaysCollapseOnBackScrolling = true;
    this.isCollapsed = false;
    this.lastRecalculateWasCollapsed = null;
    this.isVirtuallyCollapsed = false;
    this.lastScrollPositionAfterTouchStart = -1;
    this.lastYOffsetAfterTouchStart = 0;
    this.currentTranslateY = 0;
    this.currentActiveTab = -1;
    this.onCollapseChanged = null;
    this.addScrollerContainer = function(tab) {
        tabs.push(tab);
    };
    this.addCollapser = function(c) {
        collapser = c;
    };
    this.addTabView = function(tab) {
        tabview = tab;
    };
    this.unload = function() {
        unloaded = true;
        if (collapser) collapser.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        }) //reset
        ;
        if (tabs) for(var i = 0; i < tabs.length; i++){
            var scrollEl = jQuery("#" + tabs[i].getClientId());
            if (scrollerMethods[i]) scrollEl.off("scroll", scrollerMethods[i]);
        }
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        collapser = null;
        tabs = null;
    };
    this.onWindowResize = function() {
        this.recalculate(true);
    };
    this.tabChange = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        var delay = 300;
        var that = this;
        $("#" + collapser.getClientId()).css({
            "transform": "translate(0px,0px)",
            "transition-duration": delay + "ms"
        });
        $("#" + tabview.tabHolder.getClientId()).css({
            "transform": "translate(0px,0px)",
            "transition-duration": delay + "ms"
        });
        this.currentTranslateY = 0;
        this.isVirtuallyCollapsed = false; //set this to false, because we set all scroll positions to 0 so everything becomes decollapsed
        this.isCollapsed = false;
        setTimeout(function() {
            that.recalculate();
        }, delay);
        for(var i = 0; i < tabview.tabContents.controls.length; i++)try {
            tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0].scrollTo(0);
        } catch (e) {
            console.error("cannot recalculate no scroll container found");
        }
    };
    this.setScrollerBottomMargin = function(margin) {
        this.scrollerBottomMargin = margin;
    };
    this.recalculateTab = function(i) {
        if (!FootballManiaConfig.graphics.animations) return;
        if (!tabs) {
            console.warn("cannot recalcuate without tabs");
            return;
        }
        if (!tabview || !tabview.tabContents || !tabview.tabContents.controls[i] || !tabview.tabContents.controls[i].controls[1] || !tabview.tabContents.controls[i].controls[1].controls[0]) {
            console.warn("cannot recalcuate without tabview elements");
            return;
        }
        var contentWindowHeight = tabview.tabContents.getDimensions().height;
        var listviewContentHeight = tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0].getDimensions().height;
        if (collapser) var collapserHeight = collapser.getDimensions().height;
        var scrollEl = jQuery("#" + this.activeScrollContainer.getClientId());
        var top = collapserHeight;
        if (!scrollEl || !scrollEl[0]) {
            console.error("some error with finding scroller");
            return;
        }
        var tab = tabview.tabContents.controls[i];
        // console.log(i,"RECALCULATE TAB ",i,"scrollheight",scrollEl[0].scrollHeight,"contentheight",contentWindowHeight,"listview height",listviewContentHeight,this.scrollerBottomMargin)
        var extraMargin = 0;
        if (this.scrollerBottomMargin) //console.log(tabview.currentActiveTab,"extra margin",this.scrollerBottomMargin)
        extraMargin = this.scrollerBottomMargin;
        $("#" + tab.getClientId()).css({
            "top": "-" + top + "px"
        });
        $("#" + tab.getClientId()).css({
            "height": "calc(100% + " + (top - extraMargin) + "px)"
        });
        //$("#" + tab.getClientId()).css({"height": contentWindowHeight + collapserHeight + "px"});
        $("#" + tab.controls[1].controls[0].controls[0].getClientId()).css({
            "position": "relative",
            "top": top + "px",
            "height": "calc(100% - " + top + "px)"
        });
    //
    // if (!$("#"+tab.controls[1].controls[0].getClientId()).isVScrollable()){
    //     console.log(i,"content is not scrollable");
    //     // $("#" + tab.getClientId()).css({"top": "-" +top+"px"});
    //     // //$("#" + tab.getClientId()).css({"height": contentWindowHeight + collapserHeight + "px"});
    //     //
    //     // $("#" + tab.controls[1].controls[0].controls[0].getClientId()).css({
    //     //     "position": "relative",
    //     //     "top": top+"px",
    //     //     "height" : contentWindowHeight+collapserHeight+"px"
    //     // });
    //     //
    //
    //     // $("#" + tab.getClientId()).css({"box-sizing": "border-box"});
    //     //$("#" + tab.getClientId()).css({"top": "-" +top+"px"});
    //     //$("#" + tab.controls[1].controls[0].controls[0].getClientId()).css({"margin-top": "+" + top + "px", "height": "100%"});
    //     //$("#" + tab.parent.getClientId()).css({"height":"calc(100% + "+top+"px)"});
    // }
    // else{
    //     $("#" + tab.getClientId()).css({"top": "-" +top+"px"});
    //     //$("#" + tab.getClientId()).css({"height": contentWindowHeight + collapserHeight + "px"});
    //
    //     $("#" + tab.controls[1].controls[0].controls[0].getClientId()).css({
    //         "position": "relative",
    //         "top": top+"px",
    //         "height" : ""
    //     });
    //
    //
    //
    //     $("#" + tab.getClientId()).css({"box-sizing": "border-box"});
    //     //$("#" + tab.getClientId()).css({"top": "-" +top+"px"});
    //     // $("#" + tab.controls[1].controls[0].controls[0].getClientId()).css({"margin-top": "+" + top + "px", "height": ""});
    //     // $("#" + tab.parent.getClientId()).css({"height":"calc(100% + "+top+"px)"});
    //
    //     console.log(i,"content is scrollable",this.isCollapsed);
    // }
    //
    //
    //
    // return;
    // //when scrolllist is longer than the window (we can acualy scroll)
    // if (listviewContentHeight > contentWindowHeight) {
    //     $("#" + tabview.tabContents.controls[i].getClientId()).css({"top": "-" +top+"px"});
    //     $("#" + tabview.tabContents.controls[i].getClientId()).css({"height": contentWindowHeight + collapserHeight + "px"});
    //
    //     $("#" + tabview.tabContents.controls[i].controls[1].controls[0].controls[0].getClientId()).css({
    //         "position": "relative",
    //         "top": top+"px",
    //         "height" : contentWindowHeight+collapserHeight+"px"
    //     });
    //     //}
    //     $("#" + tabview.tabContents.controls[i].controls[0].getClientId()).css({"height": contentWindowHeight + collapserHeight + "px"});
    //     //enlarge the scrollbar
    // }
    // else{
    //     //console.log("no nonon ono no");
    //    //console.log("tab ",i,' content is not needed for scroll',contentWindowHeight)
    //     if (this.isCollapsed){
    //         //$("#" + tabview.tabContents.controls[i].getClientId()).css({"transform":"translate(0px,"+-collapserHeight+"px)","transition-duration": "100ms"});
    //         //$("#" + tabview.tabContents.controls[i].getClientId()).css({"top": "-" +top+"px"});
    //     }
    //     else{
    //         //$("#" + tabview.tabContents.controls[i].getClientId()).css({"transform":"translate(0px,0px)","transition-duration": "100ms"})
    //         $("#" + tabview.tabContents.controls[i].getClientId()).css({"top": "0px"});
    //         //$("#" + tabview.tabContents.controls[i].getClientId()).css({"height": contentWindowHeight + "px"});
    //
    //         if (scrollEl.scrollTop() == 0){
    //             $("#" + tabview.tabContents.controls[i].controls[1].controls[0].controls[0].getClientId()).css({
    //                 "position": "absolute",
    //                 "top": "0px",
    //             });
    //         }
    //         else{
    //
    //         }
    //     }
    // }
    };
    this.recalculate = function(force) {
        //return;
        if (!FootballManiaConfig.graphics.animations) return;
        if (!tabview) //console.log("cannot recalculate without tabview");
        return;
        console.log("RECALCULATE POSITIONS", tabview.currentActiveTab, "isCollapsed", this.isCollapsed);
        if (!force && this.lastRecalculateWasCollapsed != null && this.isCollapsed == this.lastRecalculateWasCollapsed) //console.log("dont repeat calculation");
        return;
        this.lastRecalculateWasCollapsed = this.isCollapsed;
        var collapserHeight = collapser.getDimensions().height;
        if (this.isCollapsed) {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
        }
        for(var i = 0; i < tabview.tabContents.controls.length; i++){
            if (!tabview.tabContents.controls[i].controls[1].controls[0]) {
                console.error("cannot recalculate tab without list");
                continue;
            }
            this.recalculateTab(i);
        }
    };
    this.autoCollapseOrOpen = function(scrollPosition) {
        if (this.isAutoCollapsing) return;
        this.isAutoCollapsing = true;
        if (this.currentTranslateY == 0) {
            this.isCollapsed = false;
            this.isVirtuallyCollapsed = false;
        } else if (this.currentTranslateY == -collapser.getDimensions().height) {
            this.isCollapsed = true;
            this.isVirtuallyCollapsed = true;
        }
        if (this.currentTranslateY == 0 || this.currentTranslateY == -collapser.getDimensions().height) {
            //console.log("no auto collapse when already open or closed",this.currentTranslateY);
            this.recalculate();
            this.isAutoCollapsing = false;
            return;
        }
        var collapserHeight = collapser.getDimensions().height;
        var that = this;
        var delay = 300;
        if (scrollPosition > collapserHeight * (1 / this.reducerRatio) / 2) {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": delay + "ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": delay + "ms"
            });
            that.currentTranslateY = -collapserHeight;
            this.isCollapsed = true;
            this.isVirtuallyCollapsed = true;
            this.onCollapseChanged();
            clearTimeout(this.tempTimeout);
            this.tempTimeout = setTimeout(function() {
                that.currentTranslateY = -collapserHeight;
                that.recalculate();
                that.isAutoCollapsing = false;
            }, delay);
        } else {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px,0px)",
                "transition-duration": delay + "ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px,0px)",
                "transition-duration": delay + "ms"
            });
            that.currentTranslateY = 0;
            this.isCollapsed = false;
            this.isVirtuallyCollapsed = false;
            this.onCollapseChanged();
            clearTimeout(this.tempTimeout);
            this.tempTimeout = setTimeout(function() {
                //that.currentTranslateY = 0;
                that.recalculate();
                that.isAutoCollapsing = false;
            }, delay);
        }
    };
    this.prepare = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        var collapserHeight = collapser.getDimensions().height;
        //this.isVirtuallyCollapsed = false;
        //make sure we start with a collapsed one before everything gets rendered. causes flickering
        if (this.isCollapsed) {
            this.isVirtuallyCollapsed = true;
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
        }
    };
    this.setActiveScrollContainer = function(active) {
        if (this.activeScrollContainer) {
            var scrollEl = jQuery("#" + this.activeScrollContainer.getClientId());
            scrollEl.off("scroll", this.scrollMethod);
        }
        this.activeScrollContainer = active;
    };
    this.run = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        console.log("RUN ANIMATOR FOR AGENDA " + version);
        lastListIndexScrolling = tabview.currentActiveTab;
        var that = this;
        var timeoutHandler = null;
        var timeoutHandler2 = null;
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        touchStartMethod = function(e) {
            clearTimeout(timeoutHandler2);
            clearTimeout(timeoutHandler);
            clearTimeout(that.tempTimeout);
            that.isTouching = true;
            //var scrollElement = tabs[tabview.currentActiveTab];
            var scrollElement = that.activeScrollContainer;
            var topOffset = document.querySelector("#" + scrollElement.getClientId()).scrollTop;
            that.lastScrollPositionAfterTouchStart = topOffset;
            that.lastYOffsetAfterTouchStart = that.currentTranslateY;
        };
        touchEndMethod = function() {
            that.isTouching = false;
        };
        $('body').on({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        var scrollEl = jQuery("#" + this.activeScrollContainer.getClientId());
        scrollEl.scroll(this.scrollerMethod);
        jQuery("#" + this.activeScrollContainer.getClientId()).on("scroll", this.scrollMethod);
        if (scrollEl[0]) this.recalculate();
    };
    var prevScroll = -1;
    var that = this;
    this.scrollMethod = function(e) {
        if (that.ticking) return;
        var index = 0;
        var scrollDiff;
        window.requestAnimationFrame(function() {
            that.ticking = true;
            var topOffset = e.originalEvent.target.scrollTop;
            if (prevScroll == topOffset) {
                that.ticking = false;
                // console.log("do nothing no scroll change");
                return;
            }
            lastListIndexScrolling = index;
            clearTimeout(that.timeoutHandler2);
            that.timeoutHandler2 = setTimeout(function() {
                clearTimeout(that.timeoutHandler);
                var topOffset = e.originalEvent.target.scrollTop;
                if (!that.isTouching) that.autoCollapseOrOpen(topOffset);
            }, 250);
            var topOffset = e.originalEvent.target.scrollTop;
            var collapserHeight = collapser.getDimensions().height;
            if (!that.alwaysCollapseOnBackScrolling) scrollDiff = Math.max(-topOffset, -collapserHeight);
            else {
                if (that.isCollapsed && that.isVirtuallyCollapsed) {
                    var t = (that.lastScrollPositionAfterTouchStart - topOffset) * that.reducerRatio - collapserHeight;
                    scrollDiff = Math.max(-collapserHeight, Math.min(0, t));
                } else if (that.lastScrollPositionAfterTouchStart != -1) {
                    var t = (that.lastScrollPositionAfterTouchStart - topOffset) * that.reducerRatio + that.lastYOffsetAfterTouchStart;
                    scrollDiff = Math.min(0, Math.max(-collapserHeight, t));
                } else //first time otherwise we always have collapsed after startng
                scrollDiff = 0;
            }
            that.currentTranslateY = scrollDiff;
            ///console.log("scroll event ",index,scrollDiff,that.isCollapsed)
            //this virtualcollapsed value is a little different than iscollapsed
            //when user is collapsing and no touchend event is fired then the state of
            //iscollapsed remains the same. the virtualcollapsed one changes
            //this is needed in the recalculation of positions
            if (scrollDiff == -collapserHeight) that.isVirtuallyCollapsed = true;
            else that.isVirtuallyCollapsed = false;
            //collapser.setCss({"transform":"translate(0px,"+scrollDiff+"px)","transition-duration": this.transitionDuration+"ms"});
            collapser.setCss({
                "transform": "translate(0px," + scrollDiff + "px)",
                "transition-duration": that.transitionDuration + "ms"
            });
            //tabview.tabHolder.setCss({"transform":"translate(0px,"+scrollDiff+"px)","transition-duration": this.transitionDuration+"100ms"});
            tabview.tabHolder.setCss({
                "transform": "translate(0px," + scrollDiff + "px)",
                "transition-duration": that.transitionDuration + "ms"
            });
            prevScroll = e.originalEvent.target.scrollTop;
            that.ticking = false;
        });
    };
};



var $kc8Kt = parcelRequire("kc8Kt");






class $13d02572b444e49f$export$3204f4f09a89ab8b extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        this.currentActiveTab = -1;
        this.maxVisibleTabs = 5;
        super.init();
        this.tabTitles = [];
        this.addCssClass("tabholder2");
        var tabIndicator = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabIndicator.addCssClass("tabviewindicator");
        this.addControl(tabIndicator);
        this.tabIndicator = tabIndicator;
    }
    recalculateSizes() {
        var w = this.getDimensions().width;
        var c = this.maxVisibleTabs;
        var tabw = Math.floor(w / c);
        this.calculatedTabWidth = tabw;
        for(var i = 0; i < this.controls.length; i++){
            if (this.controls[i] instanceof (0, $5983bd27facb3353$export$ff49c445471d74bb)) {
                if (this.controls[i].hasCssClass("tabholder-title-container2")) this.controls[i].setCss({
                    'width': tabw + "px"
                });
            //this.controls[i].setCss({'width':tabw+"px"});
            }
        }
        var indicatorOffset = this.currentActiveTab * tabw;
        var speed = 0;
        $("#" + this.tabIndicator.getClientId()).css({
            "transform": "translate(" + indicatorOffset + "px)",
            "transition-duration": speed + "ms"
        });
    }
    renderTabs(tabs) {
        var w = this.getDimensions().width;
        var c = this.maxVisibleTabs;
        var tabw = Math.floor(w / c);
        this.calculatedTabWidth = tabw;
        this.tabIndicator.setCss({
            'width': tabw - 20 + "px",
            "margin-left": "10px"
        });
        var initialScrollPos = 0;
        for(var i = 0; i < tabs.length; i++){
            var tabTitleContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            tabTitleContainer.addCssClass("tabholder-title-container2");
            tabTitleContainer.setStyle("width:" + tabw + "px");
            this.addControl(tabTitleContainer);
            var tabTitleContainerBg = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            tabTitleContainerBg.addCssClass("tabholder-title-container-bg");
            tabTitleContainer.addControl(tabTitleContainerBg);
            var tabTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            tabTitle.addControl(tabs[i].title);
            tabTitle.addCssClass("tabholder-title");
            tabTitleContainer.addControl(tabTitle);
            this.tabTitles.push(tabTitle);
            var that = this;
            var startClickTime = 0;
            (function(index, tabTitleContainer, tabTitleContainerBg) {
                tabTitleContainer.bind("touchstart", function() {
                    tabTitleContainerBg.addCssClass("tabholder-title-container-bg-touch");
                    tabTitleContainerBg.addCssClass("tabholder-title-container-bg-touch2");
                    startClickTime = new Date().getTime();
                //console.log("tap")
                });
                tabTitleContainer.bind("touchend", function() {
                    if (new Date().getTime() - startClickTime > 300) tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch2");
                    else setTimeout(function() {
                        tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch2");
                    }, 300);
                    if (new Date().getTime() - startClickTime > 100) tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch");
                    else setTimeout(function() {
                        tabTitleContainerBg.removeCssClass("tabholder-title-container-bg-touch");
                    }, 100);
                    //console.log("tap end");
                    that.tabClicked(index, 150);
                });
                tabTitleContainer.bind("click", function() {
                    // console.log('click');
                    that.tabClicked(index, 150);
                });
            })(i, tabTitleContainer, tabTitleContainerBg);
        }
        console.log("scroll to ", initialScrollPos);
    }
    moveToTab(index, speed) {
        if (this.tabTitles[this.currentActiveTab]) this.tabTitles[this.currentActiveTab].removeCssClass("active");
        this.currentActiveTab = index;
        console.log("---------------------------> move to tab ", this.currentActiveTab, this.tabTitles[this.currentActiveTab].getClientId());
        console.log(this.tabTitles[this.currentActiveTab]);
        setTimeout(()=>{
            this.tabTitles[this.currentActiveTab].addCssClass("active");
        }, 0);
        var w = this.getDimensions().width;
        var c = this.maxVisibleTabs;
        var tabw = Math.floor(w / c);
        var indicatorOffset = index * tabw;
        $("#" + this.tabIndicator.getClientId()).css({
            "transform": "translate(" + indicatorOffset + "px)",
            "transition-duration": speed + "ms"
        });
        document.querySelector("#" + this.getClientId()).scrollTo({
            top: 0,
            left: index * tabw - Math.floor(this.maxVisibleTabs / 2) * tabw,
            behavior: speed === 0 ? "instant" : "smooth"
        });
    }
    translateTabIndicator(progression) {
        var indicatorOffset = this.currentActiveTab * this.calculatedTabWidth + 1 * (this.calculatedTabWidth * progression);
        $("#" + this.tabIndicator.getClientId()).css({
            "transition-duration": "0ms",
            "transform": "translate(" + indicatorOffset + "px)"
        });
    }
    tabClicked(index, speed) {
        this.triggerEvent("onTabClicked", {
            index: index,
            speed: speed
        });
    }
}
class $13d02572b444e49f$export$56b391fe9ebdd0ae extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        this.currentActiveTab = 0;
        this.enableScrolling = true;
        this.cachedElements = [];
        this.maxVisibleTabs = 5;
        this.cachedParllaxBgXOffset = 0;
        this.maxRenderedContent = 3;
        super.init();
        this.addCssClass("tabview");
        this.tagName = "nav";
        var tabHolder = new $13d02572b444e49f$export$3204f4f09a89ab8b();
        this.addControl(tabHolder);
        var tabHolderBg = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabHolder.addControl(tabHolderBg);
        tabHolderBg.addCssClass("tabholder-bg");
        var tabContents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        tabContents.tagName = "main";
        tabContents.addCssClass("tabContents");
        this.addControl(tabContents);
        this.tabHolder = tabHolder;
        this.tabContents = tabContents;
    }
    unload() {
        this.cachedElements = null;
        this.tabs = null;
    }
    onWindowResize() {
        console.log("on window resize");
        var delay = 20;
        if (!this.windowResizeHandler) delay = 0;
        clearTimeout(this.windowResizeHandler);
        this.recalculateSizes();
    }
    createComponents() {
        this.tabHolder.maxVisibleTabs = this.maxVisibleTabs;
    }
    setTabTitles(tabs) {
        this.tabs = tabs;
        for(var i = 0; i < tabs.length; i++)tabs[i].tabIndex = i;
    }
    renderTabs() {
        if (this.parallaxBg) {
            if (this.tabs.length > 1) this.parallaxBg.setCss({
                'width': '120%'
            });
            else this.parallaxBg.setCss({
                'width': '100%'
            });
        }
        this.tabHolder.renderTabs(this.tabs);
        this.tabHolder.bind("onTabClicked", (e, data)=>{
            this.moveToTab(data.index, data.speed);
        });
        this.tabHolder.invalidateDisplay();
        //
        var windowHeight = jQuery(window).height();
        var top = $("#" + this.tabHolder.getClientId()).height();
        var height = windowHeight - top - $("#" + this.tabHolder.getClientId()).offset().top;
        this.tabContents.setCss({
            'height': height + "px"
        });
        //calculate width and create tabs
        var w = this.getDimensions().width;
        //add the conent items
        var left = -(Math.floor(this.maxRenderedContent / 2) * w);
        for(var i = 0; i < this.maxRenderedContent; i++){
            var p = new (0, $624900cc2abfdfb6$export$304e526a606cf55c)();
            p.enableBounce();
            p.enableFastScroll = this.enableFastScroll;
            p.addCssClass("tab-content-item");
            //p.setStyle("width:"+w+"px;height:100%;left:"+left+"px;background-color:"+colors[i]+";");
            p.setStyle("width:100%;height:100%;left:" + left + "px;");
            this.tabContents.addControl(p);
            var tabContents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            tabContents.setStyle("width:100%;height:100%;");
            p.addControl(tabContents);
            left += w;
            var dataIndex = i - Math.floor(this.maxRenderedContent / 2) + this.currentActiveTab;
            this.triggerEvent("requestTabContent", {
                dataIndex: dataIndex,
                elementIndex: i,
                target: tabContents
            });
            //we override this method to make sure the bouncepanel understands
            //which scroll element it needs
            p.getContentScrollContainer = function() {
                return this.controls[1].controls[0]; //hack assumption. for now ok
            };
        }
        this.triggerEvent("newContentTabVisible", this.tabContents.controls[Math.floor(this.maxRenderedContent / 2)]);
        this.tabContents.invalidateDisplay();
        this.registerSwipe();
        this.triggerEvent("onReady");
        this.moveToTab(this.currentActiveTab, 0, true);
    }
    recalculateSizes() {
        var w = this.getDimensions().width;
        var left = -(Math.floor(this.maxRenderedContent / 2) * w);
        var tabw = Math.floor(w / this.tabs.length);
        var windowHeight = jQuery(window).height();
        var top = $("#" + this.tabHolder.getClientId()).height();
        //we set the hight of the content here. we take the tabholder top and offsettop (when in collapsed mode)
        var height = windowHeight - top - $("#" + this.tabHolder.getClientId())[0].offsetTop;
        this.tabContents.setCss({
            'height': height + "px"
        });
        console.log("recalulalte tab size height", height, " window height", windowHeight, " tab holder top", $("#" + this.tabHolder.getClientId()).offset(), $("#" + this.tabHolder.getClientId())[0].offsetTop);
        for(var i = 0; i < this.tabContents.controls.length; i++){
            console.log("order ", i, this.tabContents.controls[i].id);
            this.tabContents.controls[i].recalculate();
            this.tabContents.controls[i].setCss({
                "width": w + "px",
                "left": left + "px"
            });
            this.tabContents.controls[i].repositionScrollbar();
            left += w;
        }
        this.tabHolder.recalculateSizes(tabw);
        //calculate tab contents height
        this.tabContents.setCss({
            'height': height + "px"
        });
        console.log("set height tab content ", height);
    }
    updateDisplay() {
        if (!this.tabsRendered) {
            this.renderTabs();
            this.tabsRendered = true;
            this.triggerEvent("tabsReady");
        }
    }
    moveToTab(index, speed, force) {
        console.log("render tabss", index, speed);
        if (speed == null) speed = 240;
        if (!force && this.currentActiveTab == index) {
            console.warn("cannot move to tab ", index, "already selected");
            return;
        }
        var trigger = false;
        if (this.currentActiveTab != index) trigger = true;
        //console.log("move to tabber ",index,speed,this.currentActiveTab);
        this.tabHolder.moveToTab(index, speed);
        var w = this.getDimensions().width;
        var offset;
        var diff = 0;
        var fullRequest = false;
        if (index == this.currentActiveTab) {
            offset = 0;
            console.log("no tab change");
        } else if (Math.abs(index - this.currentActiveTab) > 5) {
            offset = index - this.currentActiveTab < 0 ? this.maxRenderedContent * w : -this.maxRenderedContent * w;
            fullRequest = true;
            console.log("request full tab content request");
        } else {
            diff = index - this.currentActiveTab;
            console.log("request partial tab content request", diff, diff * w);
            offset = diff * w;
        }
        this.currentActiveTab = index;
        $("#" + this.tabContents.getClientId()).unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", this.transitionMethod);
        this.transitionMethod = ()=>{
            $("#" + this.tabContents.getClientId()).unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd");
            $("#" + this.tabContents.getClientId()).css({
                "transform": "translate(0px)",
                "transition-duration": "0ms"
            });
            if (fullRequest) for(var i = 0; i < this.tabContents.controls.length; i++){
                dataIndex = this.currentActiveTab + Math.floor(this.maxRenderedContent / 2) + i - -1;
                this.triggerEvent("requestTabContent", {
                    dataIndex: this.currentActiveTab + i - 1,
                    elementIndex: i,
                    target: this.tabContents.controls[i].controls[1]
                });
            }
            else if (diff > 0) {
                var rem = this.tabContents.controls.splice(0, diff);
                for(var i = 0; i < rem.length; i++){
                    var dataIndex = this.currentActiveTab + Math.floor(this.maxRenderedContent / 2) + i - (diff - 1);
                    //console.log("request tab data index:",dataIndex," @element",this.maxRenderedContent-(rem.length-i);
                    this.triggerEvent("requestTabContent", {
                        dataIndex: dataIndex,
                        elementIndex: this.maxRenderedContent - (rem.length - i),
                        target: rem[i].controls[1]
                    });
                }
                this.tabContents.controls = this.tabContents.controls.concat(rem);
            } else if (diff < 0) {
                diff *= -1;
                //console.log('removed',diff,this.tabContents.controls.length - diff,diff);
                var rem = this.tabContents.controls.splice(Math.max(0, this.tabContents.controls.length - diff), diff);
                for(var i = 0; i < rem.length; i++){
                    var dataIndex = this.currentActiveTab - Math.floor(this.maxRenderedContent / 2) + i;
                    //console.log("request tab data index:",dataIndex," @element",this.maxRenderedContent-(rem.length-i));
                    this.triggerEvent("requestTabContent", {
                        oldIndex: this.tabContents.controls.length + i,
                        dataIndex: dataIndex,
                        elementIndex: i,
                        target: rem[i].controls[1]
                    });
                //console.log("request new content for ",i+index+(Math.floor(this.maxRenderedContent/2))-diff);
                }
                this.tabContents.controls = rem.concat(this.tabContents.controls);
            }
            var left = -(Math.floor(this.maxRenderedContent / 2) * w);
            for(var i = 0; i < this.tabContents.controls.length; i++){
                //console.log("order no ",i,this.tabContents.controls[i].id);
                if (trigger) {
                    this.tabContents.controls[i].recalculate();
                    //we need to call update again to make sure new elements are
                    //binded in the bouncepanel.
                    this.tabContents.controls[i].updateDisplay();
                    this.tabContents.controls[i].setCss({
                        "width": w + "px",
                        "left": left + "px"
                    });
                }
                left += w;
            }
            if (trigger) {
                this.triggerEvent("newContentTabVisible", this.tabContents.controls[Math.floor(this.maxRenderedContent / 2)]);
                this.triggerEvent("tabChanged");
            }
        };
        //this is called when the transition animation is finished
        //we then reorder the visible tab content items
        $("#" + this.tabContents.getClientId()).bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", this.transitionMethod);
        //move the tab
        $("#" + this.tabContents.getClientId()).css({
            "transform": "translate(" + -offset + "px)",
            "transition-duration": speed + "ms"
        });
        //delete some caching
        this.cachedElements = [];
    }
    registerSwipe() {
        var that = this;
        var w = this.getDimensions().width;
        var cancelSpeed = 350;
        var stopSwiping = false;
        var stopScrolling = false;
        var finchingY = false;
        var finchingX = false;
        var lastScrollPosition = 0;
        var disableLeftRightAction = false;
        var tabContentsElem = jQuery("#" + that.tabContents.getClientId());
        that.cachedElements = [];
        $("#" + this.tabContents.getClientId()).swipe({
            allowPageScroll: "vertical",
            //Generic swipe handler for all directions
            swipe: function(event, direction, distance, duration, fingerCount, fingerData, currentDirection) {
                //console.log(that.currentActiveTab,that.maxRenderedContent-1 % that.currentActiveTab);
                //that.tabs[that.maxRenderedContent-1 % that.currentActiveTab].parent.enableBounce();
                disableLeftRightAction = false;
                //console.log("swiped ","dir",direction,"dis",distance,"dur",duration,"w",w,disableLeftRightAction,currentDirection);
                if (finchingY) {
                    that.tabContents.controls[Math.floor(that.maxRenderedContent / 2)].setCss({
                        "transform": "scaleY(1)"
                    });
                    $("#" + that.tabContents.controls[Math.floor(that.maxRenderedContent / 2)].getClientId()).addClass("tabContentsScaleBack").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                        $(this).removeClass("tabContentsScaleBack");
                        $(this).css("transform", "scaleY(1)");
                    });
                    setTimeout(function() {
                        that.tabContents.controls[Math.floor(that.maxRenderedContent / 2)].removeCssClass("tabContentsScaleBack");
                    }, 200);
                    finchingY = false;
                } else if (finchingX) {
                    $("#" + that.tabContents.controls[Math.floor(that.maxRenderedContent / 2)].getClientId()).addClass("tabContentsScaleBackX").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function() {
                        $(this).removeClass("tabContentsScaleBackX");
                        $(this).css("transform", "scaleX(1)");
                    });
                    setTimeout(function() {
                        that.tabContents.controls[Math.floor(that.maxRenderedContent / 2)].removeCssClass("tabContentsScaleBackX");
                    }, 200);
                    finchingX = false;
                }
                stopSwiping = false;
                stopScrolling = false;
                if (direction == "left") {
                    if (disableLeftRightAction) return;
                    var targetIndex = that.currentActiveTab + 1;
                    var speed = 200;
                    if (duration > 200) {
                        if (distance / w <= 0.50) {
                            console.log("cancel", distance / w);
                            targetIndex = that.currentActiveTab;
                            speed = cancelSpeed;
                        }
                    }
                    if (targetIndex > that.tabs.length - 1) {
                        targetIndex = that.tabs.length - 1;
                        speed = cancelSpeed;
                    }
                    that.moveToTab(targetIndex, speed, true);
                } else if (direction == "right") {
                    if (disableLeftRightAction) return;
                    var targetIndex = that.currentActiveTab - 1;
                    var speed = 200;
                    if (duration > 200) {
                        if (distance / w <= 0.50) {
                            console.log("cancel");
                            //if (distance <= w - (w*0.2)){
                            targetIndex = that.currentActiveTab;
                            speed = cancelSpeed;
                        }
                    }
                    if (targetIndex < 0) {
                        targetIndex = 0;
                        speed = cancelSpeed;
                    }
                    that.moveToTab(targetIndex, speed, true);
                } else {
                    speed = cancelSpeed;
                    that.moveToTab(that.currentActiveTab, speed, true);
                }
            },
            swipeStatus: function(event, phase, direction, distance, duration, fingers, fingerData, currentDirection) {
                var activeElementIndex = Math.floor(that.maxRenderedContent / 2);
                //that.tabs[that.currentActiveTab].parent.disableBounce();
                if (!that.cachedElements[that.tabContents.controls[activeElementIndex].getClientId()]) that.cachedElements[that.tabContents.controls[activeElementIndex].getClientId()] = document.querySelector("#" + that.tabContents.controls[activeElementIndex].controls[1].controls[0].getClientId());
                var elem = that.cachedElements[that.tabContents.controls[activeElementIndex].getClientId()];
                var speed = 0;
                var translation = 0;
                if (elem && elem.scrollTop == 0 && direction == "down") {
                    var t = Math.min(1, distance / 100);
                    translation = 1 + 0.02 * t;
                    // console.log("set translation",duration)
                    that.tabContents.controls[activeElementIndex].setCss({
                        "transform": "scaleY(" + translation + ")",
                        "transform-origin": "top right"
                    });
                    finchingY = true;
                    return;
                } else if (elem && direction == "up" && elem.scrollHeight - elem.scrollTop == elem.offsetHeight) {
                    //console.log("up",elem.scrollHeight,elem.scrollTop)
                    var t = Math.min(1, distance / 100);
                    translation = 1 + 0.02 * t;
                    that.tabContents.controls[activeElementIndex].setCss({
                        "transform": "scaleY(" + translation + ")",
                        "transform-origin": "bottom right"
                    });
                    finchingY = true;
                }
                if (elem) lastScrollPosition = elem.scrollTop;
                if (phase == "cancel") {
                    speed = cancelSpeed;
                    console.log("cancel");
                    that.moveToTab(that.currentActiveTab, speed, true);
                    //stopSwiping=  false;
                    stopScrolling = false;
                    //str +="<br/>Handler not triggered. <br/> One or both of the thresholds was not met "
                    return;
                } else if (phase == "end") {
                    //console.log("end");
                    speed = cancelSpeed;
                    //that.moveToTab(that.currentActiveTab,speed,true);
                    //stopSwiping=  false;
                    stopScrolling = false;
                    //str +="<br/>Handler was triggered."
                    return;
                }
                //var xDistance = Math.abs(fingerData[0].start.x - fingerData[0].last.x);
                var xDistance = Math.abs(distance);
                //disable scrolling
                if (direction == "up" || direction == "down") {
                    disableLeftRightAction = true;
                    if (!stopScrolling) stopSwiping = true;
                }
                if (!disableLeftRightAction && !stopSwiping && direction == "right") {
                    stopScrolling = true;
                    if (fingerData[0].start.x < 35) return;
                    t = 0;
                    var tNonNormalised = xDistance;
                    if (that.currentActiveTab != 0) t = Math.min(w, distance);
                    var progression = t / w;
                    tabContentsElem.css({
                        "transition-duration": "0ms",
                        "transform": "translate(" + t + "px)"
                    });
                    that.tabHolder.translateTabIndicator(-progression);
                    if (progression == 0 && fingerData[0].start.x > 30) {
                        var translation = 1 + 0.0005 * Math.min(40, tNonNormalised);
                        that.tabContents.controls[activeElementIndex].setCss({
                            "transform": "scaleX(" + translation + ")",
                            "transform-origin": "bottom left"
                        });
                        finchingX = true;
                    }
                } else if (!disableLeftRightAction && !stopSwiping && direction == "left") {
                    stopScrolling = true;
                    //event.preventDefault();
                    t = 0;
                    if (that.currentActiveTab != that.tabs.length - 1) var t = -Math.min(w, distance);
                    var progression = t / w;
                    tabContentsElem.css({
                        "transition-duration": "0ms",
                        "transform": "translate(" + t + "px)"
                    });
                    that.tabHolder.translateTabIndicator(-progression);
                    if (progression == 0 && fingerData[0].start.x > 10) {
                        var translation = 1 + 0.0005 * Math.min(20, xDistance);
                        that.tabContents.controls[activeElementIndex].setCss({
                            "transform": "scaleX(" + translation + ")",
                            "transform-origin": "bottom right"
                        });
                        finchingX = true;
                    }
                }
            },
            //Default is 75px, set to 0 for demo so any distance triggers swipe
            threshold: 30
        });
    }
}
class $13d02572b444e49f$export$fc15fc13677f3f7d extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    hideLoader(text, tab) {
        if (!this.wrapper) //return console.error("cannot hide loader. never shown");
        return;
        this.wrapper.setVisible(false);
    }
    showLoader(text, tab) {
        if (this.wrapper) {
            if (text) this.loaderText.setData(text);
            this.wrapper.setVisible(true);
            return;
        }
        this.loaderContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.loaderContainer.addCssClass("loader_container");
        this.wrapper = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.wrapper.setStyle("margin-top:-50px;");
        this.wrapper.addCssClass("loader_wrapper");
        this.wrapper.addControl(this.loaderContainer);
        this.loaderSpinner = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.loaderSpinner.addCssClass("loader_spinner");
        this.loaderSpinner.setImage("images/loader1235.svg");
        this.loaderContainer.addControl(`
        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
   <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>  
        `);
        this.loaderText = new (0, $37cbb85645b0d818$export$b04be29aa201d4f5)();
        this.loaderText.setData();
        if (text) this.loaderText.setData(text);
        this.loaderText.addCssClass("loader_text");
        this.loaderContainer.addControl(this.loaderText);
        var fade = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        fade.addCssClass("loader_fade");
        this.wrapper.addControl(fade);
        var background = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //background.addCssClass("loader_background");
        //this.loaderContainer.addControl(background);
        this.loaderfade = fade;
        this.addControl(this.wrapper, true);
    }
}





class $066a53c23ea0dafe$export$1fff54725744beb2 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "Agenda";
        this.version = 1;
        super.init();
        this.addCssClass("AgendaPage");
        this.listRenders = [];
        this.workers = [];
        this.allowableAutoRefreshDates = [];
        this.autoRefreshTimeoutHandlers = [];
        //here we know if we come from the same page or another.
        //if we navigate from back history or refresh we are not from the outside.
        //if we navigate to this page from another and the referaldata is passed in the url params
        //then we are from the outside.
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        this.requestedDateToShow = (0, $fRpWP.UrlManager).getModule("date");
        if (this.requestedDateToShow) this.requestedDateToShow = this.requestedDateToShow.replaceAll("-", "/");
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside, "---", this.requestedDateToShow);
        this.createPageLayout();
        this.coordinatoranimator = new (0, $3a49f5885469e8cf$export$af2d04701265f81a)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
            this.wrapper2 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper2.addEventListener("message", this.wrapper2);
            this.wrapper3 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper3.addEventListener("message", this.wrapper3);
        }
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).bind("showOnlyFavoritesAgendaChanged", ()=>{
            this.reApplyDataSourceInListRenders();
        });
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).bind("userpref_matchlistTypeChanged", ()=>{
            this.reApplyDataSourceInListRenders();
        });
    }
    findListRenderById(id) {
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            if (this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0].getId() == id) return this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0];
        } catch (e) {}
    }
    findIndexForRenderById(id) {
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            if (!this.tabview.tabContents.controls[i].controls[1]) continue;
            if (this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0].getId() == id) return i;
        } catch (e) {}
        return -1;
    }
    // onShowOnlyFavoritesAgendaChanged (e,setting){
    //     this.reApplyDataSourceInListRenders();
    // }
    onWorkerMessageReceived(e) {
        console.log("receive message for listrender id ", e.data[0]);
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var listRender = this.findListRenderById(e.data[0]);
        if (!listRender) {
            console.error("no listrender found for ", e.data[0]);
            return;
        }
        listRender.parent.parent.hideLoader();
        listRender.setDataSource(e.data[1]);
    }
    storeState() {
        var activeScrollPosition = 0;
        if (this.visibleListRender) activeScrollPosition = this.visibleListRender.getScroll();
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "activeScrollPosition": activeScrollPosition,
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        console.log("store state", d);
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.storeState();
        //alert("unload")
        this.stopAutoRefreshes();
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        for(var key in this.autoRefreshTimeoutHandlers)clearTimeout(this.autoRefreshTimeoutHandlers[key]);
        this.autoRefreshTimeoutHandlers = null;
        this.getPageTemplate().topTitleContainer.clear();
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).unbind("showOnlyFavoritesAgendaChanged");
        if (AppInstance.workersInitialized) {
            AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
            AppInstance.workerHelper2.removeEventListener("message", this.wrapper2);
            AppInstance.workerHelper3.removeEventListener("message", this.wrapper3);
        }
    }
    createPageLayout() {
        var row1 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row1);
        this.contentContainer = row1;
    }
    createComponents() {
        this.getPageTemplate().createMenuAgenda();
        //this.getPageTemplate().hideTitle();
        this.getPageTemplate().showTitle();
        this.createTitle();
    }
    createTitle() {
        //  var image = new Image();
        //  image.setStyle("width:28px;")
        //  image.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/flags/agendaitem.png");
        //  var title = new Panel();
        //  console.log("get title");
        //  title.addControl(Localizer.getString("agenda"));
        //  //this.getPageTemplate().topTitleContainer.addControl(image);
        //  this.getPageTemplate().topTitleContainer.addControl(title);
        //  this.getPageTemplate().topTitleContainer.invalidateDisplay();
        this.getPageTemplate().topTitleContainer.setVisible(false);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) {
            this.stopAutoRefreshes();
            this.startAutoRefreshes(); //note that this will not instantly load new data. but that doesnt matter for this page
        }
        this.previousDocumentHidden = document.hidden;
        if (document.hidden) this.stopAutoRefreshes();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
    //TODO onwindow resize for active listrenders???
    }
    onOffline() {
        console.log("on offline");
    }
    onOnline() {
        console.log("on online");
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        console.log("run app");
        this.showLoader();
        AppInstance.setup((result)=>{
            console.log("setup complete");
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", ()=>{
                    this.runApp();
                });
            }
            this.hideLoader();
            this.createTabs();
            this.tabview.bind("tabChanged", ()=>{
                console.log("tab changed  activetab", this.tabview.currentActiveTab, "active element", this.tabview.elementIndex);
                this.storeState();
                this.coordinatoranimator.tabChange();
                setTimeout(()=>{
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
                }, 1000);
            });
            var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
            if (previousState) {
                this.tabview.currentActiveTab = previousState.tabIndex;
                this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
            }
            this.contentContainer.invalidateDisplay();
            this.coordinatoranimator.prepare();
            this.coordinatoranimator.onCollapseChanged = ()=>{
                console.log("oncollapserchanged");
                this.storeState();
            };
        });
    }
    createTabs() {
        var tabview = new (0, $13d02572b444e49f$export$56b391fe9ebdd0ae)();
        this.tabview = tabview;
        this.tabview.maxVisibleTabs = 5;
        this.contentContainer.addControl(tabview);
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        var d = new Date();
        d.setUTCMinutes(0);
        d.setUTCHours(0);
        d.setUTCSeconds(0);
        d.setUTCMilliseconds(0);
        d.setTime(d.getTime() - 86400000);
        //this.allowableAutoRefreshDates.push(Intl.DateTimeFormat('en-UK').format(d));
        //console.log("CCCCC",Intl.DateTimeFormat('en-UK').format(d),('0' + d.getDate()).slice(-2) + '/'
        //     + ('0' + (d.getMonth()+1)).slice(-2) + '/'
        //     + d.getFullYear())
        this.allowableAutoRefreshDates.push(('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear());
        d.setTime(d.getTime() + 86400000);
        this.allowableAutoRefreshDates.push(('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear());
        d.setTime(d.getTime() + 86400000);
        this.allowableAutoRefreshDates.push(('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear());
        d = new Date();
        d.setMinutes(0);
        d.setHours(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        console.log(this.allowableAutoRefreshDates);
        var totalItems = 100;
        //var totalItems = 10;
        if (FootballManiaConfig.isRtl) var startTC = d.getTime() + 86400000 * Math.floor(totalItems / 2);
        else var startTC = d.getTime() - 86400000 * Math.floor(totalItems / 2);
        var dot = new Date();
        var now = new Date();
        dot.setTime(startTC);
        var tabTitles = [];
        var dateIndixes = [];
        var dataFeedExtendedVersion = []; //for far future or past data feeds we use different source
        var half = Math.floor(totalItems / 2);
        var useNormalLength = 5;
        var formatter = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            month: 'short',
            day: 'numeric'
        });
        var formatter2 = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            weekday: 'short'
        });
        for(var i = 0; i < totalItems; i++){
            //var dateIntl = Intl.DateTimeFormat('en-UK').format(dot);
            //dateIndixes.push(dateIntl);
            var dateIntl = ('0' + dot.getDate()).slice(-2) + '/' + ('0' + (dot.getMonth() + 1)).slice(-2) + '/' + dot.getFullYear();
            dateIndixes.push(dateIntl);
            var date = formatter.format(dot);
            if (dot.getDate() == now.getDate() && dot.getMonth() == now.getMonth() && dot.getFullYear() == now.getFullYear()) var day = (0, $02mnx.Localizer).getString("todaysmatches");
            else var day = formatter2.format(dot);
            if (i < half && half - useNormalLength < i || i >= half && half + useNormalLength > i) dataFeedExtendedVersion[i] = false;
            else dataFeedExtendedVersion[i] = true;
            var tab1 = {};
            tab1.title = day + "<br>" + date;
            //when page is from outsided we use this property
            if (dateIntl == this.requestedDateToShow) {
                console.log("+++++++++++++++++++", dateIntl, this.requestedDateToShow);
                tab1.initialSelected = true;
                console.log("match");
                tabview.currentActiveTab = i;
            //this.storeState();
            }
            tabTitles.push(tab1);
            if (FootballManiaConfig.isRtl) dot.setDate(dot.getDate() - 1);
            else dot.setDate(dot.getDate() + 1);
        }
        FootballManiaConfig.isRtl;
        var storeHandler;
        var listRenderScrollMethod = ()=>{
            clearTimeout(storeHandler);
            storeHandler = setTimeout(()=>{
                this.storeState();
            }, 500);
        };
        //called when tab content is changed
        tabview.bind("newContentTabVisible", (e, tabContentElement)=>{
            if (this.visibleListRender) this.visibleListRender.unbind("scroll", listRenderScrollMethod);
            this.visibleListRender = tabContentElement.controls[1].controls[0].controls[0].controls[0];
            console.log("new content tab visible", this.visibleListRender.date);
            this.coordinatoranimator.setActiveScrollContainer(tabContentElement.controls[1].controls[0]);
            this.visibleListRender.bind("scroll", listRenderScrollMethod);
            this.stopAutoRefreshes();
            this.startAutoRefreshes();
            this.coordinatoranimator.run();
            (0, $fRpWP.UrlManager).setModule("date", this.visibleListRender.date.replaceAll("/", "-"), false, true);
        });
        //called everytime when tabview wants to get content for a tab
        //date contains element index and data index.
        //usually when 3 tabs are rendered element index goes from 0,1,2
        //where 1 is the center one. data index depends on the tab titles
        tabview.bind("requestTabContent", (e, data)=>{
            data.target.clear();
            //out of bounds when most left tab or most right tab is selected
            if (data.dataIndex < 0 || data.dataIndex > dateIndixes.length - 1) return;
            var tabContent = new (0, $13d02572b444e49f$export$fc15fc13677f3f7d)();
            tabContent.addCssClass("tabviewTabContent");
            tabContent.addCssClass("noscrollbar");
            data.target.addControl(tabContent);
            var listRender = this.createAgendaDay(tabContent, data.elementIndex);
            data.target.invalidateDisplay();
            listRender.date = dateIndixes[data.dataIndex];
            console.log("request content", listRender.date, data, "index", data.elementIndex, "old index", data.oldIndex, "listrender ", listRender.id);
            if (data.dataIndex == tabview.currentActiveTab) //ok when we add the listrender to the target element
            //the listrender will only be available async.
            //thats why we add settimeout. this needs to be researched further.
            //remoing the settimeout will cause the listrender to be null in the worker recevied call
            ((listRender, data)=>{
                setTimeout(()=>{
                    this.loadAgendaDay(dateIndixes[data.dataIndex], listRender, dataFeedExtendedVersion[data.dataIndex]);
                    var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                    console.log("previous state", this.pageName, previousState);
                    if (previousState) listRender.scrollTo(previousState.activeScrollPosition || 0);
                }, 20);
            })(listRender, data);
            else ((listRender, data)=>{
                setTimeout(()=>{
                    this.loadAgendaDay(dateIndixes[data.dataIndex], listRender, dataFeedExtendedVersion[data.dataIndex]);
                }, 300);
            })(listRender, data);
        });
        FootballManiaConfig.isRtl;
        tabview.setTabTitles(tabTitles);
        tabview.bind("onReady", ()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.contentContainer.addCssClass("fadeIn").setStyle("margin-top:0;");
            this.coordinatoranimator.run();
        });
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) this.coordinatoranimator.setScrollerBottomMargin(0);
            this.coordinatoranimator.recalculateTab(1);
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px", this.tabview.currentActiveTab);
            if (tab1) {
                this.coordinatoranimator.setScrollerBottomMargin(50);
                this.coordinatoranimator.recalculateTab(1);
            }
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createAgendaDay(tab, elementIndex) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = tab;
        listRender.enableFastScroll = true;
        listRender.setItemRender(function(data) {
            if (data.type == 2) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$c4b9b4982bf4840d)()
            };
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)()
            };
        });
        listRender.emptyTemplate = function() {
            var empty = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            empty.addCssClass("listViewEmptyData");
            var attention = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            attention.addCssClass("icon-attention");
            attention.setStyle("width:60px;height:60px;");
            empty.addControl(attention);
            empty.addControl((0, $02mnx.Localizer).getString("no_matches_found"));
            //empty.addControl("<div style='margin-top:20px;' class='text-small'>"+Localizer.getString("you_have_enabled_favorite_filter")+"</div>");
            let set = (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda();
            if (set) empty.addControl("<div style='color:orange;margin-top:20px;margin-left:50px;margin-right:50px;' class='text-small'>" + (0, $02mnx.Localizer).getString("you_have_enabled_favorite_filter") + "</div>");
            return empty;
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(this.findIndexForRenderById(listRender.getId()));
        });
        listRender.fastScrollElementTemplate = ()=>{
            var panel = new (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)();
            var icon = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            var label = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            panel.addControl(icon);
            panel.addControl(label);
            return panel;
        };
        listRender.bind('requestFastScrollIndicatorItem', (e, data)=>{
            if (!data.item) return;
            var icon = data.element.controls[0];
            var label = data.element.controls[1];
            icon.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.item.country.replaceAll(" ", "-").toLowerCase() + ".png", 30, 30);
            label.clear();
            label.addControl("<b>" + data.item.localizedCountry + "</b><br>" + "<p style='font-size:13px;'>" + data.item.league + "</p>", true);
        });
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.todayScrollPosition || 0);
        container.addControl(listRender);
        tab.addControl(container);
        return listRender;
    }
    loadAgendaDay(date, listRenderTarget, extendedDataFeed, allowAutoRefresh, ignoreCache, dontShowLoader, isFromAutoRefresh) {
        //when page is already loaded then we dont load when page is hidden. but not first time, because it can happen that interstitial hides the screen first time
        if (this["firstTimeLoading" + date] && document.hidden) return this.autoRefresh(listRenderTarget);
        this["firstTimeLoading" + date] = true;
        (0, $dNeVp.ManiaCache).getMemoryCache("fixtureDate" + date);
        if (!dontShowLoader) listRenderTarget.parent.parent.showLoader();
        listRenderTarget.date = date;
        (0, $kc8Kt.DataProvider).getFixturesForDate(date, extendedDataFeed, (response)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!response.isOk()) {
                listRenderTarget.parent.parent.hideLoader();
                if (isFromAutoRefresh) return;
                var str = (0, $02mnx.Localizer).getString("nointernet") + "<br>" + (0, $02mnx.Localizer).getString("taptotryagain");
                listRenderTarget.showError(str, ()=>{
                    this.loadAgendaDay(date, listRenderTarget, extendedDataFeed, allowAutoRefresh, true);
                });
                return;
            }
            listRenderTarget.loadedDatasource = response.getData();
            var options = {
                methodType: 7,
                responseData: response.getData(),
                fixedRegions: AppInstance.getConfig().fixedRegions,
                fixedLeagueOrder: AppInstance.getConfig().fixedLeaguesOrder,
                favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
                favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
                translations: (0, $02mnx.Localizer).getLoadedLocale(),
                defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
                locale: AppInstance.getLocale(),
                enabledFeatures: AppInstance.getConfig().enabledFeatures,
                userRegionLocale: FootballManiaConfig.userRegionLocale,
                userCountry: FootballManiaConfig.detectedUserCountry,
                hiddenTitles: FootballManiaConfig.hideCountryTitleFor,
                listRenderId: listRenderTarget.getId(),
                showOnlyFavorites: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(),
                subscribedTeams: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(),
                subscribedLeagues: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(),
                subscribedMatches: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches(),
                fontSize: FootballManiaConfig.size,
                listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
            };
            if (!FootballManiaConfig.useWebWorkers) {
                var list = (0, $gQQqD.Processors).prepareTodayFeedData(options);
                var data = {
                    data: [
                        listRenderTarget.getId(),
                        list.listData,
                        list.foundUnfiltered
                    ]
                };
                this.onWorkerMessageReceived(data);
            } else {
                //some round robin logic to get one of the X workers.
                if (this.usedWorker == undefined) this.usedWorker = 0;
                else if (this.usedWorker >= this.workers.length - 1) this.usedWorker = 0;
                else this.usedWorker += 1;
                AppInstance.getWorker(this.usedWorker).postMessage(options);
            }
            if (allowAutoRefresh && this.findListRenderById(listRenderTarget.getId())) this.autoRefresh(listRenderTarget);
        }, ignoreCache);
    }
    autoRefresh(listRender, overrideInterval) {
        if (this.unloaded) return console.warn("no auto refresh because page is unloaded");
        if (!listRender || !listRender.date) {
            console.error("no listrender or date", listRender);
            return;
        }
        clearTimeout(this.autoRefreshTimeoutHandlers[listRender.date]);
        this.autoRefreshTimeoutHandlers[listRender.date] = setTimeout(()=>{
            if (document.hidden) {
                console.warn("no auto refresh because page is hidden");
                return;
            }
            console.log("auto refresh now", listRender.date);
            this.loadAgendaDay(listRender.date, listRender, false, true, true, true, true);
        }, overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.agenda);
    }
    stopAutoRefreshes() {
        for(var i = 0; i < this.autoRefreshTimeoutHandlers.length; i++)clearTimeout(this.autoRefreshTimeoutHandlers[this.autoRefreshTimeoutHandlers[i]]);
        this.autoRefreshTimeoutHandlers = [];
    }
    startAutoRefreshes(listRender) {
        this.stopAutoRefreshes();
        //console.log("start auto refreshes");
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            //ugly way of finding active listrender
            var listRender = this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0];
            //console.log("loop listrender",this.allowableAutoRefreshDates,listRender.date);
            var allowRefresh = this.allowableAutoRefreshDates.indexOf(listRender.date) != -1 ? true : false;
            if (allowRefresh) // console.log("allow auto refresh");
            this.autoRefresh(listRender);
        //console.log(listRender,listRender.date);
        } catch (e) {
            console.error("error reloading listrender maybe out of bounds ", e);
        }
    }
    /**
     * call this when you want to set datasource in listrender again
     * for example after you enabled filter. worker is using filter data
     */ reApplyDataSourceInListRenders() {
        console.log("reapply datasource in listrender");
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            if (this.usedWorker == undefined) this.usedWorker = 0;
            else if (this.usedWorker >= this.workers.length - 1) this.usedWorker = 0;
            else this.usedWorker += 1;
            //ugly way of finding active listrender
            var listRender = this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0];
            listRender.scrollTo(0);
            if (!listRender.loadedDatasource) {
                console.error("no datasource to reapply");
                continue;
            }
            console.log(listRender.loadedDatasource);
            var options = {
                methodType: 7,
                responseData: listRender.loadedDatasource,
                fixedRegions: AppInstance.getConfig().fixedRegions,
                fixedLeagueOrder: AppInstance.getConfig().fixedLeaguesOrder,
                favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
                favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
                translations: (0, $02mnx.Localizer).getLoadedLocale(),
                defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
                locale: AppInstance.getLocale(),
                enabledFeatures: AppInstance.getConfig().enabledFeatures,
                userRegionLocale: FootballManiaConfig.userRegionLocale,
                userCountry: FootballManiaConfig.detectedUserCountry,
                hiddenTitles: FootballManiaConfig.hideCountryTitleFor,
                listRenderId: listRender.getId(),
                showOnlyFavorites: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(),
                subscribedTeams: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(),
                subscribedLeagues: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(),
                subscribedMatches: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches(),
                fontSize: FootballManiaConfig.size,
                listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
            };
            AppInstance.getWorker(this.usedWorker).postMessage(options);
        } catch (e) {
            console.error("error reapplying datasource in listrender ", e);
        }
    }
}








var $fRpWP = parcelRequire("fRpWP");




var $02mnx = parcelRequire("02mnx");
parcelRequire("dNeVp");



var $gQQqD = parcelRequire("gQQqD");

var $5er4g = parcelRequire("5er4g");

var $6K7Df = parcelRequire("6K7Df");



var $kc8Kt = parcelRequire("kc8Kt");











var $02mnx = parcelRequire("02mnx");


parcelRequire("fRpWP");
class $438ff7cfa3a4e816$export$3b8f910dd0fe7f82 extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier, disableUrlHistory, data) {
        super.init(urlIdentifier, disableUrlHistory);
        this.data = data;
        this.selectedData = [];
        this.allCountries = [];
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 50) + "px;justify-content: flex-start;");
        p.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("addFavoriteModalTitle");
        title.addControl((0, $02mnx.Localizer).getString("select_leaguecup"));
        p.addControl(title);
        var selectedContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        selectedContainer.addCssClass("selectedCountriesContainer");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.setStyle("font-size: 12px;font-weight: bold;margin-bottom: 10px;");
        this.selectedCount = title;
        selectedContainer.addControl(title);
        p.addControl(selectedContainer);
        var searchResults = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchResults.addCssClass("addFavoriteModalSuggestList");
        searchResults.setStyle("height:100%;overflow-y:scroll;width:85%;");
        p.addControl(searchResults);
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
        this.renderLeagues(searchResults, this.data);
    }
    renderLeagues(target, data) {
        target.clear();
        for(var i = 0; i < data.leagues.length; i++){
            if (!data.leagues[i].name) continue;
            var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            resultP.addCssClass("suggestionsItemTitle");
            var countryFlag = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            countryFlag.setStyle("width: 24px; height: 24px; margin-inline-end: 10px;");
            countryFlag.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.countrygs.replaceAll(" ", "-").toLowerCase() + ".png");
            resultP.addControl(countryFlag);
            var countryPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            countryPanel.setStyle("margin-bottom:3px;width:100%;");
            var subType = "";
            if (data.leagues[i].subtype) subType = " - " + data.leagues[i].subtype;
            countryPanel.addControl("<b>" + data.leagues[i].name + subType + "</b>");
            ((resultP, league)=>{
                resultP.bind("click", ()=>{
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(league, {
                        "currentActiveTab": this.currentActiveTab
                    });
                });
            })(resultP, data.leagues[i]);
            resultP.addControl(countryPanel);
            target.addControl(resultP);
        }
        target.invalidateDisplay();
    }
    renderSearchResult(data, target) {
        this.renderTeamItem(data, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[data.id_gs]);
    }
}










var $9yWe2 = parcelRequire("9yWe2");

var $02mnx = parcelRequire("02mnx");



var $lU8CH = parcelRequire("lU8CH");
class $884f7ad69d27d69a$export$48ddb42d9676aafe extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.panel.setStyle("margin-top:3px;");
        this.card.setStyle("padding-bottom:4px;");
        this.content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.content.addCssClass("flexHorizontalAlign");
        this.content.setStyle("align-items: flex-start;");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("info"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        this.card.addControl(this.content);
        this.addControl(this.panel);
    }
    setData(data) {
        this.content.addControl("<table class='tableStandings' style='width:100%;'>");
        if (data.data.founded) this.createInfo((0, $02mnx.Localizer).getString("founded"), data.data.founded);
        // if (data.data.city) {
        //     this.createInfo(Localizer.getString("city"), data.data.city);
        // }
        if (data.data.venuecity) this.createInfo((0, $02mnx.Localizer).getString("city"), data.data.venuecity);
        this.createInfo((0, $02mnx.Localizer).getString("country"), data.data.country);
        if (data.data.url) {
            var element = this.createInfo((0, $02mnx.Localizer).getString("website"), data.data.url);
            element.bind("click", function() {
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).openUrl(data.data.url, true);
            });
            element.setStyle("height: 30px;cursor:pointer;");
        }
        if (data.data.coach) this.createInfo((0, $02mnx.Localizer).getString("coach"), data.data.coach);
        //this.content.addControl("</table>");
        //this.content.addControl("<table class='tableStandings' style='width:100%;'>");
        if (data.data.venue) this.createInfo((0, $02mnx.Localizer).getString("venue"), data.data.venue);
        if (data.data.venuecapacity) this.createInfo((0, $02mnx.Localizer).getString("capacity"), data.data.venuecapacity);
        if (data.data.venuesurface) this.createInfo((0, $02mnx.Localizer).getString("surface"), (0, $02mnx.Localizer).getString(data.data.venuesurface.replaceAll(" ", "_")));
        if (data.data.venueaddress) this.createInfo((0, $02mnx.Localizer).getString("address"), data.data.venueaddress);
    //this.content.addControl("</table>");
    }
    createInfo(title, data) {
        var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
        row.setStyle("height: 30px;cursor:none;");
        var th1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        th1.setStyle("padding-inline-end:8px;padding-inline-start:8px;text-align:end;vertical-align: top;font-variant:all-small-caps;font-size:14px;");
        th1.addControl(title + " : ");
        var th2 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        th2.addControl(data);
        th2.setStyle("width:50%;text-align:start;font-weight:bold;vertical-align: top;font-variant:all-small-caps;font-size:14px;");
        row.addControl(th1);
        row.addControl(th2);
        this.content.addControl(row);
        return row;
    }
}
class $884f7ad69d27d69a$export$926c397976e908f6 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listViewItem");
        this.panel.setStyle("flex-direction:inherit;");
        this.panel.addCssClass("flexHorizontalAlign");
        var startContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        startContainer.addCssClass("flexHorizontalAlign");
        var playerinfoCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        playerinfoCon.addCssClass("flexVerticalAlign");
        playerinfoCon.setStyle("align-items: flex-start;");
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.setStyle("margin-inline-start:4px;width:40px; height:40px;align-self: center;border-radius:30px; overflow:hidden;");
        //this.imageBox.placeholderData = countryPlaceHolder
        this.pos = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.pos.addCssClass("flexHorizontalAlign");
        this.pos.setStyle("height:50px;width:18px;margin-inline-start:4px;");
        this.playerName = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerName.setStyle("margin-inline-start:8px;display: flex;align-content: center;align-items: center;");
        //this.playerName.addCssClass("flexVerticalAlign");
        this.playerTeam = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerTeam.setStyle("font-size:11px;font-weight:200;margin-inline-start:8px;display: flex;align-content: center;align-items: center;");
        //this.playerTeam.addCssClass("flexVerticalAlign");
        this.goals = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.goals.addCssClass("flexHorizontalAlign");
        this.goals.setStyle("height:50px;width:30px;");
        playerinfoCon.addControl(this.playerName);
        playerinfoCon.addControl(this.playerTeam);
        startContainer.addControl(this.pos);
        startContainer.addControl(this.imageBox);
        startContainer.addControl(playerinfoCon);
        this.panel.addControl(startContainer);
        this.panel.addControl(this.goals);
        this.addControl(this.panel);
    }
    setData(data) {
        this.pos.addControl(data.pos + "");
        this.goals.addControl(data.goals + "");
        this.playerName.addControl(data.name);
        this.playerTeam.addControl(data.team);
        if (AppInstance.getConfig().enabledFeatures.playerImages) this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + data.id + "_small_rnd.png", 40, 40);
        else {
            this.imageBox.imageObjectStyle = "margin-top:-16px;margin-left:-16px;";
            if (data.nationality) this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replace(/\s|\'/g, '-').toLowerCase() + ".png", 72, 72);
            else this.imageBox.setVisible(false);
        }
        this.panel.bind("click", function() {
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(data.id);
        });
    }
}
class $884f7ad69d27d69a$export$c70b389a21e7ce0d extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.panel.setStyle("margin-top:3px;");
        this.addControl(this.panel);
    }
    setData(data) {
        super.setData(data);
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("upcoming_matches"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var matchList = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        for(var i = 0; i < data.data.futureMatches.length; i++){
            data.data.futureMatches[i].leaguename = (0, $lU8CH.RemoveReservedIfNeeded)(data.data.futureMatches[i].leaguename);
            var info = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            info.addCssClass("MatchH2HMatchTitleContainer");
            info.addControl("<p>" + (0, $9yWe2.MatchUtil).getLocalizedDate(data.data.futureMatches[i]) + "</p>");
            info.addControl("<p>" + data.data.futureMatches[i].leaguename + "</p>");
            matchList.addControl(info);
            var itemRender = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)();
            itemRender.setData(data.data.futureMatches[i]);
            matchList.addControl(itemRender);
        }
        this.card.addControl(matchList);
    }
}
class $884f7ad69d27d69a$export$e05519108f552c4e extends $884f7ad69d27d69a$export$c70b389a21e7ce0d {
    init() {
        super.init();
    }
    setData(data) {
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("nowlive"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var matchList = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        data.data.nowPlaying.leaguename = (0, $lU8CH.RemoveReservedIfNeeded)(data.data.nowPlaying.leaguename);
        var info = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        info.addCssClass("MatchH2HMatchTitleContainer");
        info.addControl("<p>" + (0, $9yWe2.MatchUtil).getLocalizedDate(data.data.nowPlaying) + "</p>");
        info.addControl("<p>" + data.data.nowPlaying.leaguename + "</p>");
        matchList.addControl(info);
        var itemRender = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)();
        itemRender.setData(data.data.nowPlaying);
        matchList.addControl(itemRender);
        this.card.addControl(matchList);
    }
}
class $884f7ad69d27d69a$export$6651050503f57e08 extends $884f7ad69d27d69a$export$c70b389a21e7ce0d {
    init() {
        super.init();
    }
    setData(data) {
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        if (data.data.todayPlaying.isfinished) title.addControl((0, $02mnx.Localizer).getString("todays_played_match"));
        else title.addControl((0, $02mnx.Localizer).getString("today"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var matchList = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        data.data.todayPlaying.leaguename = (0, $lU8CH.RemoveReservedIfNeeded)(data.data.todayPlaying.leaguename);
        var info = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        info.addCssClass("MatchH2HMatchTitleContainer");
        info.addControl("<p>" + (0, $9yWe2.MatchUtil).getLocalizedDate(data.data.todayPlaying) + "</p>");
        info.addControl("<p>" + data.data.todayPlaying.leaguename + "</p>");
        matchList.addControl(info);
        var itemRender = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)();
        itemRender.setData(data.data.todayPlaying);
        matchList.addControl(itemRender);
        this.card.addControl(matchList);
    }
}
class $884f7ad69d27d69a$export$d757c7cbad19836b extends $884f7ad69d27d69a$export$c70b389a21e7ce0d {
    init() {
        super.init();
    }
    setData(data) {
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("previous_matches"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var matchList = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        for(var i = 0; i < data.data.pastMatches.length; i++){
            data.data.pastMatches[i].leaguename = (0, $lU8CH.RemoveReservedIfNeeded)(data.data.pastMatches[i].leaguename);
            var info = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            info.addCssClass("MatchH2HMatchTitleContainer");
            info.addControl("<p>" + (0, $9yWe2.MatchUtil).getLocalizedDate(data.data.pastMatches[i]) + "</p>");
            info.addControl("<p>" + data.data.pastMatches[i].leaguename + "</p>");
            matchList.addControl(info);
            var itemRender = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)();
            itemRender.setData(data.data.pastMatches[i]);
            matchList.addControl(itemRender);
        }
        this.card.addControl(matchList);
    }
}
class $884f7ad69d27d69a$export$b8215525368cb335 extends $884f7ad69d27d69a$export$c70b389a21e7ce0d {
    init() {
        super.init();
    }
    setData(data) {
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("last_played_match"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        console.log("--------", data.data.lastPlayedMatch);
        this.card.addControl(title);
        var matchList = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        data.data.lastPlayedMatch.leaguename = (0, $lU8CH.RemoveReservedIfNeeded)(data.data.lastPlayedMatch.leaguename);
        var info = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        info.addCssClass("MatchH2HMatchTitleContainer");
        info.addControl("<p>" + (0, $9yWe2.MatchUtil).getLocalizedDate(data.data.lastPlayedMatch) + "</p>");
        info.addControl("<p>" + data.data.lastPlayedMatch.leaguename + "</p>");
        matchList.addControl(info);
        var itemRender = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)();
        itemRender.setData(data.data.lastPlayedMatch);
        matchList.addControl(itemRender);
        this.card.addControl(matchList);
    }
}
class $884f7ad69d27d69a$export$aaf97b7b835b9ed6 extends $884f7ad69d27d69a$export$c70b389a21e7ce0d {
    init() {
        super.init();
    }
    setData(data) {
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("next_playing_match"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        var matchList = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        data.data.nextMatch.leaguename = (0, $lU8CH.RemoveReservedIfNeeded)(data.data.nextMatch.leaguename);
        var info = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        info.addCssClass("MatchH2HMatchTitleContainer");
        info.addControl("<p>" + (0, $9yWe2.MatchUtil).getLocalizedDate(data.data.nextMatch) + "</p>");
        info.addControl("<p>" + data.data.nextMatch.leaguename + "</p>");
        matchList.addControl(info);
        var itemRender = new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)();
        itemRender.setData(data.data.nextMatch);
        matchList.addControl(itemRender);
        this.card.addControl(matchList);
    }
}
class $884f7ad69d27d69a$export$39a7c125c26d2066 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.panel.setStyle("margin-top:3px;");
        this.card.setStyle("padding-bottom:4px;");
        this.addControl(this.panel);
    }
    setData(data) {
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $02mnx.Localizer).getString("standen"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        this.createTables(data);
    }
    createTables(data) {
        this.data = data;
        this.card.addControl("<table class='tableStandings'>");
        console.log("create tables for team standings", data);
        for(var x = 0; x < data.data.leagues.length; x++){
            var tableData = data.data.leagues[x].table;
            for(var i = 0; i < tableData.groups.length; i++){
                var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
                var groups = tableData.groups[i];
                //var title1 = Localizer.getString("round") + " " + groups.round;
                row.setStyle("height:24px;");
                var th3 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th3.addCssClass("teamTableStandingsHeader");
                th3.setAttribute("colspan", 9);
                var newGroupName = groups.group.replace(tableData.leaguename, "").replace(":", "");
                newGroupName;
                row.addControl(th3);
                //this.card.addControl(row);
                var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
                row.setStyle("height:24px;");
                var th1Arrow = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th1Arrow.setAttribute("colspan", 2);
                //th1Arrow.addControl(data.data.leagues[x].league);
                th1Arrow.setStyle("text-align:left;padding-left:4px;");
                var th3 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th3.addControl((0, $02mnx.Localizer).getString("position"));
                th3.setStyle("width:20px;");
                var th4 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th4.addControl((0, $02mnx.Localizer).getString("table_gamesplayed"));
                th4.setStyle("width:20px;");
                var th5 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th5.addControl((0, $02mnx.Localizer).getString("table_wins"));
                th5.setStyle("width:20px;");
                var th6 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th6.addControl((0, $02mnx.Localizer).getString("table_draw"));
                th6.setStyle("width:20px;");
                var th7 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th7.addControl((0, $02mnx.Localizer).getString("table_lost"));
                th7.setStyle("width:20px;");
                var th8 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th8.addControl((0, $02mnx.Localizer).getString("table_goalsforagainst"));
                th8.setStyle("width:48px;");
                var th9 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th9.addControl((0, $02mnx.Localizer).getString("table_goaldiff"));
                th9.setStyle("width:20px;");
                var th10 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
                th10.addControl((0, $02mnx.Localizer).getString("table_points"));
                th10.setStyle("width:20px;");
                row.addControl(th1Arrow);
                //row.addControl(th2);
                row.addControl(th3);
                row.addControl(th4);
                row.addControl(th5);
                row.addControl(th6);
                row.addControl(th7);
                row.addControl(th8);
                row.addControl(th9);
                row.addControl(th10);
                this.card.addControl(row);
                for(var j = 0; j < groups.teams.length; j++){
                    var team = groups.teams[j];
                    var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
                    row.setStyle("height:34px;");
                    //colArrow.
                    data.data.leagues[x].league = (0, $lU8CH.RemoveReservedIfNeeded)(data.data.leagues[x].league);
                    var col1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    col1.addCssClass("TeamStandingsTeamName");
                    if (FootballManiaConfig.isRtl) //col1.addControl("<p style='float:right;'>"+Localizer.getString("position") + ": " + team.position+"</p>");
                    col1.addControl("<p style=''>" + data.data.leagues[x].league + "</p>");
                    else //col1.addControl("<p style='float:left;'>"+Localizer.getString("position") + ": " + team.position+"</p>");
                    col1.addControl("<p style=''>" + (0, $lU8CH.WordShorthand)(data.data.leagues[x].league) + "</p>");
                    if (team.isLive) col1.addCssClass("standingsLive");
                    var colArrow = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    if (team.position_change > 0) col1.addControl("<p style='float:left;margin-left:8px;margin-top: 4px;' class='arrow-up'></p>");
                    else if (team.position_change < 0) col1.addControl("<p  style='float:left;margin-left:8px;margin-top: 4px;' class='arrow-down'></p>");
                    var p = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    p.addControl(team.position + "");
                    var gp = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    gp.addControl(team.matchPoints + "");
                    var w = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    w.addControl(team.totalWon + "");
                    var d = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    d.addControl(team.totalDraw + "");
                    var l = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    l.addControl(team.totalLost + "");
                    var gf = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    gf.addControl(team.totalGoalsFor + "-" + team.totalGoalsAgainst);
                    var gd = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    gd.addControl(team.totalGoalsFor - team.totalGoalsAgainst + "");
                    var points = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
                    points.addControl(team.points + "");
                    row.addControl(col1);
                    row.addControl(colArrow);
                    row.addControl(p);
                    row.addControl(gp);
                    row.addControl(w);
                    row.addControl(d);
                    row.addControl(l);
                    row.addControl(gf);
                    row.addControl(gd);
                    row.addControl(points);
                    this.card.addControl(row);
                    (function(team, league, alternativeRender) {
                        row.bind("click", function() {
                            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showLeagueScreen(league, {
                                "action": "showStandings"
                            });
                        });
                    })(team, data.data.leagues[x], this.alternativeRender);
                }
            }
        }
        this.card.addControl("</table>");
    }
}
class $884f7ad69d27d69a$export$133f8ecae0b56d7d extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listViewHeader");
        this.addControl(this.panel);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addControl(this.contents);
    }
    setData(data) {
        super.setData(data);
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.contents.addControl(this.data.title);
        this.invalidateDisplay();
    }
}
class $884f7ad69d27d69a$export$a94e0da976df9a2a extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listViewItem");
        this.panel.addCssClass("flexHorizontalAlign");
        this.panel.addCssClass("noDirection"); //sub childs already have direction
        var startContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        startContainer.addCssClass("flexHorizontalAlign");
        var playerinfoCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        playerinfoCon.addCssClass("flexVerticalAlign");
        playerinfoCon.setStyle("align-items: flex-start;");
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.addCssClass("");
        this.imageBox.setStyle("margin-inline-start:4px;width:40px; height:40px;align-self: center;border-radius:30px; overflow:hidden;");
        this.redCross = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.redCross.addCssClass("cross");
        this.redCross.setStyle("margin-inline-start:-13px;margin-top:-10px;position:absolute;width:20px;height:20px;");
        this.redCross.setVisible(false);
        this.captain = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.captain.addCssClass("captain");
        this.captain.setStyle("margin-inline-start:-47px;margin-top:-10px;position:absolute;width:10px;height:10px;");
        this.captain.setVisible(false);
        this.number = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.number.addCssClass("number");
        this.number.setStyle("margin-inline-start:-3px;margin-top:20px;position:absolute;width:10px;height:10px;font-size:11px;");
        this.number.setVisible(false);
        this.pos = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.pos.addCssClass("flexHorizontalAlign");
        this.pos.setStyle("height:50px;min-width:28px;margin-inline-start:4px;");
        this.playerNameContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerNameContainer.addCssClass("flexVerticalAlign");
        this.playerNameContainer.setStyle("margin-inline-start:12px;display: flex;align-content: center;align-items: flex-start;");
        this.playerName = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerName.addCssClass("TeamSquadPlayerNameContainer");
        this.playerInfo = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerInfo.setStyle("font-weight:normal;font-size:11px;");
        this.playerNameContainer.addControl(this.playerName);
        this.playerNameContainer.addControl(this.playerInfo);
        //this.playerTeam.addCssClass("flexVerticalAlign");
        var stats = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        stats.addCssClass("flexVerticalAlign");
        var minifiedStats = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        minifiedStats.addCssClass("flexHorizontalAlign");
        var extendedStats = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        extendedStats.addCssClass("verticalAlign");
        playerinfoCon.addControl(this.redCross);
        playerinfoCon.addControl(this.captain);
        playerinfoCon.addControl(this.number);
        playerinfoCon.addControl(this.playerNameContainer);
        playerinfoCon.addControl(this.playerTeam);
        startContainer.addControl(this.imageBox);
        startContainer.addControl(playerinfoCon);
        startContainer.addControl(this.pos);
        this.panel.addControl(startContainer);
        this.panel.addControl(stats);
        stats.addControl(minifiedStats);
        stats.addControl(extendedStats);
        this.minifiedStats = minifiedStats;
        this.extendedStats = extendedStats;
        //stats.addControl(bottomStats);
        this.addControl(this.panel);
    }
    createMinifiedItem(iconclass, value) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.addCssClass("flexHorizontalAlign");
        container.setStyle("align-items: center;justify-content: flex-start;margin-inline-start:4px;width:35px;");
        var icon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        icon.addCssClass("icon " + iconclass);
        var text = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        text.setStyle("margin-inline-start:2px;");
        text.addCssClass("teamSquadPlayerStatsText");
        text.addControl(value + "");
        container.addControl(icon);
        container.addControl(text);
        return container;
    }
    createExtendedItem(title, value) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.addCssClass("flexHorizontalAlign");
        container.setStyle("margin-inline-start:4px;width:150px;line-height:25px;");
        var icon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        icon.addControl(title);
        var text = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        text.setStyle("margin-inline-start:2px;");
        text.addCssClass("teamSquadPlayerStatsText");
        text.addControl(value + "");
        container.addControl(icon);
        container.addControl(text);
        return container;
    }
    setData(data) {
        if (data.number) {
            //this.pos.addControl("<p style=font-size:10px;position:absolute;>(" + data.number + ")</p>");
            this.number.setVisible(true);
            this.number.addControl(data.number, true);
        }
        //this.goals.addControl(data.goals);
        this.playerName.addControl(data.name);
        if (AppInstance.getConfig().enabledFeatures.playerImages) this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + data.id + "_small_rnd.png", 40, 40);
        else {
            this.imageBox.imageObjectStyle = "margin-top:-16px;margin-left:-16px;";
            if (data.nationality) this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replace(/\s|\'/g, '-').toLowerCase() + ".png", 72, 72);
            else this.imageBox.setVisible(false);
        }
        if (data.injured == "True") {
            this.redCross.setVisible(true);
            if (data.injuryDescription) {
                this.playerInfo.addControl((0, $02mnx.Localizer).getString(data.injuryDescription.toLowerCase().replace("/", "").replaceAll(" ", "")));
                this.playerInfo.addControl(" (" + data.injuryFrom + ")");
            }
        }
        if (data.isCaptain && data.isCaptain != "0" && data.isCaptain != "") this.captain.setVisible(true);
        if (!this.showExtendedStats) {
            this.extendedStats.setVisible(false);
            this.minifiedStats.setVisible(true);
            this.minifiedStats.addControl(this.createMinifiedItem("ball", data.goals));
            this.minifiedStats.addControl(this.createMinifiedItem("soccercard yellow", parseInt(data.yellowcards || 0)));
            this.minifiedStats.addControl(this.createMinifiedItem("soccercard red", parseInt(data.redcards || 0) + parseInt(data.yellowred || 0)));
        } else {
            this.extendedStats.setVisible(true);
            this.minifiedStats.setVisible(false);
            this.extendedStats.addControl(this.createExtendedItem("goals", data.goals));
        // this.extendedStats.addControl(this.createExtendedItem("yellowcards", data.goals));
        // this.extendedStats.addControl(this.createExtendedItem("redcards", data.goals));
        // this.extendedStats.addControl(this.createExtendedItem("ball", data.goals));
        }
        this.panel.bind("click", function() {
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(data.id);
        });
    }
}
class $884f7ad69d27d69a$export$2e7dd623c03ef8b3 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listViewItem");
        this.panel.addCssClass("flexHorizontalAlign");
        this.panel.addCssClass("noDirection"); //sub childs already have direction
        var startContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        startContainer.addCssClass("flexHorizontalAlign");
        var playerinfoCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        playerinfoCon.setStyle("align-items: flex-start;");
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.setStyle("margin-inline-start:4px;width:40px; height:40px;align-self: center;border-radius:30px; overflow:hidden;");
        this.pos = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.pos.addCssClass("flexHorizontalAlign");
        this.pos.setStyle("height:50px;min-width:24px;margin-inline-start:8px;");
        this.playerNameContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerNameContainer.setStyle("margin-inline-start:8px;display: flex;align-content: center;align-items: flex-start;");
        this.playerName = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerInfo = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerInfo.setStyle("font-weight:200;font-size:11px;");
        this.playerNameContainer.addControl(this.playerName);
        this.playerNameContainer.addControl(this.playerInfo);
        //this.playerTeam.addCssClass("flexVerticalAlign");
        var stats = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        stats.addCssClass("flexVerticalAlign");
        var minifiedStats = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        minifiedStats.addCssClass("flexHorizontalAlign");
        playerinfoCon.addControl(this.playerNameContainer);
        playerinfoCon.addControl(this.playerTeam);
        startContainer.addControl(this.imageBox);
        //startContainer.addControl(this.pos);
        startContainer.addControl(playerinfoCon);
        this.panel.addControl(startContainer);
        this.panel.addControl(stats);
        stats.addControl(minifiedStats);
        this.minifiedStats = minifiedStats;
        this.addControl(this.panel);
        this.panel.bind("click", ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showCoachScreen(this.data.coachid);
        });
    }
    createMinifiedItem(iconclass, value) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.addCssClass("flexHorizontalAlign");
        container.setStyle("align-items: center;justify-content: flex-start;margin-inline-start:4px;width:35px;");
        var icon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        icon.addCssClass("icon " + iconclass);
        var text = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        text.setStyle("margin-inline-start:2px;");
        text.addCssClass("teamSquadPlayerStatsText");
        text.addControl(value + "");
        container.addControl(icon);
        container.addControl(text);
        return container;
    }
    setData(data) {
        this.data = data.data;
        this.playerName.addControl(data.data.coach);
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        //this.panel.setCss({"height":data.style.height+"px"});
        if (AppInstance.getConfig().enabledFeatures.playerImages) this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/coachimages/" + data.data.coachid + "_small_rnd.png", 40, 40);
        else {
            this.imageBox.imageObjectStyle = "margin-top:-16px;margin-left:-16px;";
            if (data.data.coachnationality) this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.data.coachnationality.replace(/\s|\'/g, '-').toLowerCase() + ".png", 72, 72);
            else {
                console.log();
                this.imageBox.setVisible(false);
            }
        }
    }
}
class $884f7ad69d27d69a$export$8e0fabc9037fba90 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listViewHeader");
        this.addControl(this.panel);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addControl(this.contents);
    }
    setData(data) {
        super.setData(data);
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.contents.addControl(this.data.title);
        this.invalidateDisplay();
    }
}
class $884f7ad69d27d69a$export$e8628cf973978ad2 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("");
        this.panel.addCssClass("listViewItem");
        this.panel.addCssClass("flexHorizontalAlign");
        this.panel.addCssClass("noDirection"); //sub childs already have direction
        var startContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        startContainer.addCssClass("flexHorizontalAlign");
        var endContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        endContainer.addCssClass("flexVerticalAlign");
        endContainer.setStyle("font-size:12px;height:40px;flex-flow:column;flex:auto;margin-inline-end:10px;");
        var typeContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        typeContainer.addCssClass("flexHorizontalAlign");
        //typeContainer.setStyle("width:70px;font-size:11px;height:30px;");
        var topCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        topCon.addCssClass("flexHorizontalAlign");
        var bottomCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        bottomCon.addCssClass("flexHorizontalAlign");
        endContainer.addControl(topCon);
        endContainer.addControl(bottomCon);
        endContainer.addControl(typeContainer);
        this.dateContainer = topCon;
        this.dateContainer.setStyle("align-self: flex-end;");
        this.teamContainer = bottomCon;
        this.teamContainer.setStyle("align-self: flex-end;");
        this.typeContainer = typeContainer;
        this.typeContainer.setStyle("align-self: flex-end;");
        //this.typeContainer.setStyle("");
        ///this.dateContainer = topCon
        this.imageBox = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.imageBox.addCssClass("MatchStatsEventLocalPlayer");
        this.imageBox.setStyle("margin-inline-start:4px;");
        this.playerNameContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerNameContainer.setStyle("margin-inline-start:8px;display: flex;align-content: center;align-items: flex-start;");
        this.playerName = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerNameContainer.addControl(this.playerName);
        startContainer.addControl(this.imageBox);
        startContainer.addControl(this.playerNameContainer);
        this.panel.addControl(startContainer);
        this.panel.addControl(endContainer);
        this.addControl(this.panel);
        this.bind("click", ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(this.data.data.id);
        });
    }
    setData(data) {
        this.data = data;
        this.playerName.addControl(data.data.name);
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        if (AppInstance.getConfig().enabledFeatures.playerImages) this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + data.data.id + "_small_rnd.png");
        else this.imageBox.setVisible(false);
        this.dateContainer.addControl(data.data.date);
        this.teamContainer.addControl(data.data.team);
        if (data.data.type == "Unknown") this.typeContainer.addControl("-");
        else if (data.data.type == "Loan") this.typeContainer.addControl((0, $02mnx.Localizer).getString("loan"));
        else if (data.data.type == "Free") this.typeContainer.addControl((0, $02mnx.Localizer).getString("free_exchange"));
        else this.typeContainer.addControl(data.data.type);
        this.panel.bind("click", function() {
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(data.data.id);
        });
    }
}
class $884f7ad69d27d69a$export$1fb77fe93e51380c extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("listViewMatchHeader");
        this.panel.addCssClass("flexHorizontalAlign flexAlignStart");
        this.addControl(this.panel);
        this.imageBox = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.imageBox.addCssClass("listViewCountryFlagItem");
        this.imageBox.placeholderData = (0, $61e67aa413d59276$export$a4f156a9bb250a8c);
        this.contents = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.contents.addCssClass("listViewCountryTitle");
        this.panel.addControl(this.imageBox);
        this.panel.addControl(this.contents);
    }
    setData(data) {
        super.setData(data);
        this.contents.clear();
        this.panel.setCss({
            "height": data.style.height + "px"
        });
        this.imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + this.data.country.replaceAll(" ", "-").toLowerCase() + ".png");
        this.data.title = (0, $lU8CH.RemoveReservedIfNeeded)(this.data.title);
        this.contents.addControl(this.data.title);
        this.invalidateDisplay();
    }
}
class $884f7ad69d27d69a$export$5d4aeaf48cf752ec extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("");
        this.panel.addCssClass("noDirection"); //sub childs already have direction
        this.panel.setStyle("justify-content: flex-start;margin-bottom:10px;");
        // }");
        this.panel.addCssClass("flexHorizontalAlign");
        var startContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        startContainer.addCssClass("flexHorizontalAlign");
        ///startContainer.setStyle("min-width:100px;");
        var endContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        endContainer.addCssClass("flexVerticalAlign");
        endContainer.setStyle("font-size:13px;min-height:50px;padding-top:2px;padding-right:4px;justify-content: center");
        var seasons = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        seasons.setStyle("text-align:start; margin-inline-start:16px;");
        this.seasons = seasons;
        this.imageBoxContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.imageBoxContainer.setStyle("color:black;height:20px;width:20px;margin-inline-start:10px;margin-inline-end:10px;");
        this.imageBox = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.imageBox.setStyle("height:20px;width:20px;");
        this.position = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.position.setStyle("font-size: 15px;margin-inline-start:4px;");
        this.imageBoxContainer.addControl(this.imageBox);
        this.trophycount = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.trophycount.setStyle("width:20px;");
        startContainer.addControl(this.position);
        startContainer.addControl(this.imageBoxContainer);
        startContainer.addControl(this.trophycount);
        endContainer.addControl(seasons);
        this.panel.addControl(startContainer);
        this.panel.addControl(endContainer);
        this.addControl(this.panel);
    }
    setData(data) {
        this.imageBox.addCssClass("icon-trophy");
        if (data.status == "Winner") this.position.addControl("1");
        else if (data.status == "2nd Place") this.position.addControl("2");
        this.trophycount.addControl(data.count + "x");
        for(var i = 0; i < data.seasons.length; i++){
            this.seasons.addControl(data.seasons[i]);
            if (i == data.seasons.length - 1) ;
            else if (i % 2 == 0 && i != data.seasons.length - 1) this.seasons.addControl(",  ");
            else this.seasons.addControl(",  ");
        }
    }
}









var $02mnx = parcelRequire("02mnx");



var $fRpWP = parcelRequire("fRpWP");
class $446d11058bb1c901$export$a8567479b4d0c8e extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier, disableUrlHistory, data) {
        super.init(urlIdentifier, disableUrlHistory);
        this.data = data;
        this.selectedData = [];
        this.allCountries = [];
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 50) + "px;justify-content: flex-start;");
        p.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("addFavoriteModalTitle");
        title.addControl((0, $02mnx.Localizer).getString("select_season"));
        p.addControl(title);
        var selectedContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        selectedContainer.addCssClass("selectedCountriesContainer");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.setStyle("font-size: 12px;font-weight: bold;margin-bottom: 10px;");
        this.selectedCount = title;
        selectedContainer.addControl(title);
        p.addControl(selectedContainer);
        var searchResults = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchResults.addCssClass("addFavoriteModalSuggestList");
        searchResults.setStyle("height:100%;overflow-y:scroll;width:85%;");
        p.addControl(searchResults);
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
        this.renderSeasons(searchResults, this.data);
    }
    getYear(date) {
        return date[0] + "" + date[1] + "" + date[2] + "" + date[3];
    }
    renderSeasons(target, data) {
        console.log("render saesons ", data);
        target.clear();
        ///data.seasons = data.seasons.reverse();
        var reversed = data.tableHistory.seasons.slice().reverse();
        var nowSelected = null;
        if ((0, $fRpWP.UrlManager).getModule("tableSeason")) nowSelected = (0, $fRpWP.UrlManager).getModule("tableSeason");
        var indexSeleted = 0;
        for(var i = 0; i < reversed.length; i++){
            var s = reversed[i];
            var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            resultP.addCssClass("suggestionsItemTitle");
            resultP.setStyle("text-align:center");
            var countryFlag = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            countryFlag.setStyle("width: 24px; height: 24px; margin-inline-end: 10px;");
            //countryFlag.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.countrygs.replaceAll(" ","_").toLowerCase() + ".png");
            //resultP.addControl(countryFlag);
            var countryPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            countryPanel.setStyle("margin-bottom:3px;width:100%;");
            var starty = this.getYear(s.start_date);
            var endty = this.getYear(s.end_date);
            if (nowSelected == starty + "-" + endty) {
                countryPanel.addControl("<b style='font-size:18px;'>" + starty + " - " + endty + "</b>");
                indexSeleted = i;
            } else countryPanel.addControl(starty + " - " + endty);
            ((resultP, season)=>{
                resultP.bind("click", ()=>{
                    //Router.showLeagueScreen(league,{"currentActiveTab":this.currentActiveTab});
                    this.getPage().triggerEvent("seasonSelect", season);
                    this.destroy();
                });
            })(resultP, s);
            resultP.addControl(countryPanel);
            target.addControl(resultP);
        }
        target.invalidateDisplay();
        setTimeout(()=>{
            //TODO 50px is working , but maybe getting the height from some calculated value would be better
            jQuery("#" + target.getClientId()).scrollTop(indexSeleted * 50);
        }, 100);
    }
    renderSearchResult(data, target) {
        this.renderTeamItem(data, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[data.id_gs]);
    }
}







var $02mnx = parcelRequire("02mnx");


class $97a36908f6bfd105$export$a0c6f0531d3cecbd extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("flexHorizontalAlign");
        this.addControl(this.panel);
    }
    setData(data) {
        this.panel.addControl("<table class='tableStandings'>");
        for(var i = 0; i < data.data.trophies.seasons.length; i++){
            var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
            var row2 = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
            var th = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
            th.setStyle("font-size:var(--text-size-xxlarge);");
            th.setAttribute("colspan", 2);
            data.data.trophies.seasons[i].season;
            th.addControl(data.data.trophies.seasons[i].season);
            row.addControl(th);
            this.panel.addControl(row);
            row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
            th = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            th.addCssClass("flexHorizontalAlign");
            th.setStyle("justify-content: flex-start;text-align: start;padding-inline-start: 4px;");
            if (AppInstance.getConfig().enabledFeatures.teamImages) {
                var image = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
                image.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
                image.setCss({
                    'height': "36px",
                    'width': "36px"
                });
                image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + data.data.trophies.seasons[i].winner_team_id_gs + "_small_rnd.png", 36, 36);
                th.addControl(image);
            }
            var teamname = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            teamname.setStyle("padding-inline-start: 8px;");
            teamname.addControl(data.data.trophies.seasons[i].winner_name);
            th.addControl(teamname);
            row.addControl(th);
            th = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            th.setStyle("text-align: end;width:30%;padding-inline-end: 6px;");
            th.addControl((0, $02mnx.Localizer).getString("trophyfirst"));
            row.addControl(th);
            this.panel.addControl(row);
            row2 = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
            th = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            th.addCssClass("flexHorizontalAlign");
            th.setStyle("justify-content: flex-start;text-align: start;padding-inline-start: 4px;");
            if (AppInstance.getConfig().enabledFeatures.teamImages) {
                var image = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
                image.placeholderData = (0, $61e67aa413d59276$export$d5cd1fb4cc71c74);
                image.setCss({
                    'height': "36px",
                    'width': "36px"
                });
                image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + data.data.trophies.seasons[i].runnerup_team_id_gs + "_small_rnd.png", 36, 36);
                th.addControl(image);
            }
            var teamname = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            teamname.setStyle("padding-inline-start: 8px;");
            teamname.addControl(data.data.trophies.seasons[i].runnerup_name);
            th.addControl(teamname);
            row2.addControl(th);
            th = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            th.setStyle("text-align: end;width:30%;padding-inline-end: 6px;");
            th.addControl((0, $02mnx.Localizer).getString("trophysecond"));
            row2.addControl(th);
            if (data.data.trophies.seasons[i].runnerup_name) this.panel.addControl(row2);
            (function(winnerid, secondid) {
                row.bind("click", function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(winnerid);
                });
                row2.bind("click", function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(secondid);
                });
            })(data.data.trophies.seasons[i].winner_team_id_gs, data.data.trophies.seasons[i].runnerup_team_id_gs);
        }
        this.panel.addControl("</table>");
    }
}



class $f914ccdaa1862435$export$9fc0e0d0ecb98c84 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "League";
        this.version = 1;
        super.init();
        this.setStyle("height:100%;");
        //this is a bit hacky.
        //the id change event is fired even when we set the id of this page before
        //this logic. The reason is because the onhashchange event is async
        //and altough we change the url before this logic, the onhashchange event fires
        //afte this logic
        this.bind("renderComplete", ()=>{
            //alert("listen")
            //we do this to register back button scenario where page A is match and page B is also match
            setTimeout(function() {
                (0, $fRpWP.UrlManager).listenModule('lid', function() {
                    var id = (0, $fRpWP.UrlManager).getModule('lid');
                    if (id == undefined || (0, $fRpWP.UrlManager).getModule('section') != "League") return console.warn("ignore opening league , probably navigating to other screen");
                    AppInstance.loadPage("League", {
                        "lid": id
                    }, false);
                });
            }, 100);
        });
        this.pageName = "League_" + (0, $fRpWP.UrlManager).getModule("lid");
        this.addCssClass("LeaguePage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $23ab1716e6aced69$export$bd2148639dcb5f7e)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
        }
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        //this.tabview.tabs[0].hideLoader();
        this.fixturesListrender.setDataSource(e.data);
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "matchstatsScrollPosition": this.fixturesListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        if (this.standingsListrender) d.standingListrenderScrollPosition = this.standingsListrender.getScroll();
        if (this.topscorersListrender) d.topscorersListrenderScrollPosition = this.topscorersListrender.getScroll();
        if (this.trophiesListrender) d.trophiesListrenderScrollPosition = this.trophiesListrender.getScroll();
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.fixturesLoadHandler);
        this.modal = null;
        (0, $fRpWP.UrlManager).unlistenModule('lid');
        (0, $fRpWP.UrlManager).unlistenModule('tableSeason');
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onOffline() {
        this.getPageTemplate().createMenuLeague();
    }
    onOnline() {
        this.autoInterval(0);
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) {
            this.autoInterval(0);
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
        }
        this.previousDocumentHidden = document.hidden;
    //console.log("visibility change ",document.hidden,this);
    }
    createPageLayout() {
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().showTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.fixturesListrender) this.fixturesListrender.onWindowResize();
        if (this.standingsListrender) this.standingsListrender.onWindowResize();
        if (this.topscorersListrender) this.topscorersListrender.onWindowResize();
        if (this.trophiesListrender) this.trophiesListrender.onWindowResize();
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        console.log("run app");
        this.showLoader();
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup((result)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", ()=>{
                    this.runApp();
                });
            }
            (0, $kc8Kt.DataProvider).getLeagueMatches((0, $fRpWP.UrlManager).getModule("lid"), (response)=>{
                this.hideLoader();
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", ()=>{
                        this.runApp();
                    });
                    else return this.showError("", ()=>{
                        this.runApp();
                    });
                }
                var data = response.getData();
                this.cachedData = data;
                if (data.topscorers && data.topscorers.tournaments.length && data.topscorers.tournaments[0].players.length < 3) data.topscorers = null;
                this.createTitle(data);
                this.createTabs(data);
                this.getPageTemplate().createMenuLeague(response.getData());
                this.tabview.bind("tabChanged", ()=>{
                    this.storeState();
                    this.coordinatoranimator.tabChange();
                    console.log("-------------------> tab changed");
                // this.loadStandings(this.cachedData);
                // this.loadTopscorers(this.cachedData);
                // this.loadFixtures(this.cachedData);
                // this.loadTrophies(this.cachedData);
                });
                var storeHandler = null;
                var storeHandler2 = null;
                var storeHandler3 = null;
                this.fixturesListrender.bind("scroll", (e, scroll)=>{
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(()=>{
                        this.storeState();
                    }, 200);
                });
                var standings = false;
                var topscorers = false;
                if (this.standingsListrender) {
                    standings = true;
                    this.standingsListrender.bind("scroll", (e, scroll)=>{
                        clearTimeout(storeHandler2);
                        storeHandler2 = setTimeout(()=>{
                            this.storeState();
                        }, 200);
                    });
                    this.standingsListrender.bind("onRequestSeasonSelector", ()=>{
                        this.openSeasonSelectModal();
                    });
                    this.bind("seasonSelect", (e, season)=>{
                        console.log("seasonSelect    ", season);
                        var startYear = season.start_date[0] + "" + season.start_date[1] + "" + season.start_date[2] + "" + season.start_date[3];
                        var endYear = season.end_date[0] + "" + season.end_date[1] + "" + season.end_date[2] + "" + season.end_date[3];
                        console.log("current", this.cachedData.table.season, "choice", startYear + "/" + endYear);
                        if (this.cachedData.table.season == startYear + "/" + endYear) {
                            console.log("remove module");
                            (0, $fRpWP.UrlManager).removeModule("tableSeason");
                            (0, $fRpWP.UrlManager).updateUrl(true);
                        } else {
                            console.log("add module");
                            (0, $fRpWP.UrlManager).registerModule("tableSeason");
                            (0, $fRpWP.UrlManager).setModule("tableSeason", startYear + "-" + endYear);
                        }
                        this.loadStandings(this.cachedData);
                    });
                    //called when pressing back button.
                    (0, $fRpWP.UrlManager).listenModule("tableSeason", (module, value)=>{
                        this.loadStandings(this.cachedData);
                    });
                }
                if (this.topscorersListrender) {
                    topscorers = true;
                    this.topscorersListrender.bind("scroll", (e, scroll)=>{
                        clearTimeout(storeHandler3);
                        storeHandler3 = setTimeout(()=>{
                            this.storeState();
                        }, 200);
                    });
                }
                if (this.trophiesListrender) this.trophiesListrender.bind("scroll", (e, scroll)=>{
                    clearTimeout(storeHandler3);
                    storeHandler3 = setTimeout(()=>{
                        this.storeState();
                    }, 200);
                });
                if (FootballManiaConfig.isRtl) this.tabview.currentActiveTab = this.tabview.tabs.length - 1;
                var extraData = (0, $fRpWP.UrlManager).getModule("extradata");
                if (extraData) try {
                    extraData = JSON.parse(decodeURI(atob(extraData)));
                    if (extraData.currentActiveTab != null) this.tabview.currentActiveTab = extraData.currentActiveTab;
                    else if (extraData.action == "showStandings") this.tabview.currentActiveTab = 1;
                    (0, $fRpWP.UrlManager).removeModule("extradata");
                } catch (e) {
                    console.error(e);
                }
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                if (previousState) {
                    this.tabview.currentActiveTab = previousState.tabIndex;
                    this.fixturesListrender.scrollTo(previousState.matchstatsScrollPosition || 0);
                    console.log("restored scroll ", previousState.matchstatsScrollPosition);
                    if (this.standingsListrender) this.standingsListrender.scrollTo(previousState.standingListrenderScrollPosition || 0);
                    if (this.topscorersListrender) this.topscorersListrender.scrollTo(previousState.topscorersListrenderScrollPosition || 0);
                    this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                }
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.prepare();
                this.loadFixtures(data);
                if (this.standingsListrender && data.table && data.table.groups.length) this.loadStandings(data);
                if (this.topscorersListrender && data.topscorers && data.topscorers.tournaments.length && data.topscorers.tournaments[0].players.length) this.loadTopscorers(data);
                if (this.trophiesListrender && data.trophies) this.loadTrophies(data);
            }, false);
        });
    }
    openLeagueSelectModal(leagueOpenTabIndex) {
        var urlIdentifier = "leagueSelectModal";
        var pan = new (0, $438ff7cfa3a4e816$export$3b8f910dd0fe7f82)(urlIdentifier, true, this.cachedData.info);
        pan.currentActiveTab = this.tabview.currentActiveTab;
        pan.enableUrlHistory = false;
        this.modal = pan;
        this.getPage().addControl(pan, true);
    }
    openSeasonSelectModal(leagueOpenTabIndex) {
        var urlIdentifier = "seasonSelectModal";
        var pan = new (0, $446d11058bb1c901$export$a8567479b4d0c8e)(urlIdentifier, true, this.cachedData);
        pan.currentActiveTab = this.tabview.currentActiveTab;
        pan.enableUrlHistory = false;
        this.modal = pan;
        this.getPage().addControl(pan, true);
    }
    createTitle(data) {
        if (!data.info) return;
        var wrapper = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        wrapper.addCssClass("flexVerticalAlign");
        wrapper.setStyle("height: 43px;");
        var con = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        con.setStyle("width:100%;justify-content: center;");
        con.addCssClass("flexHorizontalAlign");
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.setStyle("width:28px;");
        image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + (0, $33b38b124674c7d3$export$6059b7f8008e8cd5).remapCountryLogo(data.info.keygs, data.info.countrygs.replaceAll(" ", "-").toLowerCase()) + ".png");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        if (!AppInstance.getConfig().enabledFeatures.showCompleteLeagueNames) {
            var regex = new RegExp(AppInstance.getConfig().reservedWords.join("|"), "g");
            data.info.title = data.info.title.replace(regex, "");
        }
        if (FootballManiaConfig.hideCountryTitleFor.indexOf(data.info.countrygs) != -1) title.addControl(data.info.title);
        else {
            title.addControl((0, $6K7Df.CountryUtil).getLocalizedCountryByName(data.info.countrygs));
            title.addControl(" - " + data.info.title);
        }
        if (data.info.subtype) {
            title.addControl(" - ");
            title.addControl(data.info.subtype);
        }
        con.addControl(image);
        con.addControl(title);
        con.addControl("<p class='arrow-down-choice' style='margin-top:3px; margin-inline-start:6px;'></p>");
        wrapper.addControl(con);
        this.getPageTemplate().topTitleContainer.addControl(wrapper);
        //this.getPageTemplate().topTitleContainer.addControl(subtitle);
        this.getPageTemplate().topTitleContainer.invalidateDisplay();
        con.bind("click", ()=>{
            this.openLeagueSelectModal(this.cachedData);
        });
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        this.tabview = tabview;
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        var tab2;
        var tab3;
        var tab4;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        //tab1.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab1.addCssClass("listViewScrollableContainer");
        tab1.title = (0, $02mnx.Localizer).getString("schedule");
        tab1.iconClass = "icon-shedule";
        var offset = 0;
        if (data.table && data.table.groups.length) {
            tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            var con = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            con.setStyle("width: 100%;position:absolute;");
            var top = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            top.addCssClass("tableHeader");
            top.setStyle("background-color:red;height:50px;width:100%;");
            var bottom = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            bottom.addCssClass("tableFooter");
            var scroller = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            scroller.addCssClass("scroller");
            //con.addControl(top);
            con.addControl(scroller);
            con.addControl(bottom);
            this.tableFooter = bottom;
            this.tableScroller = scroller;
            //tab2.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
            tab2.title = (0, $02mnx.Localizer).getString("standen");
            tab2.scrollerContainerReference = scroller;
            tab2.iconClass = "icon-listorder";
            tab2.addControl(con);
            this.createTableFooterDescriptions();
        }
        if (data.topscorers && data.topscorers.tournaments.length && data.topscorers.tournaments[0].players.length) {
            tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            //tab3.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
            tab3.addCssClass("listViewScrollableContainer");
            tab3.title = (0, $02mnx.Localizer).getString("topscoreplayers");
            tab3.iconClass = "icon-shoe";
        }
        if (data.trophies) {
            tab4 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            //tab3.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
            tab4.addCssClass("listViewScrollableContainer");
            tab4.title = (0, $02mnx.Localizer).getString("trophies");
            tab4.iconClass = "icon-trophy";
        }
        var index = 0;
        if (FootballManiaConfig.isRtl) {
            if (tab4) {
                this.createTrophiesControls(tab4, index);
                this.coordinatoranimator.addScrollerContainer(tab4);
                tabs.push(tab4);
                index++;
            }
            if (tab3) {
                this.createTopscorersControls(tab3, index);
                this.coordinatoranimator.addScrollerContainer(tab3);
                tabs.push(tab3);
                index++;
            }
            if (tab2) {
                this.createStandingsControls(scroller, index);
                this.coordinatoranimator.addScrollerContainer(scroller);
                tabs.push(tab2);
                index++;
            }
            if (tab1) {
                this.createFixturesControls(tab1, index);
                this.coordinatoranimator.addScrollerContainer(tab1);
                tabs.push(tab1);
                index++;
            }
        } else {
            if (tab1) {
                this.createFixturesControls(tab1, index);
                this.coordinatoranimator.addScrollerContainer(tab1);
                index++;
                tabs.push(tab1);
            }
            if (tab2) {
                this.createStandingsControls(scroller, index);
                this.coordinatoranimator.addScrollerContainer(scroller);
                index++;
                tabs.push(tab2);
            }
            if (tab3) {
                this.createTopscorersControls(tab3, index);
                this.coordinatoranimator.addScrollerContainer(tab3);
                index++;
                tabs.push(tab3);
            }
            if (tab4) {
                this.createTrophiesControls(tab4, index);
                this.coordinatoranimator.addScrollerContainer(tab4);
                tabs.push(tab4);
                index++;
            }
        }
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", ()=>{
            this.coordinatoranimator.run();
        });
        tab1.showLoader();
        if (tab2) tab2.showLoader();
        if (tab3) tab3.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
            if (tab2) {
                scroller.setCss({
                    'height': '(100vh - ' + this.tableViewHeightOffset + 'px)  '
                });
                tab2.setCss({
                    'height': '100%'
                });
            }
            if (tab3) tab3.setCss({
                'height': '100%'
            });
            if (tab4) tab4.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab2) {
                bottom.setCss({
                    'bottom': '50px'
                });
                scroller.setCss({
                    'height': 'calc(100% - ' + this.tableViewHeightOffset + 'px)'
                });
            }
            if (tab3) tab3.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab4) tab4.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
        console.log("load mrec banner ad", this.cachedData);
        this.loadMediumRectangle();
    }
    loadMediumRectangle(noAutoInterval) {
        if (FootballManiaConfig.isPremium) return;
        //change 1/3 to continue
        // if (Math.random() > 0.33) {
        //     return;
        // }
        //we load mrec and immediately redraw the page
        (0, $9f67281357957bbc$export$89d41d4ee5fc0b81).loadMediumRectangle((error, data)=>{
            if (error) //this.stickyBannerTargetContainer.setVisible(false);
            console.warn("error loading mrec banner", error);
            else {
                //this.adContent.setVisible(true);
                console.log("mrec ad loaded", this.cachedData, data);
                this.adContentMrec = data;
                if (!noAutoInterval) this.autoInterval(1);
            }
        });
    }
    createTableFooterDescriptions() {
        this.tableFooter.clear();
        console.log("createTableFooterDescriptions");
        var data = this.cachedData;
        if (data.historyTable) var groups = data.historyTable.groups;
        else groups = data.table.groups;
        var descriptions = {};
        for(var i = 0; i < groups.length; i++)for(var j = 0; j < groups[i].teams.length; j++){
            if (!groups[i].teams[j].description_v2) continue;
            descriptions[groups[i].teams[j].description_v2] = data.table.groups[i].teams[j].color;
        }
        var heightFooter = 0;
        for(var description in descriptions){
            var con2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            con2.addCssClass("flexHorizontalAlign");
            con2.setStyle("height:15px;justify-content: flex-start;");
            var bar = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            var text = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            bar.setStyle("margin-inline-end:4px;height:10px;width:20px;background-color:" + descriptions[description]);
            con2.addControl(bar);
            text.addControl(description);
            con2.addControl(description);
            console.log("description", description);
            this.tableFooter.addControl(con2);
            heightFooter += 15;
        }
        heightFooter += 10;
        this.tableViewHeightOffset = heightFooter + 50;
        ///set fixed height of scroller container table items.
        //this is needed because bottom description container is dynamic in height
        this.tableFooter.setCss({
            "height": heightFooter + "px"
        });
        this.tableScroller.setCss({
            "width": "100%",
            "height": "calc(100vh - " + this.tableViewHeightOffset + "px)",
            "position": "relative",
            "overflow-y": "scroll",
            "transform": "translate(0,0)"
        });
        this.tableFooter.invalidateDisplay();
    }
    createFixturesControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = tab;
        listRender.enableFastScroll = true;
        listRender.setItemRender(function(data) {
            if (data.type == 2) return {
                typeId: 2,
                render: new (0, $ae10f9e8e1dd758b$export$603c3d0f5550cd51)()
            };
            else if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$f5387a0c75ad4890)()
            };
            else if (data.type == 3) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$ee3300d1140ed632)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_schedule_available")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        listRender.fastScrollElementTemplate = ()=>{
            var panel = new (0, $bf7f47488c894fdf$export$7a7fa4424cb20976)();
            var label = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            panel.addControl(label);
            return panel;
        };
        var dt = new (0, $5er4g.DateTimecode)();
        listRender.bind('requestFastScrollIndicatorItem', (e, data)=>{
            if (!data.item) return;
            console.log(data.item);
            var label = data.element.controls[0];
            var timeInfo = "";
            if (data.item.dayTimecodeLocalized) {
                dt.setTimecode(data.item.dayTimecodeLocalized);
                timeInfo = dt.toLocaleDateString();
            }
            var roundInfo = "";
            if (data.item.week) roundInfo = (0, $02mnx.Localizer).getString("round") + " " + data.item.week;
            else if (data.item.stageName) roundInfo = data.item.stageName;
            else if (data.item.round) roundInfo = data.item.round;
            label.clear();
            label.addControl("<b>" + timeInfo + "</b><br>" + roundInfo + "</br></b>", true);
        });
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.fixturesScrollPosition || 0);
        container.addControl(listRender);
        this.fixturesListrender = listRender;
        tab.addControl(container);
    }
    createStandingsControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$d120ce917f1dbbe9)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            console.log("restore scroll #2 : ", previousState.standingListrenderScrollPosition);
            listRender.scrollTo(previousState.standingListrenderScrollPosition || 0);
        }
        container.addControl(listRender);
        this.standingsListrender = listRender;
        tab.addControl(container);
    }
    createTopscorersControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        console.log("init topscorers list render", this.tabview);
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.tabview = this.tabview;
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$926c397976e908f6)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            console.log("restore scroll #2 : ", previousState.topscorersListrenderScrollPosition);
            listRender.scrollTo(previousState.topscorersListrenderScrollPosition || 0);
        }
        container.addControl(listRender);
        this.topscorersListrender = listRender;
        tab.addControl(container);
    }
    createTrophiesControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.tabview = this.tabview;
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $97a36908f6bfd105$export$a0c6f0531d3cecbd)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            console.log("restore scroll trophiesListrenderScrollPosition : ", previousState.trophiesListrenderScrollPosition);
            listRender.scrollTo(previousState.trophiesListrenderScrollPosition || 0);
        }
        container.addControl(listRender);
        this.trophiesListrender = listRender;
        tab.addControl(container);
    }
    loadFixtures(data, ignoreCache) {
        if (!data) return this.autoInterval();
        if (!this.fixturesListrender) return console.warn("cannot load fixtures with list");
        this.tabview.currentActiveTab, this.fixturesListrender.containerTarget.tabIndex;
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var options = {
            methodType: 3,
            responseData: data,
            fontSize: FootballManiaConfig.size,
            dontSelectByCurrentData: false,
            translations: (0, $02mnx.Localizer).getLoadedLocale(),
            defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
            mrecAdData: this.adContentMrec,
            listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
        };
        if (!FootballManiaConfig.useWebWorkers) {
            var list = (0, $gQQqD.Processors).prepareFixtureData(options);
            var data = {
                data: list
            };
            this.onWorkerMessageReceived(data);
        } else AppInstance.workerHelper1.postMessage(options);
        this.tabview.tabs[this.fixturesListrender.containerTarget.tabIndex].hideLoader();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
    }
    loadStandings(data, ignoreCache) {
        console.log("load standings", data);
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        if (!this.standingsListrender) return console.warn("cannot load standings with list");
        this.tabview.currentActiveTab, this.standingsListrender.containerTarget.parent.parent.tabIndex;
        var urlTableSeason = (0, $fRpWP.UrlManager).getModule("tableSeason");
        console.log("url table season", urlTableSeason, this.cachedData);
        var proceed = true;
        //if end is year now
        if (urlTableSeason) {
            var lastYearSelector = urlTableSeason.slice(5, 9);
            var lastYearAvailableInSelections = this.cachedData.tableHistory.seasons[this.cachedData.tableHistory.seasons.length - 1].end_date.split("-")[0];
            if (lastYearSelector == lastYearAvailableInSelections) {
                proceed = false;
                this.cachedData.historyTable = null;
            }
        // var endYear = urlTableSeason.slice(5, 9);
        // var currentYear = new Date().getFullYear();
        // if (endYear == currentYear){
        //     proceed = false;
        //     this.cachedData.historyTable = null;
        // }
        } else {
            this.cachedData.historyTable = null;
            proceed = false;
        }
        console.log("no proceed");
        if (proceed) {
            //  this.standingsListrender.showLoader();
            this.tabview.tabs[this.standingsListrender.containerTarget.parent.parent.tabIndex].showLoader();
            var key = (0, $fRpWP.UrlManager).getModule("lid");
            var season = (0, $fRpWP.UrlManager).getModule("tableSeason");
            key = key + "_" + season;
            (0, $kc8Kt.DataProvider).getHistoryTable(key, (data)=>{
                if (!data.isOk()) {
                    console.error("loading history table error. fall back to current table");
                    (0, $fRpWP.UrlManager).removeModule("tableSeason");
                    (0, $fRpWP.UrlManager).updateUrl(true);
                    return this.loadStandings(this.cachedData);
                }
                this.cachedData.historyTable = data.getData();
                this.cachedData.historyTable.groups = [];
                //if is string
                if (typeof this.cachedData.historyTable.season != "string") {
                    //var startYear this.cachedData.table.season
                    const yearStart = this.cachedData.historyTable.season.start_date.slice(0, 4);
                    const yearEnd = this.cachedData.historyTable.season.end_date.slice(0, 4);
                    this.cachedData.historyTable.season = yearStart + "/" + yearEnd;
                }
                for(var i = 0; i < this.cachedData.historyTable.rounds.length; i++){
                    var round = this.cachedData.historyTable.rounds[i];
                    if (round.groups) for(var j = 0; j < round.groups.length; j++){
                        var group = round.groups[j];
                        group.round = "";
                        group.name = group.group;
                        //group.group = "";
                        group.teams = group.tables.total.teams;
                        this.cachedData.historyTable.groups.push(group);
                    }
                    else {
                        var group = {
                            country: round.country,
                            group: "",
                            round: round.round,
                            name: round.name,
                            teams: round.tables.total.teams
                        };
                        this.cachedData.historyTable.groups.push(group);
                    }
                    var listData = [];
                    var item = {
                        "data": this.cachedData,
                        "type": 1
                    };
                    listData.push(item);
                    console.log("hide loader standings index", this.standingsListrender.containerTarget.parent.parent.tabIndex);
                }
                this.tabview.tabs[this.standingsListrender.containerTarget.parent.parent.tabIndex].hideLoader();
                this.standingsListrender.setDataSource(listData);
                this.createTableFooterDescriptions();
            //clonedData.data = data.getData();
            });
        } else {
            var timeout = 0;
            if (this.tabview.currentActiveTab != this.standingsListrender.containerTarget.parent.parent.tabIndex) timeout = 1000;
            console.log("load standings ", data);
            setTimeout(()=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                var listData = [];
                var item = {
                    "data": data,
                    "type": 1
                };
                listData.push(item);
                console.log("hide loader standings index", this.standingsListrender.containerTarget.parent.parent.tabIndex);
                this.tabview.tabs[this.standingsListrender.containerTarget.parent.parent.tabIndex].hideLoader();
                this.standingsListrender.setDataSource(listData);
                this.createTableFooterDescriptions();
            }, timeout);
        }
    }
    loadTopscorers(data, ignoreCache) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        if (!this.topscorersListrender) return console.warn("cannot load topscorers with list");
        this.tabview.currentActiveTab, this.topscorersListrender.containerTarget.tabIndex;
        var timeout = 0;
        if (this.tabview.currentActiveTab != this.topscorersListrender.containerTarget.tabIndex) timeout = 1500;
        setTimeout(()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            var listData = [];
            var topscorer;
            var tournament;
            for(var i = 0; i < data.topscorers.tournaments.length; i++){
                tournament = data.topscorers.tournaments[i];
                for(var j = 0; j < tournament.players.length; j++){
                    topscorer = tournament.players[j];
                    topscorer.type = 1;
                    topscorer.style = {
                        "height": 50
                    };
                    listData.push(topscorer);
                }
            }
            console.log("hide loader standings index", this.topscorersListrender.containerTarget.parent.parent.tabIndex);
            this.tabview.tabs[this.topscorersListrender.containerTarget.tabIndex].hideLoader();
            this.topscorersListrender.setDataSource(listData);
        }, timeout);
    }
    loadTrophies(data, ignoreCache) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        if (!this.trophiesListrender) return console.warn("cannot load trophies with list");
        // if (this.tabview.currentActiveTab != this.trophiesListrender.containerTarget.tabIndex){
        //     return;
        // }
        var timeout = 0;
        if (this.tabview.currentActiveTab != this.trophiesListrender.containerTarget.tabIndex) timeout = 900;
        setTimeout(()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            var listData = [];
            var trophy;
            console.log("load trophies ", data);
            for(var i = 0; i < data.trophies.seasons.length; i++){
                trophy = data.trophies.seasons[i];
                trophy.type = 1;
                trophy.style = {
                    "height": 50
                };
                listData.push(trophy);
            }
            console.log("list data trophies", listData);
            console.log("hide loader trophy index", this.trophiesListrender.containerTarget.parent.parent.tabIndex);
            this.tabview.tabs[this.trophiesListrender.containerTarget.tabIndex].hideLoader();
            var listData = [];
            var item = {
                "data": this.cachedData,
                "type": 1
            };
            listData.push(item);
            this.trophiesListrender.setDataSource(listData);
        }, timeout);
    }
    autoInterval(overrideInterval) {
        clearTimeout(this.fixturesLoadHandler);
        this.fixturesLoadHandler = setTimeout(()=>{
            this.loadMediumRectangle(true);
            if (document.hidden) {
                console.warn("no auto refresh because page is hidden");
                return;
            }
            (0, $kc8Kt.DataProvider).getLeagueMatches((0, $fRpWP.UrlManager).getModule("lid"), (response)=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.autoInterval();
                    return;
                }
                //todo error screen
                this.cachedData = response.getData();
                this.cachedData.adContentMrec = this.adContentMrec;
                this.getPageTemplate().createMenuLeague(response.getData());
                this.loadFixtures(response.getData());
                if (this.standingsListrender) this.loadStandings(response.getData());
                if (this.topscorersListrender) this.loadTopscorers(response.getData());
            });
        }, overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.league);
    }
}




var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $gQQqD = parcelRequire("gQQqD");


//this control runs in combination with collapser (topbar) and tabiew
// when target scroller scrolls down it collapses the topbar and tabview tabs.
const $107e0c5a9208480d$export$c2d159db55e3bf03 = function() {
    var version = "1.0";
    var tabs = [];
    var scrollerMethods = [];
    var touchStartMethod = null;
    var touchEndMethod = null;
    var collapser = null;
    var tabview = null;
    var topbar = null;
    var ignoreEvents = false;
    var ignoreEventForIndex = [];
    var lastListIndexScrolling = -1;
    var unloaded = false;
    this.matchStatus; //we use this for collapser differnt ways
    this.isTouching = false;
    this.reducerRatio = 0.3;
    this.transitionDuration = 100;
    this.alwaysCollapseOnBackScrolling = true;
    this.isCollapsed = false;
    this.lastRecalculateWasCollapsed = null;
    this.isVirtuallyCollapsed = false;
    this.lastScrollPositionAfterTouchStart = -1;
    this.lastYOffsetAfterTouchStart = 0;
    this.currentTranslateY = 0;
    this.currentActiveTab = -1;
    this.addScrollerContainer = function(tab) {
        if (tabs) tabs.push(tab);
        else console.warn("cannot add, no scroll container found");
    };
    this.addCollapser = function(c) {
        collapser = c;
    };
    this.addTopBar = function(tb) {
        topbar = tb;
    };
    this.addTabView = function(tab) {
        tabview = tab;
    };
    this.unload = function() {
        unloaded = true;
        if (topbar) topbar.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        if (collapser) collapser.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        if (tabs) for(var i = 0; i < tabs.length; i++){
            var scrollEl = jQuery("#" + tabs[i].getClientId());
            if (scrollerMethods[i]) scrollEl.off("scroll", scrollerMethods[i]);
        }
        scrollerMethods = null;
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        collapser = null;
        tabs = null;
        topbar = null;
    };
    this.onWindowResize = function() {
        this.recalculate(true);
    };
    this.tabChange = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        if (this.currentActiveTab == -1) {
            console.log("nononono");
            this.currentActiveTab = tabview.currentActiveTab;
            return;
        }
        var collaped = this.isCollapsed;
        var virtuallyCollapsed = this.isVirtuallyCollapsed;
        if (collapser) var collapserHeight = collapser.getDimensions().height;
        //console.log("RECALCULATE TAB ",i,scrollEl[0].scrollHeight,contentWindowHeight,collapserHeight)
        var height = collapserHeight;
        for(var i = 0; i < tabs.length; i++){
            // if (i == tabview.currentActiveTab) continue;
            ignoreEvents = true;
            if (ignoreEventForIndex.indexOf(i) == -1) ignoreEventForIndex.push(i);
            (function(i) {
                setTimeout(function() {
                    var scrollElement = tabs[i];
                    document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                        top: collaped || virtuallyCollapsed ? height : 0,
                        left: 0
                    });
                //that.recalculateTab(i)
                }, 0);
            })(i);
            ignoreEvents = false;
        }
        this.currentActiveTab = tabview.currentActiveTab;
    };
    this.recalculateTab = function(i) {
        if (!tabs || !tabs[i]) {
            console.warn("cannot recalcuate without tabs");
            return;
        }
        if (!tabview || !tabview.tabContents || !tabview.tabContents.controls[i] || !tabview.tabContents.controls[i].controls[1] || !tabview.tabContents.controls[i].controls[1].controls[0]) {
            console.warn("cannot recalcuate without tabview elements");
            return;
        }
        var contentWindowHeight = tabview.tabContents.getDimensions().height;
        var collapserHeight = 0;
        if (collapser) collapserHeight = collapser.getDimensions().height;
        var scrollEl = jQuery("#" + tabs[i].getClientId());
        var top = collapserHeight;
        if (!scrollEl || !scrollEl[0]) {
            console.warn("no scroller");
            return;
        }
        ///console.log("RECALCULATE TAB ",i,scrollEl[0].scrollHeight,contentWindowHeight,collapserHeight)
        var height = contentWindowHeight + collapserHeight;
        if (scrollEl[0].scrollHeight > contentWindowHeight) {
            //console.log("is higher");
            //if scrollheight is higher than screenheight than
            $("#" + tabview.tabContents.controls[i].getClientId()).css({
                "transform": "translate(0px,0px)",
                "transition-duration": "0ms"
            });
            $("#" + tabview.tabContents.controls[i].getClientId()).css({
                "top": "-" + top + "px"
            });
            $("#" + tabview.tabContents.controls[i].getClientId()).css({
                "height": height + 0 + "px"
            });
            $("#" + tabview.tabContents.controls[i].controls[1].getClientId()).css({
                "height": height + "px"
            });
            if (scrollEl.scrollTop() == 0) $("#" + tabview.tabContents.controls[i].controls[1].controls[0].getClientId()).css({
                "position": "absolute",
                "top": top + "px",
                "height": height + "px"
            });
            $("#" + tabview.tabContents.controls[i].controls[0].getClientId()).css({
                "height": height + "px"
            });
        //enlarge the scrollbar
        } else {
            console.log("tab ", i, ' content is not needed for scroll', contentWindowHeight);
            if (this.isCollapsed) //if collapsed and scrollheight is smaller than screenheight we put to minus offset
            //because otherwise it canot be scrolled up (towards the topbar)
            $("#" + tabview.tabContents.controls[i].getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "100ms"
            });
            else {
                //put the scrolller to the top
                $("#" + tabview.tabContents.controls[i].getClientId()).css({
                    "transform": "translate(0px,0px)",
                    "transition-duration": "100ms"
                });
                $("#" + tabview.tabContents.controls[i].getClientId()).css({
                    "top": "0px"
                });
                $("#" + tabview.tabContents.controls[i].getClientId()).css({
                    "height": contentWindowHeight + "px"
                });
                if (scrollEl.scrollTop() == 0) $("#" + tabview.tabContents.controls[i].controls[1].controls[0].getClientId()).css({
                    "position": "absolute",
                    "top": "0px"
                });
            }
        }
    };
    this.recalculate = function(force, onlyTabIndex) {
        if (!FootballManiaConfig.graphics.animations) return;
        //return;
        if (!force && this.lastRecalculateWasCollapsed != null && this.isCollapsed == this.lastRecalculateWasCollapsed) //console.log("NO NEED TO RECALCULATE POSITIONS");
        return;
        console.log("RECALCULATE POSITIONS", "isCollapsed", this.isCollapsed);
        this.lastRecalculateWasCollapsed = this.isCollapsed;
        var collapserHeight = collapser.getDimensions().height;
        if (this.isCollapsed) {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            if (topbar) $("#" + topbar.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            if (tabview) $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
        }
        if (tabs) for(var i = 0; i < tabs.length; i++){
            var scrollEl = jQuery("#" + tabs[i].getClientId());
            console.log("XXXXXXXX", scrollEl[0].scrollHeight);
            this.recalculateTab(i);
            if (this.isCollapsed || this.isVirtuallyCollapsed) {
                if (lastListIndexScrolling != i && scrollEl.scrollTop() <= collapserHeight) {
                    console.log("scroll #1 manually tab", i, "to ", collapserHeight);
                    var scrollElement = tabs[i];
                    ignoreEvents = true;
                    if (ignoreEventForIndex.indexOf(i) == -1) ignoreEventForIndex.push(i);
                    document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                        top: collapserHeight,
                        left: 0
                    });
                    ignoreEvents = false;
                }
            } else if (lastListIndexScrolling != i && scrollEl.scrollTop() <= collapserHeight) {
                console.log("scroll #2 manually tab", i, " to ", 0);
                var scrollElement = tabs[i];
                ignoreEvents = true;
                if (ignoreEventForIndex.indexOf(i) == -1) ignoreEventForIndex.push(i);
                document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                    top: 0,
                    left: 0
                });
                ignoreEvents = false;
            }
        }
    };
    this.autoCollapseOrOpen = function(scrollPosition) {
        //return;
        if (this.isAutoCollapsing) {
            console.log("dont do twice ");
            return;
        }
        this.isAutoCollapsing = true;
        if (this.currentTranslateY == 0) this.isCollapsed = false;
        else if (this.currentTranslateY == -collapser.getDimensions().height) this.isCollapsed = true;
        if (this.currentTranslateY == 0 || this.currentTranslateY == -collapser.getDimensions().height) {
            console.log("no auto collapse when already open or closed", this.currentTranslateY);
            this.isAutoCollapsing = false;
            this.recalculate();
            return;
        }
        console.log("AUTO COLLAPSE", this.currentTranslateY);
        var collapserHeight = collapser.getDimensions().height;
        var that = this;
        var delay = 300;
        if (scrollPosition > collapserHeight * (1 / this.reducerRatio) / 2) {
            var scrollElement = tabs[tabview.currentActiveTab];
            this.isCollapsed = true;
            document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                top: collapserHeight,
                left: 0,
                behavior: "smooth"
            });
        } else {
            var scrollElement = tabs[tabview.currentActiveTab];
            document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            that.currentTranslateY = 0;
            this.isCollapsed = false;
            setTimeout(function() {
                //that.currentTranslateY = 0;
                that.recalculate();
            }, delay);
        }
    };
    this.ensureStartPositions = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        if (this.isTouching) //console.log("NO PREPARE WHEN TOUCHING");
        return;
        if (!collapser || !tabview || !topbar || !tabs) {
            console.error("NO COLLAPSER OR TABVIEW OR TOPBAR");
            return;
        }
        console.log("PREPARE RUN ANIMATOR FOR MATCHSCREEN " + version);
        var collapserHeight = collapser.getDimensions().height;
        // collapser.awayImage.setVisible(true);
        // collapser.homeImage.setVisible(true);
        collapser.homeImage.setVisible(true);
        //make sure we start with a collapsed one before everything gets rendered. causes flickering
        if (this.isCollapsed) {
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + topbar.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            var scrollElement = tabs[tabview.currentActiveTab];
            var el = document.querySelector("#" + scrollElement.getClientId());
            //console.log("scroll to 0 from start",el.scrollHeight,el.scrollTop);
            //only scroll to zero when user not scrolled
            if (el.scrollTop < collapserHeight) el.scrollTo({
                top: collapserHeight,
                left: 0
            });
        }
    };
    this.prerun = function(collapsed) {
        if (!FootballManiaConfig.graphics.animations) return;
        console.log("PRE RUN ANIMATOR FOR MATCHSCREEN " + version);
        if (collapsed) {
            this.currentTranslateY = -collapser.getDimensions().height;
            this.autoCollapseOrOpen(-collapser.getDimensions().height);
        } else this.autoCollapseOrOpen(0);
        collapser.homeImage.setVisible(false);
    }, this.run = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        console.log("RUN ANIMATOR (tabs:" + tabs.length + ") FOR TEAMSCREEN " + version);
        lastListIndexScrolling = tabview.currentActiveTab;
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        for(var i = 0; i < scrollerMethods.length; i++){
            var scrollEl = jQuery("#" + tabs[i].getClientId());
            scrollEl.off("scroll", scrollerMethods[i]);
        }
        this.recalculate();
        var that = this;
        var timeoutHandler = null;
        var timeoutHandler2 = null;
        var homeImage = collapser.homeImage;
        var backgroundImage = collapser.backgroundImage;
        var startOpacityBackground = $("#" + backgroundImage.getClientId()).css("opacity");
        touchStartMethod = function(e) {
            that.isTouching = true;
            var scrollElement = tabs[tabview.currentActiveTab];
            if (!scrollElement) {
                console.error("no scroll element in tab " + tabview.currentActiveTab + " found. do nothing?");
                return;
            }
            var topOffset = document.querySelector("#" + scrollElement.getClientId()).scrollTop;
            that.lastScrollPositionAfterTouchStart = topOffset;
            that.lastYOffsetAfterTouchStart = that.currentTranslateY;
        };
        touchEndMethod = function() {
            that.isTouching = false;
            if (that.currentTranslateY > -collapser.getDimensions().height) that.isCollapsed = false;
            clearTimeout(timeoutHandler);
            timeoutHandler = setTimeout(function() {
                if (unloaded) return;
                if (!tabs) {
                    console.error("no tabs found why??");
                    return;
                }
                that.currentActiveTab = tabview.currentActiveTab;
                var scrollElement = tabs[tabview.currentActiveTab];
                if (!scrollElement) {
                    console.error("no scroll element in tab " + tabview.currentActiveTab + " found. do nothing?");
                    return;
                }
                var topOffset = document.querySelector("#" + scrollElement.getClientId()).scrollTop;
                that.autoCollapseOrOpen(topOffset);
            }, 100);
        };
        $('body').on({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        //what if dynamic height?
        var collapserHeight = collapser.getDimensions().height;
        function runTabSCrollLogic(index) {
            // console.log("run scroll logic ",index);
            var scrollEl = jQuery("#" + tabs[index].getClientId());
            var prevScroll = null;
            var ticking = false;
            scrollerMethods[index] = function(e) {
                if (ticking) return;
                clearTimeout(timeoutHandler);
                window.requestAnimationFrame(function() {
                    ticking = true;
                    if (ignoreEvents || index != tabview.currentActiveTab) {
                        console.log("ignore scroll event if not this active tab ", index);
                        ticking = false;
                        return;
                    }
                    if (ignoreEventForIndex.indexOf(index) != -1) {
                        console.log("ignore scroll event this time", index, ignoreEventForIndex);
                        //ignoreEventForIndex = -1;
                        ignoreEventForIndex.splice(ignoreEventForIndex.indexOf(index), 1);
                        ticking = false;
                        return;
                    }
                    var topOffset = e.originalEvent.target.scrollTop;
                    if (prevScroll == topOffset) {
                        ticking = false;
                        console.log("do nothing no scroll change");
                        return;
                    }
                    lastListIndexScrolling = index;
                    clearTimeout(timeoutHandler2);
                    timeoutHandler2 = setTimeout(function() {
                        that.isAutoCollapsing = false;
                        var topOffset = e.originalEvent.target.scrollTop;
                        if (!that.isTouching) that.autoCollapseOrOpen(topOffset);
                    }, 150);
                    var topOffset = e.originalEvent.target.scrollTop;
                    if (that.isCollapsed) {
                        //console.log("is collapsed scroll",topOffset,collapserHeight);
                        if (topOffset <= collapserHeight) {
                            ///var t = ((that.lastScrollPositionAfterTouchStart - topOffset) * that.reducerRatio) - collapserHeight;
                            var t = -topOffset;
                            scrollDiff = Math.max(-collapserHeight, Math.min(0, t));
                        //scrollDiff =  t;
                        //console.log("--->",scrollDiff,t,topOffset)
                        } else //console.log("do other")
                        scrollDiff = Math.max(-topOffset, -collapserHeight);
                    } else {
                        //console.log("is not collapsed scroll",topOffset,collapserHeight);
                        if (topOffset >= collapserHeight) scrollDiff = -collapserHeight;
                        else if (that.lastScrollPositionAfterTouchStart != -1) {
                            //var t = ((that.lastScrollPositionAfterTouchStart - topOffset) * that.reducerRatio) + that.lastYOffsetAfterTouchStart;
                            var t = (collapserHeight - topOffset - collapserHeight) * that.reducerRatio;
                            var scrollDiff = Math.min(0, Math.max(-collapserHeight, t));
                            var scrollDiff = t;
                        } else scrollDiff = 0;
                    }
                    that.currentTranslateY = scrollDiff;
                    //this virtualcollapsed value is a little different than iscollapsed
                    //when user is collapsing and no touchend event is fired then the state of
                    //iscollapsed remains the same. the virtualcollapsed one changes
                    //this is needed in the recalculation of positions
                    if (scrollDiff == -collapserHeight) that.isVirtuallyCollapsed = true;
                    else that.isVirtuallyCollapsed = false;
                    //collapser.setCss({"transform":"translate(0px,"+scrollDiff+"px)","transition-duration": this.transitionDuration+"ms"});
                    collapser.setCss({
                        "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
                        "transition-duration": "80ms"
                    });
                    tabview.tabHolder.setCss({
                        "transform": "translate(0px," + scrollDiff + "px)",
                        "transition-duration": that.transitionDuration + "100ms"
                    });
                    tabview.tabHolder.setCss({
                        "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
                        "transition-duration": "80ms"
                    });
                    var progression = -scrollDiff / collapserHeight;
                    homeImage.setCss({
                        "opacity": 1 - progression * 1
                    });
                    backgroundImage.setCss({
                        "transform": "translateX(" + tabview.cachedParllaxBgXOffset + "%) translateY(" + (-50 + progression * 30) + "px)",
                        "transition-duration": "80ms",
                        "opacity": startOpacityBackground - progression * startOpacityBackground
                    });
                    topbar.setCss({
                        "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
                        "transition-duration": "80ms"
                    });
                    prevScroll = e.originalEvent.target.scrollTop;
                    ticking = false;
                });
            };
            if (scrollerMethods[index]) scrollEl.off("scroll", scrollerMethods[index]);
            scrollEl.scroll(scrollerMethods[index]);
        }
        for(var i = 0; i < tabs.length; i++)runTabSCrollLogic(i);
    };
};





var $02mnx = parcelRequire("02mnx");


var $kc8Kt = parcelRequire("kc8Kt");
const $0e66157a439e566d$export$e890d9a81f335735 = {
    storageTeamLikes: "teamLikes",
    storagePlayerLikes: "teamLikes",
    cachedTeamLikes: null,
    cachedPlayerLikes: null,
    getTeamLikes: function() {
        if (this.cachedTeamLikes) return this.cachedTeamLikes;
        var data = {};
        try {
            var raw = localStorage.getItem(this.storageTeamLikes);
            data = JSON.parse(raw);
            if (!data) data = {};
        } catch (e) {
            console.warn("error getting team likes ", e);
        }
        this.cachedTeamFavorites = data;
        return data;
    },
    didLikeTeam: function(teamid) {
        var data = this.getTeamLikes();
        if (data[teamid]) return true;
        return false;
    },
    likeTeam: function(teamid) {
        if (!this.didLikeTeam(teamid)) {
            this.cachedTeamLikes = null;
            var data = this.getTeamLikes();
            data[teamid] = 1;
            localStorage.setItem(this.storageTeamLikes, JSON.stringify(data));
            (0, $kc8Kt.DataProvider).like("team", teamid, ()=>{
                console.log("liked team ", teamid);
            });
            return true;
        }
    },
    unlikeTeam: function(key) {},
    getPlayerLikes: function() {
        if (this.cachedPlayerLikes) return this.cachedPlayerLikes;
        var data = {};
        try {
            var raw = localStorage.getItem(this.storagePlayerLikes);
            data = JSON.parse(raw);
            if (!data) data = {};
        } catch (e) {
            console.warn("error getting player likes ", e);
        }
        this.cachedPlayerLikes = data;
        return data;
    },
    didLikePlayer: function(id) {
        var data = this.getPlayerLikes();
        if (data[id]) return true;
        return false;
    },
    likePlayer: function(id) {
        if (!this.didLikePlayer(id)) {
            this.cachedPlayerLikes = null;
            var data = this.getPlayerLikes();
            data[id] = 1;
            localStorage.setItem(this.storagePlayerLikes, JSON.stringify(data));
            (0, $kc8Kt.DataProvider).like("player", id, ()=>{
                console.log("liked player ", id);
            });
            return true;
        }
    },
    unlikePlayer: function(key) {}
};
if (typeof window !== 'undefined') window.Likelizer = $0e66157a439e566d$export$e890d9a81f335735;



var $kc8Kt = parcelRequire("kc8Kt");
class $ad6492822693bd05$export$9298f05f7fab7165 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
        this.addCssClass("MatchHeaderContainer TeamHeaderContainer");
        this.bounceEnabled = true;
        var homeContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        homeContainer.addCssClass("MatchHeaderHomeContainer");
        homeContainer.setStyle("width:100%;");
        this.backgroundImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.backgroundImage.setVisible(false);
        this.backgroundImage.addCssClass("MatchHeaderBackgroundImage");
        //this.backgroundImage.addCssClass("fade-in-image2");
        this.homeImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.homeImage.addCssClass("MatchHeaderTeamLogoContainer");
        this.homeImage.setStyle("height:90px;width:90px;position:relative;");
        if (window.location.host == "stg.holoduke.nl") this.homeImage.bind("click", ()=>{
            //open url in new window
            window.open("https://tools.holoduke.nl/#id=" + this.oldData.id_gs + "&section=TeamDetail");
            window.open("https://tools.holoduke.nl/#id=" + this.oldData.id_gs + "&section=TeamDetail");
        });
        this.teamFlag = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.teamFlag.setStyle("width:40px;height:40px; position:absolute; bottom:50px; left:calc(50% - 50%/2 - 40px);");
        this.shape = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.shape.setStyle("width:130px; height:30px; position:absolute;top:3px; left:calc(50% + 50px);");
        this.shape.setStyle("width:130px; height:30px; position:absolute;top:77px; left:calc(50% - 65px);");
        this.shape.addCssClass("MatchStatsContainerFormStart flexHorizontalAlign");
        this.homeTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.homeTitle.addCssClass("MatchHeaderTeamText");
        this.teamLike = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.teamLike.setStyle("position:absolute;bottom:50px;left:calc(50% + 50%/2);font-variant: all-petite-caps;    font-style: italic;");
        var heart = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.heart = heart;
        heart.addCssClass("heart-wrapper");
        var c = `
  <div class="heart">
    <div class="tl"></div>
    <div class="tr"></div>
    <div class="bl"></div>
    <div class="br"></div>
  </div>
  <div class="ring"></div>
  <div class="circles"></div>
        `;
        heart.addControl(c);
        this.teamLike.addControl(heart);
        this.addControl(this.backgroundImage);
        this.addControl(homeContainer);
        homeContainer.addControl(this.homeImage);
        homeContainer.addControl(this.teamFlag);
        homeContainer.addControl(this.shape);
        homeContainer.addControl(this.homeTitle);
        this.homeImage.addControl(this.teamLike);
    }
    setPresetData(data, instantRender) {
        if (!data) {
            console.error("cannot set preset data without data");
            return;
        }
        if ((0, $40e70090f1e1ff2d$export$5510f7c459d7063c).getCurrentTheme() != "light" && instantRender) {
            this.backgroundImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/venue/" + data.venueid + ".png");
            this.backgroundImage.setVisible(true);
        }
        this.homeTitle.clear();
        this.homeTitle.addControl(data.teamname, true);
        //this.teamFounded.addControl(data.founded,true);
        if (!this.oldData || this.oldData.id_gs != data.id_gs) {
            var teamImageSubFolder = "";
            var hideFlag = false;
            if (!AppInstance.getConfig().enabledFeatures.teamImages) {
                teamImageSubFolder = "country/";
                hideFlag = true;
            }
            this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + teamImageSubFolder + data.id_gs + "_rnd.png", AppInstance.getConfig().sizes.matchHeaderImageSize, AppInstance.getConfig().sizes.matchHeaderImageSize);
            this.homeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("home team image"));
            data.fixtures && data.fixtures.length && data.fixtures[0].filegroup;
            if (!hideFlag && data.country) this.teamFlag.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.country.replaceAll(" ", "-").toLowerCase() + ".png");
            else this.teamFlag.setVisible(false);
            if (data.shape) {
                for(var index in data.shape){
                    var letter = data.shape[index];
                    var item = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
                    if (letter == "W") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormWin");
                    else if (letter == "D") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormDraw");
                    else if (letter == "L") item.addCssClass("MatchStatsContainerFormItem MatchStatsContainerFormLost");
                    item.addControl(letter);
                    this.shape.addControl(item);
                }
                this.shape.invalidateDisplay();
            }
        }
        this.oldData = data;
        var clicked = false;
        if ((0, $0e66157a439e566d$export$e890d9a81f335735).didLikeTeam(this.oldData.id_gs)) this.heart.addCssClass("activated");
        else this.heart.bind("click", ()=>{
            if (clicked) return;
            clicked = true;
            console.log("clicckk", this.oldData.id_gs);
            (0, $0e66157a439e566d$export$e890d9a81f335735).likeTeam(this.oldData.id_gs);
            this.heart.addCssClass("active");
            //get element and change content
            jQuery("#heartcount").html(parseInt(jQuery("#heartcount").html()) + 1);
        });
        (0, $kc8Kt.DataProvider).getLike("team", data.id_gs, (e)=>{
            if (!e.isOk()) {
                console.error("error getting like", e);
                return;
            }
            var d = `<div id="heartcount" style=font-size:17px;position:absolute;width:100%;text-align:center;ont-weight: bold;color: #6d28cc;font-size: 17px;>
            ` + e.getData().count + `
            </div>`;
            this.teamLike.addControl(d, true);
        });
    }
    setData(data) {}
}



var $kc8Kt = parcelRequire("kc8Kt");





class $9be7336a4db2275f$export$3e5d0af8e738b082 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "Team";
        this.version = 1;
        super.init();
        this.setStyle("height:100%");
        //this is a bit hacky.
        //the id change event is fired even when we set the id of this page before
        //this logic. The reason is because the onhashchange event is async
        //and altough we change the url before this logic, the onhashchange event fires
        //afte this logic
        this.bind("renderComplete", this.getProxy(function() {
            //we do this to register back button scenario where page A is match and page B is also match
            setTimeout(function() {
                (0, $fRpWP.UrlManager).listenModule('tid', function() {
                    var id = (0, $fRpWP.UrlManager).getModule('tid');
                    if (id == undefined || (0, $fRpWP.UrlManager).getModule('section') != "Team") return console.warn("ignore opening league , probably navigating to other screen");
                    AppInstance.loadPage("Team", {
                        "tid": id
                    }, false);
                });
            }, 100);
        }));
        this.pageName = "Team_" + (0, $fRpWP.UrlManager).getModule("tid");
        this.addCssClass("LeaguePage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $107e0c5a9208480d$export$c2d159db55e3bf03)();
        this.coordinatoranimator.reducerRatio = 1;
        this.coordinatoranimator.transitionDuration = 20;
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        this.wrapper1 = this.onWorkerMessageReceived.bind(this);
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var listData = [];
        if (e.data[1].leagues.length) {
            var item = {
                "data": e.data[1],
                "type": 7
            };
            listData.push(item);
        }
        if (e.data[1].nowPlaying) {
            var item = {
                "data": e.data[1],
                "type": 4
            };
            listData.push(item);
        } else if (e.data[1].todayPlaying) {
            var item = {
                "data": e.data[1],
                "type": 5
            };
            listData.push(item);
        } else if (e.data[1].nextMatch) {
            var item = {
                "data": e.data[1],
                "type": 6
            };
            listData.push(item);
        } else if (e.data[1].lastPlayedMatch) {
            var item = {
                "data": e.data[1],
                "type": 3
            };
            listData.push(item);
        }
        if (e.data[1].futureMatches && e.data[1].futureMatches.length) {
            var item = {
                "data": e.data[1],
                "type": 1
            };
            listData.push(item);
        }
        if (e.data[1].pastMatches && e.data[1].pastMatches.length) {
            var item = {
                "data": e.data[1],
                "type": 2
            };
            listData.push(item);
        }
        var item = {
            "data": e.data[1],
            "type": 8
        };
        listData.push(item);
        var tabIndex = 0;
        var timeout = 0;
        if (this.tabview.currentActiveTab != tabIndex) timeout = 400;
        setTimeout(this.getProxy(function() {
            this.teamListrender.containerTarget.hideLoader();
            this.teamListrender.setDataSource(listData);
        }), timeout);
        if (this.squadListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != tabIndex) timeout = 500;
            setTimeout(this.getProxy(function() {
                this.squadListrender.containerTarget.hideLoader();
                this.squadListrender.setDataSource(e.data[1].squad);
            }), timeout);
        }
        if (this.transfersListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != tabIndex) timeout = 600;
            setTimeout(this.getProxy(function() {
                this.transfersListrender.containerTarget.hideLoader();
                this.transfersListrender.setDataSource(e.data[1].transfers);
            }), timeout);
        }
        if (this.trophiesListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != tabIndex) timeout = 700;
            setTimeout(this.getProxy(function() {
                this.trophiesListrender.containerTarget.hideLoader();
                this.trophiesListrender.setDataSource(e.data[1].trophies);
            }), timeout);
        }
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "teamListrenderScrollPosition": this.teamListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        if (this.squadListrender) d.squadListrenderScrollPosition = this.squadListrender.getScroll();
        if (this.transfersListrender) d.transfersListrenderScrollPosition = this.transfersListrender.getScroll();
        if (this.trophiesListrender) d.trophiesListrenderScrollPosition = this.trophiesListrender.getScroll();
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.teamLoadHandler);
        (0, $fRpWP.UrlManager).unlistenModule('tid');
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) this.autoInterval(0);
        this.previousDocumentHidden = document.hidden;
    //console.log("visibility change ",document.hidden,this);
    }
    onOffline() {
        this.getPageTemplate().createMenuTeam(false, false);
    }
    onOnline() {
        this.autoInterval(0);
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showBanner();
    }
    createPageLayout() {
        this.teamHeader = new (0, $ad6492822693bd05$export$9298f05f7fab7165)();
        this.teamHeader.setVisible(false);
        this.coordinatoranimator.addCollapser(this.teamHeader);
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(this.teamHeader);
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().hideTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.teamListrender) this.teamListrender.onWindowResize();
        if (this.squadListrender) this.squadListrender.onWindowResize();
        if (this.transfersListrender) this.transfersListrender.onWindowResize();
        if (this.trophiesListrender) this.trophiesListrender.onWindowResize();
    }
    updateDisplay() {
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) this.coordinatoranimator.prerun(previousState.headerCollapsed);
        else this.coordinatoranimator.prerun(false);
        this.runApp();
    }
    runApp() {
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", this.getProxy(function() {
                    this.runApp();
                }));
            }
            this.showLoader();
            (0, $kc8Kt.DataProvider).getTeam((0, $fRpWP.UrlManager).getModule("tid"), this.getProxy(function(response) {
                this.hideLoader();
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                        this.runApp();
                    }));
                    else return this.showError("", this.getProxy(function() {
                        this.runApp();
                    }));
                }
                var data = response.getData();
                if (!data.teamname) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                    this.runApp();
                }));
                this.createTabs(data);
                this.teamHeader.setPresetData(data, true);
                this.teamHeader.setVisible(true);
                this.getPageTemplate().createMenuTeam(response.getData());
                this.tabview.bind("tabChanged", this.getProxy(function() {
                    this.storeState();
                    this.coordinatoranimator.tabChange();
                }));
                var storeHandler = null;
                var storeHandler2 = null;
                var storeHandler3 = null;
                var storeHandler4 = null;
                this.teamListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 200);
                }));
                if (this.squadListrender) this.squadListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler2);
                    storeHandler2 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 200);
                }));
                if (this.transfersListrender) this.transfersListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler3);
                    storeHandler3 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 200);
                }));
                if (this.trophiesListrender) this.trophiesListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler4);
                    storeHandler4 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 200);
                }));
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                if (previousState) {
                    this.tabview.currentActiveTab = previousState.tabIndex;
                    this.teamListrender.scrollTo(previousState.teamListrenderScrollPosition || 0);
                    if (this.squadListrender) this.squadListrender.scrollTo(previousState.squadListrenderScrollPosition || 0);
                    if (this.transfersListrender) this.transfersListrender.scrollTo(previousState.transfersListrenderScrollPosition || 0);
                    if (this.trophiesListrender) this.trophiesListrender.scrollTo(previousState.trophiesListrenderScrollPosition || 0);
                    this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                }
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.ensureStartPositions(); //we call this to ensure tabview is collapsed without flicker
                this.coordinatoranimator.run();
                //this.coordinatoranimator.prepare();
                var tabIndex = 0;
                this.loadFixtures(data, tabIndex);
            }), false);
        }));
    }
    createTitle(data) {
        if (!data) return;
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl(data.teamname);
        this.getPageTemplate().topTitleContainer.addControl(title);
        this.getPageTemplate().topTitleContainer.invalidateDisplay();
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        if ((0, $40e70090f1e1ff2d$export$5510f7c459d7063c).getCurrentTheme() != "light") tabview.parallaxBg = this.teamHeader.backgroundImage;
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("background-color:red;height:20px; width:100%;float:left;");
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        var tab2;
        var tab3;
        var tab4;
        var tabIndexUsed = 0;
        if (FootballManiaConfig.isRtl) {
            if (data.trophies) {
                tab4 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                tab4.addCssClass("listViewScrollableContainer");
                tab4.title = (0, $02mnx.Localizer).getString("trophies");
                tab4.iconClass = "icon-trophy";
                tabs.push(tab4);
                this.createTrophiesControls(tab4, tabIndexUsed);
                this.coordinatoranimator.addScrollerContainer(tab4);
                tab4.showLoader();
                tabIndexUsed += 1;
            }
            if (data.isProcessedByProcessor && data.transfers && data.transfers.length || !data.isProcessedByProcessor && data.transfers && (data.transfers.in && data.transfers.in.length || data.transfers.out && data.transfers.out.length)) {
                tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                tab3.addCssClass("listViewScrollableContainer");
                tab3.title = (0, $02mnx.Localizer).getString("transfers");
                tab3.iconClass = "icon-transfers";
                tabs.push(tab3);
                this.createTransfersControls(tab3, tabIndexUsed);
                this.coordinatoranimator.addScrollerContainer(tab3);
                tab3.showLoader();
                tabIndexUsed += 1;
            }
            if (data.squad) {
                tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                tab2.addCssClass("listViewScrollableContainer");
                tab2.title = (0, $02mnx.Localizer).getString("team");
                tab2.iconClass = "icon-team";
                tabs.push(tab2);
                this.createSquadControls(tab2, tabIndexUsed);
                tabIndexUsed += 1;
                this.coordinatoranimator.addScrollerContainer(tab2);
                tab2.showLoader();
            }
            tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab1.addCssClass("listViewScrollableContainer");
            tab1.title = (0, $02mnx.Localizer).getString("info");
            tab1.iconClass = "icon-tabhome";
            tabs.push(tab1);
            this.createTeamControls(tab1, tabIndexUsed);
            this.coordinatoranimator.addScrollerContainer(tab1);
            tab1.showLoader();
            tabview.currentActiveTab = tabIndexUsed;
        } else {
            tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab1.addCssClass("listViewScrollableContainer");
            tab1.title = (0, $02mnx.Localizer).getString("info");
            tab1.iconClass = "icon-tabhome";
            tabs.push(tab1);
            this.createTeamControls(tab1, tabIndexUsed);
            this.coordinatoranimator.addScrollerContainer(tab1);
            tab1.showLoader();
            tabIndexUsed += 1;
            if (data.squad) {
                tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                tab2.addCssClass("listViewScrollableContainer");
                tab2.title = (0, $02mnx.Localizer).getString("team");
                tab2.iconClass = "icon-team";
                tabs.push(tab2);
                this.createSquadControls(tab2, tabIndexUsed);
                tabIndexUsed += 1;
                this.coordinatoranimator.addScrollerContainer(tab2);
                tab2.showLoader();
            }
            if (data.isProcessedByProcessor && data.transfers && data.transfers.length || !data.isProcessedByProcessor && data.transfers && (data.transfers.in && data.transfers.in.length || data.transfers.out && data.transfers.out.length)) {
                tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                tab3.addCssClass("listViewScrollableContainer");
                tab3.title = (0, $02mnx.Localizer).getString("transfers");
                tab3.iconClass = "icon-transfers";
                tabs.push(tab3);
                this.createTransfersControls(tab3, tabIndexUsed);
                tabIndexUsed += 1;
                this.coordinatoranimator.addScrollerContainer(tab3);
                tab3.showLoader();
            }
            if (data.trophies) {
                tab4 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                tab4.addCssClass("listViewScrollableContainer");
                tab4.title = (0, $02mnx.Localizer).getString("trophies");
                tab4.iconClass = "icon-trophy";
                tabs.push(tab4);
                this.createTrophiesControls(tab4, tabIndexUsed);
                tabIndexUsed += 1;
                this.coordinatoranimator.addScrollerContainer(tab4);
                tab4.showLoader();
            }
        }
        this.coordinatoranimator.addTopBar(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", this.getProxy(function() {
            this.coordinatoranimator.run();
        }));
        this.tabview = tabview;
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
            if (tab2) tab2.setCss({
                'height': '100%'
            });
            if (tab3) tab3.setCss({
                'height': '100%'
            });
            if (tab4) tab4.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab2) tab2.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab3) tab3.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab4) tab4.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createTeamControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$c70b389a21e7ce0d)()
            };
            else if (data.type == 2) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$d757c7cbad19836b)()
            };
            else if (data.type == 3) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$b8215525368cb335)()
            };
            else if (data.type == 4) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$e05519108f552c4e)()
            };
            else if (data.type == 5) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$6651050503f57e08)()
            };
            else if (data.type == 6) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$aaf97b7b835b9ed6)()
            };
            else if (data.type == 7) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$39a7c125c26d2066)()
            };
            else if (data.type == 8) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$48ddb42d9676aafe)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
            this.coordinatoranimator.ensureStartPositions();
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.fixturesScrollPosition || 0);
        container.addControl(listRender);
        this.teamListrender = listRender;
        tab.addControl(container);
    }
    createSquadControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$a94e0da976df9a2a)()
            };
            else if (data.type == 2) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$133f8ecae0b56d7d)()
            };
            else if (data.type == 3) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$2e7dd623c03ef8b3)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.squadListrenderScrollPosition || 0);
        container.addControl(listRender);
        this.squadListrender = listRender;
        tab.addControl(container);
    }
    createTransfersControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$e8628cf973978ad2)()
            };
            else if (data.type == 2) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$8e0fabc9037fba90)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$e5da9225dca7bbb3)({
                message: (0, $02mnx.Localizer).getString("no_transfer_data")
            });
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.transfersListrenderScrollPosition || 0);
        container.addControl(listRender);
        this.transfersListrender = listRender;
        tab.addControl(container);
    }
    createTrophiesControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$5d4aeaf48cf752ec)()
            };
            if (data.type == 2) return {
                typeId: 2,
                render: new (0, $884f7ad69d27d69a$export$1fb77fe93e51380c)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$e5da9225dca7bbb3)({
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.trophiesListrenderScrollPosition || 0);
        container.addControl(listRender);
        this.trophiesListrender = listRender;
        tab.addControl(container);
    }
    loadFixtures(data, ignoreCache) {
        if (!data) return this.autoInterval();
        var tabIndex = 0;
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var timeout = 0;
        if (this.tabview.currentActiveTab != tabIndex) timeout = 600;
        var options = {
            methodType: 8,
            responseData: data,
            dontSelectCurrentMatch: true,
            translations: (0, $02mnx.Localizer).getLoadedLocale(),
            defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
            locale: AppInstance.getLocale(),
            fontSize: FootballManiaConfig.size,
            listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
        };
        if (!FootballManiaConfig.useWebWorkers) {
            var list = (0, $gQQqD.Processors).prepareTeamFixtureData(options);
            var data = {
                data: [
                    0,
                    list
                ]
            };
            this.onWorkerMessageReceived(data);
        } else AppInstance.workerHelper1.postMessage(options);
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
    }
    autoInterval(overrideInterval) {
        clearTimeout(this.teamLoadHandler);
        this.teamLoadHandler = setTimeout(this.getProxy(function() {
            if (document.hidden) {
                console.warn("no auto refresh because page is hidden");
                return;
            }
            (0, $kc8Kt.DataProvider).getTeam((0, $fRpWP.UrlManager).getModule("tid"), this.getProxy(function(response) {
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.autoInterval();
                    return;
                }
                this.getPageTemplate().createMenuTeam(response.getData());
                var options = {
                    methodType: 8,
                    responseData: response.getData(),
                    translations: (0, $02mnx.Localizer).getLoadedLocale(),
                    defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
                    locale: AppInstance.getLocale(),
                    fontSize: FootballManiaConfig.size,
                    listType: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getMatchListType()
                };
                if (!FootballManiaConfig.useWebWorkers) {
                    var list = (0, $gQQqD.Processors).prepareTeamFixtureData(options);
                    var data = {
                        data: [
                            0,
                            list
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else AppInstance.workerHelper1.postMessage(options);
            }));
        }), overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.team);
    }
}








var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $gQQqD = parcelRequire("gQQqD");

//this control runs in combination with collapser (topbar) and tabiew
// when target scroller scrolls down it collapses the topbar and tabview scrollers.
const $0c58d603846ced72$export$56239863efbd94b6 = function() {
    var version = "2.0";
    var scrollers = [];
    var scrollerMethods = [];
    var touchStartMethod = null;
    var touchEndMethod = null;
    var collapser = null;
    var tabview = null;
    var topbar = null;
    var ignoreEvents = false;
    var ignoreEventForIndex = [];
    var lastListIndexScrolling = -1;
    var unloaded = false;
    this.matchStatus; //we use this for collapser differnt ways
    this.isTouching = false;
    this.reducerRatio = 0.3;
    this.transitionDuration = 100;
    this.alwaysCollapseOnBackScrolling = true;
    this.isCollapsed = false;
    this.lastRecalculateWasCollapsed = null;
    this.isVirtuallyCollapsed = false;
    this.lastScrollPositionAfterTouchStart = -1;
    this.lastYOffsetAfterTouchStart = 0;
    this.currentTranslateY = 0;
    this.currentActiveTab = -1;
    this.addScrollerContainer = function(tab, index) {
        if (scrollers) {
            if (scrollers[index]) {
                console.warn("scroller already added");
                return;
            }
            scrollers[index] = tab;
            this.activateScroller(tab);
            this.recalculateTab(index);
        } else console.warn("cannot add, no scroll container found");
    };
    this.addCollapser = function(c) {
        collapser = c;
    };
    this.addTopBar = function(tb) {
        topbar = tb;
    };
    this.addTabView = function(tab) {
        tabview = tab;
    };
    this.unload = function() {
        unloaded = true;
        if (topbar) topbar.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        if (collapser) collapser.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        if (scrollers) for(var i = 0; i < scrollers.length; i++){
            if (!scrollers[i]) continue;
            var scrollEl = jQuery("#" + scrollers[i].getClientId());
            if (scrollerMethods[i]) scrollEl.off("scroll", scrollerMethods[i]);
        }
        scrollers = null;
        scrollerMethods = null;
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        collapser = null;
        scrollers = null;
        topbar = null;
    };
    this.onWindowResize = function() {
        this.recalculate(true);
    };
    this.tabChange = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        if (this.currentActiveTab == -1) {
            console.log("ignore tab change ", this.currentActiveTab, tabview.currentActiveTab);
            this.currentActiveTab = tabview.currentActiveTab;
        //return;
        }
        var collaped = this.isCollapsed;
        var virtuallyCollapsed = this.isVirtuallyCollapsed;
        console.log("tab changed", tabview.currentActiveTab, collaped, virtuallyCollapsed);
        if (collapser) var collapserHeight = collapser.getDimensions().height;
        //console.log("RECALCULATE TAB ",i,scrollEl[0].scrollHeight,contentWindowHeight,collapserHeight)
        console.log("---------------------------------------->>>> tab changedd");
        var height = collapserHeight;
        var that = this;
        for(var i = 0; i < scrollers.length; i++){
            // if (i == tabview.currentActiveTab) continue;
            ignoreEvents = true;
            if (ignoreEventForIndex.indexOf(i) == -1) ignoreEventForIndex.push(i);
            (function(i) {
                setTimeout(function() {
                    var scrollElement = scrollers[i];
                    if (!scrollElement) {
                        console.error("no scroller for tab index " + i + " change logic");
                        return;
                    }
                    document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                        top: collaped || virtuallyCollapsed ? height : 0,
                        left: 0
                    });
                    that.recalculateTab(i);
                }, 0);
            })(i);
            ignoreEvents = false;
        }
        this.currentActiveTab = tabview.currentActiveTab;
    };
    this.recalculateTab = function(i) {
        if (!scrollers || !scrollers[i]) {
            console.warn("cannot recalcuate without tabs");
            return;
        }
        if (!tabview || !tabview.tabContents || !tabview.tabContents.controls[i] || !tabview.tabContents.controls[i].controls[0]) {
            console.warn("cannot recalcuate without tabview elements");
            return;
        }
        var contentWindowHeight = tabview.tabContents.getDimensions().height;
        var collapserHeight = 0;
        if (collapser) collapserHeight = collapser.getDimensions().height;
        var scrollEl = jQuery("#" + scrollers[i].getClientId());
        var top = collapserHeight;
        if (!scrollEl || !scrollEl[0]) {
            console.warn("no scroller");
            return;
        }
        // var isScrollable = scrollEl.isVScrollable();
        //
        // console.log("RECALCULATE TAB ",i,isScrollable,scrollEl[0].scrollHeight,contentWindowHeight,collapserHeight)
        // return;
        var height = contentWindowHeight + collapserHeight;
        if (scrollEl[0].scrollHeight > contentWindowHeight) {
            //console.log("scrollheight is higher than screenheight"+contentWindowHeight+"--"+scrollEl[0].scrollHeight);
            $("#" + scrollers[i].getClientId()).css({
                "top": "-" + top + "px"
            });
            var contentOverFlow = scrollEl[0].scrollHeight - contentWindowHeight;
            $("#" + scrollers[i].controls[0].getClientId()).css({
                "position": "absolute",
                "top": top + "px",
                "width": "100%"
            });
            $("#" + tabview.tabContents.controls[i].controls[0].getClientId()).css({
                "height": height + "px"
            });
        } else {
            console.log(i, "not needed");
            //$("#" + tabview.tabContents.controls[i].getClientId()).css({"overflow": "hidden"});
            // console.log("tab ",i,' content is not needed for scroll',contentWindowHeight)
            if (this.isCollapsed || this.isVirtuallyCollapsed) //if collapsed and scrollheight is smaller than screenheight we put to minus offset
            //because otherwise it canot be scrolled up (towards the topbar)
            $("#" + scrollers[i].getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            else $("#" + scrollers[i].getClientId()).css({
                "transform": "translate(0px,0px)",
                "transition-duration": "0ms"
            });
        }
    };
    this.recalculate = function(force, onlyTabIndex) {
        console.log("recalculate");
        for(var i = 0; i < scrollers.length; i++)//var scrollEl = jQuery("#" + scollers[i].getClientId());
        ///console.log("XXXXXXXX",scrollEl[0].scrollHeight,contentWindowHeight)
        this.recalculateTab(i);
    };
    this.autoCollapseOrOpen = function(scrollPosition) {
        //return;
        if (this.isAutoCollapsing) {
            console.log("dont do twice ");
            return;
        }
        this.isAutoCollapsing = true;
        if (this.currentTranslateY == 0) this.isCollapsed = false;
        else if (this.currentTranslateY == -collapser.getDimensions().height) this.isCollapsed = true;
        if (this.currentTranslateY == 0 || this.currentTranslateY == -collapser.getDimensions().height) {
            console.log("no auto collapse when already open or closed", this.currentTranslateY);
            this.isAutoCollapsing = false;
            this.recalculate();
            return;
        }
        console.log("AUTO COLLAPSE", this.currentTranslateY);
        var collapserHeight = collapser.getDimensions().height;
        var that = this;
        var delay = 300;
        if (scrollPosition > collapserHeight * (1 / this.reducerRatio) / 2) {
            var scrollElement = scrollers[tabview.currentActiveTab];
            this.isCollapsed = true;
            document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                top: collapserHeight,
                left: 0,
                behavior: "smooth"
            });
        } else {
            var scrollElement = scrollers[tabview.currentActiveTab];
            document.querySelector("#" + scrollElement.getClientId()).scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            that.currentTranslateY = 0;
            this.isCollapsed = false;
            setTimeout(function() {
                //that.currentTranslateY = 0;
                that.recalculate();
            }, delay);
        }
    };
    this.ensureStartPositions = function() {
        //alert("a")
        if (!FootballManiaConfig.graphics.animations) return;
        if (!collapser || !tabview || !topbar) {
            console.error("NO COLLAPSER OR TABVIEW OR TOPBAR");
            return;
        }
        if (this.isTouching) return;
        console.log("PREPARE RUN ANIMATOR FOR MATCHSCREEN " + version);
        var collapserHeight = collapser.getDimensions().height;
        collapser.homeImage.setVisible(true);
        //make sure we start with a collapsed one before everything gets rendered. causes flickering
        if (this.isCollapsed) {
            /// alert("collapsed");
            $("#" + collapser.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + tabview.tabHolder.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
            $("#" + topbar.getClientId()).css({
                "transform": "translate(0px," + -collapserHeight + "px)",
                "transition-duration": "0ms"
            });
        }
    };
    this.prerun = function(collapsed) {
        if (!FootballManiaConfig.graphics.animations) return;
        //collapser.remove();
        console.log("PRE RUN ANIMATOR FOR MATCHSCREEN " + version, collapsed);
        if (collapsed) {
            this.currentTranslateY = -collapser.getDimensions().height;
            this.autoCollapseOrOpen(-collapser.getDimensions().height);
        } else this.autoCollapseOrOpen(0);
        collapser.homeImage.setVisible(false);
    }, this.run = function() {
        if (!FootballManiaConfig.graphics.animations) return;
        console.log("RUN ANIMATOR (scrollers:" + scrollers.length + ") FOR TEAMSCREEN " + version);
        lastListIndexScrolling = tabview.currentActiveTab;
        $('body').off({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
        for(var i = 0; i < scrollerMethods.length; i++){
            console.log("scroller", scrollers[i].controls[0].controls[0].controls[0].getClientId());
            var scrollEl = jQuery("#" + scrollers[i].controls[0].controls[0].controls[0].getClientId());
            scrollEl.off("scroll", scrollerMethods[i]);
        }
        this.recalculate();
        var that = this;
        touchStartMethod = function(e) {
            that.isTouching = true;
            var scrollElement = scrollers[tabview.currentActiveTab];
            if (!scrollElement) {
                console.error("no scroll element in tab " + tabview.currentActiveTab + " found. do nothing?");
                return;
            }
            var topOffset = document.querySelector("#" + scrollElement.getClientId()).scrollTop;
            that.lastScrollPositionAfterTouchStart = topOffset;
            that.lastYOffsetAfterTouchStart = that.currentTranslateY;
        };
        touchEndMethod = function() {
            that.isTouching = false;
            if (that.currentTranslateY > -collapser.getDimensions().height) that.isCollapsed = false;
            clearTimeout(timeoutHandler);
            timeoutHandler = setTimeout(function() {
                if (unloaded) return;
                if (!scrollers) {
                    console.error("no scrollers found why??");
                    return;
                }
                that.currentActiveTab = tabview.currentActiveTab;
                var scrollElement = scrollers[tabview.currentActiveTab];
                if (!scrollElement) {
                    console.error("no scroll element in tab " + tabview.currentActiveTab + " found. do nothing?");
                    return;
                }
                var topOffset = document.querySelector("#" + scrollElement.getClientId()).scrollTop;
                that.autoCollapseOrOpen(topOffset);
            }, 100);
        };
        $('body').on({
            'touchstart': touchStartMethod,
            'touchend': touchEndMethod
        });
    };
    var timeoutHandler;
    var timeoutHandler2;
    this.activateScroller = function(scroller) {
        if (!FootballManiaConfig.graphics.animations) return;
        var that = this;
        var homeImage = collapser.homeImage;
        var backgroundImage = collapser.backgroundImage;
        var startOpacityBackground = $("#" + backgroundImage.getClientId()).css("opacity");
        //what if dynamic height?
        var collapserHeight = collapser.getDimensions().height;
        var index = scrollers.indexOf(scroller);
        var scrollEl = jQuery("#" + scroller.getClientId());
        var prevScroll = null;
        var ticking = false;
        scrollerMethods[index] = function(e) {
            if (ticking) return;
            clearTimeout(timeoutHandler);
            window.requestAnimationFrame(()=>{
                ticking = true;
                if (ignoreEvents || index != tabview.currentActiveTab) {
                    console.log("ignore scroll event if not this active tab ", index);
                    ticking = false;
                    return;
                }
                if (ignoreEventForIndex.indexOf(index) != -1) {
                    console.log("ignore scroll event this time", index, ignoreEventForIndex);
                    //ignoreEventForIndex = -1;
                    ignoreEventForIndex.splice(ignoreEventForIndex.indexOf(index), 1);
                    ticking = false;
                    return;
                }
                var topOffset = e.originalEvent.target.scrollTop;
                if (prevScroll == topOffset) {
                    ticking = false;
                    console.log("do nothing no scroll change");
                    return;
                }
                lastListIndexScrolling = index;
                clearTimeout(timeoutHandler2);
                timeoutHandler2 = setTimeout(()=>{
                    that.isAutoCollapsing = false;
                    var topOffset = e.originalEvent.target.scrollTop;
                    if (!that.isTouching) that.autoCollapseOrOpen(topOffset);
                }, 150);
                var topOffset = e.originalEvent.target.scrollTop;
                if (that.isCollapsed) {
                    if (topOffset <= collapserHeight) {
                        var t = -topOffset;
                        scrollDiff = Math.max(-collapserHeight, Math.min(0, t));
                    } else scrollDiff = Math.max(-topOffset, -collapserHeight);
                } else {
                    if (topOffset >= collapserHeight) scrollDiff = -collapserHeight;
                    else if (that.lastScrollPositionAfterTouchStart != -1) {
                        var t = (collapserHeight - topOffset - collapserHeight) * that.reducerRatio;
                        var scrollDiff = Math.min(0, Math.max(-collapserHeight, t));
                        var scrollDiff = t;
                    } else scrollDiff = 0;
                }
                that.currentTranslateY = scrollDiff;
                //this virtualcollapsed value is a little different than iscollapsed
                //when user is collapsing and no touchend event is fired then the state of
                //iscollapsed remains the same. the virtualcollapsed one changes
                //this is needed in the recalculation of positions
                if (scrollDiff == -collapserHeight) that.isVirtuallyCollapsed = true;
                else that.isVirtuallyCollapsed = false;
                //collapser.setCss({"transform":"translate(0px,"+scrollDiff+"px)","transition-duration": this.transitionDuration+"ms"});
                collapser.setCss({
                    "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
                    "transition-duration": "80ms"
                });
                tabview.tabHolder.setCss({
                    "transform": "translate(0px," + scrollDiff + "px)",
                    "transition-duration": this.transitionDuration + "100ms"
                });
                tabview.tabHolder.setCss({
                    "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
                    "transition-duration": "80ms"
                });
                var progression = -scrollDiff / collapserHeight;
                homeImage.setCss({
                    "opacity": 1 - progression * 1
                });
                backgroundImage.setCss({
                    "transform": "translateX(" + tabview.cachedParllaxBgXOffset + "%) translateY(" + (-50 + progression * 30) + "px)",
                    "transition-duration": "80ms",
                    "opacity": startOpacityBackground - progression * startOpacityBackground
                });
                topbar.setCss({
                    "transform": "translate(0px," + Math.round(scrollDiff) + "px)",
                    "transition-duration": "80ms"
                });
                prevScroll = e.originalEvent.target.scrollTop;
                ticking = false;
            });
        };
        if (scrollerMethods[index]) scrollEl.off("scroll", scrollerMethods[index]);
        scrollEl.scroll(scrollerMethods[index]);
    };
};





var $02mnx = parcelRequire("02mnx");



var $kc8Kt = parcelRequire("kc8Kt");
class $52bf27ff9a260a43$export$ab2ac12c6c1f7256 extends (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587) {
    init() {
        super.init();
        this.addCssClass("MatchHeaderContainer TeamHeaderContainer");
        this.bounceEnabled = true;
        var homeContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        homeContainer.addCssClass("MatchHeaderHomeContainer");
        homeContainer.setStyle("width:100%;");
        this.backgroundImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.backgroundImage.setVisible(false);
        this.backgroundImage.addCssClass("MatchHeaderBackgroundImage");
        this.backgroundImage.setStyle("filter: blur(8px);width:170%;height:170%;");
        //this.backgroundImage.addCssClass("fade-in-image2");
        this.homeImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.homeImage.addCssClass("MatchHeaderTeamLogoContainer");
        this.homeImage.setStyle("height:100px;width:100px;");
        this.teamFlag = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.teamFlag.setStyle("width:40px;height:40px; position:absolute; bottom:50px; left:calc(50% - 50%/2 - 40px);");
        //      this.teamFlag = new ImagePlaceHolder();
        //        this.teamFlag.setStyle("margin-inline-start:4px;width:40px; height:40px;align-self: center;border-radius:30px; overflow:hidden; position:absolute; top:3px; right:calc(50% + 55px);");
        this.image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.image.setStyle("width:40px; height:40px; position:absolute;top:3px; left:calc(50% + 55px);");
        this.image.addCssClass("MatchStatsContainerFormStart flexHorizontalAlign");
        this.homeTitle = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.homeTitle.addCssClass("MatchHeaderTeamText");
        this.teamLike = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.teamLike.setStyle("position:absolute;bottom:50px;left:calc(50% + 50%/2);font-variant: all-petite-caps;    font-style: italic;");
        var heart = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.heart = heart;
        heart.addCssClass("heart-wrapper");
        var c = `
  <div class="heart">
    <div class="tl"></div>
    <div class="tr"></div>
    <div class="bl"></div>
    <div class="br"></div>
  </div>
  <div class="ring"></div>
  <div class="circles"></div>
        `;
        heart.addControl(c);
        this.teamLike.addControl(heart);
        this.addControl(this.backgroundImage);
        this.addControl(homeContainer);
        homeContainer.addControl(this.homeImage);
        homeContainer.addControl(this.teamFlag);
        homeContainer.addControl(this.image);
        homeContainer.addControl(this.homeTitle);
        this.homeImage.addControl(this.teamLike);
    }
    setPresetData(data, instantRender) {
        if (!data) {
            console.error("cannot set preset data without data");
            return;
        }
        if (instantRender) {
            if (data.nationality) {
                this.backgroundImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replaceAll(" ", "-").toLowerCase() + ".png");
                this.backgroundImage.setVisible(true);
            }
        }
        this.homeTitle.clear();
        //this.homeTitle.addControl(data.name,true);
        if (!data.firstname) data.firstname = "";
        if (!data.lastname) data.lastname = "";
        if (!AppInstance.getConfig().isRtl) this.homeTitle.addControl(data.firstname + " " + data.lastname, true);
        else this.homeTitle.addControl(data.lastname + " " + data.firstname, true);
        if (!this.oldData || this.oldData.id != data.id) {
            if (AppInstance.getConfig().enabledFeatures.playerImages) {
                this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + data.id + "_rnd.png", 100, 100);
                this.homeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("player image"));
                if (data.nationality) {
                    this.teamFlag.imageObjectStyle = "margin-top:-15px;margin-left:-16px;";
                    this.teamFlag.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replaceAll(" ", "-").toLowerCase() + ".png", 70, 70);
                } else this.teamFlag.remove();
                if (data.teamid) this.image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + data.teamid + "_small_rnd.png", AppInstance.getConfig().sizes.fixtureListImageSize, AppInstance.getConfig().sizes.fixtureListImageSize);
                else this.image.remove();
            } else {
                this.teamFlag.remove();
                this.image.remove();
                this.homeImage.imageObjectStyle = "margin-top:-40px;margin-left:-40px;";
                this.homeImage.setCss({
                    'overflow': "hidden",
                    "border-radius": "50%"
                });
                if (data.nationality) this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replaceAll(" ", "-").toLowerCase() + ".png", 180, 180);
            //this.image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/"+AppInstance.getConfig().url.teamPlayerImageUrl+"/teams_gs/" + data.teamid + "_small_rnd.png", AppInstance.getConfig().sizes.fixtureListImageSize, AppInstance.getConfig().sizes.fixtureListImageSize);
            }
        }
        this.oldData = data;
        var clicked = false;
        if ((0, $0e66157a439e566d$export$e890d9a81f335735).didLikePlayer(this.oldData.id)) this.heart.addCssClass("activated");
        else this.heart.bind("click", ()=>{
            if (clicked) return;
            clicked = true;
            console.log("clicckk", this.oldData.id);
            (0, $0e66157a439e566d$export$e890d9a81f335735).likePlayer(this.oldData.id);
            this.heart.addCssClass("active");
            //get element and change content
            jQuery("#heartcount").html(parseInt(jQuery("#heartcount").html()) + 1);
        });
        (0, $kc8Kt.DataProvider).getLike("player", data.id, (e)=>{
            if (!e.isOk()) {
                console.error("error getting like", e);
                return;
            }
            var d = `<div id="heartcount" style=font-size:17px;position:absolute;width:100%;text-align:center;ont-weight: bold;color: #6d28cc;font-size: 17px;>
            ` + e.getData().count + `
            </div>`;
            this.teamLike.addControl(d, true);
        });
    }
    setData(data) {}
}



var $kc8Kt = parcelRequire("kc8Kt");









parcelRequire("9yWe2");

var $02mnx = parcelRequire("02mnx");


var $5er4g = parcelRequire("5er4g");

var $6K7Df = parcelRequire("6K7Df");

var $lU8CH = parcelRequire("lU8CH");

class $67d0d0b32ec91180$export$cad9d717a3aa3269 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(data) {
        super.init();
        this.data = data;
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-bottom:40px;");
        //
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.panel.setStyle("margin-top:3px;margin-bottom:-3px;");
        this.card.setStyle("padding-bottom:4px;");
        //
        this.content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.content.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //title.addControl(Localizer.getString("passport"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        this.card.addControl(this.content);
        //
        this.addControl(this.panel);
    }
    setData(data) {
        this.data = data.data;
        this.content.addControl("<table class='tableInfoList' style='width:100%;'>");
        this.createInfo((0, $02mnx.Localizer).getString("name"), this.data.name);
        this.createInfo((0, $02mnx.Localizer).getString("firstname"), this.data.firstname);
        this.createInfo((0, $02mnx.Localizer).getString("lastname"), this.data.lastname);
        if (this.data.birthdate) {
            var date = new (0, $5er4g.DateTimecode)();
            //this.data.birthdate = "17/03/2018";
            var split = this.data.birthdate.split("/");
            //this.tempDateTime.clear()
            date.setYear(split[2]);
            date.setMonth(split[1] - 1);
            date.setDate(split[0]);
            this.createInfo((0, $02mnx.Localizer).getString("birthdate"), date.toLocaleDateStringLong());
            this.createInfo((0, $02mnx.Localizer).getString("age"), date.getAgeInYearsTillNow() + "");
        }
        this.createInfo((0, $02mnx.Localizer).getString("birthplace"), this.data.birthplace);
        this.createInfo((0, $02mnx.Localizer).getString("nationality"), (0, $6K7Df.CountryUtil).getLocalizedCountryByName(this.data.nationality));
        this.createInfo((0, $02mnx.Localizer).getString("height"), this.data.height);
        this.createInfo((0, $02mnx.Localizer).getString("weight"), this.data.weight);
        this.createInfo((0, $02mnx.Localizer).getString("team"), this.data.team);
        if (this.data.preferredFoot && this.data.preferredFoot == "Left") this.createInfo((0, $02mnx.Localizer).getString("preferred_foot"), (0, $02mnx.Localizer).getString("left_foot"));
        else if (this.data.preferredFoot && this.data.preferredFoot == "Right") this.createInfo((0, $02mnx.Localizer).getString("preferred_foot"), (0, $02mnx.Localizer).getString("right_foot"));
        if (this.data.position) this.createInfo((0, $02mnx.Localizer).getString("position"), (0, $02mnx.Localizer).getString(this.data.position.toLowerCase()));
        if (this.data.marketvalue) {
            var value = Intl.NumberFormat('en-EN', {
                style: 'currency',
                currency: 'EUR'
            }).format(this.data.marketvalue);
            var valueRank = "";
            if (this.data.valuerank) valueRank = " (#" + this.data.valuerank + ")";
            var row = this.createInfo((0, $02mnx.Localizer).getString("market_value"), value + valueRank, true);
            //row.controls[1].setCss({"text-decoration": "underline"});
            row.bind("click", ()=>{
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerMarketValues(this.data.id);
            });
        }
        this.content.addControl("</table>");
        if (this.data.isPlayer) {
            var buttonLink = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            buttonLink.addCssClass("button");
            buttonLink.setStyle("margin-top:10px;min-width:150px;background-color:var(--match-votebutton-background-color);");
            buttonLink.addControl((0, $02mnx.Localizer).getString("playerstats"));
            this.content.addControl(buttonLink);
            buttonLink.bind("click", ()=>{
                (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(this.data.id);
            });
        }
    }
    createInfo(title, data, isLink) {
        if (data == null || data == "" || data == undefined) return;
        if (data.trim() == "") return;
        var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
        row.setStyle("height: 20px;cursor:none;");
        var th1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        th1.addCssClass("tableInfoTitle");
        th1.addControl(title + " : ");
        var th2 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        if (isLink) th2.addControl("<a style='text-decoration:underline;'>" + data + "</a>");
        else th2.addControl(data);
        th2.addCssClass("tableInfoValue");
        row.addControl(th1);
        row.addControl(th2);
        this.content.addControl(row);
        return row;
    }
}
class $67d0d0b32ec91180$export$1fd87e9a56ac7064 extends $67d0d0b32ec91180$export$cad9d717a3aa3269 {
    createComponents(data) {
        this.content.addControl("<table class='tableStandings' style='width:100%;'>");
        // this.createInfo(Localizer.getString("total days injured this year"), "1 day");
        // this.createInfo(Localizer.getString("total days injured last year"), "1 day");
        //this.createInfo(Localizer.getString("total days not available"), "1 day");
        this.createInfo((0, $02mnx.Localizer).getString("status"), "active");
        this.content.addControl("</table>");
    }
}




var $373c07ec4018fb7a$exports = {};

$373c07ec4018fb7a$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "subin.60d515bf.png";


var $812b88f9e7a7f8e5$exports = {};

$812b88f9e7a7f8e5$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "subout.b7c56990.png";


var $db40c632c5725bba$exports = {};

$db40c632c5725bba$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "lineups.05e927ca.png";


var $026b187e1d759ffe$exports = {};

$026b187e1d759ffe$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "bench.4a6cfd1f.png";


var $5178e7536e7e28e8$exports = {};

$5178e7536e7e28e8$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "time_clock.b0cbfc87.png";


class $67d0d0b32ec91180$export$d4c5bf92dc49d29b extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    updateDisplay() {
        this.parent.addCssClass("playerStatsStickyLegenda");
    }
    setData(data) {
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(this.panel);
        this.data = data.data;
        this.panel.addCssClass("playerStatsLegenda");
        //this.panel.addCssClass("playerStatsStickyLegenda")
        this.panel.addControl("<table class='playerStatsTable'>");
        var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
        this.panel.addControl(row);
        row.setStyle("height:20px;");
        var c1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c1.setStyle("text-align: start;");
        row.addControl(c1);
        var c2 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c2.addCssClass("playerStatsItem");
        row.addControl(c2);
        var c3 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c3.addCssClass("playerStatsItem");
        row.addControl(c3);
        var c4 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c4.addCssClass("playerStatsItem");
        row.addControl(c4);
        var c5 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c5.addCssClass("playerStatsItem");
        row.addControl(c5);
        var c6 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c6.addCssClass("playerStatsItem");
        row.addControl(c6);
        var c7 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c7.addCssClass("playerStatsItem");
        row.addControl(c7);
        var c8 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c8.addCssClass("playerStatsItem");
        row.addControl(c8);
        var c9 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c9.addCssClass("playerStatsItemMinutes");
        row.addControl(c9);
        var i2 = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        i2.setImage(new URL($0008cb34d0412506$exports));
        c2.addControl(new (0, $df64cf20c6ea21bc$export$3e431a229df88919)().setImage(new URL($b3feca7ce224195e$exports)).setStyle("width:20px;"));
        c3.addControl(new (0, $df64cf20c6ea21bc$export$3e431a229df88919)().setImage(new URL($8a3745c536ca60af$exports)).setStyle("width:20px;"));
        c4.addControl(new (0, $df64cf20c6ea21bc$export$3e431a229df88919)().setImage(new URL($0008cb34d0412506$exports)).setStyle("width:20px;"));
        c5.addControl(new (0, $df64cf20c6ea21bc$export$3e431a229df88919)().setImage(new URL($373c07ec4018fb7a$exports)).setStyle("width:20px;"));
        c6.addControl(new (0, $df64cf20c6ea21bc$export$3e431a229df88919)().setImage(new URL($812b88f9e7a7f8e5$exports)).setStyle("width:20px;"));
        c7.addControl(new (0, $df64cf20c6ea21bc$export$3e431a229df88919)().setImage(new URL($db40c632c5725bba$exports)).setStyle("width:20px;"));
        c8.addControl(new (0, $df64cf20c6ea21bc$export$3e431a229df88919)().setImage(new URL($026b187e1d759ffe$exports)).setStyle("width:20px;"));
        c9.addControl(new (0, $df64cf20c6ea21bc$export$3e431a229df88919)().setImage(new URL($5178e7536e7e28e8$exports)).setStyle("width:20px;"));
        this.panel.addControl("</table>");
    }
}
class $67d0d0b32ec91180$export$9ed2ea241c3e7305 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-top:0px;");
        this.addControl(this.panel);
    }
    setData(data) {
        for(var i = 0; i < data.data.careerclubs.length; i++){
            this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            this.card.addCssClass("MatchStatsContainerCard");
            //this.panel.setStyle("margin-top:3px;");
            this.card.setStyle("padding-bottom:4px;padding-top:0px;margin-top:0px;margin-bottom:4px;");
            var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            container.setStyle("align-items: center;justify-content: space-between;display:flex;width:100%;height:50px;");
            this.createClubCareerItem(data.data.careerclubs[i], container);
            this.card.addControl(container);
            this.panel.addControl(this.card);
        }
    }
    createClubCareerItem(data, target) {
        var left = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        left.setStyle("height:40px;display:flex;align-items: center");
        var imageBox = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        imageBox.addCssClass("listViewCountryFlagItem");
        if (AppInstance.getConfig().enabledFeatures.teamImages) {
            imageBox.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + data.id + "_small_rnd.png", 40, 40);
            left.addControl(imageBox);
        }
        var team = new (0, $37cbb85645b0d818$export$b04be29aa201d4f5)();
        team.setStyle("margin-inline-start:8px;");
        team.setData(data.name);
        left.addControl(team);
        target.addControl(left);
        var period = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        period.setStyle("float:right");
        period.addControl(new (0, $37cbb85645b0d818$export$b04be29aa201d4f5)().setData(this.translateDateString(data.from) + (data.to ? " - " + this.translateDateString(data.to) : "")));
        target.addControl(period);
    }
    translateDateString(date) {
        if (!date) return "";
        try {
            var split = date.split(" ");
            var monthName = split[0];
            var year = split[1];
            var monthNames = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ];
            var d = new Date();
            d.setMonth(monthNames.indexOf(monthName));
            d.setFullYear(year);
            var formatter = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
                year: 'numeric',
                month: 'short'
            });
            return formatter.format(d);
        } catch (e) {
            return date;
        }
    }
}
class $67d0d0b32ec91180$export$4cc13e747962c1d1 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    updateDisplay() {
        this.parent.addCssClass("playerStatsStickyLegenda");
    }
    setData(data) {
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(this.panel);
        this.data = data.data;
        this.panel.addCssClass("playerStatsLegenda");
        this.panel.addCssClass("playerStatsLegenda");
        this.panel.addControl("<table class='tableInjuries'>");
        var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
        var c1 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        c1.setStyle("width:50%;");
        var c2 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        c2.setStyle("width:100px;");
        var c3 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        c3.setStyle("width:100px;");
        var c4 = new (0, $5f67bb3af1a541ad$export$331161bdaadcdb17)();
        c4.setStyle("text-align:end;margin-inline-end:10px;");
        row.addControl(c1);
        row.addControl(c2);
        row.addControl(c3);
        row.addControl(c4);
        c1.addControl((0, $02mnx.Localizer).getString("injury_type"));
        c2.addControl((0, $02mnx.Localizer).getString("period_from"));
        c3.addControl((0, $02mnx.Localizer).getString("period_to"));
        c4.addControl((0, $02mnx.Localizer).getString("days"));
        this.panel.addControl(row);
        this.panel.addControl("</table>");
    }
}
class $67d0d0b32ec91180$export$1cb596563defa388 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(hideBell) {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-top:0px;font-weight:bold;");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        //this.panel.setStyle("margin-top:3px;");
        this.card.setStyle("justify-content: space-around;flex-direction:column;display:flex;padding-bottom:4px;padding-top:0px;margin-top:0px;");
        this.addControl(this.panel);
    }
    setData(data) {
        this.card.clear();
        this.card.addControl("<table class='tableInjuries' style='width:100%;'>");
        for(var i = 0; i < data.data.sidelined.length; i++)this.createSidelined(data.data.sidelined[i]);
        this.card.addControl("</table>");
    }
    createSidelined(data) {
        var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
        row.setStyle("width:100%;border-bottom: 1px solid var(--match-fixture-divider-color);");
        var c1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c1.setStyle("width:50%;");
        var c2 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c2.setStyle("width:100px;");
        var c3 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c3.setStyle("width:100px;");
        var c4 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        //c4.setStyle("margin-inline-end:10px;")
        row.addControl(c1);
        row.addControl(c2);
        row.addControl(c3);
        row.addControl(c4);
        var injuryType = data.injurytype.replaceAll(" ", "_").replaceAll("/", "_").toLowerCase();
        if (injuryType == "suspended") injuryType = (0, $02mnx.Localizer).getString("injury_suspended");
        else if (injuryType == "groin_pelvis_injury") injuryType = (0, $02mnx.Localizer).getString("groin_pelvis_injury");
        else if ((0, $02mnx.Localizer).hasString(injuryType)) injuryType = (0, $02mnx.Localizer).getString(injuryType);
        else {
            console.log(injuryType);
            injuryType = data.injurytype;
        }
        c1.addControl(this.camelize(injuryType));
        var onGoing = false;
        if (data.date_start != "" && data.date_start != null) {
            c2.addControl(this.getNiceDate(data.date_start));
            onGoing = true;
        }
        if (data.date_end != "" && data.date_end != null) {
            c3.addControl(this.getNiceDate(data.date_end));
            onGoing = false;
        }
        if (data.date_start != "" && data.date_end != "" && data.date_start != null && data.date_end != null) {
            var dayLength = this.getDayLength(data.date_start, data.date_end);
            // const rtf = new Intl.RelativeTimeFormat(FootballManiaConfig.userLocale, { numeric: "always", // other values: "auto"
            //     style: "long" });
            // var parts = rtf.formatToParts(dayLength, "day");
            // //c4.addControl(parts[1].value + " "+parts[2].value);
            c4.addControl(dayLength + "");
        } else if (onGoing) {
            var date = new Date();
            var split = data.date_start.split("/");
            date.setYear("20" + split[2]);
            date.setMonth(split[1] - 1);
            date.setDate(split[0]);
            var diffMs = Math.abs(new Date().getTime() - date.getTime());
            var dayLength = Math.ceil(diffMs / 86400000);
            c4.addControl(dayLength + "");
        }
        this.card.addControl(row);
    }
    camelize(str) {
        let words = str.split(' ');
        let capitalizedWords = words.map((word)=>{
            return word.charAt(0).toUpperCase() + word.slice(1);
        });
        return capitalizedWords.join(' ');
    }
    getNiceDate(a) {
        var date = new (0, $5er4g.DateTimecode)();
        var split = a.split("/");
        date.setYear(split[2]);
        date.setMonth(split[1] - 1);
        date.setDate(split[0]);
        return date.toLocaleDateStringAlt();
    }
    getDayLength(a, b) {
        var date = new (0, $5er4g.DateTimecode)();
        var split = a.split("/");
        date.setYear(split[2]);
        date.setMonth(split[1] - 1);
        date.setDate(split[0]);
        var date2 = new (0, $5er4g.DateTimecode)();
        var split2 = b.split("/");
        date2.setYear(split2[2]);
        date2.setMonth(split2[1] - 1);
        date2.setDate(split2[0]);
        const diffMs = Math.abs(date2.getTimecode() - date.getTimecode());
        return Math.ceil(diffMs / 86400000);
    }
}
class $67d0d0b32ec91180$export$2bfb8a280097c119 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-top:0px;");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        //this.panel.setStyle("margin-top:3px;");
        this.card.setStyle("padding-bottom:4px;padding-top:0px;margin-top:0px;");
        this.addControl(this.panel);
    }
    setData(data) {
        this.createStats(data);
    }
    createStats(data) {
        this.data = data;
        this.card.addControl("<table class='playerStatsTable'>");
        for(var x = 0; x < data.data.allStatistics.length; x++){
            //console.log("stats",data.data.allStatistics[x]);
            var stats = data.data.allStatistics[x];
            var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
            row.setStyle("");
            this.card.addControl(row);
            var c1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c1.setStyle("text-align: start;");
            row.addControl(c1);
            var c2 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c2.addCssClass("playerStatsItem");
            row.addControl(c2);
            var c3 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c3.addCssClass("playerStatsItem");
            row.addControl(c3);
            var c4 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c4.addCssClass("playerStatsItem");
            row.addControl(c4);
            var c5 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c5.addCssClass("playerStatsItem");
            row.addControl(c5);
            var c6 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c6.addCssClass("playerStatsItem");
            row.addControl(c6);
            var c7 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c7.addCssClass("playerStatsItem");
            row.addControl(c7);
            var c8 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c8.addCssClass("playerStatsItem");
            row.addControl(c8);
            var c9 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c9.addCssClass("playerStatsItemMinutes");
            row.addControl(c9);
            var c10 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c10.addCssClass("playerStatsItemMinutes");
            //row.addControl(c10);
            c1.addControl(stats.season);
            c2.addControl(stats.goals);
            c3.addControl(stats.yellowcards);
            if (stats.yellowred != "" && stats.redcards != "") c4.addControl(parseInt(stats.yellowred) + parseInt(stats.redcards) + "");
            c5.addControl(stats.substitute_in);
            c6.addControl(stats.substitute_out);
            c7.addControl(stats.lineups);
            c8.addControl(stats.substitutes_on_bench);
            c9.addControl(stats.minutes);
            var row2 = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
            row2.addCssClass("tablePlayerStatsDivider");
            this.card.addControl(row2);
            var c11 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
            c11.setAttribute("colspan", 9);
            ///c1.addCssClass("flexHorizontal");
            row2.addControl(c11);
            var con = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            con.addCssClass("tablePlayerStatsItemContainer");
            c11.addControl(con);
            if (AppInstance.getConfig().enabledFeatures.teamImages) {
                var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
                image.setStyle("width:40px;height:40px;");
                image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + stats.teamid + "_small_rnd.png");
                con.addControl(image);
            }
            var subCon = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            subCon.addCssClass("flexVerticalAlign");
            subCon.setStyle("align-items: flex-start;height: 35px;");
            stats.league = (0, $lU8CH.RemoveReservedIfNeeded)(stats.league);
            subCon.addControl("<p style='margin-inline-start: 10px;'>" + stats.name + "</p>");
            subCon.addControl("<p style='margin-inline-start: 10px;'>" + stats.league + "</p>");
            con.addControl(subCon);
            (function(stats) {
                con.bind("click", function() {
                    (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showTeamScreen(stats.teamid);
                });
            })(stats);
        }
        this.card.addControl("</table>");
    }
}
class $67d0d0b32ec91180$export$dc35904be8fb7df4 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init() {
        super.init();
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-top:0px;font-weight:bold;");
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        //this.panel.setStyle("margin-top:3px;");
        this.card.setStyle("justify-content: space-around;flex-direction:column;display:flex;padding-bottom:4px;padding-top:0px;margin-top:0px;");
        this.addControl(this.panel);
    }
    setData(data) {
        this.card.clear();
        this.card.addControl("<table class='tableTransfers' style='width:100%;'>");
        for(var i = 0; i < data.data.transfers.length; i++)this.createTransfers(data.data.transfers[i]);
        this.card.addControl("</table>");
    }
    createTransfers(data) {
        var row = new (0, $5f67bb3af1a541ad$export$b05581f4e764e162)();
        row.setStyle("height:50px;width:100%;border-bottom: 1px solid var(--match-fixture-divider-color);");
        var c1 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c1.setStyle("width:100px;");
        var c2 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c2.setStyle("width:100px;text-align:end;");
        // var c3 = new TableCol();
        // c3.setStyle("width:100px;");
        var c4 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        ///c4.setStyle("width:40px;");
        var c5 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c5.setStyle("width:100px;");
        //c4.setStyle("margin-inline-end:10px;")
        var c6 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c6.setStyle("width:100px;");
        var c7 = new (0, $5f67bb3af1a541ad$export$fa07a78f5c25d264)();
        c7.setStyle("width:80px;");
        row.addControl(c1);
        row.addControl(c2);
        //row.addControl(c3);
        row.addControl(c4);
        row.addControl(c5);
        //row.addControl(c6);
        row.addControl(c7);
        const date = this.getNiceDate(data.date);
        c1.addControl(date);
        // var image = new Image();
        // image.setStyle("width:40px;height:40px;")
        // image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/teams_gs/" + data.from_id + "_rnd.png");
        c2.addControl(data.from);
        // c3.addControl(image);
        var arrow = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        arrow.addCssClass("icon-arrow-right");
        var rotation = "";
        if (FootballManiaConfig.isRtl) rotation = "transform: rotateY(180deg);";
        arrow.setStyle("margin-inline-start: 10px;margin-inline-end: 10px;width:30px;height:30px;" + rotation);
        c4.addControl(arrow);
        // var image = new Image();
        // image.setStyle("width:40px;height:40px;")
        // image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/teams_gs/" + data.to_id + "_rnd.png");
        c5.addControl(data.to);
        // c6.addControl(image);
        //console.log(data);
        if (data.transferType == "Loan") c7.addControl((0, $02mnx.Localizer).getString("loan"));
        else if (data.transferType == "Free") c7.addControl((0, $02mnx.Localizer).getString("free"));
        else c7.addControl(data.transferType);
        this.card.addControl(row);
    }
    getNiceDate(a) {
        var date = new (0, $5er4g.DateTimecode)();
        var split = a.split("/");
        date.setYear(split[2]);
        date.setMonth(split[1] - 1);
        date.setDate(split[0]);
        return Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit'
        }).format(date.getDateObject());
    }
}



class $1be0fcd02f170985$export$2616165974278734 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "Player";
        this.version = 1;
        super.init();
        this.setStyle("height:100%");
        //this is a bit hacky.
        //the id change event is fired even when we set the id of this page before
        //this logic. The reason is because the onhashchange event is async
        //and altough  we change the url before this logic, the onhashchange event fires
        //afte this logic
        this.bind("renderComplete", this.getProxy(function() {
            //alert("listen")
            //we do this to register back button scenario where page A is match and page B is also match
            setTimeout(function() {
                (0, $fRpWP.UrlManager).listenModule('pid', function() {
                    var id = (0, $fRpWP.UrlManager).getModule('pid');
                    if (id == undefined || (0, $fRpWP.UrlManager).getModule('section') != "Player") return console.warn("ignore opening league , probably navigating to other screen");
                    AppInstance.loadPage("Player", {
                        "pid": id
                    }, false);
                });
            }, 100);
        }));
        this.pageName = "Player_" + (0, $fRpWP.UrlManager).getModule("pid");
        this.addCssClass("PlayerPage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $0c58d603846ced72$export$56239863efbd94b6)();
        this.coordinatoranimator.reducerRatio = 1;
        this.coordinatoranimator.transitionDuration = 2;
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        this.wrapper1 = this.onWorkerMessageReceived.bind(this);
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var listData = [];
        console.log('worker message received', e.data[1]);
        if (e.data[1].allStatistics) {
            if (e.data[1].allStatistics.length) {
                var item = {
                    "data": e.data[1],
                    "type": 2
                };
                listData.push(item);
                //TODO: because of this item below the list is not stable after refresh.
                //somehow sticky element does something strange
                var item = {
                    "data": e.data[1],
                    "type": 3
                };
                listData.push(item);
                item = {
                    "data": e.data[1],
                    "type": 1
                };
                listData.push(item);
            }
        }
        var tabIndex = 0;
        var timeout = 0;
        if (this.tabview.currentActiveTab != this.playerListrender.tabIndex) timeout = 400;
        setTimeout(this.getProxy(function() {
            console.log("set dataaaaaaaa");
            this.playerListrender.containerTarget.hideLoader();
            this.playerListrender.setDataSource(listData);
        }), timeout);
        if (this.sidelinedListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != this.sidelinedListrender.tabIndex) timeout = 500;
            setTimeout(this.getProxy(function() {
                var listData = [];
                var item = {
                    "data": e.data[1],
                    "type": 2
                };
                listData.push(item);
                item = {
                    "data": e.data[1],
                    "type": 1
                };
                listData.push(item);
                this.sidelinedListrender.containerTarget.hideLoader();
                this.sidelinedListrender.setDataSource(listData);
            }), timeout);
        }
        if (this.transfersListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != this.transfersListrender.tabIndex) timeout = 700;
            setTimeout(this.getProxy(function() {
                this.transfersListrender.containerTarget.hideLoader();
                var listData = [];
                var item = {
                    "data": e.data[1],
                    "type": 1
                };
                listData.push(item);
                this.transfersListrender.setDataSource(listData);
            }), timeout);
        }
        if (this.trophiesListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != this.trophiesListrender.tabIndex) timeout = 700;
            setTimeout(this.getProxy(function() {
                this.trophiesListrender.containerTarget.hideLoader();
                this.trophiesListrender.setDataSource(e.data[1].trophies);
            }), timeout);
        }
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "playerListrenderScrollPosition": this.playerListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed || this.coordinatoranimator.isVirtuallyCollapsed
        };
        if (this.sidelinedListrender) d.sideLinedListrenderScrollPosition = this.sidelinedListrender.getScroll();
        if (this.transfersListrender) d.transfersListrenderScrollPosition = this.transfersListrender.getScroll();
        if (this.trophiesListrender) d.trophiesListrenderScrollPosition = this.trophiesListrender.getScroll();
        console.log("store state", d);
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.playerLoadHandler);
        (0, $fRpWP.UrlManager).unlistenModule('pid');
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) this.autoInterval(0);
        this.previousDocumentHidden = document.hidden;
    }
    createPageLayout() {
        this.playerHeader = new (0, $52bf27ff9a260a43$export$ab2ac12c6c1f7256)();
        this.playerHeader.setVisible(false);
        this.coordinatoranimator.addCollapser(this.playerHeader);
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(this.playerHeader);
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().hideTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.playerListrender) this.playerListrender.onWindowResize();
        if (this.sidelinedListrender) this.sidelinedListrender.onWindowResize();
        if (this.trophiesListrender) this.trophiesListrender.onWindowResize();
    }
    updateDisplay() {
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) this.coordinatoranimator.prerun(previousState.headerCollapsed);
        else this.coordinatoranimator.prerun(false);
        this.runApp();
    }
    runApp() {
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", this.getProxy(function() {
                    this.runApp();
                }));
            }
            this.showLoader();
            (0, $kc8Kt.DataProvider).getPlayer((0, $fRpWP.UrlManager).getModule("pid"), this.getProxy(function(response) {
                this.hideLoader();
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                        this.runApp();
                    }));
                    else return this.showError("", this.getProxy(function() {
                        this.runApp();
                    }));
                }
                var data = response.getData();
                if (!data.name) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                    this.runApp();
                }));
                this.createTabs(data);
                this.playerHeader.setPresetData(data, true);
                this.playerHeader.setVisible(true);
                ///this.coordinatoranimator.prerun()
                // return;
                this.getPageTemplate().createMenuPlayer(response.getData());
                this.tabview.bind("tabChanged", this.getProxy(function() {
                    console.log("tab changed!!!!");
                    this.storeState();
                    this.coordinatoranimator.tabChange();
                }));
                var storeHandler = null;
                var storeHandler2 = null;
                var storeHandler3 = null;
                var storeHandler4 = null;
                this.playerListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 300);
                }));
                //
                if (this.sidelinedListrender) this.sidelinedListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler2);
                    storeHandler2 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 300);
                }));
                if (this.transfersListrender) this.transfersListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler3);
                    storeHandler3 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 300);
                }));
                if (this.trophiesListrender) this.trophiesListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler4);
                    storeHandler4 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 300);
                }));
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                if (previousState) {
                    this.tabview.currentActiveTab = previousState.tabIndex;
                    this.coordinatoranimator.currentActiveTab = previousState.tabIndex;
                    this.playerListrender.scrollTo(previousState.playerListrenderScrollPosition || 0);
                    console.log("restore scroll transfers ", previousState.transfersListrenderScrollPosition);
                    if (this.sidelinedListrender) this.sidelinedListrender.scrollTo(previousState.sideLinedListrenderScrollPosition || 0);
                    if (this.transfersListrender) this.transfersListrender.scrollTo(previousState.transfersListrenderScrollPosition || 0);
                    if (this.trophiesListrender) this.trophiesListrender.scrollTo(previousState.trophiesListrenderScrollPosition || 0);
                    this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                }
                console.log("----------->", previousState);
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.ensureStartPositions(); //we call this to ensure tabview is collapsed without flicker
                //this.coordinatoranimator.run();
                //this.coordinatoranimator.prepare();
                var tabIndex = 0;
                this.loadPlayer(data, tabIndex);
            }));
        }));
    }
    createTitle(data) {
        if (!data) return;
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl(data.playername);
        this.getPageTemplate().topTitleContainer.addControl(title);
        this.getPageTemplate().topTitleContainer.invalidateDisplay();
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        tabview.parallaxBg = this.playerHeader.backgroundImage;
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("background-color:red;height:20px; width:100%;float:left;");
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        var tab2;
        var tab3;
        var tab4;
        var tabIndexUsed = 0;
        if (FootballManiaConfig.isRtl) {
            if (data.trophies && data.trophies.length) {
                tab4 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab4.setStyle("width:100%;height:100%;position:relative;");
                tab4.title = (0, $02mnx.Localizer).getString("trophies");
                tab4.iconClass = "icon-trophy";
                tabs.push(tab4);
                this.createTrophiesControls(tab4, tabIndexUsed);
                tab4.showLoader();
                tabIndexUsed += 1;
            }
            if (data.transfers && data.transfers.length) {
                tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab3.setStyle("width:100%;height:100%;position:relative;");
                tab3.title = (0, $02mnx.Localizer).getString("transfers");
                tabs.push(tab3);
                this.createTransfersControls(tab3, tabIndexUsed);
                tab3.showLoader();
                tabIndexUsed += 1;
            }
            if (data.sidelined && data.sidelined.length) {
                tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab2.setStyle("width:100%;height:100%;position:relative;");
                tab2.title = (0, $02mnx.Localizer).getString("injuries");
                tabs.push(tab2);
                this.createsidelinedControls(tab2, tabIndexUsed);
                tab2.showLoader();
                tabIndexUsed += 1;
            }
            tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab1.setStyle("width:100%;height:100%;position:relative;");
            tab1.title = (0, $02mnx.Localizer).getString("info");
            tabs.push(tab1);
            this.createplayerControls(tab1, tabIndexUsed);
            tabview.currentActiveTab = tabIndexUsed;
        } else {
            tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab1.setStyle("width:100%;height:100%;position:relative;");
            tab1.title = (0, $02mnx.Localizer).getString("info");
            tabs.push(tab1);
            this.createplayerControls(tab1, tabIndexUsed);
            tabIndexUsed += 1;
            if (data.sidelined && data.sidelined.length) {
                tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab2.setStyle("width:100%;height:100%;position:relative;");
                tab2.title = (0, $02mnx.Localizer).getString("injuries");
                tabs.push(tab2);
                this.createsidelinedControls(tab2, tabIndexUsed);
                tab2.showLoader();
                tabIndexUsed += 1;
            }
            if (data.transfers && data.transfers.length) {
                tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab3.setStyle("width:100%;height:100%;position:relative;");
                tab3.title = (0, $02mnx.Localizer).getString("transfers");
                tabs.push(tab3);
                this.createTransfersControls(tab3, tabIndexUsed);
                tab3.showLoader();
                tabIndexUsed += 1;
            }
            if (data.trophies && data.trophies.length) {
                tab4 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab4.setStyle("width:100%;height:100%;position:relative;");
                tab4.title = (0, $02mnx.Localizer).getString("trophies");
                tab4.iconClass = "icon-trophy";
                tabs.push(tab4);
                this.createTrophiesControls(tab4, tabIndexUsed);
                tab4.showLoader();
            }
        }
        this.coordinatoranimator.addTopBar(this.getPageTemplate().topBar);
        //this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", this.getProxy(function() {
            this.coordinatoranimator.run();
        }));
        this.tabview = tabview;
        tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
            if (tab2) tab2.setCss({
                'height': '100%'
            });
            if (tab3) tab3.setCss({
                'height': '100%'
            });
            if (tab4) tab4.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab2) tab2.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab3) tab3.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab4) tab4.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createplayerControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.activateScrolling = true;
        listRender.containerTarget = tab;
        listRender.tabIndex = index;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $67d0d0b32ec91180$export$2bfb8a280097c119)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $67d0d0b32ec91180$export$cad9d717a3aa3269)()
            };
            else if (data.type == 3) return {
                typeId: 2,
                render: new (0, $67d0d0b32ec91180$export$d4c5bf92dc49d29b)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            tab.scrollerContainerReference = listRender.mainContainer; //otherwise wrong scrollpanel is used and on IOS we cannot scroll because transform is breaikig scroll
            this.coordinatoranimator.addScrollerContainer(listRender.mainContainer, index);
            this.coordinatoranimator.recalculateTab(index);
        //this.coordinatoranimator.ensureStartPositions();
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.playerStatsScrollPosition || 0);
        container.addControl(listRender);
        this.playerListrender = listRender;
        tab.addControl(container);
    }
    createsidelinedControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.activateScrolling = true;
        listRender.containerTarget = tab;
        listRender.tabIndex = index;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $67d0d0b32ec91180$export$1cb596563defa388)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $67d0d0b32ec91180$export$4cc13e747962c1d1)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb () {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            tab.scrollerContainerReference = listRender.mainContainer; //otherwise wrong scrollpanel is used and on IOS we cannot scroll because transform is breaikig scroll
            this.coordinatoranimator.addScrollerContainer(listRender.mainContainer, index);
            this.coordinatoranimator.recalculateTab(index);
        //this.coordinatoranimator.ensureStartPositions();
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.sideLinedListrenderScrollPosition || 0);
        container.addControl(listRender);
        this.sidelinedListrender = listRender;
        tab.addControl(container);
    }
    createTransfersControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.activateScrolling = true;
        listRender.tabIndex = index;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $67d0d0b32ec91180$export$dc35904be8fb7df4)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$e5da9225dca7bbb3)({
                message: (0, $02mnx.Localizer).getString("no_transfer_data")
            });
        };
        listRender.bind('createdList', this.getProxy(function() {
            tab.scrollerContainerReference = listRender.mainContainer; //make sure correct scrller container tabview otherwise wrong scrollpanel is used and on IOS we cannot scroll because transform is breaikig scroll
            this.coordinatoranimator.addScrollerContainer(listRender.mainContainer, index);
            this.coordinatoranimator.recalculateTab(index);
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            console.log("restore scroll transfers #2 : ", previousState.transfersListrenderScrollPosition);
            listRender.scrollTo(previousState.transfersListrenderScrollPosition || 0);
        }
        container.addControl(listRender);
        this.transfersListrender = listRender;
        tab.addControl(container);
    }
    createTrophiesControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.activateScrolling = true;
        listRender.containerTarget = tab;
        listRender.tabIndex = index;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$5d4aeaf48cf752ec)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $884f7ad69d27d69a$export$1fb77fe93e51380c)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            tab.scrollerContainerReference = listRender.mainContainer; //otherwise wrong scrollpanel is used and on IOS we cannot scroll because transform is breaikig scroll
            this.coordinatoranimator.addScrollerContainer(listRender.mainContainer, index);
            this.coordinatoranimator.recalculateTab(index);
        //this.coordinatoranimator.ensureStartPositions();
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.trophiesListrenderScrollPosition || 0);
        container.addControl(listRender);
        this.trophiesListrender = listRender;
        tab.addControl(container);
    }
    loadPlayer(data, ignoreCache) {
        console.log("load player");
        if (!data) return this.autoInterval();
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        if (!FootballManiaConfig.useWebWorkers) {
            var list = (0, $gQQqD.Processors).preparePlayerData(data, (0, $02mnx.Localizer).getLoadedLocale(), (0, $02mnx.Localizer).DefaultTranslations, AppInstance.getLocale());
            var data = {
                data: [
                    0,
                    list
                ]
            };
            this.onWorkerMessageReceived(data);
        } else AppInstance.workerHelper1.postMessage({
            methodType: 9,
            data: data,
            translations: (0, $02mnx.Localizer).getLoadedLocale(),
            defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
            locale: AppInstance.getLocale()
        });
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
    }
    autoInterval(overrideInterval) {
        clearTimeout(this.playerLoadHandler);
        this.playerLoadHandler = setTimeout(this.getProxy(function() {
            if (document.hidden) {
                console.warn("no auto refresh because page is hidden");
                return;
            }
            (0, $kc8Kt.DataProvider).getPlayer((0, $fRpWP.UrlManager).getModule("pid"), this.getProxy(function(response) {
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.autoInterval();
                    return;
                }
                //todo error screen
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!FootballManiaConfig.useWebWorkers) {
                    var list = (0, $gQQqD.Processors).preparePlayerData(response.getData(), (0, $02mnx.Localizer).getLoadedLocale(), (0, $02mnx.Localizer).DefaultTranslations, AppInstance.getLocale());
                    var data = {
                        data: [
                            0,
                            list
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else AppInstance.workerHelper1.postMessage({
                    methodType: 9,
                    data: response.getData(),
                    translations: (0, $02mnx.Localizer).getLoadedLocale(),
                    defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
                    locale: AppInstance.getLocale()
                });
            }));
        }), overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.player);
    }
}








var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $gQQqD = parcelRequire("gQQqD");





var $02mnx = parcelRequire("02mnx");


class $51445f88877cf672$export$17651595ac1df58f extends (0, $52bf27ff9a260a43$export$ab2ac12c6c1f7256) {
    init() {
        super.init();
    }
    setPresetData(data, instantRender) {
        if (!data) {
            console.error("cannot set preset data without data");
            return;
        }
        if (instantRender) {
            if (data.nationality) {
                this.backgroundImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replaceAll(" ", "-").toLowerCase() + ".png");
                this.backgroundImage.setVisible(true);
            }
        }
        this.homeTitle.clear();
        if (!AppInstance.getConfig().isRtl) this.homeTitle.addControl(data.firstname + " " + data.lastname, true);
        else this.homeTitle.addControl(data.lastname + " " + data.firstname, true);
        if (!this.oldData || this.oldData.id != data.id) {
            if (AppInstance.getConfig().enabledFeatures.playerImages) {
                this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/coachimages/" + data.id + "_rnd.png", 100, 100);
                this.homeImage.setAttribute("alt", (0, $02mnx.Localizer).getString("player image"));
                if (data.nationality) {
                    this.teamFlag.imageObjectStyle = "margin-top:-15px;margin-left:-16px;";
                    this.teamFlag.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replaceAll(" ", "-").toLowerCase() + ".png", 70, 70);
                } else this.teamFlag.remove();
                if (data.teamid) this.image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/teams_gs/" + data.teamid + "_small_rnd.png", AppInstance.getConfig().sizes.fixtureListImageSize, AppInstance.getConfig().sizes.fixtureListImageSize);
                else this.image.remove();
            } else {
                this.teamFlag.remove();
                this.image.remove();
                this.homeImage.imageObjectStyle = "margin-top:-40px;margin-left:-40px;";
                this.homeImage.setCss({
                    'overflow': "hidden",
                    "border-radius": "50%"
                });
                if (data.nationality) this.homeImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replaceAll(" ", "-").toLowerCase() + ".png", 180, 180);
            //this.image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/"+AppInstance.getConfig().url.teamPlayerImageUrl+"/teams_gs/" + data.teamid + "_small_rnd.png", AppInstance.getConfig().sizes.fixtureListImageSize, AppInstance.getConfig().sizes.fixtureListImageSize);
            }
        }
        this.oldData = data;
    }
    setData(data) {}
}



var $kc8Kt = parcelRequire("kc8Kt");





class $8bf5eb0582c02c41$export$b4de764f4b9821a extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "Coach";
        this.version = 1;
        super.init();
        this.setStyle("height:100%");
        //this is a bit hacky.
        //the id change event is fired even when we set the id of this page before
        //this logic. The reason is because the onhashchange event is async
        //and altough  we change the url before this logic, the onhashchange event fires
        //afte this logic
        this.bind("renderComplete", this.getProxy(function() {
            //alert("listen")
            //we do this to register back button scenario where page A is match and page B is also match
            setTimeout(function() {
                (0, $fRpWP.UrlManager).listenModule('cid', function() {
                    var id = (0, $fRpWP.UrlManager).getModule('cid');
                    if (id == undefined || (0, $fRpWP.UrlManager).getModule('section') != "Player") return console.warn("ignore opening league , probably navigating to other screen");
                    AppInstance.loadPage("Coach", {
                        "cid": id
                    }, false);
                });
            }, 100);
        }));
        this.pageName = "Coach_" + (0, $fRpWP.UrlManager).getModule("cid");
        this.addCssClass("PlayerPage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $0c58d603846ced72$export$56239863efbd94b6)();
        this.coordinatoranimator.reducerRatio = 1;
        this.coordinatoranimator.transitionDuration = 2;
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        this.wrapper1 = this.onWorkerMessageReceived.bind(this);
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var tabIndex = 0;
        var timeout = 0;
        if (this.tabview.currentActiveTab != this.playerListrender.tabIndex) timeout = 400;
        setTimeout(this.getProxy(function() {
            console.log("set dataaaaaaaa", e.data[1]);
            this.playerListrender.containerTarget.hideLoader();
            var listData = [];
            item = {
                "data": e.data[1],
                "type": 1
            };
            listData.push(item);
            if (e.data[1].careerclubs) {
                var item = {
                    "data": e.data[1],
                    "type": 2
                };
                listData.push(item);
            }
            this.playerListrender.setDataSource(listData);
        }), timeout);
        if (this.sidelinedListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != this.sidelinedListrender.tabIndex) timeout = 500;
            setTimeout(this.getProxy(function() {
                var listData = [];
                var item = {
                    "data": e.data[1],
                    "type": 2
                };
                listData.push(item);
                item = {
                    "data": e.data[1],
                    "type": 1
                };
                listData.push(item);
                this.sidelinedListrender.containerTarget.hideLoader();
                this.sidelinedListrender.setDataSource(listData);
            }), timeout);
        }
        if (this.transfersListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != this.transfersListrender.tabIndex) timeout = 700;
            setTimeout(this.getProxy(function() {
                this.transfersListrender.containerTarget.hideLoader();
                var listData = [];
                var item = {
                    "data": e.data[1],
                    "type": 1
                };
                listData.push(item);
                this.transfersListrender.setDataSource(listData);
            }), timeout);
        }
        if (this.trophiesListrender) {
            tabIndex++;
            timeout = 0;
            if (this.tabview.currentActiveTab != this.trophiesListrender.tabIndex) timeout = 700;
            setTimeout(this.getProxy(function() {
                this.trophiesListrender.containerTarget.hideLoader();
                this.trophiesListrender.setDataSource(e.data[1].trophies);
            }), timeout);
        }
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "playerListrenderScrollPosition": this.playerListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed || this.coordinatoranimator.isVirtuallyCollapsed
        };
        if (this.sidelinedListrender) d.sideLinedListrenderScrollPosition = this.sidelinedListrender.getScroll();
        if (this.transfersListrender) d.transfersListrenderScrollPosition = this.transfersListrender.getScroll();
        if (this.trophiesListrender) d.trophiesListrenderScrollPosition = this.trophiesListrender.getScroll();
        console.log("store state", d);
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.playerLoadHandler);
        (0, $fRpWP.UrlManager).unlistenModule('cid');
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) this.autoInterval(0);
        this.previousDocumentHidden = document.hidden;
    }
    createPageLayout() {
        this.coachHeader = new (0, $51445f88877cf672$export$17651595ac1df58f)();
        this.coachHeader.setVisible(false);
        this.coordinatoranimator.addCollapser(this.coachHeader);
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(this.coachHeader);
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().hideTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.playerListrender) this.playerListrender.onWindowResize();
        if (this.sidelinedListrender) this.sidelinedListrender.onWindowResize();
        if (this.trophiesListrender) this.trophiesListrender.onWindowResize();
    }
    updateDisplay() {
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) this.coordinatoranimator.prerun(previousState.headerCollapsed);
        else this.coordinatoranimator.prerun(false);
        this.runApp();
    }
    runApp() {
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", this.getProxy(function() {
                    this.runApp();
                }));
            }
            this.showLoader();
            (0, $kc8Kt.DataProvider).getCoach((0, $fRpWP.UrlManager).getModule("cid"), this.getProxy(function(response) {
                this.hideLoader();
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                        this.runApp();
                    }));
                    else return this.showError("", this.getProxy(function() {
                        this.runApp();
                    }));
                }
                var data = response.getData();
                if (!data.name) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                    this.runApp();
                }));
                this.createTabs(data);
                this.coachHeader.setPresetData(data, true);
                this.coachHeader.setVisible(true);
                ///this.coordinatoranimator.prerun()
                // return;
                this.getPageTemplate().createMenuPlayer(response.getData());
                this.tabview.bind("tabChanged", this.getProxy(function() {
                    console.log("tab changed!!!!");
                    this.storeState();
                    this.coordinatoranimator.tabChange();
                }));
                var storeHandler = null;
                var storeHandler2 = null;
                var storeHandler3 = null;
                var storeHandler4 = null;
                this.playerListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 300);
                }));
                //
                if (this.sidelinedListrender) this.sidelinedListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler2);
                    storeHandler2 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 300);
                }));
                if (this.transfersListrender) this.transfersListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler3);
                    storeHandler3 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 300);
                }));
                if (this.trophiesListrender) this.trophiesListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler4);
                    storeHandler4 = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 300);
                }));
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                if (previousState) {
                    this.tabview.currentActiveTab = previousState.tabIndex;
                    this.coordinatoranimator.currentActiveTab = previousState.tabIndex;
                    this.playerListrender.scrollTo(previousState.playerListrenderScrollPosition || 0);
                    console.log("restore scroll transfers ", previousState.transfersListrenderScrollPosition);
                    if (this.sidelinedListrender) this.sidelinedListrender.scrollTo(previousState.sideLinedListrenderScrollPosition || 0);
                    if (this.transfersListrender) this.transfersListrender.scrollTo(previousState.transfersListrenderScrollPosition || 0);
                    if (this.trophiesListrender) this.trophiesListrender.scrollTo(previousState.trophiesListrenderScrollPosition || 0);
                    this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                }
                console.log("----------->", previousState);
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.ensureStartPositions(); //we call this to ensure tabview is collapsed without flicker
                //this.coordinatoranimator.run();
                //this.coordinatoranimator.prepare();
                var tabIndex = 0;
                this.processCoachData(data, tabIndex);
            }));
        }));
    }
    createTitle(data) {
        if (!data) return;
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl(data.playername);
        this.getPageTemplate().topTitleContainer.addControl(title);
        this.getPageTemplate().topTitleContainer.invalidateDisplay();
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        tabview.parallaxBg = this.coachHeader.backgroundImage;
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("background-color:red;height:20px; width:100%;float:left;");
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        var tab2;
        var tab3;
        var tab4;
        var tabIndexUsed = 0;
        if (FootballManiaConfig.isRtl) {
            if (data.trophies && data.trophies.length) {
                tab4 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab4.setStyle("width:100%;height:100%;position:relative;");
                tab4.title = (0, $02mnx.Localizer).getString("trophies");
                tabs.push(tab4);
                this.createTrophiesControls(tab4, tabIndexUsed);
                tab4.showLoader();
                tabIndexUsed += 1;
            }
            if (data.transfers && data.transfers.length) {
                tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab3.setStyle("width:100%;height:100%;position:relative;");
                tab3.title = (0, $02mnx.Localizer).getString("transfers");
                tabs.push(tab3);
                this.createTransfersControls(tab3, tabIndexUsed);
                tab3.showLoader();
                tabIndexUsed += 1;
            }
            if (data.sidelined && data.sidelined.length) {
                tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab2.setStyle("width:100%;height:100%;position:relative;");
                tab2.title = (0, $02mnx.Localizer).getString("injuries");
                tabs.push(tab2);
                this.createsidelinedControls(tab2, tabIndexUsed);
                tab2.showLoader();
                tabIndexUsed += 1;
            }
            tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab1.setStyle("width:100%;height:100%;position:relative;");
            tab1.title = (0, $02mnx.Localizer).getString("info");
            tabs.push(tab1);
            this.createplayerControls(tab1, tabIndexUsed);
            tabview.currentActiveTab = tabIndexUsed;
        } else {
            tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
            tab1.setStyle("width:100%;height:100%;position:relative;");
            tab1.title = (0, $02mnx.Localizer).getString("info");
            tabs.push(tab1);
            this.createplayerControls(tab1, tabIndexUsed);
            tabIndexUsed += 1;
            if (data.sidelined && data.sidelined.length) {
                tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab2.setStyle("width:100%;height:100%;position:relative;");
                tab2.title = (0, $02mnx.Localizer).getString("injuries");
                tabs.push(tab2);
                this.createsidelinedControls(tab2, tabIndexUsed);
                tab2.showLoader();
                tabIndexUsed += 1;
            }
            if (data.transfers && data.transfers.length) {
                tab3 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab3.setStyle("width:100%;height:100%;position:relative;");
                tab3.title = (0, $02mnx.Localizer).getString("transfers");
                tabs.push(tab3);
                this.createTransfersControls(tab3, tabIndexUsed);
                tab3.showLoader();
                tabIndexUsed += 1;
            }
            if (data.trophies && data.trophies.length) {
                tab4 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
                //tab3.setStyle("width:100%;height: calc(100% + 133px);margin-top:-133px;position:relative;overflow-y: scroll;transform: translate(0,0);");
                tab4.setStyle("width:100%;height:100%;position:relative;");
                tab4.title = (0, $02mnx.Localizer).getString("trophies");
                tabs.push(tab4);
                this.createTrophiesControls(tab4, tabIndexUsed);
                tab4.showLoader();
            }
        }
        this.coordinatoranimator.addTopBar(this.getPageTemplate().topBar);
        //this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", this.getProxy(function() {
            this.coordinatoranimator.run();
        }));
        this.tabview = tabview;
        tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
            if (tab2) tab2.setCss({
                'height': '100%'
            });
            if (tab3) tab3.setCss({
                'height': '100%'
            });
            if (tab4) tab4.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab2) tab2.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab3) tab3.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab4) tab4.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createplayerControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.activateScrolling = true;
        listRender.containerTarget = tab;
        listRender.tabIndex = index;
        listRender.setItemRender(function(data) {
            if (data.type == 2) return {
                typeId: 2,
                render: new (0, $67d0d0b32ec91180$export$9ed2ea241c3e7305)()
            };
            else if (data.type == 1) return {
                typeId: 1,
                render: new (0, $67d0d0b32ec91180$export$cad9d717a3aa3269)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            tab.scrollerContainerReference = listRender.mainContainer; //otherwise wrong scrollpanel is used and on IOS we cannot scroll because transform is breaikig scroll
            this.coordinatoranimator.addScrollerContainer(listRender.mainContainer, index);
            this.coordinatoranimator.recalculateTab(index);
        //this.coordinatoranimator.ensureStartPositions();
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.playerStatsScrollPosition || 0);
        container.addControl(listRender);
        this.playerListrender = listRender;
        tab.addControl(container);
    }
    createsidelinedControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.activateScrolling = true;
        listRender.containerTarget = tab;
        listRender.tabIndex = index;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $67d0d0b32ec91180$export$1cb596563defa388)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $67d0d0b32ec91180$export$4cc13e747962c1d1)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb () {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            tab.scrollerContainerReference = listRender.mainContainer; //otherwise wrong scrollpanel is used and on IOS we cannot scroll because transform is breaikig scroll
            this.coordinatoranimator.addScrollerContainer(listRender.mainContainer, index);
            this.coordinatoranimator.recalculateTab(index);
        //this.coordinatoranimator.ensureStartPositions();
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.sideLinedListrenderScrollPosition || 0);
        container.addControl(listRender);
        this.sidelinedListrender = listRender;
        tab.addControl(container);
    }
    createTransfersControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.activateScrolling = true;
        listRender.tabIndex = index;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $67d0d0b32ec91180$export$dc35904be8fb7df4)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$e5da9225dca7bbb3)({
                message: (0, $02mnx.Localizer).getString("no_transfer_data")
            });
        };
        listRender.bind('createdList', this.getProxy(function() {
            tab.scrollerContainerReference = listRender.mainContainer; //make sure correct scrller container tabview otherwise wrong scrollpanel is used and on IOS we cannot scroll because transform is breaikig scroll
            this.coordinatoranimator.addScrollerContainer(listRender.mainContainer, index);
            this.coordinatoranimator.recalculateTab(index);
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            console.log("restore scroll transfers #2 : ", previousState.transfersListrenderScrollPosition);
            listRender.scrollTo(previousState.transfersListrenderScrollPosition || 0);
        }
        container.addControl(listRender);
        this.transfersListrender = listRender;
        tab.addControl(container);
    }
    createTrophiesControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.activateScrolling = true;
        listRender.containerTarget = tab;
        listRender.tabIndex = index;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $884f7ad69d27d69a$export$5d4aeaf48cf752ec)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $884f7ad69d27d69a$export$1fb77fe93e51380c)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            tab.scrollerContainerReference = listRender.mainContainer; //otherwise wrong scrollpanel is used and on IOS we cannot scroll because transform is breaikig scroll
            this.coordinatoranimator.addScrollerContainer(listRender.mainContainer, index);
            this.coordinatoranimator.recalculateTab(index);
        //this.coordinatoranimator.ensureStartPositions();
        }));
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.trophiesListrenderScrollPosition || 0);
        container.addControl(listRender);
        this.trophiesListrender = listRender;
        tab.addControl(container);
    }
    processCoachData(data, ignoreCache) {
        console.log("load coach");
        if (!data) return this.autoInterval();
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        if (!FootballManiaConfig.useWebWorkers) {
            var list = (0, $gQQqD.Processors).preparePlayerData(data, (0, $02mnx.Localizer).getLoadedLocale(), (0, $02mnx.Localizer).DefaultTranslations, AppInstance.getLocale());
            var data = {
                data: [
                    0,
                    list
                ]
            };
            this.onWorkerMessageReceived(data);
        } else AppInstance.workerHelper1.postMessage({
            methodType: 9,
            data: data,
            translations: (0, $02mnx.Localizer).getLoadedLocale(),
            defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
            locale: AppInstance.getLocale()
        });
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
    }
    autoInterval(overrideInterval) {
        clearTimeout(this.playerLoadHandler);
        this.playerLoadHandler = setTimeout(this.getProxy(function() {
            if (document.hidden) {
                console.warn("no auto refresh because page is hidden");
                return;
            }
            (0, $kc8Kt.DataProvider).getCoach((0, $fRpWP.UrlManager).getModule("cid"), this.getProxy(function(response) {
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.autoInterval();
                    return;
                }
                //todo error screen
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!FootballManiaConfig.useWebWorkers) {
                    var list = (0, $gQQqD.Processors).preparePlayerData(response.getData(), (0, $02mnx.Localizer).getLoadedLocale(), (0, $02mnx.Localizer).DefaultTranslations, AppInstance.getLocale());
                    var data = {
                        data: [
                            0,
                            list
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else AppInstance.workerHelper1.postMessage({
                    methodType: 9,
                    data: response.getData(),
                    translations: (0, $02mnx.Localizer).getLoadedLocale(),
                    defaultTranslations: (0, $02mnx.Localizer).DefaultTranslations,
                    locale: AppInstance.getLocale()
                });
            }));
        }), overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.player);
    }
}





var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $kc8Kt = parcelRequire("kc8Kt");


var $6K7Df = parcelRequire("6K7Df");





class $9bcdf8c54273a23c$export$bad1c9032f2cc88a extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "CountryLeagues_" + (0, $fRpWP.UrlManager).getModule("lid");
        this.version = 1;
        super.init();
        this.setStyle("height:100%");
        this.bind("renderComplete", ()=>{
            var that = this;
            //alert("listen")
            //we do this to register back button scenario where page A is match and page B is also match
            setTimeout(function() {
                if (that.unloaded) {
                    console.log("ignore, page is unloaded");
                    return;
                }
                (0, $fRpWP.UrlManager).listenModule('cid', function() {
                    (0, $fRpWP.UrlManager).unlistenModule("cid");
                    var id = (0, $fRpWP.UrlManager).getModule('cid');
                    if (id == undefined || (0, $fRpWP.UrlManager).getModule('section') != "CountryLeagues") return console.warn("ignore opening league , probably navigating to other screen");
                    AppInstance.loadPage("CountryLeagues", {
                        "cid": id
                    }, false);
                });
            }, 100);
        });
        this.pageName = "CountryLeagues_" + (0, $fRpWP.UrlManager).getModule("lid");
        this.addCssClass("LeaguePage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $23ab1716e6aced69$export$bd2148639dcb5f7e)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
        }
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        this.tabview.tabs[0].hideLoader();
        this.competitionsListrender.setDataSource(e.data);
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "competitionsScrollPosition": this.competitionsListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.competitionsLoadHandler);
        (0, $fRpWP.UrlManager).unlistenModule('cid');
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        this.previousDocumentHidden = !document.hidden;
        this.previousDocumentHidden = document.hidden;
    //console.log("visibility change ",document.hidden,this);
    }
    createPageLayout() {
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().showTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.competitionsListrender) this.competitionsListrender.onWindowResize();
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        console.log("run app");
        this.showLoader();
        AppInstance.setup((result)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", ()=>{
                    this.runApp();
                });
            }
            var country = decodeURI((0, $fRpWP.UrlManager).getModule("cid"));
            (0, $kc8Kt.DataProvider).getCountryLeagues(country, (response)=>{
                this.hideLoader();
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", ()=>{
                        this.runApp();
                    });
                    else return this.showError("", ()=>{
                        this.runApp();
                    });
                }
                var data = response.getData();
                this.createTitle(data);
                this.createTabs(data);
                this.getPageTemplate().createMenuCountryLeagues(response.getData());
                this.tabview.bind("tabChanged", ()=>{
                    this.storeState();
                    this.coordinatoranimator.tabChange();
                });
                var storeHandler = null;
                this.competitionsListrender.bind("scroll", (e, scroll)=>{
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(()=>{
                        this.storeState();
                    }, 200);
                });
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                if (previousState) {
                    this.tabview.currentActiveTab = previousState.tabIndex;
                    this.competitionsListrender.scrollTo(previousState.competitionsScrollPosition || 0);
                    console.log("restored scroll ", previousState.competitionsScrollPosition);
                    this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                }
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.prepare();
                this.loadCountryLeagues(data);
            }, true);
        });
    }
    createTitle(data) {
        var country = decodeURI((0, $fRpWP.UrlManager).getModule("cid"));
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.setStyle("width:28px;");
        image.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + country.replaceAll(" ", "-").toLowerCase() + ".png");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addControl((0, $6K7Df.CountryUtil).getLocalizedCountryByName(country));
        this.getPageTemplate().topTitleContainer.addControl(image);
        this.getPageTemplate().topTitleContainer.addControl(title);
        this.getPageTemplate().topTitleContainer.invalidateDisplay();
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab1.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab1.title = (0, $02mnx.Localizer).getString("competitions");
        tabs.push(tab1);
        this.createCountryLeaguesControls(tab1, 0);
        this.coordinatoranimator.addScrollerContainer(tab1);
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", ()=>{
            this.coordinatoranimator.run();
        });
        this.tabview = tabview;
        tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createCountryLeaguesControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $761fc09f912370da$export$5f18642dbcedb9ce)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$5094fa700c8c41ca)()
            };
        });
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) {
            console.log("restore scroll #2 : ", previousState.competitionsScrollPosition);
            listRender.scrollTo(previousState.competitionsScrollPosition || 0);
        }
        container.addControl(listRender);
        this.competitionsListrender = listRender;
        tab.addControl(container);
    }
    loadCountryLeagues(data, ignoreCache) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        for(var i = 0; i < data.length; i++){
            data[i].type = 1;
            data[i].country = decodeURI((0, $fRpWP.UrlManager).getModule("cid"));
        }
        this.tabview.tabs[0].hideLoader();
        this.competitionsListrender.setDataSource(data);
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
    }
}




var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $gQQqD = parcelRequire("gQQqD");



var $kc8Kt = parcelRequire("kc8Kt");








class $2e49a60e68d7e121$export$5081865e84e17f53 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(data) {
        super.init();
        this.data = data;
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-bottom:40px;");
        //
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard ");
        this.panel.addControl(this.card);
        this.panel.setStyle("margin-top:3px;margin-bottom:-3px;");
        this.card.setStyle("padding-bottom:4px;height:48px;cursor:pointer;");
        //
        this.content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.content.addCssClass("flexHorizontalAlign");
        this.content.setStyle("align-items: flex-start;");
        this.card.addControl(this.content);
        this.rank = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.rank.setStyle("align-self: center;padding-inline-start:4px;padding-inline-end:4px;min-width:28px;");
        this.content.addControl(this.rank);
        this.playerImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        this.playerImage.setStyle("width:40px; height:40px;align-self: center;border-radius:30px; overflow:hidden;");
        this.content.addControl(this.playerImage);
        this.playerCountryImage = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        this.playerCountryImage.setStyle("align-self: center;margin-inline-start: 8px;width: 20px;");
        this.content.addControl(this.playerCountryImage);
        this.playerName = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerName.setStyle("align-self: center;margin-inline-start: 8px;line-height: 21px;");
        this.content.addControl(this.playerName);
        this.playerValue = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        var margin = "margin-left:auto;";
        if (FootballManiaConfig.isRtl) margin = "margin-right:auto;";
        this.playerValue.setStyle(margin + "align-self: center;");
        this.content.addControl(this.playerValue);
        this.addControl(this.panel);
        this.valueFormatter = Intl.NumberFormat('en-EN', {
            style: 'currency',
            currency: 'EUR'
        });
        this.content.bind("click", ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showPlayerScreen(this.data.id);
        });
    }
    setData(data) {
        this.data = data;
        this.rank.clear();
        this.playerName.clear();
        this.playerValue.clear();
        this.rank.addControl(data.rank + "", true);
        if (this.data.style.selected) this.card.addCssClass("highlightanimated");
        if (AppInstance.getConfig().enabledFeatures.playerImages) {
            this.playerImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + data.id + "_small_rnd.png", 40, 40);
            this.playerCountryImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replace(/\s|\'/g, '-').toLowerCase() + ".png");
        } else {
            this.playerImage.imageObjectStyle = "margin-top:-16px;margin-left:-16px;";
            this.playerImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + data.nationality.replace(/\s|\'/g, '-').toLowerCase() + ".png", 72, 72);
            this.playerCountryImage.setVisible(false);
        }
        this.playerName.addControl(data.name + " <br> <i style='font-weight:bold;'> " + data.team + "</i>", true);
        this.playerValue.addControl(this.valueFormatter.format(data.marketvalue), true);
    }
}








var $02mnx = parcelRequire("02mnx");


var $kc8Kt = parcelRequire("kc8Kt");

var $6K7Df = parcelRequire("6K7Df");

var $fRpWP = parcelRequire("fRpWP");
class $9d7769ca17983c73$export$ab2a68d00457bd5a extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier) {
        super.init(urlIdentifier);
        this.selectedData = [];
        this.allCountries = [];
    }
    createComponents() {
        super.createComponents();
        var dim = this.getPage().getDimensions();
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        p.setStyle("height:" + (dim.height - 50) + "px;justify-content: flex-start;");
        p.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.addCssClass("addFavoriteModalTitle");
        title.addControl((0, $02mnx.Localizer).getString("filter_by_country"));
        p.addControl(title);
        var selectedContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        selectedContainer.addCssClass("selectedCountriesContainer");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        title.setStyle("font-size: 12px;font-weight: bold;margin-bottom: 10px;");
        this.selectedCount = title;
        var resetButton = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        resetButton.addControl((0, $02mnx.Localizer).getString("reset"));
        resetButton.addCssClass("modal-country-reset-button");
        this.resetButton = resetButton;
        this.resetButton.setVisible(false);
        resetButton.bind("click", ()=>{
            this.selectedData = [];
            searchPh.setVisible(true);
            this.renderCountries(searchResults, this.allCountries);
            this.renderSelected();
            this.updateUrl();
            this.getPage().triggerEvent("countrySelected", {
                "selected": this.selectedData
            });
        });
        selectedContainer.addControl(title);
        selectedContainer.addControl(resetButton);
        p.addControl(selectedContainer);
        var search = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        search.addCssClass("topBarSearchContainer modalSearchContainer");
        search.setStyle("margin-inline-end:0px;margin-top:10px;position:relative;border: 1px solid #184548;width: 80%;border-radius: 13px;margin-bottom: 16px;");
        var searchInput = new (0, $2cf92be5dbbab152$export$574966fbea4a65e5)();
        search.addControl(searchInput);
        searchInput.setStyle("height:40px;text-align: center;");
        var searchPh = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchPh.addControl((0, $02mnx.Localizer).getString("menu_search"));
        searchPh.setStyle("font-style: italic;opacity:0.7;position:absolute;top:12px;left:0px;right:0px;bottom:0px;pointer-events:none;");
        search.addControl(searchPh);
        this.searchInput = searchInput;
        p.addControl(search);
        var searchResults = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        searchResults.addCssClass("addFavoriteModalSuggestList");
        searchResults.setStyle("height:100%;overflow-y:scroll;width:85%;");
        p.addControl(searchResults);
        this.addControl(p);
        this.setVisible(false);
        setTimeout(()=>{
            this.setVisible(true);
            this.reValidateSize();
        }, 50);
        searchInput.bind("click", ()=>{
            searchPh.setVisible(false);
        });
        searchInput.bind("blur", ()=>{
            if (!jQuery("#" + searchInput.clientId).val()) searchPh.setVisible(true);
        });
        searchInput.bind("keydown", (e)=>{
            clearTimeout(this.inputter);
            this.inputter = setTimeout(()=>{
                if (!jQuery("#" + searchInput.clientId).val()) {
                    this.renderCountries(searchResults, this.allCountries);
                    this.renderSelected();
                    return;
                }
                if (e.originalEvent.key == "Enter") {
                    jQuery("#" + searchInput.clientId).blur();
                    return;
                }
                var countries = (0, $6K7Df.CountryUtil).findCountries(this.allCountries, jQuery("#" + searchInput.clientId).val(), AppInstance.getConfig().userLocale);
                console.log("render ", countries);
                this.renderCountries(searchResults, countries);
                this.renderSelected();
            }, 200);
        });
        (0, $kc8Kt.DataProvider).getOtherData("topMarketValuedPlayersCountries.json", (response)=>{
            if (!response || !response.isOk()) {
                console.log("no goodie", response);
                return;
            }
            let regionNames = new Intl.DisplayNames([
                'en'
            ], {
                type: 'region'
            });
            var pushOwnCountry = false;
            if (FootballManiaConfig.userIntlLocale && FootballManiaConfig.userIntlLocale.region) {
                var userCountry = regionNames.of(FootballManiaConfig.userIntlLocale.region);
                var countries = response.getData();
                for(var i = 0; i < countries.length; i++){
                    console.log(countries[i], userCountry);
                    if (countries[i].toLowerCase() == userCountry.toLowerCase()) {
                        pushOwnCountry = true;
                        console.log("adddd");
                        break;
                    }
                }
            }
            var localizedcountries = (0, $6K7Df.CountryUtil).localizeCountries(countries, FootballManiaConfig.userLocale);
            if (pushOwnCountry) {
                var userCountry = (0, $6K7Df.CountryUtil).localizeCountries([
                    userCountry
                ], FootballManiaConfig.userLocale)[0];
                userCountry.isOwnCountry = true;
                localizedcountries.unshift(userCountry);
            }
            this.allCountries = localizedcountries;
            this.updateSelectedFromUrl();
            this.renderCountries(searchResults, localizedcountries);
            this.renderSelected();
        });
    }
    addSelected(country) {
        this.selectedData.push(country);
        this.updateUrl();
        console.log("add selected ", this.selectedData);
        //ugly but changing the url is async and we need to wait for it to be done
        setTimeout(()=>{
            this.getPage().triggerEvent("countrySelected", {
                "selected": this.selectedData
            });
        }, 50);
        console.log("add selected ", this.selectedData);
    }
    removeSelected(country) {
        this.selectedData.splice(this.selectedData.indexOf(country), 1);
        this.updateUrl();
        //ugly but changing the url is async and we need to wait for it to be done
        setTimeout(()=>{
            this.getPage().triggerEvent("countrySelected", {
                "selected": this.selectedData
            });
        }, 50);
    }
    destroy() {
        super.destroy();
        setTimeout(()=>{
            //console.log("u")
            this.updateUrl();
        }, 100);
    }
    updateSelectedFromUrl() {
        var countries = (0, $fRpWP.UrlManager).getModule("filter_countries");
        if (countries) {
            countries = atob(countries);
            countries = countries.split(",");
            this.selectedData = countries;
        }
        this.getPage().triggerEvent("countrySelected", {
            "selected": this.selectedData
        });
    }
    updateUrl() {
        var string = "";
        for(var i = 0; i < this.selectedData.length; i++){
            string += this.selectedData[i];
            if (i < this.selectedData.length - 1) string += ",";
        }
        if (string == "") {
            console.log("remove module");
            (0, $fRpWP.UrlManager).removeModule("filter_countries");
            (0, $fRpWP.UrlManager).updateUrl(true);
            return;
        }
        string = btoa(string);
        var dontAffectHistory = true;
        if (!(0, $fRpWP.UrlManager).getModule("filter_countries")) (0, $fRpWP.UrlManager).registerModule("filter_countries");
        //module,value,dontUpdateUrl,dontAffectHistory
        (0, $fRpWP.UrlManager).setModule("filter_countries", string, false, dontAffectHistory);
    }
    renderSelected() {
        this.selectedCount.clear();
        if (this.selectedData.length) {
            this.selectedCount.addControl((0, $02mnx.Localizer).getString("selected") + " " + this.selectedData.length, true);
            this.resetButton.setVisible(true);
        } else {
            this.selectedCount.addControl((0, $02mnx.Localizer).getString("selected") + " " + this.allCountries.length, true);
            this.resetButton.setVisible(false);
        }
    }
    renderCountries(target, countries) {
        target.clear();
        var selected = this.selectedData;
        console.log('render selected', selected);
        for(var i = 0; i < countries.length; i++){
            var resultP = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            resultP.addCssClass("suggestionsItemTitle");
            countries[i].isOwnCountry;
            var checkbox = new (0, $dcf731dd052ddaa7$export$48513f6b9f8ce62d)();
            if (selected && selected.indexOf(countries[i].name) != -1) {
                console.log("set data true");
                checkbox.setData(true);
            }
            checkbox.countryData = countries[i];
            checkbox.setStyle("margin-inline-end: 10px;");
            resultP.addControl(checkbox);
            var countryFlag = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
            countryFlag.setStyle("width: 24px; height: 24px; margin-inline-end: 10px;");
            countryFlag.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/images/flags/" + countries[i].name.replaceAll(" ", "-").toLowerCase() + ".png");
            resultP.addControl(countryFlag);
            var countryPanel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            countryPanel.setStyle("margin-bottom:3px;width:100%;");
            if (countries[i].isOwnCountry) countryPanel.addControl("<b>" + countries[i].localized + "</b>");
            else countryPanel.addControl(countries[i].localized);
            resultP.addControl(countryPanel);
            target.addControl(resultP);
            ((checkbox, countryPanel)=>{
                checkbox.bind("change", ()=>{
                    console.log("onchange", checkbox.getData(), checkbox.countryData);
                    if (!checkbox.getData()) {
                        this.removeSelected(checkbox.countryData.name);
                        this.renderSelected();
                        return;
                    }
                    this.addSelected(checkbox.countryData.name);
                    this.renderSelected();
                });
                countryPanel.bind("click", ()=>{
                    checkbox.setData(!checkbox.getData());
                    if (!checkbox.getData()) {
                        this.removeSelected(checkbox.countryData.name);
                        this.renderSelected();
                        return;
                    }
                    this.addSelected(checkbox.countryData.name);
                    this.renderSelected();
                });
            })(checkbox, countryPanel);
        }
        target.invalidateDisplay();
    }
    renderSearchResult(data, target) {
        this.renderTeamItem(data, target, (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams()[data.id_gs]);
    }
}


class $8340ce0bbb0259c4$export$43c5b0b95280147b extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init(params) {
        this.pageName = "PlayerMarketValue";
        this.version = 1;
        super.init();
        this.setStyle("height:100%");
        this.pageName = "PlayerMarketValues";
        this.addCssClass("PlayerMarketValuePage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        // setTimeout(() => {
        //     console.log("params",params);
        //     UrlManager.removeModule("spid");
        //     UrlManager.updateUrl(true);
        // }, 1000);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $23ab1716e6aced69$export$bd2148639dcb5f7e)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
        }
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        this.tabview.tabs[0].hideLoader();
        this.topValueListrender.setDataSource(e.data);
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "topValueScrollPosition": this.topValueListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        if (this.filterModal) d.filterModalOpen = 1;
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.topValueLoadHandler);
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) this.autoInterval(0);
        this.previousDocumentHidden = document.hidden;
    //console.log("visibility change ",document.hidden,this);
    }
    createPageLayout() {
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().showTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.topValueListrender) this.topValueListrender.onWindowResize();
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        console.log("run app");
        this.showLoader();
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", this.getProxy(function() {
                    this.runApp();
                }));
            }
            (0, $kc8Kt.DataProvider).getPlayerMarketValueRanking(this.getProxy(function(response) {
                this.hideLoader();
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                        this.runApp();
                    }));
                    else return this.showError("", this.getProxy(function() {
                        this.runApp();
                    }));
                }
                var data = response.getData();
                console.log("data", data);
                this.createTitle(data);
                this.createTabs(data);
                this.getPageTemplate().createMenuPlayerMarketValues(response.getData());
                this.tabview.bind("tabChanged", this.getProxy(function() {
                    this.storeState();
                    this.coordinatoranimator.tabChange();
                }));
                var storeHandler = null;
                this.topValueListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 200);
                    (0, $fRpWP.UrlManager).removeModule("spid");
                    (0, $fRpWP.UrlManager).updateUrl(true);
                }));
                this.bind("onModalOpen", (e, modal)=>{
                    console.log(modal.urlIdentifier);
                    this.filterModal = null;
                    if (modal.urlIdentifier == "countryfilter") {
                        this.filterModal = modal;
                        this.getPageTemplate().hideStickBannerAd();
                        this.preventStickBannerAdOnce = true;
                        this.storeState();
                    }
                });
                this.bind("onModalClose", ()=>{
                    this.filterModal = null;
                    this.getPageTemplate().loadStickyBannerAd();
                    this.storeState();
                });
                this.bind("countrySelected", (e, selected)=>{
                    console.log("countries filter selected", selected, this.lastLoadedData);
                    this.selectedFilterData = selected;
                    if (this.lastLoadedData) this.processMarketValueData(this.lastLoadedData);
                //this.filterDataSource(selected);
                });
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                console.log("previousState", previousState);
                if (previousState) {
                    this.tabview.currentActiveTab = previousState.tabIndex;
                    this.topValueListrender.scrollTo(previousState.topValueScrollPosition || 0);
                    this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                    console.log("previousState.filterModalOpen", previousState.filterModalOpen);
                    if (previousState.filterModalOpen) setTimeout(()=>{
                        var urlIdentifier = "countryfilter";
                        var modal = new (0, $9d7769ca17983c73$export$ab2a68d00457bd5a)(urlIdentifier);
                        this.addControl(modal, true);
                    });
                }
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.prepare();
                this.lastLoadedData = data;
                this.processMarketValueData(data);
            }), false);
        }));
        this.bind("filterClicked", ()=>{
            var urlIdentifier = "countryfilter";
            var modal = new (0, $9d7769ca17983c73$export$ab2a68d00457bd5a)(urlIdentifier);
            this.addControl(modal, true);
            this.getPageTemplate().hideStickBannerAd();
        });
    }
    createTitle(data) {
        this.getPageTemplate().topTitleContainer.setVisible(false);
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab1.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab1.title = (0, $02mnx.Localizer).getString("player_market_values");
        tabs.push(tab1);
        this.createTopValueControls(tab1, 0);
        this.coordinatoranimator.addScrollerContainer(tab1);
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", this.getProxy(function() {
            this.coordinatoranimator.run();
        }));
        this.tabview = tabview;
        tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            if (this.preventStickBannerAdOnce) {
                this.preventStickBannerAdOnce = false;
                this.hideStickBannerAd();
                return;
            }
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.bind("stickyBannerHide", ()=>{
            console.error("sticky banner hide -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createTopValueControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = tab;
        listRender.enableFastScroll = true;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $2e49a60e68d7e121$export$5081865e84e17f53)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.fixturesScrollPosition || 0);
        container.addControl(listRender);
        this.topValueListrender = listRender;
        tab.addControl(container);
    }
    processMarketValueData(data, ignoreCache) {
        var selectedFilterData = null;
        var countries = (0, $fRpWP.UrlManager).getModule("filter_countries");
        if (countries) {
            countries = atob(countries);
            countries = countries.split(",");
            selectedFilterData = countries;
        }
        var selectedPlayer = (0, $fRpWP.UrlManager).getModule("spid");
        if (!data) return this.autoInterval();
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        if (!FootballManiaConfig.useWebWorkers) {
            var list = (0, $gQQqD.Processors).preparePlayerMarketValuesData(data, selectedFilterData, selectedPlayer);
            var data = {
                data: list
            };
            this.onWorkerMessageReceived(data);
        } else AppInstance.workerHelper1.postMessage({
            methodType: 11,
            filterData: selectedFilterData,
            data: data
        });
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
    }
    autoInterval(overrideInterval) {
        clearTimeout(this.topValueLoadHandler);
        this.topValueLoadHandler = setTimeout(this.getProxy(function() {
            if (document.hidden) {
                console.warn("no auto refresh because page is hidden");
                return;
            }
            (0, $kc8Kt.DataProvider).getPlayerMarketValueRanking(this.getProxy(function(response) {
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.autoInterval();
                    return;
                }
                //todo error screen
                this.processMarketValueData(response.getData());
            }));
        }), overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.ranking);
    }
}








var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $gQQqD = parcelRequire("gQQqD");

var $dNeVp = parcelRequire("dNeVp");







var $kc8Kt = parcelRequire("kc8Kt");




class $f0f9bd023085811a$export$b18dd2400b8f82c extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "FifaRanking";
        this.version = 1;
        super.init();
        this.addCssClass("FifaRankingPage");
        this.listRenders = [];
        this.workers = [];
        this.allowableAutoRefreshDates = [];
        this.autoRefreshTimeoutHandlers = [];
        //here we know if we come from the same page or another.
        //if we navigate from back history or refresh we are not from the outside.
        //if we navigate to this page from another and the referaldata is passed in the url params
        //then we are from the outside.
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) {
            (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
            this.requestedDateToShow = (0, $fRpWP.UrlManager).getModule("date");
        }
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.createPageLayout();
        this.coordinatoranimator = new (0, $3a49f5885469e8cf$export$af2d04701265f81a)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
            this.wrapper2 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper2.addEventListener("message", this.wrapper2);
            this.wrapper3 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper3.addEventListener("message", this.wrapper3);
        }
    }
    findListRenderById(id) {
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            if (this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0].getId() == id) return this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0];
        } catch (e) {}
    }
    findIndexForRenderById(id) {
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            if (!this.tabview.tabContents.controls[i].controls[1]) continue;
            if (this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0].getId() == id) return i;
        } catch (e) {}
        return -1;
    }
    onWorkerMessageReceived(e) {
        console.log("receive message", e.data[0]);
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var listRender = this.findListRenderById(e.data[0]);
        if (!listRender) {
            console.error("no listrender found for ", e.data[0]);
            return;
        }
        listRender.parent.parent.hideLoader();
        listRender.setDataSource(e.data[1]);
    }
    storeState() {
        var activeScrollPosition = 0;
        if (this.visibleListRender) activeScrollPosition = this.visibleListRender.getScroll();
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "activeScrollPosition": activeScrollPosition,
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        console.log("store state", d);
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        //alert("unload")
        this.stopAutoRefreshes();
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        for(var key in this.autoRefreshTimeoutHandlers)clearTimeout(this.autoRefreshTimeoutHandlers[key]);
        this.autoRefreshTimeoutHandlers = null;
        this.getPageTemplate().topTitleContainer.clear();
        (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).unbind("showOnlyFavoritesAgendaChanged");
        if (AppInstance.workersInitialized) {
            AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
            AppInstance.workerHelper2.removeEventListener("message", this.wrapper2);
            AppInstance.workerHelper3.removeEventListener("message", this.wrapper3);
        }
    }
    createPageLayout() {
        var row1 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row1);
        this.contentContainer = row1;
    }
    createComponents() {
        this.getPageTemplate().createMenuFifaRanking();
        //this.getPageTemplate().hideTitle();
        this.getPageTemplate().showTitle();
        this.createTitle();
    }
    createTitle() {
        var image = new (0, $df64cf20c6ea21bc$export$3e431a229df88919)();
        image.setStyle("width:22px;");
        // image.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/flags/ranking.png");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.titleControl = title;
        //this.getPageTemplate().topTitleContainer.addControl(image);
        this.getPageTemplate().topTitleContainer.addControl(title);
        this.getPageTemplate().topTitleContainer.invalidateDisplay();
    //this.getPageTemplate().topTitleContainer.setVisible(false);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) {
            this.stopAutoRefreshes();
            this.startAutoRefreshes(); //note that this will not instantly load new data. but that doesnt matter for this page
        }
        this.previousDocumentHidden = document.hidden;
        if (document.hidden) this.stopAutoRefreshes();
    }
    onWindowResize() {
        if (!this.i) this.i = 1;
        //this.getPageTemplate().topBar.addControl(this.i,true);
        console.log("onwindow resize");
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
    //TODO onwindow resize for active listrenders???
    }
    onOffline() {
        console.log("on offline");
    }
    onOnline() {
        console.log("on online");
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        console.log("run app");
        this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            console.log("setup complete");
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", this.getProxy(function() {
                    this.runApp();
                }));
            }
            this.titleControl.clear();
            this.titleControl.addControl((0, $02mnx.Localizer).getString("world_ranking_list"), true);
            this.hideLoader();
            this.createTabs();
            this.tabview.bind("tabChanged", this.getProxy(function() {
                console.log("tab changed  activetab", this.tabview.currentActiveTab, "active element", this.tabview.elementIndex);
                this.storeState();
                this.coordinatoranimator.tabChange();
            }));
            this.tabview.currentActiveTab = FootballManiaConfig.isRtl ? this.tabview.tabs.length - 1 : 0;
            var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
            if (previousState) {
                this.tabview.currentActiveTab = previousState.tabIndex;
                this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
            }
            this.contentContainer.invalidateDisplay();
            this.coordinatoranimator.prepare();
            this.coordinatoranimator.onCollapseChanged = this.getProxy(function() {
                console.log("oncollapserchanged");
                this.storeState();
            });
        }));
    }
    createTabs() {
        var tabview = new (0, $13d02572b444e49f$export$56b391fe9ebdd0ae)();
        this.tabview = tabview;
        this.tabview.maxVisibleTabs = 5;
        this.contentContainer.addControl(tabview);
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        var d = new Date();
        d.setMinutes(0);
        d.setHours(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        this.allowableAutoRefreshDates.push(new Date().getFullYear());
        var totalItems = 13;
        //var totalItems = 10;
        var startTC = d.getTime();
        var dot = new Date();
        dot.setTime(startTC);
        var tabTitles = [];
        var dateIndixes = [];
        var dataFeedExtendedVersion = []; //for far future or past data feeds we use different source
        for(var i = 0; i < totalItems; i++){
            var day = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
                year: 'numeric'
            }).format(dot);
            var dateIntl = Intl.DateTimeFormat('en-UK', {
                year: 'numeric'
            }).format(dot);
            dateIndixes.push(dateIntl);
            var tab1 = {};
            tab1.title = day;
            //when page is from outsided we use this property
            if (dateIntl == this.requestedDateToShow) {
                tab1.initialSelected = true;
                tabview.currentActiveTab = i;
                this.storeState();
            }
            tabTitles.push(tab1);
            dot.setFullYear(dot.getFullYear() - 1);
        }
        var storeHandler;
        var listRenderScrollMethod = this.getProxy(function() {
            clearTimeout(storeHandler);
            storeHandler = setTimeout(this.getProxy(function() {
                this.storeState();
            }), 500);
        });
        //called when tab content is changed
        tabview.bind("newContentTabVisible", this.getProxy(function(e, tabContentElement) {
            if (this.visibleListRender) this.visibleListRender.unbind("scroll", listRenderScrollMethod);
            this.visibleListRender = tabContentElement.controls[1].controls[0].controls[0].controls[0];
            console.log("new content tab visible", this.visibleListRender.date);
            this.coordinatoranimator.setActiveScrollContainer(tabContentElement.controls[1].controls[0]);
            this.visibleListRender.bind("scroll", listRenderScrollMethod);
            this.stopAutoRefreshes();
            this.startAutoRefreshes();
            this.coordinatoranimator.run();
        }));
        //called everytime when tabview wants to get content for a tab
        //date contains element index and data index.
        //usually when 3 tabs are rendered element index goes from 0,1,2
        //where 1 is the center one. data index depends on the tab titles
        tabview.bind("requestTabContent", this.getProxy(function(e, data) {
            data.target.clear();
            //out of bounds when most left tab or most right tab is selected
            if (data.dataIndex < 0 || data.dataIndex > dateIndixes.length - 1) return;
            console.log("request content", data, "index", data.elementIndex, "old index", data.oldIndex);
            var tabContent = new (0, $13d02572b444e49f$export$fc15fc13677f3f7d)();
            tabContent.addCssClass("tabviewTabContent");
            tabContent.addCssClass("noscrollbar");
            data.target.addControl(tabContent);
            var listRender = this.createYear(tabContent, data.elementIndex);
            listRender.date = dateIndixes[data.dataIndex];
            if (data.dataIndex == tabview.currentActiveTab) ((listRender, data)=>{
                setTimeout(()=>{
                    this.loadYear(dateIndixes[data.dataIndex], listRender, dataFeedExtendedVersion[data.dataIndex]);
                    var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                    if (previousState) listRender.scrollTo(previousState.activeScrollPosition || 0);
                }, 50);
            })(listRender, data);
            else this.getProxy(function(listRender, data) {
                setTimeout(this.getProxy(function() {
                    this.loadYear(dateIndixes[data.dataIndex], listRender, dataFeedExtendedVersion[data.dataIndex]);
                }), 200);
            })(listRender, data);
            data.target.invalidateDisplay();
        }));
        if (FootballManiaConfig.isRtl) tabTitles.reverse();
        tabview.setTabTitles(tabTitles);
        tabview.bind("onReady", this.getProxy(function() {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.contentContainer.addCssClass("fadeIn").setStyle("margin-top:0;");
            this.coordinatoranimator.run();
        }));
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) this.coordinatoranimator.setScrollerBottomMargin(0);
            this.coordinatoranimator.recalculateTab(1);
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px", this.tabview.currentActiveTab);
            if (tab1) {
                this.coordinatoranimator.setScrollerBottomMargin(50);
                this.coordinatoranimator.recalculateTab(1);
            }
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createYear(tab, elementIndex) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = tab;
        listRender.enableFastScroll = true;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $ae10f9e8e1dd758b$export$4a590bcb9bb280eb)()
            };
        });
        listRender.emptyTemplate = function() {
            var empty = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            empty.addCssClass("listViewEmptyData");
            var attention = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
            attention.addCssClass("icon-attention");
            attention.setStyle("width:60px;height:60px;");
            empty.addControl(attention);
            empty.addControl((0, $02mnx.Localizer).getString("no_data"));
            return empty;
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(this.findIndexForRenderById(listRender.getId()));
        }));
        listRender.setPlaceHolderWidth("100%;");
        container.addControl(listRender);
        tab.addControl(container);
        return listRender;
    }
    loadYear(date, listRenderTarget, extendedDataFeed, allowAutoRefresh, ignoreCache, dontShowLoader, isFromAutoRefresh) {
        //when page is already loaded then we dont load when page is hidden. but not first time, because it can happen that interstitial hides the screen first time
        if (this["firstTimeLoading" + date] && document.hidden) return this.autoRefresh(listRenderTarget);
        this["firstTimeLoading" + date] = true;
        (0, $dNeVp.ManiaCache).getMemoryCache("rankings" + date);
        if (!dontShowLoader) listRenderTarget.parent.parent.showLoader();
        listRenderTarget.date = date;
        (0, $kc8Kt.DataProvider).getRanking(date, this.getProxy(function(response) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!response.isOk()) {
                listRenderTarget.parent.parent.hideLoader();
                if (isFromAutoRefresh) return;
                var str = (0, $02mnx.Localizer).getString("nointernet") + "<br>" + (0, $02mnx.Localizer).getString("taptotryagain");
                listRenderTarget.showError(str, this.getProxy(function() {
                    this.loadYear(date, listRenderTarget, allowAutoRefresh, true);
                }));
                return;
            }
            listRenderTarget.loadedDatasource = response.getData();
            if (!FootballManiaConfig.useWebWorkers) {
                var listData = (0, $gQQqD.Processors).prepareRankingData(response.getData(), AppInstance.getConfig().fixedRegions, AppInstance.getConfig().fixedLeaguesOrder, (0, $02mnx.Localizer).getLoadedLocale(), (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(), (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(), FootballManiaConfig.hideCountryTitleFor, AppInstance.getLocale(), (0, $02mnx.Localizer).DefaultTranslations, (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(), (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(), (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(), (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches());
                var data = {
                    data: [
                        listRenderTarget.getId(),
                        listData
                    ]
                };
                this.onWorkerMessageReceived(data);
            } else {
                //some round robin logic to get one of the X workers.
                if (this.usedWorker == undefined) this.usedWorker = 0;
                else if (this.usedWorker >= this.workers.length - 1) this.usedWorker = 0;
                else this.usedWorker += 1;
                AppInstance.getWorker(this.usedWorker).postMessage({
                    methodType: 7,
                    data: response.getData(),
                    fixedRegions: AppInstance.getConfig().fixedRegions,
                    fixedLeagueOrder: AppInstance.getConfig().fixedLeaguesOrder,
                    favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
                    favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
                    translations: (0, $02mnx.Localizer).getLoadedLocale(),
                    locale: AppInstance.getLocale(),
                    hiddenTitles: FootballManiaConfig.hideCountryTitleFor,
                    listRenderId: listRenderTarget.getId(),
                    showOnlyFavorites: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(),
                    subscribedTeams: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(),
                    subscribedLeagues: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(),
                    subscribedMatches: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches()
                });
            }
            if (allowAutoRefresh && this.findListRenderById(listRenderTarget.getId())) this.autoRefresh(listRenderTarget);
        }), ignoreCache);
    }
    autoRefresh(listRender, overrideInterval) {
        if (this.unloaded) return console.warn("no auto refresh because page is unloaded");
        if (!listRender || !listRender.date) {
            console.error("no listrender or date", listRender);
            return;
        }
        clearTimeout(this.autoRefreshTimeoutHandlers[listRender.date]);
        this.autoRefreshTimeoutHandlers[listRender.date] = setTimeout(this.getProxy(function() {
            if (document.hidden) {
                console.warn("no auto refresh because page is hidden");
                return;
            }
            console.log("auto refresh now", listRender.date);
            this.loadYear(listRender.date, listRender, true, true, true, true);
        }), overrideInterval != null ? overrideInterval : AppInstance.getConfig().refreshIntervals.ranking);
    }
    stopAutoRefreshes() {
        for(var i = 0; i < this.autoRefreshTimeoutHandlers.length; i++)clearTimeout(this.autoRefreshTimeoutHandlers[this.autoRefreshTimeoutHandlers[i]]);
        this.autoRefreshTimeoutHandlers = [];
    }
    startAutoRefreshes(listRender) {
        this.stopAutoRefreshes();
        console.log("start auto refreshes");
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            //ugly way of finding active listrender
            var listRender = this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0];
            var allowRefresh = this.allowableAutoRefreshDates.indexOf(Number.parseInt(listRender.date)) != -1 ? true : false;
            console.log("loop listrender", this.allowableAutoRefreshDates.indexOf(2023), this.allowableAutoRefreshDates, listRender.date, allowRefresh);
            if (allowRefresh) {
                console.log("allow auto refresh");
                this.autoRefresh(listRender);
            }
            console.log(listRender, listRender.date);
        } catch (e) {
            console.error("error reloading listrender. are you at beginning or end. or some other error ", e);
        }
    }
    /**
     * call this when you want to set datasource in listrender again
     * for example after you enabled filter. worker is using filter data
     */ reApplyDataSourceInListRenders() {
        console.log("reapply datasource in listrender");
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            if (this.usedWorker == undefined) this.usedWorker = 0;
            else if (this.usedWorker >= this.workers.length - 1) this.usedWorker = 0;
            else this.usedWorker += 1;
            //ugly way of finding active listrender
            var listRender = this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].controls[0];
            listRender.scrollTo(0);
            AppInstance.getWorker(this.usedWorker).postMessage({
                methodType: 7,
                data: listRender.loadedDatasource,
                fixedRegions: AppInstance.getConfig().fixedRegions,
                fixedLeagueOrder: AppInstance.getConfig().fixedLeaguesOrder,
                favoriteLeagues: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteLeagues(),
                favoriteTeams: (0, $aabc673d1ba8b527$export$db78e401119da622).getFavoriteTeams(),
                translations: (0, $02mnx.Localizer).getLoadedLocale(),
                locale: AppInstance.getLocale(),
                defaultLocale: (0, $02mnx.Localizer).DefaultTranslations,
                hiddenTitles: FootballManiaConfig.hideCountryTitleFor,
                listRenderId: listRender.getId(),
                showOnlyFavorites: (0, $893ad9ebb6e0883d$export$61165f5ad0de9ff6).getShowOnlyFavoritesAgenda(),
                subscribedTeams: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedTeams(),
                subscribedLeagues: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedLeagues(),
                subscribedMatches: (0, $542851713e8a5d10$export$60959659b2c22881).getSubscribedMatches()
            });
        } catch (e) {
            console.error("error reapplying datasource in listrender ", e);
        }
    }
}





var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $gQQqD = parcelRequire("gQQqD");


var $kc8Kt = parcelRequire("kc8Kt");





class $68dd5f8d12bc8ab4$export$b7d170e1c2775e6e extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "ChatIndex";
        this.version = 1;
        super.init();
        this.setStyle("height:100%");
        this.pageName = "Chat_" + (0, $fRpWP.UrlManager).getModule("lid");
        this.addCssClass("ChatPage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $23ab1716e6aced69$export$bd2148639dcb5f7e)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
        }
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        this.tabview.tabs[0].hideLoader();
        this.forumIndexListrender.setDataSource(e.data);
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "topValueScrollPosition": this.forumIndexListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.topValueLoadHandler);
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) this.autoInterval(0);
        this.previousDocumentHidden = document.hidden;
    //console.log("visibility change ",document.hidden,this);
    }
    createPageLayout() {
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().showTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.forumIndexListrender) this.forumIndexListrender.onWindowResize();
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        console.log("run app");
        this.showLoader();
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", this.getProxy(function() {
                    this.runApp();
                }));
            }
            (0, $kc8Kt.DataProvider).getForumIndex(this.getProxy(function(response) {
                console.log("get forum index ", response.getData());
                this.hideLoader();
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    if (response.getStatus() == 404) return this.showPageDataDoesNotExist("", this.getProxy(function() {
                        this.runApp();
                    }));
                    else return this.showError("", this.getProxy(function() {
                        this.runApp();
                    }));
                }
                var data = response.getData();
                console.log("data", data);
                this.createTitle(data);
                this.createTabs(data);
                this.getPageTemplate().createMenuForumIndex(response.getData());
                this.tabview.bind("tabChanged", this.getProxy(function() {
                    this.storeState();
                    this.coordinatoranimator.tabChange();
                }));
                var storeHandler = null;
                var storeHandler2 = null;
                var storeHandler3 = null;
                this.forumIndexListrender.bind("scroll", this.getProxy(function(e, scroll) {
                    clearTimeout(storeHandler);
                    storeHandler = setTimeout(this.getProxy(function() {
                        this.storeState();
                    }), 200);
                }));
                var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
                if (previousState) {
                    this.tabview.currentActiveTab = previousState.tabIndex;
                    this.forumIndexListrender.scrollTo(previousState.topValueScrollPosition || 0);
                    this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                }
                this.contentContainer.invalidateDisplay();
                this.coordinatoranimator.prepare();
                this.processForumIndexData(data);
            }), false);
        }));
    }
    createTitle(data) {
        this.getPageTemplate().topTitleContainer.setVisible(false);
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        var tab2;
        var tab3;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab1.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab1.title = (0, $02mnx.Localizer).getString("forum");
        tabs.push(tab1);
        this.createForumIndexControls(tab1, 0);
        this.coordinatoranimator.addScrollerContainer(tab1);
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", this.getProxy(function() {
            this.coordinatoranimator.run();
        }));
        this.tabview = tabview;
        tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createForumIndexControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $07ee7f8611ef3055$export$9195dbe354ce2bc9)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $07ee7f8611ef3055$export$1ffd76da79c62f76)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new NoDataMessage({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.fixturesScrollPosition || 0);
        container.addControl(listRender);
        this.forumIndexListrender = listRender;
        tab.addControl(container);
    }
    processForumIndexData(data, ignoreCache) {
        if (!data) return this.autoInterval();
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        if (!FootballManiaConfig.useWebWorkers) {
            var list = (0, $gQQqD.Processors).prepareForumIndexData(data);
            var data = {
                data: list
            };
            this.onWorkerMessageReceived(data);
        } else AppInstance.workerHelper1.postMessage({
            methodType: 12,
            data: data
        });
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
    }
    autoInterval(overrideInterval) {
        console.log("autoInterval not implemented", overrideInterval);
    }
}





var $fRpWP = parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");








class $820af1231e5bf861$export$95db43ce2cc121cc extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "ForumChat";
        this.version = 1;
        super.init();
        (0, $0dbc6ded793568e1$export$1a7533566a41982d).init();
        this.setStyle("height:100%");
        this.pageName = "ForumChat";
        this.addCssClass("ForumChat");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $23ab1716e6aced69$export$bd2148639dcb5f7e)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
        }
        window.addEventListener("message", this.onWebviewMessagePosted);
    }
    onWebviewMessagePosted(e) {
        console.log("on webview message posted", e);
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
    //this.tabview.tabs[0].hideLoader();
    //this.chatListrender.setDataSource(e.data);
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "topValueScrollPosition": this.chatListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.topValueLoadHandler);
        clearTimeout(this.menuSlideInTimeouthandler);
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    //window.removeEventListener("message",this.onWebviewMessagePosted);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        this.previousDocumentHidden = !document.hidden;
        this.previousDocumentHidden = document.hidden;
    //console.log("visibility change ",document.hidden,this);
    }
    createPageLayout() {
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().showTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.chatListrender) this.chatListrender.onWindowResize();
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        console.log("run app");
        this.showLoader();
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup((result)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", ()=>{
                    this.runApp();
                });
            }
            this.hideLoader();
            this.createTitle();
            this.createTabs();
            this.getPageTemplate().createMenuForumChat();
            this.tabview.bind("tabChanged", ()=>{
                this.storeState();
                this.coordinatoranimator.tabChange();
            });
            var storeHandler = null;
            this.chatListrender.bind("scroll", (e, scroll)=>{
                clearTimeout(storeHandler);
                clearTimeout(this.menuSlideInTimeouthandler);
                if (this.chatMenuPopup) {
                    this.chatMenuPopup.slideOut();
                    for(var i = 0; i < this.chatListrender.indexRenderedItemRenderMap.length; i++)this.chatListrender.indexRenderedItemRenderMap[i].unblur();
                    this.inBlurMode = false;
                }
                storeHandler = setTimeout(()=>{
                    this.storeState();
                }, 200);
            });
            var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
            if (previousState) {
                this.tabview.currentActiveTab = previousState.tabIndex;
                this.chatListrender.scrollTo(previousState.topValueScrollPosition || 0);
                this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
            }
            this.contentContainer.invalidateDisplay();
            this.coordinatoranimator.prepare();
            this.initChat();
        });
    }
    createTitle(data) {
        this.getPageTemplate().topTitleContainer.setVisible(false);
    }
    createTabs(data) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        var tab2;
        var tab3;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        //        tab1.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab1.title = (0, $02mnx.Localizer).getString(decodeURI((0, $fRpWP.UrlManager).getModule("title")));
        tabs.push(tab1);
        var con = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        con.setStyle("width: 100%;position:absolute;");
        var bottom = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        bottom.addCssClass("tableFooter");
        var input = new (0, $51908c82e41b0e01$export$10e6f4f66014ee2d)();
        input.addCssClass("ChatInput");
        input.setData((0, $02mnx.Localizer).getString("chattypehint"));
        this.chatMenuPopup = new (0, $b327ff81cc3a41d8$export$1457961a45169cfb)();
        this.chatMenuPopup.isAdmin = true;
        this.chatMenuPopup.bind("thumbup", ()=>{
            console.log(this.selectedChatData);
            if (!this.selectedChatData) {
                console.error("no selected chat data");
                return;
            }
            this.chatListrender.rateMessage(this.selectedChatData, 1);
        });
        this.chatMenuPopup.bind("thumbdown", ()=>{
            console.log(this.selectedChatData);
            if (!this.selectedChatData) {
                console.error("no selected chat data");
                return;
            }
            this.chatListrender.rateMessage(this.selectedChatData, -1);
        });
        this.chatMenuPopup.bind("requestAdminMenu", ()=>{
            console.log(this.selectedChatData);
            if (!this.selectedChatData) {
                console.error("no selected chat data");
                return;
            }
            var adminPanel = new (0, $b327ff81cc3a41d8$export$1b1752f8539f7991)();
            adminPanel.setData(this.selectedChatData);
            this.adminPanel = adminPanel;
            this.getPage().addControl(adminPanel, true);
            clearTimeout(this.menuSlideInTimeouthandler);
            this.getPage().bind("onModalClose", ()=>{
                this.chatMenuPopup.slideOut();
                for(var i = 0; i < this.chatListrender.indexRenderedItemRenderMap.length; i++)this.chatListrender.indexRenderedItemRenderMap[i].unblur();
                this.inBlurMode = false;
            });
            adminPanel.bind("removeMessage", ()=>{
                this.chatListrender.adminRemoveMessage(this.selectedChatData);
            });
            adminPanel.bind("banUser1day", ()=>{
                this.chatListrender.adminBanUser(this.selectedChatData, 1);
            });
            adminPanel.bind("banUser7days", ()=>{
                this.chatListrender.adminBanUser(this.selectedChatData, 7);
            });
            adminPanel.bind("banUser365days", ()=>{
                this.chatListrender.adminBanUser(this.selectedChatData, 365);
            });
            adminPanel.bind("unbanuser", ()=>{
                this.chatListrender.adminUnbanUser(this.selectedChatData, 365);
            });
        });
        bottom.addControl(this.chatMenuPopup);
        bottom.addControl(input);
        bottom.setVisible(false);
        var arrow = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        arrow.addCssClass("arrow-right");
        bottom.addControl(arrow);
        var scroller = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        scroller.addCssClass("scroller");
        con.addControl(scroller);
        con.addControl(bottom);
        //tab2.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab1.addControl(con);
        //tab2.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        this.coordinatoranimator.addScrollerContainer(scroller);
        var heightFooter = 0;
        heightFooter += 50;
        ///set fixed height of scroller container table items.
        //this is needed because bottom description container is dynamic in height
        bottom.setStyle("height:" + heightFooter + "px;bottom:inherit;display: flex;    flex-direction: row;align-items: center;justify-content: flex-start;");
        var offset = 50;
        scroller.setStyle("width:100%;height:calc(100% - " + offset + "px);position:relative;overflow-y: scroll;transform: translate(0,0);");
        this.createChatControls(scroller, 0);
        //this.coordinatoranimator.addScrollerContainer(tab1);
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", ()=>{
            this.coordinatoranimator.run();
        });
        this.tabview = tabview;
        this.bottomInputContainer = bottom;
        this.bottomInput = input;
        this.bottomArrow = arrow;
        tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            //if (tab1) tab1.setCss({'height': 'calc(100% - 50px)'});
            //scroller.setStyle("width:100%;height:calc(100% - 150px);position:relative;overflow-y: scroll;transform: translate(0,0);");
            scroller.setCss({
                "height": "calc(100% - " + (offset + 50) + "px)"
            });
            bottom.setCss({
                "bottom": "50px"
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createChatControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $52274ddb13c5ef93$export$7d9d7c166fa1026a)();
        listRender.chatIndex = (0, $fRpWP.UrlManager).getModule("index");
        listRender.containerTarget = tab;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $07ee7f8611ef3055$export$bce6b4f752d51f16)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$5006bd6e14e3bbef)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_chat_messages")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind("click", (data)=>{
            console.log("click");
            this.chatMenuPopup.slideOut();
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
            this.inBlurMode = false;
        });
        listRender.bind('createdList', ()=>{
            this.coordinatoranimator.recalculateTab(index);
        });
        listRender.bind("authentication_start", (data)=>{
            this.getPageTemplate().hideStickBannerAd();
        });
        listRender.bind("authentication_end", (data)=>{
            this.getPageTemplate().loadStickyBannerAd();
        });
        listRender.bind('refresh_chat', ()=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.tabview.tabs[0].hideLoader();
            this.bottomInputContainer.setVisible(true);
        });
        listRender.bind("accepted", ()=>{
            console.log("accepted");
            this.acceptInteraction();
        });
        listRender.bind("incoming_message", (data)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            clearTimeout(this.menuSlideInTimeouthandler);
            this.chatMenuPopup.slideOut();
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
        });
        listRender.bind("voteFailed", (data)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            clearTimeout(this.menuSlideInTimeouthandler);
            this.chatMenuPopup.slideOut();
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
        });
        listRender.bind("authentication_error", (data)=>{
            this.getPageTemplate().createMenuForumChat(); //in case we auto logout
        });
        listRender.bind("adminActionFailed", (data)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            clearTimeout(this.menuSlideInTimeouthandler);
            this.chatMenuPopup.slideOut();
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
            if (this.adminPanel) this.adminPanel.destroy();
        });
        listRender.bind("itemClick", (e, data)=>{
            console.log("itemClick");
            if (!this.chatMenuPopup.isAdmin && data.removed == 1) {
                console.log("message removed");
                return;
            }
            if (this.inBlurMode) {
                clearTimeout(this.menuSlideInTimeouthandler);
                this.chatMenuPopup.slideOut();
                console.log("slideout");
                for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
                this.inBlurMode = false;
                return;
            } else this.chatMenuPopup.enableVote(data.userVote != 1 && data.userVote != -1);
            console.log("slidein");
            this.chatMenuPopup.slideIn();
            clearTimeout(this.menuSlideInTimeouthandler);
            this.menuSlideInTimeouthandler = setTimeout(()=>{
                console.log("timeout for slideout");
                this.chatMenuPopup.slideOut();
                this.inBlurMode = false;
                for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)listRender.indexRenderedItemRenderMap[i].unblur();
                this.selectedChatData = null;
            }, 5000);
            for(var i = 0; i < listRender.indexRenderedItemRenderMap.length; i++)if (!this.inBlurMode && listRender.indexRenderedItemRenderMap[i].data != data) {
                listRender.indexRenderedItemRenderMap[i].blur();
                this.selectedChatData = data;
            } else listRender.indexRenderedItemRenderMap[i].unblur();
            this.inBlurMode = !this.inBlurMode;
        });
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.fixturesScrollPosition || 0);
        container.addControl(listRender);
        this.chatListrender = listRender;
        tab.addControl(container);
    }
    acceptInteraction(data) {
        var message = "";
        // this.bottomArrow.unbind('click');
        // this.bottomInput.unbind('click');
        // this.bottomInput.unbind('keyup');
        this.bottomInput.bind('click', ()=>{
            this.bottomInput.setData("");
        });
        this.bottomArrow.bind('click', ()=>{
            this.chatListrender.addMessage(this.bottomInput.getData());
            this.bottomInput.setData("");
        });
        this.bottomInput.bind('keyup', (e)=>{
            if (e.keyCode == 13) {
                this.chatListrender.addMessage(this.bottomInput.getData());
                this.bottomInput.setData("");
            } else {
                message = this.bottomInput.getData();
                console.log("the current message = " + message);
            }
        });
    }
    initChat(data, ignoreCache) {}
}



parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $gQQqD = parcelRequire("gQQqD");



var $kc8Kt = parcelRequire("kc8Kt");











var $02mnx = parcelRequire("02mnx");

parcelRequire("6K7Df");

var $kc8Kt = parcelRequire("kc8Kt");






var $gQQqD = parcelRequire("gQQqD");
class $45704ea9e1f2be17$export$845f649722154d7a extends (0, $b27fd2646652aa84$export$2b77a92f1a5ad772) {
    init(urlIdentifier) {
        super.init(urlIdentifier);
    }
    createComponents() {
        super.createComponents();
        var nameContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        nameContainer.setStyle("font-size:15px;height:30px;font-variant: small-caps;");
        this.addControl(nameContainer);
        var titleBarContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        titleBarContainer.setStyle("vertical-align: baseline;;display:flex;align-items: centerwidth:100%;height:80px;");
        this.addControl(titleBarContainer);
        var titleBarHitScore = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        titleBarHitScore.addCssClass("RatingGood");
        titleBarHitScore.setStyle("width:100%;display: flex;align-items: center;justify-content: center");
        titleBarContainer.addControl(titleBarHitScore);
        var userImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        userImage.setStyle("width:70px;height:70px;");
        userImage.image.setStyle("border-radius: 40px;overflow: hidden;");
        titleBarContainer.addControl(userImage);
        var titleBarMissScore = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        titleBarMissScore.addCssClass("RatingBad");
        titleBarMissScore.setStyle("width:100%;display: flex;align-items: center;justify-content: center");
        titleBarContainer.addControl(titleBarMissScore);
        var scrollContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        scrollContainer.setStyle("margin:5px;height:100%;position:relative;overflow-y: scroll;overflow-x:hidden;transform: translate(0,0);");
        this.scrollContainer = scrollContainer;
        var p = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //p.setStyle("height:"+(dim.height-50)+"px;justify-content: flex-start;");
        p.addCssClass("flexVerticalAlign");
        scrollContainer.addControl(p);
        this.addControl(scrollContainer);
        this.titleBarContainer = titleBarContainer;
        this.titleBarHitScore = titleBarHitScore;
        this.titleBarMissScore = titleBarMissScore;
        this.userImage = userImage;
        this.nameContainer = nameContainer;
        this.createList(p);
        this.loadUserVotes();
    }
    loadUserVotes() {
        console.log("load user votes", this.urlIdentifier);
        var id = this.urlIdentifier.split("_")[1];
        (0, $kc8Kt.DataProvider).getTopVoterUser(id, (response)=>{
            console.log("get topvoter user", response.getData());
            var data = (0, $gQQqD.Processors).prepareUserVotesData(response.getData());
            console.log("===>", data);
            if (data.hits) {
                this.titleBarHitScore.addControl(data.hits + "", true);
                this.titleBarMissScore.addControl(data.misses + "", true);
                this.userImage.setImage(data.userdetails.social_profile_image, 70, 70);
                this.nameContainer.addControl(data.userdetails.social_username, true);
            }
            console.log("set datasource", data.listData);
            if (!data.listData) this.titleBarContainer.setVisible(false);
            this.listRender.setDataSource(data.listData || []);
        });
    }
    destroy() {
        super.destroy();
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState("userVoteModal");
    }
    storeState() {
        var d = {
            "scrollPosition": this.listRender.getScroll()
        };
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState("userVoteModal", d);
    }
    createList(container) {
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = this.scrollContainer;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $8df5656fdf1240ef$export$b3fa8dd152db2ecc)()
            };
            else if (data.type == 2) return {
                typeId: 2,
                render: new (0, $8df5656fdf1240ef$export$1ddeaa321d685bcf)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {}));
        var storeHandler;
        listRender.bind("scroll", (e, scroll)=>{
            clearTimeout(storeHandler);
            storeHandler = setTimeout(()=>{
                this.storeState();
            }, 200);
        });
        listRender.setPlaceHolderWidth("100%;");
        this.listRender = listRender;
        container.addControl(listRender);
        var state = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState("userVoteModal");
        if (state) {
            console.log("set scroll", state.scrollPosition);
            listRender.scrollTo(state.scrollPosition);
        }
        return listRender;
    }
}




class $8df5656fdf1240ef$export$d5fdcaccd0e3d9b7 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(data) {
        super.init();
        this.data = data;
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        this.panel.setStyle("margin-bottom:40px;");
        //
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        this.panel.setStyle("margin-top:3px;margin-bottom:-3px;");
        this.card.setStyle("padding-bottom:4px;height:48px;cursor:pointer;");
        //
        this.content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.content.addCssClass("flexHorizontalAlign");
        this.content.setStyle("align-items: flex-start;");
        this.card.addControl(this.content);
        this.playerImage = new (0, $61e67aa413d59276$export$ecf150517ad2aa0)();
        //this.playerImage.placeholderData = teamPlaceholder;
        this.playerImage.image.setStyle("height: 40px;border-radius: 20px;overflow: hidden;");
        this.playerImage.setStyle("width:40px; height:40px;align-self: center;");
        this.content.addControl(this.playerImage);
        this.rank = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.rank.setStyle("align-self: center;padding-inline-start:4px;padding-inline-end:4px;");
        this.content.addControl(this.rank);
        this.playerName = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerName.setStyle("align-self: center;margin-inline-start: 8px;line-height: 21px;");
        this.content.addControl(this.playerName);
        var margin = "margin-left:auto;";
        if (FootballManiaConfig.isRtl) margin = "margin-right:auto;";
        this.rightContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.rightContainer.setStyle(margin + "align-self: center;display:flex;flex-direction: column;justify-content: space-around;height:100%;");
        this.content.addControl(this.rightContainer);
        this.score = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.score.setStyle("text-align:end;font-size:12px;");
        this.playerScoreRatio = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.playerScoreRatio.setStyle("text-align:end;font-size:13px;font-weight:bold;");
        this.rightContainer.addControl(this.playerScoreRatio);
        this.rightContainer.addControl(this.score);
        this.addControl(this.panel);
        this.valueFormatter = Intl.NumberFormat('en-EN', {
            style: 'currency',
            currency: 'EUR'
        });
        this.content.bind("click", ()=>{
            var urlIdentifier = "userVotesModal_" + this.data.id;
            var pan = new (0, $45704ea9e1f2be17$export$845f649722154d7a)(urlIdentifier);
            this.modal = pan;
            this.getPage().addControl(pan, true);
        });
    }
    setData(data) {
        this.data = data;
        this.rank.clear();
        this.playerName.clear();
        this.playerScoreRatio.clear();
        this.score.clear();
        if (data.isMine) this.panel.setCss({
            "background-color": "var(---match-votebutton-selected-background-color)"
        });
        var ratio = "";
        if (data.hits && data.misses) {
            ratio = data.hits / data.misses;
            ratio = Math.round(ratio * 100) / 100;
            if (ratio >= 1.8) this.playerScoreRatio.setCss({
                color: "#aa02a2"
            });
            else if (ratio > 1.5) this.playerScoreRatio.setCss({
                color: "#00ff00"
            });
            else this.playerScoreRatio.setCss({
                color: ""
            });
        } else this.playerScoreRatio.setCss({
            color: ""
        });
        this.rank.addControl(data.rank + "", true);
        this.playerImage.setImage(data.social_profile_image, 40, 40);
        // this.playerCountryImage.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/flags/"+data.usercountry.replace(/\s|\'/g, '-').toLowerCase()+".png");
        this.playerName.addControl((data.social_username || "Anonymous") + "<br> <i> " + data.points + "</i>", true);
        this.playerScoreRatio.addControl(ratio + "", true);
        this.score.addControl(data.hits + " / " + data.misses, true);
    }
}
class $8df5656fdf1240ef$export$b3fa8dd152db2ecc extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(data) {
        super.init();
        this.data = data;
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.setStyle("padding-left:10px;padding-right:5px;border-radius:2px;background-color: var(--listHeaderBackground);width: 100%;display:flex;height:48px;justify-content: space-between;flex-direction: row;");
        this.left = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.left.setStyle("display:flex;flex-direction: column;justify-content: space-evenly;");
        this.right = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.right.setStyle("display:flex;flex-direction: column;justify-content: space-evenly;");
        this.rightTopContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.rightTopContainer.setStyle("display:flex;flex-direction: row;justify-content: space-between;");
        this.rightBottomContainer = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.rightBottomContainer.setStyle("display:flex;flex-direction: row;justify-content: space-between;");
        this.right.addControl(this.rightTopContainer);
        this.right.addControl(this.rightBottomContainer);
        this.homeTeam = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.homeTeam.setStyle("text-align:start;");
        this.awayTeam = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.awayTeam.setStyle("text-align:start;");
        this.homePoints = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.homePoints.setStyle("text-align:start;width:20px;");
        this.awayPoints = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.awayPoints.setStyle("text-align:start;width:20px;");
        this.homeChoice = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.homeChoice.setStyle("text-align:end;");
        this.awayChoice = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.awayChoice.setStyle("text-align:end;");
        this.drawChoice = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.drawChoice.setStyle("text-align:end;");
        this.left.addControl(this.homeTeam);
        this.left.addControl(this.awayTeam);
        this.rightTopContainer.addControl(this.homePoints);
        this.rightTopContainer.addControl(this.homeChoice);
        this.rightBottomContainer.addControl(this.awayPoints);
        this.rightBottomContainer.addControl(this.awayChoice);
        this.rightBottomContainer.addControl(this.drawChoice);
        this.panel.addControl(this.left);
        this.panel.addControl(this.right);
        this.addControl(this.panel);
        this.panel.bind("click", ()=>{
            (0, $2ee970b2529997d7$export$55185c17a0fcbe46).showMatchScreen(null, this.data);
        });
    }
    setData(data) {
        this.data = data;
        this.homeTeam.clear();
        this.homeTeam.addControl(data.localteam);
        this.awayTeam.clear();
        this.awayTeam.addControl(data.visitorteam);
        this.homePoints.clear();
        this.homePoints.addControl("1");
        this.awayPoints.clear();
        this.awayPoints.addControl("2");
        this.homeChoice.clear();
        this.awayChoice.clear();
        this.drawChoice.clear();
        if (this.data.votedfor == "0") this.homeChoice.addControl("X");
        else if (this.data.votedfor == "1") this.awayChoice.addControl("X");
        else this.drawChoice.addControl("<p style='margin-top:-10px;'>X</p>");
        if (this.data.isPast) {
            if (this.data.localscore > this.data.visitorscore && this.data.votedfor == "0") this.panel.setCss({
                "background-color": "green"
            });
            else if (this.data.localscore < this.data.visitorscore && this.data.votedfor == "1") this.panel.setCss({
                "background-color": "green"
            });
            else if (this.data.localscore == this.data.visitorscore && this.data.votedfor == "2") this.panel.setCss({
                "background-color": "green"
            });
            else this.panel.setCss({
                "background-color": "#df0707"
            });
        } else this.panel.setCss({
            "background-color": "var(--listHeaderBackground)"
        });
        this.panel.invalidateDisplay();
    }
}
class $8df5656fdf1240ef$export$1ddeaa321d685bcf extends (0, $ae10f9e8e1dd758b$export$603c3d0f5550cd51) {
    init(data) {
        super.init(data);
        this.panel.setStyle("background:none;border:none;");
    }
    setData(data, preventRender, preventInstantRender) {
        //this._super(data);
        this.panel.clear();
        var d = Intl.DateTimeFormat(FootballManiaConfig.userLocale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }).format(data.dayTimecodeLocalized);
        //this.panel.addControl(MatchUtil.getLocalizedDate(data,true),true);
        this.panel.addControl("<div style='width: 100%;'>" + d + "</div>");
    }
}



var $dNeVp = parcelRequire("dNeVp");

class $9d4deff23e202483$export$f7de2fbbe486a72 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init() {
        this.pageName = "TopVoters";
        this.version = 1;
        super.init();
        this.setStyle("height:100%");
        this.addCssClass("TopVotersPage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $23ab1716e6aced69$export$bd2148639dcb5f7e)();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
            this.wrapper2 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper2.addEventListener("message", this.wrapper2);
            this.wrapper3 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper3.addEventListener("message", this.wrapper3);
        }
    }
    findListRenderById(id) {
        for(var i = 0; i < this.tabview.tabContents.controls.length; i++)try {
            if (this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0].getId() == id) return this.tabview.tabContents.controls[i].controls[1].controls[0].controls[0];
        } catch (e) {
            console.error(e);
        }
    }
    getActiveListRender() {
        return this.tabview.tabContents.controls[this.tabview.currentActiveTab].controls[1].controls[0].controls[0];
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        var listRender = this.findListRenderById(e.data[0]);
        if (!listRender) {
            console.error("no listrender found for ", e.data[0]);
            return;
        }
        listRender.parent.parent.hideLoader();
        listRender.setDataSource(e.data[1]);
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "scrollPosition": this.getActiveListRender().getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsed
        };
        if (this.userVotesModal) d.userVoteModalOpen = this.userVotesModal.urlIdentifier;
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.topValueLoadHandler);
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) //this.autoInterval(0);
        console.warn("no autorefresh implementation");
        this.previousDocumentHidden = document.hidden;
    }
    createPageLayout() {
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().showTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.allTimeTopVoterListrender) this.allTimeTopVoterListrender.onWindowResize();
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        console.log("run app");
        this.showLoader();
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup(this.getProxy(function(result) {
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            if (!result) {
                this.hideLoader();
                console.error("error app setup");
                return this.showError("", this.getProxy(function() {
                    this.runApp();
                }));
            }
            this.hideLoader();
            this.createTitle();
            this.createTabs();
            this.getPageTemplate().createMenuTopVoters();
            this.tabview.bind("tabChanged", this.getProxy(function() {
                this.storeState();
                this.coordinatoranimator.tabChange();
            }));
            var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
            if (previousState) {
                this.tabview.currentActiveTab = previousState.tabIndex;
                this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
            }
            this.contentContainer.invalidateDisplay();
            //TODO: find out why we cannot set scroll before invalidateDisplay
            if (previousState) this.getActiveListRender().scrollTo(previousState.scrollPosition || 0);
            this.bind("onModalOpen", (e, modal)=>{
                console.log("onModalOpen", modal);
                this.userVotesModal = modal;
                this.storeState();
            });
            this.bind("onModalClose", ()=>{
                console.log("onModalClose");
                this.userVotesModal = null;
                this.storeState();
            });
            if (previousState && previousState.userVoteModalOpen) setTimeout(()=>{
                var urlIdentifier = previousState.userVoteModalOpen;
                var modal = new (0, $45704ea9e1f2be17$export$845f649722154d7a)(urlIdentifier);
                this.addControl(modal, true);
            });
            this.coordinatoranimator.prepare();
        }));
    }
    createTitle(data) {
        this.getPageTemplate().topTitleContainer.setVisible(false);
    }
    createTabs() {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        this.tabview = tabview;
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        var tab2;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab1.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab1.title = (0, $02mnx.Localizer).getString("all_time");
        tabs.push(tab1);
        tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab2.setStyle("width:100%;height:100%;position:relative;overflow-y: scroll;transform: translate(0,0);");
        tab2.title = (0, $02mnx.Localizer).getString("last_month");
        tabs.push(tab2);
        var listRender1 = this.createTopVotersControls(tab1, 0);
        var listRender2 = this.createTopVotersControls(tab2, 1);
        this.coordinatoranimator.addScrollerContainer(tab1);
        this.coordinatoranimator.addScrollerContainer(tab2);
        this.coordinatoranimator.addCollapser(this.getPageTemplate().topBar);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        tabview.bind("onReady", this.getProxy(function() {
            this.coordinatoranimator.run();
        }));
        this.loadTopVoters("alltime", listRender1, false, false, false, false);
        this.loadTopVoters("monthly", listRender2, false, false, false, false);
        tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
            if (tab1) tab1.setCss({
                'height': '100%'
            });
            if (tab2) tab2.setCss({
                'height': '100%'
            });
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) tab1.setCss({
                'height': 'calc(100% - 50px)'
            });
            if (tab2) tab2.setCss({
                'height': 'calc(100% - 50px)'
            });
        });
        this.getPageTemplate().loadStickyBannerAd();
    }
    createTopVotersControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var top = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        top.setStyle("width:100%;height:50px;background-color:red;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = tab;
        listRender.enableFastScroll = true;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $8df5656fdf1240ef$export$d5fdcaccd0e3d9b7)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        var storeHandler = null;
        listRender.bind("scroll", (e, scroll)=>{
            clearTimeout(storeHandler);
            storeHandler = setTimeout(()=>{
                this.storeState();
            }, 200);
        });
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) listRender.scrollTo(previousState.allTimeTopVoterScrollPosition || 0);
        container.addControl(listRender);
        tab.addControl(container);
        return listRender;
    }
    loadTopVoters(period, listRenderTarget, ignoreCache, dontShowLoader, isFromAutoRefresh, ignoreMemoryCache, forceWorkers) {
        if (period == "alltime") {
            var tabIndex = 0;
            var cacheKey = "allTimeTopVoters";
        } else {
            tabIndex = 1;
            cacheKey = "monthlyTopVoters";
        }
        var timeout = 0;
        if (this.tabview.currentActiveTab != tabIndex) {
            forceWorkers = true;
            timeout = 300;
        }
        var extraTimeout = 0;
        if (!forceWorkers && !ignoreMemoryCache && (0, $dNeVp.ManiaCache).getMemoryCache(cacheKey)) {
            if (this.tabview.currentActiveTab != tabIndex) {
                if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
            }
            setTimeout(()=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                //only set memory cache when we are on the live tab
                if (this.tabview.currentActiveTab == tabIndex) {
                    console.log("use mem cache");
                    listRenderTarget.setDataSource((0, $dNeVp.ManiaCache).getMemoryCache(cacheKey));
                    if (!dontShowLoader) this.tabview.tabs[tabIndex].hideLoader();
                    console.log("use mem cache complete");
                    extraTimeout = 100;
                }
                return this.autoRefreshAllTimeTopVoters(100 + extraTimeout, true);
            }, timeout);
            return;
        }
        if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
        setTimeout(()=>{
            (0, $kc8Kt.DataProvider).getTopVoters((response)=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.tabview.tabs[tabIndex].hideLoader();
                    var str = (0, $02mnx.Localizer).getString("nointernet") + "<br>" + (0, $02mnx.Localizer).getString("taptotryagain");
                    listRenderTarget.showError(str, ()=>{
                        this.loadTopVoters(period, listRenderTarget, ignoreCache, dontShowLoader, isFromAutoRefresh, ignoreMemoryCache, forceWorkers);
                    });
                    return;
                }
                console.log("get top voters ", response.getData());
                var options = {
                    methodType: 13,
                    responseData: response.getData(),
                    listRenderId: listRenderTarget.getId()
                };
                if (!forceWorkers && !FootballManiaConfig.useWebWorkers) {
                    var list = (0, $gQQqD.Processors).prepareTopVotersData(options);
                    var data = {
                        data: [
                            listRenderTarget.getId(),
                            list
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else AppInstance.workerHelper2.postMessage(options);
            }, ignoreCache, period);
        }, timeout);
    }
}



parcelRequire("fRpWP");



var $02mnx = parcelRequire("02mnx");

var $gQQqD = parcelRequire("gQQqD");

const $5fe785bdb97f66db$export$83df0d22a2e3a1c0 = function() {
    // Private variables
    const state = {
        version: "1.0",
        scrollerContainers: [],
        scrollerMethods: [],
        touchStartMethod: null,
        touchEndMethod: null,
        collapser: null,
        tabview: null,
        ignoreEvents: false,
        ignoreEventForIndex: [],
        unloaded: false,
        isTouching: false,
        reducerRatio: 0.5,
        transitionDuration: 100,
        alwaysCollapseOnBackScrolling: true,
        isCollapsed: false,
        lastRecalculateWasCollapsed: null,
        isVirtuallyCollapsed: false,
        lastScrollPositionAfterTouchStart: -1,
        lastYOffsetAfterTouchStart: 0,
        currentTranslateY: 0,
        currentActiveTab: -1,
        cachedTopbarElement: null,
        cachedTabholderElement: null,
        cachedScrollerCollection: null,
        mouseIsDown: false,
        lastUsedScrollerElement: null,
        lastUsedScrollerElementListener: null
    };
    // Utility methods
    const getElementSafe = (selector, cacheKey)=>{
        if (!state[cacheKey]) state[cacheKey] = document.querySelector(selector);
        return state[cacheKey];
    };
    // Public methods
    this.addScrollerContainer = (tab)=>{
        if (tab) state.scrollerContainers.push(tab);
    };
    this.addCollapser = (c)=>{
        state.collapser = c;
    };
    this.addTabView = (tab)=>{
        state.tabview = tab;
    };
    this.getTabBar = ()=>getElementSafe(".topBar", "cachedTopbarElement");
    this.getTabHolder = ()=>getElementSafe(".tabholder", "cachedTabholderElement");
    this.unload = ()=>{
        if (state.unloaded) return;
        state.unloaded = true;
        if (state.collapser) state.collapser.setCss({
            "transform": "translate(0px,0px)",
            "transition-duration": "0ms"
        });
        state.scrollerContainers.forEach((container, i)=>{
            const $scrollEl = jQuery(`#${container.getClientId()}`);
            if (state.scrollerMethods[i]) $scrollEl.off("scroll", state.scrollerMethods[i]);
        });
        jQuery('body').off({
            'touchstart': state.touchStartMethod,
            'touchend': state.touchEndMethod
        });
        if (state.lastUsedScrollerElement && state.lastUsedScrollerElementListener) state.lastUsedScrollerElement.removeEventListener("scroll", state.lastUsedScrollerElementListener);
    };
    this.initAnimations = ()=>{
        var _FootballManiaConfig_graphics, _FootballManiaConfig;
        if (!state.tabview || !((_FootballManiaConfig = FootballManiaConfig) === null || _FootballManiaConfig === void 0 ? void 0 : (_FootballManiaConfig_graphics = _FootballManiaConfig.graphics) === null || _FootballManiaConfig_graphics === void 0 ? void 0 : _FootballManiaConfig_graphics.animations)) return;
        const topbar = this.getTabBar();
        const tabholder = this.getTabHolder();
        if (!topbar || !tabholder) return;
        const currentTab = state.tabview.currentActiveTab;
        if (!state.cachedScrollerCollection) state.cachedScrollerCollection = [];
        let cachedScroller = state.cachedScrollerCollection[currentTab];
        if (!cachedScroller) {
            var _state_scrollerContainers_currentTab;
            const element = document.getElementById((_state_scrollerContainers_currentTab = state.scrollerContainers[currentTab]) === null || _state_scrollerContainers_currentTab === void 0 ? void 0 : _state_scrollerContainers_currentTab.getClientId());
            if (!element) return;
            const timeline = new ScrollTimeline({
                source: element,
                axis: "block"
            });
            state.cachedScrollerCollection[currentTab] = {
                element: element,
                timeline: timeline
            };
            cachedScroller = state.cachedScrollerCollection[currentTab];
        }
        [
            this.tabholderAnimation,
            this.topbarAnimation
        ].forEach((anim)=>{
            if (anim) {
                anim.commitStyles();
                anim.cancel();
            }
        });
        const style = window.getComputedStyle(tabholder);
        const matrixY = new DOMMatrix(style.transform).m42;
        const isCollapsed = matrixY === -50;
        const isExpanded = matrixY === 0;
        if (state.lastUsedScrollerElement && state.lastUsedScrollerElementListener) state.lastUsedScrollerElement.removeEventListener("scroll", state.lastUsedScrollerElementListener);
        const scrollHandler = ()=>{
            if (state.mouseIsDown) return;
            clearTimeout(state.scrollTimeout);
            state.scrollTimeout = setTimeout(()=>this.autoCollapseOrOpen(), 200);
        };
        state.lastUsedScrollerElement = cachedScroller.element;
        state.lastUsedScrollerElementListener = scrollHandler;
        cachedScroller.element.addEventListener("scroll", scrollHandler);
        const topOffset = cachedScroller.element.scrollTop;
        const keyframes = {
            transform: [
                'translateY(0px)',
                'translateY(-50px)'
            ]
        };
        const options = {
            timeline: cachedScroller.timeline,
            linear: "both",
            fill: isCollapsed ? "backwards" : "forwards",
            rangeStart: `calc(0% + ${isCollapsed ? topOffset - 50 : topOffset}px)`,
            rangeEnd: `calc(0% + ${isCollapsed ? topOffset : topOffset + 50}px)`
        };
        this.tabholderAnimation = tabholder.animate(keyframes, options);
        this.topbarAnimation = topbar.animate(keyframes, options);
    };
    this.autoCollapseOrOpen = ()=>{
        var _FootballManiaConfig_graphics, _FootballManiaConfig;
        if (!state.tabview || !((_FootballManiaConfig = FootballManiaConfig) === null || _FootballManiaConfig === void 0 ? void 0 : (_FootballManiaConfig_graphics = _FootballManiaConfig.graphics) === null || _FootballManiaConfig_graphics === void 0 ? void 0 : _FootballManiaConfig_graphics.animations)) return;
        const scroller = state.scrollerContainers[state.tabview.currentActiveTab];
        if (!scroller) return;
        const tabholder = this.getTabHolder();
        const topbar = this.getTabBar();
        if (!tabholder || !topbar) return;
        const scrollElement = document.getElementById(scroller.getClientId());
        if (!scrollElement) return;
        const style = window.getComputedStyle(tabholder);
        const matrixY = new DOMMatrix(style.transform).m42;
        const topOffset = scrollElement.scrollTop;
        [
            this.tabholderAnimation,
            this.topbarAnimation
        ].forEach((anim)=>{
            if (anim) {
                anim.commitStyles();
                anim.cancel();
            }
        });
        if (topOffset < 25) {
            scrollElement.scroll({
                top: 0,
                behavior: 'smooth'
            });
            const targetY = 0;
            this.animateToPosition(tabholder, topbar, matrixY, targetY);
        } else if (topOffset < 50) {
            scrollElement.scroll({
                top: 50,
                behavior: 'smooth'
            });
            const targetY = -50;
            this.animateToPosition(tabholder, topbar, matrixY, targetY);
        } else {
            const targetY = matrixY < -25 ? -50 : 0;
            this.animateToPosition(tabholder, topbar, matrixY, targetY);
        }
    };
    this.animateToPosition = (tabholder, topbar, currentY, targetY)=>{
        const keyframes = {
            transform: [
                `translateY(${currentY}px)`,
                `translateY(${targetY}px)`
            ]
        };
        const options = {
            duration: 150,
            fill: "forwards"
        };
        this.tabholderAnimation = tabholder.animate(keyframes, options);
        this.topbarAnimation = topbar.animate(keyframes, options);
        this.tabholderAnimation.onfinish = ()=>this.initAnimations();
    };
    this.run = ()=>{
        var _FootballManiaConfig_graphics, _FootballManiaConfig;
        if (!((_FootballManiaConfig = FootballManiaConfig) === null || _FootballManiaConfig === void 0 ? void 0 : (_FootballManiaConfig_graphics = _FootballManiaConfig.graphics) === null || _FootballManiaConfig_graphics === void 0 ? void 0 : _FootballManiaConfig_graphics.animations)) return;
        state.touchStartMethod = ()=>{
            state.mouseIsDown = true;
            this.initAnimations();
        };
        state.touchEndMethod = ()=>{
            state.mouseIsDown = false;
            this.autoCollapseOrOpen();
        };
        jQuery('body').on({
            'touchstart': state.touchStartMethod,
            'touchend': state.touchEndMethod
        });
        this.initAnimations();
    };
    // Stub methods for future implementation
    this.onWindowResize = ()=>this.recalculate(true);
    this.tabChange = ()=>{};
    this.recalculateTab = ()=>{};
    this.recalculate = ()=>{};
    this.prepare = ()=>{};
    this.collapseHeader = ()=>{};
    this.expandHeader = ()=>{};
    this.isCollapsedCalculated = ()=>false;
};



var $kc8Kt = parcelRequire("kc8Kt");











parcelRequire("9yWe2");
parcelRequire("02mnx");

parcelRequire("5er4g");
parcelRequire("6K7Df");
parcelRequire("lU8CH");
class $5e833b2d9f1fd105$export$bb2afbfd7c2da8f9 extends (0, $2a9fdfb6f07b1997$export$b3f2024387ec8f9f) {
    init(data) {
        super.init();
        this.data = data;
        this.panel = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.panel.addCssClass("MatchStatsContainer");
        //
        this.card = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.card.addCssClass("MatchStatsContainerCard");
        this.panel.addControl(this.card);
        //this.panel.setStyle("margin-top:3px;margin-bottom:-3px;");
        this.card.setStyle("padding-bottom:4px;");
        //
        this.content = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.content.setStyle("height:40px;");
        this.content.addCssClass("flexVerticalAlign");
        var title = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        //title.addControl(Localizer.getString("passport"));
        title.addCssClass("MatchStatsTitleText MatchH2HTitle");
        this.card.addControl(title);
        this.card.addControl(this.content);
        //
        this.addControl(this.panel);
    }
    setData(data) {
        this.data = data.data;
        this.content.clear();
        this.content.addControl("aaap " + data.index);
        this.content.invalidateDisplay();
    }
}


class $ceab2c9f4eaea863$export$d84faf0fb56f517 extends (0, $0e26d0b3b103d6c2$export$db22d6a18a24ebf7) {
    init(params) {
        this.pageName = "PlayerMarketValue";
        this.version = 1;
        super.init();
        this.pageName = "PlayerMarketValues";
        this.addCssClass("PlayerMarketValuePage");
        this.isNavigatedFromOutside = (0, $2ee970b2529997d7$export$55185c17a0fcbe46).navigationIsFromOutside();
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).updateCurrentReferalData();
        if (this.isNavigatedFromOutside) (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).flushPageState(this.pageName);
        console.log("OPENING PAGE " + this.pageName + " VERSION " + this.version + " is from outside " + this.isNavigatedFromOutside);
        this.coordinatoranimator = new (0, $5fe785bdb97f66db$export$83df0d22a2e3a1c0)();
        window.an = this.coordinatoranimator;
        (0, $2ee970b2529997d7$export$55185c17a0fcbe46).disallowBackButtonQuitApp();
        this.createPageLayout();
        if (AppInstance.workersInitialized) {
            this.wrapper1 = this.onWorkerMessageReceived.bind(this);
            AppInstance.workerHelper1.addEventListener("message", this.wrapper1);
        }
    }
    onWorkerMessageReceived(e) {
        if (this.unloaded) return console.warn("page is unloaded abort further actions");
        console.log("worker received ", e.data[1]);
        this.tabview.tabs[e.data[0]].hideLoader();
        if (e.data[0] == 0) this.topTeamsListrender.setDataSource(e.data[1]);
        else if (e.data[0] == 1) this.topPlayersListrender.setDataSource(e.data[1]);
        this.autoInterval();
    }
    storeState() {
        var d = {
            "tabIndex": this.tabview.currentActiveTab,
            "topTeamScrollPosition": this.topTeamsListrender && this.topTeamsListrender.getScroll(),
            "headerCollapsed": this.coordinatoranimator.isCollapsedCalculated()
        };
        console.log("store state ", d);
        (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).savePageState(this.pageName, d);
    }
    unload() {
        this.unloaded = true;
        $.xhrPool.abortAll();
        this.coordinatoranimator.unload();
        clearTimeout(this.topValueLoadHandler);
        if (AppInstance.workersInitialized) AppInstance.workerHelper1.removeEventListener("message", this.wrapper1);
    }
    onVisibilityChange() {
        //page is becoming visible after hide
        if (this.previousDocumentHidden = !document.hidden) this.autoInterval(0);
        this.previousDocumentHidden = document.hidden;
    //console.log("visibility change ",document.hidden,this);
    }
    createPageLayout() {
        var row2 = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        this.addControl(row2);
        this.contentContainer = row2;
    }
    createComponents() {
        this.getPageTemplate().showTitle();
    }
    onWindowResize() {
        super.onWindowResize();
        if (this.tabview) this.tabview.onWindowResize();
        if (this.coordinatoranimator) this.coordinatoranimator.onWindowResize();
        if (this.topTeamsListrender) this.topTeamsListrender.onWindowResize();
    }
    updateDisplay() {
        this.runApp();
    }
    runApp() {
        this.showLoader();
        if (!AppInstance.setupAlreadyDone) this.showLoader();
        AppInstance.setup((result)=>{
            if (this.unloaded) return console.warn("page is unloaded abort further actions");
            this.hideLoader();
            if (!result) {
                console.error("error app setup");
                return this.showError("", ()=>{
                    this.runApp();
                });
            }
            var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
            this.createTitle();
            this.createTabs(previousState);
            this.loadTopTeams(0);
            this.loadTopPlayers(1);
            //  this.getPageTemplate().createMenuPlayerMarketValues(response.getData());
            this.tabview.bind("tabChanged", ()=>{
                this.storeState();
                console.log("################# tab changed");
                this.coordinatoranimator.tabChange();
            });
            this.tabview.bind("onReady", this.getProxy(function() {
                this.coordinatoranimator.isCollapsed = previousState && previousState.headerCollapsed;
                setTimeout(()=>{
                    console.log("################# onread");
                    this.coordinatoranimator.run();
                }, 1500);
            }));
            var storeHandler = null;
            //this event is triggered when user scrolls the listrender.
            //it is not called always when scrollTo is called (when prevent boolean)
            this.topTeamScrollListener = (e, scroll)=>{
                clearTimeout(storeHandler);
                ///console.log("=======> received scroll event");
                storeHandler = setTimeout(()=>{
                    if (!this.preventScrollEventStoreStateSaveOnce) this.storeState();
                    this.preventScrollEventStoreStateSaveOnce = false;
                }, 200);
            };
            //this event is triggered when scrollTo method on listrender is called.
            //we use this to restore header state to stored state. this method is called after the page is loaded.
            this.onscrollToCompleteListener = (e)=>{
                ///console.log("=====> scroll to complete",e);
                if (!previousState.headerCollapsed) setTimeout(()=>{
                    this.coordinatoranimator.expandHeader();
                }, 1);
            //
            // e.preventDefault();
            // e.stopPropagation();
            // e.stopImmediatePropagation();
            };
            this.topTeamsListrender.bind("scroll", this.topTeamScrollListener);
            this.topPlayersListrender.bind("scroll", this.topTeamScrollListener);
            this.topTeamsListrender.bind("onScrollToComplete", this.onscrollToCompleteListener);
            this.topPlayersListrender.bind("onScrollToComplete", this.onscrollToCompleteListener);
            console.log("previousState", previousState);
            if (previousState) {
                this.tabview.currentActiveTab = previousState.tabIndex;
                this.coordinatoranimator.isCollapsed = previousState.headerCollapsed;
                if (this.topTeamsListrender) {
                    console.log("scroll to ", previousState.topTeamScrollPosition || 0);
                    this.topTeamsListrender.scrollTo(previousState.topTeamScrollPosition || 0, true);
                }
                if (this.topPlayersListrender) {
                    console.log("scroll to ", previousState.topPlayerScrollPosition || 0);
                    this.topPlayersListrender.scrollTo(previousState.topPlayerScrollPosition || 0, true);
                }
            }
            this.contentContainer.invalidateDisplay();
        }, false);
    }
    createTitle(data) {
        this.getPageTemplate().topTitleContainer.setVisible(false);
    }
    createTabs(previousState) {
        var tabview = new (0, $28c0cceb076dcf38$export$44c45b2b7f09d2a6)();
        tabview.tabHolder.addCssClass("animateHeaderCollapse");
        this.contentContainer.addControl(tabview);
        var tabs = [];
        var tab1;
        tab1 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab1.addCssClass("listViewScroller"); //enableCollapserTimeLine
        tab1.title = (0, $02mnx.Localizer).getString("Top Teams");
        tabs.push(tab1);
        this.createTopTeamsControls(tab1, 0);
        this.coordinatoranimator.addScrollerContainer(tab1);
        var tab2;
        tab2 = new (0, $28c0cceb076dcf38$export$a6fec5efcdc65be2)();
        tab2.addCssClass("listViewScroller");
        tab2.title = (0, $02mnx.Localizer).getString("Top Players");
        tabs.push(tab2);
        this.createTopPlayerControls(tab2, 1);
        this.coordinatoranimator.addScrollerContainer(tab2);
        this.coordinatoranimator.addTabView(tabview);
        tabview.setTabs(tabs);
        this.tabview = tabview;
        //tab1.showLoader();
        this.bind("stickyBannerLoadFail", ()=>{
            console.error("sticky banner load fail -> set height to 100%");
        //if (tab1) tab1.setCss({'height': 'calc(100svh - 50px)'});
        });
        //triggered from page template
        this.bind("stickyBannerLoadSuccess", ()=>{
            if (this.preventStickBannerAdOnce) {
                this.preventStickBannerAdOnce = false;
                this.hideStickBannerAd();
                return;
            }
            console.log("sticky banner load success -> set height to 100% - 50px");
            if (tab1) {
                //tab1.setCss({'height': 'calc(100svh - 100px)'});
                //below is logic to make sure when scroll is at the end it remains at the end and not jumps up a bit.
                //its not a perfect solution, but ok for now.
                var scrollRemaining = this.topTeamsListrender.scrollRemaining();
                if (scrollRemaining <= 50) this.topTeamsListrender.scrollTo(this.topTeamsListrender.getScroll() + scrollRemaining, true);
            }
        });
        this.bind("stickyBannerHide", ()=>{
            console.error("sticky banner hide -> set height to 100%");
        //if (tab1) tab1.setCss({'height': 'calc(100svh - 100px)'});
        });
        this.getPageTemplate().loadStickyBannerAd();
    // setTimeout(()=>{
    //     this.topTeamsListrender.scrollTo(1500);
    // },4000);
    }
    createTopTeamsControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = tab;
        listRender.enableFastScroll = true;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $5e833b2d9f1fd105$export$bb2afbfd7c2da8f9)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) console.log("scroll to ", previousState.fixturesScrollPosition || 0);
        this.topTeamsListrender = listRender;
        tab.addControl(listRender);
    }
    createTopPlayerControls(tab, index) {
        var container = new (0, $53fe8439ad8103ec$export$2ddb90ad54e5f587)();
        container.setStyle("width:100%;margin:0 auto;height:100%;");
        var listRender = new (0, $cc353791ae30d153$export$bc805d5457972dba)();
        listRender.containerTarget = tab;
        listRender.enableFastScroll = true;
        listRender.setItemRender(function(data) {
            if (data.type == 1) return {
                typeId: 1,
                render: new (0, $5e833b2d9f1fd105$export$bb2afbfd7c2da8f9)()
            };
        });
        listRender.emptyTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$4caa372402b56d41)({
                cb: function() {
                    history.back();
                },
                message: (0, $02mnx.Localizer).getString("no_data")
            });
        };
        listRender.errorTemplate = function(cb) {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)(cb);
        };
        listRender.noInternetTemplate = function() {
            return new (0, $90aac4880169307d$export$915e9e7bd4f0f96d)();
        };
        listRender.bind('createdList', this.getProxy(function() {
            this.coordinatoranimator.recalculateTab(index);
        }));
        listRender.setPlaceHolderWidth("100%;");
        var previousState = (0, $f8e803ab7d0be49a$export$4d5c8163a511d38a).getCurrentPageState(this.pageName);
        if (previousState) console.log("scroll to ", previousState.fixturesScrollPosition || 0);
        this.topPlayersListrender = listRender;
        tab.addControl(listRender);
    }
    loadTopTeams(tabIndex, ignoreCache, dontShowLoader, isFromAutoRefresh, ignoreMemoryCache, forceWorkers) {
        if (!this.topTeamsListrender) {
            console.error("topTeamsListrender not set");
            return;
        }
        var timeout = 0;
        console.log("current active tab ", this.tabview.currentActiveTab, tabIndex);
        if (this.tabview.currentActiveTab != tabIndex) {
            forceWorkers = true;
            timeout = 850;
        }
        if (!AppInstance.workersInitialized) forceWorkers = false;
        if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
        setTimeout(()=>{
            (0, $kc8Kt.DataProvider).getTopTeams((response)=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.tabview.tabs[tabIndex].hideLoader();
                    var str = (0, $02mnx.Localizer).getString("nointernet") + "<br>" + (0, $02mnx.Localizer).getString("taptotryagain");
                    this.topTeamsListrender.showError(str, ()=>{
                        this.topTeamsListrender.hideError();
                        this.loadTopTeams(ignoreCache);
                    });
                    return;
                }
                var options = {
                    methodType: 14,
                    responseData: response.getData(),
                    tabIndex: tabIndex
                };
                if (!forceWorkers && !FootballManiaConfig.useWebWorkers) {
                    console.log("a");
                    var list = (0, $gQQqD.Processors).prepareTopTeams(options);
                    var data = {
                        data: [
                            tabIndex,
                            list
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else {
                    console.log("b");
                    AppInstance.workerHelper1.postMessage(options);
                }
            }, ignoreCache);
        }, timeout);
    }
    loadTopPlayers(tabIndex, ignoreCache, dontShowLoader, isFromAutoRefresh, ignoreMemoryCache, forceWorkers) {
        if (!this.topPlayersListrender) {
            console.error("loadTopPlayers not set");
            return;
        }
        var timeout = 0;
        console.log("current active tab ", this.tabview.currentActiveTab, tabIndex);
        if (this.tabview.currentActiveTab != tabIndex) {
            forceWorkers = true;
            timeout = 850;
        }
        if (!AppInstance.workersInitialized) forceWorkers = false;
        if (!dontShowLoader) this.tabview.tabs[tabIndex].showLoader();
        setTimeout(()=>{
            (0, $kc8Kt.DataProvider).getTopTeams((response)=>{
                if (this.unloaded) return console.warn("page is unloaded abort further actions");
                if (!response.isOk()) {
                    this.tabview.tabs[tabIndex].hideLoader();
                    var str = (0, $02mnx.Localizer).getString("nointernet") + "<br>" + (0, $02mnx.Localizer).getString("taptotryagain");
                    this.topPlayersListrender.showError(str, ()=>{
                        this.topPlayersListrender.hideError();
                        this.loadTopPlayers(ignoreCache);
                    });
                    return;
                }
                var options = {
                    methodType: 15,
                    responseData: response.getData(),
                    tabIndex: tabIndex
                };
                if (!forceWorkers && !FootballManiaConfig.useWebWorkers) {
                    console.log("load playrers");
                    var list = (0, $gQQqD.Processors).prepareTopTeams(options);
                    var data = {
                        data: [
                            tabIndex,
                            list
                        ]
                    };
                    this.onWorkerMessageReceived(data);
                } else {
                    console.log("load playrers 2");
                    AppInstance.workerHelper1.postMessage(options);
                }
            }, ignoreCache);
        }, timeout);
    }
    autoInterval(overrideInterval) {}
}



var $kc8Kt = parcelRequire("kc8Kt");


var $02mnx = parcelRequire("02mnx");

var $3SrKy = parcelRequire("3SrKy");

var $6K7Df = parcelRequire("6K7Df");



const $d0757321c39843a5$export$cae2bcaccd579807 = {
    "appmode": "android",
    "autoDetectAppMode": true,
    "url": {
        "imageBaseUrl": "",
        "teamPlayerImageUrl": "images",
        "dataBaseUrl": "/footapi/",
        "voteBaseUrl": "/"
    },
    "ajaxTimeout": 15000,
    "clientVersion": 1533,
    "apiVersion": 2800,
    "theme": "dark",
    "size": "medium",
    "defaultTheme": "dark",
    "defaultSize": "medium",
    "defaultHomeScreen": "home",
    "useAndroidThemeAndSizes": true,
    "useWebWorkers": false,
    "isPremium": false,
    "refreshIntervals": {
        "live": 30000,
        "today": 60000,
        "home": 60000,
        "match": 30000,
        "league": 30000,
        "agenda": 60000,
        "team": 60000,
        "commentaries": 30000,
        "countryLeague": 60000000,
        "player": 60000000,
        "commentary": 30000,
        "news": 60000,
        "ranking": 60000000,
        "forum": 60000
    },
    "cacheTimes": {
        "config": 600000,
        "home": 60000,
        "live": 10000,
        "today": 15000,
        "datefixtures": 20000,
        "match": 5000,
        "league": 30000,
        "leagueinfo": 60000,
        "translations": 864000000,
        "search": 60000,
        "team": 60000,
        "player": 120000,
        "countryLeagues": 60000,
        "suggestions": 60000,
        "commentaries": 20000,
        "news": 60000,
        "ranking": 120000,
        "forum": 120000,
        "ads": 2000,
        "userinfo": 600000
    },
    "sizes": {
        "fixtureListImageSize": 38,
        "fixtureListFlagSize": 38,
        "matchHeaderImageSize": 80
    },
    "graphics": {
        "animations": true,
        "listRenderMaxRenderCount": 20,
        "defaultMatchListType": 1
    },
    "enabledFeatures": {
        "search": true,
        "news": true,
        "chat": true,
        "forum": true,
        "matchChat": true,
        "playerImages": true,
        "teamImages": true,
        "stickyad": true,
        "mrecad": true,
        "housead": true,
        "userPredictions": true,
        "entertainment": true,
        "showHiddenLeagues": true,
        "showCompleteLeagueNames": true
    },
    "reservedWords": [
        "UEFA",
        "FIFA",
        "World Cup",
        "EFL"
    ],
    "hiddenLeagues": [],
    "enableVideo": true,
    "disabledVideoCountries": [
        "us",
        "es",
        "en"
    ],
    "userLocale": "da",
    "userLocaleFull": "nl-NL",
    "userRegionLocale": "Southern Europe",
    "autoSetLocale": true,
    "isRtl": false,
    "autoSetRtl": true,
    "is24HourFormat": true,
    "defaultLocale": "en",
    "allowableLocales": [
        "en",
        "es",
        "nl",
        "ru",
        "de",
        "fr",
        "ar",
        "it",
        "cs",
        "da",
        "el",
        "fa",
        "hi",
        "hr",
        "hu",
        "id",
        "in",
        "is",
        "ja",
        "ko",
        "mn",
        "no",
        "pa",
        "pt",
        "pl",
        "ro",
        "sv",
        "th",
        "tr",
        "uk",
        "vi",
        "zh",
        "zh-rCN",
        "zh-rHK",
        "zh-rTW"
    ],
    "availableNewsLocales": [
        "en",
        "us",
        "it",
        "es",
        "fr",
        "de",
        "nl",
        "be",
        "ru",
        "pt-BR"
    ],
    "availableChatLocales": [
        "en",
        "it",
        "de",
        "ru"
    ],
    "default_chat_locale": "en",
    "disallowedHighlightRegions": [
        "North America"
    ],
    "enabledOddsCountries": [
        "ma",
        "at",
        "cl",
        "ec",
        "ci",
        "pe",
        "kr",
        "br",
        "sl",
        "mz",
        "cr",
        "gn",
        "bf",
        "ga",
        "ar",
        "ve",
        "mm",
        "bj",
        "ml",
        "cm",
        "gh",
        "ug",
        "cg",
        "cd",
        "mx",
        "sn",
        "ng",
        "vn",
        "ke",
        "uz",
        "ca",
        "th",
        "zm",
        "az",
        "my",
        "id",
        "ec",
        "in",
        "bd"
    ],
    "newsLocaleRemap": {
        "en": "us"
    },
    "hiddenCountries": [],
    "fixedLeaguesOrder": {
        "Western Europe": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "Eurocups"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsEurope",
                "EurocupsUEFAChampionsLeague",
                "EurocupsUEFAEuropaLeague",
                "EurocupsEuropaChampionshipQualification",
                "EurocupsUEFAEuropaConferenceLeague",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "EnglandPremierLeague",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Southern Europe": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "Eurocups"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsEurope",
                "EurocupsUEFAChampionsLeague",
                "EurocupsUEFAEuropaLeague",
                "EurocupsEuropaChampionshipQualification",
                "EurocupsUEFAEuropaConferenceLeague",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "EnglandPremierLeague",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Eastern Europe": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "Eurocups"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsEurope",
                "EurocupsUEFAChampionsLeague",
                "EurocupsUEFAEuropaLeague",
                "EurocupsEuropaChampionshipQualification",
                "EurocupsUEFAEuropaConferenceLeague",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "EnglandPremierLeague",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Central and Southeast Europe": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "Eurocups"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsEurope",
                "EurocupsUEFAChampionsLeague",
                "EurocupsUEFAEuropaLeague",
                "EurocupsEuropaChampionshipQualification",
                "EurocupsUEFAEuropaConferenceLeague",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "EnglandPremierLeague",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Nordic Countries": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "Eurocups"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsEurope",
                "EurocupsUEFAChampionsLeague",
                "EurocupsUEFAEuropaLeague",
                "EurocupsEuropaChampionshipQualification",
                "EurocupsUEFAEuropaConferenceLeague",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "EnglandPremierLeague",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Baltic Countries": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "Eurocups"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsEurope",
                "EurocupsUEFAChampionsLeague",
                "EurocupsUEFAEuropaLeague",
                "EurocupsEuropaChampionshipQualification",
                "EurocupsUEFAEuropaConferenceLeague",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "EnglandPremierLeague",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "South America": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "Eurocups"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsSouthAmerica",
                "InternationalSouthAmericaCONMEBOLLibertadores",
                "InternationalSouthAmericaCONMEBOLLibertadores",
                "InternationalSouthAmericaCONMEBOLSudamericana",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Central America": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "International North Central America"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalCupsConcacafLeague",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "North America": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "International North Central America"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalCupsConcacafLeague",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Micronesia/Caribbean": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "International North Central America"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalCupsConcacafLeague",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Southern and Central Asia": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Northern Africa": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalAfricaCAFConfederationsCup",
                "EurocupsUEFAChampionsLeague",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Central Africa": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "International Africa"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalAfricaCAFConfederationsCup",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Western Africa": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "International Africa"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalAfricaCAFConfederationsCup",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Southern Africa": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "International Africa"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalAfricaCAFConfederationsCup",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Eastern Africa": {
            "countries": [
                "World Cup",
                "World Cup Qualifications",
                "International Africa"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsNorthCentralAmerica",
                "InternationalAfricaCAFConfederationsCup",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Caribbean": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsOceania",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Middle East": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Southeast Asia": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Eastern Asia": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Southern Asia": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "WorldCupQualificationsOceania",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Australia and New Zealand": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Melanesia": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Polynesia": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Micronesia": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        },
        "Unknown": {
            "countries": [
                "World Cup",
                "World Cup Qualifications"
            ],
            "leagues": [
                "WorldCupBrazil2014",
                "WorldCupQualificationsOceania",
                "WorldCupQualificationsAsia",
                "WorldCupQualificationsEurope",
                "WorldCupQualificationsSouthAmerica",
                "WorldCupQualificationsNorthCentralAmerica",
                "WorldCupQualificationsAfrica",
                "InternationalCupsOlympics",
                "InternationalCupsOlympicsWomen",
                "InternationalCupsFriendlies"
            ]
        }
    },
    "fixedRegions": [
        "World Cup",
        "World Cup Qualifications",
        "Eurocups",
        "International South America",
        "International Cups",
        "International Africa",
        "International North Central America",
        "International Asia",
        "International Oceania"
    ],
    "hideCountryTitleFor": [
        "International Cups",
        "Eurocups",
        "World Cup",
        "International South America",
        "International Africa",
        "International North Central America",
        "International Asia",
        "International Oceania",
        "World Cup Qualifications"
    ]
};



// import {DefaultTranslations}  from "./translations/default_translations.js";
window.FootballManiaConfig = (0, $d0757321c39843a5$export$cae2bcaccd579807); //required by many modules TODO: make nicer
(0, $40e70090f1e1ff2d$export$5510f7c459d7063c).autoApplyTheme();
(0, $40e70090f1e1ff2d$export$5510f7c459d7063c).autoApplySize();
console.log("=========================> Build version: [" + (0, $d0757321c39843a5$export$cae2bcaccd579807).clientVersion + "]");
$.xhrPool = [];
// if (navigator.serviceWorker) {
//     navigator.serviceWorker.register(new URL('/sw.js', import.meta.url),
//         //{ scope:"./",enabled: true, registrationStrategy: 'registerImmediately' }
//         { scope:"/"}
//     ).then(function(registration) {
//         console.log('ServiceWorker registration successful with scope:',  registration.scope);
//     }).catch(function(error) {
//         console.log('ServiceWorker registration failed:', error);
//     });
//
//     navigator.serviceWorker
// }
//some polyfill for older browsers
if (!String.prototype.replaceAll) {
    console.log("polyfilling replaceAll");
    String.prototype.replaceAll = function(str, newStr) {
        // If a regex pattern
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') return this.replace(str, newStr);
        // If a string
        return this.replace(new RegExp(str, 'g'), newStr);
    };
}
var $842752ceaadce4c5$exports = {};

$842752ceaadce4c5$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "service-worker.js";


if (navigator.serviceWorker) navigator.serviceWorker.register($842752ceaadce4c5$exports);
else console.error("Service worker not supported");
$.ajaxSetup({
    beforeSend: function(jqXHR) {
        $.xhrPool.push(jqXHR);
    },
    complete: function(jqXHR) {
        var i = $.xhrPool.indexOf(jqXHR);
        if (i > -1) $.xhrPool.splice(i, 1);
    }
});
$.xhrPool.abortAll = function() {
    $(this).each(function(i, jqXHR) {
        jqXHR.abort();
        $.xhrPool.splice(0, 1);
    });
};
var $3a6e3d492b4654f8$exports = {};

$3a6e3d492b4654f8$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "workers.411b1a1d.js";




var $4b1fd6f08152459d$exports = {};

$4b1fd6f08152459d$exports = (parcelRequire("2SJ43")).getBundleURL('kuLgW') + "firebase-messaging-service-worker.js";


class $a1f4112d2b4354d8$export$f045649a075103db extends (0, $38ca654a9d34084c$export$16975c34e60e1e61) {
    init(settings) {
        super.init(settings);
        window.AppInstance = this;
        this.preSetup();
        if (this.workersSupported()) {
            console.log("registering workers");
            try {
                this.workerHelper1 = new window.Worker(new URL($3a6e3d492b4654f8$exports), {
                    type: 'module'
                });
                this.workerHelper2 = new window.Worker(new URL($3a6e3d492b4654f8$exports), {
                    type: 'module'
                });
                this.workerHelper3 = new window.Worker(new URL($3a6e3d492b4654f8$exports), {
                    type: 'module'
                });
                this.workersInitialized = true;
            } catch (e) {
                console.error("Error registering workers", e);
            }
        }
        $.fn.isVScrollable = function() {
            return this[0].scrollHeight > this[0].clientHeight;
        };
    }
    workersSupported() {
        return undefined != window.Worker;
    }
    getWorker(i) {
        if (i == 0) return this.workerHelper1;
        if (i == 1) return this.workerHelper2;
        if (i == 2) return this.workerHelper3;
    }
    getLocale() {
        return (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale;
    }
    loadJsScript(src, loadCallback, errorCallback, type) {
        const script = document.createElement('script');
        script.type = type || 'text/javascript';
        script.src = src;
        script.onload = function() {
            loadCallback();
        };
        script.onerror = function() {
            errorCallback();
        };
        document.head.appendChild(script);
        //renderer.appendChild(this.document.body, script);
        return script;
    }
    getStrippedConfig() {
        return 0, $d0757321c39843a5$export$cae2bcaccd579807;
    }
    getConfig() {
        return 0, $d0757321c39843a5$export$cae2bcaccd579807;
    }
    enableRtl(enable) {
        console.log("enable RTL ", enable);
        if (enable) {
            document.documentElement.setAttribute('data-textdirection', "rtl");
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isRtl = true;
        } else {
            document.documentElement.setAttribute('data-textdirection', "ltr");
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isRtl = false;
        }
    }
    //TODO use config. but config needs to load first before this is called
    useWebAds() {
        return (0, $d0757321c39843a5$export$cae2bcaccd579807).isWebStandalone;
    }
    /**
     * presetup happens automatically before any page /template is initialized
     * @param cb
     */ preSetup(cb) {
        const forcedLocale = localStorage.getItem("forceLanguage");
        console.log("preSetup", forcedLocale);
        if (forcedLocale && forcedLocale.length > 1) {
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale = localStorage.getItem("forceLanguage");
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocaleFull = (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userIntlLocale = new Intl.Locale((0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale);
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userRegionLocale = (0, $6K7Df.CountryUtil).getRegionByLocale();
            console.log("forced language", (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale, (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocaleFull);
        }
        const forcedRegion = localStorage.getItem("forceRegion");
        if (forcedRegion && forcedRegion.length > 1) {
            (0, $d0757321c39843a5$export$cae2bcaccd579807).detectedUserCountryCode = forcedRegion;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).detectedUserCountry = (0, $6K7Df.CountryUtil).getCountryByLocale(forcedRegion, "EN");
            console.log("forced region", (0, $d0757321c39843a5$export$cae2bcaccd579807).userRegionLocale);
        }
        //FootballManiaConfig.detectedUserCountryCode = "BR";
        //FootballManiaConfig.detectedUserCountry = CountryUtil.getCountryByLocale(FootballManiaConfig.detectedUserCountryCode, "EN");
        if ((0, $d0757321c39843a5$export$cae2bcaccd579807).autoSetLocale) try {
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocaleFull = navigator.language;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale = navigator.language.slice(0, 2);
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userIntlLocale = new Intl.Locale(navigator.language);
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userRegionLocale = (0, $6K7Df.CountryUtil).getRegionByLocale();
            console.log("auto set locale", (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale, (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocaleFull);
        } catch (e) {
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale = (0, $d0757321c39843a5$export$cae2bcaccd579807).defaultLocale;
            console.error("failed to set locale, use default", e);
        }
        else try {
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userIntlLocale = new Intl.Locale((0, $d0757321c39843a5$export$cae2bcaccd579807).userLocaleFull);
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userRegionLocale = (0, $6K7Df.CountryUtil).getRegionByLocale();
            console.log("manual set locale", (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale, (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocaleFull);
        } catch (e) {
            console.error("failed to set locale, use default", e);
            (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale = (0, $d0757321c39843a5$export$cae2bcaccd579807).defaultLocale;
            console.log("manual set locale", (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale, (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocaleFull);
        }
        document.documentElement.setAttribute("lang", (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale);
        if (window.JSAndroidBridge) {
            console.log("detected android");
            if ((0, $d0757321c39843a5$export$cae2bcaccd579807).autoDetectAppMode) (0, $d0757321c39843a5$export$cae2bcaccd579807).appmode = "android";
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isWebStandalone = false;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).enableWebAds = false;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isAndroid = true;
            console.log("retreiving RTL from android");
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isRtl = window.JSAndroidBridge.isRTL();
            this.enableRtl((0, $d0757321c39843a5$export$cae2bcaccd579807).isRtl);
        } else if (window.isIOS || window.iOSConfig || navigator && navigator.platform && navigator.platform.toLowerCase().indexOf("iphone") > -1) {
            console.log("detected iphone with config ", window.iOSConfig);
            if ((0, $d0757321c39843a5$export$cae2bcaccd579807).autoDetectAppMode) (0, $d0757321c39843a5$export$cae2bcaccd579807).appmode = "ios";
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isWebStandalone = false;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).useWebWorkers = false;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isIphone = true;
        } else {
            console.log("detected web");
            if ((0, $d0757321c39843a5$export$cae2bcaccd579807).autoDetectAppMode) (0, $d0757321c39843a5$export$cae2bcaccd579807).appmode = "web";
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isWebStandalone = true;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isAndroid = false;
            if (!(0, $d0757321c39843a5$export$cae2bcaccd579807).autoSetRtl) {
                console.log("retreiving RTL from config. Auto detect disabled");
                this.enableRtl((0, $d0757321c39843a5$export$cae2bcaccd579807).isRtl);
            } else try {
                const loc = new Intl.Locale((0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale);
                if (loc.textInfo) {
                    console.log("detecting RTL from browser: ", loc.textInfo.direction);
                    this.enableRtl(loc.textInfo.direction === "rtl");
                } else console.error("failed to detect RTL from browser. Use default");
            } catch (e) {
                console.error("failed to detect RTL from browser. Use default");
                this.enableRtl(false);
                (0, $d0757321c39843a5$export$cae2bcaccd579807).userLocale = (0, $d0757321c39843a5$export$cae2bcaccd579807).defaultLocale;
            }
            if (navigator.serviceWorker) navigator.serviceWorker.register($4b1fd6f08152459d$exports).then(function(registration) {
                console.log('ServiceWorker registration successful with scope:', registration.scope);
                window.firebaseServiceWorker = registration;
            });
            else console.error("Service worker not supported");
        }
        if ((0, $d0757321c39843a5$export$cae2bcaccd579807).appmode == "ios") {
            // FootballManiaConfig.enabledFeatures.news = false;
            // FootballManiaConfig.enabledFeatures.search = false;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).enabledFeatures.forum = false;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).enabledFeatures.chat = false;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).enabledFeatures.matchChat = false;
            // FootballManiaConfig.enabledFeatures.playerImages = false;
            // FootballManiaConfig.enabledFeatures.teamImages = false;
            // FootballManiaConfig.enabledFeatures.userPredictions = false;
            // FootballManiaConfig.enabledFeatures.entertainment = false;
            // FootballManiaConfig.enabledFeatures.showHiddenLeagues = false;
            // FootballManiaConfig.enabledFeatures.housead = false;
            // FootballManiaConfig.enabledFeatures.showCompleteLeagueNames = false;
            (0, $d0757321c39843a5$export$cae2bcaccd579807).graphics.defaultMatchListType = 3;
        }
    }
    /**
     * setup is manually called from within a page.
     * @param cb
     */ setup(cb) {
        if (this.setupAlreadyDone) {
            setTimeout(()=>{
                return cb(this.setupAlreadyDone);
            }, 20);
            return;
        }
        (0, $kc8Kt.DataProvider).getConfig((response)=>{
            if (!response.isOk()) {
                console.error("failed to load config");
                return cb(false);
            }
            if (!this.workersInitialized) {
                console.log("loaded config. workers were never initialized. disable workers");
                (0, $d0757321c39843a5$export$cae2bcaccd579807).useWebWorkers = false;
            }
            this.doUserPreferenceStuff(response.getData());
            (0, $kc8Kt.DataProvider).getInfo((response)=>{
                if (response.isOk()) try {
                    const info = JSON.parse(atob(response.getData()));
                    console.log("info response ", info);
                    if (!(0, $d0757321c39843a5$export$cae2bcaccd579807).detectedUserCountryCode) {
                        console.log("auto detected country code ", info.countryCode, info.countryCode.length);
                        (0, $d0757321c39843a5$export$cae2bcaccd579807).detectedUserCountryCode = info.countryCode;
                        (0, $d0757321c39843a5$export$cae2bcaccd579807).detectedUserCountry = (0, $6K7Df.CountryUtil).getCountryByLocale(info.countryCode, "EN");
                    }
                } catch (e) {
                    console.error("failed to parse info", e);
                }
                this.loadPlatformSpecifcStuff(()=>{
                    //var config = response.getData();
                    (0, $02mnx.Localizer).loadLocale(AppInstance.getLocale(), (result)=>{
                        this.setupAlreadyDone = result;
                        cb(result);
                        setTimeout(()=>{
                            (0, $3SrKy.PushMessaging).init(this);
                        }, 1000);
                    });
                });
            });
        });
    }
    doUserPreferenceStuff(config) {
        //when user disabled animations
        const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
        (0, $d0757321c39843a5$export$cae2bcaccd579807).size = (0, $40e70090f1e1ff2d$export$5510f7c459d7063c).getCurrentSize();
        (0, $d0757321c39843a5$export$cae2bcaccd579807).theme = (0, $40e70090f1e1ff2d$export$5510f7c459d7063c).getCurrentTheme();
        if (!!isReduced) (0, $d0757321c39843a5$export$cae2bcaccd579807).graphics.animations = false;
        else (0, $d0757321c39843a5$export$cae2bcaccd579807).graphics.animations = true;
    }
    loadPlatformSpecifcStuff(cb) {
        if (window.JSAndroidBridge) {
            var defaultHomeScreen = window.JSAndroidBridge.getDefaultHomeScreen();
            (0, $d0757321c39843a5$export$cae2bcaccd579807).defaultHomeScreen = defaultHomeScreen;
            //console.log("default home screen ",FootballManiaApp.defaultHomeScreen);
            (0, $d0757321c39843a5$export$cae2bcaccd579807).isPremium = window.JSAndroidBridge.isPremium();
            var isMigratedFromAndroid = localStorage.getItem("android_native_migration_done");
            //isMigratedFromAndroid = false;
            if (!isMigratedFromAndroid) {
                //load subscribed matches
                var subscribedMatches = window.JSAndroidBridge.getSubscribedMatches();
                var subscribedTeams = window.JSAndroidBridge.getSubscribedTeams();
                var subscribedLeagues = window.JSAndroidBridge.getSubscribedLeagues();
                //load all favorite teams and leagues
                var favoriteTeams = window.JSAndroidBridge.getTeamFavorites();
                var favoriteLeagues = window.JSAndroidBridge.getLeagueFavorites();
                var votedMatches = window.JSAndroidBridge.getAllVotedMatches();
                (0, $aabc673d1ba8b527$export$db78e401119da622).migrateAndroidFavoriteTeams(favoriteTeams);
                (0, $aabc673d1ba8b527$export$db78e401119da622).migrateAndroidFavoriteLeagues(favoriteLeagues);
                (0, $542851713e8a5d10$export$60959659b2c22881).migrateAndroidMatchSubscriptions(subscribedMatches);
                (0, $542851713e8a5d10$export$60959659b2c22881).migrateAndroidTeamSubscriptions(subscribedTeams);
                (0, $542851713e8a5d10$export$60959659b2c22881).migrateAndroidLeagueSubscriptions(subscribedLeagues);
                (0, $ce9390ea20c7ac7b$export$bf48777cc692e18f).migrateAndroidMatchVotes(votedMatches);
                localStorage.setItem("android_native_migration_done", 1);
            //load other settings
            }
            return cb();
        } else {
            //some logic to disable context menu
            window.oncontextmenu = function(event) {
                // eslint-disable-next-line no-console
                const pointerEvent = event;
                // eslint-disable-next-line no-console
                if (pointerEvent.pointerType === 'touch') // context menu was triggerd by long press
                return false;
                // just to show that pointerEvent.pointerType has another value 'mouse' aka right click
                if (pointerEvent.pointerType === 'mouse') // context menu was triggered by right click
                return true;
                // returning true will show a context menu for other cases
                return true;
            };
            cb();
        }
    }
    isOnline() {
        return window.navigator.onLine;
    }
}
//** start application logic */
$(document).ready(function() {
    // jQuery.event.special.touchstart = {
    //     setup: function( _, ns, handle ) {
    //         this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    //     }
    // };
    // jQuery.event.special.touchmove = {
    //     setup: function( _, ns, handle ) {
    //         this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    //     }
    // };
    // jQuery.event.special.wheel = {
    //     setup: function( _, ns, handle ){
    //         this.addEventListener("wheel", handle, { passive: true });
    //     }
    // };
    // jQuery.event.special.mousewheel = {
    //     setup: function( _, ns, handle ){
    //         this.addEventListener("mousewheel", handle, { passive: true });
    //     }
    // };
    const applicationParameters = {};
    applicationParameters.applicationName = "fm";
    applicationParameters.pages = {
        "Home": (0, $e402e2991179b868$export$b94310965bed44e6),
        "News": (0, $d1f65a756ab5ad7f$export$aec6fe3795564851),
        "Match": (0, $0a2141772032e98d$export$f421feb8fad20413),
        "Team": (0, $9be7336a4db2275f$export$3e5d0af8e738b082),
        "Agenda": (0, $066a53c23ea0dafe$export$1fff54725744beb2),
        "Player": (0, $1be0fcd02f170985$export$2616165974278734),
        "Coach": (0, $8bf5eb0582c02c41$export$b4de764f4b9821a),
        "League": (0, $f914ccdaa1862435$export$9fc0e0d0ecb98c84),
        "CountryLeagues": (0, $9bcdf8c54273a23c$export$bad1c9032f2cc88a),
        "PlayerValuesRanking": (0, $8340ce0bbb0259c4$export$43c5b0b95280147b),
        "Fifaranking": (0, $f0f9bd023085811a$export$b18dd2400b8f82c),
        "ForumIndex": (0, $68dd5f8d12bc8ab4$export$b7d170e1c2775e6e),
        "ForumChat": (0, $820af1231e5bf861$export$95db43ce2cc121cc),
        "TopVoters": (0, $9d4deff23e202483$export$f7de2fbbe486a72),
        "TopTeamsLeagues": (0, $ceab2c9f4eaea863$export$d84faf0fb56f517)
    };
    applicationParameters.defaultPage = "Home";
    applicationParameters.pageTemplate = (0, $aeb70e56f7d1eb62$export$58b0d2e434fc5ae2);
    applicationParameters.renderTarget = 'target';
    var app = new $a1f4112d2b4354d8$export$f045649a075103db(applicationParameters);
    app.run();
});


//# sourceMappingURL=index.ee7c73eb.js.map
